webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, jQuery, $) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // require.context('./images', true, /^\.\//);
	
	// Authentication module wrapper
	
	
	// Material Design Lite
	// TODO: rem this dependency and move components to LumX
	/*
	  Well it seems at this stage we're stuck with MDL and LumX, I never intended to have two Material frameworks
	  but currently Formly only has templates for LumX...
	*/
	
	
	__webpack_require__(130);
	
	__webpack_require__(346);
	
	__webpack_require__(283);
	
	var _common = __webpack_require__(149);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(263);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(128);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(347);
	
	__webpack_require__(282);
	
	__webpack_require__(273);
	
	__webpack_require__(280);
	
	__webpack_require__(279);
	
	__webpack_require__(277);
	
	__webpack_require__(278);
	
	__webpack_require__(276);
	
	__webpack_require__(274);
	
	__webpack_require__(275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Angular and app components
	__webpack_require__(388);
	__webpack_require__(2);
	__webpack_require__(5);
	
	// Moment
	// import './vendor/moment/moment.js'
	// import './vendor/moment/lang/en-au.js'
	moment.locale('en-au');
	
	// NG6 app modules
	
	
	// Formly
	// moved into ./vendor as only updated on Bower
	
	__webpack_require__(281);
	
	// Datatable plugins
	var _anyNumberSort = function _anyNumberSort(a, b, high) {
	  var reg = /[+-]?((\d+(\.\d*)?)|\.\d+)([eE][+-]?[0-9]+)?/;
	  a = a.replace(',', '.').match(reg);
	  a = a !== null ? parseFloat(a[0]) : high;
	  b = b.replace(',', '.').match(reg);
	  b = b !== null ? parseFloat(b[0]) : high;
	  return a < b ? -1 : a > b ? 1 : 0;
	};
	
	jQuery.extend(jQuery.fn.dataTableExt.oSort, {
	  "any-number-asc": function anyNumberAsc(a, b) {
	    return _anyNumberSort(a, b, Number.POSITIVE_INFINITY);
	  },
	  "any-number-desc": function anyNumberDesc(a, b) {
	    return _anyNumberSort(a, b, Number.NEGATIVE_INFINITY) * -1;
	  }
	});
	
	// Datatables
	window.JSZip = __webpack_require__(120);
	__webpack_require__(9);
	__webpack_require__(12);
	__webpack_require__(90);
	// import './vendor/datatables/js/datatables.js';
	
	
	// datatables column sorting
	
	
	// datatables buttons
	
	
	// Enable DataTables to recognise Aussie-formatted dates when using client-side processing
	
	
	// show/hide table footer
	
	
	angular.module('app', ['Authentication', __webpack_require__(43), _common2.default.name, _components2.default.name, __webpack_require__(38), "datatables", "datatables.columnfilter", "datatables.buttons", __webpack_require__(41), __webpack_require__(36), __webpack_require__(39), "lumx", "formlyLumx", 'ui.router']).config(["$locationProvider", "$httpProvider", function ($locationProvider, $httpProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	}]).constant('USER', {
	  'name': '',
	  'email': '',
	  'specialty': '',
	  'role': '',
	  'worklist': '',
	  'id': '',
	  'token': ''
	}).constant('CONST', {
	  'CLINICIANRESPONSE': ['Yes', 'No', 'Other'],
	  'CRITERIA': ['0 - Does Not Meet Criteria', '1 - Original Coder Query', '2 - Target DRG', '3 - B or C DRG', '4 - Other'],
	  'CRITERIAPRIORITY': ['4 - Other'],
	  'DOCTYPE': ['Anaesthetic Report', 'Coroners Report', 'Discharge Summary', 'Entire Episode', 'Incomplete Other', 'Inpatient Progress Notes', 'Operation Report', 'Results', 'SSU Discharge Summary'],
	  'ENVIRONMENT': '',
	  'HOSPITALID': 1180, // TODO: This isn't needed anymore, but I'll assign 1180 to all masterpublic clients in their DBs until we deal with it properly (it's still referenced elsewhere in the app)
	  'LOSSIMPLE': ['0 days', '1+ days'],
	  'MYVIEW': { 'assignedCoder': undefined, 'active': false, 'selectedStatus': [], 'selectedSpecialty': [], 'selectedCriteria': [], 'startDate': undefined, 'startDateFormatted': undefined, 'endDate': undefined, 'endDateFormatted': undefined, 'sortCol': undefined, 'sortDir': undefined, 'selectedLos': [] },
	  'MUTABLEFIELDS': ['PCCLModifiedUser', 'PCCLModifiedDate', 'nameOfAuditor', 'auditFinalisedDateTime', 'drg', 'currentDRG', 'finalDRG', 'dateAuditFinalised', 'wies', 'currentWIES', 'finalWIES', 'totalWIESChange', 'urn', 'episodeNumber', 'admissionDate', 'dischargeDate', 'careType', 'speciality', 'campus', 'patientClassification', 'healthCareFund', 'atsi', 'ICUAdmission', 'ICUHours', 'mechVenitilationHours', 'NIVentilationHours', 'currentDRG', 'currentDRGDescription', 'lowTrim', 'highTrim', 'los', 'LOSOutcome', 'diagProc', 'diagType', 'diagCode', 'diagDescription', 'modifiedReason', 'modifiedByUser', 'modifiedDateTime', 'DRGCode', 'wiesDiff'],
	  'POLLINGINTERVAL': 5000,
	  'ROLE': ['Administrator', 'Auditor', 'CDS', 'Coder', 'Reporter', 'Clerical'],
	  'STATUS': ['0 - Not For Audit', '1 - Requires Review by Auditor', '2 - Currently Open for Audit', '3 - Ready for Clinician', '4 - Finalised'],
	  'TABLEROWS': 100
	}).component('app', _app2.default).filter('reverse', function () {
	  return function (items) {
	    return items.slice().reverse();
	  };
	}).filter('minsToHrsMins', function () {
	  return function (inputInMinutes) {
	    // Convert minutes to seconds
	    var seconds = inputInMinutes ? inputInMinutes * 60 : 0;
	
	    // Calculate (and subtract) whole hours
	    var hours = Math.floor(seconds / 3600);
	    seconds -= hours * 3600;
	
	    // Calculate (and subtract) whole minutes
	    var minutes = Math.floor(seconds / 60) % 60;
	
	    return hours + ':' + (minutes < 10 ? '0' + minutes : minutes);
	  };
	}).run(["$http", "$rootScope", "User", "AuthenticationService", "VersionService", "$location", "$state", "$cookieStore", "$timeout", function ($http, $rootScope, User, AuthenticationService, VersionService, $location, $state, $cookieStore, $timeout) {
	
	  //************************** Start: Active Directory implementation ********************** */
	  $rootScope.activeDirectoryError = false;
	  var splitUrl = $location.absUrl().split('?');
	  // If logout was selected then sent logout type
	  var logoutTypeParameter = splitUrl.length > 1 && splitUrl[1].toString() ? splitUrl[1] : '';
	  var input = logoutTypeParameter.indexOf('partialToken=') > -1 ? logoutTypeParameter.split('partialToken=')[1] : '';
	  var output = AuthenticationService.Decrypt(input);
	  var emailToken = output;
	  var userEmail = '';
	  var user = User.getUser();
	
	  VersionService.ensureVersionMatchWithServerLoop();
	
	  $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.function/init').then(function successCallback(response) {
	    var headerColourFunc = response.data.filter(function (x) {
	      return x.name === 'Header Colour';
	    });
	    if (headerColourFunc && headerColourFunc[0]) {
	      document.documentElement.classList.add(headerColourFunc[0].valueString);
	    }
	
	    var activeDirectoryFunc = response.data.filter(function (x) {
	      return x.name === 'Active Directory';
	    });
	    $rootScope.activeDirectoryActive = activeDirectoryFunc && activeDirectoryFunc[0] && activeDirectoryFunc[0].isActive;
	
	    var pubTok = activeDirectoryFunc[0] ? AuthenticationService.Decrypt(activeDirectoryFunc[0].label) : '';
	    if (emailToken) {
	      var emailTokenCry = emailToken.replace(pubTok, '');
	      var emailTokenDry = AuthenticationService.Decrypt(emailTokenCry);
	      var emailTokenSplit = emailTokenDry.split(':');
	      if (emailTokenSplit.length > 1) {
	        userEmail = emailTokenSplit[0];
	        $rootScope.partialToken = emailTokenSplit[1].substr(0, 10);
	      }
	    } else {
	      if (user.activeDirectoryToken) {
	        $rootScope.partialToken = user.activeDirectoryToken;
	      }
	    }
	
	    if ($rootScope.partialToken && !user.activeDirectoryToken) {
	      user.activeDirectoryToken = $rootScope.partialToken;
	    }
	
	    var loginPage = window.location.href.indexOf('/login') > -1;
	
	    // Is AD enabled - should only be gchhs envs
	    if ($rootScope.activeDirectoryActive && loginPage) {
	      // If user previously logged in then re-authorise token with saml service - will there be token refreshes in saml/ad we need to poll for?
	      if (user.activeDirectoryToken && userEmail.indexOf('@') > -1) {
	        $http({
	          method: "GET",
	          url: '' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.person/checkActiveDirectoryUser',
	          params: { authToken: btoa(userEmail + ":" + user.activeDirectoryToken)
	            // headers: {"Authorization": "Basic " + btoa(userEmail + ":" + user.activeDirectoryToken)},
	          } }).success(function (response) {
	          var userTok = user.activeDirectoryToken.substr(0, 10);
	          var userTokE1 = btoa(userTok);
	          var userTokE1a = userTokE1.replace(/=/g, '');
	          var userTokE1b = userTokE1a + pubTok.replace(/=/g, '');
	          var userTokE1c = userTokE1b.replace(/=/g, '');
	          var userTokE1d = userTokE1c.substring(0, userTokE1c.length - 2);
	          var userTokE2 = btoa(userTokE1d);
	          var userTokE2a = userTokE2.replace(/=/g, '');
	          if (response && response.data && response.data.indexOf('Sorry') > -1) {
	            $rootScope.activeDirectoryErrorMsg = response.data;
	          }
	          $http.post(activeDirectoryFunc[0].valueString, { partialToken: userTokE2a }).then(function successCallback(response2) {
	            if (response2.data.clientAuthorised) {
	              $http({
	                method: "GET",
	                url: '' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.person/checkUserActiveDirectoryAuth',
	                params: { authToken: btoa(userEmail + ":" + response2.data.token)
	                  //headers: {"Authorization": "Basic " + btoa(userEmail + ":" + response2.data.token)},
	                } }).success(function (response3) {
	                if (!response3.data.token) {
	                  $rootScope.activeDirectoryError = true;
	                  $timeout(function () {
	                    window.location = activeDirectoryFunc[0].description;
	                  }, 5000);
	                } else {
	                  $rootScope.globals = {
	                    currentUser: {
	                      active: response3.data.active,
	                      activeDirectoryToken: response3.data.activeDirectoryToken,
	                      dtype: response3.data.dtype,
	                      email: response3.data.email,
	                      firstname: response3.data.firstname,
	                      id: response3.data.id,
	                      initialLogin: response3.data.initialLogin,
	                      lastname: response3.data.lastname,
	                      name: response3.data.firstname + ' ' + response3.data.lastname,
	                      role: response3.data.dtype,
	                      roleId: response3.data.roleId,
	                      speciality: response3.data.specialty,
	                      token: response3.data.token,
	                      userName: response3.data.userName,
	                      campus: response3.data.campus,
	                      worklist: response3.data.worklist,
	                      codingOperationsTeam: response3.data.codingOperationsTeam
	                    }
	                  };
	                  $cookieStore.put('globals', $rootScope.globals);
	                  User.setUser(response3.data.codingOperationsTeam, response3.data.firstname + ' ' + response3.data.lastname, response3.data.email, response3.data.specialty, response3.data.dtype, response3.data.worklist, response3.data.id, response3.data.token, response3.data.roleId, response3.data.activeDirectoryToken, response3.data.initialLogin, response3.data.campus);
	                  if (loginPage) {
	                    console.log('App.js... - logged in from AD');
	                    // $state.go('home', {}, {});
	                    window.location = window.location.origin + '/v2/index.html';
	                  }
	                }
	              }).error(function (resp) {
	                // console.log('checkUserActiveDirectoryAuth error: ', resp);
	                $rootScope.activeDirectoryError = true;
	                AuthenticationService.ClearCredentials(3);
	                $timeout(function () {
	                  $rootScope.activeDirectoryErrorMsg = '';
	                  window.location = activeDirectoryFunc[0].description;
	                }, 5000);
	              });
	            } else {
	              $rootScope.activeDirectoryError = true;
	              AuthenticationService.ClearCredentials(3);
	              $timeout(function () {
	                $rootScope.activeDirectoryErrorMsg = '';
	                window.location = activeDirectoryFunc[0].description;
	              }, 5000);
	            }
	          }, function errorCallback(handshakereceivedresp) {
	            // console.log('saml handshakereceived error: ', handshakereceivedresp);
	            $rootScope.activeDirectoryError = true;
	            AuthenticationService.ClearCredentials(3);
	            $timeout(function () {
	              $rootScope.activeDirectoryErrorMsg = '';
	              window.location = activeDirectoryFunc[0].description;
	            }, 5000);
	          });
	        }).error(function (response) {
	          // console.log('checkActiveDirectoryUser error: ', response);
	          $rootScope.activeDirectoryError = true;
	          AuthenticationService.ClearCredentials(3);
	          $timeout(function () {
	            $rootScope.activeDirectoryErrorMsg = '';
	            window.location = activeDirectoryFunc[0].description;
	          }, 5000);
	        });
	      } else {
	        // Otherwise redirect to adfs to log back in
	        AuthenticationService.ClearCredentials(3);
	        window.location = activeDirectoryFunc[0].description;
	      }
	    }
	
	    //************************** End: Active Directory implementation ********************** */
	
	    var westernConfigFunc = response.data.filter(function (x) {
	      return x.name === 'Western Config';
	    });
	    $rootScope.westernConfig = westernConfigFunc && westernConfigFunc[0] && westernConfigFunc[0].isActive;
	    if ($rootScope.westernConfig) {
	      document.documentElement.classList.add('western');
	    }
	  });
	}]).run(['formlyConfig', function (formlyConfig) {
	  // this disables APIcheck on non-development servers
	  formlyConfig.disableWarnings = window.location.hostname === 'localhost' ? false : true;
	  // remove auto-complete (doesn't seem to be working atm)
	  formlyConfig.extras.removeChromeAutoComplete = true;
	}])
	
	// setup our user object
	.run(['$rootScope', '$cookieStore', '$state', 'User', function ($rootScope, $cookieStore, $state, User) {
	
	  var USER = User.getUser();
	
	  // keep user logged in after page refresh
	  $rootScope.globals = $cookieStore.get('globals') || {};
	
	  if ($rootScope.globals.currentUser) {
	    USER.name = $rootScope.globals.currentUser.name;
	    USER.email = $rootScope.globals.currentUser.email;
	    USER.specialty = $rootScope.globals.currentUser.specialty;
	    USER.role = $rootScope.globals.currentUser.role;
	    USER.roleId = $rootScope.globals.currentUser.roleId;
	    USER.worklist = $rootScope.globals.currentUser.worklist;
	    USER.id = $rootScope.globals.currentUser.id;
	    USER.token = $rootScope.globals.currentUser.token;
	    USER.activeDirectoryToken = $rootScope.globals.currentUser.activeDirectoryToken;
	    USER.initialLogin = $rootScope.globals.currentUser.initialLogin;
	    USER.codingOperationsTeam = $rootScope.globals.currentUser.codingOperationsTeam;
	    USER.campus = $rootScope.globals.currentUser.campus;
	    User.setUser(USER.codingOperationsTeam, USER.name, USER.email, USER.specialty, USER.role, USER.worklist, USER.id, USER.token, USER.roleId, USER.activeDirectoryToken, USER.initialLogin, User.campus);
	  }
	
	  // Prevent access to Admin routes
	  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
	    // hide elements if /login
	    if (toState.name === 'login') {
	      $('body').addClass('login');
	    } else if (toState.name === 'logout') {
	      $('body').removeClass('login');
	    } else {
	      $('body').removeClass('login');
	    }
	
	    if (toState.admin === true && USER.role !== 'Administrator' && USER.role !== 'Manager') {
	      // User isn't admin, send to home
	      $state.transitionTo("home");
	      event.preventDefault();
	    } else if (toState.admin === "Reporter" && USER.role !== 'Manager' && USER.role !== 'Reporter' && USER.role !== 'Administrator') {
	      // User isn't admin, send to home
	      $state.transitionTo("home");
	      event.preventDefault();
	    }
	  });
	
	  if (!USER.token && $state.name !== 'logout') {
	    $state.transitionTo("login");
	  }
	}]).factory('materialButtons', function () {
	  return {
	
	    processing: function processing() {
	
	      window.componentHandler.upgradeAllRegistered();
	
	      $('#auditTable').on('processing.dt', function (e, settings, processing) {
	        $(this).parents('.dataTables_wrapper').next().toggleClass('hidden', processing ? false : true);
	      });
	    },
	
	    render: function render() {
	
	      $.extend(true, $.fn.dataTable.defaults, {
	        dom: "<'hiddensearch'f'>" + "tr" + "<'table-footer'lip'>",
	        renderer: 'material'
	      });
	
	      $.fn.dataTable.ext.renderer.pageButton.material = function (settings, host, idx, buttons, page, pages) {
	        var api = new $.fn.dataTable.Api(settings);
	        var classes = settings.oClasses;
	        var lang = settings.oLanguage.oPaginate;
	        var aria = settings.oLanguage.oAria.paginate || {};
	        var btnDisplay,
	            btnClass,
	            counter = 0;
	
	        var attach = function attach(container, buttons) {
	          var i, ien, node, button, disabled, active;
	          var clickHandler = function clickHandler(e) {
	            e.preventDefault();
	            if (!$(e.currentTarget).hasClass('disabled') && api.page() != e.data.action) {
	              api.page(e.data.action).draw('page');
	            }
	          };
	
	          for (i = 0, ien = buttons.length; i < ien; i++) {
	            button = buttons[i];
	
	            if ($.isArray(button)) {
	              attach(container, button);
	            } else {
	              btnDisplay = '';
	              active = false;
	
	              switch (button) {
	                case 'ellipsis':
	                  btnDisplay = '&#x2026;';
	                  btnClass = 'disabled';
	                  break;
	
	                case 'first':
	                  btnDisplay = lang.sFirst;
	                  btnClass = button + (page > 0 ? '' : ' disabled');
	                  break;
	
	                case 'previous':
	                  btnDisplay = lang.sPrevious;
	                  btnClass = button + (page > 0 ? '' : ' disabled');
	                  break;
	
	                case 'next':
	                  btnDisplay = lang.sNext;
	                  btnClass = button + (page < pages - 1 ? '' : ' disabled');
	                  break;
	
	                case 'last':
	                  btnDisplay = lang.sLast;
	                  btnClass = button + (page < pages - 1 ? '' : ' disabled');
	                  break;
	
	                default:
	                  btnDisplay = button + 1;
	                  btnClass = '';
	                  active = page === button;
	                  break;
	              }
	
	              if (active) {
	                btnClass += ' mdl-button--raised mdl-button--colored';
	              }
	
	              if (btnDisplay) {
	                node = $('<button>', {
	                  'class': 'mdl-button ' + btnClass,
	                  'id': idx === 0 && typeof button === 'string' ? settings.sTableId + '_' + button : null,
	                  'aria-controls': settings.sTableId,
	                  'aria-label': aria[button],
	                  'data-dt-idx': counter,
	                  'tabindex': settings.iTabIndex,
	                  'disabled': btnClass.indexOf('disabled') !== -1
	                }).html(btnDisplay).appendTo(container);
	
	                settings.oApi._fnBindAction(node, { action: button }, clickHandler);
	
	                counter++;
	              }
	            }
	          }
	        };
	
	        // IE9 throws an 'unknown error' if document.activeElement is used
	        // inside an iframe or frame.
	        var activeEl;
	
	        try {
	          // Because this approach is destroying and recreating the paging
	          // elements, focus is lost on the select button which is bad for
	          // accessibility. So we want to restore focus once the draw has
	          // completed
	          activeEl = $(host).find(document.activeElement).data('dt-idx');
	        } catch (e) {}
	
	        attach($(host).empty().html('<div class="pagination"/>').children(), buttons);
	
	        if (activeEl) {
	          $(host).find('[data-dt-idx=' + activeEl + ']').focus();
	        }
	      };
	    }
	  };
	}).factory('checkChanged', ["CONST", function (CONST) {
	  return {
	
	    process: function process(scope) {
	
	      // WH uses Chrome 39, which doesn't support .startsWith
	      if (!String.prototype.startsWith) {
	        String.prototype.startsWith = function (searchString, position) {
	          position = position || 0;
	          return this.substr(position, searchString.length) === searchString;
	        };
	      }
	
	      var changed = false;
	
	      angular.forEach(scope.vm.form, function (formField, index) {
	
	        if ((typeof formField === 'undefined' ? 'undefined' : _typeof(formField)) === 'object') {
	
	          if (index.startsWith('vm.form')) {
	
	            if (typeof formField.$viewValue !== 'undefined') {
	
	              if (formField.$viewValue !== false) {
	
	                if (formField.$viewValue !== "") {
	
	                  changed = true;
	                }
	              }
	            }
	          }
	        }
	      }, scope);
	
	      return changed;
	    },
	
	    processQueryChanged: function processQueryChanged(scope, readyForClinicianChange) {
	
	      var changed = false;
	
	      angular.forEach(scope, function (form, formIndex) {
	
	        if (form.queryResponded !== "" || form.queryRespondedDetails !== "" || form.queryAltered !== false || form.queryAlteredDetails !== "" || form.queryRemoved !== false || form.queryRemovedDetails !== "" || form.specialty !== "" || form.auditType !== "" || form.complete !== false || form.projectedWies !== "" || form.auditTypeId && form.auditTypeId !== "" || form.queryType && form.queryType !== "" || form.queryTemplateName !== "" || form.queryReason !== "" || form.queryCategory !== "" || form.queryDetails !== "") {
	          changed = true;
	        }
	      }, scope);
	
	      // query generated dialog button
	      if (readyForClinicianChange) changed = true;
	
	      return changed;
	    },
	
	    processCode: function processCode(scope) {
	
	      var changed = false;
	      var model = scope.vm.model;
	
	      angular.forEach(model, function (formField, index) {
	
	        if (formField.errorCategory || formField.modifiedDetails) {
	
	          changed = true;
	        }
	      }, scope);
	
	      var toggleModel = scope.vm.toggleModel;
	
	      if (toggleModel.codingOperationsTeam || toggleModel.auditOutcomeRefCodeId || toggleModel.requiresAuditorReview || toggleModel.requiresCoderReview) {
	
	        changed = true;
	      }
	      return changed;
	    },
	
	    processDRG: function processDRG(scope) {
	
	      var changed = false;
	
	      angular.forEach(scope.vm.model, function (formField, index) {
	
	        if (formField.auditRule || formField.auditType || formField.changeCategory || formField.episodeQueryId || formField.modifiedDetails) {
	
	          changed = true;
	        }
	
	        if (formField.modifiedType !== 'Initial' && formField.modifiedType !== 'Changed') {
	
	          changed = true;
	        }
	      }, scope);
	
	      return changed;
	    }
	
	  };
	}]).factory('datePicker', function () {
	  return {
	
	    autoClose: function autoClose(scope) {
	
	      // Close the date-picker dialog on click of date
	      scope.$watchGroup(['vm.startDate.input.date', 'vm.endDate.input.date', 'vm.startDatePicker.input.date', 'vm.endDatePicker.input.date', 'vm.dueDatePicker.input.date', 'vm.dischargeDateFromPicker.input.date', 'vm.dischargeDateEndPicker.input.date'], function (newValues, oldValues, scope) {
	
	        $('.lx-date-picker-filter--is-shown').click();
	      });
	    }
	
	  };
	}).factory('formFactory', function () {
	  return {
	
	    reset: function reset(form) {
	
	      if (form) {
	        form.$setPristine();
	        form.$setUntouched();
	      }
	    }
	
	  };
	}).config(["formlyConfigProvider", function config(formlyConfigProvider) {
	  // set templates here
	  formlyConfigProvider.setType({
	    name: 'matchField',
	    apiCheck: function apiCheck() {
	      return {
	        data: {
	          fieldToMatch: formlyExampleApiCheck.string
	        }
	      };
	    },
	    apiCheckOptions: {
	      prefix: 'matchField type'
	    },
	    defaultOptions: function matchFieldDefaultOptions(options) {
	      return {
	        extras: {
	          validateOnModelChange: true
	        },
	        expressionProperties: {
	          'templateOptions.disabled': function templateOptionsDisabled(viewValue, modelValue, scope) {
	            var matchField = find(scope.fields, 'key', options.data.fieldToMatch);
	            if (!matchField) {
	              throw new Error('Could not find a field for the key ' + options.data.fieldToMatch);
	            }
	            var model = options.data.modelToMatch || scope.model;
	            var originalValue = model[options.data.fieldToMatch];
	            var invalidOriginal = matchField.formControl && matchField.formControl.$invalid;
	            return !originalValue || invalidOriginal;
	          }
	        },
	        validators: {
	          fieldMatch: {
	            expression: function expression(viewValue, modelValue, fieldScope) {
	              var value = modelValue || viewValue;
	              var model = options.data.modelToMatch || fieldScope.model;
	              return value === model[options.data.fieldToMatch];
	            },
	            message: options.data.matchFieldMessage || '"Must match"'
	          }
	        }
	      };
	
	      function find(array, prop, value) {
	        var foundItem;
	        array.some(function (item) {
	          if (item[prop] === value) {
	            foundItem = item;
	          }
	          return !!foundItem;
	        });
	        return foundItem;
	      }
	    }
	  });
	}]);
	
	angular.bootstrap(document.body, ['app']);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f40c84ddf242a7c0ca3966052be1c05a.jpg";

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "@charset \"UTF-8\";\r\n\r\n/*!\r\n  Paper Collapse v0.4.0\r\n\r\n  Collapsible paper cards.\r\n\r\n  Made with love by bbo - ©2015 Alexander Rühle\r\n  MIT License http://opensource.org/licenses/MIT\r\n*/.collapse-card{transition:.4s;margin:0}.collapse-card *{box-sizing:border-box}.collapse-card.active{z-index:200;margin:0}.collapse-card .collapse-card__heading span.ic:before{content:\"\\F140\"}.collapse-card.active .collapse-card__heading span.ic:before,.collapse-card .collapse-card__heading:hover span.ic:before{content:\"\\F143\"}.collapse-card.active .collapse-card__heading:hover span.ic:before{content:\"\\F140\"}.collapse-card__heading{cursor:pointer;position:relative}.collapse-card__heading:after{clear:both}.collapse-card__heading i{float:left}.collapse-card__heading span.ic{position:absolute;top:2px}.collapse-card__heading span.ic:before{color:#2196f3;display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:36px;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0)}.collapse-card__body{padding:0 24px 24px;margin-top:-20px;display:none}", ""]);
	
	// exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".form-pending{color:rgba(0,0,0,.541176)}.form-error,.form-pending{font-size:.85em;list-style:none}.form-error{color:#f44336}.aftl-select{position:relative}.aftl-select-lower{bottom:-11px}.aftl-select-higher{bottom:11px}.inline-wrapper{display:inline}.inline--after,.inline--before,.inline--content{display:inline-block}.radio-button__inline{display:inline-block;margin-right:10px}", ""]);
	
	// exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "html{color:rgba(0,0,0,.87)}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}fieldset,hr{border:0;padding:0}hr{display:block;height:1px;border-top:1px solid #ccc;margin:1em 0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{margin:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}.hidden{display:none!important}.visuallyhidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.visuallyhidden.focusable:active,.visuallyhidden.focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}.invisible{visibility:hidden}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}@media print{*,:after,:before,:first-letter,:first-line{background:0 0!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href)\")\"}abbr[title]:after{content:\" (\" attr(title)\")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999}thead{display:table-header-group}blockquote,img,pre,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}.mdl-accordion,.mdl-button,.mdl-card,.mdl-checkbox,.mdl-dropdown-menu,.mdl-icon-toggle,.mdl-item,.mdl-radio,.mdl-slider,.mdl-switch,.mdl-tabs__tab,a{-webkit-tap-highlight-color:transparent;-webkit-tap-highlight-color:rgba(255,255,255,0)}body,html{width:100%;font-family:Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;line-height:20px}html{height:100%;-ms-touch-action:manipulation;touch-action:manipulation}body{min-height:100%}main{display:block}[hidden]{display:none!important}h1,h2,h3,h4,h5,h6,p{padding:0}h1,h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{font-family:Roboto,Helvetica,Arial,sans-serif;letter-spacing:-.02em;line-height:1.35}h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{font-weight:400;opacity:.54;font-size:.6em}h1,h2{font-weight:400}h1{font-size:56px}h1,h2,h3{margin:24px 0}h2,h3{font-family:Roboto,Helvetica,Arial,sans-serif}h2{font-size:45px;line-height:48px}h3,h4{font-weight:400}h3{font-size:34px;line-height:40px}h4,h5{font-family:Roboto,Helvetica,Arial,sans-serif}h4{-moz-osx-font-smoothing:grayscale;font-size:24px;line-height:32px}h4,h5,h6,p{margin:24px 0 16px}h5{font-size:20px;font-weight:500;line-height:1;letter-spacing:.02em}blockquote,h6{font-family:Roboto,Helvetica,Arial,sans-serif}h6,p{font-size:16px;font-weight:400;line-height:24px;letter-spacing:.04em}p{font-size:14px;letter-spacing:0;margin:0 0 16px}a{color:#40c4ff;font-weight:500}blockquote{position:relative;font-size:24px;font-weight:300;font-style:italic;line-height:1.35;letter-spacing:.08em}blockquote:before{position:absolute;left:-.5em;content:\"\\201C\"}blockquote:after{content:\"\\201D\";margin-left:-.05em}mark{background-color:#f4ff81}dt{font-weight:700}address,ol,ul{font-weight:400;letter-spacing:0}address{font-style:normal;font-size:12px;line-height:1}ol,ul{font-size:14px;line-height:24px}.mdl-typography--display-4,.mdl-typography--display-4-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:112px;font-weight:300;line-height:1;letter-spacing:-.04em}.mdl-typography--display-4-color-contrast{opacity:.54}.mdl-typography--display-3,.mdl-typography--display-3-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:56px;font-weight:400;line-height:1.35;letter-spacing:-.02em}.mdl-typography--display-3-color-contrast{opacity:.54}.mdl-typography--display-2,.mdl-typography--display-2-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:45px;font-weight:400;line-height:48px}.mdl-typography--display-2-color-contrast{opacity:.54}.mdl-typography--display-1,.mdl-typography--display-1-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:34px;font-weight:400;line-height:40px}.mdl-typography--display-1-color-contrast{opacity:.54}.mdl-typography--headline,.mdl-typography--headline-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:24px;font-weight:400;line-height:32px;-moz-osx-font-smoothing:grayscale}.mdl-typography--headline-color-contrast{opacity:.87}.mdl-typography--title,.mdl-typography--title-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:20px;font-weight:500;line-height:1;letter-spacing:.02em}.mdl-typography--title-color-contrast{opacity:.87}.mdl-typography--subhead,.mdl-typography--subhead-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px;letter-spacing:.04em}.mdl-typography--subhead-color-contrast{opacity:.87}.mdl-typography--body-2,.mdl-typography--body-2-color-contrast{font-size:14px;font-weight:700;line-height:24px;letter-spacing:0}.mdl-typography--body-2-color-contrast{opacity:.87}.mdl-typography--body-1,.mdl-typography--body-1-color-contrast{font-size:14px;font-weight:400;line-height:24px;letter-spacing:0}.mdl-typography--body-1-color-contrast{opacity:.87}.mdl-typography--body-2-force-preferred-font,.mdl-typography--body-2-force-preferred-font-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;line-height:24px;letter-spacing:0}.mdl-typography--body-2-force-preferred-font-color-contrast{opacity:.87}.mdl-typography--body-1-force-preferred-font,.mdl-typography--body-1-force-preferred-font-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;line-height:24px;letter-spacing:0}.mdl-typography--body-1-force-preferred-font-color-contrast{opacity:.87}.mdl-typography--caption,.mdl-typography--caption-force-preferred-font{font-size:12px;font-weight:400;line-height:1;letter-spacing:0}.mdl-typography--caption-force-preferred-font{font-family:Roboto,Helvetica,Arial,sans-serif}.mdl-typography--caption-color-contrast,.mdl-typography--caption-force-preferred-font-color-contrast{font-size:12px;font-weight:400;line-height:1;letter-spacing:0;opacity:.54}.mdl-typography--caption-force-preferred-font-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif}.mdl-typography--button,.mdl-typography--button-color-contrast,.mdl-typography--menu,.mdl-typography--menu-color-contrast{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;line-height:1;letter-spacing:0}.mdl-typography--menu-color-contrast{opacity:.87}.mdl-typography--button,.mdl-typography--button-color-contrast{text-transform:uppercase}.mdl-typography--button-color-contrast{opacity:.87}.mdl-typography--text-left{text-align:left}.mdl-typography--text-right{text-align:right}.mdl-typography--text-center{text-align:center}.mdl-typography--text-justify{text-align:justify}.mdl-typography--text-nowrap{white-space:nowrap}.mdl-typography--text-lowercase{text-transform:lowercase}.mdl-typography--text-uppercase{text-transform:uppercase}.mdl-typography--text-capitalize{text-transform:capitalize}.mdl-typography--font-thin{font-weight:200!important}.mdl-typography--font-light{font-weight:300!important}.mdl-typography--font-regular{font-weight:400!important}.mdl-typography--font-medium{font-weight:500!important}.mdl-typography--font-bold{font-weight:700!important}.mdl-typography--font-black{font-weight:900!important}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;word-wrap:normal;font-feature-settings:\"liga\";-webkit-font-feature-settings:\"liga\";-webkit-font-smoothing:antialiased}.mdl-color-text--red{color:#f44336!important}.mdl-color--red{background-color:#f44336!important}.mdl-color-text--red-50{color:#ffebee!important}.mdl-color--red-50{background-color:#ffebee!important}.mdl-color-text--red-100{color:#ffcdd2!important}.mdl-color--red-100{background-color:#ffcdd2!important}.mdl-color-text--red-200{color:#ef9a9a!important}.mdl-color--red-200{background-color:#ef9a9a!important}.mdl-color-text--red-300{color:#e57373!important}.mdl-color--red-300{background-color:#e57373!important}.mdl-color-text--red-400{color:#ef5350!important}.mdl-color--red-400{background-color:#ef5350!important}.mdl-color-text--red-500{color:#f44336!important}.mdl-color--red-500{background-color:#f44336!important}.mdl-color-text--red-600{color:#e53935!important}.mdl-color--red-600{background-color:#e53935!important}.mdl-color-text--red-700{color:#d32f2f!important}.mdl-color--red-700{background-color:#d32f2f!important}.mdl-color-text--red-800{color:#c62828!important}.mdl-color--red-800{background-color:#c62828!important}.mdl-color-text--red-900{color:#b71c1c!important}.mdl-color--red-900{background-color:#b71c1c!important}.mdl-color-text--red-A100{color:#ff8a80!important}.mdl-color--red-A100{background-color:#ff8a80!important}.mdl-color-text--red-A200{color:#ff5252!important}.mdl-color--red-A200{background-color:#ff5252!important}.mdl-color-text--red-A400{color:#ff1744!important}.mdl-color--red-A400{background-color:#ff1744!important}.mdl-color-text--red-A700{color:#d50000!important}.mdl-color--red-A700{background-color:#d50000!important}.mdl-color-text--pink{color:#e91e63!important}.mdl-color--pink{background-color:#e91e63!important}.mdl-color-text--pink-50{color:#fce4ec!important}.mdl-color--pink-50{background-color:#fce4ec!important}.mdl-color-text--pink-100{color:#f8bbd0!important}.mdl-color--pink-100{background-color:#f8bbd0!important}.mdl-color-text--pink-200{color:#f48fb1!important}.mdl-color--pink-200{background-color:#f48fb1!important}.mdl-color-text--pink-300{color:#f06292!important}.mdl-color--pink-300{background-color:#f06292!important}.mdl-color-text--pink-400{color:#ec407a!important}.mdl-color--pink-400{background-color:#ec407a!important}.mdl-color-text--pink-500{color:#e91e63!important}.mdl-color--pink-500{background-color:#e91e63!important}.mdl-color-text--pink-600{color:#d81b60!important}.mdl-color--pink-600{background-color:#d81b60!important}.mdl-color-text--pink-700{color:#c2185b!important}.mdl-color--pink-700{background-color:#c2185b!important}.mdl-color-text--pink-800{color:#ad1457!important}.mdl-color--pink-800{background-color:#ad1457!important}.mdl-color-text--pink-900{color:#880e4f!important}.mdl-color--pink-900{background-color:#880e4f!important}.mdl-color-text--pink-A100{color:#ff80ab!important}.mdl-color--pink-A100{background-color:#ff80ab!important}.mdl-color-text--pink-A200{color:#ff4081!important}.mdl-color--pink-A200{background-color:#ff4081!important}.mdl-color-text--pink-A400{color:#f50057!important}.mdl-color--pink-A400{background-color:#f50057!important}.mdl-color-text--pink-A700{color:#c51162!important}.mdl-color--pink-A700{background-color:#c51162!important}.mdl-color-text--purple{color:#9c27b0!important}.mdl-color--purple{background-color:#9c27b0!important}.mdl-color-text--purple-50{color:#f3e5f5!important}.mdl-color--purple-50{background-color:#f3e5f5!important}.mdl-color-text--purple-100{color:#e1bee7!important}.mdl-color--purple-100{background-color:#e1bee7!important}.mdl-color-text--purple-200{color:#ce93d8!important}.mdl-color--purple-200{background-color:#ce93d8!important}.mdl-color-text--purple-300{color:#ba68c8!important}.mdl-color--purple-300{background-color:#ba68c8!important}.mdl-color-text--purple-400{color:#ab47bc!important}.mdl-color--purple-400{background-color:#ab47bc!important}.mdl-color-text--purple-500{color:#9c27b0!important}.mdl-color--purple-500{background-color:#9c27b0!important}.mdl-color-text--purple-600{color:#8e24aa!important}.mdl-color--purple-600{background-color:#8e24aa!important}.mdl-color-text--purple-700{color:#7b1fa2!important}.mdl-color--purple-700{background-color:#7b1fa2!important}.mdl-color-text--purple-800{color:#6a1b9a!important}.mdl-color--purple-800{background-color:#6a1b9a!important}.mdl-color-text--purple-900{color:#4a148c!important}.mdl-color--purple-900{background-color:#4a148c!important}.mdl-color-text--purple-A100{color:#ea80fc!important}.mdl-color--purple-A100{background-color:#ea80fc!important}.mdl-color-text--purple-A200{color:#e040fb!important}.mdl-color--purple-A200{background-color:#e040fb!important}.mdl-color-text--purple-A400{color:#d500f9!important}.mdl-color--purple-A400{background-color:#d500f9!important}.mdl-color-text--purple-A700{color:#a0f!important}.mdl-color--purple-A700{background-color:#a0f!important}.mdl-color-text--deep-purple{color:#673ab7!important}.mdl-color--deep-purple{background-color:#673ab7!important}.mdl-color-text--deep-purple-50{color:#ede7f6!important}.mdl-color--deep-purple-50{background-color:#ede7f6!important}.mdl-color-text--deep-purple-100{color:#d1c4e9!important}.mdl-color--deep-purple-100{background-color:#d1c4e9!important}.mdl-color-text--deep-purple-200{color:#b39ddb!important}.mdl-color--deep-purple-200{background-color:#b39ddb!important}.mdl-color-text--deep-purple-300{color:#9575cd!important}.mdl-color--deep-purple-300{background-color:#9575cd!important}.mdl-color-text--deep-purple-400{color:#7e57c2!important}.mdl-color--deep-purple-400{background-color:#7e57c2!important}.mdl-color-text--deep-purple-500{color:#673ab7!important}.mdl-color--deep-purple-500{background-color:#673ab7!important}.mdl-color-text--deep-purple-600{color:#5e35b1!important}.mdl-color--deep-purple-600{background-color:#5e35b1!important}.mdl-color-text--deep-purple-700{color:#512da8!important}.mdl-color--deep-purple-700{background-color:#512da8!important}.mdl-color-text--deep-purple-800{color:#4527a0!important}.mdl-color--deep-purple-800{background-color:#4527a0!important}.mdl-color-text--deep-purple-900{color:#311b92!important}.mdl-color--deep-purple-900{background-color:#311b92!important}.mdl-color-text--deep-purple-A100{color:#b388ff!important}.mdl-color--deep-purple-A100{background-color:#b388ff!important}.mdl-color-text--deep-purple-A200{color:#7c4dff!important}.mdl-color--deep-purple-A200{background-color:#7c4dff!important}.mdl-color-text--deep-purple-A400{color:#651fff!important}.mdl-color--deep-purple-A400{background-color:#651fff!important}.mdl-color-text--deep-purple-A700{color:#6200ea!important}.mdl-color--deep-purple-A700{background-color:#6200ea!important}.mdl-color-text--indigo{color:#3f51b5!important}.mdl-color--indigo{background-color:#3f51b5!important}.mdl-color-text--indigo-50{color:#e8eaf6!important}.mdl-color--indigo-50{background-color:#e8eaf6!important}.mdl-color-text--indigo-100{color:#c5cae9!important}.mdl-color--indigo-100{background-color:#c5cae9!important}.mdl-color-text--indigo-200{color:#9fa8da!important}.mdl-color--indigo-200{background-color:#9fa8da!important}.mdl-color-text--indigo-300{color:#7986cb!important}.mdl-color--indigo-300{background-color:#7986cb!important}.mdl-color-text--indigo-400{color:#5c6bc0!important}.mdl-color--indigo-400{background-color:#5c6bc0!important}.mdl-color-text--indigo-500{color:#3f51b5!important}.mdl-color--indigo-500{background-color:#3f51b5!important}.mdl-color-text--indigo-600{color:#3949ab!important}.mdl-color--indigo-600{background-color:#3949ab!important}.mdl-color-text--indigo-700{color:#303f9f!important}.mdl-color--indigo-700{background-color:#303f9f!important}.mdl-color-text--indigo-800{color:#283593!important}.mdl-color--indigo-800{background-color:#283593!important}.mdl-color-text--indigo-900{color:#1a237e!important}.mdl-color--indigo-900{background-color:#1a237e!important}.mdl-color-text--indigo-A100{color:#8c9eff!important}.mdl-color--indigo-A100{background-color:#8c9eff!important}.mdl-color-text--indigo-A200{color:#536dfe!important}.mdl-color--indigo-A200{background-color:#536dfe!important}.mdl-color-text--indigo-A400{color:#3d5afe!important}.mdl-color--indigo-A400{background-color:#3d5afe!important}.mdl-color-text--indigo-A700{color:#304ffe!important}.mdl-color--indigo-A700{background-color:#304ffe!important}.mdl-color-text--blue{color:#2196f3!important}.mdl-color--blue{background-color:#2196f3!important}.mdl-color-text--blue-50{color:#e3f2fd!important}.mdl-color--blue-50{background-color:#e3f2fd!important}.mdl-color-text--blue-100{color:#bbdefb!important}.mdl-color--blue-100{background-color:#bbdefb!important}.mdl-color-text--blue-200{color:#90caf9!important}.mdl-color--blue-200{background-color:#90caf9!important}.mdl-color-text--blue-300{color:#64b5f6!important}.mdl-color--blue-300{background-color:#64b5f6!important}.mdl-color-text--blue-400{color:#42a5f5!important}.mdl-color--blue-400{background-color:#42a5f5!important}.mdl-color-text--blue-500{color:#2196f3!important}.mdl-color--blue-500{background-color:#2196f3!important}.mdl-color-text--blue-600{color:#1e88e5!important}.mdl-color--blue-600{background-color:#1e88e5!important}.mdl-color-text--blue-700{color:#1976d2!important}.mdl-color--blue-700{background-color:#1976d2!important}.mdl-color-text--blue-800{color:#1565c0!important}.mdl-color--blue-800{background-color:#1565c0!important}.mdl-color-text--blue-900{color:#0d47a1!important}.mdl-color--blue-900{background-color:#0d47a1!important}.mdl-color-text--blue-A100{color:#82b1ff!important}.mdl-color--blue-A100{background-color:#82b1ff!important}.mdl-color-text--blue-A200{color:#448aff!important}.mdl-color--blue-A200{background-color:#448aff!important}.mdl-color-text--blue-A400{color:#2979ff!important}.mdl-color--blue-A400{background-color:#2979ff!important}.mdl-color-text--blue-A700{color:#2962ff!important}.mdl-color--blue-A700{background-color:#2962ff!important}.mdl-color-text--light-blue{color:#03a9f4!important}.mdl-color--light-blue{background-color:#03a9f4!important}.mdl-color-text--light-blue-50{color:#e1f5fe!important}.mdl-color--light-blue-50{background-color:#e1f5fe!important}.mdl-color-text--light-blue-100{color:#b3e5fc!important}.mdl-color--light-blue-100{background-color:#b3e5fc!important}.mdl-color-text--light-blue-200{color:#81d4fa!important}.mdl-color--light-blue-200{background-color:#81d4fa!important}.mdl-color-text--light-blue-300{color:#4fc3f7!important}.mdl-color--light-blue-300{background-color:#4fc3f7!important}.mdl-color-text--light-blue-400{color:#29b6f6!important}.mdl-color--light-blue-400{background-color:#29b6f6!important}.mdl-color-text--light-blue-500{color:#03a9f4!important}.mdl-color--light-blue-500{background-color:#03a9f4!important}.mdl-color-text--light-blue-600{color:#039be5!important}.mdl-color--light-blue-600{background-color:#039be5!important}.mdl-color-text--light-blue-700{color:#0288d1!important}.mdl-color--light-blue-700{background-color:#0288d1!important}.mdl-color-text--light-blue-800{color:#0277bd!important}.mdl-color--light-blue-800{background-color:#0277bd!important}.mdl-color-text--light-blue-900{color:#01579b!important}.mdl-color--light-blue-900{background-color:#01579b!important}.mdl-color-text--light-blue-A100{color:#80d8ff!important}.mdl-color--light-blue-A100{background-color:#80d8ff!important}.mdl-color-text--light-blue-A200{color:#40c4ff!important}.mdl-color--light-blue-A200{background-color:#40c4ff!important}.mdl-color-text--light-blue-A400{color:#00b0ff!important}.mdl-color--light-blue-A400{background-color:#00b0ff!important}.mdl-color-text--light-blue-A700{color:#0091ea!important}.mdl-color--light-blue-A700{background-color:#0091ea!important}.mdl-color-text--cyan{color:#00bcd4!important}.mdl-color--cyan{background-color:#00bcd4!important}.mdl-color-text--cyan-50{color:#e0f7fa!important}.mdl-color--cyan-50{background-color:#e0f7fa!important}.mdl-color-text--cyan-100{color:#b2ebf2!important}.mdl-color--cyan-100{background-color:#b2ebf2!important}.mdl-color-text--cyan-200{color:#80deea!important}.mdl-color--cyan-200{background-color:#80deea!important}.mdl-color-text--cyan-300{color:#4dd0e1!important}.mdl-color--cyan-300{background-color:#4dd0e1!important}.mdl-color-text--cyan-400{color:#26c6da!important}.mdl-color--cyan-400{background-color:#26c6da!important}.mdl-color-text--cyan-500{color:#00bcd4!important}.mdl-color--cyan-500{background-color:#00bcd4!important}.mdl-color-text--cyan-600{color:#00acc1!important}.mdl-color--cyan-600{background-color:#00acc1!important}.mdl-color-text--cyan-700{color:#0097a7!important}.mdl-color--cyan-700{background-color:#0097a7!important}.mdl-color-text--cyan-800{color:#00838f!important}.mdl-color--cyan-800{background-color:#00838f!important}.mdl-color-text--cyan-900{color:#006064!important}.mdl-color--cyan-900{background-color:#006064!important}.mdl-color-text--cyan-A100{color:#84ffff!important}.mdl-color--cyan-A100{background-color:#84ffff!important}.mdl-color-text--cyan-A200{color:#18ffff!important}.mdl-color--cyan-A200{background-color:#18ffff!important}.mdl-color-text--cyan-A400{color:#00e5ff!important}.mdl-color--cyan-A400{background-color:#00e5ff!important}.mdl-color-text--cyan-A700{color:#00b8d4!important}.mdl-color--cyan-A700{background-color:#00b8d4!important}.mdl-color-text--teal{color:#009688!important}.mdl-color--teal{background-color:#009688!important}.mdl-color-text--teal-50{color:#e0f2f1!important}.mdl-color--teal-50{background-color:#e0f2f1!important}.mdl-color-text--teal-100{color:#b2dfdb!important}.mdl-color--teal-100{background-color:#b2dfdb!important}.mdl-color-text--teal-200{color:#80cbc4!important}.mdl-color--teal-200{background-color:#80cbc4!important}.mdl-color-text--teal-300{color:#4db6ac!important}.mdl-color--teal-300{background-color:#4db6ac!important}.mdl-color-text--teal-400{color:#26a69a!important}.mdl-color--teal-400{background-color:#26a69a!important}.mdl-color-text--teal-500{color:#009688!important}.mdl-color--teal-500{background-color:#009688!important}.mdl-color-text--teal-600{color:#00897b!important}.mdl-color--teal-600{background-color:#00897b!important}.mdl-color-text--teal-700{color:#00796b!important}.mdl-color--teal-700{background-color:#00796b!important}.mdl-color-text--teal-800{color:#00695c!important}.mdl-color--teal-800{background-color:#00695c!important}.mdl-color-text--teal-900{color:#004d40!important}.mdl-color--teal-900{background-color:#004d40!important}.mdl-color-text--teal-A100{color:#a7ffeb!important}.mdl-color--teal-A100{background-color:#a7ffeb!important}.mdl-color-text--teal-A200{color:#64ffda!important}.mdl-color--teal-A200{background-color:#64ffda!important}.mdl-color-text--teal-A400{color:#1de9b6!important}.mdl-color--teal-A400{background-color:#1de9b6!important}.mdl-color-text--teal-A700{color:#00bfa5!important}.mdl-color--teal-A700{background-color:#00bfa5!important}.mdl-color-text--green{color:#4caf50!important}.mdl-color--green{background-color:#4caf50!important}.mdl-color-text--green-50{color:#e8f5e9!important}.mdl-color--green-50{background-color:#e8f5e9!important}.mdl-color-text--green-100{color:#c8e6c9!important}.mdl-color--green-100{background-color:#c8e6c9!important}.mdl-color-text--green-200{color:#a5d6a7!important}.mdl-color--green-200{background-color:#a5d6a7!important}.mdl-color-text--green-300{color:#81c784!important}.mdl-color--green-300{background-color:#81c784!important}.mdl-color-text--green-400{color:#66bb6a!important}.mdl-color--green-400{background-color:#66bb6a!important}.mdl-color-text--green-500{color:#4caf50!important}.mdl-color--green-500{background-color:#4caf50!important}.mdl-color-text--green-600{color:#43a047!important}.mdl-color--green-600{background-color:#43a047!important}.mdl-color-text--green-700{color:#388e3c!important}.mdl-color--green-700{background-color:#388e3c!important}.mdl-color-text--green-800{color:#2e7d32!important}.mdl-color--green-800{background-color:#2e7d32!important}.mdl-color-text--green-900{color:#1b5e20!important}.mdl-color--green-900{background-color:#1b5e20!important}.mdl-color-text--green-A100{color:#b9f6ca!important}.mdl-color--green-A100{background-color:#b9f6ca!important}.mdl-color-text--green-A200{color:#69f0ae!important}.mdl-color--green-A200{background-color:#69f0ae!important}.mdl-color-text--green-A400{color:#00e676!important}.mdl-color--green-A400{background-color:#00e676!important}.mdl-color-text--green-A700{color:#00c853!important}.mdl-color--green-A700{background-color:#00c853!important}.mdl-color-text--light-green{color:#8bc34a!important}.mdl-color--light-green{background-color:#8bc34a!important}.mdl-color-text--light-green-50{color:#f1f8e9!important}.mdl-color--light-green-50{background-color:#f1f8e9!important}.mdl-color-text--light-green-100{color:#dcedc8!important}.mdl-color--light-green-100{background-color:#dcedc8!important}.mdl-color-text--light-green-200{color:#c5e1a5!important}.mdl-color--light-green-200{background-color:#c5e1a5!important}.mdl-color-text--light-green-300{color:#aed581!important}.mdl-color--light-green-300{background-color:#aed581!important}.mdl-color-text--light-green-400{color:#9ccc65!important}.mdl-color--light-green-400{background-color:#9ccc65!important}.mdl-color-text--light-green-500{color:#8bc34a!important}.mdl-color--light-green-500{background-color:#8bc34a!important}.mdl-color-text--light-green-600{color:#7cb342!important}.mdl-color--light-green-600{background-color:#7cb342!important}.mdl-color-text--light-green-700{color:#689f38!important}.mdl-color--light-green-700{background-color:#689f38!important}.mdl-color-text--light-green-800{color:#558b2f!important}.mdl-color--light-green-800{background-color:#558b2f!important}.mdl-color-text--light-green-900{color:#33691e!important}.mdl-color--light-green-900{background-color:#33691e!important}.mdl-color-text--light-green-A100{color:#ccff90!important}.mdl-color--light-green-A100{background-color:#ccff90!important}.mdl-color-text--light-green-A200{color:#b2ff59!important}.mdl-color--light-green-A200{background-color:#b2ff59!important}.mdl-color-text--light-green-A400{color:#76ff03!important}.mdl-color--light-green-A400{background-color:#76ff03!important}.mdl-color-text--light-green-A700{color:#64dd17!important}.mdl-color--light-green-A700{background-color:#64dd17!important}.mdl-color-text--lime{color:#cddc39!important}.mdl-color--lime{background-color:#cddc39!important}.mdl-color-text--lime-50{color:#f9fbe7!important}.mdl-color--lime-50{background-color:#f9fbe7!important}.mdl-color-text--lime-100{color:#f0f4c3!important}.mdl-color--lime-100{background-color:#f0f4c3!important}.mdl-color-text--lime-200{color:#e6ee9c!important}.mdl-color--lime-200{background-color:#e6ee9c!important}.mdl-color-text--lime-300{color:#dce775!important}.mdl-color--lime-300{background-color:#dce775!important}.mdl-color-text--lime-400{color:#d4e157!important}.mdl-color--lime-400{background-color:#d4e157!important}.mdl-color-text--lime-500{color:#cddc39!important}.mdl-color--lime-500{background-color:#cddc39!important}.mdl-color-text--lime-600{color:#c0ca33!important}.mdl-color--lime-600{background-color:#c0ca33!important}.mdl-color-text--lime-700{color:#afb42b!important}.mdl-color--lime-700{background-color:#afb42b!important}.mdl-color-text--lime-800{color:#9e9d24!important}.mdl-color--lime-800{background-color:#9e9d24!important}.mdl-color-text--lime-900{color:#827717!important}.mdl-color--lime-900{background-color:#827717!important}.mdl-color-text--lime-A100{color:#f4ff81!important}.mdl-color--lime-A100{background-color:#f4ff81!important}.mdl-color-text--lime-A200{color:#eeff41!important}.mdl-color--lime-A200{background-color:#eeff41!important}.mdl-color-text--lime-A400{color:#c6ff00!important}.mdl-color--lime-A400{background-color:#c6ff00!important}.mdl-color-text--lime-A700{color:#aeea00!important}.mdl-color--lime-A700{background-color:#aeea00!important}.mdl-color-text--yellow{color:#ffeb3b!important}.mdl-color--yellow{background-color:#ffeb3b!important}.mdl-color-text--yellow-50{color:#fffde7!important}.mdl-color--yellow-50{background-color:#fffde7!important}.mdl-color-text--yellow-100{color:#fff9c4!important}.mdl-color--yellow-100{background-color:#fff9c4!important}.mdl-color-text--yellow-200{color:#fff59d!important}.mdl-color--yellow-200{background-color:#fff59d!important}.mdl-color-text--yellow-300{color:#fff176!important}.mdl-color--yellow-300{background-color:#fff176!important}.mdl-color-text--yellow-400{color:#ffee58!important}.mdl-color--yellow-400{background-color:#ffee58!important}.mdl-color-text--yellow-500{color:#ffeb3b!important}.mdl-color--yellow-500{background-color:#ffeb3b!important}.mdl-color-text--yellow-600{color:#fdd835!important}.mdl-color--yellow-600{background-color:#fdd835!important}.mdl-color-text--yellow-700{color:#fbc02d!important}.mdl-color--yellow-700{background-color:#fbc02d!important}.mdl-color-text--yellow-800{color:#f9a825!important}.mdl-color--yellow-800{background-color:#f9a825!important}.mdl-color-text--yellow-900{color:#f57f17!important}.mdl-color--yellow-900{background-color:#f57f17!important}.mdl-color-text--yellow-A100{color:#ffff8d!important}.mdl-color--yellow-A100{background-color:#ffff8d!important}.mdl-color-text--yellow-A200{color:#ff0!important}.mdl-color--yellow-A200{background-color:#ff0!important}.mdl-color-text--yellow-A400{color:#ffea00!important}.mdl-color--yellow-A400{background-color:#ffea00!important}.mdl-color-text--yellow-A700{color:#ffd600!important}.mdl-color--yellow-A700{background-color:#ffd600!important}.mdl-color-text--amber{color:#ffc107!important}.mdl-color--amber{background-color:#ffc107!important}.mdl-color-text--amber-50{color:#fff8e1!important}.mdl-color--amber-50{background-color:#fff8e1!important}.mdl-color-text--amber-100{color:#ffecb3!important}.mdl-color--amber-100{background-color:#ffecb3!important}.mdl-color-text--amber-200{color:#ffe082!important}.mdl-color--amber-200{background-color:#ffe082!important}.mdl-color-text--amber-300{color:#ffd54f!important}.mdl-color--amber-300{background-color:#ffd54f!important}.mdl-color-text--amber-400{color:#ffca28!important}.mdl-color--amber-400{background-color:#ffca28!important}.mdl-color-text--amber-500{color:#ffc107!important}.mdl-color--amber-500{background-color:#ffc107!important}.mdl-color-text--amber-600{color:#ffb300!important}.mdl-color--amber-600{background-color:#ffb300!important}.mdl-color-text--amber-700{color:#ffa000!important}.mdl-color--amber-700{background-color:#ffa000!important}.mdl-color-text--amber-800{color:#ff8f00!important}.mdl-color--amber-800{background-color:#ff8f00!important}.mdl-color-text--amber-900{color:#ff6f00!important}.mdl-color--amber-900{background-color:#ff6f00!important}.mdl-color-text--amber-A100{color:#ffe57f!important}.mdl-color--amber-A100{background-color:#ffe57f!important}.mdl-color-text--amber-A200{color:#ffd740!important}.mdl-color--amber-A200{background-color:#ffd740!important}.mdl-color-text--amber-A400{color:#ffc400!important}.mdl-color--amber-A400{background-color:#ffc400!important}.mdl-color-text--amber-A700{color:#ffab00!important}.mdl-color--amber-A700{background-color:#ffab00!important}.mdl-color-text--orange{color:#ff9800!important}.mdl-color--orange{background-color:#ff9800!important}.mdl-color-text--orange-50{color:#fff3e0!important}.mdl-color--orange-50{background-color:#fff3e0!important}.mdl-color-text--orange-100{color:#ffe0b2!important}.mdl-color--orange-100{background-color:#ffe0b2!important}.mdl-color-text--orange-200{color:#ffcc80!important}.mdl-color--orange-200{background-color:#ffcc80!important}.mdl-color-text--orange-300{color:#ffb74d!important}.mdl-color--orange-300{background-color:#ffb74d!important}.mdl-color-text--orange-400{color:#ffa726!important}.mdl-color--orange-400{background-color:#ffa726!important}.mdl-color-text--orange-500{color:#ff9800!important}.mdl-color--orange-500{background-color:#ff9800!important}.mdl-color-text--orange-600{color:#fb8c00!important}.mdl-color--orange-600{background-color:#fb8c00!important}.mdl-color-text--orange-700{color:#f57c00!important}.mdl-color--orange-700{background-color:#f57c00!important}.mdl-color-text--orange-800{color:#ef6c00!important}.mdl-color--orange-800{background-color:#ef6c00!important}.mdl-color-text--orange-900{color:#e65100!important}.mdl-color--orange-900{background-color:#e65100!important}.mdl-color-text--orange-A100{color:#ffd180!important}.mdl-color--orange-A100{background-color:#ffd180!important}.mdl-color-text--orange-A200{color:#ffab40!important}.mdl-color--orange-A200{background-color:#ffab40!important}.mdl-color-text--orange-A400{color:#ff9100!important}.mdl-color--orange-A400{background-color:#ff9100!important}.mdl-color-text--orange-A700{color:#ff6d00!important}.mdl-color--orange-A700{background-color:#ff6d00!important}.mdl-color-text--deep-orange{color:#ff5722!important}.mdl-color--deep-orange{background-color:#ff5722!important}.mdl-color-text--deep-orange-50{color:#fbe9e7!important}.mdl-color--deep-orange-50{background-color:#fbe9e7!important}.mdl-color-text--deep-orange-100{color:#ffccbc!important}.mdl-color--deep-orange-100{background-color:#ffccbc!important}.mdl-color-text--deep-orange-200{color:#ffab91!important}.mdl-color--deep-orange-200{background-color:#ffab91!important}.mdl-color-text--deep-orange-300{color:#ff8a65!important}.mdl-color--deep-orange-300{background-color:#ff8a65!important}.mdl-color-text--deep-orange-400{color:#ff7043!important}.mdl-color--deep-orange-400{background-color:#ff7043!important}.mdl-color-text--deep-orange-500{color:#ff5722!important}.mdl-color--deep-orange-500{background-color:#ff5722!important}.mdl-color-text--deep-orange-600{color:#f4511e!important}.mdl-color--deep-orange-600{background-color:#f4511e!important}.mdl-color-text--deep-orange-700{color:#e64a19!important}.mdl-color--deep-orange-700{background-color:#e64a19!important}.mdl-color-text--deep-orange-800{color:#d84315!important}.mdl-color--deep-orange-800{background-color:#d84315!important}.mdl-color-text--deep-orange-900{color:#bf360c!important}.mdl-color--deep-orange-900{background-color:#bf360c!important}.mdl-color-text--deep-orange-A100{color:#ff9e80!important}.mdl-color--deep-orange-A100{background-color:#ff9e80!important}.mdl-color-text--deep-orange-A200{color:#ff6e40!important}.mdl-color--deep-orange-A200{background-color:#ff6e40!important}.mdl-color-text--deep-orange-A400{color:#ff3d00!important}.mdl-color--deep-orange-A400{background-color:#ff3d00!important}.mdl-color-text--deep-orange-A700{color:#dd2c00!important}.mdl-color--deep-orange-A700{background-color:#dd2c00!important}.mdl-color-text--brown{color:#795548!important}.mdl-color--brown{background-color:#795548!important}.mdl-color-text--brown-50{color:#efebe9!important}.mdl-color--brown-50{background-color:#efebe9!important}.mdl-color-text--brown-100{color:#d7ccc8!important}.mdl-color--brown-100{background-color:#d7ccc8!important}.mdl-color-text--brown-200{color:#bcaaa4!important}.mdl-color--brown-200{background-color:#bcaaa4!important}.mdl-color-text--brown-300{color:#a1887f!important}.mdl-color--brown-300{background-color:#a1887f!important}.mdl-color-text--brown-400{color:#8d6e63!important}.mdl-color--brown-400{background-color:#8d6e63!important}.mdl-color-text--brown-500{color:#795548!important}.mdl-color--brown-500{background-color:#795548!important}.mdl-color-text--brown-600{color:#6d4c41!important}.mdl-color--brown-600{background-color:#6d4c41!important}.mdl-color-text--brown-700{color:#5d4037!important}.mdl-color--brown-700{background-color:#5d4037!important}.mdl-color-text--brown-800{color:#4e342e!important}.mdl-color--brown-800{background-color:#4e342e!important}.mdl-color-text--brown-900{color:#3e2723!important}.mdl-color--brown-900{background-color:#3e2723!important}.mdl-color-text--grey{color:#9e9e9e!important}.mdl-color--grey{background-color:#9e9e9e!important}.mdl-color-text--grey-50{color:#fafafa!important}.mdl-color--grey-50{background-color:#fafafa!important}.mdl-color-text--grey-100{color:#f5f5f5!important}.mdl-color--grey-100{background-color:#f5f5f5!important}.mdl-color-text--grey-200{color:#eee!important}.mdl-color--grey-200{background-color:#eee!important}.mdl-color-text--grey-300{color:#e0e0e0!important}.mdl-color--grey-300{background-color:#e0e0e0!important}.mdl-color-text--grey-400{color:#bdbdbd!important}.mdl-color--grey-400{background-color:#bdbdbd!important}.mdl-color-text--grey-500{color:#9e9e9e!important}.mdl-color--grey-500{background-color:#9e9e9e!important}.mdl-color-text--grey-600{color:#757575!important}.mdl-color--grey-600{background-color:#757575!important}.mdl-color-text--grey-700{color:#616161!important}.mdl-color--grey-700{background-color:#616161!important}.mdl-color-text--grey-800{color:#424242!important}.mdl-color--grey-800{background-color:#424242!important}.mdl-color-text--grey-900{color:#212121!important}.mdl-color--grey-900{background-color:#212121!important}.mdl-color-text--blue-grey{color:#607d8b!important}.mdl-color--blue-grey{background-color:#607d8b!important}.mdl-color-text--blue-grey-50{color:#eceff1!important}.mdl-color--blue-grey-50{background-color:#eceff1!important}.mdl-color-text--blue-grey-100{color:#cfd8dc!important}.mdl-color--blue-grey-100{background-color:#cfd8dc!important}.mdl-color-text--blue-grey-200{color:#b0bec5!important}.mdl-color--blue-grey-200{background-color:#b0bec5!important}.mdl-color-text--blue-grey-300{color:#90a4ae!important}.mdl-color--blue-grey-300{background-color:#90a4ae!important}.mdl-color-text--blue-grey-400{color:#78909c!important}.mdl-color--blue-grey-400{background-color:#78909c!important}.mdl-color-text--blue-grey-500{color:#607d8b!important}.mdl-color--blue-grey-500{background-color:#607d8b!important}.mdl-color-text--blue-grey-600{color:#546e7a!important}.mdl-color--blue-grey-600{background-color:#546e7a!important}.mdl-color-text--blue-grey-700{color:#455a64!important}.mdl-color--blue-grey-700{background-color:#455a64!important}.mdl-color-text--blue-grey-800{color:#37474f!important}.mdl-color--blue-grey-800{background-color:#37474f!important}.mdl-color-text--blue-grey-900{color:#263238!important}.mdl-color--blue-grey-900{background-color:#263238!important}.mdl-color--black{background-color:#000!important}.mdl-color-text--black{color:#000!important}.mdl-color--white{background-color:#fff!important}.mdl-color-text--white{color:#fff!important}.mdl-color--primary{background-color:#2196f3!important}.mdl-color--primary-contrast{background-color:#fff!important}.mdl-color--primary-dark{background-color:#1976d2!important}.mdl-color--accent{background-color:#40c4ff!important}.mdl-color--accent-contrast{background-color:#424242!important}.mdl-color-text--primary{color:#2196f3!important}.mdl-color-text--primary-contrast{color:#fff!important}.mdl-color-text--primary-dark{color:#1976d2!important}.mdl-color-text--accent{color:#40c4ff!important}.mdl-color-text--accent-contrast{color:#424242!important}.mdl-ripple{background:#000;border-radius:50%;height:50px;left:0;opacity:0;pointer-events:none;position:absolute;top:0;transform:translate(-50%,-50%);width:50px;overflow:hidden}.mdl-ripple.is-animating{transition:transform .3s cubic-bezier(0,0,.2,1),width .3s cubic-bezier(0,0,.2,1),height .3s cubic-bezier(0,0,.2,1),opacity .6s cubic-bezier(0,0,.2,1)}.mdl-ripple.is-visible{opacity:.3}.mdl-animation--default,.mdl-animation--fast-out-slow-in{transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-animation--linear-out-slow-in{transition-timing-function:cubic-bezier(0,0,.2,1)}.mdl-animation--fast-out-linear-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.mdl-badge{position:relative;white-space:nowrap;margin-right:24px}.mdl-badge:not([data-badge]){margin-right:auto}.mdl-badge[data-badge]:after{content:attr(data-badge);display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;position:absolute;top:-11px;right:-24px;font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:600;font-size:12px;width:22px;height:22px;border-radius:50%;background:#40c4ff;color:#424242}.mdl-button .mdl-badge[data-badge]:after{top:-10px;right:-5px}.mdl-badge.mdl-badge--no-background[data-badge]:after{color:#40c4ff;background:rgba(66,66,66,.2);box-shadow:0 0 1px gray}.mdl-badge.mdl-badge--overlap{margin-right:10px}.mdl-badge.mdl-badge--overlap:after{right:-10px}.mdl-button{background:0 0;border:none;border-radius:2px;color:#000;position:relative;height:36px;margin:0;min-width:64px;padding:0 16px;display:inline-block;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase;letter-spacing:0;overflow:hidden;will-change:box-shadow;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1);outline:none;cursor:pointer;text-decoration:none;text-align:center;line-height:36px;vertical-align:middle}.mdl-button::-moz-focus-inner{border:0}.mdl-button:hover{background-color:hsla(0,0%,62%,.2)}.mdl-button:focus:not(:active){background-color:rgba(0,0,0,.12)}.mdl-button:active{background-color:hsla(0,0%,62%,.4)}.mdl-button.mdl-button--colored{color:#2196f3}.mdl-button.mdl-button--colored:focus:not(:active){background-color:rgba(0,0,0,.12)}input.mdl-button[type=submit]{-webkit-appearance:none}.mdl-button--raised{background:hsla(0,0%,62%,.2);box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-button--raised:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised.mdl-button--colored{background:#2196f3;color:#fff}.mdl-button--raised.mdl-button--colored:active,.mdl-button--raised.mdl-button--colored:focus:not(:active),.mdl-button--raised.mdl-button--colored:hover{background-color:#2196f3}.mdl-button--raised.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--fab{border-radius:50%;font-size:24px;height:56px;margin:auto;min-width:56px;width:56px;padding:0;overflow:hidden;background:hsla(0,0%,62%,.2);box-shadow:0 1px 1.5px 0 rgba(0,0,0,.12),0 1px 1px 0 rgba(0,0,0,.24);position:relative;line-height:normal}.mdl-button--fab .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--fab.mdl-button--mini-fab{height:40px;min-width:40px;width:40px}.mdl-button--fab .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button--fab:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab.mdl-button--colored{background:#40c4ff;color:#424242}.mdl-button--fab.mdl-button--colored:active,.mdl-button--fab.mdl-button--colored:focus:not(:active),.mdl-button--fab.mdl-button--colored:hover{background-color:#40c4ff}.mdl-button--fab.mdl-button--colored .mdl-ripple{background:#424242}.mdl-button--icon{border-radius:50%;font-size:24px;height:32px;margin-left:0;margin-right:0;min-width:32px;width:32px;padding:0;overflow:hidden;color:inherit;line-height:normal}.mdl-button--icon .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon{height:24px;min-width:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon .material-icons{top:0;left:0}.mdl-button--icon .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button__ripple-container{display:block;height:100%;left:0;position:absolute;top:0;width:100%;z-index:0;overflow:hidden}.mdl-button.mdl-button--disabled .mdl-button__ripple-container .mdl-ripple,.mdl-button[disabled] .mdl-button__ripple-container .mdl-ripple{background-color:transparent}.mdl-button--primary.mdl-button--primary{color:#2196f3}.mdl-button--primary.mdl-button--primary .mdl-ripple{background:#fff}.mdl-button--primary.mdl-button--primary.mdl-button--fab,.mdl-button--primary.mdl-button--primary.mdl-button--raised{color:#fff;background-color:#2196f3}.mdl-button--accent.mdl-button--accent{color:#40c4ff}.mdl-button--accent.mdl-button--accent .mdl-ripple{background:#424242}.mdl-button--accent.mdl-button--accent.mdl-button--fab,.mdl-button--accent.mdl-button--accent.mdl-button--raised{color:#424242;background-color:#40c4ff}.mdl-button.mdl-button--disabled.mdl-button--disabled,.mdl-button[disabled][disabled]{color:rgba(0,0,0,.26);cursor:default;background-color:transparent}.mdl-button--fab.mdl-button--disabled.mdl-button--disabled,.mdl-button--fab[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-button--raised.mdl-button--disabled.mdl-button--disabled,.mdl-button--raised[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26);box-shadow:none}.mdl-button--colored.mdl-button--disabled.mdl-button--disabled,.mdl-button--colored[disabled][disabled]{color:rgba(0,0,0,.26)}.mdl-button .material-icons{vertical-align:middle}.mdl-card{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;font-size:16px;font-weight:400;min-height:200px;overflow:hidden;width:330px;z-index:1;position:relative;background:#fff;border-radius:2px;box-sizing:border-box}.mdl-card__media{background-color:#40c4ff;background-repeat:repeat;background-position:50% 50%;background-size:cover;background-origin:padding-box;background-attachment:scroll;box-sizing:border-box}.mdl-card__title,.mdl-card__title-text{display:block;display:-ms-flexbox;display:flex;line-height:normal}.mdl-card__title{-ms-flex-align:center;align-items:center;-ms-flex-pack:stretch;justify-content:stretch;padding:16px;perspective-origin:165px 56px;box-sizing:border-box;color:#000;transform-origin:165px 56px}.mdl-card__title.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__title-text{-ms-flex-item-align:end;align-self:flex-end;color:inherit;font-size:24px;font-weight:300;overflow:hidden;transform-origin:149px 48px;margin:0}.mdl-card__subtitle-text{font-size:14px;color:rgba(0,0,0,.54);margin:0}.mdl-card__supporting-text{color:rgba(0,0,0,.54);font-size:1rem;line-height:18px;overflow:hidden;padding:16px;width:90%}.mdl-card__actions{font-size:16px;line-height:normal;width:100%;background-color:transparent;padding:8px;box-sizing:border-box}.mdl-card__actions.mdl-card--border{border-top:1px solid rgba(0,0,0,.1)}.mdl-card--expand{-ms-flex-positive:1;flex-grow:1}.mdl-card__menu{position:absolute;right:16px;top:16px}.mdl-checkbox{position:relative;z-index:1;vertical-align:middle;display:inline-block;box-sizing:border-box;width:100%;height:24px;margin:0;padding:0}.mdl-checkbox.is-upgraded{padding-left:24px}.mdl-checkbox__input{line-height:24px}.mdl-checkbox.is-upgraded .mdl-checkbox__input{position:absolute;width:0;height:0;margin:0;padding:0;opacity:0;-ms-appearance:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none}.mdl-checkbox__box-outline{position:absolute;top:3px;left:0;display:inline-block;box-sizing:border-box;width:16px;height:16px;margin:0;cursor:pointer;overflow:hidden;border:2px solid rgba(0,0,0,.54);border-radius:2px;z-index:2}.mdl-checkbox.is-checked .mdl-checkbox__box-outline{border:2px solid #2196f3}.mdl-checkbox.is-disabled .mdl-checkbox__box-outline,fieldset[disabled] .mdl-checkbox .mdl-checkbox__box-outline{border:2px solid rgba(0,0,0,.26);cursor:auto}.mdl-checkbox__focus-helper{position:absolute;top:3px;left:0;display:inline-block;box-sizing:border-box;width:16px;height:16px;border-radius:50%;background-color:transparent}.mdl-checkbox.is-focused .mdl-checkbox__focus-helper{box-shadow:0 0 0 8px rgba(0,0,0,.1);background-color:rgba(0,0,0,.1)}.mdl-checkbox.is-focused.is-checked .mdl-checkbox__focus-helper{box-shadow:0 0 0 8px rgba(33,150,243,.26);background-color:rgba(33,150,243,.26)}.mdl-checkbox__tick-outline{position:absolute;top:0;left:0;height:100%;width:100%;-webkit-mask:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcCI+CiAgICAgIDxwYXRoCiAgICAgICAgIGQ9Ik0gMCwwIDAsMSAxLDEgMSwwIDAsMCB6IE0gMC44NTM0Mzc1LDAuMTY3MTg3NSAwLjk1OTY4NzUsMC4yNzMxMjUgMC40MjkzNzUsMC44MDM0Mzc1IDAuMzIzMTI1LDAuOTA5Njg3NSAwLjIxNzE4NzUsMC44MDM0Mzc1IDAuMDQwMzEyNSwwLjYyNjg3NSAwLjE0NjU2MjUsMC41MjA2MjUgMC4zMjMxMjUsMC42OTc1IDAuODUzNDM3NSwwLjE2NzE4NzUgeiIKICAgICAgICAgc3R5bGU9ImZpbGw6I2ZmZmZmZjtmaWxsLW9wYWNpdHk6MTtzdHJva2U6bm9uZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgICA8bWFzayBpZD0ibWFzayIgbWFza1VuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgbWFza0NvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICA8cGF0aAogICAgICAgICBkPSJNIDAsMCAwLDEgMSwxIDEsMCAwLDAgeiBNIDAuODUzNDM3NSwwLjE2NzE4NzUgMC45NTk2ODc1LDAuMjczMTI1IDAuNDI5Mzc1LDAuODAzNDM3NSAwLjMyMzEyNSwwLjkwOTY4NzUgMC4yMTcxODc1LDAuODAzNDM3NSAwLjA0MDMxMjUsMC42MjY4NzUgMC4xNDY1NjI1LDAuNTIwNjI1IDAuMzIzMTI1LDAuNjk3NSAwLjg1MzQzNzUsMC4xNjcxODc1IHoiCiAgICAgICAgIHN0eWxlPSJmaWxsOiNmZmZmZmY7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOm5vbmUiIC8+CiAgICA8L21hc2s+CiAgPC9kZWZzPgogIDxyZWN0CiAgICAgd2lkdGg9IjEiCiAgICAgaGVpZ2h0PSIxIgogICAgIHg9IjAiCiAgICAgeT0iMCIKICAgICBjbGlwLXBhdGg9InVybCgjY2xpcCkiCiAgICAgc3R5bGU9ImZpbGw6IzAwMDAwMDtmaWxsLW9wYWNpdHk6MTtzdHJva2U6bm9uZSIgLz4KPC9zdmc+Cg==\");mask:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcCI+CiAgICAgIDxwYXRoCiAgICAgICAgIGQ9Ik0gMCwwIDAsMSAxLDEgMSwwIDAsMCB6IE0gMC44NTM0Mzc1LDAuMTY3MTg3NSAwLjk1OTY4NzUsMC4yNzMxMjUgMC40MjkzNzUsMC44MDM0Mzc1IDAuMzIzMTI1LDAuOTA5Njg3NSAwLjIxNzE4NzUsMC44MDM0Mzc1IDAuMDQwMzEyNSwwLjYyNjg3NSAwLjE0NjU2MjUsMC41MjA2MjUgMC4zMjMxMjUsMC42OTc1IDAuODUzNDM3NSwwLjE2NzE4NzUgeiIKICAgICAgICAgc3R5bGU9ImZpbGw6I2ZmZmZmZjtmaWxsLW9wYWNpdHk6MTtzdHJva2U6bm9uZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgICA8bWFzayBpZD0ibWFzayIgbWFza1VuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgbWFza0NvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICA8cGF0aAogICAgICAgICBkPSJNIDAsMCAwLDEgMSwxIDEsMCAwLDAgeiBNIDAuODUzNDM3NSwwLjE2NzE4NzUgMC45NTk2ODc1LDAuMjczMTI1IDAuNDI5Mzc1LDAuODAzNDM3NSAwLjMyMzEyNSwwLjkwOTY4NzUgMC4yMTcxODc1LDAuODAzNDM3NSAwLjA0MDMxMjUsMC42MjY4NzUgMC4xNDY1NjI1LDAuNTIwNjI1IDAuMzIzMTI1LDAuNjk3NSAwLjg1MzQzNzUsMC4xNjcxODc1IHoiCiAgICAgICAgIHN0eWxlPSJmaWxsOiNmZmZmZmY7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOm5vbmUiIC8+CiAgICA8L21hc2s+CiAgPC9kZWZzPgogIDxyZWN0CiAgICAgd2lkdGg9IjEiCiAgICAgaGVpZ2h0PSIxIgogICAgIHg9IjAiCiAgICAgeT0iMCIKICAgICBjbGlwLXBhdGg9InVybCgjY2xpcCkiCiAgICAgc3R5bGU9ImZpbGw6IzAwMDAwMDtmaWxsLW9wYWNpdHk6MTtzdHJva2U6bm9uZSIgLz4KPC9zdmc+Cg==\");background:0 0;transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:background}.mdl-checkbox.is-checked .mdl-checkbox__tick-outline{background:#2196f3url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K\")}.mdl-checkbox.is-checked.is-disabled .mdl-checkbox__tick-outline,fieldset[disabled] .mdl-checkbox.is-checked .mdl-checkbox__tick-outline{background:rgba(0,0,0,.26)url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K\")}.mdl-checkbox__label{position:relative;cursor:pointer;font-size:16px;line-height:24px;margin:0}.mdl-checkbox.is-disabled .mdl-checkbox__label,fieldset[disabled] .mdl-checkbox .mdl-checkbox__label{color:rgba(0,0,0,.26);cursor:auto}.mdl-checkbox__ripple-container{position:absolute;z-index:2;top:-6px;left:-10px;box-sizing:border-box;width:36px;height:36px;border-radius:50%;cursor:pointer;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-checkbox__ripple-container .mdl-ripple{background:#2196f3}.mdl-checkbox.is-disabled .mdl-checkbox__ripple-container,fieldset[disabled] .mdl-checkbox .mdl-checkbox__ripple-container{cursor:auto}.mdl-checkbox.is-disabled .mdl-checkbox__ripple-container .mdl-ripple,fieldset[disabled] .mdl-checkbox .mdl-checkbox__ripple-container .mdl-ripple{background:0 0}.mdl-data-table{position:relative;border:1px solid rgba(0,0,0,.12);border-collapse:collapse;white-space:nowrap;font-size:13px;background-color:#fff}.mdl-data-table thead{padding-bottom:3px}.mdl-data-table thead .mdl-data-table__select{margin-top:0}.mdl-data-table tbody tr{position:relative;height:48px;transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:background-color}.mdl-data-table tbody tr.is-selected{background-color:#e0e0e0}.mdl-data-table tbody tr:hover{background-color:#eee}.mdl-data-table td,.mdl-data-table th{padding:0 18px 12px;text-align:right}.mdl-data-table td:first-of-type,.mdl-data-table th:first-of-type{padding-left:24px}.mdl-data-table td:last-of-type,.mdl-data-table th:last-of-type{padding-right:24px}.mdl-data-table td,.mdl-data-table th{position:relative;height:48px;box-sizing:border-box}.mdl-data-table td{border-top:1px solid rgba(0,0,0,.12);border-bottom:1px solid rgba(0,0,0,.12);padding-top:12px}.mdl-data-table td,.mdl-data-table td .mdl-data-table__select{vertical-align:middle}.mdl-data-table th{vertical-align:bottom;text-overflow:ellipsis;font-weight:700;line-height:24px;letter-spacing:0;font-size:12px;color:rgba(0,0,0,.54);padding-bottom:8px}.mdl-data-table th .mdl-data-table__header--sorted-ascending,.mdl-data-table th .mdl-data-table__header--sorted-descending{color:rgba(0,0,0,.87)}.mdl-data-table th .mdl-data-table__header--sorted-ascending:before,.mdl-data-table th .mdl-data-table__header--sorted-descending:before{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;word-wrap:normal;font-feature-settings:\"liga\";-webkit-font-feature-settings:\"liga\";-webkit-font-smoothing:antialiased}.mdl-data-table th .mdl-data-table__header--sorted-ascending:before{content:\"\\E5D8\"}.mdl-data-table th .mdl-data-table__header--sorted-descending:before{content:\"\\E5DB\"}.mdl-data-table__select{width:16px}.mdl-data-table__cell--non-numeric.mdl-data-table__cell--non-numeric{text-align:left}.mdl-dialog{border:none;box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2);width:280px}.mdl-dialog__title{padding:24px 24px 0;margin:0;font-size:2.5rem}.mdl-dialog__actions{padding:8px 8px 8px 24px;display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-ms-flex-wrap:wrap;flex-wrap:wrap}.mdl-dialog__actions>*{margin-right:8px;height:36px}.mdl-dialog__actions>:first-child{margin-right:0}.mdl-dialog__actions--full-width{padding:0 0 8px}.mdl-dialog__actions--full-width>*{height:48px;-ms-flex:0 0 100%;flex:0 0 100%;padding-right:16px;margin-right:0;text-align:right}.mdl-dialog__content{padding:20px 24px 24px;color:rgba(0,0,0,.54)}.mdl-mega-footer{padding:16px 40px;color:#9e9e9e;background-color:#424242}.mdl-mega-footer--bottom-section:after,.mdl-mega-footer--middle-section:after,.mdl-mega-footer--top-section:after,.mdl-mega-footer__bottom-section:after,.mdl-mega-footer__middle-section:after,.mdl-mega-footer__top-section:after{content:\"\";display:block;clear:both}.mdl-mega-footer--left-section,.mdl-mega-footer--right-section,.mdl-mega-footer__left-section,.mdl-mega-footer__right-section{margin-bottom:16px}.mdl-mega-footer--right-section a,.mdl-mega-footer__right-section a{display:block;margin-bottom:16px;color:inherit;text-decoration:none}@media screen and (min-width:760px){.mdl-mega-footer--left-section,.mdl-mega-footer__left-section{float:left}.mdl-mega-footer--right-section,.mdl-mega-footer__right-section{float:right}.mdl-mega-footer--right-section a,.mdl-mega-footer__right-section a{display:inline-block;margin-left:16px;line-height:36px;vertical-align:middle}}.mdl-mega-footer--social-btn,.mdl-mega-footer__social-btn{width:36px;height:36px;padding:0;margin:0;background-color:#9e9e9e;border:none}.mdl-mega-footer--drop-down-section,.mdl-mega-footer__drop-down-section{display:block;position:relative}@media screen and (min-width:760px){.mdl-mega-footer--drop-down-section,.mdl-mega-footer__drop-down-section{width:33%}.mdl-mega-footer--drop-down-section:first-child,.mdl-mega-footer--drop-down-section:nth-child(2),.mdl-mega-footer__drop-down-section:first-child,.mdl-mega-footer__drop-down-section:nth-child(2){float:left}.mdl-mega-footer--drop-down-section:nth-child(3),.mdl-mega-footer__drop-down-section:nth-child(3){float:right}.mdl-mega-footer--drop-down-section:nth-child(3):after,.mdl-mega-footer__drop-down-section:nth-child(3):after{clear:right}.mdl-mega-footer--drop-down-section:nth-child(4),.mdl-mega-footer__drop-down-section:nth-child(4){clear:right;float:right}.mdl-mega-footer--middle-section:after,.mdl-mega-footer__middle-section:after{content:\"\";display:block;clear:both}.mdl-mega-footer--bottom-section,.mdl-mega-footer__bottom-section{padding-top:0}}@media screen and (min-width:1024px){.mdl-mega-footer--drop-down-section,.mdl-mega-footer--drop-down-section:nth-child(3),.mdl-mega-footer--drop-down-section:nth-child(4),.mdl-mega-footer__drop-down-section,.mdl-mega-footer__drop-down-section:nth-child(3),.mdl-mega-footer__drop-down-section:nth-child(4){width:24%;float:left}}.mdl-mega-footer--heading-checkbox,.mdl-mega-footer__heading-checkbox{position:absolute;width:100%;height:55.8px;padding:32px;margin:-16px 0 0;cursor:pointer;z-index:1;opacity:0}.mdl-mega-footer--heading-checkbox+.mdl-mega-footer--heading:after,.mdl-mega-footer--heading-checkbox+.mdl-mega-footer__heading:after,.mdl-mega-footer__heading-checkbox+.mdl-mega-footer--heading:after,.mdl-mega-footer__heading-checkbox+.mdl-mega-footer__heading:after{font-family:Material Icons;content:\"\\E5CE\"}.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer--heading+.mdl-mega-footer--link-list,.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer__heading+.mdl-mega-footer__link-list,.mdl-mega-footer--heading-checkbox:checked~.mdl-mega-footer--link-list,.mdl-mega-footer--heading-checkbox:checked~.mdl-mega-footer__link-list,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer--heading+.mdl-mega-footer--link-list,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer__heading+.mdl-mega-footer__link-list,.mdl-mega-footer__heading-checkbox:checked~.mdl-mega-footer--link-list,.mdl-mega-footer__heading-checkbox:checked~.mdl-mega-footer__link-list{display:none}.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer--heading:after,.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer__heading:after,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer--heading:after,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer__heading:after{font-family:Material Icons;content:\"\\E5CF\"}.mdl-mega-footer--heading,.mdl-mega-footer__heading{position:relative;width:100%;padding-right:39.8px;margin-bottom:16px;box-sizing:border-box;font-size:14px;line-height:23.8px;font-weight:500;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:#e0e0e0}.mdl-mega-footer--heading:after,.mdl-mega-footer__heading:after{content:\"\";position:absolute;top:0;right:0;display:block;width:23.8px;height:23.8px;background-size:cover}.mdl-mega-footer--link-list,.mdl-mega-footer__link-list{list-style:none;padding:0;margin:0 0 32px}.mdl-mega-footer--link-list:after,.mdl-mega-footer__link-list:after{clear:both;display:block;content:\"\"}.mdl-mega-footer--link-list li,.mdl-mega-footer__link-list li{font-size:14px;font-weight:400;letter-spacing:0;line-height:20px}.mdl-mega-footer--link-list a,.mdl-mega-footer__link-list a{color:inherit;text-decoration:none;white-space:nowrap}@media screen and (min-width:760px){.mdl-mega-footer--heading-checkbox,.mdl-mega-footer__heading-checkbox{display:none}.mdl-mega-footer--heading-checkbox+.mdl-mega-footer--heading:after,.mdl-mega-footer--heading-checkbox+.mdl-mega-footer__heading:after,.mdl-mega-footer__heading-checkbox+.mdl-mega-footer--heading:after,.mdl-mega-footer__heading-checkbox+.mdl-mega-footer__heading:after{content:\"\"}.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer--heading+.mdl-mega-footer--link-list,.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer__heading+.mdl-mega-footer__link-list,.mdl-mega-footer--heading-checkbox:checked~.mdl-mega-footer--link-list,.mdl-mega-footer--heading-checkbox:checked~.mdl-mega-footer__link-list,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer--heading+.mdl-mega-footer--link-list,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer__heading+.mdl-mega-footer__link-list,.mdl-mega-footer__heading-checkbox:checked~.mdl-mega-footer--link-list,.mdl-mega-footer__heading-checkbox:checked~.mdl-mega-footer__link-list{display:block}.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer--heading:after,.mdl-mega-footer--heading-checkbox:checked+.mdl-mega-footer__heading:after,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer--heading:after,.mdl-mega-footer__heading-checkbox:checked+.mdl-mega-footer__heading:after{content:\"\"}}.mdl-mega-footer--bottom-section,.mdl-mega-footer__bottom-section{padding-top:16px;margin-bottom:16px}.mdl-logo{margin-bottom:16px;color:#fff}.mdl-mega-footer--bottom-section .mdl-mega-footer--link-list li,.mdl-mega-footer__bottom-section .mdl-mega-footer__link-list li{float:left;margin-bottom:0;margin-right:16px}@media screen and (min-width:760px){.mdl-logo{float:left;margin-bottom:0;margin-right:16px}}.mdl-mini-footer{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:justify;justify-content:space-between;padding:32px 16px;color:#9e9e9e;background-color:#424242}.mdl-mini-footer:after{content:\"\";display:block}.mdl-mini-footer .mdl-logo{line-height:36px}.mdl-mini-footer--link-list,.mdl-mini-footer__link-list{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;list-style:none;margin:0;padding:0}.mdl-mini-footer--link-list li,.mdl-mini-footer__link-list li{margin-bottom:0;margin-right:16px}@media screen and (min-width:760px){.mdl-mini-footer--link-list li,.mdl-mini-footer__link-list li{line-height:36px}}.mdl-mini-footer--link-list a,.mdl-mini-footer__link-list a{color:inherit;text-decoration:none;white-space:nowrap}.mdl-mini-footer--left-section,.mdl-mini-footer__left-section{display:inline-block;-ms-flex-order:0;order:0}.mdl-mini-footer--right-section,.mdl-mini-footer__right-section{display:inline-block;-ms-flex-order:1;order:1}.mdl-mini-footer--social-btn,.mdl-mini-footer__social-btn{width:36px;height:36px;padding:0;margin:0;background-color:#9e9e9e;border:none}.mdl-icon-toggle{position:relative;z-index:1;vertical-align:middle;display:inline-block;height:32px;margin:0;padding:0}.mdl-icon-toggle__input{line-height:32px}.mdl-icon-toggle.is-upgraded .mdl-icon-toggle__input{position:absolute;width:0;height:0;margin:0;padding:0;opacity:0;-ms-appearance:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none}.mdl-icon-toggle__label{display:inline-block;position:relative;cursor:pointer;height:32px;width:32px;min-width:32px;color:#616161;border-radius:50%;padding:0;margin-left:0;margin-right:0;text-align:center;background-color:transparent;will-change:background-color;transition:background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1)}.mdl-icon-toggle__label.material-icons{line-height:32px;font-size:24px}.mdl-icon-toggle.is-checked .mdl-icon-toggle__label{color:#2196f3}.mdl-icon-toggle.is-disabled .mdl-icon-toggle__label{color:rgba(0,0,0,.26);cursor:auto;transition:none}.mdl-icon-toggle.is-focused .mdl-icon-toggle__label{background-color:rgba(0,0,0,.12)}.mdl-icon-toggle.is-focused.is-checked .mdl-icon-toggle__label{background-color:rgba(33,150,243,.26)}.mdl-icon-toggle__ripple-container{position:absolute;z-index:2;top:-2px;left:-2px;box-sizing:border-box;width:36px;height:36px;border-radius:50%;cursor:pointer;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-icon-toggle__ripple-container .mdl-ripple{background:#616161}.mdl-icon-toggle.is-disabled .mdl-icon-toggle__ripple-container{cursor:auto}.mdl-icon-toggle.is-disabled .mdl-icon-toggle__ripple-container .mdl-ripple{background:0 0}.mdl-list{display:block;padding:8px 0;list-style:none}.mdl-list__item,.mdl-list__item .mdl-list__item-primary-content{box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.mdl-list__item{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;letter-spacing:.04em;line-height:1;min-height:48px;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding:16px;cursor:default;color:rgba(0,0,0,.87);overflow:hidden}.mdl-list__item .mdl-list__item-primary-content{-ms-flex-order:0;order:0;-ms-flex-positive:2;flex-grow:2;text-decoration:none}.mdl-list__item .mdl-list__item-primary-content .mdl-list__item-icon{margin-right:32px}.mdl-list__item .mdl-list__item-primary-content .mdl-list__item-avatar{margin-right:16px}.mdl-list__item .mdl-list__item-secondary-content{display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-align:end;align-items:flex-end;margin-left:16px}.mdl-list__item .mdl-list__item-secondary-content .mdl-list__item-secondary-action label{display:inline}.mdl-list__item .mdl-list__item-secondary-content .mdl-list__item-secondary-info{font-size:12px;font-weight:400;line-height:1;letter-spacing:0;color:rgba(0,0,0,.54)}.mdl-list__item .mdl-list__item-secondary-content .mdl-list__item-sub-header{padding:0 0 0 16px}.mdl-list__item-icon,.mdl-list__item-icon.material-icons{height:24px;width:24px;font-size:24px;box-sizing:border-box;color:#757575}.mdl-list__item-avatar,.mdl-list__item-avatar.material-icons{height:40px;width:40px;box-sizing:border-box;border-radius:50%;background-color:#757575;font-size:40px;color:#fff}.mdl-list__item--two-line{height:72px}.mdl-list__item--two-line .mdl-list__item-primary-content{height:36px;line-height:20px;display:block}.mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-avatar{float:left}.mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-icon{float:left;margin-top:6px}.mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-secondary-content{height:36px}.mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-sub-title{font-size:14px;font-weight:400;letter-spacing:0;line-height:18px;color:rgba(0,0,0,.54);display:block;padding:0}.mdl-list__item--three-line{height:88px}.mdl-list__item--three-line .mdl-list__item-primary-content{height:52px;line-height:20px;display:block}.mdl-list__item--three-line .mdl-list__item-primary-content .mdl-list__item-avatar,.mdl-list__item--three-line .mdl-list__item-primary-content .mdl-list__item-icon{float:left}.mdl-list__item--three-line .mdl-list__item-secondary-content{height:52px}.mdl-list__item--three-line .mdl-list__item-text-body{font-size:14px;font-weight:400;letter-spacing:0;line-height:18px;height:52px;color:rgba(0,0,0,.54);display:block;padding:0}.mdl-menu__container,.mdl-menu__outline{display:block;margin:0;padding:0;border:none;position:absolute;z-index:-1}.mdl-menu__container{height:0;width:0;visibility:hidden;overflow:visible}.mdl-menu__container.is-animating,.mdl-menu__container.is-visible{z-index:999;visibility:visible}.mdl-menu__outline{background:#fff;border-radius:2px;top:0;left:0;overflow:hidden;opacity:0;transform:scale(0);transform-origin:0 0;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);will-change:transform;transition:transform .3s cubic-bezier(.4,0,.2,1),opacity .2s cubic-bezier(.4,0,.2,1)}.mdl-menu__container.is-visible .mdl-menu__outline{opacity:1;transform:scale(1);z-index:999}.mdl-menu__outline.mdl-menu--bottom-right{transform-origin:100% 0}.mdl-menu__outline.mdl-menu--top-left{transform-origin:0 100%}.mdl-menu__outline.mdl-menu--top-right{transform-origin:100% 100%}.mdl-menu{position:absolute;list-style:none;top:0;left:0;height:auto;width:auto;min-width:124px;padding:8px 0;margin:0;opacity:0;clip:rect(0 0 0 0);z-index:-1}.mdl-menu__container.is-visible .mdl-menu{opacity:1;z-index:999}.mdl-menu.is-animating{transition:opacity .2s cubic-bezier(.4,0,.2,1),clip .3s cubic-bezier(.4,0,.2,1)}.mdl-menu.mdl-menu--bottom-right{left:auto;right:0}.mdl-menu.mdl-menu--top-left{top:auto;bottom:0}.mdl-menu.mdl-menu--top-right{top:auto;left:auto;bottom:0;right:0}.mdl-menu.mdl-menu--unaligned{top:auto;left:auto}.mdl-menu__item{display:block;border:none;color:rgba(0,0,0,.87);background-color:transparent;text-align:left;margin:0;padding:0 16px;outline-color:#bdbdbd;position:relative;overflow:hidden;font-size:14px;font-weight:400;letter-spacing:0;text-decoration:none;cursor:pointer;height:48px;line-height:48px;white-space:nowrap;opacity:0;transition:opacity .2s cubic-bezier(.4,0,.2,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mdl-menu__container.is-visible .mdl-menu__item{opacity:1}.mdl-menu__item::-moz-focus-inner{border:0}.mdl-menu__item--full-bleed-divider{border-bottom:1px solid rgba(0,0,0,.12)}.mdl-menu__item[data-mdl-disabled],.mdl-menu__item[disabled]{color:#bdbdbd;background-color:transparent;cursor:auto}.mdl-menu__item[data-mdl-disabled]:focus,.mdl-menu__item[data-mdl-disabled]:hover,.mdl-menu__item[disabled]:focus,.mdl-menu__item[disabled]:hover{background-color:transparent}.mdl-menu__item[data-mdl-disabled] .mdl-ripple,.mdl-menu__item[disabled] .mdl-ripple{background:0 0}.mdl-menu__item:hover{background-color:#eee}.mdl-menu__item:focus{outline:none;background-color:#eee}.mdl-menu__item:active{background-color:#e0e0e0}.mdl-menu__item--ripple-container{display:block;height:100%;left:0;position:absolute;top:0;width:100%;z-index:0;overflow:hidden}.mdl-progress{display:block;position:relative;height:4px;width:500px;max-width:100%}.mdl-progress>.bar{display:block;position:absolute;top:0;bottom:0;width:0;transition:width .2s cubic-bezier(.4,0,.2,1)}.mdl-progress>.progressbar{background-color:#2196f3;z-index:1;left:0}.mdl-progress>.bufferbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#2196f3,#2196f3);z-index:0;left:0}.mdl-progress>.auxbar{right:0}@supports (-webkit-appearance:none){.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#2196f3,#2196f3);-webkit-mask:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=\");mask:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=\")}}.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.9),hsla(0,0%,100%,.9)),linear-gradient(90deg,#2196f3,#2196f3)}.mdl-progress.mdl-progress--indeterminate>.bar1,.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar1,.mdl-progress.mdl-progress__indeterminate>.bar3{background-color:#2196f3;animation-name:indeterminate1;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar3{background-image:none;animation-name:indeterminate2}@keyframes indeterminate1{0%{left:0;width:0}50%{left:25%;width:75%}75%{left:100%;width:0}}@keyframes indeterminate2{0%,50%{left:0;width:0}75%{left:0;width:25%}to{left:100%;width:0}}.mdl-navigation{display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;box-sizing:border-box}.mdl-navigation__link{color:#424242;text-decoration:none;margin:0;font-size:14px;font-weight:400;line-height:24px;letter-spacing:0;opacity:.87}.mdl-navigation__link .material-icons{vertical-align:middle}.mdl-layout{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow-y:auto;overflow-x:hidden;position:relative;-webkit-overflow-scrolling:touch}.mdl-layout.is-small-screen .mdl-layout--large-screen-only,.mdl-layout:not(.is-small-screen) .mdl-layout--small-screen-only{display:none}.mdl-layout__container{position:absolute;width:100%;height:100%}.mdl-layout-title,.mdl-layout__title{display:block;position:relative;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:20px;line-height:1;letter-spacing:.02em;font-weight:400;box-sizing:border-box}.mdl-layout-spacer{-ms-flex-positive:1;flex-grow:1}.mdl-layout__drawer{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:240px;height:100%;max-height:100%;position:absolute;top:0;left:0;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);box-sizing:border-box;border-right:1px solid #e0e0e0;background:#fafafa;transform:translateX(-250px);transform-style:preserve-3d;will-change:transform;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:transform;color:#424242;overflow:visible;overflow-y:auto;z-index:5}.mdl-layout__drawer.is-visible{transform:translateX(0)}.mdl-layout__drawer.is-visible~.mdl-layout__content.mdl-layout__content{overflow:hidden}.mdl-layout__drawer>*{-ms-flex-negative:0;flex-shrink:0}.mdl-layout__drawer>.mdl-layout-title,.mdl-layout__drawer>.mdl-layout__title{line-height:64px;padding-left:40px}@media screen and (max-width:1024px){.mdl-layout__drawer>.mdl-layout-title,.mdl-layout__drawer>.mdl-layout__title{line-height:56px;padding-left:16px}}.mdl-layout__drawer .mdl-navigation{-ms-flex-direction:column;flex-direction:column;-webkit-align-items:stretch;-ms-flex-align:stretch;-ms-grid-row-align:stretch;align-items:stretch;padding-top:16px}.mdl-layout__drawer .mdl-navigation .mdl-navigation__link{display:block;-ms-flex-negative:0;flex-shrink:0;padding:16px 40px;margin:0;color:#757575}@media screen and (max-width:1024px){.mdl-layout__drawer .mdl-navigation .mdl-navigation__link{padding:16px}}.mdl-layout__drawer .mdl-navigation .mdl-navigation__link:hover{background-color:#e0e0e0}.mdl-layout__drawer .mdl-navigation .mdl-navigation__link--current{background-color:#000;color:#e0e0e0}@media screen and (min-width:1025px){.mdl-layout--fixed-drawer>.mdl-layout__drawer{transform:translateX(0)}}.mdl-layout__drawer-button{display:block;position:absolute;height:48px;width:48px;border:0;-ms-flex-negative:0;flex-shrink:0;overflow:hidden;text-align:center;cursor:pointer;font-size:26px;line-height:50px;font-family:Helvetica,Arial,sans-serif;margin:10px 12px;top:0;left:0;color:#fff;z-index:4}.mdl-layout__header .mdl-layout__drawer-button{position:absolute;color:#fff;background-color:inherit}@media screen and (max-width:1024px){.mdl-layout__header .mdl-layout__drawer-button{margin:4px}.mdl-layout__drawer-button{margin:4px;color:rgba(0,0,0,.5)}}@media screen and (min-width:1025px){.mdl-layout--fixed-drawer>.mdl-layout__drawer-button,.mdl-layout--no-desktop-drawer-button .mdl-layout__drawer-button{display:none}}.mdl-layout--no-drawer-button .mdl-layout__drawer-button{display:none}.mdl-layout__header{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-pack:start;justify-content:flex-start;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;width:100%;margin:0;padding:0;border:none;min-height:64px;max-height:1000px;z-index:3;background-color:#2196f3;color:#fff;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:max-height,box-shadow}@media screen and (max-width:1024px){.mdl-layout__header{min-height:56px}}.mdl-layout--fixed-drawer.is-upgraded:not(.is-small-screen)>.mdl-layout__header{margin-left:240px;width:calc(100% - 240px)}@media screen and (min-width:1025px){.mdl-layout--fixed-drawer>.mdl-layout__header .mdl-layout__header-row{padding-left:40px}}.mdl-layout__header>.mdl-layout-icon{position:absolute;left:40px;top:16px;height:32px;width:32px;overflow:hidden;z-index:3;display:block}@media screen and (max-width:1024px){.mdl-layout__header>.mdl-layout-icon{left:16px;top:12px}}.mdl-layout.has-drawer .mdl-layout__header>.mdl-layout-icon{display:none}.mdl-layout__header.is-compact{max-height:64px}@media screen and (max-width:1024px){.mdl-layout__header.is-compact{max-height:56px}}.mdl-layout__header.is-compact.has-tabs{height:112px}@media screen and (max-width:1024px){.mdl-layout__header.is-compact.has-tabs{min-height:104px}.mdl-layout__header{display:none}.mdl-layout--fixed-header>.mdl-layout__header{display:-ms-flexbox;display:flex}}.mdl-layout__header--transparent.mdl-layout__header--transparent{background-color:transparent;box-shadow:none}.mdl-layout__header--scroll,.mdl-layout__header--seamed{box-shadow:none}.mdl-layout__header--waterfall{box-shadow:none;overflow:hidden}.mdl-layout__header--waterfall.is-casting-shadow{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-layout__header--waterfall.mdl-layout__header--waterfall-hide-top{-ms-flex-pack:end;justify-content:flex-end}.mdl-layout__header-row{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-negative:0;flex-shrink:0;box-sizing:border-box;-ms-flex-item-align:stretch;align-self:stretch;-ms-flex-align:center;align-items:center;height:64px;margin:0;padding:0 40px 0 80px}.mdl-layout--no-drawer-button .mdl-layout__header-row{padding-left:40px}@media screen and (min-width:1025px){.mdl-layout--no-desktop-drawer-button .mdl-layout__header-row{padding-left:40px}}@media screen and (max-width:1024px){.mdl-layout__header-row{height:56px;padding:0 16px 0 72px}.mdl-layout--no-drawer-button .mdl-layout__header-row{padding-left:16px}}.mdl-layout__header-row>*{-ms-flex-negative:0;flex-shrink:0}.mdl-layout__header--scroll .mdl-layout__header-row{width:100%}.mdl-layout__header-row .mdl-navigation{margin:0;padding:0;height:64px;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}@media screen and (max-width:1024px){.mdl-layout__header-row .mdl-navigation{height:56px}}.mdl-layout__header-row .mdl-navigation__link{display:block;color:#fff;line-height:64px;padding:0 24px}@media screen and (max-width:1024px){.mdl-layout__header-row .mdl-navigation__link{line-height:56px;padding:0 16px}}.mdl-layout__obfuscator{background-color:transparent;position:absolute;top:0;left:0;height:100%;width:100%;z-index:4;visibility:hidden;transition-property:background-color;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-layout__obfuscator.is-visible{background-color:rgba(0,0,0,.5);visibility:visible}@supports (pointer-events:auto){.mdl-layout__obfuscator{background-color:rgba(0,0,0,.5);opacity:0;transition-property:opacity;visibility:visible;pointer-events:none}.mdl-layout__obfuscator.is-visible{pointer-events:auto;opacity:1}}.mdl-layout__content{-ms-flex:0 1 auto;position:relative;display:inline-block;overflow-y:auto;overflow-x:hidden;-ms-flex-positive:1;flex-grow:1;z-index:1;-webkit-overflow-scrolling:touch}.mdl-layout--fixed-drawer>.mdl-layout__content{margin-left:240px}.mdl-layout__container.has-scrolling-header .mdl-layout__content{overflow:visible}@media screen and (max-width:1024px){.mdl-layout--fixed-drawer>.mdl-layout__content{margin-left:0}.mdl-layout__container.has-scrolling-header .mdl-layout__content{overflow-y:auto;overflow-x:hidden}}.mdl-layout__tab-bar{height:96px;margin:0;width:calc(100% - 112px);padding:0 0 0 56px;display:-ms-flexbox;display:flex;background-color:#2196f3;overflow-y:hidden;overflow-x:scroll}.mdl-layout__tab-bar::-webkit-scrollbar{display:none}.mdl-layout--no-drawer-button .mdl-layout__tab-bar{padding-left:16px;width:calc(100% - 32px)}@media screen and (min-width:1025px){.mdl-layout--no-desktop-drawer-button .mdl-layout__tab-bar{padding-left:16px;width:calc(100% - 32px)}}@media screen and (max-width:1024px){.mdl-layout__tab-bar{width:calc(100% - 60px);padding:0 0 0 60px}.mdl-layout--no-drawer-button .mdl-layout__tab-bar{width:calc(100% - 8px);padding-left:4px}}.mdl-layout--fixed-tabs .mdl-layout__tab-bar{padding:0;overflow:hidden;width:100%}.mdl-layout__tab-bar-container{position:relative;height:48px;width:100%;border:none;margin:0;z-index:2;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;overflow:hidden}.mdl-layout__container>.mdl-layout__tab-bar-container{position:absolute;top:0;left:0}.mdl-layout__tab-bar-button{display:inline-block;position:absolute;top:0;height:48px;width:56px;z-index:4;text-align:center;background-color:#2196f3;color:transparent;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mdl-layout--no-desktop-drawer-button .mdl-layout__tab-bar-button,.mdl-layout--no-drawer-button .mdl-layout__tab-bar-button{width:16px}.mdl-layout--no-desktop-drawer-button .mdl-layout__tab-bar-button .material-icons,.mdl-layout--no-drawer-button .mdl-layout__tab-bar-button .material-icons{position:relative;left:-4px}@media screen and (max-width:1024px){.mdl-layout__tab-bar-button{display:none;width:60px}}.mdl-layout--fixed-tabs .mdl-layout__tab-bar-button{display:none}.mdl-layout__tab-bar-button .material-icons{line-height:48px}.mdl-layout__tab-bar-button.is-active{color:#fff}.mdl-layout__tab-bar-left-button{left:0}.mdl-layout__tab-bar-right-button{right:0}.mdl-layout__tab{margin:0;border:none;padding:0 24px;float:left;position:relative;display:block;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;text-decoration:none;height:48px;line-height:48px;text-align:center;font-weight:500;font-size:14px;text-transform:uppercase;color:hsla(0,0%,100%,.6);overflow:hidden}@media screen and (max-width:1024px){.mdl-layout__tab{padding:0 12px}}.mdl-layout--fixed-tabs .mdl-layout__tab{float:none;-ms-flex-positive:1;flex-grow:1;padding:0}.mdl-layout.is-upgraded .mdl-layout__tab.is-active{color:#fff}.mdl-layout.is-upgraded .mdl-layout__tab.is-active:after{height:2px;width:100%;display:block;content:\" \";bottom:0;left:0;position:absolute;background:#40c4ff;animation:border-expand .2s cubic-bezier(.4,0,.4,1).01s alternate forwards;transition:all 1s cubic-bezier(.4,0,1,1)}.mdl-layout__tab .mdl-layout__tab-ripple-container{display:block;position:absolute;height:100%;width:100%;left:0;top:0;z-index:1;overflow:hidden}.mdl-layout__tab .mdl-layout__tab-ripple-container .mdl-ripple{background-color:#fff}.mdl-layout.is-upgraded .mdl-layout__tab-panel.is-active,.mdl-layout__tab-panel{display:block}.mdl-layout.is-upgraded .mdl-layout__tab-panel{display:none}.mdl-radio{position:relative;font-size:16px;display:inline-block;box-sizing:border-box;margin:0;padding-left:0}.mdl-radio.is-upgraded{padding-left:24px}.mdl-radio,.mdl-radio__button{line-height:24px}.mdl-radio.is-upgraded .mdl-radio__button{position:absolute;width:0;height:0;margin:0;padding:0;opacity:0;-ms-appearance:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none}.mdl-radio__outer-circle{position:absolute;top:4px;left:0;display:inline-block;box-sizing:border-box;width:16px;height:16px;margin:0;cursor:pointer;border:2px solid rgba(0,0,0,.54);border-radius:50%;z-index:2}.mdl-radio.is-checked .mdl-radio__outer-circle{border:2px solid #2196f3}.mdl-radio.is-disabled .mdl-radio__outer-circle,.mdl-radio__outer-circle fieldset[disabled] .mdl-radio{border:2px solid rgba(0,0,0,.26);cursor:auto}.mdl-radio__inner-circle{position:absolute;z-index:1;margin:0;top:8px;left:4px;box-sizing:border-box;width:8px;height:8px;cursor:pointer;transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:transform;transform:scale3d(0,0,0);border-radius:50%;background:#2196f3}.mdl-radio.is-checked .mdl-radio__inner-circle{transform:scaleX(1)}.mdl-radio.is-disabled .mdl-radio__inner-circle,fieldset[disabled] .mdl-radio .mdl-radio__inner-circle{background:rgba(0,0,0,.26);cursor:auto}.mdl-radio.is-focused .mdl-radio__inner-circle{box-shadow:0 0 0 10px rgba(0,0,0,.1)}.mdl-radio__label{cursor:pointer}.mdl-radio.is-disabled .mdl-radio__label,fieldset[disabled] .mdl-radio .mdl-radio__label{color:rgba(0,0,0,.26);cursor:auto}.mdl-radio__ripple-container{position:absolute;z-index:2;top:-9px;left:-13px;box-sizing:border-box;width:42px;height:42px;border-radius:50%;cursor:pointer;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-radio__ripple-container .mdl-ripple{background:#2196f3}.mdl-radio.is-disabled .mdl-radio__ripple-container,fieldset[disabled] .mdl-radio .mdl-radio__ripple-container{cursor:auto}.mdl-radio.is-disabled .mdl-radio__ripple-container .mdl-ripple,fieldset[disabled] .mdl-radio .mdl-radio__ripple-container .mdl-ripple{background:0 0}:root .mdl-slider.mdl-slider.is-upgraded,_:-ms-input-placeholder{-ms-appearance:none;height:32px;margin:0}.mdl-slider{width:calc(100% - 40px);margin:0 20px}.mdl-slider.is-upgraded{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:2px;background:0 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0;padding:0;color:#2196f3;-ms-flex-item-align:center;align-self:center;z-index:1;cursor:pointer}.mdl-slider.is-upgraded::-moz-focus-outer{border:0}.mdl-slider.is-upgraded::-ms-tooltip{display:none}.mdl-slider.is-upgraded::-webkit-slider-runnable-track{background:0 0}.mdl-slider.is-upgraded::-moz-range-track{background:0 0;border:none}.mdl-slider.is-upgraded::-ms-track{background:0 0;color:transparent;height:2px;width:100%;border:none}.mdl-slider.is-upgraded::-ms-fill-lower{padding:0;background:linear-gradient(90deg,transparent,transparent 16px,#2196f3 16px,#2196f3 0)}.mdl-slider.is-upgraded::-ms-fill-upper{padding:0;background:linear-gradient(270deg,transparent,transparent 16px,rgba(0,0,0,.26) 16px,rgba(0,0,0,.26) 0)}.mdl-slider.is-upgraded::-webkit-slider-thumb{-webkit-appearance:none;width:12px;height:12px;box-sizing:border-box;border-radius:50%;background:#2196f3;border:none;transition:transform .18s cubic-bezier(.4,0,.2,1),border .18s cubic-bezier(.4,0,.2,1),box-shadow .18s cubic-bezier(.4,0,.2,1),background .28s cubic-bezier(.4,0,.2,1)}.mdl-slider.is-upgraded::-moz-range-thumb{-moz-appearance:none;width:12px;height:12px;box-sizing:border-box;border-radius:50%;background-image:none;background:#2196f3;border:none}.mdl-slider.is-upgraded:focus:not(:active)::-webkit-slider-thumb{box-shadow:0 0 0 10px rgba(33,150,243,.26)}.mdl-slider.is-upgraded:focus:not(:active)::-moz-range-thumb{box-shadow:0 0 0 10px rgba(33,150,243,.26)}.mdl-slider.is-upgraded:active::-webkit-slider-thumb{background-image:none;background:#2196f3;transform:scale(1.5)}.mdl-slider.is-upgraded:active::-moz-range-thumb{background-image:none;background:#2196f3;transform:scale(1.5)}.mdl-slider.is-upgraded::-ms-thumb{width:32px;height:32px;border:none;border-radius:50%;background:#2196f3;transform:scale(.375);transition:transform .18s cubic-bezier(.4,0,.2,1),background .28s cubic-bezier(.4,0,.2,1)}.mdl-slider.is-upgraded:focus:not(:active)::-ms-thumb{background:radial-gradient(circle closest-side,#2196f3 0,#2196f3 37.5%,rgba(33,150,243,.26) 37.5%,rgba(33,150,243,.26)100%);transform:scale(1)}.mdl-slider.is-upgraded:active::-ms-thumb{background:#2196f3;transform:scale(.5625)}.mdl-slider.is-upgraded.is-lowest-value::-webkit-slider-thumb{border:2px solid rgba(0,0,0,.26);background:0 0}.mdl-slider.is-upgraded.is-lowest-value::-moz-range-thumb{border:2px solid rgba(0,0,0,.26);background:0 0}.mdl-slider.is-upgraded.is-lowest-value+.mdl-slider__background-flex>.mdl-slider__background-upper{left:6px}.mdl-slider.is-upgraded.is-lowest-value:focus:not(:active)::-webkit-slider-thumb{box-shadow:0 0 0 10px rgba(0,0,0,.12);background:rgba(0,0,0,.12)}.mdl-slider.is-upgraded.is-lowest-value:focus:not(:active)::-moz-range-thumb{box-shadow:0 0 0 10px rgba(0,0,0,.12);background:rgba(0,0,0,.12)}.mdl-slider.is-upgraded.is-lowest-value:active::-webkit-slider-thumb{border:1.6px solid rgba(0,0,0,.26);transform:scale(1.5)}.mdl-slider.is-upgraded.is-lowest-value:active+.mdl-slider__background-flex>.mdl-slider__background-upper{left:9px}.mdl-slider.is-upgraded.is-lowest-value:active::-moz-range-thumb{border:1.5px solid rgba(0,0,0,.26);transform:scale(1.5)}.mdl-slider.is-upgraded.is-lowest-value::-ms-thumb{background:radial-gradient(circle closest-side,transparent 0,transparent 66.67%,rgba(0,0,0,.26) 66.67%,rgba(0,0,0,.26) 100%)}.mdl-slider.is-upgraded.is-lowest-value:focus:not(:active)::-ms-thumb{background:radial-gradient(circle closest-side,rgba(0,0,0,.12) 0,rgba(0,0,0,.12) 25%,rgba(0,0,0,.26) 25%,rgba(0,0,0,.26) 37.5%,rgba(0,0,0,.12) 37.5%,rgba(0,0,0,.12)100%);transform:scale(1)}.mdl-slider.is-upgraded.is-lowest-value:active::-ms-thumb{transform:scale(.5625);background:radial-gradient(circle closest-side,transparent 0,transparent 77.78%,rgba(0,0,0,.26) 77.78%,rgba(0,0,0,.26) 100%)}.mdl-slider.is-upgraded.is-lowest-value::-ms-fill-lower{background:0 0}.mdl-slider.is-upgraded.is-lowest-value::-ms-fill-upper{margin-left:6px}.mdl-slider.is-upgraded.is-lowest-value:active::-ms-fill-upper{margin-left:9px}.mdl-slider.is-upgraded:disabled::-webkit-slider-thumb,.mdl-slider.is-upgraded:disabled:active::-webkit-slider-thumb,.mdl-slider.is-upgraded:disabled:focus::-webkit-slider-thumb{transform:scale(.667);background:rgba(0,0,0,.26)}.mdl-slider.is-upgraded:disabled::-moz-range-thumb,.mdl-slider.is-upgraded:disabled:active::-moz-range-thumb,.mdl-slider.is-upgraded:disabled:focus::-moz-range-thumb{transform:scale(.667);background:rgba(0,0,0,.26)}.mdl-slider.is-upgraded:disabled+.mdl-slider__background-flex>.mdl-slider__background-lower{background-color:rgba(0,0,0,.26);left:-6px}.mdl-slider.is-upgraded:disabled+.mdl-slider__background-flex>.mdl-slider__background-upper{left:6px}.mdl-slider.is-upgraded.is-lowest-value:disabled::-webkit-slider-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:active::-webkit-slider-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:focus::-webkit-slider-thumb{border:3px solid rgba(0,0,0,.26);background:0 0;transform:scale(.667)}.mdl-slider.is-upgraded.is-lowest-value:disabled::-moz-range-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:active::-moz-range-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:focus::-moz-range-thumb{border:3px solid rgba(0,0,0,.26);background:0 0;transform:scale(.667)}.mdl-slider.is-upgraded.is-lowest-value:disabled:active+.mdl-slider__background-flex>.mdl-slider__background-upper{left:6px}.mdl-slider.is-upgraded:disabled::-ms-thumb,.mdl-slider.is-upgraded:disabled:active::-ms-thumb,.mdl-slider.is-upgraded:disabled:focus::-ms-thumb{transform:scale(.25);background:rgba(0,0,0,.26)}.mdl-slider.is-upgraded.is-lowest-value:disabled::-ms-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:active::-ms-thumb,.mdl-slider.is-upgraded.is-lowest-value:disabled:focus::-ms-thumb{transform:scale(.25);background:radial-gradient(circle closest-side,transparent 0,transparent 50%,rgba(0,0,0,.26) 50%,rgba(0,0,0,.26) 100%)}.mdl-slider.is-upgraded:disabled::-ms-fill-lower{margin-right:6px;background:linear-gradient(90deg,transparent,transparent 25px,rgba(0,0,0,.26) 25px,rgba(0,0,0,.26) 0)}.mdl-slider.is-upgraded.is-lowest-value:disabled:active::-ms-fill-upper,.mdl-slider.is-upgraded:disabled::-ms-fill-upper{margin-left:6px}.mdl-slider__ie-container{height:18px;overflow:visible;border:none;margin:none;padding:none}.mdl-slider__background-flex,.mdl-slider__container{background:0 0;display:-ms-flexbox;display:flex}.mdl-slider__container{-ms-flex-direction:row;flex-direction:row;height:18px;position:relative}.mdl-slider__background-flex{position:absolute;height:2px;width:calc(100% - 52px);top:50%;left:0;margin:0 26px;overflow:hidden;border:0;padding:0;transform:translateY(-1px)}.mdl-slider__background-lower,.mdl-slider__background-upper{-ms-flex:0;flex:0;position:relative;border:0;padding:0}.mdl-slider__background-lower{background:#2196f3}.mdl-slider__background-upper{background:rgba(0,0,0,.26);transition:left .18s cubic-bezier(.4,0,.2,1)}.mdl-snackbar{position:fixed;bottom:0;left:50%;margin-right:-50%;cursor:default;background-color:#323232;z-index:10000;display:-ms-flexbox;display:flex;font-family:Roboto,Helvetica,Arial,sans-serif;will-change:transform;transform:translateY(80px);transition:transform .25s cubic-bezier(.4,0,1,1);pointer-events:none}@media (max-width:479px){.mdl-snackbar{width:100%;left:0;min-height:48px;max-height:80px}}@media (min-width:480px){.mdl-snackbar{min-width:288px;max-width:568px;border-radius:2px}}.mdl-snackbar--active{transform:translate(0);pointer-events:auto;transition:transform .25s cubic-bezier(0,0,.2,1)}.mdl-snackbar__text{padding:14px 24px;vertical-align:middle;color:#fff}.mdl-snackbar__action{background:0 0;border:none;color:#40c4ff;padding:14px 24px;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase;line-height:1;letter-spacing:0;overflow:hidden;outline:none;opacity:0;pointer-events:none;cursor:pointer;text-decoration:none;text-align:center;vertical-align:middle}.mdl-snackbar__action::-moz-focus-inner{border:0}.mdl-snackbar__action:not([aria-hidden]){opacity:1;pointer-events:auto}.mdl-spinner{display:inline-block;position:relative;width:28px;height:28px}.mdl-spinner:not(.is-upgraded).is-active:after{content:\"Loading...\"}.mdl-spinner.is-upgraded.is-active{animation:mdl-spinner__container-rotate 1.56823529412s linear infinite}@keyframes mdl-spinner__container-rotate{to{transform:rotate(1turn)}}.mdl-spinner__layer{position:absolute;width:100%;height:100%;opacity:0}.mdl-spinner__layer-1{border-color:#42a5f5}.mdl-spinner--single-color .mdl-spinner__layer-1,.mdl-spinner--single-color .mdl-spinner__layer-2,.mdl-spinner--single-color .mdl-spinner__layer-3,.mdl-spinner--single-color .mdl-spinner__layer-4{border-color:#2196f3}.mdl-spinner.is-active .mdl-spinner__layer-1{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both}.mdl-spinner__layer-2{border-color:#f44336}.mdl-spinner.is-active .mdl-spinner__layer-2{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both}.mdl-spinner__layer-3{border-color:#fdd835}.mdl-spinner.is-active .mdl-spinner__layer-3{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both}.mdl-spinner__layer-4{border-color:#4caf50}.mdl-spinner.is-active .mdl-spinner__layer-4{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1)infinite both,mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4,0,.2,1)infinite both}@keyframes mdl-spinner__fill-unfill-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(3turn)}}@keyframes mdl-spinner__layer-1-fade-in-out{0%,25%,90%,to{opacity:.99}26%,89%{opacity:0}}@keyframes mdl-spinner__layer-2-fade-in-out{0%,15%,51%{opacity:0}25%,50%{opacity:.99}}@keyframes mdl-spinner__layer-3-fade-in-out{0%,40%,76%{opacity:0}50%,75%{opacity:.99}}@keyframes mdl-spinner__layer-4-fade-in-out{0%,65%,to{opacity:0}75%,90%{opacity:.99}}.mdl-spinner__gap-patch{position:absolute;box-sizing:border-box;top:0;left:45%;width:10%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__gap-patch .mdl-spinner__circle{width:1000%;left:-450%}.mdl-spinner__circle-clipper{display:inline-block;position:relative;width:50%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__circle-clipper .mdl-spinner__circle{width:200%}.mdl-spinner__circle{box-sizing:border-box;height:100%;border-width:3px;border-style:solid;border-color:inherit;border-bottom-color:transparent!important;border-radius:50%;animation:none;position:absolute;top:0;right:0;bottom:0;left:0}.mdl-spinner__left .mdl-spinner__circle{border-right-color:transparent!important;transform:rotate(129deg)}.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle{animation:mdl-spinner__left-spin 1333ms cubic-bezier(.4,0,.2,1)infinite both}.mdl-spinner__right .mdl-spinner__circle{left:-100%;border-left-color:transparent!important;transform:rotate(-129deg)}.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle{animation:mdl-spinner__right-spin 1333ms cubic-bezier(.4,0,.2,1)infinite both}@keyframes mdl-spinner__left-spin{0%,to{transform:rotate(130deg)}50%{transform:rotate(-5deg)}}@keyframes mdl-spinner__right-spin{0%,to{transform:rotate(-130deg)}50%{transform:rotate(5deg)}}.mdl-switch{position:relative;z-index:1;vertical-align:middle;display:inline-block;box-sizing:border-box;width:100%;height:24px;margin:0;padding:0;overflow:visible;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mdl-switch.is-upgraded{padding-left:28px}.mdl-switch__input{line-height:24px}.mdl-switch.is-upgraded .mdl-switch__input{position:absolute;width:0;height:0;margin:0;padding:0;opacity:0;-ms-appearance:none;-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none}.mdl-switch__track{background:rgba(0,0,0,.26);position:absolute;left:0;top:5px;height:14px;width:36px;border-radius:14px;cursor:pointer}.mdl-switch.is-checked .mdl-switch__track{background:rgba(33,150,243,.5)}.mdl-switch.is-disabled .mdl-switch__track,.mdl-switch__track fieldset[disabled] .mdl-switch{background:rgba(0,0,0,.12);cursor:auto}.mdl-switch__thumb{background:#fafafa;position:absolute;left:0;top:2px;height:20px;width:20px;border-radius:50%;cursor:pointer;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);transition-duration:.28s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:left}.mdl-switch.is-checked .mdl-switch__thumb{background:#2196f3;left:16px;box-shadow:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12)}.mdl-switch.is-disabled .mdl-switch__thumb,.mdl-switch__thumb fieldset[disabled] .mdl-switch{background:#bdbdbd;cursor:auto}.mdl-switch__focus-helper{position:absolute;top:50%;left:50%;transform:translate(-4px,-4px);display:inline-block;box-sizing:border-box;width:8px;height:8px;border-radius:50%;background-color:transparent}.mdl-switch.is-focused .mdl-switch__focus-helper{box-shadow:0 0 0 20px rgba(0,0,0,.1);background-color:rgba(0,0,0,.1)}.mdl-switch.is-focused.is-checked .mdl-switch__focus-helper{box-shadow:0 0 0 20px rgba(33,150,243,.26);background-color:rgba(33,150,243,.26)}.mdl-switch__label{position:relative;cursor:pointer;font-size:16px;line-height:24px;margin:0;left:24px}.mdl-switch.is-disabled .mdl-switch__label,.mdl-switch__label fieldset[disabled] .mdl-switch{color:#bdbdbd;cursor:auto}.mdl-switch__ripple-container{position:absolute;z-index:2;top:-12px;left:-14px;box-sizing:border-box;width:48px;height:48px;border-radius:50%;cursor:pointer;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000);transition-duration:.4s;transition-timing-function:step-end;transition-property:left}.mdl-switch__ripple-container .mdl-ripple{background:#2196f3}.mdl-switch.is-disabled .mdl-switch__ripple-container,.mdl-switch__ripple-container fieldset[disabled] .mdl-switch{cursor:auto}.mdl-switch.is-disabled .mdl-switch__ripple-container .mdl-ripple,fieldset[disabled] .mdl-switch .mdl-switch__ripple-container .mdl-ripple{background:0 0}.mdl-switch.is-checked .mdl-switch__ripple-container{left:2px}.mdl-tabs{display:block;width:100%}.mdl-tabs__tab-bar{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-ms-flex-align:start;align-items:flex-start;height:48px;padding:0;margin:0;border-bottom:1px solid #e0e0e0}.mdl-tabs__tab{margin:0;border:none;padding:0 24px;float:left;position:relative;display:block;text-decoration:none;height:48px;line-height:48px;text-align:center;font-weight:500;font-size:14px;text-transform:uppercase;color:rgba(0,0,0,.54);overflow:hidden}.mdl-tabs.is-upgraded .mdl-tabs__tab.is-active{color:rgba(0,0,0,.87)}.mdl-tabs.is-upgraded .mdl-tabs__tab.is-active:after{height:2px;width:100%;display:block;content:\" \";bottom:0;left:0;position:absolute;background:#2196f3;animation:border-expand .2s cubic-bezier(.4,0,.4,1).01s alternate forwards;transition:all 1s cubic-bezier(.4,0,1,1)}.mdl-tabs__tab .mdl-tabs__ripple-container{display:block;position:absolute;height:100%;width:100%;left:0;top:0;z-index:1;overflow:hidden}.mdl-tabs__tab .mdl-tabs__ripple-container .mdl-ripple{background:#2196f3}.mdl-tabs.is-upgraded .mdl-tabs__panel.is-active,.mdl-tabs__panel{display:block}.mdl-tabs.is-upgraded .mdl-tabs__panel{display:none}@keyframes border-expand{0%{opacity:0;width:0}to{opacity:1;width:100%}}.mdl-textfield{position:relative;font-size:16px;display:inline-block;box-sizing:border-box;width:300px;max-width:100%;margin:0;padding:20px 0}.mdl-textfield .mdl-button{position:absolute;bottom:20px}.mdl-textfield--align-right{text-align:right}.mdl-textfield--full-width{width:100%}.mdl-textfield--expandable{min-width:32px;width:auto;min-height:32px}.mdl-textfield__input{border:none;border-bottom:1px solid rgba(0,0,0,.12);display:block;font-size:16px;font-family:Helvetica,Arial,sans-serif;margin:0;padding:4px 0;width:100%;background:0 0;text-align:left;color:inherit}.mdl-textfield__input[type=number]{-moz-appearance:textfield}.mdl-textfield__input[type=number]::-webkit-inner-spin-button,.mdl-textfield__input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mdl-textfield.is-focused .mdl-textfield__input{outline:none}.mdl-textfield.is-invalid .mdl-textfield__input{border-color:#d50000;box-shadow:none}.mdl-textfield.is-disabled .mdl-textfield__input,fieldset[disabled] .mdl-textfield .mdl-textfield__input{background-color:transparent;border-bottom:1px dotted rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-textfield textarea.mdl-textfield__input{display:block}.mdl-textfield__label{bottom:0;font-size:16px;left:0;right:0;pointer-events:none;position:absolute;display:block;top:24px;width:100%;overflow:hidden;white-space:nowrap;text-align:left}.mdl-textfield.is-dirty .mdl-textfield__label{visibility:hidden}.mdl-textfield--floating-label .mdl-textfield__label{transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,.mdl-textfield__label,fieldset[disabled] .mdl-textfield .mdl-textfield__label{color:rgba(0,0,0,.26)}.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#2196f3;font-size:12px;top:4px;visibility:visible}.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label{top:-16px}.mdl-textfield--floating-label.is-invalid .mdl-textfield__label{color:#d50000;font-size:12px}.mdl-textfield__label:after{background-color:#2196f3;bottom:20px;content:\"\";height:2px;left:45%;position:absolute;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);visibility:hidden;width:10px}.mdl-textfield.is-focused .mdl-textfield__label:after{left:0;visibility:visible;width:100%}.mdl-textfield.is-invalid .mdl-textfield__label:after{background-color:#d50000}.mdl-textfield__error{color:#d50000;position:absolute;font-size:12px;margin-top:3px;visibility:hidden;display:block}.mdl-textfield.is-invalid .mdl-textfield__error{visibility:visible}.mdl-textfield__expandable-holder{position:relative;margin-left:32px;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);display:inline-block;max-width:.1px}.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,.mdl-textfield.is-focused .mdl-textfield__expandable-holder{max-width:600px}.mdl-textfield__expandable-holder .mdl-textfield__label:after{bottom:0}.mdl-tooltip{transform:scale(0);transform-origin:top center;will-change:transform;z-index:999;background:rgba(97,97,97,.9);border-radius:2px;color:#fff;display:inline-block;font-size:10px;font-weight:500;line-height:14px;max-width:170px;position:fixed;top:-500px;left:-500px;padding:8px;text-align:center}.mdl-tooltip.is-active{animation:pulse .2s cubic-bezier(0,0,.2,1)forwards}.mdl-tooltip--large{line-height:14px;font-size:14px;padding:16px}@keyframes pulse{0%{transform:scale(0);opacity:0}50%{transform:scale(.99)}to{transform:scale(1);opacity:1;visibility:visible}}.mdl-shadow--2dp{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-shadow--3dp{box-shadow:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12)}.mdl-shadow--4dp{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2)}.mdl-shadow--6dp{box-shadow:0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12),0 3px 5px -1px rgba(0,0,0,.2)}.mdl-shadow--8dp{box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.mdl-shadow--16dp{box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.mdl-shadow--24dp{box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2)}.mdl-grid{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin:0 auto;-ms-flex-align:stretch;align-items:stretch}.mdl-grid.mdl-grid--no-spacing{padding:0}.mdl-cell{box-sizing:border-box}.mdl-cell--top{-ms-flex-item-align:start;align-self:flex-start}.mdl-cell--middle{-ms-flex-item-align:center;align-self:center}.mdl-cell--bottom{-ms-flex-item-align:end;align-self:flex-end}.mdl-cell--stretch{-ms-flex-item-align:stretch;align-self:stretch}.mdl-grid.mdl-grid--no-spacing>.mdl-cell{margin:0}.mdl-cell--order-1{-ms-flex-order:1;order:1}.mdl-cell--order-2{-ms-flex-order:2;order:2}.mdl-cell--order-3{-ms-flex-order:3;order:3}.mdl-cell--order-4{-ms-flex-order:4;order:4}.mdl-cell--order-5{-ms-flex-order:5;order:5}.mdl-cell--order-6{-ms-flex-order:6;order:6}.mdl-cell--order-7{-ms-flex-order:7;order:7}.mdl-cell--order-8{-ms-flex-order:8;order:8}.mdl-cell--order-9{-ms-flex-order:9;order:9}.mdl-cell--order-10{-ms-flex-order:10;order:10}.mdl-cell--order-11{-ms-flex-order:11;order:11}.mdl-cell--order-12{-ms-flex-order:12;order:12}@media (max-width:479px){.mdl-grid{padding:8px}.mdl-cell{margin:8px;width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell{width:100%}.mdl-cell--hide-phone{display:none!important}.mdl-cell--order-1-phone.mdl-cell--order-1-phone{-ms-flex-order:1;order:1}.mdl-cell--order-2-phone.mdl-cell--order-2-phone{-ms-flex-order:2;order:2}.mdl-cell--order-3-phone.mdl-cell--order-3-phone{-ms-flex-order:3;order:3}.mdl-cell--order-4-phone.mdl-cell--order-4-phone{-ms-flex-order:4;order:4}.mdl-cell--order-5-phone.mdl-cell--order-5-phone{-ms-flex-order:5;order:5}.mdl-cell--order-6-phone.mdl-cell--order-6-phone{-ms-flex-order:6;order:6}.mdl-cell--order-7-phone.mdl-cell--order-7-phone{-ms-flex-order:7;order:7}.mdl-cell--order-8-phone.mdl-cell--order-8-phone{-ms-flex-order:8;order:8}.mdl-cell--order-9-phone.mdl-cell--order-9-phone{-ms-flex-order:9;order:9}.mdl-cell--order-10-phone.mdl-cell--order-10-phone{-ms-flex-order:10;order:10}.mdl-cell--order-11-phone.mdl-cell--order-11-phone{-ms-flex-order:11;order:11}.mdl-cell--order-12-phone.mdl-cell--order-12-phone{-ms-flex-order:12;order:12}.mdl-cell--1-col,.mdl-cell--1-col-phone.mdl-cell--1-col-phone{width:calc(25% - 16px)}.mdl-grid--no-spacing>.mdl-cell--1-col,.mdl-grid--no-spacing>.mdl-cell--1-col-phone.mdl-cell--1-col-phone{width:25%}.mdl-cell--2-col,.mdl-cell--2-col-phone.mdl-cell--2-col-phone{width:calc(50% - 16px)}.mdl-grid--no-spacing>.mdl-cell--2-col,.mdl-grid--no-spacing>.mdl-cell--2-col-phone.mdl-cell--2-col-phone{width:50%}.mdl-cell--3-col,.mdl-cell--3-col-phone.mdl-cell--3-col-phone{width:calc(75% - 16px)}.mdl-grid--no-spacing>.mdl-cell--3-col,.mdl-grid--no-spacing>.mdl-cell--3-col-phone.mdl-cell--3-col-phone{width:75%}.mdl-cell--4-col,.mdl-cell--4-col-phone.mdl-cell--4-col-phone,.mdl-cell--5-col{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--4-col,.mdl-grid--no-spacing>.mdl-cell--4-col-phone.mdl-cell--4-col-phone{width:100%}.mdl-cell--5-col-phone.mdl-cell--5-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--5-col,.mdl-grid--no-spacing>.mdl-cell--5-col-phone.mdl-cell--5-col-phone{width:100%}.mdl-cell--6-col,.mdl-cell--6-col-phone.mdl-cell--6-col-phone,.mdl-cell--7-col{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--6-col,.mdl-grid--no-spacing>.mdl-cell--6-col-phone.mdl-cell--6-col-phone{width:100%}.mdl-cell--7-col-phone.mdl-cell--7-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--7-col,.mdl-grid--no-spacing>.mdl-cell--7-col-phone.mdl-cell--7-col-phone{width:100%}.mdl-cell--8-col,.mdl-cell--8-col-phone.mdl-cell--8-col-phone,.mdl-cell--9-col{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--8-col,.mdl-grid--no-spacing>.mdl-cell--8-col-phone.mdl-cell--8-col-phone{width:100%}.mdl-cell--9-col-phone.mdl-cell--9-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--9-col,.mdl-grid--no-spacing>.mdl-cell--9-col-phone.mdl-cell--9-col-phone{width:100%}.mdl-cell--10-col,.mdl-cell--10-col-phone.mdl-cell--10-col-phone,.mdl-cell--11-col{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--10-col,.mdl-grid--no-spacing>.mdl-cell--10-col-phone.mdl-cell--10-col-phone{width:100%}.mdl-cell--11-col-phone.mdl-cell--11-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--11-col,.mdl-grid--no-spacing>.mdl-cell--11-col-phone.mdl-cell--11-col-phone{width:100%}.mdl-cell--12-col,.mdl-cell--12-col-phone.mdl-cell--12-col-phone{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--12-col,.mdl-grid--no-spacing>.mdl-cell--12-col-phone.mdl-cell--12-col-phone{width:100%}.mdl-cell--1-offset,.mdl-cell--1-offset-phone.mdl-cell--1-offset-phone{margin-left:calc(25% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset-phone.mdl-cell--1-offset-phone{margin-left:25%}.mdl-cell--2-offset,.mdl-cell--2-offset-phone.mdl-cell--2-offset-phone{margin-left:calc(50% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset-phone.mdl-cell--2-offset-phone{margin-left:50%}.mdl-cell--3-offset,.mdl-cell--3-offset-phone.mdl-cell--3-offset-phone{margin-left:calc(75% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset-phone.mdl-cell--3-offset-phone{margin-left:75%}}@media (min-width:480px) and (max-width:839px){.mdl-grid{padding:8px}.mdl-cell{margin:8px;width:calc(50% - 16px)}.mdl-grid--no-spacing>.mdl-cell{width:50%}.mdl-cell--hide-tablet{display:none!important}.mdl-cell--order-1-tablet.mdl-cell--order-1-tablet{-ms-flex-order:1;order:1}.mdl-cell--order-2-tablet.mdl-cell--order-2-tablet{-ms-flex-order:2;order:2}.mdl-cell--order-3-tablet.mdl-cell--order-3-tablet{-ms-flex-order:3;order:3}.mdl-cell--order-4-tablet.mdl-cell--order-4-tablet{-ms-flex-order:4;order:4}.mdl-cell--order-5-tablet.mdl-cell--order-5-tablet{-ms-flex-order:5;order:5}.mdl-cell--order-6-tablet.mdl-cell--order-6-tablet{-ms-flex-order:6;order:6}.mdl-cell--order-7-tablet.mdl-cell--order-7-tablet{-ms-flex-order:7;order:7}.mdl-cell--order-8-tablet.mdl-cell--order-8-tablet{-ms-flex-order:8;order:8}.mdl-cell--order-9-tablet.mdl-cell--order-9-tablet{-ms-flex-order:9;order:9}.mdl-cell--order-10-tablet.mdl-cell--order-10-tablet{-ms-flex-order:10;order:10}.mdl-cell--order-11-tablet.mdl-cell--order-11-tablet{-ms-flex-order:11;order:11}.mdl-cell--order-12-tablet.mdl-cell--order-12-tablet{-ms-flex-order:12;order:12}.mdl-cell--1-col,.mdl-cell--1-col-tablet.mdl-cell--1-col-tablet{width:calc(12.5% - 16px)}.mdl-grid--no-spacing>.mdl-cell--1-col,.mdl-grid--no-spacing>.mdl-cell--1-col-tablet.mdl-cell--1-col-tablet{width:12.5%}.mdl-cell--2-col,.mdl-cell--2-col-tablet.mdl-cell--2-col-tablet{width:calc(25% - 16px)}.mdl-grid--no-spacing>.mdl-cell--2-col,.mdl-grid--no-spacing>.mdl-cell--2-col-tablet.mdl-cell--2-col-tablet{width:25%}.mdl-cell--3-col,.mdl-cell--3-col-tablet.mdl-cell--3-col-tablet{width:calc(37.5% - 16px)}.mdl-grid--no-spacing>.mdl-cell--3-col,.mdl-grid--no-spacing>.mdl-cell--3-col-tablet.mdl-cell--3-col-tablet{width:37.5%}.mdl-cell--4-col,.mdl-cell--4-col-tablet.mdl-cell--4-col-tablet{width:calc(50% - 16px)}.mdl-grid--no-spacing>.mdl-cell--4-col,.mdl-grid--no-spacing>.mdl-cell--4-col-tablet.mdl-cell--4-col-tablet{width:50%}.mdl-cell--5-col,.mdl-cell--5-col-tablet.mdl-cell--5-col-tablet{width:calc(62.5% - 16px)}.mdl-grid--no-spacing>.mdl-cell--5-col,.mdl-grid--no-spacing>.mdl-cell--5-col-tablet.mdl-cell--5-col-tablet{width:62.5%}.mdl-cell--6-col,.mdl-cell--6-col-tablet.mdl-cell--6-col-tablet{width:calc(75% - 16px)}.mdl-grid--no-spacing>.mdl-cell--6-col,.mdl-grid--no-spacing>.mdl-cell--6-col-tablet.mdl-cell--6-col-tablet{width:75%}.mdl-cell--7-col,.mdl-cell--7-col-tablet.mdl-cell--7-col-tablet{width:calc(87.5% - 16px)}.mdl-grid--no-spacing>.mdl-cell--7-col,.mdl-grid--no-spacing>.mdl-cell--7-col-tablet.mdl-cell--7-col-tablet{width:87.5%}.mdl-cell--8-col,.mdl-cell--8-col-tablet.mdl-cell--8-col-tablet,.mdl-cell--9-col{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--8-col,.mdl-grid--no-spacing>.mdl-cell--8-col-tablet.mdl-cell--8-col-tablet{width:100%}.mdl-cell--9-col-tablet.mdl-cell--9-col-tablet{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--9-col,.mdl-grid--no-spacing>.mdl-cell--9-col-tablet.mdl-cell--9-col-tablet{width:100%}.mdl-cell--10-col,.mdl-cell--10-col-tablet.mdl-cell--10-col-tablet,.mdl-cell--11-col{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--10-col,.mdl-grid--no-spacing>.mdl-cell--10-col-tablet.mdl-cell--10-col-tablet{width:100%}.mdl-cell--11-col-tablet.mdl-cell--11-col-tablet{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--11-col,.mdl-grid--no-spacing>.mdl-cell--11-col-tablet.mdl-cell--11-col-tablet{width:100%}.mdl-cell--12-col,.mdl-cell--12-col-tablet.mdl-cell--12-col-tablet{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--12-col,.mdl-grid--no-spacing>.mdl-cell--12-col-tablet.mdl-cell--12-col-tablet{width:100%}.mdl-cell--1-offset,.mdl-cell--1-offset-tablet.mdl-cell--1-offset-tablet{margin-left:calc(12.5% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset-tablet.mdl-cell--1-offset-tablet{margin-left:12.5%}.mdl-cell--2-offset,.mdl-cell--2-offset-tablet.mdl-cell--2-offset-tablet{margin-left:calc(25% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset-tablet.mdl-cell--2-offset-tablet{margin-left:25%}.mdl-cell--3-offset,.mdl-cell--3-offset-tablet.mdl-cell--3-offset-tablet{margin-left:calc(37.5% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset-tablet.mdl-cell--3-offset-tablet{margin-left:37.5%}.mdl-cell--4-offset,.mdl-cell--4-offset-tablet.mdl-cell--4-offset-tablet{margin-left:calc(50% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--4-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--4-offset-tablet.mdl-cell--4-offset-tablet{margin-left:50%}.mdl-cell--5-offset,.mdl-cell--5-offset-tablet.mdl-cell--5-offset-tablet{margin-left:calc(62.5% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--5-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--5-offset-tablet.mdl-cell--5-offset-tablet{margin-left:62.5%}.mdl-cell--6-offset,.mdl-cell--6-offset-tablet.mdl-cell--6-offset-tablet{margin-left:calc(75% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--6-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--6-offset-tablet.mdl-cell--6-offset-tablet{margin-left:75%}.mdl-cell--7-offset,.mdl-cell--7-offset-tablet.mdl-cell--7-offset-tablet{margin-left:calc(87.5% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--7-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--7-offset-tablet.mdl-cell--7-offset-tablet{margin-left:87.5%}}@media (min-width:840px){.mdl-grid{padding:8px}.mdl-cell{margin:8px;width:calc(33.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell{width:33.3333333333%}.mdl-cell--hide-desktop{display:none!important}.mdl-cell--order-1-desktop.mdl-cell--order-1-desktop{-ms-flex-order:1;order:1}.mdl-cell--order-2-desktop.mdl-cell--order-2-desktop{-ms-flex-order:2;order:2}.mdl-cell--order-3-desktop.mdl-cell--order-3-desktop{-ms-flex-order:3;order:3}.mdl-cell--order-4-desktop.mdl-cell--order-4-desktop{-ms-flex-order:4;order:4}.mdl-cell--order-5-desktop.mdl-cell--order-5-desktop{-ms-flex-order:5;order:5}.mdl-cell--order-6-desktop.mdl-cell--order-6-desktop{-ms-flex-order:6;order:6}.mdl-cell--order-7-desktop.mdl-cell--order-7-desktop{-ms-flex-order:7;order:7}.mdl-cell--order-8-desktop.mdl-cell--order-8-desktop{-ms-flex-order:8;order:8}.mdl-cell--order-9-desktop.mdl-cell--order-9-desktop{-ms-flex-order:9;order:9}.mdl-cell--order-10-desktop.mdl-cell--order-10-desktop{-ms-flex-order:10;order:10}.mdl-cell--order-11-desktop.mdl-cell--order-11-desktop{-ms-flex-order:11;order:11}.mdl-cell--order-12-desktop.mdl-cell--order-12-desktop{-ms-flex-order:12;order:12}.mdl-cell--1-col,.mdl-cell--1-col-desktop.mdl-cell--1-col-desktop{width:calc(8.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell--1-col,.mdl-grid--no-spacing>.mdl-cell--1-col-desktop.mdl-cell--1-col-desktop{width:8.3333333333%}.mdl-cell--2-col,.mdl-cell--2-col-desktop.mdl-cell--2-col-desktop{width:calc(16.6666666667% - 16px)}.mdl-grid--no-spacing>.mdl-cell--2-col,.mdl-grid--no-spacing>.mdl-cell--2-col-desktop.mdl-cell--2-col-desktop{width:16.6666666667%}.mdl-cell--3-col,.mdl-cell--3-col-desktop.mdl-cell--3-col-desktop{width:calc(25% - 16px)}.mdl-grid--no-spacing>.mdl-cell--3-col,.mdl-grid--no-spacing>.mdl-cell--3-col-desktop.mdl-cell--3-col-desktop{width:25%}.mdl-cell--4-col,.mdl-cell--4-col-desktop.mdl-cell--4-col-desktop{width:calc(33.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell--4-col,.mdl-grid--no-spacing>.mdl-cell--4-col-desktop.mdl-cell--4-col-desktop{width:33.3333333333%}.mdl-cell--5-col,.mdl-cell--5-col-desktop.mdl-cell--5-col-desktop{width:calc(41.6666666667% - 16px)}.mdl-grid--no-spacing>.mdl-cell--5-col,.mdl-grid--no-spacing>.mdl-cell--5-col-desktop.mdl-cell--5-col-desktop{width:41.6666666667%}.mdl-cell--6-col,.mdl-cell--6-col-desktop.mdl-cell--6-col-desktop{width:calc(50% - 16px)}.mdl-grid--no-spacing>.mdl-cell--6-col,.mdl-grid--no-spacing>.mdl-cell--6-col-desktop.mdl-cell--6-col-desktop{width:50%}.mdl-cell--7-col,.mdl-cell--7-col-desktop.mdl-cell--7-col-desktop{width:calc(58.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell--7-col,.mdl-grid--no-spacing>.mdl-cell--7-col-desktop.mdl-cell--7-col-desktop{width:58.3333333333%}.mdl-cell--8-col,.mdl-cell--8-col-desktop.mdl-cell--8-col-desktop{width:calc(66.6666666667% - 16px)}.mdl-grid--no-spacing>.mdl-cell--8-col,.mdl-grid--no-spacing>.mdl-cell--8-col-desktop.mdl-cell--8-col-desktop{width:66.6666666667%}.mdl-cell--9-col,.mdl-cell--9-col-desktop.mdl-cell--9-col-desktop{width:calc(75% - 16px)}.mdl-grid--no-spacing>.mdl-cell--9-col,.mdl-grid--no-spacing>.mdl-cell--9-col-desktop.mdl-cell--9-col-desktop{width:75%}.mdl-cell--10-col,.mdl-cell--10-col-desktop.mdl-cell--10-col-desktop{width:calc(83.3333333333% - 16px)}.mdl-grid--no-spacing>.mdl-cell--10-col,.mdl-grid--no-spacing>.mdl-cell--10-col-desktop.mdl-cell--10-col-desktop{width:83.3333333333%}.mdl-cell--11-col,.mdl-cell--11-col-desktop.mdl-cell--11-col-desktop{width:calc(91.6666666667% - 16px)}.mdl-grid--no-spacing>.mdl-cell--11-col,.mdl-grid--no-spacing>.mdl-cell--11-col-desktop.mdl-cell--11-col-desktop{width:91.6666666667%}.mdl-cell--12-col,.mdl-cell--12-col-desktop.mdl-cell--12-col-desktop{width:calc(100% - 16px)}.mdl-grid--no-spacing>.mdl-cell--12-col,.mdl-grid--no-spacing>.mdl-cell--12-col-desktop.mdl-cell--12-col-desktop{width:100%}.mdl-cell--1-offset,.mdl-cell--1-offset-desktop.mdl-cell--1-offset-desktop{margin-left:calc(8.3333333333% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--1-offset-desktop.mdl-cell--1-offset-desktop{margin-left:8.3333333333%}.mdl-cell--2-offset,.mdl-cell--2-offset-desktop.mdl-cell--2-offset-desktop{margin-left:calc(16.6666666667% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--2-offset-desktop.mdl-cell--2-offset-desktop{margin-left:16.6666666667%}.mdl-cell--3-offset,.mdl-cell--3-offset-desktop.mdl-cell--3-offset-desktop{margin-left:calc(25% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--3-offset-desktop.mdl-cell--3-offset-desktop{margin-left:25%}.mdl-cell--4-offset,.mdl-cell--4-offset-desktop.mdl-cell--4-offset-desktop{margin-left:calc(33.3333333333% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--4-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--4-offset-desktop.mdl-cell--4-offset-desktop{margin-left:33.3333333333%}.mdl-cell--5-offset,.mdl-cell--5-offset-desktop.mdl-cell--5-offset-desktop{margin-left:calc(41.6666666667% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--5-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--5-offset-desktop.mdl-cell--5-offset-desktop{margin-left:41.6666666667%}.mdl-cell--6-offset,.mdl-cell--6-offset-desktop.mdl-cell--6-offset-desktop{margin-left:calc(50% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--6-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--6-offset-desktop.mdl-cell--6-offset-desktop{margin-left:50%}.mdl-cell--7-offset,.mdl-cell--7-offset-desktop.mdl-cell--7-offset-desktop{margin-left:calc(58.3333333333% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--7-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--7-offset-desktop.mdl-cell--7-offset-desktop{margin-left:58.3333333333%}.mdl-cell--8-offset,.mdl-cell--8-offset-desktop.mdl-cell--8-offset-desktop{margin-left:calc(66.6666666667% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--8-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--8-offset-desktop.mdl-cell--8-offset-desktop{margin-left:66.6666666667%}.mdl-cell--9-offset,.mdl-cell--9-offset-desktop.mdl-cell--9-offset-desktop{margin-left:calc(75% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--9-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--9-offset-desktop.mdl-cell--9-offset-desktop{margin-left:75%}.mdl-cell--10-offset,.mdl-cell--10-offset-desktop.mdl-cell--10-offset-desktop{margin-left:calc(83.3333333333% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--10-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--10-offset-desktop.mdl-cell--10-offset-desktop{margin-left:83.3333333333%}.mdl-cell--11-offset,.mdl-cell--11-offset-desktop.mdl-cell--11-offset-desktop{margin-left:calc(91.6666666667% + 8px)}.mdl-grid.mdl-grid--no-spacing>.mdl-cell--11-offset,.mdl-grid.mdl-grid--no-spacing>.mdl-cell--11-offset-desktop.mdl-cell--11-offset-desktop{margin-left:91.6666666667%}}body{margin:0}.styleguide-demo h1{margin:48px 24px 0}.styleguide-demo h1:after{content:\"\";display:block;width:100%;border-bottom:1px solid rgba(0,0,0,.5);margin-top:24px}.styleguide-demo{opacity:0;transition:opacity .6s ease}.styleguide-masthead{height:256px;background:#212121;padding:115px 16px 0}.styleguide-container{position:relative;max-width:960px;width:100%}.styleguide-title{color:#fff;bottom:auto;position:relative;font-size:56px;font-weight:300;line-height:1;letter-spacing:-.02em}.styleguide-title:after{border-bottom:0}.styleguide-title span{font-weight:300}.mdl-styleguide .mdl-layout__drawer .mdl-navigation__link{padding:10px 24px}.demosLoaded .styleguide-demo{opacity:1}iframe{display:block;width:100%;border:none}iframe.heightSet{overflow:hidden}.demo-wrapper{margin:24px}.demo-wrapper iframe{border:1px solid rgba(0,0,0,.5)}", ""]);
	
	// exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Material Design Icons;src:url(" + __webpack_require__(110) + ");src:url(" + __webpack_require__(109) + "?#iefix&v=1.9.32) format(\"embedded-opentype\"),url(" + __webpack_require__(113) + ") format(\"woff2\"),url(" + __webpack_require__(114) + ") format(\"woff\"),url(" + __webpack_require__(112) + ") format(\"truetype\"),url(" + __webpack_require__(111) + "#materialdesigniconsregular) format(\"svg\");font-weight:400;font-style:normal}.mdi-set,.mdi:before{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;line-height:inherit;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.mdi-access-point:before{content:\"\\F002\"}.mdi-access-point-network:before{content:\"\\F003\"}.mdi-account:before{content:\"\\F004\"}.mdi-account-alert:before{content:\"\\F005\"}.mdi-account-box:before{content:\"\\F006\"}.mdi-account-box-outline:before{content:\"\\F007\"}.mdi-account-card-details:before{content:\"\\F5D2\"}.mdi-account-check:before{content:\"\\F008\"}.mdi-account-circle:before{content:\"\\F009\"}.mdi-account-convert:before{content:\"\\F00A\"}.mdi-account-edit:before{content:\"\\F6BB\"}.mdi-account-key:before{content:\"\\F00B\"}.mdi-account-location:before{content:\"\\F00C\"}.mdi-account-minus:before{content:\"\\F00D\"}.mdi-account-multiple:before{content:\"\\F00E\"}.mdi-account-multiple-minus:before{content:\"\\F5D3\"}.mdi-account-multiple-outline:before{content:\"\\F00F\"}.mdi-account-multiple-plus:before{content:\"\\F010\"}.mdi-account-network:before{content:\"\\F011\"}.mdi-account-off:before{content:\"\\F012\"}.mdi-account-outline:before{content:\"\\F013\"}.mdi-account-plus:before{content:\"\\F014\"}.mdi-account-remove:before{content:\"\\F015\"}.mdi-account-search:before{content:\"\\F016\"}.mdi-account-settings:before{content:\"\\F630\"}.mdi-account-settings-variant:before{content:\"\\F631\"}.mdi-account-star:before{content:\"\\F017\"}.mdi-account-switch:before{content:\"\\F019\"}.mdi-adjust:before{content:\"\\F01A\"}.mdi-air-conditioner:before{content:\"\\F01B\"}.mdi-airballoon:before{content:\"\\F01C\"}.mdi-airplane:before{content:\"\\F01D\"}.mdi-airplane-landing:before{content:\"\\F5D4\"}.mdi-airplane-off:before{content:\"\\F01E\"}.mdi-airplane-takeoff:before{content:\"\\F5D5\"}.mdi-airplay:before{content:\"\\F01F\"}.mdi-alarm:before{content:\"\\F020\"}.mdi-alarm-check:before{content:\"\\F021\"}.mdi-alarm-multiple:before{content:\"\\F022\"}.mdi-alarm-off:before{content:\"\\F023\"}.mdi-alarm-plus:before{content:\"\\F024\"}.mdi-alarm-snooze:before{content:\"\\F68D\"}.mdi-album:before{content:\"\\F025\"}.mdi-alert:before{content:\"\\F026\"}.mdi-alert-box:before{content:\"\\F027\"}.mdi-alert-circle:before{content:\"\\F028\"}.mdi-alert-circle-outline:before{content:\"\\F5D6\"}.mdi-alert-decagram:before{content:\"\\F6BC\"}.mdi-alert-octagon:before{content:\"\\F029\"}.mdi-alert-octagram:before{content:\"\\F766\"}.mdi-alert-outline:before{content:\"\\F02A\"}.mdi-all-inclusive:before{content:\"\\F6BD\"}.mdi-alpha:before{content:\"\\F02B\"}.mdi-alphabetical:before{content:\"\\F02C\"}.mdi-altimeter:before{content:\"\\F5D7\"}.mdi-amazon:before{content:\"\\F02D\"}.mdi-amazon-clouddrive:before{content:\"\\F02E\"}.mdi-ambulance:before{content:\"\\F02F\"}.mdi-amplifier:before{content:\"\\F030\"}.mdi-anchor:before{content:\"\\F031\"}.mdi-android:before{content:\"\\F032\"}.mdi-android-debug-bridge:before{content:\"\\F033\"}.mdi-android-studio:before{content:\"\\F034\"}.mdi-angular:before{content:\"\\F6B1\"}.mdi-angularjs:before{content:\"\\F6BE\"}.mdi-animation:before{content:\"\\F5D8\"}.mdi-apple:before{content:\"\\F035\"}.mdi-apple-finder:before{content:\"\\F036\"}.mdi-apple-ios:before{content:\"\\F037\"}.mdi-apple-keyboard-caps:before{content:\"\\F632\"}.mdi-apple-keyboard-command:before{content:\"\\F633\"}.mdi-apple-keyboard-control:before{content:\"\\F634\"}.mdi-apple-keyboard-option:before{content:\"\\F635\"}.mdi-apple-keyboard-shift:before{content:\"\\F636\"}.mdi-apple-mobileme:before{content:\"\\F038\"}.mdi-apple-safari:before{content:\"\\F039\"}.mdi-application:before{content:\"\\F614\"}.mdi-apps:before{content:\"\\F03B\"}.mdi-archive:before{content:\"\\F03C\"}.mdi-arrange-bring-forward:before{content:\"\\F03D\"}.mdi-arrange-bring-to-front:before{content:\"\\F03E\"}.mdi-arrange-send-backward:before{content:\"\\F03F\"}.mdi-arrange-send-to-back:before{content:\"\\F040\"}.mdi-arrow-all:before{content:\"\\F041\"}.mdi-arrow-bottom-left:before{content:\"\\F042\"}.mdi-arrow-bottom-right:before{content:\"\\F043\"}.mdi-arrow-compress:before{content:\"\\F615\"}.mdi-arrow-compress-all:before{content:\"\\F044\"}.mdi-arrow-down:before{content:\"\\F045\"}.mdi-arrow-down-bold:before{content:\"\\F72D\"}.mdi-arrow-down-bold-box:before{content:\"\\F72E\"}.mdi-arrow-down-bold-box-outline:before{content:\"\\F72F\"}.mdi-arrow-down-bold-circle:before{content:\"\\F047\"}.mdi-arrow-down-bold-circle-outline:before{content:\"\\F048\"}.mdi-arrow-down-bold-hexagon-outline:before{content:\"\\F049\"}.mdi-arrow-down-box:before{content:\"\\F6BF\"}.mdi-arrow-down-drop-circle:before{content:\"\\F04A\"}.mdi-arrow-down-drop-circle-outline:before{content:\"\\F04B\"}.mdi-arrow-down-thick:before{content:\"\\F046\"}.mdi-arrow-expand:before{content:\"\\F616\"}.mdi-arrow-expand-all:before{content:\"\\F04C\"}.mdi-arrow-left:before{content:\"\\F04D\"}.mdi-arrow-left-bold:before{content:\"\\F730\"}.mdi-arrow-left-bold-box:before{content:\"\\F731\"}.mdi-arrow-left-bold-box-outline:before{content:\"\\F732\"}.mdi-arrow-left-bold-circle:before{content:\"\\F04F\"}.mdi-arrow-left-bold-circle-outline:before{content:\"\\F050\"}.mdi-arrow-left-bold-hexagon-outline:before{content:\"\\F051\"}.mdi-arrow-left-box:before{content:\"\\F6C0\"}.mdi-arrow-left-drop-circle:before{content:\"\\F052\"}.mdi-arrow-left-drop-circle-outline:before{content:\"\\F053\"}.mdi-arrow-left-thick:before{content:\"\\F04E\"}.mdi-arrow-right:before{content:\"\\F054\"}.mdi-arrow-right-bold:before{content:\"\\F733\"}.mdi-arrow-right-bold-box:before{content:\"\\F734\"}.mdi-arrow-right-bold-box-outline:before{content:\"\\F735\"}.mdi-arrow-right-bold-circle:before{content:\"\\F056\"}.mdi-arrow-right-bold-circle-outline:before{content:\"\\F057\"}.mdi-arrow-right-bold-hexagon-outline:before{content:\"\\F058\"}.mdi-arrow-right-box:before{content:\"\\F6C1\"}.mdi-arrow-right-drop-circle:before{content:\"\\F059\"}.mdi-arrow-right-drop-circle-outline:before{content:\"\\F05A\"}.mdi-arrow-right-thick:before{content:\"\\F055\"}.mdi-arrow-top-left:before{content:\"\\F05B\"}.mdi-arrow-top-right:before{content:\"\\F05C\"}.mdi-arrow-up:before{content:\"\\F05D\"}.mdi-arrow-up-bold:before{content:\"\\F736\"}.mdi-arrow-up-bold-box:before{content:\"\\F737\"}.mdi-arrow-up-bold-box-outline:before{content:\"\\F738\"}.mdi-arrow-up-bold-circle:before{content:\"\\F05F\"}.mdi-arrow-up-bold-circle-outline:before{content:\"\\F060\"}.mdi-arrow-up-bold-hexagon-outline:before{content:\"\\F061\"}.mdi-arrow-up-box:before{content:\"\\F6C2\"}.mdi-arrow-up-drop-circle:before{content:\"\\F062\"}.mdi-arrow-up-drop-circle-outline:before{content:\"\\F063\"}.mdi-arrow-up-thick:before{content:\"\\F05E\"}.mdi-assistant:before{content:\"\\F064\"}.mdi-asterisk:before{content:\"\\F6C3\"}.mdi-at:before{content:\"\\F065\"}.mdi-atom:before{content:\"\\F767\"}.mdi-attachment:before{content:\"\\F066\"}.mdi-audiobook:before{content:\"\\F067\"}.mdi-auto-fix:before{content:\"\\F068\"}.mdi-auto-upload:before{content:\"\\F069\"}.mdi-autorenew:before{content:\"\\F06A\"}.mdi-av-timer:before{content:\"\\F06B\"}.mdi-baby:before{content:\"\\F06C\"}.mdi-baby-buggy:before{content:\"\\F68E\"}.mdi-backburger:before{content:\"\\F06D\"}.mdi-backspace:before{content:\"\\F06E\"}.mdi-backup-restore:before{content:\"\\F06F\"}.mdi-bandcamp:before{content:\"\\F674\"}.mdi-bank:before{content:\"\\F070\"}.mdi-barcode:before{content:\"\\F071\"}.mdi-barcode-scan:before{content:\"\\F072\"}.mdi-barley:before{content:\"\\F073\"}.mdi-barrel:before{content:\"\\F074\"}.mdi-basecamp:before{content:\"\\F075\"}.mdi-basket:before{content:\"\\F076\"}.mdi-basket-fill:before{content:\"\\F077\"}.mdi-basket-unfill:before{content:\"\\F078\"}.mdi-battery:before{content:\"\\F079\"}.mdi-battery-10:before{content:\"\\F07A\"}.mdi-battery-20:before{content:\"\\F07B\"}.mdi-battery-30:before{content:\"\\F07C\"}.mdi-battery-40:before{content:\"\\F07D\"}.mdi-battery-50:before{content:\"\\F07E\"}.mdi-battery-60:before{content:\"\\F07F\"}.mdi-battery-70:before{content:\"\\F080\"}.mdi-battery-80:before{content:\"\\F081\"}.mdi-battery-90:before{content:\"\\F082\"}.mdi-battery-alert:before{content:\"\\F083\"}.mdi-battery-charging:before{content:\"\\F084\"}.mdi-battery-charging-100:before{content:\"\\F085\"}.mdi-battery-charging-20:before{content:\"\\F086\"}.mdi-battery-charging-30:before{content:\"\\F087\"}.mdi-battery-charging-40:before{content:\"\\F088\"}.mdi-battery-charging-60:before{content:\"\\F089\"}.mdi-battery-charging-80:before{content:\"\\F08A\"}.mdi-battery-charging-90:before{content:\"\\F08B\"}.mdi-battery-minus:before{content:\"\\F08C\"}.mdi-battery-negative:before{content:\"\\F08D\"}.mdi-battery-outline:before{content:\"\\F08E\"}.mdi-battery-plus:before{content:\"\\F08F\"}.mdi-battery-positive:before{content:\"\\F090\"}.mdi-battery-unknown:before{content:\"\\F091\"}.mdi-beach:before{content:\"\\F092\"}.mdi-beaker:before{content:\"\\F68F\"}.mdi-beats:before{content:\"\\F097\"}.mdi-beer:before{content:\"\\F098\"}.mdi-behance:before{content:\"\\F099\"}.mdi-bell:before{content:\"\\F09A\"}.mdi-bell-off:before{content:\"\\F09B\"}.mdi-bell-outline:before{content:\"\\F09C\"}.mdi-bell-plus:before{content:\"\\F09D\"}.mdi-bell-ring:before{content:\"\\F09E\"}.mdi-bell-ring-outline:before{content:\"\\F09F\"}.mdi-bell-sleep:before{content:\"\\F0A0\"}.mdi-beta:before{content:\"\\F0A1\"}.mdi-bible:before{content:\"\\F0A2\"}.mdi-bike:before{content:\"\\F0A3\"}.mdi-bing:before{content:\"\\F0A4\"}.mdi-binoculars:before{content:\"\\F0A5\"}.mdi-bio:before{content:\"\\F0A6\"}.mdi-biohazard:before{content:\"\\F0A7\"}.mdi-bitbucket:before{content:\"\\F0A8\"}.mdi-black-mesa:before{content:\"\\F0A9\"}.mdi-blackberry:before{content:\"\\F0AA\"}.mdi-blender:before{content:\"\\F0AB\"}.mdi-blinds:before{content:\"\\F0AC\"}.mdi-block-helper:before{content:\"\\F0AD\"}.mdi-blogger:before{content:\"\\F0AE\"}.mdi-bluetooth:before{content:\"\\F0AF\"}.mdi-bluetooth-audio:before{content:\"\\F0B0\"}.mdi-bluetooth-connect:before{content:\"\\F0B1\"}.mdi-bluetooth-off:before{content:\"\\F0B2\"}.mdi-bluetooth-settings:before{content:\"\\F0B3\"}.mdi-bluetooth-transfer:before{content:\"\\F0B4\"}.mdi-blur:before{content:\"\\F0B5\"}.mdi-blur-linear:before{content:\"\\F0B6\"}.mdi-blur-off:before{content:\"\\F0B7\"}.mdi-blur-radial:before{content:\"\\F0B8\"}.mdi-bomb:before{content:\"\\F690\"}.mdi-bomb-off:before{content:\"\\F6C4\"}.mdi-bone:before{content:\"\\F0B9\"}.mdi-book:before{content:\"\\F0BA\"}.mdi-book-minus:before{content:\"\\F5D9\"}.mdi-book-multiple:before{content:\"\\F0BB\"}.mdi-book-multiple-variant:before{content:\"\\F0BC\"}.mdi-book-open:before{content:\"\\F0BD\"}.mdi-book-open-page-variant:before{content:\"\\F5DA\"}.mdi-book-open-variant:before{content:\"\\F0BE\"}.mdi-book-plus:before{content:\"\\F5DB\"}.mdi-book-variant:before{content:\"\\F0BF\"}.mdi-bookmark:before{content:\"\\F0C0\"}.mdi-bookmark-check:before{content:\"\\F0C1\"}.mdi-bookmark-music:before{content:\"\\F0C2\"}.mdi-bookmark-outline:before{content:\"\\F0C3\"}.mdi-bookmark-plus:before{content:\"\\F0C5\"}.mdi-bookmark-plus-outline:before{content:\"\\F0C4\"}.mdi-bookmark-remove:before{content:\"\\F0C6\"}.mdi-boombox:before{content:\"\\F5DC\"}.mdi-bootstrap:before{content:\"\\F6C5\"}.mdi-border-all:before{content:\"\\F0C7\"}.mdi-border-bottom:before{content:\"\\F0C8\"}.mdi-border-color:before{content:\"\\F0C9\"}.mdi-border-horizontal:before{content:\"\\F0CA\"}.mdi-border-inside:before{content:\"\\F0CB\"}.mdi-border-left:before{content:\"\\F0CC\"}.mdi-border-none:before{content:\"\\F0CD\"}.mdi-border-outside:before{content:\"\\F0CE\"}.mdi-border-right:before{content:\"\\F0CF\"}.mdi-border-style:before{content:\"\\F0D0\"}.mdi-border-top:before{content:\"\\F0D1\"}.mdi-border-vertical:before{content:\"\\F0D2\"}.mdi-bow-tie:before{content:\"\\F677\"}.mdi-bowl:before{content:\"\\F617\"}.mdi-bowling:before{content:\"\\F0D3\"}.mdi-box:before{content:\"\\F0D4\"}.mdi-box-cutter:before{content:\"\\F0D5\"}.mdi-box-shadow:before{content:\"\\F637\"}.mdi-bridge:before{content:\"\\F618\"}.mdi-briefcase:before{content:\"\\F0D6\"}.mdi-briefcase-check:before{content:\"\\F0D7\"}.mdi-briefcase-download:before{content:\"\\F0D8\"}.mdi-briefcase-upload:before{content:\"\\F0D9\"}.mdi-brightness-1:before{content:\"\\F0DA\"}.mdi-brightness-2:before{content:\"\\F0DB\"}.mdi-brightness-3:before{content:\"\\F0DC\"}.mdi-brightness-4:before{content:\"\\F0DD\"}.mdi-brightness-5:before{content:\"\\F0DE\"}.mdi-brightness-6:before{content:\"\\F0DF\"}.mdi-brightness-7:before{content:\"\\F0E0\"}.mdi-brightness-auto:before{content:\"\\F0E1\"}.mdi-broom:before{content:\"\\F0E2\"}.mdi-brush:before{content:\"\\F0E3\"}.mdi-buffer:before{content:\"\\F619\"}.mdi-bug:before{content:\"\\F0E4\"}.mdi-bulletin-board:before{content:\"\\F0E5\"}.mdi-bullhorn:before{content:\"\\F0E6\"}.mdi-bullseye:before{content:\"\\F5DD\"}.mdi-burst-mode:before{content:\"\\F5DE\"}.mdi-bus:before{content:\"\\F0E7\"}.mdi-cached:before{content:\"\\F0E8\"}.mdi-cake:before{content:\"\\F0E9\"}.mdi-cake-layered:before{content:\"\\F0EA\"}.mdi-cake-variant:before{content:\"\\F0EB\"}.mdi-calculator:before{content:\"\\F0EC\"}.mdi-calendar:before{content:\"\\F0ED\"}.mdi-calendar-blank:before{content:\"\\F0EE\"}.mdi-calendar-check:before{content:\"\\F0EF\"}.mdi-calendar-clock:before{content:\"\\F0F0\"}.mdi-calendar-multiple:before{content:\"\\F0F1\"}.mdi-calendar-multiple-check:before{content:\"\\F0F2\"}.mdi-calendar-plus:before{content:\"\\F0F3\"}.mdi-calendar-question:before{content:\"\\F691\"}.mdi-calendar-range:before{content:\"\\F678\"}.mdi-calendar-remove:before{content:\"\\F0F4\"}.mdi-calendar-text:before{content:\"\\F0F5\"}.mdi-calendar-today:before{content:\"\\F0F6\"}.mdi-call-made:before{content:\"\\F0F7\"}.mdi-call-merge:before{content:\"\\F0F8\"}.mdi-call-missed:before{content:\"\\F0F9\"}.mdi-call-received:before{content:\"\\F0FA\"}.mdi-call-split:before{content:\"\\F0FB\"}.mdi-camcorder:before{content:\"\\F0FC\"}.mdi-camcorder-box:before{content:\"\\F0FD\"}.mdi-camcorder-box-off:before{content:\"\\F0FE\"}.mdi-camcorder-off:before{content:\"\\F0FF\"}.mdi-camera:before{content:\"\\F100\"}.mdi-camera-burst:before{content:\"\\F692\"}.mdi-camera-enhance:before{content:\"\\F101\"}.mdi-camera-front:before{content:\"\\F102\"}.mdi-camera-front-variant:before{content:\"\\F103\"}.mdi-camera-iris:before{content:\"\\F104\"}.mdi-camera-off:before{content:\"\\F5DF\"}.mdi-camera-party-mode:before{content:\"\\F105\"}.mdi-camera-rear:before{content:\"\\F106\"}.mdi-camera-rear-variant:before{content:\"\\F107\"}.mdi-camera-switch:before{content:\"\\F108\"}.mdi-camera-timer:before{content:\"\\F109\"}.mdi-cancel:before{content:\"\\F739\"}.mdi-candle:before{content:\"\\F5E2\"}.mdi-candycane:before{content:\"\\F10A\"}.mdi-car:before{content:\"\\F10B\"}.mdi-car-battery:before{content:\"\\F10C\"}.mdi-car-connected:before{content:\"\\F10D\"}.mdi-car-wash:before{content:\"\\F10E\"}.mdi-cards:before{content:\"\\F638\"}.mdi-cards-outline:before{content:\"\\F639\"}.mdi-cards-playing-outline:before{content:\"\\F63A\"}.mdi-cards-variant:before{content:\"\\F6C6\"}.mdi-carrot:before{content:\"\\F10F\"}.mdi-cart:before{content:\"\\F110\"}.mdi-cart-off:before{content:\"\\F66B\"}.mdi-cart-outline:before{content:\"\\F111\"}.mdi-cart-plus:before{content:\"\\F112\"}.mdi-case-sensitive-alt:before{content:\"\\F113\"}.mdi-cash:before{content:\"\\F114\"}.mdi-cash-100:before{content:\"\\F115\"}.mdi-cash-multiple:before{content:\"\\F116\"}.mdi-cash-usd:before{content:\"\\F117\"}.mdi-cast:before{content:\"\\F118\"}.mdi-cast-connected:before{content:\"\\F119\"}.mdi-cast-off:before{content:\"\\F789\"}.mdi-castle:before{content:\"\\F11A\"}.mdi-cat:before{content:\"\\F11B\"}.mdi-ceiling-light:before{content:\"\\F768\"}.mdi-cellphone:before{content:\"\\F11C\"}.mdi-cellphone-android:before{content:\"\\F11D\"}.mdi-cellphone-basic:before{content:\"\\F11E\"}.mdi-cellphone-dock:before{content:\"\\F11F\"}.mdi-cellphone-iphone:before{content:\"\\F120\"}.mdi-cellphone-link:before{content:\"\\F121\"}.mdi-cellphone-link-off:before{content:\"\\F122\"}.mdi-cellphone-settings:before{content:\"\\F123\"}.mdi-certificate:before{content:\"\\F124\"}.mdi-chair-school:before{content:\"\\F125\"}.mdi-chart-arc:before{content:\"\\F126\"}.mdi-chart-areaspline:before{content:\"\\F127\"}.mdi-chart-bar:before{content:\"\\F128\"}.mdi-chart-bar-stacked:before{content:\"\\F769\"}.mdi-chart-bubble:before{content:\"\\F5E3\"}.mdi-chart-gantt:before{content:\"\\F66C\"}.mdi-chart-histogram:before{content:\"\\F129\"}.mdi-chart-line:before{content:\"\\F12A\"}.mdi-chart-line-stacked:before{content:\"\\F76A\"}.mdi-chart-pie:before{content:\"\\F12B\"}.mdi-chart-scatterplot-hexbin:before{content:\"\\F66D\"}.mdi-chart-timeline:before{content:\"\\F66E\"}.mdi-check:before{content:\"\\F12C\"}.mdi-check-all:before{content:\"\\F12D\"}.mdi-check-circle:before{content:\"\\F5E0\"}.mdi-check-circle-outline:before{content:\"\\F5E1\"}.mdi-checkbox-blank:before{content:\"\\F12E\"}.mdi-checkbox-blank-circle:before{content:\"\\F12F\"}.mdi-checkbox-blank-circle-outline:before{content:\"\\F130\"}.mdi-checkbox-blank-outline:before{content:\"\\F131\"}.mdi-checkbox-marked:before{content:\"\\F132\"}.mdi-checkbox-marked-circle:before{content:\"\\F133\"}.mdi-checkbox-marked-circle-outline:before{content:\"\\F134\"}.mdi-checkbox-marked-outline:before{content:\"\\F135\"}.mdi-checkbox-multiple-blank:before{content:\"\\F136\"}.mdi-checkbox-multiple-blank-circle:before{content:\"\\F63B\"}.mdi-checkbox-multiple-blank-circle-outline:before{content:\"\\F63C\"}.mdi-checkbox-multiple-blank-outline:before{content:\"\\F137\"}.mdi-checkbox-multiple-marked:before{content:\"\\F138\"}.mdi-checkbox-multiple-marked-circle:before{content:\"\\F63D\"}.mdi-checkbox-multiple-marked-circle-outline:before{content:\"\\F63E\"}.mdi-checkbox-multiple-marked-outline:before{content:\"\\F139\"}.mdi-checkerboard:before{content:\"\\F13A\"}.mdi-chemical-weapon:before{content:\"\\F13B\"}.mdi-chevron-double-down:before{content:\"\\F13C\"}.mdi-chevron-double-left:before{content:\"\\F13D\"}.mdi-chevron-double-right:before{content:\"\\F13E\"}.mdi-chevron-double-up:before{content:\"\\F13F\"}.mdi-chevron-down:before{content:\"\\F140\"}.mdi-chevron-left:before{content:\"\\F141\"}.mdi-chevron-right:before{content:\"\\F142\"}.mdi-chevron-up:before{content:\"\\F143\"}.mdi-chip:before{content:\"\\F61A\"}.mdi-church:before{content:\"\\F144\"}.mdi-circle:before{content:\"\\F764\"}.mdi-circle-outline:before{content:\"\\F765\"}.mdi-cisco-webex:before{content:\"\\F145\"}.mdi-city:before{content:\"\\F146\"}.mdi-clipboard:before{content:\"\\F147\"}.mdi-clipboard-account:before{content:\"\\F148\"}.mdi-clipboard-alert:before{content:\"\\F149\"}.mdi-clipboard-arrow-down:before{content:\"\\F14A\"}.mdi-clipboard-arrow-left:before{content:\"\\F14B\"}.mdi-clipboard-check:before{content:\"\\F14C\"}.mdi-clipboard-flow:before{content:\"\\F6C7\"}.mdi-clipboard-outline:before{content:\"\\F14D\"}.mdi-clipboard-plus:before{content:\"\\F750\"}.mdi-clipboard-text:before{content:\"\\F14E\"}.mdi-clippy:before{content:\"\\F14F\"}.mdi-clock:before{content:\"\\F150\"}.mdi-clock-alert:before{content:\"\\F5CE\"}.mdi-clock-end:before{content:\"\\F151\"}.mdi-clock-fast:before{content:\"\\F152\"}.mdi-clock-in:before{content:\"\\F153\"}.mdi-clock-out:before{content:\"\\F154\"}.mdi-clock-start:before{content:\"\\F155\"}.mdi-close:before{content:\"\\F156\"}.mdi-close-box:before{content:\"\\F157\"}.mdi-close-box-outline:before{content:\"\\F158\"}.mdi-close-circle:before{content:\"\\F159\"}.mdi-close-circle-outline:before{content:\"\\F15A\"}.mdi-close-network:before{content:\"\\F15B\"}.mdi-close-octagon:before{content:\"\\F15C\"}.mdi-close-octagon-outline:before{content:\"\\F15D\"}.mdi-close-outline:before{content:\"\\F6C8\"}.mdi-closed-caption:before{content:\"\\F15E\"}.mdi-cloud:before{content:\"\\F15F\"}.mdi-cloud-check:before{content:\"\\F160\"}.mdi-cloud-circle:before{content:\"\\F161\"}.mdi-cloud-download:before{content:\"\\F162\"}.mdi-cloud-off-outline:before{content:\"\\F164\"}.mdi-cloud-outline:before{content:\"\\F163\"}.mdi-cloud-print:before{content:\"\\F165\"}.mdi-cloud-print-outline:before{content:\"\\F166\"}.mdi-cloud-sync:before{content:\"\\F63F\"}.mdi-cloud-upload:before{content:\"\\F167\"}.mdi-code-array:before{content:\"\\F168\"}.mdi-code-braces:before{content:\"\\F169\"}.mdi-code-brackets:before{content:\"\\F16A\"}.mdi-code-equal:before{content:\"\\F16B\"}.mdi-code-greater-than:before{content:\"\\F16C\"}.mdi-code-greater-than-or-equal:before{content:\"\\F16D\"}.mdi-code-less-than:before{content:\"\\F16E\"}.mdi-code-less-than-or-equal:before{content:\"\\F16F\"}.mdi-code-not-equal:before{content:\"\\F170\"}.mdi-code-not-equal-variant:before{content:\"\\F171\"}.mdi-code-parentheses:before{content:\"\\F172\"}.mdi-code-string:before{content:\"\\F173\"}.mdi-code-tags:before{content:\"\\F174\"}.mdi-code-tags-check:before{content:\"\\F693\"}.mdi-codepen:before{content:\"\\F175\"}.mdi-coffee:before{content:\"\\F176\"}.mdi-coffee-outline:before{content:\"\\F6C9\"}.mdi-coffee-to-go:before{content:\"\\F177\"}.mdi-coin:before{content:\"\\F178\"}.mdi-coins:before{content:\"\\F694\"}.mdi-collage:before{content:\"\\F640\"}.mdi-color-helper:before{content:\"\\F179\"}.mdi-comment:before{content:\"\\F17A\"}.mdi-comment-account:before{content:\"\\F17B\"}.mdi-comment-account-outline:before{content:\"\\F17C\"}.mdi-comment-alert:before{content:\"\\F17D\"}.mdi-comment-alert-outline:before{content:\"\\F17E\"}.mdi-comment-check:before{content:\"\\F17F\"}.mdi-comment-check-outline:before{content:\"\\F180\"}.mdi-comment-multiple-outline:before{content:\"\\F181\"}.mdi-comment-outline:before{content:\"\\F182\"}.mdi-comment-plus-outline:before{content:\"\\F183\"}.mdi-comment-processing:before{content:\"\\F184\"}.mdi-comment-processing-outline:before{content:\"\\F185\"}.mdi-comment-question-outline:before{content:\"\\F186\"}.mdi-comment-remove-outline:before{content:\"\\F187\"}.mdi-comment-text:before{content:\"\\F188\"}.mdi-comment-text-outline:before{content:\"\\F189\"}.mdi-compare:before{content:\"\\F18A\"}.mdi-compass:before{content:\"\\F18B\"}.mdi-compass-outline:before{content:\"\\F18C\"}.mdi-console:before{content:\"\\F18D\"}.mdi-contact-mail:before{content:\"\\F18E\"}.mdi-contacts:before{content:\"\\F6CA\"}.mdi-content-copy:before{content:\"\\F18F\"}.mdi-content-cut:before{content:\"\\F190\"}.mdi-content-duplicate:before{content:\"\\F191\"}.mdi-content-paste:before{content:\"\\F192\"}.mdi-content-save:before{content:\"\\F193\"}.mdi-content-save-all:before{content:\"\\F194\"}.mdi-content-save-settings:before{content:\"\\F61B\"}.mdi-contrast:before{content:\"\\F195\"}.mdi-contrast-box:before{content:\"\\F196\"}.mdi-contrast-circle:before{content:\"\\F197\"}.mdi-cookie:before{content:\"\\F198\"}.mdi-copyright:before{content:\"\\F5E6\"}.mdi-counter:before{content:\"\\F199\"}.mdi-cow:before{content:\"\\F19A\"}.mdi-creation:before{content:\"\\F1C9\"}.mdi-credit-card:before{content:\"\\F19B\"}.mdi-credit-card-multiple:before{content:\"\\F19C\"}.mdi-credit-card-off:before{content:\"\\F5E4\"}.mdi-credit-card-plus:before{content:\"\\F675\"}.mdi-credit-card-scan:before{content:\"\\F19D\"}.mdi-crop:before{content:\"\\F19E\"}.mdi-crop-free:before{content:\"\\F19F\"}.mdi-crop-landscape:before{content:\"\\F1A0\"}.mdi-crop-portrait:before{content:\"\\F1A1\"}.mdi-crop-rotate:before{content:\"\\F695\"}.mdi-crop-square:before{content:\"\\F1A2\"}.mdi-crosshairs:before{content:\"\\F1A3\"}.mdi-crosshairs-gps:before{content:\"\\F1A4\"}.mdi-crown:before{content:\"\\F1A5\"}.mdi-cube:before{content:\"\\F1A6\"}.mdi-cube-outline:before{content:\"\\F1A7\"}.mdi-cube-send:before{content:\"\\F1A8\"}.mdi-cube-unfolded:before{content:\"\\F1A9\"}.mdi-cup:before{content:\"\\F1AA\"}.mdi-cup-off:before{content:\"\\F5E5\"}.mdi-cup-water:before{content:\"\\F1AB\"}.mdi-currency-btc:before{content:\"\\F1AC\"}.mdi-currency-eur:before{content:\"\\F1AD\"}.mdi-currency-gbp:before{content:\"\\F1AE\"}.mdi-currency-inr:before{content:\"\\F1AF\"}.mdi-currency-ngn:before{content:\"\\F1B0\"}.mdi-currency-rub:before{content:\"\\F1B1\"}.mdi-currency-try:before{content:\"\\F1B2\"}.mdi-currency-usd:before{content:\"\\F1B3\"}.mdi-currency-usd-off:before{content:\"\\F679\"}.mdi-cursor-default:before{content:\"\\F1B4\"}.mdi-cursor-default-outline:before{content:\"\\F1B5\"}.mdi-cursor-move:before{content:\"\\F1B6\"}.mdi-cursor-pointer:before{content:\"\\F1B7\"}.mdi-cursor-text:before{content:\"\\F5E7\"}.mdi-database:before{content:\"\\F1B8\"}.mdi-database-minus:before{content:\"\\F1B9\"}.mdi-database-plus:before{content:\"\\F1BA\"}.mdi-debug-step-into:before{content:\"\\F1BB\"}.mdi-debug-step-out:before{content:\"\\F1BC\"}.mdi-debug-step-over:before{content:\"\\F1BD\"}.mdi-decagram:before{content:\"\\F76B\"}.mdi-decagram-outline:before{content:\"\\F76C\"}.mdi-decimal-decrease:before{content:\"\\F1BE\"}.mdi-decimal-increase:before{content:\"\\F1BF\"}.mdi-delete:before{content:\"\\F1C0\"}.mdi-delete-circle:before{content:\"\\F682\"}.mdi-delete-empty:before{content:\"\\F6CB\"}.mdi-delete-forever:before{content:\"\\F5E8\"}.mdi-delete-sweep:before{content:\"\\F5E9\"}.mdi-delete-variant:before{content:\"\\F1C1\"}.mdi-delta:before{content:\"\\F1C2\"}.mdi-deskphone:before{content:\"\\F1C3\"}.mdi-desktop-mac:before{content:\"\\F1C4\"}.mdi-desktop-tower:before{content:\"\\F1C5\"}.mdi-details:before{content:\"\\F1C6\"}.mdi-developer-board:before{content:\"\\F696\"}.mdi-deviantart:before{content:\"\\F1C7\"}.mdi-dialpad:before{content:\"\\F61C\"}.mdi-diamond:before{content:\"\\F1C8\"}.mdi-dice-1:before{content:\"\\F1CA\"}.mdi-dice-2:before{content:\"\\F1CB\"}.mdi-dice-3:before{content:\"\\F1CC\"}.mdi-dice-4:before{content:\"\\F1CD\"}.mdi-dice-5:before{content:\"\\F1CE\"}.mdi-dice-6:before{content:\"\\F1CF\"}.mdi-dice-d10:before{content:\"\\F76E\"}.mdi-dice-d20:before{content:\"\\F5EA\"}.mdi-dice-d4:before{content:\"\\F5EB\"}.mdi-dice-d6:before{content:\"\\F5EC\"}.mdi-dice-d8:before{content:\"\\F5ED\"}.mdi-dice-multiple:before{content:\"\\F76D\"}.mdi-dictionary:before{content:\"\\F61D\"}.mdi-directions:before{content:\"\\F1D0\"}.mdi-directions-fork:before{content:\"\\F641\"}.mdi-discord:before{content:\"\\F66F\"}.mdi-disk:before{content:\"\\F5EE\"}.mdi-disk-alert:before{content:\"\\F1D1\"}.mdi-disqus:before{content:\"\\F1D2\"}.mdi-disqus-outline:before{content:\"\\F1D3\"}.mdi-division:before{content:\"\\F1D4\"}.mdi-division-box:before{content:\"\\F1D5\"}.mdi-dna:before{content:\"\\F683\"}.mdi-dns:before{content:\"\\F1D6\"}.mdi-do-not-disturb:before{content:\"\\F697\"}.mdi-do-not-disturb-off:before{content:\"\\F698\"}.mdi-dolby:before{content:\"\\F6B2\"}.mdi-domain:before{content:\"\\F1D7\"}.mdi-dots-horizontal:before{content:\"\\F1D8\"}.mdi-dots-vertical:before{content:\"\\F1D9\"}.mdi-douban:before{content:\"\\F699\"}.mdi-download:before{content:\"\\F1DA\"}.mdi-download-network:before{content:\"\\F6F3\"}.mdi-drag:before{content:\"\\F1DB\"}.mdi-drag-horizontal:before{content:\"\\F1DC\"}.mdi-drag-vertical:before{content:\"\\F1DD\"}.mdi-drawing:before{content:\"\\F1DE\"}.mdi-drawing-box:before{content:\"\\F1DF\"}.mdi-dribbble:before{content:\"\\F1E0\"}.mdi-dribbble-box:before{content:\"\\F1E1\"}.mdi-drone:before{content:\"\\F1E2\"}.mdi-dropbox:before{content:\"\\F1E3\"}.mdi-drupal:before{content:\"\\F1E4\"}.mdi-duck:before{content:\"\\F1E5\"}.mdi-dumbbell:before{content:\"\\F1E6\"}.mdi-earth:before{content:\"\\F1E7\"}.mdi-earth-box:before{content:\"\\F6CC\"}.mdi-earth-box-off:before{content:\"\\F6CD\"}.mdi-earth-off:before{content:\"\\F1E8\"}.mdi-edge:before{content:\"\\F1E9\"}.mdi-eject:before{content:\"\\F1EA\"}.mdi-elevation-decline:before{content:\"\\F1EB\"}.mdi-elevation-rise:before{content:\"\\F1EC\"}.mdi-elevator:before{content:\"\\F1ED\"}.mdi-email:before{content:\"\\F1EE\"}.mdi-email-alert:before{content:\"\\F6CE\"}.mdi-email-open:before{content:\"\\F1EF\"}.mdi-email-open-outline:before{content:\"\\F5EF\"}.mdi-email-outline:before{content:\"\\F1F0\"}.mdi-email-secure:before{content:\"\\F1F1\"}.mdi-email-variant:before{content:\"\\F5F0\"}.mdi-emby:before{content:\"\\F6B3\"}.mdi-emoticon:before{content:\"\\F1F2\"}.mdi-emoticon-cool:before{content:\"\\F1F3\"}.mdi-emoticon-dead:before{content:\"\\F69A\"}.mdi-emoticon-devil:before{content:\"\\F1F4\"}.mdi-emoticon-excited:before{content:\"\\F69B\"}.mdi-emoticon-happy:before{content:\"\\F1F5\"}.mdi-emoticon-neutral:before{content:\"\\F1F6\"}.mdi-emoticon-poop:before{content:\"\\F1F7\"}.mdi-emoticon-sad:before{content:\"\\F1F8\"}.mdi-emoticon-tongue:before{content:\"\\F1F9\"}.mdi-engine:before{content:\"\\F1FA\"}.mdi-engine-outline:before{content:\"\\F1FB\"}.mdi-equal:before{content:\"\\F1FC\"}.mdi-equal-box:before{content:\"\\F1FD\"}.mdi-eraser:before{content:\"\\F1FE\"}.mdi-eraser-variant:before{content:\"\\F642\"}.mdi-escalator:before{content:\"\\F1FF\"}.mdi-ethernet:before{content:\"\\F200\"}.mdi-ethernet-cable:before{content:\"\\F201\"}.mdi-ethernet-cable-off:before{content:\"\\F202\"}.mdi-etsy:before{content:\"\\F203\"}.mdi-ev-station:before{content:\"\\F5F1\"}.mdi-evernote:before{content:\"\\F204\"}.mdi-exclamation:before{content:\"\\F205\"}.mdi-exit-to-app:before{content:\"\\F206\"}.mdi-export:before{content:\"\\F207\"}.mdi-eye:before{content:\"\\F208\"}.mdi-eye-off:before{content:\"\\F209\"}.mdi-eye-off-outline:before{content:\"\\F6D0\"}.mdi-eye-outline:before{content:\"\\F6CF\"}.mdi-eyedropper:before{content:\"\\F20A\"}.mdi-eyedropper-variant:before{content:\"\\F20B\"}.mdi-face:before{content:\"\\F643\"}.mdi-face-profile:before{content:\"\\F644\"}.mdi-facebook:before{content:\"\\F20C\"}.mdi-facebook-box:before{content:\"\\F20D\"}.mdi-facebook-messenger:before{content:\"\\F20E\"}.mdi-factory:before{content:\"\\F20F\"}.mdi-fan:before{content:\"\\F210\"}.mdi-fast-forward:before{content:\"\\F211\"}.mdi-fast-forward-outline:before{content:\"\\F6D1\"}.mdi-fax:before{content:\"\\F212\"}.mdi-feather:before{content:\"\\F6D2\"}.mdi-ferry:before{content:\"\\F213\"}.mdi-file:before{content:\"\\F214\"}.mdi-file-account:before{content:\"\\F73A\"}.mdi-file-chart:before{content:\"\\F215\"}.mdi-file-check:before{content:\"\\F216\"}.mdi-file-cloud:before{content:\"\\F217\"}.mdi-file-delimited:before{content:\"\\F218\"}.mdi-file-document:before{content:\"\\F219\"}.mdi-file-document-box:before{content:\"\\F21A\"}.mdi-file-excel:before{content:\"\\F21B\"}.mdi-file-excel-box:before{content:\"\\F21C\"}.mdi-file-export:before{content:\"\\F21D\"}.mdi-file-find:before{content:\"\\F21E\"}.mdi-file-hidden:before{content:\"\\F613\"}.mdi-file-image:before{content:\"\\F21F\"}.mdi-file-import:before{content:\"\\F220\"}.mdi-file-lock:before{content:\"\\F221\"}.mdi-file-multiple:before{content:\"\\F222\"}.mdi-file-music:before{content:\"\\F223\"}.mdi-file-outline:before{content:\"\\F224\"}.mdi-file-pdf:before{content:\"\\F225\"}.mdi-file-pdf-box:before{content:\"\\F226\"}.mdi-file-plus:before{content:\"\\F751\"}.mdi-file-powerpoint:before{content:\"\\F227\"}.mdi-file-powerpoint-box:before{content:\"\\F228\"}.mdi-file-presentation-box:before{content:\"\\F229\"}.mdi-file-restore:before{content:\"\\F670\"}.mdi-file-send:before{content:\"\\F22A\"}.mdi-file-tree:before{content:\"\\F645\"}.mdi-file-video:before{content:\"\\F22B\"}.mdi-file-word:before{content:\"\\F22C\"}.mdi-file-word-box:before{content:\"\\F22D\"}.mdi-file-xml:before{content:\"\\F22E\"}.mdi-film:before{content:\"\\F22F\"}.mdi-filmstrip:before{content:\"\\F230\"}.mdi-filmstrip-off:before{content:\"\\F231\"}.mdi-filter:before{content:\"\\F232\"}.mdi-filter-outline:before{content:\"\\F233\"}.mdi-filter-remove:before{content:\"\\F234\"}.mdi-filter-remove-outline:before{content:\"\\F235\"}.mdi-filter-variant:before{content:\"\\F236\"}.mdi-find-replace:before{content:\"\\F6D3\"}.mdi-fingerprint:before{content:\"\\F237\"}.mdi-fire:before{content:\"\\F238\"}.mdi-firefox:before{content:\"\\F239\"}.mdi-fish:before{content:\"\\F23A\"}.mdi-flag:before{content:\"\\F23B\"}.mdi-flag-checkered:before{content:\"\\F23C\"}.mdi-flag-outline:before{content:\"\\F23D\"}.mdi-flag-outline-variant:before{content:\"\\F23E\"}.mdi-flag-triangle:before{content:\"\\F23F\"}.mdi-flag-variant:before{content:\"\\F240\"}.mdi-flash:before{content:\"\\F241\"}.mdi-flash-auto:before{content:\"\\F242\"}.mdi-flash-off:before{content:\"\\F243\"}.mdi-flash-outline:before{content:\"\\F6D4\"}.mdi-flash-red-eye:before{content:\"\\F67A\"}.mdi-flashlight:before{content:\"\\F244\"}.mdi-flashlight-off:before{content:\"\\F245\"}.mdi-flask:before{content:\"\\F093\"}.mdi-flask-empty:before{content:\"\\F094\"}.mdi-flask-empty-outline:before{content:\"\\F095\"}.mdi-flask-outline:before{content:\"\\F096\"}.mdi-flattr:before{content:\"\\F246\"}.mdi-flip-to-back:before{content:\"\\F247\"}.mdi-flip-to-front:before{content:\"\\F248\"}.mdi-floppy:before{content:\"\\F249\"}.mdi-flower:before{content:\"\\F24A\"}.mdi-folder:before{content:\"\\F24B\"}.mdi-folder-account:before{content:\"\\F24C\"}.mdi-folder-download:before{content:\"\\F24D\"}.mdi-folder-google-drive:before{content:\"\\F24E\"}.mdi-folder-image:before{content:\"\\F24F\"}.mdi-folder-lock:before{content:\"\\F250\"}.mdi-folder-lock-open:before{content:\"\\F251\"}.mdi-folder-move:before{content:\"\\F252\"}.mdi-folder-multiple:before{content:\"\\F253\"}.mdi-folder-multiple-image:before{content:\"\\F254\"}.mdi-folder-multiple-outline:before{content:\"\\F255\"}.mdi-folder-open:before{content:\"\\F76F\"}.mdi-folder-outline:before{content:\"\\F256\"}.mdi-folder-plus:before{content:\"\\F257\"}.mdi-folder-remove:before{content:\"\\F258\"}.mdi-folder-star:before{content:\"\\F69C\"}.mdi-folder-upload:before{content:\"\\F259\"}.mdi-font-awesome:before{content:\"\\F03A\"}.mdi-food:before{content:\"\\F25A\"}.mdi-food-apple:before{content:\"\\F25B\"}.mdi-food-fork-drink:before{content:\"\\F5F2\"}.mdi-food-off:before{content:\"\\F5F3\"}.mdi-food-variant:before{content:\"\\F25C\"}.mdi-football:before{content:\"\\F25D\"}.mdi-football-australian:before{content:\"\\F25E\"}.mdi-football-helmet:before{content:\"\\F25F\"}.mdi-format-align-bottom:before{content:\"\\F752\"}.mdi-format-align-center:before{content:\"\\F260\"}.mdi-format-align-justify:before{content:\"\\F261\"}.mdi-format-align-left:before{content:\"\\F262\"}.mdi-format-align-middle:before{content:\"\\F753\"}.mdi-format-align-right:before{content:\"\\F263\"}.mdi-format-align-top:before{content:\"\\F754\"}.mdi-format-annotation-plus:before{content:\"\\F646\"}.mdi-format-bold:before{content:\"\\F264\"}.mdi-format-clear:before{content:\"\\F265\"}.mdi-format-color-fill:before{content:\"\\F266\"}.mdi-format-color-text:before{content:\"\\F69D\"}.mdi-format-float-center:before{content:\"\\F267\"}.mdi-format-float-left:before{content:\"\\F268\"}.mdi-format-float-none:before{content:\"\\F269\"}.mdi-format-float-right:before{content:\"\\F26A\"}.mdi-format-font:before{content:\"\\F6D5\"}.mdi-format-header-1:before{content:\"\\F26B\"}.mdi-format-header-2:before{content:\"\\F26C\"}.mdi-format-header-3:before{content:\"\\F26D\"}.mdi-format-header-4:before{content:\"\\F26E\"}.mdi-format-header-5:before{content:\"\\F26F\"}.mdi-format-header-6:before{content:\"\\F270\"}.mdi-format-header-decrease:before{content:\"\\F271\"}.mdi-format-header-equal:before{content:\"\\F272\"}.mdi-format-header-increase:before{content:\"\\F273\"}.mdi-format-header-pound:before{content:\"\\F274\"}.mdi-format-horizontal-align-center:before{content:\"\\F61E\"}.mdi-format-horizontal-align-left:before{content:\"\\F61F\"}.mdi-format-horizontal-align-right:before{content:\"\\F620\"}.mdi-format-indent-decrease:before{content:\"\\F275\"}.mdi-format-indent-increase:before{content:\"\\F276\"}.mdi-format-italic:before{content:\"\\F277\"}.mdi-format-line-spacing:before{content:\"\\F278\"}.mdi-format-line-style:before{content:\"\\F5C8\"}.mdi-format-line-weight:before{content:\"\\F5C9\"}.mdi-format-list-bulleted:before{content:\"\\F279\"}.mdi-format-list-bulleted-type:before{content:\"\\F27A\"}.mdi-format-list-checks:before{content:\"\\F755\"}.mdi-format-list-numbers:before{content:\"\\F27B\"}.mdi-format-page-break:before{content:\"\\F6D6\"}.mdi-format-paint:before{content:\"\\F27C\"}.mdi-format-paragraph:before{content:\"\\F27D\"}.mdi-format-pilcrow:before{content:\"\\F6D7\"}.mdi-format-quote-close:before{content:\"\\F27E\"}.mdi-format-quote-open:before{content:\"\\F756\"}.mdi-format-rotate-90:before{content:\"\\F6A9\"}.mdi-format-section:before{content:\"\\F69E\"}.mdi-format-size:before{content:\"\\F27F\"}.mdi-format-strikethrough:before{content:\"\\F280\"}.mdi-format-strikethrough-variant:before{content:\"\\F281\"}.mdi-format-subscript:before{content:\"\\F282\"}.mdi-format-superscript:before{content:\"\\F283\"}.mdi-format-text:before{content:\"\\F284\"}.mdi-format-textdirection-l-to-r:before{content:\"\\F285\"}.mdi-format-textdirection-r-to-l:before{content:\"\\F286\"}.mdi-format-title:before{content:\"\\F5F4\"}.mdi-format-underline:before{content:\"\\F287\"}.mdi-format-vertical-align-bottom:before{content:\"\\F621\"}.mdi-format-vertical-align-center:before{content:\"\\F622\"}.mdi-format-vertical-align-top:before{content:\"\\F623\"}.mdi-format-wrap-inline:before{content:\"\\F288\"}.mdi-format-wrap-square:before{content:\"\\F289\"}.mdi-format-wrap-tight:before{content:\"\\F28A\"}.mdi-format-wrap-top-bottom:before{content:\"\\F28B\"}.mdi-forum:before{content:\"\\F28C\"}.mdi-forward:before{content:\"\\F28D\"}.mdi-foursquare:before{content:\"\\F28E\"}.mdi-fridge:before{content:\"\\F28F\"}.mdi-fridge-filled:before{content:\"\\F290\"}.mdi-fridge-filled-bottom:before{content:\"\\F291\"}.mdi-fridge-filled-top:before{content:\"\\F292\"}.mdi-fullscreen:before{content:\"\\F293\"}.mdi-fullscreen-exit:before{content:\"\\F294\"}.mdi-function:before{content:\"\\F295\"}.mdi-gamepad:before{content:\"\\F296\"}.mdi-gamepad-variant:before{content:\"\\F297\"}.mdi-garage:before{content:\"\\F6D8\"}.mdi-garage-open:before{content:\"\\F6D9\"}.mdi-gas-cylinder:before{content:\"\\F647\"}.mdi-gas-station:before{content:\"\\F298\"}.mdi-gate:before{content:\"\\F299\"}.mdi-gauge:before{content:\"\\F29A\"}.mdi-gavel:before{content:\"\\F29B\"}.mdi-gender-female:before{content:\"\\F29C\"}.mdi-gender-male:before{content:\"\\F29D\"}.mdi-gender-male-female:before{content:\"\\F29E\"}.mdi-gender-transgender:before{content:\"\\F29F\"}.mdi-gesture-double-tap:before{content:\"\\F73B\"}.mdi-gesture-swipe-down:before{content:\"\\F73C\"}.mdi-gesture-swipe-left:before{content:\"\\F73D\"}.mdi-gesture-swipe-right:before{content:\"\\F73E\"}.mdi-gesture-swipe-up:before{content:\"\\F73F\"}.mdi-gesture-tap:before{content:\"\\F740\"}.mdi-gesture-two-double-tap:before{content:\"\\F741\"}.mdi-gesture-two-tap:before{content:\"\\F742\"}.mdi-ghost:before{content:\"\\F2A0\"}.mdi-gift:before{content:\"\\F2A1\"}.mdi-git:before{content:\"\\F2A2\"}.mdi-github-box:before{content:\"\\F2A3\"}.mdi-github-circle:before{content:\"\\F2A4\"}.mdi-github-face:before{content:\"\\F6DA\"}.mdi-glass-flute:before{content:\"\\F2A5\"}.mdi-glass-mug:before{content:\"\\F2A6\"}.mdi-glass-stange:before{content:\"\\F2A7\"}.mdi-glass-tulip:before{content:\"\\F2A8\"}.mdi-glassdoor:before{content:\"\\F2A9\"}.mdi-glasses:before{content:\"\\F2AA\"}.mdi-gmail:before{content:\"\\F2AB\"}.mdi-gnome:before{content:\"\\F2AC\"}.mdi-gondola:before{content:\"\\F685\"}.mdi-google:before{content:\"\\F2AD\"}.mdi-google-cardboard:before{content:\"\\F2AE\"}.mdi-google-chrome:before{content:\"\\F2AF\"}.mdi-google-circles:before{content:\"\\F2B0\"}.mdi-google-circles-communities:before{content:\"\\F2B1\"}.mdi-google-circles-extended:before{content:\"\\F2B2\"}.mdi-google-circles-group:before{content:\"\\F2B3\"}.mdi-google-controller:before{content:\"\\F2B4\"}.mdi-google-controller-off:before{content:\"\\F2B5\"}.mdi-google-drive:before{content:\"\\F2B6\"}.mdi-google-earth:before{content:\"\\F2B7\"}.mdi-google-glass:before{content:\"\\F2B8\"}.mdi-google-keep:before{content:\"\\F6DB\"}.mdi-google-maps:before{content:\"\\F5F5\"}.mdi-google-nearby:before{content:\"\\F2B9\"}.mdi-google-pages:before{content:\"\\F2BA\"}.mdi-google-photos:before{content:\"\\F6DC\"}.mdi-google-physical-web:before{content:\"\\F2BB\"}.mdi-google-play:before{content:\"\\F2BC\"}.mdi-google-plus:before{content:\"\\F2BD\"}.mdi-google-plus-box:before{content:\"\\F2BE\"}.mdi-google-translate:before{content:\"\\F2BF\"}.mdi-google-wallet:before{content:\"\\F2C0\"}.mdi-gradient:before{content:\"\\F69F\"}.mdi-grease-pencil:before{content:\"\\F648\"}.mdi-grid:before{content:\"\\F2C1\"}.mdi-grid-large:before{content:\"\\F757\"}.mdi-grid-off:before{content:\"\\F2C2\"}.mdi-group:before{content:\"\\F2C3\"}.mdi-guitar-acoustic:before{content:\"\\F770\"}.mdi-guitar-electric:before{content:\"\\F2C4\"}.mdi-guitar-pick:before{content:\"\\F2C5\"}.mdi-guitar-pick-outline:before{content:\"\\F2C6\"}.mdi-hackernews:before{content:\"\\F624\"}.mdi-hamburger:before{content:\"\\F684\"}.mdi-hand-pointing-right:before{content:\"\\F2C7\"}.mdi-hanger:before{content:\"\\F2C8\"}.mdi-hangouts:before{content:\"\\F2C9\"}.mdi-harddisk:before{content:\"\\F2CA\"}.mdi-headphones:before{content:\"\\F2CB\"}.mdi-headphones-box:before{content:\"\\F2CC\"}.mdi-headphones-settings:before{content:\"\\F2CD\"}.mdi-headset:before{content:\"\\F2CE\"}.mdi-headset-dock:before{content:\"\\F2CF\"}.mdi-headset-off:before{content:\"\\F2D0\"}.mdi-heart:before{content:\"\\F2D1\"}.mdi-heart-box:before{content:\"\\F2D2\"}.mdi-heart-box-outline:before{content:\"\\F2D3\"}.mdi-heart-broken:before{content:\"\\F2D4\"}.mdi-heart-half:before{content:\"\\F6DE\"}.mdi-heart-half-full:before{content:\"\\F6DD\"}.mdi-heart-half-outline:before{content:\"\\F6DF\"}.mdi-heart-off:before{content:\"\\F758\"}.mdi-heart-outline:before{content:\"\\F2D5\"}.mdi-heart-pulse:before{content:\"\\F5F6\"}.mdi-help:before{content:\"\\F2D6\"}.mdi-help-box:before{content:\"\\F78A\"}.mdi-help-circle:before{content:\"\\F2D7\"}.mdi-help-circle-outline:before{content:\"\\F625\"}.mdi-help-network:before{content:\"\\F6F4\"}.mdi-hexagon:before{content:\"\\F2D8\"}.mdi-hexagon-multiple:before{content:\"\\F6E0\"}.mdi-hexagon-outline:before{content:\"\\F2D9\"}.mdi-highway:before{content:\"\\F5F7\"}.mdi-history:before{content:\"\\F2DA\"}.mdi-hololens:before{content:\"\\F2DB\"}.mdi-home:before{content:\"\\F2DC\"}.mdi-home-map-marker:before{content:\"\\F5F8\"}.mdi-home-modern:before{content:\"\\F2DD\"}.mdi-home-outline:before{content:\"\\F6A0\"}.mdi-home-variant:before{content:\"\\F2DE\"}.mdi-hook:before{content:\"\\F6E1\"}.mdi-hook-off:before{content:\"\\F6E2\"}.mdi-hops:before{content:\"\\F2DF\"}.mdi-hospital:before{content:\"\\F2E0\"}.mdi-hospital-building:before{content:\"\\F2E1\"}.mdi-hospital-marker:before{content:\"\\F2E2\"}.mdi-hotel:before{content:\"\\F2E3\"}.mdi-houzz:before{content:\"\\F2E4\"}.mdi-houzz-box:before{content:\"\\F2E5\"}.mdi-human:before{content:\"\\F2E6\"}.mdi-human-child:before{content:\"\\F2E7\"}.mdi-human-female:before{content:\"\\F649\"}.mdi-human-greeting:before{content:\"\\F64A\"}.mdi-human-handsdown:before{content:\"\\F64B\"}.mdi-human-handsup:before{content:\"\\F64C\"}.mdi-human-male:before{content:\"\\F64D\"}.mdi-human-male-female:before{content:\"\\F2E8\"}.mdi-human-pregnant:before{content:\"\\F5CF\"}.mdi-humble-bundle:before{content:\"\\F743\"}.mdi-image:before{content:\"\\F2E9\"}.mdi-image-album:before{content:\"\\F2EA\"}.mdi-image-area:before{content:\"\\F2EB\"}.mdi-image-area-close:before{content:\"\\F2EC\"}.mdi-image-broken:before{content:\"\\F2ED\"}.mdi-image-broken-variant:before{content:\"\\F2EE\"}.mdi-image-filter:before{content:\"\\F2EF\"}.mdi-image-filter-black-white:before{content:\"\\F2F0\"}.mdi-image-filter-center-focus:before{content:\"\\F2F1\"}.mdi-image-filter-center-focus-weak:before{content:\"\\F2F2\"}.mdi-image-filter-drama:before{content:\"\\F2F3\"}.mdi-image-filter-frames:before{content:\"\\F2F4\"}.mdi-image-filter-hdr:before{content:\"\\F2F5\"}.mdi-image-filter-none:before{content:\"\\F2F6\"}.mdi-image-filter-tilt-shift:before{content:\"\\F2F7\"}.mdi-image-filter-vintage:before{content:\"\\F2F8\"}.mdi-image-multiple:before{content:\"\\F2F9\"}.mdi-import:before{content:\"\\F2FA\"}.mdi-inbox:before{content:\"\\F686\"}.mdi-inbox-arrow-down:before{content:\"\\F2FB\"}.mdi-inbox-arrow-up:before{content:\"\\F3D1\"}.mdi-incognito:before{content:\"\\F5F9\"}.mdi-infinity:before{content:\"\\F6E3\"}.mdi-information:before{content:\"\\F2FC\"}.mdi-information-outline:before{content:\"\\F2FD\"}.mdi-information-variant:before{content:\"\\F64E\"}.mdi-instagram:before{content:\"\\F2FE\"}.mdi-instapaper:before{content:\"\\F2FF\"}.mdi-internet-explorer:before{content:\"\\F300\"}.mdi-invert-colors:before{content:\"\\F301\"}.mdi-itunes:before{content:\"\\F676\"}.mdi-jeepney:before{content:\"\\F302\"}.mdi-jira:before{content:\"\\F303\"}.mdi-jsfiddle:before{content:\"\\F304\"}.mdi-json:before{content:\"\\F626\"}.mdi-keg:before{content:\"\\F305\"}.mdi-kettle:before{content:\"\\F5FA\"}.mdi-key:before{content:\"\\F306\"}.mdi-key-change:before{content:\"\\F307\"}.mdi-key-minus:before{content:\"\\F308\"}.mdi-key-plus:before{content:\"\\F309\"}.mdi-key-remove:before{content:\"\\F30A\"}.mdi-key-variant:before{content:\"\\F30B\"}.mdi-keyboard:before{content:\"\\F30C\"}.mdi-keyboard-backspace:before{content:\"\\F30D\"}.mdi-keyboard-caps:before{content:\"\\F30E\"}.mdi-keyboard-close:before{content:\"\\F30F\"}.mdi-keyboard-off:before{content:\"\\F310\"}.mdi-keyboard-return:before{content:\"\\F311\"}.mdi-keyboard-tab:before{content:\"\\F312\"}.mdi-keyboard-variant:before{content:\"\\F313\"}.mdi-kickstarter:before{content:\"\\F744\"}.mdi-kodi:before{content:\"\\F314\"}.mdi-label:before{content:\"\\F315\"}.mdi-label-outline:before{content:\"\\F316\"}.mdi-lambda:before{content:\"\\F627\"}.mdi-lamp:before{content:\"\\F6B4\"}.mdi-lan:before{content:\"\\F317\"}.mdi-lan-connect:before{content:\"\\F318\"}.mdi-lan-disconnect:before{content:\"\\F319\"}.mdi-lan-pending:before{content:\"\\F31A\"}.mdi-language-c:before{content:\"\\F671\"}.mdi-language-cpp:before{content:\"\\F672\"}.mdi-language-csharp:before{content:\"\\F31B\"}.mdi-language-css3:before{content:\"\\F31C\"}.mdi-language-html5:before{content:\"\\F31D\"}.mdi-language-javascript:before{content:\"\\F31E\"}.mdi-language-php:before{content:\"\\F31F\"}.mdi-language-python:before{content:\"\\F320\"}.mdi-language-python-text:before{content:\"\\F321\"}.mdi-language-swift:before{content:\"\\F6E4\"}.mdi-language-typescript:before{content:\"\\F6E5\"}.mdi-laptop:before{content:\"\\F322\"}.mdi-laptop-chromebook:before{content:\"\\F323\"}.mdi-laptop-mac:before{content:\"\\F324\"}.mdi-laptop-off:before{content:\"\\F6E6\"}.mdi-laptop-windows:before{content:\"\\F325\"}.mdi-lastfm:before{content:\"\\F326\"}.mdi-launch:before{content:\"\\F327\"}.mdi-layers:before{content:\"\\F328\"}.mdi-layers-off:before{content:\"\\F329\"}.mdi-lead-pencil:before{content:\"\\F64F\"}.mdi-leaf:before{content:\"\\F32A\"}.mdi-led-off:before{content:\"\\F32B\"}.mdi-led-on:before{content:\"\\F32C\"}.mdi-led-outline:before{content:\"\\F32D\"}.mdi-led-variant-off:before{content:\"\\F32E\"}.mdi-led-variant-on:before{content:\"\\F32F\"}.mdi-led-variant-outline:before{content:\"\\F330\"}.mdi-library:before{content:\"\\F331\"}.mdi-library-books:before{content:\"\\F332\"}.mdi-library-music:before{content:\"\\F333\"}.mdi-library-plus:before{content:\"\\F334\"}.mdi-lightbulb:before{content:\"\\F335\"}.mdi-lightbulb-on:before{content:\"\\F6E7\"}.mdi-lightbulb-on-outline:before{content:\"\\F6E8\"}.mdi-lightbulb-outline:before{content:\"\\F336\"}.mdi-link:before{content:\"\\F337\"}.mdi-link-off:before{content:\"\\F338\"}.mdi-link-variant:before{content:\"\\F339\"}.mdi-link-variant-off:before{content:\"\\F33A\"}.mdi-linkedin:before{content:\"\\F33B\"}.mdi-linkedin-box:before{content:\"\\F33C\"}.mdi-linux:before{content:\"\\F33D\"}.mdi-loading:before{content:\"\\F771\"}.mdi-lock:before{content:\"\\F33E\"}.mdi-lock-open:before{content:\"\\F33F\"}.mdi-lock-open-outline:before{content:\"\\F340\"}.mdi-lock-outline:before{content:\"\\F341\"}.mdi-lock-pattern:before{content:\"\\F6E9\"}.mdi-lock-plus:before{content:\"\\F5FB\"}.mdi-lock-reset:before{content:\"\\F772\"}.mdi-login:before{content:\"\\F342\"}.mdi-login-variant:before{content:\"\\F5FC\"}.mdi-logout:before{content:\"\\F343\"}.mdi-logout-variant:before{content:\"\\F5FD\"}.mdi-looks:before{content:\"\\F344\"}.mdi-loop:before{content:\"\\F6EA\"}.mdi-loupe:before{content:\"\\F345\"}.mdi-lumx:before{content:\"\\F346\"}.mdi-magnet:before{content:\"\\F347\"}.mdi-magnet-on:before{content:\"\\F348\"}.mdi-magnify:before{content:\"\\F349\"}.mdi-magnify-minus:before{content:\"\\F34A\"}.mdi-magnify-minus-outline:before{content:\"\\F6EB\"}.mdi-magnify-plus:before{content:\"\\F34B\"}.mdi-magnify-plus-outline:before{content:\"\\F6EC\"}.mdi-mail-ru:before{content:\"\\F34C\"}.mdi-mailbox:before{content:\"\\F6ED\"}.mdi-map:before{content:\"\\F34D\"}.mdi-map-marker:before{content:\"\\F34E\"}.mdi-map-marker-circle:before{content:\"\\F34F\"}.mdi-map-marker-minus:before{content:\"\\F650\"}.mdi-map-marker-multiple:before{content:\"\\F350\"}.mdi-map-marker-off:before{content:\"\\F351\"}.mdi-map-marker-plus:before{content:\"\\F651\"}.mdi-map-marker-radius:before{content:\"\\F352\"}.mdi-margin:before{content:\"\\F353\"}.mdi-markdown:before{content:\"\\F354\"}.mdi-marker:before{content:\"\\F652\"}.mdi-marker-check:before{content:\"\\F355\"}.mdi-martini:before{content:\"\\F356\"}.mdi-material-ui:before{content:\"\\F357\"}.mdi-math-compass:before{content:\"\\F358\"}.mdi-matrix:before{content:\"\\F628\"}.mdi-maxcdn:before{content:\"\\F359\"}.mdi-medical-bag:before{content:\"\\F6EE\"}.mdi-medium:before{content:\"\\F35A\"}.mdi-memory:before{content:\"\\F35B\"}.mdi-menu:before{content:\"\\F35C\"}.mdi-menu-down:before{content:\"\\F35D\"}.mdi-menu-down-outline:before{content:\"\\F6B5\"}.mdi-menu-left:before{content:\"\\F35E\"}.mdi-menu-right:before{content:\"\\F35F\"}.mdi-menu-up:before{content:\"\\F360\"}.mdi-menu-up-outline:before{content:\"\\F6B6\"}.mdi-message:before{content:\"\\F361\"}.mdi-message-alert:before{content:\"\\F362\"}.mdi-message-bulleted:before{content:\"\\F6A1\"}.mdi-message-bulleted-off:before{content:\"\\F6A2\"}.mdi-message-draw:before{content:\"\\F363\"}.mdi-message-image:before{content:\"\\F364\"}.mdi-message-outline:before{content:\"\\F365\"}.mdi-message-plus:before{content:\"\\F653\"}.mdi-message-processing:before{content:\"\\F366\"}.mdi-message-reply:before{content:\"\\F367\"}.mdi-message-reply-text:before{content:\"\\F368\"}.mdi-message-settings:before{content:\"\\F6EF\"}.mdi-message-settings-variant:before{content:\"\\F6F0\"}.mdi-message-text:before{content:\"\\F369\"}.mdi-message-text-outline:before{content:\"\\F36A\"}.mdi-message-video:before{content:\"\\F36B\"}.mdi-meteor:before{content:\"\\F629\"}.mdi-microphone:before{content:\"\\F36C\"}.mdi-microphone-off:before{content:\"\\F36D\"}.mdi-microphone-outline:before{content:\"\\F36E\"}.mdi-microphone-settings:before{content:\"\\F36F\"}.mdi-microphone-variant:before{content:\"\\F370\"}.mdi-microphone-variant-off:before{content:\"\\F371\"}.mdi-microscope:before{content:\"\\F654\"}.mdi-microsoft:before{content:\"\\F372\"}.mdi-minecraft:before{content:\"\\F373\"}.mdi-minus:before{content:\"\\F374\"}.mdi-minus-box:before{content:\"\\F375\"}.mdi-minus-box-outline:before{content:\"\\F6F1\"}.mdi-minus-circle:before{content:\"\\F376\"}.mdi-minus-circle-outline:before{content:\"\\F377\"}.mdi-minus-network:before{content:\"\\F378\"}.mdi-mixcloud:before{content:\"\\F62A\"}.mdi-monitor:before{content:\"\\F379\"}.mdi-monitor-multiple:before{content:\"\\F37A\"}.mdi-more:before{content:\"\\F37B\"}.mdi-motorbike:before{content:\"\\F37C\"}.mdi-mouse:before{content:\"\\F37D\"}.mdi-mouse-off:before{content:\"\\F37E\"}.mdi-mouse-variant:before{content:\"\\F37F\"}.mdi-mouse-variant-off:before{content:\"\\F380\"}.mdi-move-resize:before{content:\"\\F655\"}.mdi-move-resize-variant:before{content:\"\\F656\"}.mdi-movie:before{content:\"\\F381\"}.mdi-multiplication:before{content:\"\\F382\"}.mdi-multiplication-box:before{content:\"\\F383\"}.mdi-music:before{content:\"\\F759\"}.mdi-music-box:before{content:\"\\F384\"}.mdi-music-box-outline:before{content:\"\\F385\"}.mdi-music-circle:before{content:\"\\F386\"}.mdi-music-note:before{content:\"\\F387\"}.mdi-music-note-bluetooth:before{content:\"\\F5FE\"}.mdi-music-note-bluetooth-off:before{content:\"\\F5FF\"}.mdi-music-note-eighth:before{content:\"\\F388\"}.mdi-music-note-half:before{content:\"\\F389\"}.mdi-music-note-off:before{content:\"\\F38A\"}.mdi-music-note-quarter:before{content:\"\\F38B\"}.mdi-music-note-sixteenth:before{content:\"\\F38C\"}.mdi-music-note-whole:before{content:\"\\F38D\"}.mdi-music-off:before{content:\"\\F75A\"}.mdi-nature:before{content:\"\\F38E\"}.mdi-nature-people:before{content:\"\\F38F\"}.mdi-navigation:before{content:\"\\F390\"}.mdi-near-me:before{content:\"\\F5CD\"}.mdi-needle:before{content:\"\\F391\"}.mdi-nest-protect:before{content:\"\\F392\"}.mdi-nest-thermostat:before{content:\"\\F393\"}.mdi-netflix:before{content:\"\\F745\"}.mdi-network:before{content:\"\\F6F2\"}.mdi-new-box:before{content:\"\\F394\"}.mdi-newspaper:before{content:\"\\F395\"}.mdi-nfc:before{content:\"\\F396\"}.mdi-nfc-tap:before{content:\"\\F397\"}.mdi-nfc-variant:before{content:\"\\F398\"}.mdi-ninja:before{content:\"\\F773\"}.mdi-nodejs:before{content:\"\\F399\"}.mdi-note:before{content:\"\\F39A\"}.mdi-note-multiple:before{content:\"\\F6B7\"}.mdi-note-multiple-outline:before{content:\"\\F6B8\"}.mdi-note-outline:before{content:\"\\F39B\"}.mdi-note-plus:before{content:\"\\F39C\"}.mdi-note-plus-outline:before{content:\"\\F39D\"}.mdi-note-text:before{content:\"\\F39E\"}.mdi-notification-clear-all:before{content:\"\\F39F\"}.mdi-npm:before{content:\"\\F6F6\"}.mdi-nuke:before{content:\"\\F6A3\"}.mdi-numeric:before{content:\"\\F3A0\"}.mdi-numeric-0-box:before{content:\"\\F3A1\"}.mdi-numeric-0-box-multiple-outline:before{content:\"\\F3A2\"}.mdi-numeric-0-box-outline:before{content:\"\\F3A3\"}.mdi-numeric-1-box:before{content:\"\\F3A4\"}.mdi-numeric-1-box-multiple-outline:before{content:\"\\F3A5\"}.mdi-numeric-1-box-outline:before{content:\"\\F3A6\"}.mdi-numeric-2-box:before{content:\"\\F3A7\"}.mdi-numeric-2-box-multiple-outline:before{content:\"\\F3A8\"}.mdi-numeric-2-box-outline:before{content:\"\\F3A9\"}.mdi-numeric-3-box:before{content:\"\\F3AA\"}.mdi-numeric-3-box-multiple-outline:before{content:\"\\F3AB\"}.mdi-numeric-3-box-outline:before{content:\"\\F3AC\"}.mdi-numeric-4-box:before{content:\"\\F3AD\"}.mdi-numeric-4-box-multiple-outline:before{content:\"\\F3AE\"}.mdi-numeric-4-box-outline:before{content:\"\\F3AF\"}.mdi-numeric-5-box:before{content:\"\\F3B0\"}.mdi-numeric-5-box-multiple-outline:before{content:\"\\F3B1\"}.mdi-numeric-5-box-outline:before{content:\"\\F3B2\"}.mdi-numeric-6-box:before{content:\"\\F3B3\"}.mdi-numeric-6-box-multiple-outline:before{content:\"\\F3B4\"}.mdi-numeric-6-box-outline:before{content:\"\\F3B5\"}.mdi-numeric-7-box:before{content:\"\\F3B6\"}.mdi-numeric-7-box-multiple-outline:before{content:\"\\F3B7\"}.mdi-numeric-7-box-outline:before{content:\"\\F3B8\"}.mdi-numeric-8-box:before{content:\"\\F3B9\"}.mdi-numeric-8-box-multiple-outline:before{content:\"\\F3BA\"}.mdi-numeric-8-box-outline:before{content:\"\\F3BB\"}.mdi-numeric-9-box:before{content:\"\\F3BC\"}.mdi-numeric-9-box-multiple-outline:before{content:\"\\F3BD\"}.mdi-numeric-9-box-outline:before{content:\"\\F3BE\"}.mdi-numeric-9-plus-box:before{content:\"\\F3BF\"}.mdi-numeric-9-plus-box-multiple-outline:before{content:\"\\F3C0\"}.mdi-numeric-9-plus-box-outline:before{content:\"\\F3C1\"}.mdi-nut:before{content:\"\\F6F7\"}.mdi-nutrition:before{content:\"\\F3C2\"}.mdi-oar:before{content:\"\\F67B\"}.mdi-octagon:before{content:\"\\F3C3\"}.mdi-octagon-outline:before{content:\"\\F3C4\"}.mdi-octagram:before{content:\"\\F6F8\"}.mdi-octagram-outline:before{content:\"\\F774\"}.mdi-odnoklassniki:before{content:\"\\F3C5\"}.mdi-office:before{content:\"\\F3C6\"}.mdi-oil:before{content:\"\\F3C7\"}.mdi-oil-temperature:before{content:\"\\F3C8\"}.mdi-omega:before{content:\"\\F3C9\"}.mdi-onedrive:before{content:\"\\F3CA\"}.mdi-onenote:before{content:\"\\F746\"}.mdi-opacity:before{content:\"\\F5CC\"}.mdi-open-in-app:before{content:\"\\F3CB\"}.mdi-open-in-new:before{content:\"\\F3CC\"}.mdi-openid:before{content:\"\\F3CD\"}.mdi-opera:before{content:\"\\F3CE\"}.mdi-orbit:before{content:\"\\F018\"}.mdi-ornament:before{content:\"\\F3CF\"}.mdi-ornament-variant:before{content:\"\\F3D0\"}.mdi-owl:before{content:\"\\F3D2\"}.mdi-package:before{content:\"\\F3D3\"}.mdi-package-down:before{content:\"\\F3D4\"}.mdi-package-up:before{content:\"\\F3D5\"}.mdi-package-variant:before{content:\"\\F3D6\"}.mdi-package-variant-closed:before{content:\"\\F3D7\"}.mdi-page-first:before{content:\"\\F600\"}.mdi-page-last:before{content:\"\\F601\"}.mdi-page-layout-body:before{content:\"\\F6F9\"}.mdi-page-layout-footer:before{content:\"\\F6FA\"}.mdi-page-layout-header:before{content:\"\\F6FB\"}.mdi-page-layout-sidebar-left:before{content:\"\\F6FC\"}.mdi-page-layout-sidebar-right:before{content:\"\\F6FD\"}.mdi-palette:before{content:\"\\F3D8\"}.mdi-palette-advanced:before{content:\"\\F3D9\"}.mdi-panda:before{content:\"\\F3DA\"}.mdi-pandora:before{content:\"\\F3DB\"}.mdi-panorama:before{content:\"\\F3DC\"}.mdi-panorama-fisheye:before{content:\"\\F3DD\"}.mdi-panorama-horizontal:before{content:\"\\F3DE\"}.mdi-panorama-vertical:before{content:\"\\F3DF\"}.mdi-panorama-wide-angle:before{content:\"\\F3E0\"}.mdi-paper-cut-vertical:before{content:\"\\F3E1\"}.mdi-paperclip:before{content:\"\\F3E2\"}.mdi-parking:before{content:\"\\F3E3\"}.mdi-pause:before{content:\"\\F3E4\"}.mdi-pause-circle:before{content:\"\\F3E5\"}.mdi-pause-circle-outline:before{content:\"\\F3E6\"}.mdi-pause-octagon:before{content:\"\\F3E7\"}.mdi-pause-octagon-outline:before{content:\"\\F3E8\"}.mdi-paw:before{content:\"\\F3E9\"}.mdi-paw-off:before{content:\"\\F657\"}.mdi-pen:before{content:\"\\F3EA\"}.mdi-pencil:before{content:\"\\F3EB\"}.mdi-pencil-box:before{content:\"\\F3EC\"}.mdi-pencil-box-outline:before{content:\"\\F3ED\"}.mdi-pencil-circle:before{content:\"\\F6FE\"}.mdi-pencil-circle-outline:before{content:\"\\F775\"}.mdi-pencil-lock:before{content:\"\\F3EE\"}.mdi-pencil-off:before{content:\"\\F3EF\"}.mdi-pentagon:before{content:\"\\F6FF\"}.mdi-pentagon-outline:before{content:\"\\F700\"}.mdi-percent:before{content:\"\\F3F0\"}.mdi-periscope:before{content:\"\\F747\"}.mdi-pharmacy:before{content:\"\\F3F1\"}.mdi-phone:before{content:\"\\F3F2\"}.mdi-phone-bluetooth:before{content:\"\\F3F3\"}.mdi-phone-classic:before{content:\"\\F602\"}.mdi-phone-forward:before{content:\"\\F3F4\"}.mdi-phone-hangup:before{content:\"\\F3F5\"}.mdi-phone-in-talk:before{content:\"\\F3F6\"}.mdi-phone-incoming:before{content:\"\\F3F7\"}.mdi-phone-locked:before{content:\"\\F3F8\"}.mdi-phone-log:before{content:\"\\F3F9\"}.mdi-phone-minus:before{content:\"\\F658\"}.mdi-phone-missed:before{content:\"\\F3FA\"}.mdi-phone-outgoing:before{content:\"\\F3FB\"}.mdi-phone-paused:before{content:\"\\F3FC\"}.mdi-phone-plus:before{content:\"\\F659\"}.mdi-phone-settings:before{content:\"\\F3FD\"}.mdi-phone-voip:before{content:\"\\F3FE\"}.mdi-pi:before{content:\"\\F3FF\"}.mdi-pi-box:before{content:\"\\F400\"}.mdi-piano:before{content:\"\\F67C\"}.mdi-pig:before{content:\"\\F401\"}.mdi-pill:before{content:\"\\F402\"}.mdi-pillar:before{content:\"\\F701\"}.mdi-pin:before{content:\"\\F403\"}.mdi-pin-off:before{content:\"\\F404\"}.mdi-pine-tree:before{content:\"\\F405\"}.mdi-pine-tree-box:before{content:\"\\F406\"}.mdi-pinterest:before{content:\"\\F407\"}.mdi-pinterest-box:before{content:\"\\F408\"}.mdi-pistol:before{content:\"\\F702\"}.mdi-pizza:before{content:\"\\F409\"}.mdi-plane-shield:before{content:\"\\F6BA\"}.mdi-play:before{content:\"\\F40A\"}.mdi-play-box-outline:before{content:\"\\F40B\"}.mdi-play-circle:before{content:\"\\F40C\"}.mdi-play-circle-outline:before{content:\"\\F40D\"}.mdi-play-pause:before{content:\"\\F40E\"}.mdi-play-protected-content:before{content:\"\\F40F\"}.mdi-playlist-check:before{content:\"\\F5C7\"}.mdi-playlist-minus:before{content:\"\\F410\"}.mdi-playlist-play:before{content:\"\\F411\"}.mdi-playlist-plus:before{content:\"\\F412\"}.mdi-playlist-remove:before{content:\"\\F413\"}.mdi-playstation:before{content:\"\\F414\"}.mdi-plex:before{content:\"\\F6B9\"}.mdi-plus:before{content:\"\\F415\"}.mdi-plus-box:before{content:\"\\F416\"}.mdi-plus-box-outline:before{content:\"\\F703\"}.mdi-plus-circle:before{content:\"\\F417\"}.mdi-plus-circle-multiple-outline:before{content:\"\\F418\"}.mdi-plus-circle-outline:before{content:\"\\F419\"}.mdi-plus-network:before{content:\"\\F41A\"}.mdi-plus-one:before{content:\"\\F41B\"}.mdi-plus-outline:before{content:\"\\F704\"}.mdi-pocket:before{content:\"\\F41C\"}.mdi-pokeball:before{content:\"\\F41D\"}.mdi-polaroid:before{content:\"\\F41E\"}.mdi-poll:before{content:\"\\F41F\"}.mdi-poll-box:before{content:\"\\F420\"}.mdi-polymer:before{content:\"\\F421\"}.mdi-pool:before{content:\"\\F606\"}.mdi-popcorn:before{content:\"\\F422\"}.mdi-pot:before{content:\"\\F65A\"}.mdi-pot-mix:before{content:\"\\F65B\"}.mdi-pound:before{content:\"\\F423\"}.mdi-pound-box:before{content:\"\\F424\"}.mdi-power:before{content:\"\\F425\"}.mdi-power-plug:before{content:\"\\F6A4\"}.mdi-power-plug-off:before{content:\"\\F6A5\"}.mdi-power-settings:before{content:\"\\F426\"}.mdi-power-socket:before{content:\"\\F427\"}.mdi-prescription:before{content:\"\\F705\"}.mdi-presentation:before{content:\"\\F428\"}.mdi-presentation-play:before{content:\"\\F429\"}.mdi-printer:before{content:\"\\F42A\"}.mdi-printer-3d:before{content:\"\\F42B\"}.mdi-printer-alert:before{content:\"\\F42C\"}.mdi-printer-settings:before{content:\"\\F706\"}.mdi-priority-high:before{content:\"\\F603\"}.mdi-priority-low:before{content:\"\\F604\"}.mdi-professional-hexagon:before{content:\"\\F42D\"}.mdi-projector:before{content:\"\\F42E\"}.mdi-projector-screen:before{content:\"\\F42F\"}.mdi-publish:before{content:\"\\F6A6\"}.mdi-pulse:before{content:\"\\F430\"}.mdi-puzzle:before{content:\"\\F431\"}.mdi-qqchat:before{content:\"\\F605\"}.mdi-qrcode:before{content:\"\\F432\"}.mdi-qrcode-scan:before{content:\"\\F433\"}.mdi-quadcopter:before{content:\"\\F434\"}.mdi-quality-high:before{content:\"\\F435\"}.mdi-quicktime:before{content:\"\\F436\"}.mdi-radar:before{content:\"\\F437\"}.mdi-radiator:before{content:\"\\F438\"}.mdi-radio:before{content:\"\\F439\"}.mdi-radio-handheld:before{content:\"\\F43A\"}.mdi-radio-tower:before{content:\"\\F43B\"}.mdi-radioactive:before{content:\"\\F43C\"}.mdi-radiobox-blank:before{content:\"\\F43D\"}.mdi-radiobox-marked:before{content:\"\\F43E\"}.mdi-raspberrypi:before{content:\"\\F43F\"}.mdi-ray-end:before{content:\"\\F440\"}.mdi-ray-end-arrow:before{content:\"\\F441\"}.mdi-ray-start:before{content:\"\\F442\"}.mdi-ray-start-arrow:before{content:\"\\F443\"}.mdi-ray-start-end:before{content:\"\\F444\"}.mdi-ray-vertex:before{content:\"\\F445\"}.mdi-rdio:before{content:\"\\F446\"}.mdi-react:before{content:\"\\F707\"}.mdi-read:before{content:\"\\F447\"}.mdi-readability:before{content:\"\\F448\"}.mdi-receipt:before{content:\"\\F449\"}.mdi-record:before{content:\"\\F44A\"}.mdi-record-rec:before{content:\"\\F44B\"}.mdi-recycle:before{content:\"\\F44C\"}.mdi-reddit:before{content:\"\\F44D\"}.mdi-redo:before{content:\"\\F44E\"}.mdi-redo-variant:before{content:\"\\F44F\"}.mdi-refresh:before{content:\"\\F450\"}.mdi-regex:before{content:\"\\F451\"}.mdi-relative-scale:before{content:\"\\F452\"}.mdi-reload:before{content:\"\\F453\"}.mdi-remote:before{content:\"\\F454\"}.mdi-rename-box:before{content:\"\\F455\"}.mdi-reorder-horizontal:before{content:\"\\F687\"}.mdi-reorder-vertical:before{content:\"\\F688\"}.mdi-repeat:before{content:\"\\F456\"}.mdi-repeat-off:before{content:\"\\F457\"}.mdi-repeat-once:before{content:\"\\F458\"}.mdi-replay:before{content:\"\\F459\"}.mdi-reply:before{content:\"\\F45A\"}.mdi-reply-all:before{content:\"\\F45B\"}.mdi-reproduction:before{content:\"\\F45C\"}.mdi-resize-bottom-right:before{content:\"\\F45D\"}.mdi-responsive:before{content:\"\\F45E\"}.mdi-restart:before{content:\"\\F708\"}.mdi-restore:before{content:\"\\F6A7\"}.mdi-rewind:before{content:\"\\F45F\"}.mdi-rewind-outline:before{content:\"\\F709\"}.mdi-rhombus:before{content:\"\\F70A\"}.mdi-rhombus-outline:before{content:\"\\F70B\"}.mdi-ribbon:before{content:\"\\F460\"}.mdi-road:before{content:\"\\F461\"}.mdi-road-variant:before{content:\"\\F462\"}.mdi-robot:before{content:\"\\F6A8\"}.mdi-rocket:before{content:\"\\F463\"}.mdi-roomba:before{content:\"\\F70C\"}.mdi-rotate-3d:before{content:\"\\F464\"}.mdi-rotate-left:before{content:\"\\F465\"}.mdi-rotate-left-variant:before{content:\"\\F466\"}.mdi-rotate-right:before{content:\"\\F467\"}.mdi-rotate-right-variant:before{content:\"\\F468\"}.mdi-rounded-corner:before{content:\"\\F607\"}.mdi-router-wireless:before{content:\"\\F469\"}.mdi-routes:before{content:\"\\F46A\"}.mdi-rowing:before{content:\"\\F608\"}.mdi-rss:before{content:\"\\F46B\"}.mdi-rss-box:before{content:\"\\F46C\"}.mdi-ruler:before{content:\"\\F46D\"}.mdi-run:before{content:\"\\F70D\"}.mdi-run-fast:before{content:\"\\F46E\"}.mdi-sale:before{content:\"\\F46F\"}.mdi-satellite:before{content:\"\\F470\"}.mdi-satellite-variant:before{content:\"\\F471\"}.mdi-saxophone:before{content:\"\\F609\"}.mdi-scale:before{content:\"\\F472\"}.mdi-scale-balance:before{content:\"\\F5D1\"}.mdi-scale-bathroom:before{content:\"\\F473\"}.mdi-scanner:before{content:\"\\F6AA\"}.mdi-school:before{content:\"\\F474\"}.mdi-screen-rotation:before{content:\"\\F475\"}.mdi-screen-rotation-lock:before{content:\"\\F476\"}.mdi-screwdriver:before{content:\"\\F477\"}.mdi-script:before{content:\"\\F478\"}.mdi-sd:before{content:\"\\F479\"}.mdi-seal:before{content:\"\\F47A\"}.mdi-search-web:before{content:\"\\F70E\"}.mdi-seat-flat:before{content:\"\\F47B\"}.mdi-seat-flat-angled:before{content:\"\\F47C\"}.mdi-seat-individual-suite:before{content:\"\\F47D\"}.mdi-seat-legroom-extra:before{content:\"\\F47E\"}.mdi-seat-legroom-normal:before{content:\"\\F47F\"}.mdi-seat-legroom-reduced:before{content:\"\\F480\"}.mdi-seat-recline-extra:before{content:\"\\F481\"}.mdi-seat-recline-normal:before{content:\"\\F482\"}.mdi-security:before{content:\"\\F483\"}.mdi-security-home:before{content:\"\\F689\"}.mdi-security-network:before{content:\"\\F484\"}.mdi-select:before{content:\"\\F485\"}.mdi-select-all:before{content:\"\\F486\"}.mdi-select-inverse:before{content:\"\\F487\"}.mdi-select-off:before{content:\"\\F488\"}.mdi-selection:before{content:\"\\F489\"}.mdi-selection-off:before{content:\"\\F776\"}.mdi-send:before{content:\"\\F48A\"}.mdi-serial-port:before{content:\"\\F65C\"}.mdi-server:before{content:\"\\F48B\"}.mdi-server-minus:before{content:\"\\F48C\"}.mdi-server-network:before{content:\"\\F48D\"}.mdi-server-network-off:before{content:\"\\F48E\"}.mdi-server-off:before{content:\"\\F48F\"}.mdi-server-plus:before{content:\"\\F490\"}.mdi-server-remove:before{content:\"\\F491\"}.mdi-server-security:before{content:\"\\F492\"}.mdi-set-all:before{content:\"\\F777\"}.mdi-set-center:before{content:\"\\F778\"}.mdi-set-center-right:before{content:\"\\F779\"}.mdi-set-left:before{content:\"\\F77A\"}.mdi-set-left-center:before{content:\"\\F77B\"}.mdi-set-left-right:before{content:\"\\F77C\"}.mdi-set-none:before{content:\"\\F77D\"}.mdi-set-right:before{content:\"\\F77E\"}.mdi-settings:before{content:\"\\F493\"}.mdi-settings-box:before{content:\"\\F494\"}.mdi-shape-circle-plus:before{content:\"\\F65D\"}.mdi-shape-plus:before{content:\"\\F495\"}.mdi-shape-polygon-plus:before{content:\"\\F65E\"}.mdi-shape-rectangle-plus:before{content:\"\\F65F\"}.mdi-shape-square-plus:before{content:\"\\F660\"}.mdi-share:before{content:\"\\F496\"}.mdi-share-variant:before{content:\"\\F497\"}.mdi-shield:before{content:\"\\F498\"}.mdi-shield-half-full:before{content:\"\\F77F\"}.mdi-shield-outline:before{content:\"\\F499\"}.mdi-shopping:before{content:\"\\F49A\"}.mdi-shopping-music:before{content:\"\\F49B\"}.mdi-shovel:before{content:\"\\F70F\"}.mdi-shovel-off:before{content:\"\\F710\"}.mdi-shredder:before{content:\"\\F49C\"}.mdi-shuffle:before{content:\"\\F49D\"}.mdi-shuffle-disabled:before{content:\"\\F49E\"}.mdi-shuffle-variant:before{content:\"\\F49F\"}.mdi-sigma:before{content:\"\\F4A0\"}.mdi-sigma-lower:before{content:\"\\F62B\"}.mdi-sign-caution:before{content:\"\\F4A1\"}.mdi-sign-direction:before{content:\"\\F780\"}.mdi-sign-text:before{content:\"\\F781\"}.mdi-signal:before{content:\"\\F4A2\"}.mdi-signal-2g:before{content:\"\\F711\"}.mdi-signal-3g:before{content:\"\\F712\"}.mdi-signal-4g:before{content:\"\\F713\"}.mdi-signal-hspa:before{content:\"\\F714\"}.mdi-signal-hspa-plus:before{content:\"\\F715\"}.mdi-signal-off:before{content:\"\\F782\"}.mdi-signal-variant:before{content:\"\\F60A\"}.mdi-silverware:before{content:\"\\F4A3\"}.mdi-silverware-fork:before{content:\"\\F4A4\"}.mdi-silverware-spoon:before{content:\"\\F4A5\"}.mdi-silverware-variant:before{content:\"\\F4A6\"}.mdi-sim:before{content:\"\\F4A7\"}.mdi-sim-alert:before{content:\"\\F4A8\"}.mdi-sim-off:before{content:\"\\F4A9\"}.mdi-sitemap:before{content:\"\\F4AA\"}.mdi-skip-backward:before{content:\"\\F4AB\"}.mdi-skip-forward:before{content:\"\\F4AC\"}.mdi-skip-next:before{content:\"\\F4AD\"}.mdi-skip-next-circle:before{content:\"\\F661\"}.mdi-skip-next-circle-outline:before{content:\"\\F662\"}.mdi-skip-previous:before{content:\"\\F4AE\"}.mdi-skip-previous-circle:before{content:\"\\F663\"}.mdi-skip-previous-circle-outline:before{content:\"\\F664\"}.mdi-skull:before{content:\"\\F68B\"}.mdi-skype:before{content:\"\\F4AF\"}.mdi-skype-business:before{content:\"\\F4B0\"}.mdi-slack:before{content:\"\\F4B1\"}.mdi-sleep:before{content:\"\\F4B2\"}.mdi-sleep-off:before{content:\"\\F4B3\"}.mdi-smoking:before{content:\"\\F4B4\"}.mdi-smoking-off:before{content:\"\\F4B5\"}.mdi-snapchat:before{content:\"\\F4B6\"}.mdi-snowflake:before{content:\"\\F716\"}.mdi-snowman:before{content:\"\\F4B7\"}.mdi-soccer:before{content:\"\\F4B8\"}.mdi-sofa:before{content:\"\\F4B9\"}.mdi-solid:before{content:\"\\F68C\"}.mdi-sort:before{content:\"\\F4BA\"}.mdi-sort-alphabetical:before{content:\"\\F4BB\"}.mdi-sort-ascending:before{content:\"\\F4BC\"}.mdi-sort-descending:before{content:\"\\F4BD\"}.mdi-sort-numeric:before{content:\"\\F4BE\"}.mdi-sort-variant:before{content:\"\\F4BF\"}.mdi-soundcloud:before{content:\"\\F4C0\"}.mdi-source-branch:before{content:\"\\F62C\"}.mdi-source-commit:before{content:\"\\F717\"}.mdi-source-commit-end:before{content:\"\\F718\"}.mdi-source-commit-end-local:before{content:\"\\F719\"}.mdi-source-commit-local:before{content:\"\\F71A\"}.mdi-source-commit-next-local:before{content:\"\\F71B\"}.mdi-source-commit-start:before{content:\"\\F71C\"}.mdi-source-commit-start-next-local:before{content:\"\\F71D\"}.mdi-source-fork:before{content:\"\\F4C1\"}.mdi-source-merge:before{content:\"\\F62D\"}.mdi-source-pull:before{content:\"\\F4C2\"}.mdi-speaker:before{content:\"\\F4C3\"}.mdi-speaker-off:before{content:\"\\F4C4\"}.mdi-speaker-wireless:before{content:\"\\F71E\"}.mdi-speedometer:before{content:\"\\F4C5\"}.mdi-spellcheck:before{content:\"\\F4C6\"}.mdi-spotify:before{content:\"\\F4C7\"}.mdi-spotlight:before{content:\"\\F4C8\"}.mdi-spotlight-beam:before{content:\"\\F4C9\"}.mdi-spray:before{content:\"\\F665\"}.mdi-square:before{content:\"\\F763\"}.mdi-square-inc:before{content:\"\\F4CA\"}.mdi-square-inc-cash:before{content:\"\\F4CB\"}.mdi-square-outline:before{content:\"\\F762\"}.mdi-square-root:before{content:\"\\F783\"}.mdi-stackexchange:before{content:\"\\F60B\"}.mdi-stackoverflow:before{content:\"\\F4CC\"}.mdi-stadium:before{content:\"\\F71F\"}.mdi-stairs:before{content:\"\\F4CD\"}.mdi-star:before{content:\"\\F4CE\"}.mdi-star-circle:before{content:\"\\F4CF\"}.mdi-star-half:before{content:\"\\F4D0\"}.mdi-star-off:before{content:\"\\F4D1\"}.mdi-star-outline:before{content:\"\\F4D2\"}.mdi-steam:before{content:\"\\F4D3\"}.mdi-steering:before{content:\"\\F4D4\"}.mdi-step-backward:before{content:\"\\F4D5\"}.mdi-step-backward-2:before{content:\"\\F4D6\"}.mdi-step-forward:before{content:\"\\F4D7\"}.mdi-step-forward-2:before{content:\"\\F4D8\"}.mdi-stethoscope:before{content:\"\\F4D9\"}.mdi-sticker:before{content:\"\\F5D0\"}.mdi-sticker-emoji:before{content:\"\\F784\"}.mdi-stocking:before{content:\"\\F4DA\"}.mdi-stop:before{content:\"\\F4DB\"}.mdi-stop-circle:before{content:\"\\F666\"}.mdi-stop-circle-outline:before{content:\"\\F667\"}.mdi-store:before{content:\"\\F4DC\"}.mdi-store-24-hour:before{content:\"\\F4DD\"}.mdi-stove:before{content:\"\\F4DE\"}.mdi-subdirectory-arrow-left:before{content:\"\\F60C\"}.mdi-subdirectory-arrow-right:before{content:\"\\F60D\"}.mdi-subway:before{content:\"\\F6AB\"}.mdi-subway-variant:before{content:\"\\F4DF\"}.mdi-summit:before{content:\"\\F785\"}.mdi-sunglasses:before{content:\"\\F4E0\"}.mdi-surround-sound:before{content:\"\\F5C5\"}.mdi-svg:before{content:\"\\F720\"}.mdi-swap-horizontal:before{content:\"\\F4E1\"}.mdi-swap-vertical:before{content:\"\\F4E2\"}.mdi-swim:before{content:\"\\F4E3\"}.mdi-switch:before{content:\"\\F4E4\"}.mdi-sword:before{content:\"\\F4E5\"}.mdi-sword-cross:before{content:\"\\F786\"}.mdi-sync:before{content:\"\\F4E6\"}.mdi-sync-alert:before{content:\"\\F4E7\"}.mdi-sync-off:before{content:\"\\F4E8\"}.mdi-tab:before{content:\"\\F4E9\"}.mdi-tab-plus:before{content:\"\\F75B\"}.mdi-tab-unselected:before{content:\"\\F4EA\"}.mdi-table:before{content:\"\\F4EB\"}.mdi-table-column-plus-after:before{content:\"\\F4EC\"}.mdi-table-column-plus-before:before{content:\"\\F4ED\"}.mdi-table-column-remove:before{content:\"\\F4EE\"}.mdi-table-column-width:before{content:\"\\F4EF\"}.mdi-table-edit:before{content:\"\\F4F0\"}.mdi-table-large:before{content:\"\\F4F1\"}.mdi-table-row-height:before{content:\"\\F4F2\"}.mdi-table-row-plus-after:before{content:\"\\F4F3\"}.mdi-table-row-plus-before:before{content:\"\\F4F4\"}.mdi-table-row-remove:before{content:\"\\F4F5\"}.mdi-tablet:before{content:\"\\F4F6\"}.mdi-tablet-android:before{content:\"\\F4F7\"}.mdi-tablet-ipad:before{content:\"\\F4F8\"}.mdi-taco:before{content:\"\\F761\"}.mdi-tag:before{content:\"\\F4F9\"}.mdi-tag-faces:before{content:\"\\F4FA\"}.mdi-tag-heart:before{content:\"\\F68A\"}.mdi-tag-multiple:before{content:\"\\F4FB\"}.mdi-tag-outline:before{content:\"\\F4FC\"}.mdi-tag-plus:before{content:\"\\F721\"}.mdi-tag-remove:before{content:\"\\F722\"}.mdi-tag-text-outline:before{content:\"\\F4FD\"}.mdi-target:before{content:\"\\F4FE\"}.mdi-taxi:before{content:\"\\F4FF\"}.mdi-teamviewer:before{content:\"\\F500\"}.mdi-telegram:before{content:\"\\F501\"}.mdi-television:before{content:\"\\F502\"}.mdi-television-guide:before{content:\"\\F503\"}.mdi-temperature-celsius:before{content:\"\\F504\"}.mdi-temperature-fahrenheit:before{content:\"\\F505\"}.mdi-temperature-kelvin:before{content:\"\\F506\"}.mdi-tennis:before{content:\"\\F507\"}.mdi-tent:before{content:\"\\F508\"}.mdi-terrain:before{content:\"\\F509\"}.mdi-test-tube:before{content:\"\\F668\"}.mdi-text-shadow:before{content:\"\\F669\"}.mdi-text-to-speech:before{content:\"\\F50A\"}.mdi-text-to-speech-off:before{content:\"\\F50B\"}.mdi-textbox:before{content:\"\\F60E\"}.mdi-texture:before{content:\"\\F50C\"}.mdi-theater:before{content:\"\\F50D\"}.mdi-theme-light-dark:before{content:\"\\F50E\"}.mdi-thermometer:before{content:\"\\F50F\"}.mdi-thermometer-lines:before{content:\"\\F510\"}.mdi-thumb-down:before{content:\"\\F511\"}.mdi-thumb-down-outline:before{content:\"\\F512\"}.mdi-thumb-up:before{content:\"\\F513\"}.mdi-thumb-up-outline:before{content:\"\\F514\"}.mdi-thumbs-up-down:before{content:\"\\F515\"}.mdi-ticket:before{content:\"\\F516\"}.mdi-ticket-account:before{content:\"\\F517\"}.mdi-ticket-confirmation:before{content:\"\\F518\"}.mdi-ticket-percent:before{content:\"\\F723\"}.mdi-tie:before{content:\"\\F519\"}.mdi-tilde:before{content:\"\\F724\"}.mdi-timelapse:before{content:\"\\F51A\"}.mdi-timer:before{content:\"\\F51B\"}.mdi-timer-10:before{content:\"\\F51C\"}.mdi-timer-3:before{content:\"\\F51D\"}.mdi-timer-off:before{content:\"\\F51E\"}.mdi-timer-sand:before{content:\"\\F51F\"}.mdi-timer-sand-empty:before{content:\"\\F6AC\"}.mdi-timer-sand-full:before{content:\"\\F78B\"}.mdi-timetable:before{content:\"\\F520\"}.mdi-toggle-switch:before{content:\"\\F521\"}.mdi-toggle-switch-off:before{content:\"\\F522\"}.mdi-tooltip:before{content:\"\\F523\"}.mdi-tooltip-edit:before{content:\"\\F524\"}.mdi-tooltip-image:before{content:\"\\F525\"}.mdi-tooltip-outline:before{content:\"\\F526\"}.mdi-tooltip-outline-plus:before{content:\"\\F527\"}.mdi-tooltip-text:before{content:\"\\F528\"}.mdi-tooth:before{content:\"\\F529\"}.mdi-tor:before{content:\"\\F52A\"}.mdi-tower-beach:before{content:\"\\F680\"}.mdi-tower-fire:before{content:\"\\F681\"}.mdi-traffic-light:before{content:\"\\F52B\"}.mdi-train:before{content:\"\\F52C\"}.mdi-tram:before{content:\"\\F52D\"}.mdi-transcribe:before{content:\"\\F52E\"}.mdi-transcribe-close:before{content:\"\\F52F\"}.mdi-transfer:before{content:\"\\F530\"}.mdi-transit-transfer:before{content:\"\\F6AD\"}.mdi-translate:before{content:\"\\F5CA\"}.mdi-treasure-chest:before{content:\"\\F725\"}.mdi-tree:before{content:\"\\F531\"}.mdi-trello:before{content:\"\\F532\"}.mdi-trending-down:before{content:\"\\F533\"}.mdi-trending-neutral:before{content:\"\\F534\"}.mdi-trending-up:before{content:\"\\F535\"}.mdi-triangle:before{content:\"\\F536\"}.mdi-triangle-outline:before{content:\"\\F537\"}.mdi-trophy:before{content:\"\\F538\"}.mdi-trophy-award:before{content:\"\\F539\"}.mdi-trophy-outline:before{content:\"\\F53A\"}.mdi-trophy-variant:before{content:\"\\F53B\"}.mdi-trophy-variant-outline:before{content:\"\\F53C\"}.mdi-truck:before{content:\"\\F53D\"}.mdi-truck-delivery:before{content:\"\\F53E\"}.mdi-truck-fast:before{content:\"\\F787\"}.mdi-truck-trailer:before{content:\"\\F726\"}.mdi-tshirt-crew:before{content:\"\\F53F\"}.mdi-tshirt-v:before{content:\"\\F540\"}.mdi-tumblr:before{content:\"\\F541\"}.mdi-tumblr-reblog:before{content:\"\\F542\"}.mdi-tune:before{content:\"\\F62E\"}.mdi-tune-vertical:before{content:\"\\F66A\"}.mdi-twitch:before{content:\"\\F543\"}.mdi-twitter:before{content:\"\\F544\"}.mdi-twitter-box:before{content:\"\\F545\"}.mdi-twitter-circle:before{content:\"\\F546\"}.mdi-twitter-retweet:before{content:\"\\F547\"}.mdi-uber:before{content:\"\\F748\"}.mdi-ubuntu:before{content:\"\\F548\"}.mdi-umbraco:before{content:\"\\F549\"}.mdi-umbrella:before{content:\"\\F54A\"}.mdi-umbrella-outline:before{content:\"\\F54B\"}.mdi-undo:before{content:\"\\F54C\"}.mdi-undo-variant:before{content:\"\\F54D\"}.mdi-unfold-less-horizontal:before{content:\"\\F54E\"}.mdi-unfold-less-vertical:before{content:\"\\F75F\"}.mdi-unfold-more-horizontal:before{content:\"\\F54F\"}.mdi-unfold-more-vertical:before{content:\"\\F760\"}.mdi-ungroup:before{content:\"\\F550\"}.mdi-unity:before{content:\"\\F6AE\"}.mdi-untappd:before{content:\"\\F551\"}.mdi-update:before{content:\"\\F6AF\"}.mdi-upload:before{content:\"\\F552\"}.mdi-upload-network:before{content:\"\\F6F5\"}.mdi-usb:before{content:\"\\F553\"}.mdi-vector-arrange-above:before{content:\"\\F554\"}.mdi-vector-arrange-below:before{content:\"\\F555\"}.mdi-vector-circle:before{content:\"\\F556\"}.mdi-vector-circle-variant:before{content:\"\\F557\"}.mdi-vector-combine:before{content:\"\\F558\"}.mdi-vector-curve:before{content:\"\\F559\"}.mdi-vector-difference:before{content:\"\\F55A\"}.mdi-vector-difference-ab:before{content:\"\\F55B\"}.mdi-vector-difference-ba:before{content:\"\\F55C\"}.mdi-vector-intersection:before{content:\"\\F55D\"}.mdi-vector-line:before{content:\"\\F55E\"}.mdi-vector-point:before{content:\"\\F55F\"}.mdi-vector-polygon:before{content:\"\\F560\"}.mdi-vector-polyline:before{content:\"\\F561\"}.mdi-vector-radius:before{content:\"\\F749\"}.mdi-vector-rectangle:before{content:\"\\F5C6\"}.mdi-vector-selection:before{content:\"\\F562\"}.mdi-vector-square:before{content:\"\\F001\"}.mdi-vector-triangle:before{content:\"\\F563\"}.mdi-vector-union:before{content:\"\\F564\"}.mdi-verified:before{content:\"\\F565\"}.mdi-vibrate:before{content:\"\\F566\"}.mdi-video:before{content:\"\\F567\"}.mdi-video-off:before{content:\"\\F568\"}.mdi-video-switch:before{content:\"\\F569\"}.mdi-view-agenda:before{content:\"\\F56A\"}.mdi-view-array:before{content:\"\\F56B\"}.mdi-view-carousel:before{content:\"\\F56C\"}.mdi-view-column:before{content:\"\\F56D\"}.mdi-view-dashboard:before{content:\"\\F56E\"}.mdi-view-day:before{content:\"\\F56F\"}.mdi-view-grid:before{content:\"\\F570\"}.mdi-view-headline:before{content:\"\\F571\"}.mdi-view-list:before{content:\"\\F572\"}.mdi-view-module:before{content:\"\\F573\"}.mdi-view-parallel:before{content:\"\\F727\"}.mdi-view-quilt:before{content:\"\\F574\"}.mdi-view-sequential:before{content:\"\\F728\"}.mdi-view-stream:before{content:\"\\F575\"}.mdi-view-week:before{content:\"\\F576\"}.mdi-vimeo:before{content:\"\\F577\"}.mdi-vine:before{content:\"\\F578\"}.mdi-violin:before{content:\"\\F60F\"}.mdi-visualstudio:before{content:\"\\F610\"}.mdi-vk:before{content:\"\\F579\"}.mdi-vk-box:before{content:\"\\F57A\"}.mdi-vk-circle:before{content:\"\\F57B\"}.mdi-vlc:before{content:\"\\F57C\"}.mdi-voice:before{content:\"\\F5CB\"}.mdi-voicemail:before{content:\"\\F57D\"}.mdi-volume-high:before{content:\"\\F57E\"}.mdi-volume-low:before{content:\"\\F57F\"}.mdi-volume-medium:before{content:\"\\F580\"}.mdi-volume-minus:before{content:\"\\F75D\"}.mdi-volume-mute:before{content:\"\\F75E\"}.mdi-volume-off:before{content:\"\\F581\"}.mdi-volume-plus:before{content:\"\\F75C\"}.mdi-vpn:before{content:\"\\F582\"}.mdi-walk:before{content:\"\\F583\"}.mdi-wallet:before{content:\"\\F584\"}.mdi-wallet-giftcard:before{content:\"\\F585\"}.mdi-wallet-membership:before{content:\"\\F586\"}.mdi-wallet-travel:before{content:\"\\F587\"}.mdi-wan:before{content:\"\\F588\"}.mdi-washing-machine:before{content:\"\\F729\"}.mdi-watch:before{content:\"\\F589\"}.mdi-watch-export:before{content:\"\\F58A\"}.mdi-watch-import:before{content:\"\\F58B\"}.mdi-watch-vibrate:before{content:\"\\F6B0\"}.mdi-water:before{content:\"\\F58C\"}.mdi-water-off:before{content:\"\\F58D\"}.mdi-water-percent:before{content:\"\\F58E\"}.mdi-water-pump:before{content:\"\\F58F\"}.mdi-watermark:before{content:\"\\F612\"}.mdi-waves:before{content:\"\\F78C\"}.mdi-weather-cloudy:before{content:\"\\F590\"}.mdi-weather-fog:before{content:\"\\F591\"}.mdi-weather-hail:before{content:\"\\F592\"}.mdi-weather-lightning:before{content:\"\\F593\"}.mdi-weather-lightning-rainy:before{content:\"\\F67D\"}.mdi-weather-night:before{content:\"\\F594\"}.mdi-weather-partlycloudy:before{content:\"\\F595\"}.mdi-weather-pouring:before{content:\"\\F596\"}.mdi-weather-rainy:before{content:\"\\F597\"}.mdi-weather-snowy:before{content:\"\\F598\"}.mdi-weather-snowy-rainy:before{content:\"\\F67E\"}.mdi-weather-sunny:before{content:\"\\F599\"}.mdi-weather-sunset:before{content:\"\\F59A\"}.mdi-weather-sunset-down:before{content:\"\\F59B\"}.mdi-weather-sunset-up:before{content:\"\\F59C\"}.mdi-weather-windy:before{content:\"\\F59D\"}.mdi-weather-windy-variant:before{content:\"\\F59E\"}.mdi-web:before{content:\"\\F59F\"}.mdi-webcam:before{content:\"\\F5A0\"}.mdi-webhook:before{content:\"\\F62F\"}.mdi-webpack:before{content:\"\\F72A\"}.mdi-wechat:before{content:\"\\F611\"}.mdi-weight:before{content:\"\\F5A1\"}.mdi-weight-kilogram:before{content:\"\\F5A2\"}.mdi-whatsapp:before{content:\"\\F5A3\"}.mdi-wheelchair-accessibility:before{content:\"\\F5A4\"}.mdi-white-balance-auto:before{content:\"\\F5A5\"}.mdi-white-balance-incandescent:before{content:\"\\F5A6\"}.mdi-white-balance-iridescent:before{content:\"\\F5A7\"}.mdi-white-balance-sunny:before{content:\"\\F5A8\"}.mdi-widgets:before{content:\"\\F72B\"}.mdi-wifi:before{content:\"\\F5A9\"}.mdi-wifi-off:before{content:\"\\F5AA\"}.mdi-wii:before{content:\"\\F5AB\"}.mdi-wiiu:before{content:\"\\F72C\"}.mdi-wikipedia:before{content:\"\\F5AC\"}.mdi-window-close:before{content:\"\\F5AD\"}.mdi-window-closed:before{content:\"\\F5AE\"}.mdi-window-maximize:before{content:\"\\F5AF\"}.mdi-window-minimize:before{content:\"\\F5B0\"}.mdi-window-open:before{content:\"\\F5B1\"}.mdi-window-restore:before{content:\"\\F5B2\"}.mdi-windows:before{content:\"\\F5B3\"}.mdi-wordpress:before{content:\"\\F5B4\"}.mdi-worker:before{content:\"\\F5B5\"}.mdi-wrap:before{content:\"\\F5B6\"}.mdi-wrench:before{content:\"\\F5B7\"}.mdi-wunderlist:before{content:\"\\F5B8\"}.mdi-xaml:before{content:\"\\F673\"}.mdi-xbox:before{content:\"\\F5B9\"}.mdi-xbox-controller:before{content:\"\\F5BA\"}.mdi-xbox-controller-battery-alert:before{content:\"\\F74A\"}.mdi-xbox-controller-battery-empty:before{content:\"\\F74B\"}.mdi-xbox-controller-battery-full:before{content:\"\\F74C\"}.mdi-xbox-controller-battery-low:before{content:\"\\F74D\"}.mdi-xbox-controller-battery-medium:before{content:\"\\F74E\"}.mdi-xbox-controller-battery-unknown:before{content:\"\\F74F\"}.mdi-xbox-controller-off:before{content:\"\\F5BB\"}.mdi-xda:before{content:\"\\F5BC\"}.mdi-xing:before{content:\"\\F5BD\"}.mdi-xing-box:before{content:\"\\F5BE\"}.mdi-xing-circle:before{content:\"\\F5BF\"}.mdi-xml:before{content:\"\\F5C0\"}.mdi-yammer:before{content:\"\\F788\"}.mdi-yeast:before{content:\"\\F5C1\"}.mdi-yelp:before{content:\"\\F5C2\"}.mdi-yin-yang:before{content:\"\\F67F\"}.mdi-youtube-play:before{content:\"\\F5C3\"}.mdi-zip-box:before{content:\"\\F5C4\"}.mdi-18px.mdi-set,.mdi-18px.mdi:before{font-size:18px}.mdi-24px.mdi-set,.mdi-24px.mdi:before{font-size:24px}.mdi-36px.mdi-set,.mdi-36px.mdi:before{font-size:36px}.mdi-48px.mdi-set,.mdi-48px.mdi:before{font-size:48px}.mdi-dark:before{color:rgba(0,0,0,.54)}.mdi-dark.mdi-inactive:before{color:rgba(0,0,0,.26)}.mdi-light:before{color:#fff}.mdi-light.mdi-inactive:before{color:hsla(0,0%,100%,.3)}.mdi-rotate-45:before{transform:rotate(45deg)}.mdi-rotate-90:before{transform:rotate(90deg)}.mdi-rotate-135:before{transform:rotate(135deg)}.mdi-rotate-180:before{transform:rotate(180deg)}.mdi-rotate-225:before{transform:rotate(225deg)}.mdi-rotate-270:before{transform:rotate(270deg)}.mdi-rotate-315:before{transform:rotate(315deg)}.mdi-flip-h:before{transform:scaleX(-1);filter:FlipH;-ms-filter:\"FlipH\"}.mdi-flip-v:before{transform:scaleY(-1);filter:FlipV;-ms-filter:\"FlipV\"}.mdi-spin:before{animation:mdi-spin 2s infinite linear}@keyframes mdi-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}/*! normalize.css v3.0.2 | MIT License | git.io/normalize */html{font-family:sans-serif}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}blockquote,body,caption,dd,dl,fieldset,figure,form,h1,h2,h3,h4,h5,h6,hr,legend,ol,p,pre,table,td,th,ul{margin:0;padding:0}abbr[title],dfn[title]{cursor:help}ins,u{text-decoration:none}ins{border-bottom:1px solid}html{font-size:1em;line-height:1.5;background-color:#eee;color:rgba(0,0,0,.87);min-height:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}@media screen and (min-width:1024px){[flex-container]{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex}}@media screen and (min-width:1024px){[flex-container=row]{box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row}}@media screen and (min-width:1024px){[flex-container=column]{box-orient:vertical;box-direction:normal;-moz-flex-direction:column;flex-direction:column;-ms-flex-direction:column}}[flex-wrap]{-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap}@media screen and (min-width:1024px){[flex-align=\"center center\"],[flex-align=\"center end\"],[flex-align=\"center start\"],[flex-align=center]{box-pack:center;-moz-justify-content:center;-ms-justify-content:center;-o-justify-content:center;justify-content:center;-ms-flex-pack:center}}@media screen and (min-width:1024px){[flex-align=\"end center\"],[flex-align=\"end end\"],[flex-align=\"end start\"],[flex-align=end]{box-pack:end;-moz-justify-content:flex-end;-ms-justify-content:flex-end;-o-justify-content:flex-end;justify-content:flex-end;-ms-flex-pack:end}}@media screen and (min-width:1024px){[flex-align=\"space-around center\"],[flex-align=\"space-around end\"],[flex-align=\"space-around start\"],[flex-align=space-around]{box-pack:distribute;-moz-justify-content:space-around;-ms-justify-content:space-around;-o-justify-content:space-around;justify-content:space-around;-ms-flex-pack:distribute}}@media screen and (min-width:1024px){[flex-align=\"space-between center\"],[flex-align=\"space-between end\"],[flex-align=\"space-between start\"],[flex-align=space-between]{box-pack:justify;-moz-justify-content:space-between;-ms-justify-content:space-between;-o-justify-content:space-between;justify-content:space-between;-ms-flex-pack:justify}}@media screen and (min-width:1024px){[flex-align=\"center center\"],[flex-align=\"end center\"],[flex-align=\"space-around center\"],[flex-align=\"space-between center\"],[flex-align=\"start center\"]{box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center}}@media screen and (min-width:1024px){[flex-align=\"center start\"],[flex-align=\"end start\"],[flex-align=\"space-around start\"],[flex-align=\"space-between start\"],[flex-align=\"start start\"]{box-align:start;-moz-align-items:flex-start;-ms-align-items:flex-start;-o-align-items:flex-start;align-items:flex-start;-ms-flex-align:start}}@media screen and (min-width:1024px){[flex-align=\"center end\"],[flex-align=\"end end\"],[flex-align=\"space-around end\"],[flex-align=\"space-between end\"],[flex-align=\"start end\"]{box-align:end;-moz-align-items:flex-end;-ms-align-items:flex-end;-o-align-items:flex-end;align-items:flex-end;-ms-flex-align:end}}@media screen and (min-width:1024px){[flex-gutter=\"8\"]{margin:0 -4px}}@media screen and (max-width:1023px){[flex-gutter=\"8\"]>[flex-item]{margin-bottom:8px}}@media screen and (min-width:1024px){[flex-gutter=\"8\"]>[flex-item]{padding:0 4px}}@media screen and (min-width:1024px){[flex-gutter=\"16\"]{margin:0 -8px}}@media screen and (max-width:1023px){[flex-gutter=\"16\"]>[flex-item]{margin-bottom:16px}}@media screen and (min-width:1024px){[flex-gutter=\"16\"]>[flex-item]{padding:0 8px}}@media screen and (min-width:1024px){[flex-gutter=\"24\"]{margin:0 -12px}}@media screen and (max-width:1023px){[flex-gutter=\"24\"]>[flex-item]{margin-bottom:24px}}@media screen and (min-width:1024px){[flex-gutter=\"24\"]>[flex-item]{padding:0 12px}}@media screen and (min-width:1024px){[flex-gutter=\"32\"]{margin:0 -16px}}@media screen and (max-width:1023px){[flex-gutter=\"32\"]>[flex-item]{margin-bottom:32px}}@media screen and (min-width:1024px){[flex-gutter=\"32\"]>[flex-item]{padding:0 16px}}@media screen and (min-width:1024px){[flex-item]{position:relative;box-flex:1;-moz-flex:1;-ms-flex:1;flex:1}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"1\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"1\"]{box-flex:0;-moz-flex:0 0 8.33333%;-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"1\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"1\"]{box-flex:0;-moz-flex:0 0 8.33333%;-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-height:8.33333%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"2\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"2\"]{box-flex:0;-moz-flex:0 0 16.66667%;-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"2\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"2\"]{box-flex:0;-moz-flex:0 0 16.66667%;-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-height:16.66667%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"3\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"3\"]{box-flex:0;-moz-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"3\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"3\"]{box-flex:0;-moz-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-height:25%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"4\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"4\"]{box-flex:0;-moz-flex:0 0 33.33333%;-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"4\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"4\"]{box-flex:0;-moz-flex:0 0 33.33333%;-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-height:33.33333%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"5\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"5\"]{box-flex:0;-moz-flex:0 0 41.66667%;-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"5\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"5\"]{box-flex:0;-moz-flex:0 0 41.66667%;-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-height:41.66667%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"6\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"6\"]{box-flex:0;-moz-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"6\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"6\"]{box-flex:0;-moz-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-height:50%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"7\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"7\"]{box-flex:0;-moz-flex:0 0 58.33333%;-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"7\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"7\"]{box-flex:0;-moz-flex:0 0 58.33333%;-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-height:58.33333%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"8\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"8\"]{box-flex:0;-moz-flex:0 0 66.66667%;-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"8\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"8\"]{box-flex:0;-moz-flex:0 0 66.66667%;-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-height:66.66667%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"9\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"9\"]{box-flex:0;-moz-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"9\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"9\"]{box-flex:0;-moz-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-height:75%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"10\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"10\"]{box-flex:0;-moz-flex:0 0 83.33333%;-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"10\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"10\"]{box-flex:0;-moz-flex:0 0 83.33333%;-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-height:83.33333%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"11\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"11\"]{box-flex:0;-moz-flex:0 0 91.66667%;-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"11\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"11\"]{box-flex:0;-moz-flex:0 0 91.66667%;-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-height:91.66667%}}@media screen and (min-width:1024px){[flex-container=row]>[flex-item=\"12\"],[flex-container=row][flex-column=\"12\"]>[flex-item=\"12\"]{box-flex:0;-moz-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}}@media screen and (min-width:1024px){[flex-container=column]>[flex-item=\"12\"],[flex-container=column][flex-column=\"12\"]>[flex-item=\"12\"]{box-flex:0;-moz-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-height:100%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"1\"]{box-flex:0;-moz-flex:0 0 6.25%;-ms-flex:0 0 6.25%;flex:0 0 6.25%;max-width:6.25%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"1\"]{box-flex:0;-moz-flex:0 0 6.25%;-ms-flex:0 0 6.25%;flex:0 0 6.25%;max-height:6.25%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"2\"]{box-flex:0;-moz-flex:0 0 12.5%;-ms-flex:0 0 12.5%;flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"2\"]{box-flex:0;-moz-flex:0 0 12.5%;-ms-flex:0 0 12.5%;flex:0 0 12.5%;max-height:12.5%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"3\"]{box-flex:0;-moz-flex:0 0 18.75%;-ms-flex:0 0 18.75%;flex:0 0 18.75%;max-width:18.75%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"3\"]{box-flex:0;-moz-flex:0 0 18.75%;-ms-flex:0 0 18.75%;flex:0 0 18.75%;max-height:18.75%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"4\"]{box-flex:0;-moz-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"4\"]{box-flex:0;-moz-flex:0 0 25%;-ms-flex:0 0 25%;flex:0 0 25%;max-height:25%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"5\"]{box-flex:0;-moz-flex:0 0 31.25%;-ms-flex:0 0 31.25%;flex:0 0 31.25%;max-width:31.25%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"5\"]{box-flex:0;-moz-flex:0 0 31.25%;-ms-flex:0 0 31.25%;flex:0 0 31.25%;max-height:31.25%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"6\"]{box-flex:0;-moz-flex:0 0 37.5%;-ms-flex:0 0 37.5%;flex:0 0 37.5%;max-width:37.5%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"6\"]{box-flex:0;-moz-flex:0 0 37.5%;-ms-flex:0 0 37.5%;flex:0 0 37.5%;max-height:37.5%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"7\"]{box-flex:0;-moz-flex:0 0 43.75%;-ms-flex:0 0 43.75%;flex:0 0 43.75%;max-width:43.75%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"7\"]{box-flex:0;-moz-flex:0 0 43.75%;-ms-flex:0 0 43.75%;flex:0 0 43.75%;max-height:43.75%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"8\"]{box-flex:0;-moz-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"8\"]{box-flex:0;-moz-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-height:50%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"9\"]{box-flex:0;-moz-flex:0 0 56.25%;-ms-flex:0 0 56.25%;flex:0 0 56.25%;max-width:56.25%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"9\"]{box-flex:0;-moz-flex:0 0 56.25%;-ms-flex:0 0 56.25%;flex:0 0 56.25%;max-height:56.25%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"10\"]{box-flex:0;-moz-flex:0 0 62.5%;-ms-flex:0 0 62.5%;flex:0 0 62.5%;max-width:62.5%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"10\"]{box-flex:0;-moz-flex:0 0 62.5%;-ms-flex:0 0 62.5%;flex:0 0 62.5%;max-height:62.5%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"11\"]{box-flex:0;-moz-flex:0 0 68.75%;-ms-flex:0 0 68.75%;flex:0 0 68.75%;max-width:68.75%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"11\"]{box-flex:0;-moz-flex:0 0 68.75%;-ms-flex:0 0 68.75%;flex:0 0 68.75%;max-height:68.75%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"12\"]{box-flex:0;-moz-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"12\"]{box-flex:0;-moz-flex:0 0 75%;-ms-flex:0 0 75%;flex:0 0 75%;max-height:75%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"13\"]{box-flex:0;-moz-flex:0 0 81.25%;-ms-flex:0 0 81.25%;flex:0 0 81.25%;max-width:81.25%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"13\"]{box-flex:0;-moz-flex:0 0 81.25%;-ms-flex:0 0 81.25%;flex:0 0 81.25%;max-height:81.25%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"14\"]{box-flex:0;-moz-flex:0 0 87.5%;-ms-flex:0 0 87.5%;flex:0 0 87.5%;max-width:87.5%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"14\"]{box-flex:0;-moz-flex:0 0 87.5%;-ms-flex:0 0 87.5%;flex:0 0 87.5%;max-height:87.5%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"15\"]{box-flex:0;-moz-flex:0 0 93.75%;-ms-flex:0 0 93.75%;flex:0 0 93.75%;max-width:93.75%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"15\"]{box-flex:0;-moz-flex:0 0 93.75%;-ms-flex:0 0 93.75%;flex:0 0 93.75%;max-height:93.75%}}@media screen and (min-width:1024px){[flex-container=row][flex-column=\"16\"]>[flex-item=\"16\"]{box-flex:0;-moz-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}}@media screen and (min-width:1024px){[flex-container=column][flex-column=\"16\"]>[flex-item=\"16\"]{box-flex:0;-moz-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-height:100%}}@media screen and (min-width:1024px){[flex-item-align=center]{align-self:center;-ms-flex-item-align:center}}@media screen and (min-width:1024px){[flex-item-align=start]{align-self:flex-start;-ms-flex-item-align:start}}@media screen and (min-width:1024px){[flex-item-align=end]{align-self:flex-end;-ms-flex-item-align:end}}@media screen and (min-width:1024px){[flex-item-order=\"1\"]{box-ordinal-group:1;-moz-order:1;order:1;-ms-flex-order:1}}@media screen and (min-width:1024px){[flex-item-order=\"2\"]{box-ordinal-group:2;-moz-order:2;order:2;-ms-flex-order:2}}@media screen and (min-width:1024px){[flex-item-order=\"3\"]{box-ordinal-group:3;-moz-order:3;order:3;-ms-flex-order:3}}@media screen and (min-width:1024px){[flex-item-order=\"4\"]{box-ordinal-group:4;-moz-order:4;order:4;-ms-flex-order:4}}@media screen and (min-width:1024px){[flex-item-order=\"5\"]{box-ordinal-group:5;-moz-order:5;order:5;-ms-flex-order:5}}@media screen and (min-width:1024px){[flex-item-order=\"6\"]{box-ordinal-group:6;-moz-order:6;order:6;-ms-flex-order:6}}@media screen and (min-width:1024px){[flex-item-order=\"7\"]{box-ordinal-group:7;-moz-order:7;order:7;-ms-flex-order:7}}@media screen and (min-width:1024px){[flex-item-order=\"8\"]{box-ordinal-group:8;-moz-order:8;order:8;-ms-flex-order:8}}@media screen and (min-width:1024px){[flex-item-order=\"9\"]{box-ordinal-group:9;-moz-order:9;order:9;-ms-flex-order:9}}@media screen and (min-width:1024px){[flex-item-order=\"10\"]{box-ordinal-group:10;-moz-order:10;order:10;-ms-flex-order:10}}@media screen and (min-width:1024px){[flex-item-order=\"11\"]{box-ordinal-group:11;-moz-order:11;order:11;-ms-flex-order:11}}@media screen and (min-width:1024px){[flex-item-order=\"12\"]{box-ordinal-group:12;-moz-order:12;order:12;-ms-flex-order:12}}@media screen and (min-width:1024px){[flex-item-order=\"13\"]{box-ordinal-group:13;-moz-order:13;order:13;-ms-flex-order:13}}@media screen and (min-width:1024px){[flex-item-order=\"14\"]{box-ordinal-group:14;-moz-order:14;order:14;-ms-flex-order:14}}@media screen and (min-width:1024px){[flex-item-order=\"15\"]{box-ordinal-group:15;-moz-order:15;order:15;-ms-flex-order:15}}@media screen and (min-width:1024px){[flex-item-order=\"16\"]{box-ordinal-group:16;-moz-order:16;order:16;-ms-flex-order:16}}img{display:block;max-width:100%;font-style:italic}.gm-style img,img[height],img[width]{max-width:none}.img-round{border-radius:50%}.paragraph address,.paragraph blockquote,.paragraph dl,.paragraph fieldset,.paragraph figure,.paragraph h1,.paragraph h2,.paragraph h3,.paragraph h4,.paragraph h5,.paragraph h6,.paragraph hr,.paragraph iframe,.paragraph ol,.paragraph p,.paragraph pre,.paragraph table,.paragraph ul{margin-bottom:24px}.paragraph address:last-child,.paragraph blockquote:last-child,.paragraph dl:last-child,.paragraph fieldset:last-child,.paragraph figure:last-child,.paragraph h1:last-child,.paragraph h2:last-child,.paragraph h3:last-child,.paragraph h4:last-child,.paragraph h5:last-child,.paragraph h6:last-child,.paragraph hr:last-child,.paragraph iframe:last-child,.paragraph ol:last-child,.paragraph p:last-child,.paragraph pre:last-child,.paragraph table:last-child,.paragraph ul:last-child{margin-bottom:0}.paragraph dd,.paragraph ol,.paragraph ul{margin-left:48px}.paragraph a{text-decoration:none}.paragraph a:hover{text-decoration:underline}.fs-caption{font-size:12px;font-size:.75rem}.fs-body-1,.fs-caption{font-weight:400;line-height:20px}@media screen and (max-width:1023px){.fs-body-1{font-size:14px;font-size:.875rem}}@media screen and (min-width:1024px){.fs-body-1{font-size:13px;font-size:.8125rem}}.fs-body-2{font-weight:500;line-height:24px}@media screen and (max-width:1023px){.fs-body-2{font-size:14px;font-size:.875rem}}@media screen and (min-width:1024px){.fs-body-2{font-size:13px;font-size:.8125rem}}.fs-subhead,.list-subheader{font-weight:400;line-height:24px}@media screen and (max-width:1023px){.fs-subhead,.list-subheader{font-size:16px;font-size:1rem}}@media screen and (min-width:1024px){.fs-subhead,.list-subheader{font-size:15px;font-size:.9375rem}}.fs-title{font-size:20px;font-size:1.25rem;font-weight:500;line-height:28px}.fs-headline{font-size:24px;font-size:1.5rem;font-weight:400;line-height:32px}.fs-display-1{font-size:34px;font-size:2.125rem;font-weight:400;line-height:40px}.fs-display-2{font-size:45px;font-size:2.8125rem;font-weight:400;line-height:48px;letter-spacing:-1px}.fs-display-3{font-size:56px;font-size:3.5rem;font-weight:400;line-height:64px;letter-spacing:-2px}.fs-display-4{font-size:112px;font-size:7rem;font-weight:300;line-height:128px;letter-spacing:-5px}.tc-red-50{color:#ffebee!important}.tc-pink-50{color:#fce4ec!important}.tc-purple-50{color:#f3e5f5!important}.tc-deep-purple-50{color:#ede7f6!important}.tc-indigo-50{color:#e8eaf6!important}.tc-blue-50{color:#e3f2fd!important}.tc-light-blue-50{color:#e1f5fe!important}.tc-cyan-50{color:#e0f7fa!important}.tc-teal-50{color:#e0f2f1!important}.tc-green-50{color:#e8f5e9!important}.tc-light-green-50{color:#f1f8e9!important}.tc-lime-50{color:#f9fbe7!important}.tc-yellow-50{color:#fffde7!important}.tc-amber-50{color:#fff8e1!important}.tc-orange-50{color:#fff3e0!important}.tc-deep-orange-50{color:#fbe9e7!important}.tc-brown-50{color:#efebe9!important}.tc-grey-50{color:#fafafa!important}.tc-blue-grey-50{color:#eceff1!important}.tc-red-100{color:#ffcdd2!important}.tc-pink-100{color:#f8bbd0!important}.tc-purple-100{color:#e1bee7!important}.tc-deep-purple-100{color:#d1c4e9!important}.tc-indigo-100{color:#c5cae9!important}.tc-blue-100{color:#bbdefb!important}.tc-light-blue-100{color:#b3e5fc!important}.tc-cyan-100{color:#b2ebf2!important}.tc-teal-100{color:#b2dfdb!important}.tc-green-100{color:#c8e6c9!important}.tc-light-green-100{color:#dcedc8!important}.tc-lime-100{color:#f0f4c3!important}.tc-yellow-100{color:#fff9c4!important}.tc-amber-100{color:#ffecb3!important}.tc-orange-100{color:#ffe0b2!important}.tc-deep-orange-100{color:#ffccbc!important}.tc-brown-100{color:#d7ccc8!important}.tc-grey-100{color:#f5f5f5!important}.tc-blue-grey-100{color:#cfd8dc!important}.tc-red-200{color:#ef9a9a!important}.tc-pink-200{color:#f48fb1!important}.tc-purple-200{color:#ce93d8!important}.tc-deep-purple-200{color:#b39ddb!important}.tc-indigo-200{color:#9fa8da!important}.tc-blue-200{color:#90caf9!important}.tc-light-blue-200{color:#81d4fa!important}.tc-cyan-200{color:#80deea!important}.tc-teal-200{color:#80cbc4!important}.tc-green-200{color:#a5d6a7!important}.tc-light-green-200{color:#c5e1a5!important}.tc-lime-200{color:#e6ee9c!important}.tc-yellow-200{color:#fff59d!important}.tc-amber-200{color:#ffe082!important}.tc-orange-200{color:#ffcc80!important}.tc-deep-orange-200{color:#ffab91!important}.tc-brown-200{color:#bcaaa4!important}.tc-grey-200{color:#eee!important}.tc-blue-grey-200{color:#b0bec5!important}.tc-red-300{color:#e57373!important}.tc-pink-300{color:#f06292!important}.tc-purple-300{color:#ba68c8!important}.tc-deep-purple-300{color:#9575cd!important}.tc-indigo-300{color:#7986cb!important}.tc-blue-300{color:#64b5f6!important}.tc-light-blue-300{color:#4fc3f7!important}.tc-cyan-300{color:#4dd0e1!important}.tc-teal-300{color:#4db6ac!important}.tc-green-300{color:#81c784!important}.tc-light-green-300{color:#aed581!important}.tc-lime-300{color:#dce775!important}.tc-yellow-300{color:#fff176!important}.tc-amber-300{color:#ffd54f!important}.tc-orange-300{color:#ffb74d!important}.tc-deep-orange-300{color:#ff8a65!important}.tc-brown-300{color:#a1887f!important}.tc-grey-300{color:#e0e0e0!important}.tc-blue-grey-300{color:#90a4ae!important}.tc-red-400{color:#ef5350!important}.tc-pink-400{color:#ec407a!important}.tc-purple-400{color:#ab47bc!important}.tc-deep-purple-400{color:#7e57c2!important}.tc-indigo-400{color:#5c6bc0!important}.tc-blue-400{color:#42a5f5!important}.tc-light-blue-400{color:#29b6f6!important}.tc-cyan-400{color:#26c6da!important}.tc-teal-400{color:#26a69a!important}.tc-green-400{color:#66bb6a!important}.tc-light-green-400{color:#9ccc65!important}.tc-lime-400{color:#d4e157!important}.tc-yellow-400{color:#ffee58!important}.tc-amber-400{color:#ffca28!important}.tc-orange-400{color:#ffa726!important}.tc-deep-orange-400{color:#ff7043!important}.tc-brown-400{color:#8d6e63!important}.tc-grey-400{color:#bdbdbd!important}.tc-blue-grey-400{color:#78909c!important}.tc-red-500{color:#f44336!important}.tc-pink-500{color:#e91e63!important}.tc-purple-500{color:#9c27b0!important}.tc-deep-purple-500{color:#673ab7!important}.tc-indigo-500{color:#3f51b5!important}.tc-blue-500{color:#2196f3!important}.tc-light-blue-500{color:#03a9f4!important}.tc-cyan-500{color:#00bcd4!important}.tc-teal-500{color:#009688!important}.tc-green-500{color:#4caf50!important}.tc-light-green-500{color:#8bc34a!important}.tc-lime-500{color:#cddc39!important}.tc-yellow-500{color:#ffeb3b!important}.tc-amber-500{color:#ffc107!important}.tc-orange-500{color:#ff9800!important}.tc-deep-orange-500{color:#ff5722!important}.tc-brown-500{color:#795548!important}.tc-grey-500{color:#9e9e9e!important}.tc-blue-grey-500{color:#607d8b!important}.tc-red-600{color:#e53935!important}.tc-pink-600{color:#d81b60!important}.tc-purple-600{color:#8e24aa!important}.tc-deep-purple-600{color:#5e35b1!important}.tc-indigo-600{color:#3949ab!important}.tc-blue-600{color:#1e88e5!important}.tc-light-blue-600{color:#039be5!important}.tc-cyan-600{color:#00acc1!important}.tc-teal-600{color:#00897b!important}.tc-green-600{color:#43a047!important}.tc-light-green-600{color:#7cb342!important}.tc-lime-600{color:#c0ca33!important}.tc-yellow-600{color:#fdd835!important}.tc-amber-600{color:#ffb300!important}.tc-orange-600{color:#fb8c00!important}.tc-deep-orange-600{color:#f4511e!important}.tc-brown-600{color:#6d4c41!important}.tc-grey-600{color:#757575!important}.tc-blue-grey-600{color:#546e7a!important}.tc-red-700{color:#d32f2f!important}.tc-pink-700{color:#c2185b!important}.tc-purple-700{color:#7b1fa2!important}.tc-deep-purple-700{color:#512da8!important}.tc-indigo-700{color:#303f9f!important}.tc-blue-700{color:#1976d2!important}.tc-light-blue-700{color:#0288d1!important}.tc-cyan-700{color:#0097a7!important}.tc-teal-700{color:#00796b!important}.tc-green-700{color:#388e3c!important}.tc-light-green-700{color:#689f38!important}.tc-lime-700{color:#afb42b!important}.tc-yellow-700{color:#fbc02d!important}.tc-amber-700{color:#ffa000!important}.tc-orange-700{color:#f57c00!important}.tc-deep-orange-700{color:#e64a19!important}.tc-brown-700{color:#5d4037!important}.tc-grey-700{color:#616161!important}.tc-blue-grey-700{color:#455a64!important}.tc-red-800{color:#c62828!important}.tc-pink-800{color:#ad1457!important}.tc-purple-800{color:#6a1b9a!important}.tc-deep-purple-800{color:#4527a0!important}.tc-indigo-800{color:#283593!important}.tc-blue-800{color:#1565c0!important}.tc-light-blue-800{color:#0277bd!important}.tc-cyan-800{color:#00838f!important}.tc-teal-800{color:#00695c!important}.tc-green-800{color:#2e7d32!important}.tc-light-green-800{color:#558b2f!important}.tc-lime-800{color:#9e9d24!important}.tc-yellow-800{color:#f9a825!important}.tc-amber-800{color:#ff8f00!important}.tc-orange-800{color:#ef6c00!important}.tc-deep-orange-800{color:#d84315!important}.tc-brown-800{color:#4e342e!important}.tc-grey-800{color:#424242!important}.tc-blue-grey-800{color:#37474f!important}.tc-red-900{color:#b71c1c!important}.tc-pink-900{color:#880e4f!important}.tc-purple-900{color:#4a148c!important}.tc-deep-purple-900{color:#311b92!important}.tc-indigo-900{color:#1a237e!important}.tc-blue-900{color:#0d47a1!important}.tc-light-blue-900{color:#01579b!important}.tc-cyan-900{color:#006064!important}.tc-teal-900{color:#004d40!important}.tc-green-900{color:#1b5e20!important}.tc-light-green-900{color:#33691e!important}.tc-lime-900{color:#827717!important}.tc-yellow-900{color:#f57f17!important}.tc-amber-900{color:#ff6f00!important}.tc-orange-900{color:#e65100!important}.tc-deep-orange-900{color:#bf360c!important}.tc-brown-900{color:#3e2723!important}.tc-grey-900{color:#212121!important}.tc-blue-grey-900{color:#263238!important}.tc-red-A100{color:#ff8a80!important}.tc-pink-A100{color:#ff80ab!important}.tc-purple-A100{color:#ea80fc!important}.tc-deep-purple-A100{color:#b388ff!important}.tc-indigo-A100{color:#8c9eff!important}.tc-blue-A100{color:#82b1ff!important}.tc-light-blue-A100{color:#80d8ff!important}.tc-cyan-A100{color:#84ffff!important}.tc-teal-A100{color:#a7ffeb!important}.tc-green-A100{color:#b9f6ca!important}.tc-light-green-A100{color:#ccff90!important}.tc-lime-A100{color:#f4ff81!important}.tc-yellow-A100{color:#ffff8d!important}.tc-amber-A100{color:#ffe57f!important}.tc-orange-A100{color:#ffd180!important}.tc-deep-orange-A100{color:#ff9e80!important}.tc-red-A200{color:#ff5252!important}.tc-pink-A200{color:#ff4081!important}.tc-purple-A200{color:#e040fb!important}.tc-deep-purple-A200{color:#7c4dff!important}.tc-indigo-A200{color:#536dfe!important}.tc-blue-A200{color:#448aff!important}.tc-light-blue-A200{color:#40c4ff!important}.tc-cyan-A200{color:#18ffff!important}.tc-teal-A200{color:#64ffda!important}.tc-green-A200{color:#69f0ae!important}.tc-light-green-A200{color:#b2ff59!important}.tc-lime-A200{color:#eeff41!important}.tc-yellow-A200{color:#ff0!important}.tc-amber-A200{color:#ffd740!important}.tc-orange-A200{color:#ffab40!important}.tc-deep-orange-A200{color:#ff6e40!important}.tc-red-A400{color:#ff1744!important}.tc-pink-A400{color:#f50057!important}.tc-purple-A400{color:#d500f9!important}.tc-deep-purple-A400{color:#651fff!important}.tc-indigo-A400{color:#3d5afe!important}.tc-blue-A400{color:#2979ff!important}.tc-light-blue-A400{color:#00b0ff!important}.tc-cyan-A400{color:#00e5ff!important}.tc-teal-A400{color:#1de9b6!important}.tc-green-A400{color:#00e676!important}.tc-light-green-A400{color:#76ff03!important}.tc-lime-A400{color:#c6ff00!important}.tc-yellow-A400{color:#ffea00!important}.tc-amber-A400{color:#ffc400!important}.tc-orange-A400{color:#ff9100!important}.tc-deep-orange-A400{color:#ff3d00!important}.tc-red-A700{color:#d50000!important}.tc-pink-A700{color:#c51162!important}.tc-purple-A700{color:#a0f!important}.tc-deep-purple-A700{color:#6200ea!important}.tc-indigo-A700{color:#304ffe!important}.tc-blue-A700{color:#2962ff!important}.tc-light-blue-A700{color:#0091ea!important}.tc-cyan-A700{color:#00b8d4!important}.tc-teal-A700{color:#00bfa5!important}.tc-green-A700{color:#00c853!important}.tc-light-green-A700{color:#64dd17!important}.tc-lime-A700{color:#aeea00!important}.tc-yellow-A700{color:#ffd600!important}.tc-amber-A700{color:#ffab00!important}.tc-orange-A700{color:#ff6d00!important}.tc-deep-orange-A700{color:#dd2c00!important}.tc-black{color:#000!important}.tc-black-1{color:rgba(0,0,0,.87)!important}.tc-black-2{color:rgba(0,0,0,.54)!important}.tc-black-3{color:rgba(0,0,0,.38)!important}.tc-black-4{color:rgba(0,0,0,.12)!important}.tc-white,.tc-white-1{color:#fff!important}.tc-white-2{color:hsla(0,0%,100%,.7)!important}.tc-white-3{color:hsla(0,0%,100%,.3)!important}.tc-white-4{color:hsla(0,0%,100%,.12)!important}.tc-primary{color:#2196f3!important}.tc-primary-hue-1{color:#bbdefb!important}.tc-primary-hue-2{color:#1976d2!important}.tc-accent{color:#448aff!important}.tc-accent-hue-1{color:#82b1ff!important}.tc-accent-hue-2{color:#2979ff!important}.bgc-red-50{background-color:#ffebee!important}.bgc-pink-50{background-color:#fce4ec!important}.bgc-purple-50{background-color:#f3e5f5!important}.bgc-deep-purple-50{background-color:#ede7f6!important}.bgc-indigo-50{background-color:#e8eaf6!important}.bgc-blue-50{background-color:#e3f2fd!important}.bgc-light-blue-50{background-color:#e1f5fe!important}.bgc-cyan-50{background-color:#e0f7fa!important}.bgc-teal-50{background-color:#e0f2f1!important}.bgc-green-50{background-color:#e8f5e9!important}.bgc-light-green-50{background-color:#f1f8e9!important}.bgc-lime-50{background-color:#f9fbe7!important}.bgc-yellow-50{background-color:#fffde7!important}.bgc-amber-50{background-color:#fff8e1!important}.bgc-orange-50{background-color:#fff3e0!important}.bgc-deep-orange-50{background-color:#fbe9e7!important}.bgc-brown-50{background-color:#efebe9!important}.bgc-grey-50{background-color:#fafafa!important}.bgc-blue-grey-50{background-color:#eceff1!important}.bgc-red-100{background-color:#ffcdd2!important}.bgc-pink-100{background-color:#f8bbd0!important}.bgc-purple-100{background-color:#e1bee7!important}.bgc-deep-purple-100{background-color:#d1c4e9!important}.bgc-indigo-100{background-color:#c5cae9!important}.bgc-blue-100{background-color:#bbdefb!important}.bgc-light-blue-100{background-color:#b3e5fc!important}.bgc-cyan-100{background-color:#b2ebf2!important}.bgc-teal-100{background-color:#b2dfdb!important}.bgc-green-100{background-color:#c8e6c9!important}.bgc-light-green-100{background-color:#dcedc8!important}.bgc-lime-100{background-color:#f0f4c3!important}.bgc-yellow-100{background-color:#fff9c4!important}.bgc-amber-100{background-color:#ffecb3!important}.bgc-orange-100{background-color:#ffe0b2!important}.bgc-deep-orange-100{background-color:#ffccbc!important}.bgc-brown-100{background-color:#d7ccc8!important}.bgc-grey-100{background-color:#f5f5f5!important}.bgc-blue-grey-100{background-color:#cfd8dc!important}.bgc-red-200{background-color:#ef9a9a!important}.bgc-pink-200{background-color:#f48fb1!important}.bgc-purple-200{background-color:#ce93d8!important}.bgc-deep-purple-200{background-color:#b39ddb!important}.bgc-indigo-200{background-color:#9fa8da!important}.bgc-blue-200{background-color:#90caf9!important}.bgc-light-blue-200{background-color:#81d4fa!important}.bgc-cyan-200{background-color:#80deea!important}.bgc-teal-200{background-color:#80cbc4!important}.bgc-green-200{background-color:#a5d6a7!important}.bgc-light-green-200{background-color:#c5e1a5!important}.bgc-lime-200{background-color:#e6ee9c!important}.bgc-yellow-200{background-color:#fff59d!important}.bgc-amber-200{background-color:#ffe082!important}.bgc-orange-200{background-color:#ffcc80!important}.bgc-deep-orange-200{background-color:#ffab91!important}.bgc-brown-200{background-color:#bcaaa4!important}.bgc-grey-200{background-color:#eee!important}.bgc-blue-grey-200{background-color:#b0bec5!important}.bgc-red-300{background-color:#e57373!important}.bgc-pink-300{background-color:#f06292!important}.bgc-purple-300{background-color:#ba68c8!important}.bgc-deep-purple-300{background-color:#9575cd!important}.bgc-indigo-300{background-color:#7986cb!important}.bgc-blue-300{background-color:#64b5f6!important}.bgc-light-blue-300{background-color:#4fc3f7!important}.bgc-cyan-300{background-color:#4dd0e1!important}.bgc-teal-300{background-color:#4db6ac!important}.bgc-green-300{background-color:#81c784!important}.bgc-light-green-300{background-color:#aed581!important}.bgc-lime-300{background-color:#dce775!important}.bgc-yellow-300{background-color:#fff176!important}.bgc-amber-300{background-color:#ffd54f!important}.bgc-orange-300{background-color:#ffb74d!important}.bgc-deep-orange-300{background-color:#ff8a65!important}.bgc-brown-300{background-color:#a1887f!important}.bgc-grey-300{background-color:#e0e0e0!important}.bgc-blue-grey-300{background-color:#90a4ae!important}.bgc-red-400{background-color:#ef5350!important}.bgc-pink-400{background-color:#ec407a!important}.bgc-purple-400{background-color:#ab47bc!important}.bgc-deep-purple-400{background-color:#7e57c2!important}.bgc-indigo-400{background-color:#5c6bc0!important}.bgc-blue-400{background-color:#42a5f5!important}.bgc-light-blue-400{background-color:#29b6f6!important}.bgc-cyan-400{background-color:#26c6da!important}.bgc-teal-400{background-color:#26a69a!important}.bgc-green-400{background-color:#66bb6a!important}.bgc-light-green-400{background-color:#9ccc65!important}.bgc-lime-400{background-color:#d4e157!important}.bgc-yellow-400{background-color:#ffee58!important}.bgc-amber-400{background-color:#ffca28!important}.bgc-orange-400{background-color:#ffa726!important}.bgc-deep-orange-400{background-color:#ff7043!important}.bgc-brown-400{background-color:#8d6e63!important}.bgc-grey-400{background-color:#bdbdbd!important}.bgc-blue-grey-400{background-color:#78909c!important}.bgc-red-500{background-color:#f44336!important}.bgc-pink-500{background-color:#e91e63!important}.bgc-purple-500{background-color:#9c27b0!important}.bgc-deep-purple-500{background-color:#673ab7!important}.bgc-indigo-500{background-color:#3f51b5!important}.bgc-blue-500{background-color:#2196f3!important}.bgc-light-blue-500{background-color:#03a9f4!important}.bgc-cyan-500{background-color:#00bcd4!important}.bgc-teal-500{background-color:#009688!important}.bgc-green-500{background-color:#4caf50!important}.bgc-light-green-500{background-color:#8bc34a!important}.bgc-lime-500{background-color:#cddc39!important}.bgc-yellow-500{background-color:#ffeb3b!important}.bgc-amber-500{background-color:#ffc107!important}.bgc-orange-500{background-color:#ff9800!important}.bgc-deep-orange-500{background-color:#ff5722!important}.bgc-brown-500{background-color:#795548!important}.bgc-grey-500{background-color:#9e9e9e!important}.bgc-blue-grey-500{background-color:#607d8b!important}.bgc-red-600{background-color:#e53935!important}.bgc-pink-600{background-color:#d81b60!important}.bgc-purple-600{background-color:#8e24aa!important}.bgc-deep-purple-600{background-color:#5e35b1!important}.bgc-indigo-600{background-color:#3949ab!important}.bgc-blue-600{background-color:#1e88e5!important}.bgc-light-blue-600{background-color:#039be5!important}.bgc-cyan-600{background-color:#00acc1!important}.bgc-teal-600{background-color:#00897b!important}.bgc-green-600{background-color:#43a047!important}.bgc-light-green-600{background-color:#7cb342!important}.bgc-lime-600{background-color:#c0ca33!important}.bgc-yellow-600{background-color:#fdd835!important}.bgc-amber-600{background-color:#ffb300!important}.bgc-orange-600{background-color:#fb8c00!important}.bgc-deep-orange-600{background-color:#f4511e!important}.bgc-brown-600{background-color:#6d4c41!important}.bgc-grey-600{background-color:#757575!important}.bgc-blue-grey-600{background-color:#546e7a!important}.bgc-red-700{background-color:#d32f2f!important}.bgc-pink-700{background-color:#c2185b!important}.bgc-purple-700{background-color:#7b1fa2!important}.bgc-deep-purple-700{background-color:#512da8!important}.bgc-indigo-700{background-color:#303f9f!important}.bgc-blue-700{background-color:#1976d2!important}.bgc-light-blue-700{background-color:#0288d1!important}.bgc-cyan-700{background-color:#0097a7!important}.bgc-teal-700{background-color:#00796b!important}.bgc-green-700{background-color:#388e3c!important}.bgc-light-green-700{background-color:#689f38!important}.bgc-lime-700{background-color:#afb42b!important}.bgc-yellow-700{background-color:#fbc02d!important}.bgc-amber-700{background-color:#ffa000!important}.bgc-orange-700{background-color:#f57c00!important}.bgc-deep-orange-700{background-color:#e64a19!important}.bgc-brown-700{background-color:#5d4037!important}.bgc-grey-700{background-color:#616161!important}.bgc-blue-grey-700{background-color:#455a64!important}.bgc-red-800{background-color:#c62828!important}.bgc-pink-800{background-color:#ad1457!important}.bgc-purple-800{background-color:#6a1b9a!important}.bgc-deep-purple-800{background-color:#4527a0!important}.bgc-indigo-800{background-color:#283593!important}.bgc-blue-800{background-color:#1565c0!important}.bgc-light-blue-800{background-color:#0277bd!important}.bgc-cyan-800{background-color:#00838f!important}.bgc-teal-800{background-color:#00695c!important}.bgc-green-800{background-color:#2e7d32!important}.bgc-light-green-800{background-color:#558b2f!important}.bgc-lime-800{background-color:#9e9d24!important}.bgc-yellow-800{background-color:#f9a825!important}.bgc-amber-800{background-color:#ff8f00!important}.bgc-orange-800{background-color:#ef6c00!important}.bgc-deep-orange-800{background-color:#d84315!important}.bgc-brown-800{background-color:#4e342e!important}.bgc-grey-800{background-color:#424242!important}.bgc-blue-grey-800{background-color:#37474f!important}.bgc-red-900{background-color:#b71c1c!important}.bgc-pink-900{background-color:#880e4f!important}.bgc-purple-900{background-color:#4a148c!important}.bgc-deep-purple-900{background-color:#311b92!important}.bgc-indigo-900{background-color:#1a237e!important}.bgc-blue-900{background-color:#0d47a1!important}.bgc-light-blue-900{background-color:#01579b!important}.bgc-cyan-900{background-color:#006064!important}.bgc-teal-900{background-color:#004d40!important}.bgc-green-900{background-color:#1b5e20!important}.bgc-light-green-900{background-color:#33691e!important}.bgc-lime-900{background-color:#827717!important}.bgc-yellow-900{background-color:#f57f17!important}.bgc-amber-900{background-color:#ff6f00!important}.bgc-orange-900{background-color:#e65100!important}.bgc-deep-orange-900{background-color:#bf360c!important}.bgc-brown-900{background-color:#3e2723!important}.bgc-grey-900{background-color:#212121!important}.bgc-blue-grey-900{background-color:#263238!important}.bgc-red-A100{background-color:#ff8a80!important}.bgc-pink-A100{background-color:#ff80ab!important}.bgc-purple-A100{background-color:#ea80fc!important}.bgc-deep-purple-A100{background-color:#b388ff!important}.bgc-indigo-A100{background-color:#8c9eff!important}.bgc-blue-A100{background-color:#82b1ff!important}.bgc-light-blue-A100{background-color:#80d8ff!important}.bgc-cyan-A100{background-color:#84ffff!important}.bgc-teal-A100{background-color:#a7ffeb!important}.bgc-green-A100{background-color:#b9f6ca!important}.bgc-light-green-A100{background-color:#ccff90!important}.bgc-lime-A100{background-color:#f4ff81!important}.bgc-yellow-A100{background-color:#ffff8d!important}.bgc-amber-A100{background-color:#ffe57f!important}.bgc-orange-A100{background-color:#ffd180!important}.bgc-deep-orange-A100{background-color:#ff9e80!important}.bgc-red-A200{background-color:#ff5252!important}.bgc-pink-A200{background-color:#ff4081!important}.bgc-purple-A200{background-color:#e040fb!important}.bgc-deep-purple-A200{background-color:#7c4dff!important}.bgc-indigo-A200{background-color:#536dfe!important}.bgc-blue-A200{background-color:#448aff!important}.bgc-light-blue-A200{background-color:#40c4ff!important}.bgc-cyan-A200{background-color:#18ffff!important}.bgc-teal-A200{background-color:#64ffda!important}.bgc-green-A200{background-color:#69f0ae!important}.bgc-light-green-A200{background-color:#b2ff59!important}.bgc-lime-A200{background-color:#eeff41!important}.bgc-yellow-A200{background-color:#ff0!important}.bgc-amber-A200{background-color:#ffd740!important}.bgc-orange-A200{background-color:#ffab40!important}.bgc-deep-orange-A200{background-color:#ff6e40!important}.bgc-red-A400{background-color:#ff1744!important}.bgc-pink-A400{background-color:#f50057!important}.bgc-purple-A400{background-color:#d500f9!important}.bgc-deep-purple-A400{background-color:#651fff!important}.bgc-indigo-A400{background-color:#3d5afe!important}.bgc-blue-A400{background-color:#2979ff!important}.bgc-light-blue-A400{background-color:#00b0ff!important}.bgc-cyan-A400{background-color:#00e5ff!important}.bgc-teal-A400{background-color:#1de9b6!important}.bgc-green-A400{background-color:#00e676!important}.bgc-light-green-A400{background-color:#76ff03!important}.bgc-lime-A400{background-color:#c6ff00!important}.bgc-yellow-A400{background-color:#ffea00!important}.bgc-amber-A400{background-color:#ffc400!important}.bgc-orange-A400{background-color:#ff9100!important}.bgc-deep-orange-A400{background-color:#ff3d00!important}.bgc-red-A700{background-color:#d50000!important}.bgc-pink-A700{background-color:#c51162!important}.bgc-purple-A700{background-color:#a0f!important}.bgc-deep-purple-A700{background-color:#6200ea!important}.bgc-indigo-A700{background-color:#304ffe!important}.bgc-blue-A700{background-color:#2962ff!important}.bgc-light-blue-A700{background-color:#0091ea!important}.bgc-cyan-A700{background-color:#00b8d4!important}.bgc-teal-A700{background-color:#00bfa5!important}.bgc-green-A700{background-color:#00c853!important}.bgc-light-green-A700{background-color:#64dd17!important}.bgc-lime-A700{background-color:#aeea00!important}.bgc-yellow-A700{background-color:#ffd600!important}.bgc-amber-A700{background-color:#ffab00!important}.bgc-orange-A700{background-color:#ff6d00!important}.bgc-deep-orange-A700{background-color:#dd2c00!important}.bgc-black{background-color:#000!important}.bgc-black-1{background-color:rgba(0,0,0,.87)!important}.bgc-black-2{background-color:rgba(0,0,0,.54)!important}.bgc-black-3{background-color:rgba(0,0,0,.38)!important}.bgc-black-4{background-color:rgba(0,0,0,.12)!important}.bgc-white,.bgc-white-1{background-color:#fff!important}.bgc-white-2{background-color:hsla(0,0%,100%,.7)!important}.bgc-white-3{background-color:hsla(0,0%,100%,.3)!important}.bgc-white-4{background-color:hsla(0,0%,100%,.12)!important}.bgc-primary{background-color:#2196f3!important}.bgc-primary-hue-1{background-color:#bbdefb!important}.bgc-primary-hue-2{background-color:#1976d2!important}.bgc-accent{background-color:#448aff!important}.bgc-accent-hue-1{background-color:#82b1ff!important}.bgc-accent-hue-2{background-color:#2979ff!important}.w-1\\/1{width:100%!important}.w-1\\/2{width:50%!important}.w-1\\/3{width:33.33333%!important}.w-2\\/3{width:66.66667%!important}.w-1\\/4{width:25%!important}.w-2\\/4{width:50%!important}.w-3\\/4{width:75%!important}.w-1\\/5{width:20%!important}.w-2\\/5{width:40%!important}.w-3\\/5{width:60%!important}.w-4\\/5{width:80%!important}@media screen and (max-width:480px){.w-1\\/1-palm{width:100%!important}.w-1\\/2-palm{width:50%!important}.w-1\\/3-palm{width:33.33333%!important}.w-2\\/3-palm{width:66.66667%!important}.w-1\\/4-palm{width:25%!important}.w-2\\/4-palm{width:50%!important}.w-3\\/4-palm{width:75%!important}.w-1\\/5-palm{width:20%!important}.w-2\\/5-palm{width:40%!important}.w-3\\/5-palm{width:60%!important}.w-4\\/5-palm{width:80%!important}}@media screen and (min-width:481px) and (max-width:1023px){.w-1\\/1-lap{width:100%!important}.w-1\\/2-lap{width:50%!important}.w-1\\/3-lap{width:33.33333%!important}.w-2\\/3-lap{width:66.66667%!important}.w-1\\/4-lap{width:25%!important}.w-2\\/4-lap{width:50%!important}.w-3\\/4-lap{width:75%!important}.w-1\\/5-lap{width:20%!important}.w-2\\/5-lap{width:40%!important}.w-3\\/5-lap{width:60%!important}.w-4\\/5-lap{width:80%!important}}@media screen and (min-width:481px){.w-1\\/1-lap-and-up{width:100%!important}.w-1\\/2-lap-and-up{width:50%!important}.w-1\\/3-lap-and-up{width:33.33333%!important}.w-2\\/3-lap-and-up{width:66.66667%!important}.w-1\\/4-lap-and-up{width:25%!important}.w-2\\/4-lap-and-up{width:50%!important}.w-3\\/4-lap-and-up{width:75%!important}.w-1\\/5-lap-and-up{width:20%!important}.w-2\\/5-lap-and-up{width:40%!important}.w-3\\/5-lap-and-up{width:60%!important}.w-4\\/5-lap-and-up{width:80%!important}}@media screen and (max-width:1023px){.w-1\\/1-portable{width:100%!important}.w-1\\/2-portable{width:50%!important}.w-1\\/3-portable{width:33.33333%!important}.w-2\\/3-portable{width:66.66667%!important}.w-1\\/4-portable{width:25%!important}.w-2\\/4-portable{width:50%!important}.w-3\\/4-portable{width:75%!important}.w-1\\/5-portable{width:20%!important}.w-2\\/5-portable{width:40%!important}.w-3\\/5-portable{width:60%!important}.w-4\\/5-portable{width:80%!important}}@media screen and (min-width:1024px){.w-1\\/1-desk{width:100%!important}.w-1\\/2-desk{width:50%!important}.w-1\\/3-desk{width:33.33333%!important}.w-2\\/3-desk{width:66.66667%!important}.w-1\\/4-desk{width:25%!important}.w-2\\/4-desk{width:50%!important}.w-3\\/4-desk{width:75%!important}.w-1\\/5-desk{width:20%!important}.w-2\\/5-desk{width:40%!important}.w-3\\/5-desk{width:60%!important}.w-4\\/5-desk{width:80%!important}}@media screen and (min-width:1280px){.w-1\\/1-desk-wide{width:100%!important}.w-1\\/2-desk-wide{width:50%!important}.w-1\\/3-desk-wide{width:33.33333%!important}.w-2\\/3-desk-wide{width:66.66667%!important}.w-1\\/4-desk-wide{width:25%!important}.w-2\\/4-desk-wide{width:50%!important}.w-3\\/4-desk-wide{width:75%!important}.w-1\\/5-desk-wide{width:20%!important}.w-2\\/5-desk-wide{width:40%!important}.w-3\\/5-desk-wide{width:60%!important}.w-4\\/5-desk-wide{width:80%!important}}@media screen and (min-width:1920px){.w-1\\/1-full-hd{width:100%!important}.w-1\\/2-full-hd{width:50%!important}.w-1\\/3-full-hd{width:33.33333%!important}.w-2\\/3-full-hd{width:66.66667%!important}.w-1\\/4-full-hd{width:25%!important}.w-2\\/4-full-hd{width:50%!important}.w-3\\/4-full-hd{width:75%!important}.w-1\\/5-full-hd{width:20%!important}.w-2\\/5-full-hd{width:40%!important}.w-3\\/5-full-hd{width:60%!important}.w-4\\/5-full-hd{width:80%!important}}@media (-webkit-min-device-pixel-ratio:2),(min-resolution:2dppx),(min-resolution:192dpi){.w-1\\/1-retina{width:100%!important}.w-1\\/2-retina{width:50%!important}.w-1\\/3-retina{width:33.33333%!important}.w-2\\/3-retina{width:66.66667%!important}.w-1\\/4-retina{width:25%!important}.w-2\\/4-retina{width:50%!important}.w-3\\/4-retina{width:75%!important}.w-1\\/5-retina{width:20%!important}.w-2\\/5-retina{width:40%!important}.w-3\\/5-retina{width:60%!important}.w-4\\/5-retina{width:80%!important}}.m{margin:8px!important}.mt{margin-top:8px!important}.mr{margin-right:8px!important}.mb{margin-bottom:8px!important}.mh,.ml{margin-left:8px!important}.mh{margin-right:8px!important}.mv{margin-top:8px!important;margin-bottom:8px!important}.m-{margin:4px!important}.mt-{margin-top:4px!important}.mr-{margin-right:4px!important}.mb-{margin-bottom:4px!important}.mh-,.ml-{margin-left:4px!important}.mh-{margin-right:4px!important}.mv-{margin-top:4px!important;margin-bottom:4px!important}.m\\+{margin:16px!important}.mt\\+{margin-top:16px!important}.mr\\+{margin-right:16px!important}.mb\\+{margin-bottom:16px!important}.mh\\+,.ml\\+{margin-left:16px!important}.mh\\+{margin-right:16px!important}.mv\\+{margin-top:16px!important;margin-bottom:16px!important}.m\\+\\+{margin:24px!important}.mt\\+\\+{margin-top:24px!important}.mr\\+\\+{margin-right:24px!important}.mb\\+\\+{margin-bottom:24px!important}.mh\\+\\+,.ml\\+\\+{margin-left:24px!important}.mh\\+\\+{margin-right:24px!important}.mv\\+\\+{margin-top:24px!important;margin-bottom:24px!important}.m\\+\\+\\+{margin:32px!important}.mt\\+\\+\\+{margin-top:32px!important}.mr\\+\\+\\+{margin-right:32px!important}.mb\\+\\+\\+{margin-bottom:32px!important}.mh\\+\\+\\+,.ml\\+\\+\\+{margin-left:32px!important}.mh\\+\\+\\+{margin-right:32px!important}.mv\\+\\+\\+{margin-top:32px!important;margin-bottom:32px!important}.m0{margin:0!important}.mt0{margin-top:0!important}.mr0{margin-right:0!important}.mb0{margin-bottom:0!important}.mh0,.ml0{margin-left:0!important}.mh0{margin-right:0!important}.mv0{margin-top:0!important;margin-bottom:0!important}.p{padding:8px!important}.pt{padding-top:8px!important}.pr{padding-right:8px!important}.pb{padding-bottom:8px!important}.ph,.pl{padding-left:8px!important}.ph{padding-right:8px!important}.pv{padding-top:8px!important;padding-bottom:8px!important}.p-{padding:4px!important}.pt-{padding-top:4px!important}.pr-{padding-right:4px!important}.pb-{padding-bottom:4px!important}.ph-,.pl-{padding-left:4px!important}.ph-{padding-right:4px!important}.pv-{padding-top:4px!important;padding-bottom:4px!important}.p\\+{padding:16px!important}.pt\\+{padding-top:16px!important}.pr\\+{padding-right:16px!important}.pb\\+{padding-bottom:16px!important}.ph\\+,.pl\\+{padding-left:16px!important}.ph\\+{padding-right:16px!important}.pv\\+{padding-top:16px!important;padding-bottom:16px!important}.p\\+\\+{padding:24px!important}.pt\\+\\+{padding-top:24px!important}.pr\\+\\+{padding-right:24px!important}.pb\\+\\+{padding-bottom:24px!important}.ph\\+\\+,.pl\\+\\+{padding-left:24px!important}.ph\\+\\+{padding-right:24px!important}.pv\\+\\+{padding-top:24px!important;padding-bottom:24px!important}.p\\+\\+\\+{padding:32px!important}.pt\\+\\+\\+{padding-top:32px!important}.pr\\+\\+\\+{padding-right:32px!important}.pb\\+\\+\\+{padding-bottom:32px!important}.ph\\+\\+\\+,.pl\\+\\+\\+{padding-left:32px!important}.ph\\+\\+\\+{padding-right:32px!important}.pv\\+\\+\\+{padding-top:32px!important;padding-bottom:32px!important}.p0{padding:0!important}.pt0{padding-top:0!important}.pr0{padding-right:0!important}.pb0{padding-bottom:0!important}.ph0,.pl0{padding-left:0!important}.ph0{padding-right:0!important}.pv0{padding-top:0!important;padding-bottom:0!important}.clearfix:after{clear:both;content:\"\";display:table}.float-right{float:right!important}.float-left{float:left!important}.float-none{float:none!important}.text-left{text-align:left!important}.text-center{text-align:center!important}.text-right{text-align:right!important}.display-block{display:block}.checkbox__input,.radio-button__input,.switch__input,.visuallyhidden{border:0!important;clip:rect(0 0 0 0)!important;height:1px!important;margin:-1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:1px!important}@keyframes ripple{0%{opacity:.3;transform:scale(0)}to{opacity:0;transform:scale(2.5)}}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.bare-list,.dropdown-menu ul,.list{margin:0;padding:0;list-style:none}.divider{height:1px}.divider--dark{background-color:rgba(0,0,0,.12)}.divider--light{background-color:hsla(0,0%,100%,.12)}.has-divider{border-bottom-width:1px;border-bottom-style:solid}.has-divider--dark{border-bottom-color:rgba(0,0,0,.12)}.has-divider--light{border-bottom-color:hsla(0,0%,100%,.12)}.z-depth1{box-shadow:0 3px 1px -2px rgba(0,0,0,.14),0 2px 2px 0 rgba(0,0,0,.098),0 1px 5px 0 rgba(0,0,0,.084)}.z-depth2{box-shadow:0 2px 4px -1px rgba(0,0,0,.14),0 4px 5px 0 rgba(0,0,0,.098),0 1px 10px 0 rgba(0,0,0,.084)}.z-depth3{box-shadow:0 3px 5px -1px rgba(0,0,0,.14),0 6px 10px 0 rgba(0,0,0,.098),0 1px 18px 0 rgba(0,0,0,.084)}.z-depth4{box-shadow:0 5px 5px -3px rgba(0,0,0,.14),0 8px 10px 1px rgba(0,0,0,.098),0 3px 14px 2px rgba(0,0,0,.084)}.z-depth5{box-shadow:0 8px 10px -5px rgba(0,0,0,.14),0 16px 24px 2px rgba(0,0,0,.098),0 6px 30px 5px rgba(0,0,0,.084)}.btn{z-index:2;display:inline-block;vertical-align:top;margin:0;padding:0;border:none;background-color:transparent;font-weight:400;text-align:center;text-transform:uppercase;cursor:pointer}.btn,.btn:active,.btn:focus,.btn:hover{text-decoration:none;outline:none}.btn::-moz-focus-inner{border:0;padding:0}.btn .ripple{z-index:-1}.btn--raised.btn--is-disabled,.btn--raised[disabled]{box-shadow:none!important;cursor:not-allowed;color:rgba(0,0,0,.38)!important;background-color:#e0e0e0!important}.btn--raised.btn--is-disabled .ripple,.btn--raised[disabled] .ripple{display:none}.btn--fab.btn--is-disabled,.btn--fab[disabled]{box-shadow:none!important;cursor:not-allowed;color:rgba(0,0,0,.38)!important;background-color:#e0e0e0!important}.btn--fab.btn--is-disabled .ripple,.btn--fab[disabled] .ripple{display:none}.btn--flat.btn--is-disabled,.btn--flat[disabled]{box-shadow:none!important;cursor:not-allowed;color:rgba(0,0,0,.38)!important;background-color:transparent!important}.btn--flat.btn--is-disabled .ripple,.btn--flat[disabled] .ripple{display:none}.btn--icon.btn--is-disabled,.btn--icon[disabled]{box-shadow:none!important;cursor:not-allowed;color:rgba(0,0,0,.38)!important;background-color:transparent!important}.btn--icon.btn--is-disabled .ripple,.btn--icon[disabled] .ripple{display:none}.btn--xs{padding-left:10px;padding-right:10px;line-height:24px}.btn--s,.btn--xs{font-size:11px;font-size:.6875rem}.btn--s{padding-left:12px;padding-right:12px;line-height:30px}.btn--m{padding-left:14px;padding-right:14px;font-size:13px;font-size:.8125rem;line-height:36px}.btn--l{padding-left:16px;padding-right:16px;font-size:14px;font-size:.875rem;line-height:40px}.btn--xl{padding-left:26px;padding-right:26px;font-size:16px;font-size:1rem;line-height:56px}.btn--raised{border-radius:2px;box-shadow:0 3px 1px -2px rgba(0,0,0,.14),0 2px 2px 0 rgba(0,0,0,.098),0 1px 5px 0 rgba(0,0,0,.084);transition-property:box-shadow;transition-duration:.2s}.btn--raised:hover{box-shadow:0 2px 4px -1px rgba(0,0,0,.14),0 4px 5px 0 rgba(0,0,0,.098),0 1px 10px 0 rgba(0,0,0,.084)}.btn--fab{box-shadow:0 3px 1px -2px rgba(0,0,0,.14),0 2px 2px 0 rgba(0,0,0,.098),0 1px 5px 0 rgba(0,0,0,.084);transition-property:box-shadow;transition-duration:.2s;border-radius:50%}.btn--fab:hover{box-shadow:0 2px 4px -1px rgba(0,0,0,.14),0 4px 5px 0 rgba(0,0,0,.098),0 1px 10px 0 rgba(0,0,0,.084)}.btn--raised.btn--red{color:#fff;background-color:#f44336}.btn--raised.btn--red .ripple{background-color:#290502}.btn--fab.btn--red{color:#fff;background-color:#f44336}.btn--fab.btn--red .ripple{background-color:#290502}.btn--raised.btn--pink{color:#fff;background-color:#e91e63}.btn--raised.btn--pink .ripple{background-color:#070103}.btn--fab.btn--pink{color:#fff;background-color:#e91e63}.btn--fab.btn--pink .ripple{background-color:#070103}.btn--raised.btn--purple{color:#fff;background-color:#9c27b0}.btn--raised.btn--purple .ripple{background-color:#000}.btn--fab.btn--purple{color:#fff;background-color:#9c27b0}.btn--fab.btn--purple .ripple{background-color:#000}.btn--raised.btn--deep-purple{color:#fff;background-color:#673ab7}.btn--raised.btn--deep-purple .ripple{background-color:#000}.btn--fab.btn--deep-purple{color:#fff;background-color:#673ab7}.btn--fab.btn--deep-purple .ripple{background-color:#000}.btn--raised.btn--indigo{color:#fff;background-color:#3f51b5}.btn--raised.btn--indigo .ripple{background-color:#000}.btn--fab.btn--indigo{color:#fff;background-color:#3f51b5}.btn--fab.btn--indigo .ripple{background-color:#000}.btn--raised.btn--blue{color:#fff;background-color:#2196f3}.btn--raised.btn--blue .ripple{background-color:#010c14}.btn--fab.btn--blue{color:#fff;background-color:#2196f3}.btn--fab.btn--blue .ripple{background-color:#010c14}.btn--raised.btn--light-blue{color:#fff;background-color:#03a9f4}.btn--raised.btn--light-blue .ripple{background-color:#000}.btn--fab.btn--light-blue{color:#fff;background-color:#03a9f4}.btn--fab.btn--light-blue .ripple{background-color:#000}.btn--raised.btn--cyan{color:#fff;background-color:#00bcd4}.btn--raised.btn--cyan .ripple{background-color:#000}.btn--fab.btn--cyan{color:#fff;background-color:#00bcd4}.btn--fab.btn--cyan .ripple{background-color:#000}.btn--raised.btn--teal{color:#fff;background-color:#009688}.btn--raised.btn--teal .ripple{background-color:#000}.btn--fab.btn--teal{color:#fff;background-color:#009688}.btn--fab.btn--teal .ripple{background-color:#000}.btn--raised.btn--green{color:#fff;background-color:#4caf50}.btn--raised.btn--green .ripple{background-color:#000}.btn--fab.btn--green{color:#fff;background-color:#4caf50}.btn--fab.btn--green .ripple{background-color:#000}.btn--raised.btn--light-green{color:#fff;background-color:#8bc34a}.btn--raised.btn--light-green .ripple{background-color:#070b03}.btn--fab.btn--light-green{color:#fff;background-color:#8bc34a}.btn--fab.btn--light-green .ripple{background-color:#070b03}.btn--raised.btn--lime{color:#fff;background-color:#cddc39}.btn--raised.btn--lime .ripple{background-color:#111303}.btn--fab.btn--lime{color:#fff;background-color:#cddc39}.btn--fab.btn--lime .ripple{background-color:#111303}.btn--raised.btn--yellow{color:#fff;background-color:#ffeb3b}.btn--raised.btn--yellow .ripple{background-color:#3b3500}.btn--fab.btn--yellow{color:#fff;background-color:#ffeb3b}.btn--fab.btn--yellow .ripple{background-color:#3b3500}.btn--raised.btn--amber{color:#fff;background-color:#ffc107}.btn--raised.btn--amber .ripple{background-color:#070500}.btn--fab.btn--amber{color:#fff;background-color:#ffc107}.btn--fab.btn--amber .ripple{background-color:#070500}.btn--raised.btn--orange{color:#fff;background-color:#ff9800}.btn--raised.btn--orange .ripple{background-color:#000}.btn--fab.btn--orange{color:#fff;background-color:#ff9800}.btn--fab.btn--orange .ripple{background-color:#000}.btn--raised.btn--deep-orange{color:#fff;background-color:#ff5722}.btn--raised.btn--deep-orange .ripple{background-color:#220800}.btn--fab.btn--deep-orange{color:#fff;background-color:#ff5722}.btn--fab.btn--deep-orange .ripple{background-color:#220800}.btn--raised.btn--brown{color:#fff;background-color:#795548}.btn--raised.btn--brown .ripple{background-color:#000}.btn--fab.btn--brown{color:#fff;background-color:#795548}.btn--fab.btn--brown .ripple{background-color:#000}.btn--raised.btn--grey{color:#fff;background-color:#9e9e9e}.btn--raised.btn--grey .ripple{background-color:#1f1f1f}.btn--fab.btn--grey{color:#fff;background-color:#9e9e9e}.btn--fab.btn--grey .ripple{background-color:#1f1f1f}.btn--raised.btn--blue-grey{color:#fff;background-color:#607d8b}.btn--raised.btn--blue-grey .ripple{background-color:#000}.btn--fab.btn--blue-grey{color:#fff;background-color:#607d8b}.btn--fab.btn--blue-grey .ripple{background-color:#000}.btn--raised.btn--black{color:#fff;background-color:#000}.btn--fab.btn--black,.btn--raised.btn--black .ripple{background-color:#000}.btn--fab.btn--black{color:#fff}.btn--fab.btn--black .ripple{background-color:#000}.btn--raised.btn--white{color:rgba(0,0,0,.87);background-color:#fff}.btn--raised.btn--white .ripple{background-color:gray}.btn--fab.btn--white{color:rgba(0,0,0,.87);background-color:#fff}.btn--fab.btn--white .ripple{background-color:gray}.btn--raised.btn--primary{color:#fff;background-color:#2196f3}.btn--raised.btn--primary .ripple{background-color:#010c14}.btn--fab.btn--primary{color:#fff;background-color:#2196f3}.btn--fab.btn--primary .ripple{background-color:#010c14}.btn--raised.btn--primary-hue-1{color:#fff;background-color:#bbdefb}.btn--raised.btn--primary-hue-1 .ripple{background-color:#0a63ad}.btn--fab.btn--primary-hue-1{color:#fff;background-color:#bbdefb}.btn--fab.btn--primary-hue-1 .ripple{background-color:#0a63ad}.btn--raised.btn--primary-hue-2{color:#fff;background-color:#1976d2}.btn--raised.btn--primary-hue-2 .ripple{background-color:#000}.btn--fab.btn--primary-hue-2{color:#fff;background-color:#1976d2}.btn--fab.btn--primary-hue-2 .ripple{background-color:#000}.btn--raised.btn--accent{color:#fff;background-color:#448aff}.btn--raised.btn--accent .ripple{background-color:#001944}.btn--fab.btn--accent{color:#fff;background-color:#448aff}.btn--fab.btn--accent .ripple{background-color:#001944}.btn--raised.btn--accent-hue-1{color:#fff;background-color:#82b1ff}.btn--raised.btn--accent-hue-1 .ripple{background-color:#003182}.btn--fab.btn--accent-hue-1{color:#fff;background-color:#82b1ff}.btn--fab.btn--accent-hue-1 .ripple{background-color:#003182}.btn--raised.btn--accent-hue-2{color:#fff;background-color:#2979ff}.btn--raised.btn--accent-hue-2 .ripple{background-color:#000f29}.btn--fab.btn--accent-hue-2{color:#fff;background-color:#2979ff}.btn--fab.btn--accent-hue-2 .ripple{background-color:#000f29}.btn--flat{border-radius:2px}.btn--flat,.btn--icon{transition-property:background-color;transition-duration:.2s}.btn--icon{border-radius:50%}.btn--flat.btn--red{color:#f44336}.btn--flat.btn--red .ripple{background-color:#f44336}.btn--flat.btn--red:hover{background-color:rgba(244,67,54,.15)}.btn--icon.btn--red{color:#f44336}.btn--icon.btn--red .ripple{background-color:#f44336}.btn--icon.btn--red:hover{background-color:rgba(244,67,54,.15)}.btn--flat.btn--pink{color:#e91e63}.btn--flat.btn--pink .ripple{background-color:#e91e63}.btn--flat.btn--pink:hover{background-color:rgba(233,30,99,.15)}.btn--icon.btn--pink{color:#e91e63}.btn--icon.btn--pink .ripple{background-color:#e91e63}.btn--icon.btn--pink:hover{background-color:rgba(233,30,99,.15)}.btn--flat.btn--purple{color:#9c27b0}.btn--flat.btn--purple .ripple{background-color:#9c27b0}.btn--flat.btn--purple:hover{background-color:rgba(156,39,176,.15)}.btn--icon.btn--purple{color:#9c27b0}.btn--icon.btn--purple .ripple{background-color:#9c27b0}.btn--icon.btn--purple:hover{background-color:rgba(156,39,176,.15)}.btn--flat.btn--deep-purple{color:#673ab7}.btn--flat.btn--deep-purple .ripple{background-color:#673ab7}.btn--flat.btn--deep-purple:hover{background-color:rgba(103,58,183,.15)}.btn--icon.btn--deep-purple{color:#673ab7}.btn--icon.btn--deep-purple .ripple{background-color:#673ab7}.btn--icon.btn--deep-purple:hover{background-color:rgba(103,58,183,.15)}.btn--flat.btn--indigo{color:#3f51b5}.btn--flat.btn--indigo .ripple{background-color:#3f51b5}.btn--flat.btn--indigo:hover{background-color:rgba(63,81,181,.15)}.btn--icon.btn--indigo{color:#3f51b5}.btn--icon.btn--indigo .ripple{background-color:#3f51b5}.btn--icon.btn--indigo:hover{background-color:rgba(63,81,181,.15)}.btn--flat.btn--blue{color:#2196f3}.btn--flat.btn--blue .ripple{background-color:#2196f3}.btn--flat.btn--blue:hover{background-color:rgba(33,150,243,.15)}.btn--icon.btn--blue{color:#2196f3}.btn--icon.btn--blue .ripple{background-color:#2196f3}.btn--icon.btn--blue:hover{background-color:rgba(33,150,243,.15)}.btn--flat.btn--light-blue{color:#03a9f4}.btn--flat.btn--light-blue .ripple{background-color:#03a9f4}.btn--flat.btn--light-blue:hover{background-color:rgba(3,169,244,.15)}.btn--icon.btn--light-blue{color:#03a9f4}.btn--icon.btn--light-blue .ripple{background-color:#03a9f4}.btn--icon.btn--light-blue:hover{background-color:rgba(3,169,244,.15)}.btn--flat.btn--cyan{color:#00bcd4}.btn--flat.btn--cyan .ripple{background-color:#00bcd4}.btn--flat.btn--cyan:hover{background-color:rgba(0,188,212,.15)}.btn--icon.btn--cyan{color:#00bcd4}.btn--icon.btn--cyan .ripple{background-color:#00bcd4}.btn--icon.btn--cyan:hover{background-color:rgba(0,188,212,.15)}.btn--flat.btn--teal{color:#009688}.btn--flat.btn--teal .ripple{background-color:#009688}.btn--flat.btn--teal:hover{background-color:rgba(0,150,136,.15)}.btn--icon.btn--teal{color:#009688}.btn--icon.btn--teal .ripple{background-color:#009688}.btn--icon.btn--teal:hover{background-color:rgba(0,150,136,.15)}.btn--flat.btn--green{color:#4caf50}.btn--flat.btn--green .ripple{background-color:#4caf50}.btn--flat.btn--green:hover{background-color:rgba(76,175,80,.15)}.btn--icon.btn--green{color:#4caf50}.btn--icon.btn--green .ripple{background-color:#4caf50}.btn--icon.btn--green:hover{background-color:rgba(76,175,80,.15)}.btn--flat.btn--light-green{color:#8bc34a}.btn--flat.btn--light-green .ripple{background-color:#8bc34a}.btn--flat.btn--light-green:hover{background-color:rgba(139,195,74,.15)}.btn--icon.btn--light-green{color:#8bc34a}.btn--icon.btn--light-green .ripple{background-color:#8bc34a}.btn--icon.btn--light-green:hover{background-color:rgba(139,195,74,.15)}.btn--flat.btn--lime{color:#cddc39}.btn--flat.btn--lime .ripple{background-color:#cddc39}.btn--flat.btn--lime:hover{background-color:rgba(205,220,57,.15)}.btn--icon.btn--lime{color:#cddc39}.btn--icon.btn--lime .ripple{background-color:#cddc39}.btn--icon.btn--lime:hover{background-color:rgba(205,220,57,.15)}.btn--flat.btn--yellow{color:#ffeb3b}.btn--flat.btn--yellow .ripple{background-color:#ffeb3b}.btn--flat.btn--yellow:hover{background-color:rgba(255,235,59,.15)}.btn--icon.btn--yellow{color:#ffeb3b}.btn--icon.btn--yellow .ripple{background-color:#ffeb3b}.btn--icon.btn--yellow:hover{background-color:rgba(255,235,59,.15)}.btn--flat.btn--amber{color:#ffc107}.btn--flat.btn--amber .ripple{background-color:#ffc107}.btn--flat.btn--amber:hover{background-color:rgba(255,193,7,.15)}.btn--icon.btn--amber{color:#ffc107}.btn--icon.btn--amber .ripple{background-color:#ffc107}.btn--icon.btn--amber:hover{background-color:rgba(255,193,7,.15)}.btn--flat.btn--orange{color:#ff9800}.btn--flat.btn--orange .ripple{background-color:#ff9800}.btn--flat.btn--orange:hover{background-color:rgba(255,152,0,.15)}.btn--icon.btn--orange{color:#ff9800}.btn--icon.btn--orange .ripple{background-color:#ff9800}.btn--icon.btn--orange:hover{background-color:rgba(255,152,0,.15)}.btn--flat.btn--deep-orange{color:#ff5722}.btn--flat.btn--deep-orange .ripple{background-color:#ff5722}.btn--flat.btn--deep-orange:hover{background-color:rgba(255,87,34,.15)}.btn--icon.btn--deep-orange{color:#ff5722}.btn--icon.btn--deep-orange .ripple{background-color:#ff5722}.btn--icon.btn--deep-orange:hover{background-color:rgba(255,87,34,.15)}.btn--flat.btn--brown{color:#795548}.btn--flat.btn--brown .ripple{background-color:#795548}.btn--flat.btn--brown:hover{background-color:rgba(121,85,72,.15)}.btn--icon.btn--brown{color:#795548}.btn--icon.btn--brown .ripple{background-color:#795548}.btn--icon.btn--brown:hover{background-color:rgba(121,85,72,.15)}.btn--flat.btn--grey{color:#9e9e9e}.btn--flat.btn--grey .ripple{background-color:#9e9e9e}.btn--flat.btn--grey:hover{background-color:hsla(0,0%,62%,.15)}.btn--icon.btn--grey{color:#9e9e9e}.btn--icon.btn--grey .ripple{background-color:#9e9e9e}.btn--icon.btn--grey:hover{background-color:hsla(0,0%,62%,.15)}.btn--flat.btn--blue-grey{color:#607d8b}.btn--flat.btn--blue-grey .ripple{background-color:#607d8b}.btn--flat.btn--blue-grey:hover{background-color:rgba(96,125,139,.15)}.btn--icon.btn--blue-grey{color:#607d8b}.btn--icon.btn--blue-grey .ripple{background-color:#607d8b}.btn--icon.btn--blue-grey:hover{background-color:rgba(96,125,139,.15)}.btn--flat.btn--black{color:#000}.btn--flat.btn--black .ripple{background-color:#000}.btn--flat.btn--black:hover{background-color:rgba(0,0,0,.15)}.btn--icon.btn--black{color:#000}.btn--icon.btn--black .ripple{background-color:#000}.btn--icon.btn--black:hover{background-color:rgba(0,0,0,.15)}.btn--flat.btn--white{color:#fff}.btn--flat.btn--white .ripple{background-color:#fff}.btn--flat.btn--white:hover{background-color:hsla(0,0%,100%,.15)}.btn--icon.btn--white{color:#fff}.btn--icon.btn--white .ripple{background-color:#fff}.btn--icon.btn--white:hover{background-color:hsla(0,0%,100%,.15)}.btn--flat.btn--primary{color:#2196f3}.btn--flat.btn--primary .ripple{background-color:#2196f3}.btn--flat.btn--primary:hover{background-color:rgba(33,150,243,.15)}.btn--icon.btn--primary{color:#2196f3}.btn--icon.btn--primary .ripple{background-color:#2196f3}.btn--icon.btn--primary:hover{background-color:rgba(33,150,243,.15)}.btn--flat.btn--primary-hue-1{color:#bbdefb}.btn--flat.btn--primary-hue-1 .ripple{background-color:#bbdefb}.btn--flat.btn--primary-hue-1:hover{background-color:rgba(187,222,251,.15)}.btn--icon.btn--primary-hue-1{color:#bbdefb}.btn--icon.btn--primary-hue-1 .ripple{background-color:#bbdefb}.btn--icon.btn--primary-hue-1:hover{background-color:rgba(187,222,251,.15)}.btn--flat.btn--primary-hue-2{color:#1976d2}.btn--flat.btn--primary-hue-2 .ripple{background-color:#1976d2}.btn--flat.btn--primary-hue-2:hover{background-color:rgba(25,118,210,.15)}.btn--icon.btn--primary-hue-2{color:#1976d2}.btn--icon.btn--primary-hue-2 .ripple{background-color:#1976d2}.btn--icon.btn--primary-hue-2:hover{background-color:rgba(25,118,210,.15)}.btn--flat.btn--accent{color:#448aff}.btn--flat.btn--accent .ripple{background-color:#448aff}.btn--flat.btn--accent:hover{background-color:rgba(68,138,255,.15)}.btn--icon.btn--accent{color:#448aff}.btn--icon.btn--accent .ripple{background-color:#448aff}.btn--icon.btn--accent:hover{background-color:rgba(68,138,255,.15)}.btn--flat.btn--accent-hue-1{color:#82b1ff}.btn--flat.btn--accent-hue-1 .ripple{background-color:#82b1ff}.btn--flat.btn--accent-hue-1:hover{background-color:rgba(130,177,255,.15)}.btn--icon.btn--accent-hue-1{color:#82b1ff}.btn--icon.btn--accent-hue-1 .ripple{background-color:#82b1ff}.btn--icon.btn--accent-hue-1:hover{background-color:rgba(130,177,255,.15)}.btn--flat.btn--accent-hue-2{color:#2979ff}.btn--flat.btn--accent-hue-2 .ripple{background-color:#2979ff}.btn--flat.btn--accent-hue-2:hover{background-color:rgba(41,121,255,.15)}.btn--icon.btn--accent-hue-2{color:#2979ff}.btn--icon.btn--accent-hue-2 .ripple{background-color:#2979ff}.btn--icon.btn--accent-hue-2:hover{background-color:rgba(41,121,255,.15)}.btn--icon.btn--xs{padding-left:10px;padding-right:10px;font-size:11px;font-size:.6875rem;line-height:24px;height:24px;width:24px;padding:0;font-size:13px;font-size:.8125rem}.btn--icon.btn--xs .mdi{vertical-align:top;line-height:24px}.btn--fab.btn--xs{padding-left:10px;padding-right:10px;font-size:11px;font-size:.6875rem;line-height:24px;height:24px;width:24px;padding:0;font-size:15px;font-size:.9375rem}.btn--fab.btn--xs .mdi{vertical-align:top;line-height:24px}.btn--icon.btn--s{padding-left:12px;padding-right:12px;font-size:11px;font-size:.6875rem;line-height:30px;height:30px;width:30px;padding:0;font-size:15px;font-size:.9375rem}.btn--icon.btn--s .mdi{vertical-align:top;line-height:30px}.btn--fab.btn--s{padding-left:12px;padding-right:12px;font-size:11px;font-size:.6875rem;line-height:30px;height:30px;width:30px;padding:0;font-size:15px;font-size:.9375rem}.btn--fab.btn--s .mdi{vertical-align:top;line-height:30px}.btn--icon.btn--m{padding-left:14px;padding-right:14px;font-size:13px;font-size:.8125rem;line-height:36px;height:36px;width:36px;padding:0;font-size:20px;font-size:1.25rem}.btn--icon.btn--m .mdi{vertical-align:top;line-height:36px}.btn--fab.btn--m{padding-left:14px;padding-right:14px;font-size:13px;font-size:.8125rem;line-height:36px;height:36px;width:36px;padding:0;font-size:17px;font-size:1.0625rem}.btn--fab.btn--m .mdi{vertical-align:top;line-height:36px}.btn--icon.btn--l{padding-left:16px;padding-right:16px;font-size:14px;font-size:.875rem;line-height:40px;height:40px;width:40px;padding:0;font-size:24px;font-size:1.5rem}.btn--icon.btn--l .mdi{vertical-align:top;line-height:40px}.btn--fab.btn--l{padding-left:16px;padding-right:16px;font-size:14px;font-size:.875rem;line-height:40px;height:40px;width:40px;padding:0;font-size:18px;font-size:1.125rem}.btn--fab.btn--l .mdi{vertical-align:top;line-height:40px}.btn--icon.btn--xl{padding-left:26px;padding-right:26px;font-size:16px;font-size:1rem;line-height:56px;height:56px;width:56px;padding:0;font-size:28px;font-size:1.75rem}.btn--icon.btn--xl .mdi{vertical-align:top;line-height:56px}.btn--fab.btn--xl{padding-left:26px;padding-right:26px;font-size:16px;font-size:1rem;line-height:56px;height:56px;width:56px;padding:0;font-size:20px;font-size:1.25rem}.btn--fab.btn--xl .mdi{vertical-align:top;line-height:56px}.card{border-radius:2px;background-color:#fff;overflow:hidden;box-shadow:0 3px 1px -2px rgba(0,0,0,.14),0 2px 2px 0 rgba(0,0,0,.098),0 1px 5px 0 rgba(0,0,0,.084)}.card__img--top{position:relative}.card__img--top h1,.card__img--top h2,.card__img--top h3,.card__img--top h4,.card__img--top h5,.card__img--top h6,.card__img--top span,.card__img--top strong{position:absolute;right:16px;bottom:16px;left:16px}.card__img--left img{max-height:100%}.card__actions{padding:8px;border-top:1px solid rgba(0,0,0,.12)}.checkbox{min-width:24px;min-height:24px}.checkbox--red .checkbox__label:after{color:#f44336}.checkbox--pink .checkbox__label:after{color:#e91e63}.checkbox--purple .checkbox__label:after{color:#9c27b0}.checkbox--deep-purple .checkbox__label:after{color:#673ab7}.checkbox--indigo .checkbox__label:after{color:#3f51b5}.checkbox--blue .checkbox__label:after{color:#2196f3}.checkbox--light-blue .checkbox__label:after{color:#03a9f4}.checkbox--cyan .checkbox__label:after{color:#00bcd4}.checkbox--teal .checkbox__label:after{color:#009688}.checkbox--green .checkbox__label:after{color:#4caf50}.checkbox--light-green .checkbox__label:after{color:#8bc34a}.checkbox--lime .checkbox__label:after{color:#cddc39}.checkbox--yellow .checkbox__label:after{color:#ffeb3b}.checkbox--amber .checkbox__label:after{color:#ffc107}.checkbox--orange .checkbox__label:after{color:#ff9800}.checkbox--deep-orange .checkbox__label:after{color:#ff5722}.checkbox--brown .checkbox__label:after{color:#795548}.checkbox--grey .checkbox__label:after{color:#9e9e9e}.checkbox--blue-grey .checkbox__label:after{color:#607d8b}.checkbox--black .checkbox__label:after{color:#000}.checkbox--white .checkbox__label:after{color:#fff}.checkbox--primary .checkbox__label:after{color:#2196f3}.checkbox--primary-hue-1 .checkbox__label:after{color:#bbdefb}.checkbox--primary-hue-2 .checkbox__label:after{color:#1976d2}.checkbox--accent .checkbox__label:after{color:#448aff}.checkbox--accent-hue-1 .checkbox__label:after{color:#82b1ff}.checkbox--accent-hue-2 .checkbox__label:after{color:#2979ff}.checkbox__input:not(:checked)+.checkbox__label:before{opacity:1}.checkbox__input:checked+.checkbox__label:before,.checkbox__input:not(:checked)+.checkbox__label:after{opacity:0}.checkbox__input:checked+.checkbox__label:after{opacity:1}.checkbox__input[disabled]+.checkbox__label{cursor:not-allowed}.checkbox__input[disabled]+.checkbox__label,.checkbox__input[disabled]+.checkbox__label:after,.checkbox__input[disabled]+.checkbox__label:before,.checkbox__input[disabled]~.checkbox__help{color:rgba(0,0,0,.38)}.checkbox__label{display:block;position:relative;padding-left:32px;font-weight:400;line-height:24px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkbox--standalone .checkbox__label{padding-left:0}.checkbox__label:after,.checkbox__label:before{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0);position:absolute;top:0;left:0;font-size:24px;font-size:1.5rem;line-height:24px;transition-property:opacity;transition-duration:.2s}.checkbox__label:before{content:\"\\F131\";color:rgba(0,0,0,.54)}.checkbox__label:after{content:\"\\F132\";color:#448aff}.checkbox__help{display:block;padding-left:32px;font-weight:400;line-height:20px;color:rgba(0,0,0,.54);text-align:left}@media screen and (max-width:1023px){.checkbox__help{font-size:14px;font-size:.875rem}}@media screen and (min-width:1024px){.checkbox__help{font-size:13px;font-size:.8125rem}}.data-table-container{position:relative;width:100%;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch}.data-table-header{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;height:64px;padding:0 16px 0 24px;border-bottom:1px solid rgba(0,0,0,.12)}.data-table-header__label{box-flex:1;-moz-flex:1;-ms-flex:1;flex:1}.data-table{width:100%;margin:0;table-layout:fixed}.data-table td,.data-table th{padding-right:56px;border-bottom:1px solid #e0e0e0}.data-table td:first-child,.data-table th:first-child{padding-left:24px;padding-right:24px}.data-table td:last-child,.data-table th:last-child{padding-right:24px}.data-table th{height:56px;font-size:12px;font-size:.75rem;font-weight:400;color:rgba(0,0,0,.54);text-align:left;white-space:nowrap}.data-table th i{margin-right:4px}.data-table td{height:48px;font-size:13px;font-size:.8125rem;padding-top:8px;padding-bottom:8px}.data-table tr:last-child td{border-bottom:none}.data-table__selectable-row td:first-child,.data-table__selectable-row th:first-child{width:72px}.data-table__selectable-row td:first-child:before,.data-table__selectable-row th:first-child:before{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0);content:\"\\F131\";font-size:24px;font-size:1.5rem;line-height:24px;transition-property:transform;transition-duration:.2s}.data-table__selectable-row td:nth-child(2),.data-table__selectable-row th:nth-child(2){padding-right:24px}.data-table__selectable-row td{cursor:pointer}.data-table__selectable-row:not(.data-table__selectable-row--is-selected):not(.data-table__selectable-row--is-disabled):hover td{background-color:#eee}.data-table__selectable-row--is-selected td:first-child:before,.data-table__selectable-row--is-selected th:first-child:before{content:\"\\F132\";color:#2196f3}.data-table__selectable-row--is-selected td{background-color:#f5f5f5}.data-table__selectable-row--is-disabled td:first-child:before,.data-table__selectable-row--is-disabled th:first-child:before{color:rgba(0,0,0,.38)}.data-table__selectable-row--is-disabled td{cursor:not-allowed}.data-table__sortable-cell{cursor:pointer}.data-table__sortable-cell:hover{color:rgba(0,0,0,.87)!important}.data-table__sortable-cell:before{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0);margin-right:4px}.data-table__sortable-cell--asc,.data-table__sortable-cell--desc{color:rgba(0,0,0,.87)!important}.data-table__sortable-cell--asc:before,.data-table__sortable-cell--desc:before{color:rgba(0,0,0,.54)!important}.data-table__sortable-cell--asc:before{content:\"\\F05D\"}.data-table__sortable-cell--desc:before{content:\"\\F045\"}.lx-date-picker-filter{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;background-color:rgba(0,0,0,.6);transition-property:opacity;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.lx-date-picker-filter--is-shown{opacity:1}.lx-date-input,.lx-date-input input{cursor:pointer!important}.lx-date-input input{pointer-events:none}.lx-date-picker{display:none;position:fixed;top:32px;left:50%;width:330px;margin-left:-165px;opacity:0;box-shadow:0 3px 5px -1px rgba(0,0,0,.14),0 6px 10px 0 rgba(0,0,0,.098),0 1px 18px 0 rgba(0,0,0,.084);transform:translateY(-50px);transition-property:opacity,transform;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.lx-date-picker--red .lx-date-picker__day--is-selected a,.lx-date-picker--red .lx-date-picker__day a:hover,.lx-date-picker--red .lx-date-picker__header{background-color:#f44336}.lx-date-picker--red .lx-date-picker__year--is-active,.lx-date-picker--red .lx-date-picker__year:hover{color:#f44336}.lx-date-picker--pink .lx-date-picker__day--is-selected a,.lx-date-picker--pink .lx-date-picker__day a:hover,.lx-date-picker--pink .lx-date-picker__header{background-color:#e91e63}.lx-date-picker--pink .lx-date-picker__year--is-active,.lx-date-picker--pink .lx-date-picker__year:hover{color:#e91e63}.lx-date-picker--purple .lx-date-picker__day--is-selected a,.lx-date-picker--purple .lx-date-picker__day a:hover,.lx-date-picker--purple .lx-date-picker__header{background-color:#9c27b0}.lx-date-picker--purple .lx-date-picker__year--is-active,.lx-date-picker--purple .lx-date-picker__year:hover{color:#9c27b0}.lx-date-picker--deep-purple .lx-date-picker__day--is-selected a,.lx-date-picker--deep-purple .lx-date-picker__day a:hover,.lx-date-picker--deep-purple .lx-date-picker__header{background-color:#673ab7}.lx-date-picker--deep-purple .lx-date-picker__year--is-active,.lx-date-picker--deep-purple .lx-date-picker__year:hover{color:#673ab7}.lx-date-picker--indigo .lx-date-picker__day--is-selected a,.lx-date-picker--indigo .lx-date-picker__day a:hover,.lx-date-picker--indigo .lx-date-picker__header{background-color:#3f51b5}.lx-date-picker--indigo .lx-date-picker__year--is-active,.lx-date-picker--indigo .lx-date-picker__year:hover{color:#3f51b5}.lx-date-picker--blue .lx-date-picker__day--is-selected a,.lx-date-picker--blue .lx-date-picker__day a:hover,.lx-date-picker--blue .lx-date-picker__header{background-color:#2196f3}.lx-date-picker--blue .lx-date-picker__year--is-active,.lx-date-picker--blue .lx-date-picker__year:hover{color:#2196f3}.lx-date-picker--light-blue .lx-date-picker__day--is-selected a,.lx-date-picker--light-blue .lx-date-picker__day a:hover,.lx-date-picker--light-blue .lx-date-picker__header{background-color:#03a9f4}.lx-date-picker--light-blue .lx-date-picker__year--is-active,.lx-date-picker--light-blue .lx-date-picker__year:hover{color:#03a9f4}.lx-date-picker--cyan .lx-date-picker__day--is-selected a,.lx-date-picker--cyan .lx-date-picker__day a:hover,.lx-date-picker--cyan .lx-date-picker__header{background-color:#00bcd4}.lx-date-picker--cyan .lx-date-picker__year--is-active,.lx-date-picker--cyan .lx-date-picker__year:hover{color:#00bcd4}.lx-date-picker--teal .lx-date-picker__day--is-selected a,.lx-date-picker--teal .lx-date-picker__day a:hover,.lx-date-picker--teal .lx-date-picker__header{background-color:#009688}.lx-date-picker--teal .lx-date-picker__year--is-active,.lx-date-picker--teal .lx-date-picker__year:hover{color:#009688}.lx-date-picker--green .lx-date-picker__day--is-selected a,.lx-date-picker--green .lx-date-picker__day a:hover,.lx-date-picker--green .lx-date-picker__header{background-color:#4caf50}.lx-date-picker--green .lx-date-picker__year--is-active,.lx-date-picker--green .lx-date-picker__year:hover{color:#4caf50}.lx-date-picker--light-green .lx-date-picker__day--is-selected a,.lx-date-picker--light-green .lx-date-picker__day a:hover,.lx-date-picker--light-green .lx-date-picker__header{background-color:#8bc34a}.lx-date-picker--light-green .lx-date-picker__year--is-active,.lx-date-picker--light-green .lx-date-picker__year:hover{color:#8bc34a}.lx-date-picker--lime .lx-date-picker__day--is-selected a,.lx-date-picker--lime .lx-date-picker__day a:hover,.lx-date-picker--lime .lx-date-picker__header{background-color:#cddc39}.lx-date-picker--lime .lx-date-picker__year--is-active,.lx-date-picker--lime .lx-date-picker__year:hover{color:#cddc39}.lx-date-picker--yellow .lx-date-picker__day--is-selected a,.lx-date-picker--yellow .lx-date-picker__day a:hover,.lx-date-picker--yellow .lx-date-picker__header{background-color:#ffeb3b}.lx-date-picker--yellow .lx-date-picker__year--is-active,.lx-date-picker--yellow .lx-date-picker__year:hover{color:#ffeb3b}.lx-date-picker--amber .lx-date-picker__day--is-selected a,.lx-date-picker--amber .lx-date-picker__day a:hover,.lx-date-picker--amber .lx-date-picker__header{background-color:#ffc107}.lx-date-picker--amber .lx-date-picker__year--is-active,.lx-date-picker--amber .lx-date-picker__year:hover{color:#ffc107}.lx-date-picker--orange .lx-date-picker__day--is-selected a,.lx-date-picker--orange .lx-date-picker__day a:hover,.lx-date-picker--orange .lx-date-picker__header{background-color:#ff9800}.lx-date-picker--orange .lx-date-picker__year--is-active,.lx-date-picker--orange .lx-date-picker__year:hover{color:#ff9800}.lx-date-picker--deep-orange .lx-date-picker__day--is-selected a,.lx-date-picker--deep-orange .lx-date-picker__day a:hover,.lx-date-picker--deep-orange .lx-date-picker__header{background-color:#ff5722}.lx-date-picker--deep-orange .lx-date-picker__year--is-active,.lx-date-picker--deep-orange .lx-date-picker__year:hover{color:#ff5722}.lx-date-picker--brown .lx-date-picker__day--is-selected a,.lx-date-picker--brown .lx-date-picker__day a:hover,.lx-date-picker--brown .lx-date-picker__header{background-color:#795548}.lx-date-picker--brown .lx-date-picker__year--is-active,.lx-date-picker--brown .lx-date-picker__year:hover{color:#795548}.lx-date-picker--grey .lx-date-picker__day--is-selected a,.lx-date-picker--grey .lx-date-picker__day a:hover,.lx-date-picker--grey .lx-date-picker__header{background-color:#9e9e9e}.lx-date-picker--grey .lx-date-picker__year--is-active,.lx-date-picker--grey .lx-date-picker__year:hover{color:#9e9e9e}.lx-date-picker--blue-grey .lx-date-picker__day--is-selected a,.lx-date-picker--blue-grey .lx-date-picker__day a:hover,.lx-date-picker--blue-grey .lx-date-picker__header{background-color:#607d8b}.lx-date-picker--blue-grey .lx-date-picker__year--is-active,.lx-date-picker--blue-grey .lx-date-picker__year:hover{color:#607d8b}.lx-date-picker--black .lx-date-picker__day--is-selected a,.lx-date-picker--black .lx-date-picker__day a:hover,.lx-date-picker--black .lx-date-picker__header{background-color:#000}.lx-date-picker--black .lx-date-picker__year--is-active,.lx-date-picker--black .lx-date-picker__year:hover{color:#000}.lx-date-picker--white .lx-date-picker__day--is-selected a,.lx-date-picker--white .lx-date-picker__day a:hover,.lx-date-picker--white .lx-date-picker__header{background-color:#fff}.lx-date-picker--white .lx-date-picker__year--is-active,.lx-date-picker--white .lx-date-picker__year:hover{color:#fff}.lx-date-picker--primary .lx-date-picker__day--is-selected a,.lx-date-picker--primary .lx-date-picker__day a:hover,.lx-date-picker--primary .lx-date-picker__header{background-color:#2196f3}.lx-date-picker--primary .lx-date-picker__year--is-active,.lx-date-picker--primary .lx-date-picker__year:hover{color:#2196f3}.lx-date-picker--primary-hue-1 .lx-date-picker__day--is-selected a,.lx-date-picker--primary-hue-1 .lx-date-picker__day a:hover,.lx-date-picker--primary-hue-1 .lx-date-picker__header{background-color:#bbdefb}.lx-date-picker--primary-hue-1 .lx-date-picker__year--is-active,.lx-date-picker--primary-hue-1 .lx-date-picker__year:hover{color:#bbdefb}.lx-date-picker--primary-hue-2 .lx-date-picker__day--is-selected a,.lx-date-picker--primary-hue-2 .lx-date-picker__day a:hover,.lx-date-picker--primary-hue-2 .lx-date-picker__header{background-color:#1976d2}.lx-date-picker--primary-hue-2 .lx-date-picker__year--is-active,.lx-date-picker--primary-hue-2 .lx-date-picker__year:hover{color:#1976d2}.lx-date-picker--accent .lx-date-picker__day--is-selected a,.lx-date-picker--accent .lx-date-picker__day a:hover,.lx-date-picker--accent .lx-date-picker__header{background-color:#448aff}.lx-date-picker--accent .lx-date-picker__year--is-active,.lx-date-picker--accent .lx-date-picker__year:hover{color:#448aff}.lx-date-picker--accent-hue-1 .lx-date-picker__day--is-selected a,.lx-date-picker--accent-hue-1 .lx-date-picker__day a:hover,.lx-date-picker--accent-hue-1 .lx-date-picker__header{background-color:#82b1ff}.lx-date-picker--accent-hue-1 .lx-date-picker__year--is-active,.lx-date-picker--accent-hue-1 .lx-date-picker__year:hover{color:#82b1ff}.lx-date-picker--accent-hue-2 .lx-date-picker__day--is-selected a,.lx-date-picker--accent-hue-2 .lx-date-picker__day a:hover,.lx-date-picker--accent-hue-2 .lx-date-picker__header{background-color:#2979ff}.lx-date-picker--accent-hue-2 .lx-date-picker__year--is-active,.lx-date-picker--accent-hue-2 .lx-date-picker__year:hover{color:#2979ff}.lx-date-picker--is-shown{opacity:1;transform:translateY(0)}.lx-date-picker__header{border-radius:2px 2px 0 0;padding:16px 24px}.lx-date-picker__current-date,.lx-date-picker__current-year{display:block;cursor:pointer}.lx-date-picker__current-year{font-size:14px;font-size:.875rem;color:hsla(0,0%,100%,.7);line-height:22px}.lx-date-picker__current-year--is-active,.lx-date-picker__current-year:hover{color:#fff}.lx-date-picker__current-date{font-size:38px;font-size:2.375rem;font-weight:500;color:hsla(0,0%,100%,.7);line-height:42px}.lx-date-picker__current-date--is-active,.lx-date-picker__current-date:hover{color:#fff}.lx-date-picker__calendar{height:350px;background-color:#fff}.lx-date-picker__nav{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;height:52px}.lx-date-picker__nav span{box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;font-size:14px;font-size:.875rem;text-align:center;text-transform:capitalize;font-weight:500}.lx-date-picker__nav button:first-child{margin-left:8px}.lx-date-picker__nav button:last-child{margin-right:8px}.lx-date-picker__days-of-week{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;padding:0 16px}.lx-date-picker__days-of-week span{box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;font-size:12px;font-size:.75rem;font-weight:400;color:rgba(0,0,0,.54);line-height:32px;text-align:center;text-transform:uppercase}.lx-date-picker__days{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;padding:0 16px}.lx-date-picker__day{box-flex:0;-moz-flex:0 0 14.28571%;-ms-flex:0 0 14.28571%;flex:0 0 14.28571%;max-width:14.28571%;padding:1px 0}.lx-date-picker__day a{display:block;height:40px;width:40px;margin:0 auto;border-radius:50%;font-size:12px;font-size:.75rem;text-align:center;line-height:40px;font-weight:400}.lx-date-picker__day--is-today a{font-weight:500}.lx-date-picker__day--is-selected a,.lx-date-picker__day a:hover{cursor:pointer;color:#fff}.lx-date-picker__day--is-disabled a{color:rgba(0,0,0,.38)!important;cursor:not-allowed!important}.lx-date-picker__day--is-disabled a:hover{background-color:transparent!important}.lx-date-picker__day--is-complete a{background-color:green!important;color:#fff}.lx-date-picker__day--is-complete a:hover{background-color:#90ee90!important;color:#fff}.lx-date-picker__day--is-incomplete a{background-color:#db7093!important;color:#fff}.lx-date-picker__day--is-incomplete a:hover{background-color:pink!important;color:#fff}.lx-date-picker__year-selector{position:relative;height:350px;background-color:#fff;overflow:auto;-webkit-overflow-scrolling:touch}.lx-date-picker__year{display:block;height:45px;cursor:pointer;font-size:16px;font-size:1rem;line-height:45px;text-align:center}.lx-date-picker__year--is-active{height:55px;font-size:26px;font-size:1.625rem;font-weight:500;line-height:55px}.lx-date-picker__actions{padding:8px;border-top:1px solid rgba(0,0,0,.12);border-radius:0 0 2px 2px;background-color:#fff;text-align:center}.dialog-filter{position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.6);opacity:0;transition-property:opacity;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.dialog-filter--is-shown{opacity:1}.dialog{display:none;position:fixed;top:32px;left:50%;background-color:#fff;opacity:0;top:20px;bottom:20px;box-shadow:0 3px 5px -1px rgba(0,0,0,.14),0 6px 10px 0 rgba(0,0,0,.098),0 1px 18px 0 rgba(0,0,0,.084);transform:translateY(-50px);transition-property:opacity,transform;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.dialog--alert{width:400px;margin-left:-200px}@media screen and (min-width:1024px){.dialog--l{width:800px;margin-left:-400px}}@media screen and (max-width:1023px){.dialog--l{width:80%;margin-left:-40%}}.dialog--is-shown{opacity:1;transform:translateY(0)}.dialog--is-fixed{bottom:32px}.dialog--is-fixed .dialog__header{position:absolute;top:0;right:0;left:0}.dialog--is-fixed .dialog__scrollable{position:absolute;right:0;left:0;z-index:1;overflow-x:hidden;overflow-y:auto}.dialog--is-fixed .dialog__actions,.dialog--is-fixed .dialog__footer{position:absolute;right:0;bottom:0;left:0;border-top:1px solid rgba(0,0,0,.12)}.dialog__actions,.dialog__footer{padding:8px 16px;text-align:right}.dropdown{position:relative;display:inline-block;vertical-align:top}.dropdown-menu{position:absolute;border-radius:2px;background-color:#fff;text-align:left;opacity:0;overflow:auto;box-shadow:0 3px 1px -2px rgba(0,0,0,.14),0 2px 2px 0 rgba(0,0,0,.098),0 1px 5px 0 rgba(0,0,0,.084)}.dropdown-menu ul>li{position:relative}.dropdown-menu__content{padding:8px 0;opacity:0;transition-property:opacity;transition-duration:.2s}.dropdown-menu--is-open .dropdown-menu__content{opacity:1}.dropdown-divider{height:1px;margin-top:8px;margin-bottom:8px;background-color:rgba(0,0,0,.12)}.dropdown-link{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;height:32px;padding:0 32px 0 16px;cursor:pointer;font-size:14px;font-size:.875rem;color:rgba(0,0,0,.87);line-height:32px;text-decoration:none;white-space:nowrap}.dropdown-link:not(.dropdown-link--is-header):hover{background-color:#eee}.dropdown-link:not(.dropdown-link--is-header) .mdi{margin-right:16px;color:rgba(0,0,0,.54)}.dropdown-link--is-large{height:48px}.dropdown-link--is-header{color:rgba(0,0,0,.38);cursor:default}.dropdown-link--is-header .mdi{width:18px;margin-right:6px;color:rgba(0,0,0,.38);text-align:center}.fab{display:inline-block;vertical-align:top;position:relative}.fab:hover .fab__primary .mdi:first-of-type{opacity:0;transform:rotate(45deg)}.fab:hover .fab__primary .mdi:last-child{opacity:1;transform:rotate(0)}.fab:hover .fab__actions{pointer-events:auto}.fab:hover .fab__actions .btn{opacity:1}.fab:hover .fab__actions.fab__actions--up .btn{transform:scale(1) translateY(-12px)}.fab:hover .fab__actions.fab__actions--right .btn{transform:scale(1) translateX(12px)}.fab:hover .fab__actions.fab__actions--down .btn{transform:scale(1) translateY(12px)}.fab:hover .fab__actions.fab__actions--left .btn{transform:scale(1) translateX(-12px)}.fab__primary .mdi{position:absolute;top:0;right:0;bottom:0;left:0;transition-property:opacity,transform;transition-duration:.4s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.fab__primary .mdi:first-of-type{opacity:1;transform:rotate(0)}.fab__primary .mdi:last-child{opacity:0;transform:rotate(-45deg)}.fab__actions{pointer-events:none}.fab__actions .btn{display:block;opacity:0;transform:scale(.6);transition-property:opacity,transform;transition-duration:.4s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.fab__actions--left .btn:first-child,.fab__actions--up .btn:first-child{transition-delay:.2s}.fab__actions--left .btn:nth-child(2),.fab__actions--up .btn:nth-child(2){transition-delay:.1s}.fab__actions--left .btn:nth-child(3),.fab__actions--up .btn:nth-child(3){transition-delay:.06667s}.fab__actions--left .btn:nth-child(4),.fab__actions--up .btn:nth-child(4){transition-delay:.05s}.fab__actions--left .btn:nth-child(5),.fab__actions--up .btn:nth-child(5){transition-delay:.04s}.fab__actions--left .btn:nth-child(6),.fab__actions--up .btn:nth-child(6){transition-delay:.03333s}.fab__actions--left .btn:nth-child(7),.fab__actions--up .btn:nth-child(7){transition-delay:.02857s}.fab__actions--left .btn:nth-child(8),.fab__actions--up .btn:nth-child(8){transition-delay:25ms}.fab__actions--left .btn:nth-child(9),.fab__actions--up .btn:nth-child(9){transition-delay:.02222s}.fab__actions--left .btn:nth-child(10),.fab__actions--up .btn:nth-child(10){transition-delay:.02s}.fab__actions--down .btn:first-child,.fab__actions--right .btn:first-child{transition-delay:.05s}.fab__actions--down .btn:nth-child(2),.fab__actions--right .btn:nth-child(2){transition-delay:.1s}.fab__actions--down .btn:nth-child(3),.fab__actions--right .btn:nth-child(3){transition-delay:.15s}.fab__actions--down .btn:nth-child(4),.fab__actions--right .btn:nth-child(4){transition-delay:.2s}.fab__actions--down .btn:nth-child(5),.fab__actions--right .btn:nth-child(5){transition-delay:.25s}.fab__actions--down .btn:nth-child(6),.fab__actions--right .btn:nth-child(6){transition-delay:.3s}.fab__actions--down .btn:nth-child(7),.fab__actions--right .btn:nth-child(7){transition-delay:.35s}.fab__actions--down .btn:nth-child(8),.fab__actions--right .btn:nth-child(8){transition-delay:.4s}.fab__actions--down .btn:nth-child(9),.fab__actions--right .btn:nth-child(9){transition-delay:.45s}.fab__actions--down .btn:nth-child(10),.fab__actions--right .btn:nth-child(10){transition-delay:.5s}.fab__actions--left,.fab__actions--right{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;-webkit-box-lines:single;-moz-box-lines:single;box-lines:single;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.fab__actions--up{position:absolute;bottom:56px;left:7px}.fab__actions--up .btn{margin-bottom:8px}.fab__actions--down{position:absolute;top:56px;left:7px}.fab__actions--down .btn{margin-top:8px}.fab__actions--left{position:absolute;right:56px;bottom:7px}.fab__actions--left .btn{margin-right:8px}.fab__actions--right{position:absolute;bottom:7px;left:56px}.fab__actions--right .btn{margin-left:8px}.input-file{position:relative;padding-top:32px;padding-bottom:8px}.input-file:after,.input-file:before{content:\"\"}.input-file:before{position:absolute;right:0;bottom:7px;left:0;height:1px;border-bottom:1px solid rgba(0,0,0,.12)}.input-file:after{position:absolute;right:0;bottom:6px;left:0;height:2px;background-color:#2196f3;transform:scale(0);transition-property:transform;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.input-file--is-focus:after{transform:scale(1)}.input-file__label{display:block;position:absolute;top:8px;left:0;color:rgba(0,0,0,.54);line-height:32px;pointer-events:none;transform:translateY(24px);transform-origin:bottom left;transition-property:transform,color;transition-duration:.4s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.input-file--is-active .input-file__label{transform:scale(.75) translateY(0)}.input-file--is-focus .input-file__label{color:#2196f3}.input-file__filename{display:block;height:32px;width:100%;overflow:hidden;line-height:32px;text-overflow:ellipsis;white-space:nowrap}.input-file__input{position:absolute;top:32px;left:0;height:32px;width:100%;opacity:0;cursor:pointer}.dropdown-link--is-large .mdi,.dropdown-link:not(.dropdown-link--is-header) .mdi,.icon,.lx-select-choices--default-style .lx-select-choices__choice .mdi,.lx-select-choices--default-style .lx-select-choices__subheader .mdi{vertical-align:top;text-align:center}.dropdown-link:not(.dropdown-link--is-header) .icon--circled.mdi,.icon--xs.icon--circled,.lx-select-choices--default-style .lx-select-choices__choice .icon--circled.mdi,.lx-select-choices--default-style .lx-select-choices__subheader .icon--circled.mdi{height:24px;width:24px;line-height:24px!important;font-size:10px;font-size:.625rem}.dropdown-link--is-large .icon--xs.mdi,.dropdown-link:not(.dropdown-link--is-header) .icon--flat.mdi,.dropdown-link:not(.dropdown-link--is-header) .icon--xs.mdi,.dropdown-link:not(.dropdown-link--is-header) .mdi,.icon--xs.icon--flat,.lx-select-choices--default-style .lx-select-choices__choice .icon--flat.mdi,.lx-select-choices--default-style .lx-select-choices__choice .icon--xs.mdi,.lx-select-choices--default-style .lx-select-choices__choice .mdi,.lx-select-choices--default-style .lx-select-choices__subheader .icon--flat.mdi,.lx-select-choices--default-style .lx-select-choices__subheader .icon--xs.mdi,.lx-select-choices--default-style .lx-select-choices__subheader .mdi{height:24px;width:24px;line-height:24px!important;font-size:18px;font-size:1.125rem}.dropdown-link--is-large .icon--circled.mdi,.icon--s.icon--circled{height:30px;width:30px;line-height:30px!important;font-size:12px;font-size:.75rem}.dropdown-link--is-large .dropdown-link:not(.dropdown-link--is-header) .mdi,.dropdown-link--is-large .icon--flat.mdi,.dropdown-link--is-large .icon--s.mdi,.dropdown-link--is-large .lx-select-choices--default-style .lx-select-choices__choice .mdi,.dropdown-link--is-large .lx-select-choices--default-style .lx-select-choices__subheader .mdi,.dropdown-link--is-large .mdi,.dropdown-link:not(.dropdown-link--is-header) .dropdown-link--is-large .mdi,.dropdown-link:not(.dropdown-link--is-header) .icon--s.mdi,.icon--s.icon--flat,.lx-select-choices--default-style .lx-select-choices__choice .dropdown-link--is-large .mdi,.lx-select-choices--default-style .lx-select-choices__choice .icon--s.mdi,.lx-select-choices--default-style .lx-select-choices__subheader .dropdown-link--is-large .mdi,.lx-select-choices--default-style .lx-select-choices__subheader .icon--s.mdi{height:30px;width:30px;line-height:30px!important;font-size:24px;font-size:1.5rem}.icon--m.icon--circled{height:36px;width:36px;line-height:36px!important;font-size:14px;font-size:.875rem}.dropdown-link--is-large .icon--m.mdi,.dropdown-link:not(.dropdown-link--is-header) .icon--m.mdi,.icon--m.icon--flat,.lx-select-choices--default-style .lx-select-choices__choice .icon--m.mdi,.lx-select-choices--default-style .lx-select-choices__subheader .icon--m.mdi{height:36px;width:36px;line-height:36px!important;font-size:30px;font-size:1.875rem}.icon--l.icon--circled{height:40px;width:40px;line-height:40px!important;font-size:18px;font-size:1.125rem}.dropdown-link--is-large .icon--l.mdi,.dropdown-link:not(.dropdown-link--is-header) .icon--l.mdi,.icon--l.icon--flat,.lx-select-choices--default-style .lx-select-choices__choice .icon--l.mdi,.lx-select-choices--default-style .lx-select-choices__subheader .icon--l.mdi{height:40px;width:40px;line-height:40px!important;font-size:34px;font-size:2.125rem}.icon--xl.icon--circled{height:56px;width:56px;line-height:56px!important;font-size:26px;font-size:1.625rem}.dropdown-link--is-large .icon--xl.mdi,.dropdown-link:not(.dropdown-link--is-header) .icon--xl.mdi,.icon--xl.icon--flat,.lx-select-choices--default-style .lx-select-choices__choice .icon--xl.mdi,.lx-select-choices--default-style .lx-select-choices__subheader .icon--xl.mdi{height:56px;width:56px;line-height:56px!important;font-size:50px;font-size:3.125rem}.icon--circled.icon--red{color:#fff;background-color:#f44336}.icon--flat.icon--red{color:#f44336}.icon--circled.icon--pink{color:#fff;background-color:#e91e63}.icon--flat.icon--pink{color:#e91e63}.icon--circled.icon--purple{color:#fff;background-color:#9c27b0}.icon--flat.icon--purple{color:#9c27b0}.icon--circled.icon--deep-purple{color:#fff;background-color:#673ab7}.icon--flat.icon--deep-purple{color:#673ab7}.icon--circled.icon--indigo{color:#fff;background-color:#3f51b5}.icon--flat.icon--indigo{color:#3f51b5}.icon--circled.icon--blue{color:#fff;background-color:#2196f3}.icon--flat.icon--blue{color:#2196f3}.icon--circled.icon--light-blue{color:#fff;background-color:#03a9f4}.icon--flat.icon--light-blue{color:#03a9f4}.icon--circled.icon--cyan{color:#fff;background-color:#00bcd4}.icon--flat.icon--cyan{color:#00bcd4}.icon--circled.icon--teal{color:#fff;background-color:#009688}.icon--flat.icon--teal{color:#009688}.icon--circled.icon--green{color:#fff;background-color:#4caf50}.icon--flat.icon--green{color:#4caf50}.icon--circled.icon--light-green{color:#fff;background-color:#8bc34a}.icon--flat.icon--light-green{color:#8bc34a}.icon--circled.icon--lime{color:#fff;background-color:#cddc39}.icon--flat.icon--lime{color:#cddc39}.icon--circled.icon--yellow{color:#fff;background-color:#ffeb3b}.icon--flat.icon--yellow{color:#ffeb3b}.icon--circled.icon--amber{color:#fff;background-color:#ffc107}.icon--flat.icon--amber{color:#ffc107}.icon--circled.icon--orange{color:#fff;background-color:#ff9800}.icon--flat.icon--orange{color:#ff9800}.icon--circled.icon--deep-orange{color:#fff;background-color:#ff5722}.icon--flat.icon--deep-orange{color:#ff5722}.icon--circled.icon--brown{color:#fff;background-color:#795548}.icon--flat.icon--brown{color:#795548}.icon--circled.icon--grey{color:#fff;background-color:#9e9e9e}.icon--flat.icon--grey{color:#9e9e9e}.icon--circled.icon--blue-grey{color:#fff;background-color:#607d8b}.icon--flat.icon--blue-grey{color:#607d8b}.icon--circled.icon--black{color:#fff;background-color:#000}.icon--flat.icon--black{color:#000}.icon--circled.icon--white{color:#fff;background-color:#fff}.icon--flat.icon--white{color:#fff}.icon--circled.icon--primary{color:#fff;background-color:#2196f3}.icon--flat.icon--primary{color:#2196f3}.icon--circled.icon--primary-hue-1{color:#fff;background-color:#bbdefb}.icon--flat.icon--primary-hue-1{color:#bbdefb}.icon--circled.icon--primary-hue-2{color:#fff;background-color:#1976d2}.icon--flat.icon--primary-hue-2{color:#1976d2}.icon--circled.icon--accent{color:#fff;background-color:#448aff}.icon--flat.icon--accent{color:#448aff}.icon--circled.icon--accent-hue-1{color:#fff;background-color:#82b1ff}.icon--flat.icon--accent-hue-1{color:#82b1ff}.icon--circled.icon--accent-hue-2{color:#fff;background-color:#2979ff}.icon--flat.icon--accent-hue-2{color:#2979ff}.icon--circled{border-radius:50%}.list-row{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;position:relative;padding:0 16px}.list-row.list-row--multi-line .list-primary-tile,.list-row.list-row--multi-line .list-row__primary,.list-row.list-row--multi-line .list-row__secondary,.list-row.list-row--multi-line .list-secondary-tile{padding:16px 0}.list-row:not(.list-row--multi-line) .list-content-tile,.list-row:not(.list-row--multi-line) .list-primary-tile,.list-row:not(.list-row--multi-line) .list-row__content,.list-row:not(.list-row--multi-line) .list-row__primary,.list-row:not(.list-row--multi-line) .list-row__secondary,.list-row:not(.list-row--multi-line) .list-secondary-tile{box-pack:center;-moz-justify-content:center;-ms-justify-content:center;-o-justify-content:center;justify-content:center;-ms-flex-pack:center}.list-row:not(.list-row--multi-line) .list-primary-tile,.list-row:not(.list-row--multi-line) .list-row__primary,.list-row:not(.list-row--multi-line) .list-row__secondary,.list-row:not(.list-row--multi-line) .list-secondary-tile{padding:8px 0}.list-row--has-separator .list-row__content:after{content:\"\";position:absolute;right:0;bottom:0;left:0;height:1px;background-color:rgba(0,0,0,.12)}.list-row--has-separator:last-child .list-row__content:after{display:none}.list-row--is-clickable{cursor:pointer}.list-row--is-active,.list-row--is-clickable:hover{background-color:#f5f5f5}.list-content-tile,.list-primary-tile,.list-row__content,.list-row__primary,.list-row__secondary,.list-secondary-tile{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:vertical;box-direction:normal;-moz-flex-direction:column;flex-direction:column;-ms-flex-direction:column}.list-primary-tile,.list-row__primary{width:56px}.list-content-tile,.list-row__content{position:relative;box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;padding:12px 0}.list-row__secondary,.list-secondary-tile{box-align:end;-moz-align-items:flex-end;-ms-align-items:flex-end;-o-align-items:flex-end;align-items:flex-end;-ms-flex-align:end;width:40px}.list-divider{height:1px;margin-top:8px;margin-bottom:8px;background-color:rgba(0,0,0,.12)}.list-divider--is-pushed{margin-left:72px}.list-subheader{padding:12px 16px;color:rgba(0,0,0,.54)}.list-subheader--is-pushed{margin-left:56px}.notification{position:fixed;right:24px;bottom:0;max-width:300px;padding:16px 24px;border-radius:2px;background-color:#323232;cursor:pointer;transform:translateY(100%);transition-property:margin-bottom transform;transition-duration:.4s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.notification--is-shown{transform:translateY(-24px)}.notification__content,.notification__icon{opacity:0;transition-property:opacity;transition-duration:.4s}.notification--is-shown .notification__content,.notification--is-shown .notification__icon{opacity:1}.notification__content{display:block;font-size:14px;font-size:.875rem;color:#fff;line-height:20px}.notification--has-icon .notification__content{padding-left:32px}.notification__icon{position:absolute;top:16px;left:24px;font-size:14px;font-size:.875rem;color:#fff;line-height:20px!important}.notification--red .notification__icon{color:#f44336}.notification--pink .notification__icon{color:#e91e63}.notification--purple .notification__icon{color:#9c27b0}.notification--deep-purple .notification__icon{color:#673ab7}.notification--indigo .notification__icon{color:#3f51b5}.notification--blue .notification__icon{color:#2196f3}.notification--light-blue .notification__icon{color:#03a9f4}.notification--cyan .notification__icon{color:#00bcd4}.notification--teal .notification__icon{color:#009688}.notification--green .notification__icon{color:#4caf50}.notification--light-green .notification__icon{color:#8bc34a}.notification--lime .notification__icon{color:#cddc39}.notification--yellow .notification__icon{color:#ffeb3b}.notification--amber .notification__icon{color:#ffc107}.notification--orange .notification__icon{color:#ff9800}.notification--deep-orange .notification__icon{color:#ff5722}.notification--brown .notification__icon{color:#795548}.notification--grey .notification__icon{color:#9e9e9e}.notification--blue-grey .notification__icon{color:#607d8b}.notification--black .notification__icon{color:#000}.notification--white .notification__icon{color:#fff}.notification--primary .notification__icon{color:#2196f3}.notification--primary-hue-1 .notification__icon{color:#bbdefb}.notification--primary-hue-2 .notification__icon{color:#1976d2}.notification--accent .notification__icon{color:#448aff}.notification--accent-hue-1 .notification__icon{color:#82b1ff}.notification--accent-hue-2 .notification__icon{color:#2979ff}@keyframes lx-progress-circular-rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes lx-progress-circular-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px}to{stroke-dasharray:89,200;stroke-dashoffset:-124px}}@keyframes lx-progress-linear-bar1{0%{transform:scale(.5) translateX(-150%)}37.5%{transform:scale(.75) translateX(0)}75%{transform:scale(.5) translateX(150%)}to{transform:scale(.5) translateX(150%)}}@keyframes lx-progress-linear-bar2{0%{transform:scale(.5) translateX(-250%)}40%{transform:scale(.5) translateX(-250%)}55%{transform:scale(.5) translateX(-150%)}70%{transform:scale(.5) translateX(-50%)}85%{transform:scale(.25) translateX(150%)}to{transform:scale(.25) translateX(250%)}}.progress-container--circular.progress-container--red .progress-circular__path{stroke:#f44336}.progress-container--linear.progress-container--red .progress-linear__background,.progress-container--linear.progress-container--red .progress-linear__bar{background-color:#f44336}.progress-container--circular.progress-container--pink .progress-circular__path{stroke:#e91e63}.progress-container--linear.progress-container--pink .progress-linear__background,.progress-container--linear.progress-container--pink .progress-linear__bar{background-color:#e91e63}.progress-container--circular.progress-container--purple .progress-circular__path{stroke:#9c27b0}.progress-container--linear.progress-container--purple .progress-linear__background,.progress-container--linear.progress-container--purple .progress-linear__bar{background-color:#9c27b0}.progress-container--circular.progress-container--deep-purple .progress-circular__path{stroke:#673ab7}.progress-container--linear.progress-container--deep-purple .progress-linear__background,.progress-container--linear.progress-container--deep-purple .progress-linear__bar{background-color:#673ab7}.progress-container--circular.progress-container--indigo .progress-circular__path{stroke:#3f51b5}.progress-container--linear.progress-container--indigo .progress-linear__background,.progress-container--linear.progress-container--indigo .progress-linear__bar{background-color:#3f51b5}.progress-container--circular.progress-container--blue .progress-circular__path{stroke:#2196f3}.progress-container--linear.progress-container--blue .progress-linear__background,.progress-container--linear.progress-container--blue .progress-linear__bar{background-color:#2196f3}.progress-container--circular.progress-container--light-blue .progress-circular__path{stroke:#03a9f4}.progress-container--linear.progress-container--light-blue .progress-linear__background,.progress-container--linear.progress-container--light-blue .progress-linear__bar{background-color:#03a9f4}.progress-container--circular.progress-container--cyan .progress-circular__path{stroke:#00bcd4}.progress-container--linear.progress-container--cyan .progress-linear__background,.progress-container--linear.progress-container--cyan .progress-linear__bar{background-color:#00bcd4}.progress-container--circular.progress-container--teal .progress-circular__path{stroke:#009688}.progress-container--linear.progress-container--teal .progress-linear__background,.progress-container--linear.progress-container--teal .progress-linear__bar{background-color:#009688}.progress-container--circular.progress-container--green .progress-circular__path{stroke:#4caf50}.progress-container--linear.progress-container--green .progress-linear__background,.progress-container--linear.progress-container--green .progress-linear__bar{background-color:#4caf50}.progress-container--circular.progress-container--light-green .progress-circular__path{stroke:#8bc34a}.progress-container--linear.progress-container--light-green .progress-linear__background,.progress-container--linear.progress-container--light-green .progress-linear__bar{background-color:#8bc34a}.progress-container--circular.progress-container--lime .progress-circular__path{stroke:#cddc39}.progress-container--linear.progress-container--lime .progress-linear__background,.progress-container--linear.progress-container--lime .progress-linear__bar{background-color:#cddc39}.progress-container--circular.progress-container--yellow .progress-circular__path{stroke:#ffeb3b}.progress-container--linear.progress-container--yellow .progress-linear__background,.progress-container--linear.progress-container--yellow .progress-linear__bar{background-color:#ffeb3b}.progress-container--circular.progress-container--amber .progress-circular__path{stroke:#ffc107}.progress-container--linear.progress-container--amber .progress-linear__background,.progress-container--linear.progress-container--amber .progress-linear__bar{background-color:#ffc107}.progress-container--circular.progress-container--orange .progress-circular__path{stroke:#ff9800}.progress-container--linear.progress-container--orange .progress-linear__background,.progress-container--linear.progress-container--orange .progress-linear__bar{background-color:#ff9800}.progress-container--circular.progress-container--deep-orange .progress-circular__path{stroke:#ff5722}.progress-container--linear.progress-container--deep-orange .progress-linear__background,.progress-container--linear.progress-container--deep-orange .progress-linear__bar{background-color:#ff5722}.progress-container--circular.progress-container--brown .progress-circular__path{stroke:#795548}.progress-container--linear.progress-container--brown .progress-linear__background,.progress-container--linear.progress-container--brown .progress-linear__bar{background-color:#795548}.progress-container--circular.progress-container--grey .progress-circular__path{stroke:#9e9e9e}.progress-container--linear.progress-container--grey .progress-linear__background,.progress-container--linear.progress-container--grey .progress-linear__bar{background-color:#9e9e9e}.progress-container--circular.progress-container--blue-grey .progress-circular__path{stroke:#607d8b}.progress-container--linear.progress-container--blue-grey .progress-linear__background,.progress-container--linear.progress-container--blue-grey .progress-linear__bar{background-color:#607d8b}.progress-container--circular.progress-container--black .progress-circular__path{stroke:#000}.progress-container--linear.progress-container--black .progress-linear__background,.progress-container--linear.progress-container--black .progress-linear__bar{background-color:#000}.progress-container--circular.progress-container--white .progress-circular__path{stroke:#fff}.progress-container--linear.progress-container--white .progress-linear__background,.progress-container--linear.progress-container--white .progress-linear__bar{background-color:#fff}.progress-container--circular.progress-container--primary .progress-circular__path{stroke:#2196f3}.progress-container--linear.progress-container--primary .progress-linear__background,.progress-container--linear.progress-container--primary .progress-linear__bar{background-color:#2196f3}.progress-container--circular.progress-container--primary-hue-1 .progress-circular__path{stroke:#bbdefb}.progress-container--linear.progress-container--primary-hue-1 .progress-linear__background,.progress-container--linear.progress-container--primary-hue-1 .progress-linear__bar{background-color:#bbdefb}.progress-container--circular.progress-container--primary-hue-2 .progress-circular__path{stroke:#1976d2}.progress-container--linear.progress-container--primary-hue-2 .progress-linear__background,.progress-container--linear.progress-container--primary-hue-2 .progress-linear__bar{background-color:#1976d2}.progress-container--circular.progress-container--accent .progress-circular__path{stroke:#448aff}.progress-container--linear.progress-container--accent .progress-linear__background,.progress-container--linear.progress-container--accent .progress-linear__bar{background-color:#448aff}.progress-container--circular.progress-container--accent-hue-1 .progress-circular__path{stroke:#82b1ff}.progress-container--linear.progress-container--accent-hue-1 .progress-linear__background,.progress-container--linear.progress-container--accent-hue-1 .progress-linear__bar{background-color:#82b1ff}.progress-container--circular.progress-container--accent-hue-2 .progress-circular__path{stroke:#2979ff}.progress-container--linear.progress-container--accent-hue-2 .progress-linear__background,.progress-container--linear.progress-container--accent-hue-2 .progress-linear__bar{background-color:#2979ff}.progress-circular{position:relative;width:100px;margin:0 auto}.progress-circular:before{content:\"\";display:block;padding-top:100%}.progress-circular__svg{position:absolute;top:0;right:0;bottom:0;left:0;height:100%;width:100%;margin:auto;animation:lx-progress-circular-rotate 2s linear infinite;transform-origin:center center}.progress-circular__path{stroke-dasharray:1,200;stroke-dashoffset:0;stroke-linecap:round;animation:lx-progress-circular-dash 1.5s ease-in-out infinite}.progress-linear{position:relative;height:4px;overflow:hidden}.progress-linear__background{position:absolute;top:0;right:0;bottom:0;left:0;opacity:.4}.progress-linear__bar{transform:scale(1) translateX(50%)}.progress-linear__bar--first{position:absolute;top:-12px;height:24px;width:100%;animation:lx-progress-linear-bar1 2s linear infinite}.progress-linear__bar--second{position:absolute;top:-48px;height:96px;width:100%;animation:lx-progress-linear-bar2 2s linear infinite}.radio-group .radio-button{margin-bottom:8px}.radio-button{min-width:24px;min-height:24px}.radio-button--red .radio-button__label:after{color:#f44336}.radio-button--pink .radio-button__label:after{color:#e91e63}.radio-button--purple .radio-button__label:after{color:#9c27b0}.radio-button--deep-purple .radio-button__label:after{color:#673ab7}.radio-button--indigo .radio-button__label:after{color:#3f51b5}.radio-button--blue .radio-button__label:after{color:#2196f3}.radio-button--light-blue .radio-button__label:after{color:#03a9f4}.radio-button--cyan .radio-button__label:after{color:#00bcd4}.radio-button--teal .radio-button__label:after{color:#009688}.radio-button--green .radio-button__label:after{color:#4caf50}.radio-button--light-green .radio-button__label:after{color:#8bc34a}.radio-button--lime .radio-button__label:after{color:#cddc39}.radio-button--yellow .radio-button__label:after{color:#ffeb3b}.radio-button--amber .radio-button__label:after{color:#ffc107}.radio-button--orange .radio-button__label:after{color:#ff9800}.radio-button--deep-orange .radio-button__label:after{color:#ff5722}.radio-button--brown .radio-button__label:after{color:#795548}.radio-button--grey .radio-button__label:after{color:#9e9e9e}.radio-button--blue-grey .radio-button__label:after{color:#607d8b}.radio-button--black .radio-button__label:after{color:#000}.radio-button--white .radio-button__label:after{color:#fff}.radio-button--primary .radio-button__label:after{color:#2196f3}.radio-button--primary-hue-1 .radio-button__label:after{color:#bbdefb}.radio-button--primary-hue-2 .radio-button__label:after{color:#1976d2}.radio-button--accent .radio-button__label:after{color:#448aff}.radio-button--accent-hue-1 .radio-button__label:after{color:#82b1ff}.radio-button--accent-hue-2 .radio-button__label:after{color:#2979ff}.radio-button__input:not(:checked)+.radio-button__label:before{opacity:1}.radio-button__input:checked+.radio-button__label:before,.radio-button__input:not(:checked)+.radio-button__label:after{opacity:0}.radio-button__input:checked+.radio-button__label:after{opacity:1}.radio-button__input[disabled]+.radio-button__label{cursor:not-allowed}.radio-button__input[disabled]+.radio-button__label,.radio-button__input[disabled]+.radio-button__label:after,.radio-button__input[disabled]+.radio-button__label:before,.radio-button__input[disabled]~.radio-button__help{color:rgba(0,0,0,.38)}.radio-button__label{display:block;position:relative;padding-left:32px;font-weight:400;line-height:24px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.radio-button--standalone .radio-button__label{padding-left:0}.radio-button__label:after,.radio-button__label:before{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0);position:absolute;top:0;left:0;font-size:24px;font-size:1.5rem;line-height:24px;transition-property:opacity;transition-duration:.2s}.radio-button__label:before{content:\"\\F43D\";color:rgba(0,0,0,.54)}.radio-button__label:after{content:\"\\F43E\";color:#448aff}.radio-button__help{display:block;padding-left:32px;font-weight:400;line-height:20px;color:rgba(0,0,0,.54);text-align:left}@media screen and (max-width:1023px){.radio-button__help{font-size:14px;font-size:.875rem}}@media screen and (min-width:1024px){.radio-button__help{font-size:13px;font-size:.8125rem}}.ripple{display:block;position:absolute;border-radius:100%;opacity:.3;transform:scale(0);pointer-events:none}.ripple--is-animated{animation:ripple .65s linear}.search-filter{position:relative;overflow:hidden;height:40px}.search-filter--opened-mode{width:100%}.search-filter--closed-mode{width:40px}.search-filter--red .search-filter__clear,.search-filter--red .search-filter__input input{color:#f44336}.search-filter--red .search-filter__input input::-webkit-input-placeholder{color:rgba(244,67,54,.5)}.search-filter--red .search-filter__input input:-moz-placeholder,.search-filter--red .search-filter__input input::-moz-placeholder{color:rgba(244,67,54,.5)}.search-filter--red .search-filter__input input:-ms-input-placeholder{color:rgba(244,67,54,.5)}.search-filter--pink .search-filter__clear,.search-filter--pink .search-filter__input input{color:#e91e63}.search-filter--pink .search-filter__input input::-webkit-input-placeholder{color:rgba(233,30,99,.5)}.search-filter--pink .search-filter__input input:-moz-placeholder,.search-filter--pink .search-filter__input input::-moz-placeholder{color:rgba(233,30,99,.5)}.search-filter--pink .search-filter__input input:-ms-input-placeholder{color:rgba(233,30,99,.5)}.search-filter--purple .search-filter__clear,.search-filter--purple .search-filter__input input{color:#9c27b0}.search-filter--purple .search-filter__input input::-webkit-input-placeholder{color:rgba(156,39,176,.5)}.search-filter--purple .search-filter__input input:-moz-placeholder,.search-filter--purple .search-filter__input input::-moz-placeholder{color:rgba(156,39,176,.5)}.search-filter--purple .search-filter__input input:-ms-input-placeholder{color:rgba(156,39,176,.5)}.search-filter--deep-purple .search-filter__clear,.search-filter--deep-purple .search-filter__input input{color:#673ab7}.search-filter--deep-purple .search-filter__input input::-webkit-input-placeholder{color:rgba(103,58,183,.5)}.search-filter--deep-purple .search-filter__input input:-moz-placeholder,.search-filter--deep-purple .search-filter__input input::-moz-placeholder{color:rgba(103,58,183,.5)}.search-filter--deep-purple .search-filter__input input:-ms-input-placeholder{color:rgba(103,58,183,.5)}.search-filter--indigo .search-filter__clear,.search-filter--indigo .search-filter__input input{color:#3f51b5}.search-filter--indigo .search-filter__input input::-webkit-input-placeholder{color:rgba(63,81,181,.5)}.search-filter--indigo .search-filter__input input:-moz-placeholder,.search-filter--indigo .search-filter__input input::-moz-placeholder{color:rgba(63,81,181,.5)}.search-filter--indigo .search-filter__input input:-ms-input-placeholder{color:rgba(63,81,181,.5)}.search-filter--blue .search-filter__clear,.search-filter--blue .search-filter__input input{color:#2196f3}.search-filter--blue .search-filter__input input::-webkit-input-placeholder{color:rgba(33,150,243,.5)}.search-filter--blue .search-filter__input input:-moz-placeholder,.search-filter--blue .search-filter__input input::-moz-placeholder{color:rgba(33,150,243,.5)}.search-filter--blue .search-filter__input input:-ms-input-placeholder{color:rgba(33,150,243,.5)}.search-filter--light-blue .search-filter__clear,.search-filter--light-blue .search-filter__input input{color:#03a9f4}.search-filter--light-blue .search-filter__input input::-webkit-input-placeholder{color:rgba(3,169,244,.5)}.search-filter--light-blue .search-filter__input input:-moz-placeholder,.search-filter--light-blue .search-filter__input input::-moz-placeholder{color:rgba(3,169,244,.5)}.search-filter--light-blue .search-filter__input input:-ms-input-placeholder{color:rgba(3,169,244,.5)}.search-filter--cyan .search-filter__clear,.search-filter--cyan .search-filter__input input{color:#00bcd4}.search-filter--cyan .search-filter__input input::-webkit-input-placeholder{color:rgba(0,188,212,.5)}.search-filter--cyan .search-filter__input input:-moz-placeholder,.search-filter--cyan .search-filter__input input::-moz-placeholder{color:rgba(0,188,212,.5)}.search-filter--cyan .search-filter__input input:-ms-input-placeholder{color:rgba(0,188,212,.5)}.search-filter--teal .search-filter__clear,.search-filter--teal .search-filter__input input{color:#009688}.search-filter--teal .search-filter__input input::-webkit-input-placeholder{color:rgba(0,150,136,.5)}.search-filter--teal .search-filter__input input:-moz-placeholder,.search-filter--teal .search-filter__input input::-moz-placeholder{color:rgba(0,150,136,.5)}.search-filter--teal .search-filter__input input:-ms-input-placeholder{color:rgba(0,150,136,.5)}.search-filter--green .search-filter__clear,.search-filter--green .search-filter__input input{color:#4caf50}.search-filter--green .search-filter__input input::-webkit-input-placeholder{color:rgba(76,175,80,.5)}.search-filter--green .search-filter__input input:-moz-placeholder,.search-filter--green .search-filter__input input::-moz-placeholder{color:rgba(76,175,80,.5)}.search-filter--green .search-filter__input input:-ms-input-placeholder{color:rgba(76,175,80,.5)}.search-filter--light-green .search-filter__clear,.search-filter--light-green .search-filter__input input{color:#8bc34a}.search-filter--light-green .search-filter__input input::-webkit-input-placeholder{color:rgba(139,195,74,.5)}.search-filter--light-green .search-filter__input input:-moz-placeholder,.search-filter--light-green .search-filter__input input::-moz-placeholder{color:rgba(139,195,74,.5)}.search-filter--light-green .search-filter__input input:-ms-input-placeholder{color:rgba(139,195,74,.5)}.search-filter--lime .search-filter__clear,.search-filter--lime .search-filter__input input{color:#cddc39}.search-filter--lime .search-filter__input input::-webkit-input-placeholder{color:rgba(205,220,57,.5)}.search-filter--lime .search-filter__input input:-moz-placeholder,.search-filter--lime .search-filter__input input::-moz-placeholder{color:rgba(205,220,57,.5)}.search-filter--lime .search-filter__input input:-ms-input-placeholder{color:rgba(205,220,57,.5)}.search-filter--yellow .search-filter__clear,.search-filter--yellow .search-filter__input input{color:#ffeb3b}.search-filter--yellow .search-filter__input input::-webkit-input-placeholder{color:rgba(255,235,59,.5)}.search-filter--yellow .search-filter__input input:-moz-placeholder,.search-filter--yellow .search-filter__input input::-moz-placeholder{color:rgba(255,235,59,.5)}.search-filter--yellow .search-filter__input input:-ms-input-placeholder{color:rgba(255,235,59,.5)}.search-filter--amber .search-filter__clear,.search-filter--amber .search-filter__input input{color:#ffc107}.search-filter--amber .search-filter__input input::-webkit-input-placeholder{color:rgba(255,193,7,.5)}.search-filter--amber .search-filter__input input:-moz-placeholder,.search-filter--amber .search-filter__input input::-moz-placeholder{color:rgba(255,193,7,.5)}.search-filter--amber .search-filter__input input:-ms-input-placeholder{color:rgba(255,193,7,.5)}.search-filter--orange .search-filter__clear,.search-filter--orange .search-filter__input input{color:#ff9800}.search-filter--orange .search-filter__input input::-webkit-input-placeholder{color:rgba(255,152,0,.5)}.search-filter--orange .search-filter__input input:-moz-placeholder,.search-filter--orange .search-filter__input input::-moz-placeholder{color:rgba(255,152,0,.5)}.search-filter--orange .search-filter__input input:-ms-input-placeholder{color:rgba(255,152,0,.5)}.search-filter--deep-orange .search-filter__clear,.search-filter--deep-orange .search-filter__input input{color:#ff5722}.search-filter--deep-orange .search-filter__input input::-webkit-input-placeholder{color:rgba(255,87,34,.5)}.search-filter--deep-orange .search-filter__input input:-moz-placeholder,.search-filter--deep-orange .search-filter__input input::-moz-placeholder{color:rgba(255,87,34,.5)}.search-filter--deep-orange .search-filter__input input:-ms-input-placeholder{color:rgba(255,87,34,.5)}.search-filter--brown .search-filter__clear,.search-filter--brown .search-filter__input input{color:#795548}.search-filter--brown .search-filter__input input::-webkit-input-placeholder{color:rgba(121,85,72,.5)}.search-filter--brown .search-filter__input input:-moz-placeholder,.search-filter--brown .search-filter__input input::-moz-placeholder{color:rgba(121,85,72,.5)}.search-filter--brown .search-filter__input input:-ms-input-placeholder{color:rgba(121,85,72,.5)}.search-filter--grey .search-filter__clear,.search-filter--grey .search-filter__input input{color:#9e9e9e}.search-filter--grey .search-filter__input input::-webkit-input-placeholder{color:hsla(0,0%,62%,.5)}.search-filter--grey .search-filter__input input:-moz-placeholder,.search-filter--grey .search-filter__input input::-moz-placeholder{color:hsla(0,0%,62%,.5)}.search-filter--grey .search-filter__input input:-ms-input-placeholder{color:hsla(0,0%,62%,.5)}.search-filter--blue-grey .search-filter__clear,.search-filter--blue-grey .search-filter__input input{color:#607d8b}.search-filter--blue-grey .search-filter__input input::-webkit-input-placeholder{color:rgba(96,125,139,.5)}.search-filter--blue-grey .search-filter__input input:-moz-placeholder,.search-filter--blue-grey .search-filter__input input::-moz-placeholder{color:rgba(96,125,139,.5)}.search-filter--blue-grey .search-filter__input input:-ms-input-placeholder{color:rgba(96,125,139,.5)}.search-filter--black .search-filter__clear,.search-filter--black .search-filter__input input{color:#000}.search-filter--black .search-filter__input input::-webkit-input-placeholder{color:rgba(0,0,0,.5)}.search-filter--black .search-filter__input input:-moz-placeholder,.search-filter--black .search-filter__input input::-moz-placeholder{color:rgba(0,0,0,.5)}.search-filter--black .search-filter__input input:-ms-input-placeholder{color:rgba(0,0,0,.5)}.search-filter--white .search-filter__clear,.search-filter--white .search-filter__input input{color:#fff}.search-filter--white .search-filter__input input::-webkit-input-placeholder{color:hsla(0,0%,100%,.5)}.search-filter--white .search-filter__input input:-moz-placeholder,.search-filter--white .search-filter__input input::-moz-placeholder{color:hsla(0,0%,100%,.5)}.search-filter--white .search-filter__input input:-ms-input-placeholder{color:hsla(0,0%,100%,.5)}.search-filter--primary .search-filter__clear,.search-filter--primary .search-filter__input input{color:#2196f3}.search-filter--primary .search-filter__input input::-webkit-input-placeholder{color:rgba(33,150,243,.5)}.search-filter--primary .search-filter__input input:-moz-placeholder,.search-filter--primary .search-filter__input input::-moz-placeholder{color:rgba(33,150,243,.5)}.search-filter--primary .search-filter__input input:-ms-input-placeholder{color:rgba(33,150,243,.5)}.search-filter--primary-hue-1 .search-filter__clear,.search-filter--primary-hue-1 .search-filter__input input{color:#bbdefb}.search-filter--primary-hue-1 .search-filter__input input::-webkit-input-placeholder{color:rgba(187,222,251,.5)}.search-filter--primary-hue-1 .search-filter__input input:-moz-placeholder,.search-filter--primary-hue-1 .search-filter__input input::-moz-placeholder{color:rgba(187,222,251,.5)}.search-filter--primary-hue-1 .search-filter__input input:-ms-input-placeholder{color:rgba(187,222,251,.5)}.search-filter--primary-hue-2 .search-filter__clear,.search-filter--primary-hue-2 .search-filter__input input{color:#1976d2}.search-filter--primary-hue-2 .search-filter__input input::-webkit-input-placeholder{color:rgba(25,118,210,.5)}.search-filter--primary-hue-2 .search-filter__input input:-moz-placeholder,.search-filter--primary-hue-2 .search-filter__input input::-moz-placeholder{color:rgba(25,118,210,.5)}.search-filter--primary-hue-2 .search-filter__input input:-ms-input-placeholder{color:rgba(25,118,210,.5)}.search-filter--accent .search-filter__clear,.search-filter--accent .search-filter__input input{color:#448aff}.search-filter--accent .search-filter__input input::-webkit-input-placeholder{color:rgba(68,138,255,.5)}.search-filter--accent .search-filter__input input:-moz-placeholder,.search-filter--accent .search-filter__input input::-moz-placeholder{color:rgba(68,138,255,.5)}.search-filter--accent .search-filter__input input:-ms-input-placeholder{color:rgba(68,138,255,.5)}.search-filter--accent-hue-1 .search-filter__clear,.search-filter--accent-hue-1 .search-filter__input input{color:#82b1ff}.search-filter--accent-hue-1 .search-filter__input input::-webkit-input-placeholder{color:rgba(130,177,255,.5)}.search-filter--accent-hue-1 .search-filter__input input:-moz-placeholder,.search-filter--accent-hue-1 .search-filter__input input::-moz-placeholder{color:rgba(130,177,255,.5)}.search-filter--accent-hue-1 .search-filter__input input:-ms-input-placeholder{color:rgba(130,177,255,.5)}.search-filter--accent-hue-2 .search-filter__clear,.search-filter--accent-hue-2 .search-filter__input input{color:#2979ff}.search-filter--accent-hue-2 .search-filter__input input::-webkit-input-placeholder{color:rgba(41,121,255,.5)}.search-filter--accent-hue-2 .search-filter__input input:-moz-placeholder,.search-filter--accent-hue-2 .search-filter__input input::-moz-placeholder{color:rgba(41,121,255,.5)}.search-filter--accent-hue-2 .search-filter__input input:-ms-input-placeholder{color:rgba(41,121,255,.5)}.search-filter__container{position:relative;height:40px;padding:0 40px 0 56px}.search-filter--closed-mode .search-filter__container{width:240px}.search-filter__button{position:absolute;top:0;left:0;height:40px;width:40px}.search-filter__input input{display:block;margin:0;padding:0;border:none;background-color:transparent;box-shadow:none;overflow:hidden;cursor:text;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;height:40px;width:100%}.search-filter__input input:focus{outline:none}.search-filter__clear{position:absolute;top:0;right:0;height:40px;width:40px;font-size:24px;font-size:1.5rem;text-align:center;cursor:pointer;transform:translateX(40px);transition-property:transform;transition-duration:.4s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.search-filter__clear .mdi{line-height:40px}.search-filter--has-clear-button .search-filter__clear{transform:translateX(0)}.lx-select{position:relative;padding-top:32px;padding-bottom:8px}.lx-select:after,.lx-select:before{content:\"\"}.lx-select:before{position:absolute;right:0;bottom:7px;left:0;height:1px;border-bottom:1px solid rgba(0,0,0,.12)}.lx-select:after{position:absolute;right:0;bottom:6px;left:0;height:2px;transform:scale(0);transition-property:transform;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.lx-select .dropdown{display:block}.lx-select--is-disabled{pointer-events:none}.lx-select--is-disabled:before{border-bottom-style:dashed}.lx-select--valid:after{background-color:#4caf50;transform:scale(1)}.lx-select--error:after{background-color:#f44336;transform:scale(1)}.lx-select-label{display:block;position:absolute;top:8px;left:0;color:rgba(0,0,0,.54);line-height:32px;pointer-events:none;transform:translateY(24px);transform-origin:bottom left;transition-property:transform,color;transition-duration:.4s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.lx-select--is-active.lx-select--fixed-label .lx-select-label{display:none}.lx-select--is-active .lx-select-label{transform:scale(.75) translateY(0)}.lx-select--is-disabled .lx-select-label{color:rgba(0,0,0,.38)}.lx-select--valid .lx-select-label{color:#4caf50}.lx-select--error .lx-select-label{color:#f44336}.lx-select-selected-wrapper{min-height:32px;padding-right:24px}.lx-select-selected-wrapper:after{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0);content:\"\\F35D\";position:absolute;right:8px;bottom:8px;font-size:14px;font-size:.875rem;color:rgba(0,0,0,.38);line-height:16px}.dropdown--is-open .lx-select-selected-wrapper:after{content:\"\\F360\"}.lx-select--is-unique .lx-select-selected:hover .lx-select-selected__clear{opacity:1}.lx-select--is-multiple .lx-select-selected{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;-webkit-box-lines:multiple;-moz-box-lines:multiple;box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:4px 0}.lx-select-selected__value{display:block;line-height:32px}.lx-select--is-disabled .lx-select-selected__value{color:rgba(0,0,0,.38)}.lx-select-selected__clear{display:block;position:absolute;top:0;right:24px;opacity:0;line-height:32px;transition-property:opacity,color;transition-duration:.2s}.lx-select-selected__clear:hover{color:#f44336}.lx-select-selected__tag{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;margin:2px;padding:0 4px;border-radius:2px;background-color:#eee;cursor:pointer;font-size:12px;font-size:.75rem;line-height:20px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.lx-select-selected__tag:after{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0);content:\"\\F159\";margin-left:4px;font-size:14px;font-size:.875rem;color:#bdbdbd}.lx-select-selected__tag:first-child{margin-left:0}.lx-select-selected__tag:last-child{margin-right:0}.lx-select-selected__tag:hover{background-color:#757575;color:#fff}.lx-select-selected__tag:hover:after{color:#fff}.lx-select--is-disabled .lx-select-selected__tag{color:rgba(0,0,0,.38)}.lx-select--is-disabled .lx-select-selected__tag:after{display:none}.lx-select-choices--default-style .lx-select-choices__filter{padding:2px 8px;margin-bottom:8px;border-bottom:1px solid rgba(0,0,0,.12)}.lx-select-choices--default-style .lx-select-choices__choice,.lx-select-choices--default-style .lx-select-choices__subheader{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center;position:relative;height:32px;padding:0 32px 0 16px;font-size:14px;font-size:.875rem;line-height:32px;text-decoration:none;white-space:nowrap}.lx-select-choices--default-style .lx-select-choices__choice .mdi,.lx-select-choices--default-style .lx-select-choices__subheader .mdi{margin-right:16px}.lx-select-choices--default-style .lx-select-choices__choice{cursor:pointer;color:rgba(0,0,0,.87)}.lx-select-choices--default-style .lx-select-choices__choice .mdi{color:rgba(0,0,0,.54)}.lx-select-choices--default-style .lx-select-choices__choice:hover,.lx-select-choices--is-unique.lx-select-choices--default-style .lx-select-choices__choice.lx-select-choices__choice--is-selected{background-color:#eee}.lx-select-choices--is-multiple.lx-select-choices--default-style .lx-select-choices__choice{padding-left:46px}.lx-select-choices--is-multiple.lx-select-choices--default-style .lx-select-choices__choice:after,.lx-select-choices--is-multiple.lx-select-choices--default-style .lx-select-choices__choice:before{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0);position:absolute;top:0;left:16px;height:32px;width:24px;font-size:18px;font-size:1.125rem;line-height:32px;text-align:center;transition-property:opacity;transition-duration:.2s}.lx-select-choices--is-multiple.lx-select-choices--default-style .lx-select-choices__choice:before{opacity:1;content:\"\\F131\";color:rgba(0,0,0,.54)}.lx-select-choices--is-multiple.lx-select-choices--default-style .lx-select-choices__choice:after{opacity:0;content:\"\\F132\";color:#448aff}.lx-select-choices--is-multiple.lx-select-choices--default-style .lx-select-choices__choice.lx-select-choices__choice--is-selected:before{opacity:0}.lx-select-choices--is-multiple.lx-select-choices--default-style .lx-select-choices__choice.lx-select-choices__choice--is-selected:after{opacity:1}.lx-select-choices--default-style .lx-select-choices__subheader,.lx-select-choices--default-style .lx-select-choices__subheader .mdi{color:rgba(0,0,0,.38)}.lx-select-choices--default-style .lx-select-choices__loader{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;box-pack:center;-moz-justify-content:center;-ms-justify-content:center;-o-justify-content:center;justify-content:center;-ms-flex-pack:center}.switch{min-width:35px;min-height:24px}.switch--red .switch__input:checked+.switch__label:before{background-color:rgba(244,67,54,.5)}.switch--red .switch__input:checked+.switch__label:after{background-color:#f44336}.switch--pink .switch__input:checked+.switch__label:before{background-color:rgba(233,30,99,.5)}.switch--pink .switch__input:checked+.switch__label:after{background-color:#e91e63}.switch--purple .switch__input:checked+.switch__label:before{background-color:rgba(156,39,176,.5)}.switch--purple .switch__input:checked+.switch__label:after{background-color:#9c27b0}.switch--deep-purple .switch__input:checked+.switch__label:before{background-color:rgba(103,58,183,.5)}.switch--deep-purple .switch__input:checked+.switch__label:after{background-color:#673ab7}.switch--indigo .switch__input:checked+.switch__label:before{background-color:rgba(63,81,181,.5)}.switch--indigo .switch__input:checked+.switch__label:after{background-color:#3f51b5}.switch--blue .switch__input:checked+.switch__label:before{background-color:rgba(33,150,243,.5)}.switch--blue .switch__input:checked+.switch__label:after{background-color:#2196f3}.switch--light-blue .switch__input:checked+.switch__label:before{background-color:rgba(3,169,244,.5)}.switch--light-blue .switch__input:checked+.switch__label:after{background-color:#03a9f4}.switch--cyan .switch__input:checked+.switch__label:before{background-color:rgba(0,188,212,.5)}.switch--cyan .switch__input:checked+.switch__label:after{background-color:#00bcd4}.switch--teal .switch__input:checked+.switch__label:before{background-color:rgba(0,150,136,.5)}.switch--teal .switch__input:checked+.switch__label:after{background-color:#009688}.switch--green .switch__input:checked+.switch__label:before{background-color:rgba(76,175,80,.5)}.switch--green .switch__input:checked+.switch__label:after{background-color:#4caf50}.switch--light-green .switch__input:checked+.switch__label:before{background-color:rgba(139,195,74,.5)}.switch--light-green .switch__input:checked+.switch__label:after{background-color:#8bc34a}.switch--lime .switch__input:checked+.switch__label:before{background-color:rgba(205,220,57,.5)}.switch--lime .switch__input:checked+.switch__label:after{background-color:#cddc39}.switch--yellow .switch__input:checked+.switch__label:before{background-color:rgba(255,235,59,.5)}.switch--yellow .switch__input:checked+.switch__label:after{background-color:#ffeb3b}.switch--amber .switch__input:checked+.switch__label:before{background-color:rgba(255,193,7,.5)}.switch--amber .switch__input:checked+.switch__label:after{background-color:#ffc107}.switch--orange .switch__input:checked+.switch__label:before{background-color:rgba(255,152,0,.5)}.switch--orange .switch__input:checked+.switch__label:after{background-color:#ff9800}.switch--deep-orange .switch__input:checked+.switch__label:before{background-color:rgba(255,87,34,.5)}.switch--deep-orange .switch__input:checked+.switch__label:after{background-color:#ff5722}.switch--brown .switch__input:checked+.switch__label:before{background-color:rgba(121,85,72,.5)}.switch--brown .switch__input:checked+.switch__label:after{background-color:#795548}.switch--grey .switch__input:checked+.switch__label:before{background-color:hsla(0,0%,62%,.5)}.switch--grey .switch__input:checked+.switch__label:after{background-color:#9e9e9e}.switch--blue-grey .switch__input:checked+.switch__label:before{background-color:rgba(96,125,139,.5)}.switch--blue-grey .switch__input:checked+.switch__label:after{background-color:#607d8b}.switch--black .switch__input:checked+.switch__label:before{background-color:rgba(0,0,0,.5)}.switch--black .switch__input:checked+.switch__label:after{background-color:#000}.switch--white .switch__input:checked+.switch__label:before{background-color:hsla(0,0%,100%,.5)}.switch--white .switch__input:checked+.switch__label:after{background-color:#fff}.switch--primary .switch__input:checked+.switch__label:before{background-color:rgba(33,150,243,.5)}.switch--primary .switch__input:checked+.switch__label:after{background-color:#2196f3}.switch--primary-hue-1 .switch__input:checked+.switch__label:before{background-color:rgba(187,222,251,.5)}.switch--primary-hue-1 .switch__input:checked+.switch__label:after{background-color:#bbdefb}.switch--primary-hue-2 .switch__input:checked+.switch__label:before{background-color:rgba(25,118,210,.5)}.switch--primary-hue-2 .switch__input:checked+.switch__label:after{background-color:#1976d2}.switch--accent .switch__input:checked+.switch__label:before{background-color:rgba(68,138,255,.5)}.switch--accent .switch__input:checked+.switch__label:after{background-color:#448aff}.switch--accent-hue-1 .switch__input:checked+.switch__label:before{background-color:rgba(130,177,255,.5)}.switch--accent-hue-1 .switch__input:checked+.switch__label:after{background-color:#82b1ff}.switch--accent-hue-2 .switch__input:checked+.switch__label:before{background-color:rgba(41,121,255,.5)}.switch--accent-hue-2 .switch__input:checked+.switch__label:after{background-color:#2979ff}.switch__input:not(:checked)+.switch__label:before{background-color:rgba(0,0,0,.38)}.switch__input:not(:checked)+.switch__label:after{background-color:#fafafa}.switch__input:checked+.switch__label:before{background-color:rgba(68,138,255,.5)}.switch__input:checked+.switch__label:after{background-color:#448aff;transform:translateX(15px)}.switch__input[disabled]+.switch__label{cursor:not-allowed;color:rgba(0,0,0,.38)}.switch__input[disabled]+.switch__label:before{background-color:rgba(0,0,0,.12)}.switch__input[disabled]+.switch__label:after{background-color:#bdbdbd}.switch__input[disabled]~.switch__help{color:rgba(0,0,0,.38)}.switch__label{display:block;position:relative;padding-left:45px;font-weight:400;line-height:24px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.switch--standalone .switch__label{padding-left:0}.switch__label:before{top:5px;z-index:1;height:14px;width:35px;border-radius:7px;transition-property:background-color}.switch__label:after,.switch__label:before{content:\"\";position:absolute;left:0;transition-duration:.2s}.switch__label:after{top:2px;z-index:2;display:block;height:20px;width:20px;border-radius:50%;box-shadow:0 3px 1px -2px rgba(0,0,0,.14),0 2px 2px 0 rgba(0,0,0,.098),0 1px 5px 0 rgba(0,0,0,.084);transition-property:background-color,transform}.switch__help{display:block;padding-left:45px;font-weight:400;line-height:20px;color:rgba(0,0,0,.54);text-align:left}@media screen and (max-width:1023px){.switch__help{font-size:14px;font-size:.875rem}}@media screen and (min-width:1024px){.switch__help{font-size:13px;font-size:.8125rem}}.tabs{position:relative;overflow:hidden}.tabs--theme-light.tabs--color-red .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-red .tabs__link:not(.tabs__link--is-disabled):hover{color:#f44336}.tabs--theme-dark.tabs--color-red .tabs__links,.tabs--theme-dark.tabs--indicator-red .tabs__indicator,.tabs--theme-light.tabs--color-red .tabs__indicator{background-color:#f44336}.tabs--theme-light.tabs--color-pink .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-pink .tabs__link:not(.tabs__link--is-disabled):hover{color:#e91e63}.tabs--theme-dark.tabs--color-pink .tabs__links,.tabs--theme-dark.tabs--indicator-pink .tabs__indicator,.tabs--theme-light.tabs--color-pink .tabs__indicator{background-color:#e91e63}.tabs--theme-light.tabs--color-purple .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-purple .tabs__link:not(.tabs__link--is-disabled):hover{color:#9c27b0}.tabs--theme-dark.tabs--color-purple .tabs__links,.tabs--theme-dark.tabs--indicator-purple .tabs__indicator,.tabs--theme-light.tabs--color-purple .tabs__indicator{background-color:#9c27b0}.tabs--theme-light.tabs--color-deep-purple .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-deep-purple .tabs__link:not(.tabs__link--is-disabled):hover{color:#673ab7}.tabs--theme-dark.tabs--color-deep-purple .tabs__links,.tabs--theme-dark.tabs--indicator-deep-purple .tabs__indicator,.tabs--theme-light.tabs--color-deep-purple .tabs__indicator{background-color:#673ab7}.tabs--theme-light.tabs--color-indigo .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-indigo .tabs__link:not(.tabs__link--is-disabled):hover{color:#3f51b5}.tabs--theme-dark.tabs--color-indigo .tabs__links,.tabs--theme-dark.tabs--indicator-indigo .tabs__indicator,.tabs--theme-light.tabs--color-indigo .tabs__indicator{background-color:#3f51b5}.tabs--theme-light.tabs--color-blue .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-blue .tabs__link:not(.tabs__link--is-disabled):hover{color:#2196f3}.tabs--theme-dark.tabs--color-blue .tabs__links,.tabs--theme-dark.tabs--indicator-blue .tabs__indicator,.tabs--theme-light.tabs--color-blue .tabs__indicator{background-color:#2196f3}.tabs--theme-light.tabs--color-light-blue .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-light-blue .tabs__link:not(.tabs__link--is-disabled):hover{color:#03a9f4}.tabs--theme-dark.tabs--color-light-blue .tabs__links,.tabs--theme-dark.tabs--indicator-light-blue .tabs__indicator,.tabs--theme-light.tabs--color-light-blue .tabs__indicator{background-color:#03a9f4}.tabs--theme-light.tabs--color-cyan .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-cyan .tabs__link:not(.tabs__link--is-disabled):hover{color:#00bcd4}.tabs--theme-dark.tabs--color-cyan .tabs__links,.tabs--theme-dark.tabs--indicator-cyan .tabs__indicator,.tabs--theme-light.tabs--color-cyan .tabs__indicator{background-color:#00bcd4}.tabs--theme-light.tabs--color-teal .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-teal .tabs__link:not(.tabs__link--is-disabled):hover{color:#009688}.tabs--theme-dark.tabs--color-teal .tabs__links,.tabs--theme-dark.tabs--indicator-teal .tabs__indicator,.tabs--theme-light.tabs--color-teal .tabs__indicator{background-color:#009688}.tabs--theme-light.tabs--color-green .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-green .tabs__link:not(.tabs__link--is-disabled):hover{color:#4caf50}.tabs--theme-dark.tabs--color-green .tabs__links,.tabs--theme-dark.tabs--indicator-green .tabs__indicator,.tabs--theme-light.tabs--color-green .tabs__indicator{background-color:#4caf50}.tabs--theme-light.tabs--color-light-green .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-light-green .tabs__link:not(.tabs__link--is-disabled):hover{color:#8bc34a}.tabs--theme-dark.tabs--color-light-green .tabs__links,.tabs--theme-dark.tabs--indicator-light-green .tabs__indicator,.tabs--theme-light.tabs--color-light-green .tabs__indicator{background-color:#8bc34a}.tabs--theme-light.tabs--color-lime .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-lime .tabs__link:not(.tabs__link--is-disabled):hover{color:#cddc39}.tabs--theme-dark.tabs--color-lime .tabs__links,.tabs--theme-dark.tabs--indicator-lime .tabs__indicator,.tabs--theme-light.tabs--color-lime .tabs__indicator{background-color:#cddc39}.tabs--theme-light.tabs--color-yellow .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-yellow .tabs__link:not(.tabs__link--is-disabled):hover{color:#ffeb3b}.tabs--theme-dark.tabs--color-yellow .tabs__links,.tabs--theme-dark.tabs--indicator-yellow .tabs__indicator,.tabs--theme-light.tabs--color-yellow .tabs__indicator{background-color:#ffeb3b}.tabs--theme-light.tabs--color-amber .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-amber .tabs__link:not(.tabs__link--is-disabled):hover{color:#ffc107}.tabs--theme-dark.tabs--color-amber .tabs__links,.tabs--theme-dark.tabs--indicator-amber .tabs__indicator,.tabs--theme-light.tabs--color-amber .tabs__indicator{background-color:#ffc107}.tabs--theme-light.tabs--color-orange .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-orange .tabs__link:not(.tabs__link--is-disabled):hover{color:#ff9800}.tabs--theme-dark.tabs--color-orange .tabs__links,.tabs--theme-dark.tabs--indicator-orange .tabs__indicator,.tabs--theme-light.tabs--color-orange .tabs__indicator{background-color:#ff9800}.tabs--theme-light.tabs--color-deep-orange .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-deep-orange .tabs__link:not(.tabs__link--is-disabled):hover{color:#ff5722}.tabs--theme-dark.tabs--color-deep-orange .tabs__links,.tabs--theme-dark.tabs--indicator-deep-orange .tabs__indicator,.tabs--theme-light.tabs--color-deep-orange .tabs__indicator{background-color:#ff5722}.tabs--theme-light.tabs--color-brown .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-brown .tabs__link:not(.tabs__link--is-disabled):hover{color:#795548}.tabs--theme-dark.tabs--color-brown .tabs__links,.tabs--theme-dark.tabs--indicator-brown .tabs__indicator,.tabs--theme-light.tabs--color-brown .tabs__indicator{background-color:#795548}.tabs--theme-light.tabs--color-grey .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-grey .tabs__link:not(.tabs__link--is-disabled):hover{color:#9e9e9e}.tabs--theme-dark.tabs--color-grey .tabs__links,.tabs--theme-dark.tabs--indicator-grey .tabs__indicator,.tabs--theme-light.tabs--color-grey .tabs__indicator{background-color:#9e9e9e}.tabs--theme-light.tabs--color-blue-grey .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-blue-grey .tabs__link:not(.tabs__link--is-disabled):hover{color:#607d8b}.tabs--theme-dark.tabs--color-blue-grey .tabs__links,.tabs--theme-dark.tabs--indicator-blue-grey .tabs__indicator,.tabs--theme-light.tabs--color-blue-grey .tabs__indicator{background-color:#607d8b}.tabs--theme-light.tabs--color-black .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-black .tabs__link:not(.tabs__link--is-disabled):hover{color:#000}.tabs--theme-dark.tabs--color-black .tabs__links,.tabs--theme-dark.tabs--indicator-black .tabs__indicator,.tabs--theme-light.tabs--color-black .tabs__indicator{background-color:#000}.tabs--theme-light.tabs--color-white .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-white .tabs__link:not(.tabs__link--is-disabled):hover{color:#fff}.tabs--theme-dark.tabs--color-white .tabs__links,.tabs--theme-dark.tabs--indicator-white .tabs__indicator,.tabs--theme-light.tabs--color-white .tabs__indicator{background-color:#fff}.tabs--theme-light.tabs--color-primary .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-primary .tabs__link:not(.tabs__link--is-disabled):hover{color:#2196f3}.tabs--theme-dark.tabs--color-primary .tabs__links,.tabs--theme-dark.tabs--indicator-primary .tabs__indicator,.tabs--theme-light.tabs--color-primary .tabs__indicator{background-color:#2196f3}.tabs--theme-light.tabs--color-primary-hue-1 .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-primary-hue-1 .tabs__link:not(.tabs__link--is-disabled):hover{color:#bbdefb}.tabs--theme-dark.tabs--color-primary-hue-1 .tabs__links,.tabs--theme-dark.tabs--indicator-primary-hue-1 .tabs__indicator,.tabs--theme-light.tabs--color-primary-hue-1 .tabs__indicator{background-color:#bbdefb}.tabs--theme-light.tabs--color-primary-hue-2 .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-primary-hue-2 .tabs__link:not(.tabs__link--is-disabled):hover{color:#1976d2}.tabs--theme-dark.tabs--color-primary-hue-2 .tabs__links,.tabs--theme-dark.tabs--indicator-primary-hue-2 .tabs__indicator,.tabs--theme-light.tabs--color-primary-hue-2 .tabs__indicator{background-color:#1976d2}.tabs--theme-light.tabs--color-accent .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-accent .tabs__link:not(.tabs__link--is-disabled):hover{color:#448aff}.tabs--theme-dark.tabs--color-accent .tabs__links,.tabs--theme-dark.tabs--indicator-accent .tabs__indicator,.tabs--theme-light.tabs--color-accent .tabs__indicator{background-color:#448aff}.tabs--theme-light.tabs--color-accent-hue-1 .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-accent-hue-1 .tabs__link:not(.tabs__link--is-disabled):hover{color:#82b1ff}.tabs--theme-dark.tabs--color-accent-hue-1 .tabs__links,.tabs--theme-dark.tabs--indicator-accent-hue-1 .tabs__indicator,.tabs--theme-light.tabs--color-accent-hue-1 .tabs__indicator{background-color:#82b1ff}.tabs--theme-light.tabs--color-accent-hue-2 .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-light.tabs--color-accent-hue-2 .tabs__link:not(.tabs__link--is-disabled):hover{color:#2979ff}.tabs--theme-dark.tabs--color-accent-hue-2 .tabs__links,.tabs--theme-dark.tabs--indicator-accent-hue-2 .tabs__indicator,.tabs--theme-light.tabs--color-accent-hue-2 .tabs__indicator{background-color:#2979ff}.tabs__links{position:relative;display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row}.tabs--layout-center .tabs__links{box-pack:center;-moz-justify-content:center;-ms-justify-content:center;-o-justify-content:center;justify-content:center;-ms-flex-pack:center}.tabs--theme-light .tabs__links:after{content:\"\";position:absolute;right:0;bottom:0;left:0;height:1px;background-color:rgba(0,0,0,.12)}.tabs__link{display:block;height:48px;cursor:pointer;font-weight:500;line-height:48px;text-align:center;text-transform:uppercase;transition-property:color;transition-duration:.2s}@media screen and (max-width:1023px){.tabs__link{font-size:14px;font-size:.875rem}}@media screen and (min-width:1024px){.tabs__link{font-size:13px;font-size:.8125rem}}.tabs__link .mdi{font-size:24px;font-size:1.5rem;line-height:48px}.tabs--layout-full .tabs__link{box-flex:1;-moz-flex:1;-ms-flex:1;flex:1}@media screen and (max-width:480px){.tabs--layout-center .tabs__link,.tabs--layout-inline .tabs__link{padding-left:12px;padding-right:12px}}@media screen and (min-width:481px){.tabs--layout-center .tabs__link,.tabs--layout-inline .tabs__link{padding-left:24px;padding-right:24px}}.tabs--theme-light .tabs__link{color:rgba(0,0,0,.54)}.tabs--theme-dark .tabs__link{color:hsla(0,0%,100%,.7)}.tabs--theme-dark .tabs__link:not(.tabs__link--is-disabled).tabs__link--is-active,.tabs--theme-dark .tabs__link:not(.tabs__link--is-disabled):hover{color:#fff}.tabs__link--is-disabled{opacity:.5;cursor:not-allowed}.tabs__indicator{position:absolute;top:46px;right:0;left:0;height:2px}.text-field{position:relative;padding-top:32px;padding-bottom:8px}.text-field:after,.text-field:before{content:\"\"}.text-field:before{position:absolute;right:0;bottom:7px;left:0;height:1px;border-bottom-width:1px;border-bottom-style:solid}.text-field:after{position:absolute;right:0;bottom:6px;left:0;height:2px;background-color:#2196f3;transform:scale(0);transition-property:transform;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.text-field.text-field--theme-light:before{border-bottom-color:rgba(0,0,0,.12)}.text-field.text-field--theme-dark:before{border-bottom-color:hsla(0,0%,100%,.12)}.text-field--is-focus:after{transform:scale(1)}.text-field--is-disabled{pointer-events:none}.text-field--is-disabled:before{border-bottom-style:dashed}.text-field--fixed-label{padding-top:8px}.text-field--valid:after{background-color:#4caf50;transform:scale(1)}.text-field--error:after{background-color:#f44336;transform:scale(1)}.text-field--has-icon{margin-left:64px}.text-field__label{display:block;position:absolute;top:8px;left:0;line-height:32px;pointer-events:none;transform:translateY(24px);transform-origin:bottom left;transition-property:transform,color;transition-duration:.4s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.text-field--fixed-label.text-field--has-value .text-field__label{display:none}.text-field--theme-light .text-field__label{color:rgba(0,0,0,.54)}.text-field--theme-dark .text-field__label{color:hsla(0,0%,100%,.7)}.text-field--fixed-label .text-field__label{transform:none}.text-field--is-active:not(.text-field--fixed-label) .text-field__label{transform:scale(.75) translateY(0)}.text-field--is-focus:not(.text-field--fixed-label) .text-field__label{color:#2196f3}.text-field--is-disabled.text-field--theme-light .text-field__label{color:rgba(0,0,0,.38)!important}.text-field--is-disabled.text-field--theme-dark .text-field__label{color:hsla(0,0%,100%,.3)!important}.text-field--valid .text-field__label{color:#4caf50!important}.text-field--error .text-field__label{color:#f44336!important}.text-field__input{display:block;margin:0;padding:0;border:none;background-color:transparent;box-shadow:none;overflow:hidden;cursor:text;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;-o-appearance:none;appearance:none;width:100%;font-weight:400}.text-field__input:focus{outline:none}.text-field--theme-light .text-field__input{color:rgba(0,0,0,.87)}.text-field--theme-dark .text-field__input{color:#fff}.text-field--is-disabled.text-field--theme-light .text-field__input{color:rgba(0,0,0,.38)}.text-field--is-disabled.text-field--theme-dark .text-field__input{color:hsla(0,0%,100%,.3)}input.text-field__input{height:32px}textarea.text-field__input{height:24px;margin:4px 0;resize:none}.text-field__icon{position:absolute;top:2px;left:-68px;height:44px;width:48px;line-height:44px;font-size:24px;font-size:1.5rem;text-align:center;transition-property:color;transition-duration:.4s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.text-field--theme-light .text-field__icon{color:rgba(0,0,0,.54)}.text-field--theme-dark .text-field__icon{color:hsla(0,0%,100%,.7)}.text-field--is-focus .text-field__icon{color:#2196f3}.text-field--valid .text-field__icon{color:#4caf50}.text-field--error .text-field__icon{color:#f44336}.text-field__clear{display:block;position:absolute;right:0;bottom:8px;opacity:0;cursor:pointer;line-height:32px;transition-property:opacity,color;transition-duration:.2s}.text-field__clear:hover{color:#f44336}.text-field:hover .text-field__clear{opacity:1}.text-field-error{color:#f44336}.text-field-error,.text-field-help{display:block;font-size:12px;font-size:.75rem}.text-field-help{color:rgba(0,0,0,.54)}.toolbar{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row;padding:0 16px}@media screen and (max-width:1023px){.toolbar{height:56px;padding-top:8px;padding-bottom:8px}}@media screen and (min-width:1024px){.toolbar{height:64px;padding-top:12px;padding-bottom:12px}}.toolbar__left,.toolbar__right{display:-webkit-box;display:-moz-box;display:box;display:-moz-flex;display:-ms-flexbox;display:flex;box-orient:horizontal;box-direction:normal;-moz-flex-direction:row;flex-direction:row;-ms-flex-direction:row}.toolbar__right{box-pack:end;-moz-justify-content:flex-end;-ms-justify-content:flex-end;-o-justify-content:flex-end;justify-content:flex-end;-ms-flex-pack:end;box-align:center;-moz-align-items:center;-ms-align-items:center;-o-align-items:center;align-items:center;-ms-flex-align:center}.toolbar__label{box-flex:1;-moz-flex:1;-ms-flex:1;flex:1;line-height:40px}.tooltip{position:absolute;z-index:9999;border-radius:2px;opacity:0;overflow:hidden;pointer-events:none;transition-property:opacity,transform;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.tooltip--is-active{opacity:1}@media screen and (max-width:1023px){.tooltip--is-active.tooltip--top{transform:translateY(-24px)}}@media screen and (min-width:1024px){.tooltip--is-active.tooltip--top{transform:translateY(-14px)}}@media screen and (max-width:1023px){.tooltip--is-active.tooltip--bottom{transform:translateY(24px)}}@media screen and (min-width:1024px){.tooltip--is-active.tooltip--bottom{transform:translateY(14px)}}@media screen and (max-width:1023px){.tooltip--is-active.tooltip--left{transform:translateX(-24px)}}@media screen and (min-width:1024px){.tooltip--is-active.tooltip--left{transform:translateX(-14px)}}@media screen and (max-width:1023px){.tooltip--is-active.tooltip--right{transform:translateX(24px)}}@media screen and (min-width:1024px){.tooltip--is-active.tooltip--right{transform:translateX(14px)}}.tooltip__background{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;border-radius:50%;background-color:#616161;transform:scale(0) translateY(50%);transition-property:transform;transition-duration:.6s;transition-timing-function:cubic-bezier(.23,1,.32,1)}.tooltip__label{display:block;color:#fff;white-space:nowrap}@media screen and (max-width:1023px){.tooltip__label{padding:0 16px;font-size:14px;font-size:.875rem;line-height:32px}}@media screen and (min-width:1024px){.tooltip__label{padding:0 8px;font-size:10px;font-size:.625rem;line-height:22px}}.tooltip--top .tooltip__background{transform:scale(0) translateY(50%);transform-origin:center bottom}.tooltip--top.tooltip--is-active .tooltip__background{transform:scale(3) translateY(50%)}.tooltip--bottom .tooltip__background{transform:scale(0) translateY(-50%);transform-origin:center top}.tooltip--bottom.tooltip--is-active .tooltip__background{transform:scale(3) translateY(-50%)}.tooltip--left .tooltip__background{transform:scale(0) translateX(50%);transform-origin:right center}.tooltip--left.tooltip--is-active .tooltip__background{transform:scale(3) translateX(50%)}.tooltip--right .tooltip__background{transform:scale(0) translateX(-50%);transform-origin:left center}.tooltip--right.tooltip--is-active .tooltip__background{transform:scale(3) translateX(-50%)}", ""]);
	
	// exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	exports.i(__webpack_require__(47), "");
	exports.i(__webpack_require__(46), "");
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}selection{background:#2196f3}.data-bold{font-weight:600}.bg-light{background-color:rgba(0,0,0,.06)}.loading{margin-top:50px}.loading h4{margin-top:30px}.checkbox__label:after{color:#2196f3!important}.text-field__label{color:rgba(0,0,0,.6)}.switch__inputchecked+.switch__label:before{background-color:rgba(33,150,243,.5)!important}.switch__inputchecked+.switch__label:after{background-color:#2196f3!important}.lx-select:hover{cursor:pointer}.lx-select__selected:after{color:#000!important}[lx-choices^=\"vm.specialtyOptions\"] .lx-select-selected{max-height:100px;overflow-y:auto}.lx-select-selected-wrapper:after{color:#e91e63!important;font-size:22px!important}.undisable .text-field__input{color:inherit!important;cursor:text!important}.undisable .text-field--is-disabled:before{border-bottom-style:solid!important}.training-switch{display:inline-block;margin:5px 0 0 48px}.mdl-layout.environment.western .training-switch{display:none}@media screen and (min-width:1024px){.dialog--l{width:1400px!important;margin-left:-700px!important}}@media screen and (max-width:1024px){.dialog--l{width:1000px!important;margin-left:-500px!important}}@media screen and (min-width:1024px){#doubleCheck{width:220px!important;margin-left:-110px!important;top:70%}}.lx-date{margin-top:38px}.lx-date .text-field{padding-top:0;padding-bottom:1px}.lx-date .text-field__label{top:-38px;left:-15px}.chip-wrapper{padding:10px}.chip-wrapper .chip{display:inline-flex;padding:7px 12px;border-radius:16px;align-items:center;cursor:default;min-height:32px;height:1px;background-color:#f1f1f1;margin:5px 5px 0 0;font-size:13px}.chip-wrapper .chip.pink{background-color:pink}.chip-wrapper .chip:hover{cursor:pointer}@font-face{font-family:Material Icons;font-style:normal;font-weight:400;src:url(" + __webpack_require__(91) + ");src:local(\"Material Icons\"),local(\"MaterialIcons-Regular\"),url(" + __webpack_require__(94) + ") format(\"woff2\"),url(" + __webpack_require__(93) + ") format(\"woff\"),url(" + __webpack_require__(92) + ") format(\"truetype\")}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;width:1em;height:1em;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\"}@font-face{font-family:Roboto;font-style:normal;font-weight:100;src:local(\"Roboto Thin\"),local(\"Roboto-Thin\"),url(" + __webpack_require__(96) + ") format(\"woff2\"),url(" + __webpack_require__(95) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:300;src:local(\"Roboto Light\"),local(\"Roboto-Light\"),url(" + __webpack_require__(98) + ") format(\"woff2\"),url(" + __webpack_require__(97) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:400;src:local(\"Roboto\"),local(\"Roboto-Regular\"),url(" + __webpack_require__(108) + ") format(\"woff2\"),url(" + __webpack_require__(107) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:italic;font-weight:400;src:local(\"Roboto Italic\"),local(\"Roboto-Italic\"),url(" + __webpack_require__(106) + ") format(\"woff2\"),url(" + __webpack_require__(105) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:500;src:local(\"Roboto Medium\"),local(\"Roboto-Medium\"),url(" + __webpack_require__(100) + ") format(\"woff2\"),url(" + __webpack_require__(99) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:italic;font-weight:500;src:local(\"Roboto Medium Italic\"),local(\"Roboto-MediumItalic\"),url(" + __webpack_require__(102) + ") format(\"woff2\"),url(" + __webpack_require__(101) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:700;src:local(\"Roboto Bold\"),local(\"Roboto-Bold\"),url(" + __webpack_require__(104) + ") format(\"woff2\"),url(" + __webpack_require__(103) + ") format(\"woff\")}.dataTables_wrapper .dataTables_filter{text-align:right}.dataTables_wrapper .dataTables_filter input{margin-left:.5em}.dataTables_wrapper .dataTables_info{padding-top:10px;white-space:nowrap}.dataTables_wrapper .dataTables_processing{display:none!important}.dataTables_wrapper+.mdl-spinner{position:absolute;top:250px;left:50%;text-align:center;z-index:100}.dataTables_wrapper .table-footer{display:flex;padding:2px 0}.dataTables_wrapper .dataTables_paginate{display:inline-block;margin-left:auto}.dataTables_wrapper .mdl-grid.dt-table{padding-top:0;padding-bottom:0}.dataTables_wrapper .mdl-grid.dt-table>.mdl-cell{margin-top:0;margin-bottom:0}.dataTables_wrapper .dataTables_info,.dataTables_wrapper .dt-buttons{display:inline-block;padding:8px 0 8px 24px;line-height:24px}.dataTables_wrapper .dt-buttons .dt-button{font-size:180%;color:rgba(0,0,0,.54);text-transform:uppercase}.dataTables_wrapper .dt-buttons .dt-button:hover{cursor:pointer;color:#000}.dataTables_wrapper .dt-buttons .dt-button:before{display:inline-block;width:32px;text-align:center;vertical-align:middle;font:normal normal normal 36px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0)}.dataTables_wrapper .dt-buttons .buttons-print:before{content:\"\\F42A\"}.dataTables_wrapper .dt-buttons .buttons-csv span{content:\"CSV\"}.dataTables_wrapper .dt-buttons .buttons-csv:before{content:\"\\F4F1\"}.dataTables_wrapper .dt-buttons .buttons-excel span{content:\"EXCEL\"}.dataTables_wrapper .dt-buttons .buttons-excel:before{content:\"\\F21C\"}.dataTables_wrapper .dt-buttons .buttons-select-all span{content:\"SELECT ALL\"}.dataTables_wrapper .dt-buttons .buttons-select-all:before{content:\"\\F4F3\"}.dataTables_wrapper .dt-buttons .buttons-select-none span{content:\"SELECT NONE\"}.dataTables_wrapper .dt-buttons .buttons-select-none:before{content:\"\\F4F5\"}.dataTables_wrapper .dt-buttons .dt-button:last-child:before{content:\"\\F450\"}.dataTables_wrapper .dataTables_filter{display:none}.dataTable thead>tr>td.sorting,.dataTable thead>tr>td.sorting_asc,.dataTable thead>tr>td.sorting_desc,.dataTable thead>tr>th.sorting,.dataTable thead>tr>th.sorting_asc,.dataTable thead>tr>th.sorting_desc{padding-right:30px}.dataTable thead>tr>td:active,.dataTable thead>tr>th:active{outline:none}.dataTable thead .sorting,.dataTable thead .sorting_asc,.dataTable thead .sorting_asc_disabled,.dataTable thead .sorting_desc,.dataTable thead .sorting_desc_disabled{cursor:pointer;position:relative}.dataTable thead .sorting:after,.dataTable thead .sorting:before,.dataTable thead .sorting_asc:after,.dataTable thead .sorting_asc:before,.dataTable thead .sorting_asc_disabled:after,.dataTable thead .sorting_asc_disabled:before,.dataTable thead .sorting_desc:after,.dataTable thead .sorting_desc:before,.dataTable thead .sorting_desc_disabled:after,.dataTable thead .sorting_desc_disabled:before{position:absolute;bottom:11px;display:block;opacity:.3;font-size:1.3em}.dataTable thead .sorting:before,.dataTable thead .sorting_asc:before,.dataTable thead .sorting_asc_disabled:before,.dataTable thead .sorting_desc:before,.dataTable thead .sorting_desc_disabled:before{right:1em;content:\"\\2191\"}.dataTable thead .sorting:after,.dataTable thead .sorting_asc:after,.dataTable thead .sorting_asc_disabled:after,.dataTable thead .sorting_desc:after,.dataTable thead .sorting_desc_disabled:after{right:.5em;content:\"\\2193\"}.dataTable thead .sorting_asc:before,.dataTable thead .sorting_desc:after{opacity:1}.dataTable thead .sorting_asc_disabled:before,.dataTable thead .sorting_desc_disabled:after{opacity:0}.dataTables_wrapper .mdl-data-table tbody tr{height:15px}.dataTables_wrapper .mdl-data-table tbody tr.odd{background-color:rgba(0,0,0,.06)}.dataTables_wrapper .mdl-data-table tbody tr.grandTotals,.dataTables_wrapper .mdl-data-table tbody tr.selected,.dataTables_wrapper .mdl-data-table tbody tr:hover{cursor:pointer;background-color:#2196f3;color:#fff}.dataTables_wrapper .mdl-data-table tbody tr.selected-special{cursor:pointer;background-color:#e91e63;color:#fff}.dataTables_wrapper .mdl-data-table tbody tr.totals{background-color:#f8bbd0}.dataTables_wrapper .mdl-data-table tbody tr.totals:hover{color:#000}.dataTables_wrapper .mdl-data-table tbody tr td{height:15px;padding:8px 8px 8px 18px;border-top:1px solid rgba(0,0,0,.05);border-bottom:1px solid rgba(0,0,0,.05)}.dataTables_wrapper .mdl-data-table tbody tr td:first-of-type{padding-left:24px}.dataTables_wrapper table th{height:38px}.dataTables_wrapper table th.sorting_asc,.dataTables_wrapper table th.sorting_desc{color:rgba(0,0,0,.87)}.dataTables_empty{text-align:center!important;padding-left:0;background-color:#2196f3;color:#fff;text-transform:uppercase}.percentTable thead{display:none}.material-icons.md-18{font-size:18px}.material-icons.md-24{font-size:24px}.material-icons.md-36{font-size:36px}.material-icons.md-48{font-size:48px}.material-icons.md-dark{color:rgba(0,0,0,.54)}.material-icons.md-dark.md-inactive{color:rgba(0,0,0,.26)}.material-icons.md-light{color:#fff}.material-icons.md-light.md-inactive{color:hsla(0,0%,100%,.3)}.demo .beta,.dev .beta,.local .beta,.test .beta{display:block}.western .beta{display:none!important}.local .mdl-layout__header-row,.yellow .mdl-layout__header-row{background:#ffb90c}.mdl-layout-title{color:#f5f5f5;text-decoration:none}.mdl-layout-title span{line-height:60px}.mdl-layout__header span span{display:none}.mdl-layout.environment.demo .mdl-layout__header span span,.mdl-layout.environment.dev .mdl-layout__header span span,.mdl-layout.environment.local .mdl-layout__header span span{text-transform:uppercase;display:inline-block}.mdl-menu a{text-decoration:none}.loggedIn{height:64px;line-height:64px}.login .loggedIn{display:none}@media screen and (max-width:1024px){.mdl-layout__header{display:flex}}.lx-date-picker__actions{display:none}.reports h1,auditlist h1,coding h1,episodes h1,querieslist h1{margin:16px 16px 16px 24px}.reports .lx-select-label,.reports .text-field__label,auditlist .lx-select-label,auditlist .text-field__label,coding .lx-select-label,coding .text-field__label,episodes .lx-select-label,episodes .text-field__label,querieslist .lx-select-label,querieslist .text-field__label{color:#000!important;font-size:160%}.reports .lx-select-label,auditlist .lx-select-label,coding .lx-select-label,episodes .lx-select-label,querieslist .lx-select-label{z-index:10;top:8px!important;left:15px!important}.reports .lx-select--is-active .lx-select-label,auditlist .lx-select--is-active .lx-select-label,coding .lx-select--is-active .lx-select-label,episodes .lx-select--is-active .lx-select-label,querieslist .lx-select--is-active .lx-select-label{left:0!important;top:-5px!important}.reports .mdl-grid-height100,auditlist .mdl-grid-height100,coding .mdl-grid-height100,episodes .mdl-grid-height100,querieslist .mdl-grid-height100{padding-bottom:0}.reports .mdl-grid-height100 .mdl-cell--12-col,auditlist .mdl-grid-height100 .mdl-cell--12-col,coding .mdl-grid-height100 .mdl-cell--12-col,episodes .mdl-grid-height100 .mdl-cell--12-col,querieslist .mdl-grid-height100 .mdl-cell--12-col{margin-bottom:0}.reports #auditTable,auditlist #auditTable,coding #auditTable,episodes #auditTable,querieslist #auditTable{border:0 none}.reports #auditTable .mdl-tooltip,auditlist #auditTable .mdl-tooltip,coding #auditTable .mdl-tooltip,episodes #auditTable .mdl-tooltip,querieslist #auditTable .mdl-tooltip{will-change:unset!important;max-width:none}.reports .auditTable__filters,auditlist .auditTable__filters,coding .auditTable__filters,episodes .auditTable__filters,querieslist .auditTable__filters{background-color:#e6e6e6}.reports .filter__swap,auditlist .filter__swap,coding .filter__swap,episodes .filter__swap,querieslist .filter__swap{position:absolute;right:0}.reports .lx-select-selected__tag,auditlist .lx-select-selected__tag,coding .lx-select-selected__tag,episodes .lx-select-selected__tag,querieslist .lx-select-selected__tag{background-color:#fff}.reports .search-filter__input input,auditlist .search-filter__input input,coding .search-filter__input input,episodes .search-filter__input input,querieslist .search-filter__input input{font-size:16px}.reports .lx-date-input:after,auditlist .lx-date-input:after,coding .lx-date-input:after,episodes .lx-date-input:after,querieslist .lx-date-input:after{display:inline-block;font:normal normal normal 24px/1 Material Design Icons;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0);content:\"\\F35D\";position:absolute;right:8px;top:32px;font-size:14px;font-size:.875rem;color:rgba(0,0,0,.38);line-height:32px}.reports .lx-date-input input,auditlist .lx-date-input input,coding .lx-date-input input,episodes .lx-date-input input,querieslist .lx-date-input input{color:#000!important;font-size:14px}.reports .lx-date-input:focus:after,auditlist .lx-date-input:focus:after,coding .lx-date-input:focus:after,episodes .lx-date-input:focus:after,querieslist .lx-date-input:focus:after{content:\"\\F360\"}.reports .lx-date-input .text-field:before,auditlist .lx-date-input .text-field:before,coding .lx-date-input .text-field:before,episodes .lx-date-input .text-field:before,querieslist .lx-date-input .text-field:before{border-bottom:0 none!important}.reports .lx-date-input,.reports .lx-select-selected-wrapper,auditlist .lx-date-input,auditlist .lx-select-selected-wrapper,coding .lx-date-input,coding .lx-select-selected-wrapper,episodes .lx-date-input,episodes .lx-select-selected-wrapper,querieslist .lx-date-input,querieslist .lx-select-selected-wrapper{background-color:#fff;padding-left:15px;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.reports .lx-date-input:after,.reports .lx-select-selected-wrapper:after,auditlist .lx-date-input:after,auditlist .lx-select-selected-wrapper:after,coding .lx-date-input:after,coding .lx-select-selected-wrapper:after,episodes .lx-date-input:after,episodes .lx-select-selected-wrapper:after,querieslist .lx-date-input:after,querieslist .lx-select-selected-wrapper:after{color:#e91e63;font-size:22px}.reports .mdl-button,auditlist .mdl-button,coding .mdl-button,episodes .mdl-button,querieslist .mdl-button{font-weight:400}.reports .collapse-card__close_handler,auditlist .collapse-card__close_handler,coding .collapse-card__close_handler,episodes .collapse-card__close_handler,querieslist .collapse-card__close_handler{text-align:right}.reports .collapse-card__close_handler:hover,auditlist .collapse-card__close_handler:hover,coding .collapse-card__close_handler:hover,episodes .collapse-card__close_handler:hover,querieslist .collapse-card__close_handler:hover{cursor:pointer;color:#2196f3}.reports .collapse-card__close_handler i,.reports .collapse-card__close_handler span,auditlist .collapse-card__close_handler i,auditlist .collapse-card__close_handler span,coding .collapse-card__close_handler i,coding .collapse-card__close_handler span,episodes .collapse-card__close_handler i,episodes .collapse-card__close_handler span,querieslist .collapse-card__close_handler i,querieslist .collapse-card__close_handler span{display:inline-flex;vertical-align:middle}#auditList__details{z-index:10;background-color:#fff;overflow-x:visible;color:#000}#auditList__details.hide{display:none}#auditList__details .mdl-grid--no-spacing{padding:16px 16px 0 6px}#auditList__details .mdl-list{padding:0}#auditList__details .mdl-list.first-list{padding-left:0}#auditList__details .mdl-list.second-list{margin-left:16px}#auditList__details .mdl-list__item{align-items:flex-start;padding:6px 12px;min-height:20px;font-size:14px;border-style:none none solid;border-width:1px;border-color:#e6e6e6}#auditList__details .mdl-list__item-primary-content{font-weight:600;-ms-flex-positive:0;flex-grow:0;min-width:150px}#auditList__details .mdl-list__item-sub-title{align-items:flex-start;-ms-flex-positive:1;flex-grow:1}#auditList__details .mdl-list__item--two-line{font-size:16px;height:70px;margin-bottom:11px;padding:16px}#auditList__details .mdl-list__item--two-line .mdl-list__item-primary-content{font-weight:400;min-width:260px}#auditList__details .mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-sub-title{color:#000;font-size:14px;line-height:26px}#auditList__details .mdl-list__item--two-line .mdl-list__item-primary-content .mdl-list__item-sub-title strong{color:#000;margin-right:13px}#auditList__details .auditList__middle .mdl-list__item-primary-content{min-width:160px}.auditDetails-card{height:324px;margin-top:-13px}.auditDetails-card .mdl-card__supporting-text{padding:2px 0 0}.auditDetails-card.mdl-card{position:absolute;width:320px}.auditDetails-card.applied-rules{background-color:#fff}.auditDetails-card.applied-rules .mdl-card__title{background-color:#2196f3}.auditDetails-card>.mdl-card__title{color:#fff;padding:8px;background-color:#ec407a;position:relative}.auditDetails-card>.mdl-card__title h4{font-size:16px;line-height:24px;display:-webkit-box;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis}.auditDetails-card>.mdl-card__title h4 span{font-size:16px;font-weight:400}.auditDetails-card__blue>.mdl-card__title{background-color:#2196f3}.auditDetails-card .mdl-data-table{font-weight:600;font-size:16px;color:#000;border:0 none!important}.auditDetails-card .mdl-data-table .mdl-data-table__cell{font-weight:400}.auditDetails-card .mdl-data-table tbody tr{height:12px!important}.auditDetails-card .mdl-data-table tbody tr td{height:12px!important;border:0 none!important;border-bottom:0 none!important;border-top:0 none!important;padding-top:8px;padding-bottom:8px}.auditDetails-card .mdl-card__actions{padding:5px 8px;text-align:right}auditlist .lx-date,coding .lx-date{margin-top:31px}auditlist .lx-date-input:after,coding .lx-date-input:after{top:31px}.mdl-layout.environment.western auditlist [lx-panes-id=audittabs],.mdl-layout.environment.western auditlist [lx-panes-id=audittabs]+.divider,.mdl-layout.environment.western coding [lx-panes-id=audittabs],.mdl-layout.environment.western coding [lx-panes-id=audittabs]+.divider{display:none}@media screen and (max-width:1024px){auditlist .filter__swap,coding .filter__swap,reports .filter__swap{right:35px}auditlist .lx-date-input,coding .lx-date-input,reports .lx-date-input{position:relative}auditlist .lx-date-input:after,coding .lx-date-input:after{top:0}}.il{display:inline-block}.modal-section .modals{width:60%}.modal-section .modals-buffer{width:40%}.modal-section .modal-col{width:44%}.modal-section .modal-col .modal-row{width:95%}.modal-section .modal-col .modal-row .modal-chk{width:70%}.modal-section .modal-col .modal-row .speech-bub{width:20%}.modal-section .modal-col .modal-row .speech-bub .modal{position:relative;overflow:hidden;margin-top:-7px}.modal-section .modal-col-right{width:55%}.modal-section .modal-col-right .modal-row .modal-chk-big{width:75%}.ad-error{padding:15px;color:red}", ""]);
	
	// exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "#drgs{font-size:120%}#drgs__notification{min-width:auto}#drgs__notification button{display:none}#drgs .drg-input{margin-top:24px}", ""]);
	
	// exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "episodes{display:block;margin:-16px}episodes__notification{min-width:auto}episodes__notification button{display:none}episodes .text-field__input{line-height:24px;font-size:.75rem}", ""]);
	
	// exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "#wies{font-size:120%}#wies__notification{min-width:auto}#wies__notification button{display:none}", ""]);
	
	// exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "site{font-size:120%}site__notification{min-width:auto}site__notification button{display:none}site .build-number{opacity:.54}", ""]);
	
	// exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "#specialties{font-size:120%}#specialties__notification{min-width:auto}#specialties__notification button{display:none}#specialties .uppercase{text-transform:uppercase}", ""]);
	
	// exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "#users{font-size:120%}#users__notification{min-width:auto}#users__notification button{display:none}#users .table-defhrs__mtd{table-layout:fixed;width:100%}#users .table-defhrs__mtd th{text-align:center;height:$mdl-tablepadding;background-color:#2196f3;border:1px solid #fff;padding:10px 0}#users .table-defhrs__mtd td{height:$mdl-tablepadding;padding:0;line-height:$mdl-tablepadding;text-align:center;background-color:#e6e6e6}#users .table-defhrs__mtd td .text-field{padding-top:0}#users .text-defhrslx__mtd{text-align:center}", ""]);
	
	// exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".auditedmed h6{display:inline-block;margin-right:10px}.auditedmed h6:last-of-type{margin-right:0}.total-figures{display:inline-block;margin-right:20px;font-size:18px;float:right}", ""]);
	
	// exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "auditprogramresults h6{float:right;display:inline-block;margin-right:10px}auditprogramresults h6:first-of-type{margin-right:0}", ""]);
	
	// exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "auditresultsummary h6{text-align:right;margin-right:10px}auditresultsummary h6:last-of-type{margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "awaitingreview h6{float:right;display:inline-block;margin-right:10px}awaitingreview h6:first-of-type{margin-right:0}", ""]);
	
	// exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "changespercoder .bold{color:#ff91a4}", ""]);
	
	// exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "coderreviewed h6{display:inline-block;margin-right:10px}coderreviewed h6:last-of-type{margin-right:0}", ""]);
	
	// exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "codingactivity .top-filters .lx-select{margin-right:17px;padding-top:14px}codingactivity .top-filters .lx-select .lx-select-selected__value{font-size:16px}", ""]);
	
	// exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".commonicdchanges{color:red}", ""]);
	
	// exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".commonicdchangesbydrg{color:red}", ""]);
	
	// exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".print-btn{position:absolute;bottom:7px}.highcharts-tooltip+text{display:none}#print .bt-white{border-top:1px solid #fff}#print .dataTables_wrapper .mdl-data-table tbody tr.odd{background-color:unset}#print .dataTables_wrapper .mdl-data-table tbody tr:hover{cursor:unset;background-color:#eee;color:inherit}#print .dataTables_wrapper .mdl-data-table tbody tr:hover.grand-footer,#print .dataTables_wrapper .mdl-data-table tbody tr:hover.group-footer,#print .dataTables_wrapper .mdl-data-table tbody tr:hover.group-header{color:rgba(0,0,0,.54)}#print .mdl-data-table{border:1px solid rgba(0,0,0,.12);white-space:normal;width:100%!important}#print .mdl-data-table td,#print .mdl-data-table th{position:static;font-size:13px;height:48px;border-top:1px solid #e0e0e0;border-bottom:none;padding:3px}#print .mdl-data-table td:first-of-type,#print .mdl-data-table th:first-of-type{padding-left:24px}#print .mdl-data-table td:last-of-type,#print .mdl-data-table th:last-of-type{padding-right:24px}#print .group-header{background-color:#eee!important}#print .grand-footer,#print .group-footer,#print .group-header{font-weight:700;color:rgba(0,0,0,.54)}#print .group-header td{border-top:1px solid #c5c5c5!important}#print .mdl-data-table td:first-child{border-top:1px solid #e0e0e0}#print .oa-footer td{border-top:1px solid #e0e0e0!important;background-color:#e91e63;color:#fff;font-weight:700}#print .dataTables_empty{border-bottom:none!important;background-color:#1d8bf1;color:#fff;text-align:center;text-transform:uppercase}#print .chart{width:100%;display:flex;justify-content:center;align-items:center}#print .print-switch{float:right;font-size:13px}#print .lx-select{float:right;width:70%;padding-top:14px;margin-right:16px}#print div.lx-select-selected{display:none}#print .lx-select-label{top:-9px!important}#print .lx-select--is-active.lx-select--fixed-label .lx-select-label{display:block;top:-9px!important;left:15px!important;transform:translateY(24px)}@media print{#print{-webkit-print-color-adjust:exact}#print p{padding-left:0!important}#print .table{padding:0!important}#print .mdl-data-table{margin:16px 0}#print .mdl-data-table td,#print .mdl-data-table th,#print .mdl-data-table tr{font-size:10px;height:28px}#print .chart{display:inline}#print td.bgc-red-500.tc-white.bt-white:first-letter,#print td.bgc-red-500.tc-white.bt-white:first-line{color:#fff!important}#print .lx-select,#print .no-print,#print .print-switch{display:none}}", ""]);
	
	// exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".print-btn{position:absolute;bottom:7px}.highcharts-tooltip+text{display:none}#print .bt-white{border-top:1px solid #fff}#print .dataTables_wrapper .mdl-data-table tbody tr.odd{background-color:unset}#print .dataTables_wrapper .mdl-data-table tbody tr:hover{cursor:unset;background-color:#eee;color:inherit}#print .dataTables_wrapper .mdl-data-table tbody tr:hover.grand-footer,#print .dataTables_wrapper .mdl-data-table tbody tr:hover.group-footer,#print .dataTables_wrapper .mdl-data-table tbody tr:hover.group-header{color:rgba(0,0,0,.54)}#print .mdl-data-table{border:1px solid rgba(0,0,0,.12);white-space:normal;width:100%!important}#print .mdl-data-table td,#print .mdl-data-table th{position:static;font-size:13px;height:48px;border-top:1px solid #e0e0e0;border-bottom:none;padding:3px}#print .mdl-data-table td:first-of-type,#print .mdl-data-table th:first-of-type{padding-left:24px}#print .mdl-data-table td:last-of-type,#print .mdl-data-table th:last-of-type{padding-right:24px}#print .group-header{background-color:#eee!important}#print .grand-footer,#print .group-footer,#print .group-header{font-weight:700;color:rgba(0,0,0,.54)}#print .group-header td{border-top:1px solid #c5c5c5!important}#print .mdl-data-table td:first-child{border-top:1px solid #e0e0e0}#print .oa-footer td{border-top:1px solid #e0e0e0!important;background-color:#e91e63;color:#fff;font-weight:700}#print .dataTables_empty{border-bottom:none!important;background-color:#1d8bf1;color:#fff;text-align:center;text-transform:uppercase}#print .chart{width:100%;display:flex;justify-content:center;align-items:center}#print .print-switch{float:right;font-size:13px}#print .lx-select{float:right;width:70%;padding-top:14px;margin-right:16px}#print div.lx-select-selected{display:none}#print .lx-select-label{top:-9px!important}#print .lx-select--is-active.lx-select--fixed-label .lx-select-label{display:block;top:-9px!important;left:15px!important;transform:translateY(24px)}@media print{#print{-webkit-print-color-adjust:exact}#print p{padding-left:0!important}#print .table{padding:0!important}#print .mdl-data-table{margin:16px 0}#print .mdl-data-table td,#print .mdl-data-table th,#print .mdl-data-table tr{font-size:10px;height:28px}#print .chart{display:inline}#print td.bgc-red-500.tc-white.bt-white:first-letter,#print td.bgc-red-500.tc-white.bt-white:first-line{color:#fff!important}#print .lx-select,#print .no-print,#print .print-switch{display:none}}", ""]);
	
	// exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "queries h6{float:right;display:inline-block;margin-right:10px}queries h6:first-of-type{margin-right:0}", ""]);
	
	// exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "sentqueries .search-filter{margin-top:26px}", ""]);
	
	// exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".auditedmed h6{display:inline-block;margin-right:10px}.auditedmed h6:last-of-type{margin-right:0}", ""]);
	
	// exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}selection{background:#2196f3}.mdl-layout-title{color:#f5f5f5;text-decoration:none}.data-bold{font-weight:600}.bg-light{background-color:rgba(0,0,0,.06)}.loading{margin-top:50px}.loading h4{margin-top:30px}.checkbox__label:after{color:#2196f3!important}.text-field__label{color:rgba(0,0,0,.6)}.switch__inputchecked+.switch__label:before{background-color:rgba(33,150,243,.5)!important}.switch__inputchecked+.switch__label:after{background-color:#2196f3!important}.lx-select:hover{cursor:pointer}.lx-select__selected:after{color:#000!important}[lx-choices^=\"vm.specialtyOptions\"] .lx-select-selected{max-height:100px;overflow-y:auto}.lx-select-selected-wrapper:after{color:#e91e63!important;font-size:22px!important}.undisable .text-field__input{color:inherit!important;cursor:text!important}.undisable .text-field--is-disabled:before{border-bottom-style:solid!important}.training-switch{display:inline-block;margin:5px 0 0 48px}.mdl-layout.environment.western .training-switch{display:none}@media screen and (min-width:1024px){.dialog--l{width:1400px!important;margin-left:-700px!important}}@media screen and (max-width:1024px){.dialog--l{width:1000px!important;margin-left:-500px!important}}@media screen and (min-width:1024px){#doubleCheck{width:220px!important;margin-left:-110px!important;top:70%}}.lx-date{margin-top:38px}.lx-date .text-field{padding-top:0;padding-bottom:1px}.lx-date .text-field__label{top:-38px;left:-15px}.chip-wrapper{padding:10px}.chip-wrapper .chip{display:inline-flex;padding:7px 12px;border-radius:16px;align-items:center;cursor:default;min-height:32px;height:1px;background-color:#f1f1f1;margin:5px 5px 0 0;font-size:13px}.chip-wrapper .chip.pink{background-color:pink}.chip-wrapper .chip:hover{cursor:pointer}admin{z-index:1}admin:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;opacity:.3;z-index:-1;background:url(" + __webpack_require__(11) + ");background-size:cover}.admin__filters{background-color:#e6e6e6}.admin .lx-date{margin-top:31px}.admin .lx-select-selected__value{font-size:.75rem}.admin__stats,.admin h1{margin:16px 16px 16px 24px}.admin__stats{margin-left:0}.admin .lx-select-selected__clear{color:#2196f3;right:30px;font-size:14px}.dropdown-menu--is-open .dropdown-menu__content{padding:8px 16px}.dropdown-menu--is-open .dropdown-menu__content a{text-decoration:none;display:block}.dropdown-menu--is-open .dropdown-menu__content a:hover{color:#2196f3}", ""]);
	
	// exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}selection{background:#2196f3}.mdl-layout-title{color:#f5f5f5;text-decoration:none}.data-bold{font-weight:600}.bg-light{background-color:rgba(0,0,0,.06)}.loading{margin-top:50px}.loading h4{margin-top:30px}.checkbox__label:after{color:#2196f3!important}.text-field__label{color:rgba(0,0,0,.6)}.switch__inputchecked+.switch__label:before{background-color:rgba(33,150,243,.5)!important}.switch__inputchecked+.switch__label:after{background-color:#2196f3!important}.lx-select:hover{cursor:pointer}.lx-select__selected:after{color:#000!important}[lx-choices^=\"vm.specialtyOptions\"] .lx-select-selected{max-height:100px;overflow-y:auto}.lx-select-selected-wrapper:after{color:#e91e63!important;font-size:22px!important}.undisable .text-field__input{color:inherit!important;cursor:text!important}.undisable .text-field--is-disabled:before{border-bottom-style:solid!important}.training-switch{display:inline-block;margin:5px 0 0 48px}.mdl-layout.environment.western .training-switch{display:none}@media screen and (min-width:1024px){.dialog--l{width:1400px!important;margin-left:-700px!important}}@media screen and (max-width:1024px){.dialog--l{width:1000px!important;margin-left:-500px!important}}@media screen and (min-width:1024px){#doubleCheck{width:220px!important;margin-left:-110px!important;top:70%}}.lx-date{margin-top:38px}.lx-date .text-field{padding-top:0;padding-bottom:1px}.lx-date .text-field__label{top:-38px;left:-15px}.chip-wrapper{padding:10px}.chip-wrapper .chip{display:inline-flex;padding:7px 12px;border-radius:16px;align-items:center;cursor:default;min-height:32px;height:1px;background-color:#f1f1f1;margin:5px 5px 0 0;font-size:13px}.chip-wrapper .chip.pink{background-color:pink}.chip-wrapper .chip:hover{cursor:pointer}authentication{z-index:1}authentication:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;opacity:.3;z-index:-1;background:url(" + __webpack_require__(11) + ");background-size:cover}authentication .mdl-card{width:100%}authentication .mdi:before{transform:scale(1.4) translate(6px,18px)}authentication form{width:90%}authentication form .form-error{margin-left:63px}authentication form input[type=submit]{position:absolute;left:-99999px}authentication form .text-field{padding-top:37px}authentication .pull-right{position:absolute!important;right:25px}input:-webkit-autofill,select:-webkit-autofill,textarea:-webkit-autofill{-webkit-text-fill-color:#000!important;background-color:#fff!important;-webkit-box-shadow:0 0 0 50px #fff inset}", ""]);
	
	// exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}selection{background:#2196f3}.mdl-layout-title{color:#f5f5f5;text-decoration:none}.data-bold{font-weight:600}.bg-light{background-color:rgba(0,0,0,.06)}.loading{margin-top:50px}.loading h4{margin-top:30px}.checkbox__label:after{color:#2196f3!important}.text-field__label{color:rgba(0,0,0,.6)}.switch__inputchecked+.switch__label:before{background-color:rgba(33,150,243,.5)!important}.switch__inputchecked+.switch__label:after{background-color:#2196f3!important}.lx-select:hover{cursor:pointer}.lx-select__selected:after{color:#000!important}[lx-choices^=\"vm.specialtyOptions\"] .lx-select-selected{max-height:100px;overflow-y:auto}.lx-select-selected-wrapper:after{color:#e91e63!important;font-size:22px!important}.undisable .text-field__input{color:inherit!important;cursor:text!important}.undisable .text-field--is-disabled:before{border-bottom-style:solid!important}.training-switch{display:inline-block;margin:5px 0 0 48px}.mdl-layout.environment.western .training-switch{display:none}@media screen and (min-width:1024px){.dialog--l{width:1400px!important;margin-left:-700px!important}}@media screen and (max-width:1024px){.dialog--l{width:1000px!important;margin-left:-500px!important}}@media screen and (min-width:1024px){#doubleCheck{width:220px!important;margin-left:-110px!important;top:70%}}.lx-date{margin-top:38px}.lx-date .text-field{padding-top:0;padding-bottom:1px}.lx-date .text-field__label{top:-38px;left:-15px}.chip-wrapper{padding:10px}.chip-wrapper .chip{display:inline-flex;padding:7px 12px;border-radius:16px;align-items:center;cursor:default;min-height:32px;height:1px;background-color:#f1f1f1;margin:5px 5px 0 0;font-size:13px}.chip-wrapper .chip.pink{background-color:pink}.chip-wrapper .chip:hover{cursor:pointer}authentication{z-index:1}authentication:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;opacity:.3;z-index:-1;background:url(" + __webpack_require__(11) + ");background-size:cover}authentication .mdl-card{width:100%}authentication .mdi:before{transform:scale(1.4) translate(6px,18px)}authentication form{width:90%}authentication form .form-error{margin-left:63px}authentication form input[type=submit]{position:absolute;left:-99999px}authentication form .text-field{padding-top:37px}authentication .pull-right{position:absolute!important;right:25px}input:-webkit-autofill,select:-webkit-autofill,textarea:-webkit-autofill{-webkit-text-fill-color:#000!important;background-color:#fff!important;-webkit-box-shadow:0 0 0 50px #fff inset}", ""]);
	
	// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}selection{background:#2196f3}.mdl-layout-title{color:#f5f5f5;text-decoration:none}.data-bold{font-weight:600}.bg-light{background-color:rgba(0,0,0,.06)}.loading{margin-top:50px}.loading h4{margin-top:30px}.checkbox__label:after{color:#2196f3!important}.text-field__label{color:rgba(0,0,0,.6)}.switch__inputchecked+.switch__label:before{background-color:rgba(33,150,243,.5)!important}.switch__inputchecked+.switch__label:after{background-color:#2196f3!important}.lx-select:hover{cursor:pointer}.lx-select__selected:after{color:#000!important}[lx-choices^=\"vm.specialtyOptions\"] .lx-select-selected{max-height:100px;overflow-y:auto}.lx-select-selected-wrapper:after{color:#e91e63!important;font-size:22px!important}.undisable .text-field__input{color:inherit!important;cursor:text!important}.undisable .text-field--is-disabled:before{border-bottom-style:solid!important}.training-switch{display:inline-block;margin:5px 0 0 48px}.mdl-layout.environment.western .training-switch{display:none}@media screen and (min-width:1024px){.dialog--l{width:1400px!important;margin-left:-700px!important}}@media screen and (max-width:1024px){.dialog--l{width:1000px!important;margin-left:-500px!important}}@media screen and (min-width:1024px){#doubleCheck{width:220px!important;margin-left:-110px!important;top:70%}}.lx-date{margin-top:38px}.lx-date .text-field{padding-top:0;padding-bottom:1px}.lx-date .text-field__label{top:-38px;left:-15px}.chip-wrapper{padding:10px}.chip-wrapper .chip{display:inline-flex;padding:7px 12px;border-radius:16px;align-items:center;cursor:default;min-height:32px;height:1px;background-color:#f1f1f1;margin:5px 5px 0 0;font-size:13px}.chip-wrapper .chip.pink{background-color:pink}.chip-wrapper .chip:hover{cursor:pointer}reports{z-index:1}reports:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;opacity:.3;z-index:-1;background:url(" + __webpack_require__(11) + ");background-size:cover}.reports__filters{background-color:#e6e6e6}.reports .lx-date{margin-top:31px}.reports .lx-select-selected__value{font-size:.75rem}.reports__stats,.reports h1{margin:16px 16px 16px 24px}.reports__stats{margin-left:0}.reports .lx-select-selected__clear{color:#2196f3;right:30px;font-size:14px}.dropdown-menu--is-open .dropdown-menu__content{padding:8px 16px}.dropdown-menu--is-open .dropdown-menu__content a{text-decoration:none;display:block}.dropdown-menu--is-open .dropdown-menu__content a:hover{color:#2196f3}", ""]);
	
	// exports


/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/MaterialIcons-Regular.eot";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/MaterialIcons-Regular.ttf";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/MaterialIcons-Regular.woff";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/MaterialIcons-Regular.woff2";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-100.woff";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-100.woff2";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-300.woff";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-300.woff2";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-500.woff";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-500.woff2";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-500italic.woff";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-500italic.woff2";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-700.woff";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-700.woff2";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-italic.woff";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-italic.woff2";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-regular.woff";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/roboto-v15-latin-regular.woff2";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/materialdesignicons-webfont.eot";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/materialdesignicons-webfont.eot";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/materialdesignicons-webfont.svg";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/materialdesignicons-webfont.ttf";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/materialdesignicons-webfont.woff2";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "res/materialdesignicons-webfont.woff";

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en-au": 28,
		"./en-au.js": 28
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 127;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(293);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(348);
	
	var _app3 = __webpack_require__(129);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _app2.default,
	  controller: _app4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = appComponent;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppController = function AppController($scope, $rootScope, User, AuthenticationService, FunctionService, $cookieStore, $location, V2Service, $timeout, $state) {
	  _classCallCheck(this, AppController);
	
	  var initialLocation = window.location.href;
	  this.appFunctions = [];
	  this.appFunctionSettings = {};
	  this.appMenuFunctions = [];
	  this.loginRoute = 'login';
	  this.logoutRoute = 'logout';
	
	  $rootScope.globals = $cookieStore.get('globals') || {};
	  $cookieStore.remove('redirectURL');
	  // console.log('$rootScope.globals: ' + JSON.stringify($rootScope.globals));
	
	  var params = $location.search();
	
	  if (params.token) {
	    // console.log('Got v2 token...');
	    $rootScope.globals = {
	      currentUser: {
	        codingOperationsTeam: false,
	        email: params.email,
	        name: params.firstname + ' ' + params.lastname,
	        speciality: params.speciality,
	        role: params.role,
	        worklist: params.worklist,
	        id: params.userId,
	        token: params.token,
	        roleId: params.roleId,
	        redirectRoute: params.redirectRoute,
	        activeDirectoryToken: '',
	        initialLogin: false,
	        campus: params.campus
	      }
	    };
	
	    AuthenticationService.SetCredentials(false, params.email, params.firstname + ' ' + params.lastname, params.speciality, params.role, params.worklist, params.userId, params.token, Number(params.roleId), '', undefined, undefined, params.campus);
	
	    $cookieStore.put('globals', $rootScope.globals);
	    User.setUser(false, params.firstname + ' ' + params.lastname, params.email, params.speciality, params.role, params.worklist, params.userId, params.token, Number(params.roleId), undefined, false, params.campus);
	    this.user = User.getUser();
	
	    this.userRoleId = 0;
	    if ($rootScope.globals.currentUser && $rootScope.globals.currentUser.roleId) {
	      if (!$scope.vm.user.name) {
	        $scope.vm.user.name = $rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname;
	      }
	      $scope.vm.userRoleId = $rootScope.globals.currentUser.roleId;
	    }
	
	    if (initialLocation.indexOf('v2') > -1) {
	      V2Service.redirectToV2($scope.vm.userRoleId);
	    }
	
	    // If cookie has roleId stored then fetch function list
	    if ($rootScope.globals.currentUser && $rootScope.globals.currentUser.roleId) {
	      FunctionService.getFunctions($rootScope.globals.currentUser.roleId);
	    }
	
	    // Subscribe to functions fetched event then populate side menu lists
	    FunctionService.subscribe($scope, function (event, data) {
	      if (event.name === 'functions-fetched-event') {
	        $scope.vm.appFunctionSettings = data.functionSettings;
	        $scope.vm.appFunctions = data.functions;
	        $scope.vm.appMenuFunctions = data.functions.filter(function (x) {
	          return x.functionType === 'MEN';
	        });
	      }
	    });
	  } else if ($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.token) {
	    AuthenticationService.SetCredentials(false, $rootScope.globals.currentUser.email, $rootScope.globals.currentUser.name, $rootScope.globals.speciality, $rootScope.globals.currentUser.role, $rootScope.globals.worklist, $rootScope.globals.currentUser.id, $rootScope.globals.currentUser.token, Number($rootScope.globals.currentUser.roleId), '', undefined, undefined, $rootScope.globals.campus);
	
	    User.setUser(false, $rootScope.globals.currentUser.name, $rootScope.globals.currentUser.email, '', $rootScope.globals.currentUser.role, [], $rootScope.globals.currentUser.id, $rootScope.globals.currentUser.token, Number($rootScope.globals.currentUser.roleId), undefined, false, '');
	    this.user = User.getUser();
	
	    // If cookie has roleId stored then fetch function list
	    if ($rootScope.globals.currentUser && $rootScope.globals.currentUser.roleId) {
	      FunctionService.getFunctions($rootScope.globals.currentUser.roleId);
	    }
	
	    // Subscribe to functions fetched event then populate side menu lists
	    FunctionService.subscribe($scope, function (event, data) {
	      if (event.name === 'functions-fetched-event') {
	        $scope.vm.appFunctionSettings = data.functionSettings;
	        $scope.vm.appFunctions = data.functions;
	        $scope.vm.appMenuFunctions = data.functions.filter(function (x) {
	          return x.functionType === 'MEN';
	        });
	      }
	    });
	  }
	  if ($scope.vm.user) {
	    if (params.redirectRoute === undefined) {
	      var path = window.location.pathname.substring(1).replace('/', '.');
	      // console.log('Path: ' + path);
	      if (path !== '' && path.substring(0, 2) !== 'v2') {
	        if (path !== 'home') {
	          $state.go(path, {}, {});
	        } else {
	          $state.go('admin', {}, {});
	        }
	      } else if (path === '') {
	        // console.log('Going to login page now!');
	        $state.go('login', {}, {});
	      } else {
	        window.location = window.location.origin + '/v2/index.html';
	      }
	    } else if (params.redirectRoute === 'admin' || params.redirectRoute === '') {
	      $state.go('admin', {}, {});
	    } else {
	      $state.go(params.redirectRoute.replace('/', '.').replace('-', ''), {}, {});
	    }
	  } else {
	    // console.log('Got no token, redirect to login page...');
	    $state.go('login', {}, {});
	  }
	
	  $('.mdl-layout__drawer a').click(function () {
	    closeMenu();
	  });
	
	  function closeMenu() {
	    var d = document.querySelector('.mdl-layout');
	    d.MaterialLayout.toggleDrawer();
	  }
	
	  $scope.getFunctionSetting = function (funcName, setting) {
	    return $scope.vm.appFunctionSettings && $scope.vm.appFunctionSettings[funcName] ? $scope.vm.appFunctionSettings[funcName][setting] : false;
	  };
	
	  $scope.isLoginPage = function () {
	    return $location.path().indexOf('login') > -1;
	  };
	
	  $scope.isLogoutPage = function () {
	    return $location.path().indexOf('logout') > -1;
	  };
	
	  $scope.navItemClick = function (route, toggleMenu) {
	
	    $rootScope.globals = $cookieStore.get('globals');
	    var roleId = $rootScope.globals.currentUser.roleId ? $rootScope.globals.currentUser.roleId : $scope.vm.userRoleId;
	
	    // If on login page assume logged out so clear function settings
	    if (route.indexOf($scope.vm.loginRoute) > -1 || route.indexOf($scope.vm.logoutRoute) > -1) {
	      $scope.vm.appFunctionSettings = {};
	      $scope.vm.appFunctions = [];
	    }
	
	    // Close nav menu when left hand menu item clicked
	    if (toggleMenu) {
	      var d = document.querySelector('.mdl-layout');
	      d.MaterialLayout.toggleDrawer();
	    }
	
	    if (route.indexOf('v2') > -1) {
	      $rootScope.stopTokenRefresh = true;
	      var cfDomain = '.codefocus.com.au';
	      var cfDomainIndex = window.location.hostname.indexOf(cfDomain) || window.location.hostname.indexOf('10.0.1.1');
	
	      $rootScope.globals.currentUser.redirectRoute = route.replace('' + ("v2") + '/', '');
	
	      AuthenticationService.SetCredentials($rootScope.globals.currentUser.codingOperationsTeam, $scope.vm.user.email, $scope.vm.user.name, $scope.vm.user.specialty, $scope.vm.user.role, $scope.vm.user.worklist, $scope.vm.user.id, $scope.vm.user.token, roleId, $rootScope.globals.currentUser.redirectRoute, $rootScope.globals.currentUser.activeDirectoryToken, $rootScope.globals.currentUser.initialLogin, $scope.vm.user.campus);
	
	      if (window.location.hostname.indexOf('localhost') > -1) {
	        if (roleId) {
	          window.location = 'http://localhost:4200/' + ("v2") + '?token=' + $rootScope.globals.currentUser.token + '&roleId=' + roleId + '&redirectRoute=' + $rootScope.globals.currentUser.redirectRoute;
	        }
	      } else if (cfDomainIndex > -1) {
	        V2Service.redirectToV2(roleId);
	      }
	    }
	  };
	};
	
	exports.default = AppController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('Authentication', []);
	_angular2.default.module('Authentication').factory('AuthenticationService', ['Base64', '$state', '$http', '$cookieStore', '$rootScope', '$timeout', '$q', '$location', 'User', 'FunctionService', 'CONST', function (Base64, $state, $http, $cookieStore, $rootScope, $timeout, $q, $location, User, FunctionService, CONST) {
	
	  var service = {};
	
	  service.Login = function (scope, callback) {
	
	    scope.username = undefined;
	    scope.password = undefined;
	
	    _angular2.default.forEach(scope.vm.userFields, function (value, key) {
	
	      if (value.id === 'username') {
	
	        scope.username = value.value();
	      } else if (value.id === 'password') {
	
	        scope.password = value.value();
	      }
	    });
	
	    var respond = {};
	
	    $http({
	      method: "GET",
	      url: '' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.person/checkUser',
	      params: { authToken: btoa(scope.username + ":" + scope.password) }
	    }).success(function (response) {
	
	      if (response.data.length === 0) {
	
	        respond.message = 'Username or password is incorrect';
	      } else {
	
	        respond = { success: response.data };
	        ({}).email = response.data.email;
	        ({}).name = response.data.firstname + ' ' + response.data.lastname;
	        ({}).specialty = response.data.specialty;
	        ({}).role = response.data.dtype;
	        ({}).worklist = response.data.worklist;
	        ({}).id = response.data.id;
	        ({}).token = response.data.token;
	        ({}).roleId = response.data.roleId;
	        ({}).activeDirectoryToken = response.data.activeDirectoryToken;
	        ({}).campus = response.data.campus;
	        ({}).codingOperationsTeam = response.data.codingOperationsTeam;
	        User.setUser(({}).codingOperationsTeam, ({}).name, ({}).email, ({}).specialty, ({}).role, ({}).worklist, ({}).id, ({}).token, ({}).roleId, ({}).activeDirectoryToken, false, ({}).campus);
	      }
	      callback(respond);
	    }).error(function (response) {
	      respond.message = 'An error has occurred!';
	      callback(respond);
	    });
	  };
	
	  service.Decrypt = function (input) {
	    var output = "";
	    var chr1,
	        chr2,
	        chr3 = "";
	    var enc1,
	        enc2,
	        enc3,
	        enc4 = "";
	    var i = 0;
	
	    var base64test = /[^A-Za-z0-9\+\/\=]/g;
	    if (base64test.exec(input)) {
	      // console.log("There were invalid base64 characters in the input text.\n" +
	      //   "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
	      //   "Expect errors in decoding.");
	    }
	    var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    do {
	      enc1 = keyStr.indexOf(input.charAt(i++));
	      enc2 = keyStr.indexOf(input.charAt(i++));
	      enc3 = keyStr.indexOf(input.charAt(i++));
	      enc4 = keyStr.indexOf(input.charAt(i++));
	
	      chr1 = enc1 << 2 | enc2 >> 4;
	      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	      chr3 = (enc3 & 3) << 6 | enc4;
	
	      output = output + String.fromCharCode(chr1);
	
	      if (enc3 != 64) {
	        output = output + String.fromCharCode(chr2);
	      }
	      if (enc4 != 64) {
	        output = output + String.fromCharCode(chr3);
	      }
	
	      chr1 = chr2 = chr3 = "";
	      enc1 = enc2 = enc3 = enc4 = "";
	    } while (i < input.length);
	
	    return output;
	  };
	
	  service.UpdateUser = function () {
	    var globals = $cookieStore.get('globals') || {};
	    if (globals.currentUser) {
	      ({}).name = globals.currentUser.name;
	      ({}).email = globals.currentUser.email;
	      ({}).specialty = globals.currentUser.specialty;
	      ({}).role = globals.currentUser.role;
	      ({}).id = globals.currentUser.id;
	      ({}).token = globals.currentUser.token;
	      ({}).roleId = globals.currentUser.roleId;
	      ({}).activeDirectoryToken = globals.currentUser.activeDirectoryToken;
	      ({}).initialLogin = globals.currentUser.initialLogin;
	      ({}).campus = globals.currentUser.campus;
	      ({}).codingOperationsTeam = globals.currentUser.codingOperationsTeam;
	    }
	    return ({});
	  };
	
	  service.UpdateUserToken = function () {
	
	    $rootScope.globals = $cookieStore.get('globals') || {};
	
	    var deferred = $q.defer();
	
	    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    if ($rootScope.stopTokenRefresh === undefined && $rootScope.globals.currentUser.initialLogin === undefined) {
	      $http.post(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.usersession/token', $rootScope.globals.currentUser.token).then(function successCallback(response) {
	        $rootScope.globals.currentUser.initialLogin = true;
	        $rootScope.globals.currentUser.token = response.data;
	        $cookieStore.put('globals', $rootScope.globals);
	        // Update v2 cookie with updated token
	        document.cookie = 'globals=' + JSON.stringify($rootScope.globals) + '; path=/' + ("v2") + '/;';
	        var currentUser = User.getUser();
	        User.setUser(currentUser.codingOperationsTeam, currentUser.name, currentUser.email, currentUser.specialty, currentUser.role, currentUser.worklist, currentUser.id, response.data, currentUser.roleId, currentUser.activeDirectoryToken, true, currentUser.campus);
	        FunctionService.getFunctions(currentUser.roleId ? currentUser.roleId : $rootScope.globals.currentUser.roleId).then(function successCallback(functionsResponse) {
	          deferred.resolve(functionsResponse.data);
	        });
	      }, function errorCallback(response) {
	        if (response.status === 401) {
	          window.location.replace(window.location.origin + '/login?logout=true');
	        }
	      });
	    } else {
	      deferred.resolve();
	    }
	    return deferred.promise;
	  };
	
	  service.SetCredentials = function (codingOperationsTeam, email, name, speciality, role, worklist, id, token, roleId, redirectRoute, activeDirectoryToken, initialLogin, campuses) {
	
	    var spec,
	        uCampus,
	        list = worklist; // In case worklist is null
	
	    if (speciality) {
	      spec = speciality.indexOf(',') > -1 ? speciality.split(',') : speciality;
	    } else {
	      spec = "";
	    }
	
	    if (campuses) {
	      uCampus = campuses.indexOf(',') > -1 ? campuses.split(',') : campuses;
	    } else {
	      uCampus = "";
	    }
	
	    if (worklist) {
	      list = worklist.indexOf(',') > -1 ? worklist.split(',') : []; // Worklist isn't null, so make list an array
	    }
	
	    if (Array.isArray(list) && list.length === 0) {
	      list.push(worklist); // A single worklist
	    }
	
	    ({}).codingOperationsTeam = codingOperationsTeam;
	    ({}).email = email;
	    ({}).name = name;
	    ({}).specialty = spec;
	    ({}).role = role;
	    ({}).worklist = list;
	    ({}).id = id;
	    ({}).token = token;
	    ({}).roleId = roleId;
	    ({}).redirectRoute = redirectRoute;
	    ({}).activeDirectoryToken = activeDirectoryToken;
	    ({}).initialLogin = initialLogin;
	    ({}).campus = uCampus;
	
	    $rootScope.globals = {
	      currentUser: {
	        codingOperationsTeam: codingOperationsTeam,
	        email: email,
	        name: name,
	        firstname: name.substring(0, name.indexOf(' ')),
	        lastname: name.substring(name.indexOf(' ') + 1),
	        speciality: spec,
	        role: role,
	        worklist: list,
	        id: id,
	        token: token,
	        roleId: roleId,
	        redirectRoute: redirectRoute,
	        activeDirectoryToken: activeDirectoryToken,
	        initialLogin: initialLogin,
	        campus: uCampus
	      }
	    };
	
	    $rootScope.USER = ({});
	
	    $cookieStore.put('globals', $rootScope.globals);
	    User.setUser(codingOperationsTeam, name, email, spec, role, list, id, token, roleId, activeDirectoryToken, initialLogin, uCampus);
	  };
	
	  service.ClearCredentials = function (logoutType) {
	    console.log('service.ClearCredentials...');
	    if ($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.token) {
	      $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	      $http.post(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.usersession/logout/' + logoutType, $rootScope.globals.currentUser.token);
	      $state.transitionTo("logout");
	    }
	    $rootScope.globals = {};
	    $cookieStore.remove('globals');
	  };
	
	  return service;
	}]).factory('Base64', function () {
	  /* jshint ignore:start */
	
	  var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	  return {
	    encode: function encode(input) {
	      var output = "";
	      var chr1,
	          chr2,
	          chr3 = "";
	      var enc1,
	          enc2,
	          enc3,
	          enc4 = "";
	      var i = 0;
	
	      do {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
	        chr1 = chr2 = chr3 = "";
	        enc1 = enc2 = enc3 = enc4 = "";
	      } while (i < input.length);
	
	      return output;
	    },
	
	    decode: function decode(input) {
	      var output = "";
	      var chr1,
	          chr2,
	          chr3 = "";
	      var enc1,
	          enc2,
	          enc3,
	          enc4 = "";
	      var i = 0;
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        window.alert("There were invalid base64 characters in the input text.\n" + "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" + "Expect errors in decoding.");
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	      do {
	        enc1 = keyStr.indexOf(input.charAt(i++));
	        enc2 = keyStr.indexOf(input.charAt(i++));
	        enc3 = keyStr.indexOf(input.charAt(i++));
	        enc4 = keyStr.indexOf(input.charAt(i++));
	
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	
	        chr1 = chr2 = chr3 = "";
	        enc1 = enc2 = enc3 = enc4 = "";
	      } while (i < input.length);
	
	      return output;
	    }
	  };
	
	  /* jshint ignore:end */
	});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _drgs = __webpack_require__(294);
	
	var _drgs2 = _interopRequireDefault(_drgs);
	
	var _drgs3 = __webpack_require__(132);
	
	var _drgs4 = _interopRequireDefault(_drgs3);
	
	__webpack_require__(349);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var drgsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _drgs2.default,
	  controller: _drgs4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = drgsComponent;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DRGService = function () {
	  function DRGService($http, $rootScope) {
	    _classCallCheck(this, DRGService);
	
	    if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(DRGService, [{
	    key: 'getSpecialties',
	    value: function getSpecialties() {
	      return this.$http.get('' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/queryall?domain=SPECIAL');
	    }
	  }, {
	    key: 'getSpecialtyDesc',
	    value: function getSpecialtyDesc(specialtyId) {
	      return this.$http.get('' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/' + specialtyId);
	    }
	  }, {
	    key: 'getDRG',
	    value: function getDRG(wiesVer) {
	      return this.$http.get('' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.wies/findbywiesversion?ver=' + wiesVer);
	    }
	  }, {
	    key: 'putDRG',
	    value: function putDRG(specialtyId, data) {
	      return this.$http.put(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.wies/' + specialtyId + '/', data);
	    }
	  }, {
	    key: 'getDistinctWIES',
	    value: function getDistinctWIES() {
	      return this.$http.get('' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.wies/distinctwies');
	    }
	  }]);
	
	  return DRGService;
	}();
	
	var DrgsController = function DrgsController($http, $scope, LxDialogService, Constants, CONST, $rootScope, $location, FunctionService, $sanitize) {
	  _classCallCheck(this, DrgsController);
	
	  $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	  this.name = 'DRG';
	  this.episodeValue = '';
	  this.specialtyString = '';
	  this.options = {
	    removeChromeAutoComplete: true
	  };
	
	  this.form = "drg";
	
	  this.DRGOptions = [];
	  this.DRG = {
	    selectedDRG: null
	  };
	
	  this.WIESVEROptions = [];
	  this.WIESVER = {
	    selectedWIESVER: null
	  };
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialty.specialtyOptions = [];
	
	  this.roles = {
	    selectedRole: undefined
	  };
	  this.roles.rolesOptions = CONST.ROLE;
	
	  this.model = {};
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	  });
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	  });
	
	  // Setup WIESVER Select
	  new DRGService($http, $scope).getDistinctWIES().then(function successCallback(response) {
	
	    angular.forEach(response.data, function (value, key) {
	      $scope.vm.WIESVEROptions.push(value);
	    });
	
	    $scope.vm.WIESVER.selectedWIESVER = $scope.vm.WIESVEROptions[0];
	    setupDRG($scope.vm.WIESVER.selectedWIESVER.wiesVersion);
	  }, function errorCallback(response) {
	    if (response.status === 401) {
	      window.location.replace(window.location.origin + '/login?logout=true');
	    }
	  });
	
	  function setupDRG(wiesVer) {
	    // Setup DRG Select
	    new DRGService($http, $scope).getDRG(wiesVer).then(function successCallback(response) {
	
	      // reset DRG options
	      if ($scope.vm.DRGOptions) $scope.vm.DRGOptions = [];
	
	      angular.forEach(response.data, function (value, key) {
	        value.comments = $sanitize(value.comments);
	        $scope.vm.DRGOptions.push(value);
	      });
	
	      $scope.vm.DRG.selectedDRG = $scope.vm.DRGOptions[0];
	    }, function errorCallback(response) {
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + '/login?logout=true');
	      }
	    });
	  }
	
	  // Setup Specialties Select options
	  new DRGService($http, $scope).getSpecialties().then(function successCallback(response) {
	    angular.forEach(response.data, function (value, key) {
	      value['comments'] = $sanitize(value.comments);
	      value['groupName'] = $sanitize(value.groupName);
	      value['description'] = $sanitize(value.description);
	      if (value['description']) {
	        $scope.vm.specialty.specialtyOptions.push(value);
	      }
	    });
	
	    // $scope.vm.specialty.selectedspecialty = $scope.vm.specialtyOptions[0];
	  }, function errorCallback(response) {
	    if (response.status === 401) {
	      window.location.replace(window.location.origin + '/login?logout=true');
	    }
	  });
	
	  this.DRGCallback = DRGCallback;
	  this.specialtyCallback = specialtyCallback;
	  this.WIESVERCallback = WIESVERCallback;
	
	  function WIESVERCallback(_newValue, _oldValue) {
	
	    if (_newValue != _oldValue && _oldValue) setupDRG($scope.vm.WIESVER.selectedWIESVER.wiesVersion);
	  }
	
	  function DRGCallback(_newValue, _oldValue) {
	
	    if (!$scope.vm.DRG.selectedDRG) return;
	
	    if ($scope.vm.DRG.selectedDRG !== $scope.vm.model) angular.copy($scope.vm.DRG.selectedDRG, $scope.vm.model);
	
	    var spec,
	        specialtyArr = $scope.vm.DRG.selectedDRG.targetedSpecialties;
	
	    if (specialtyArr) {
	
	      spec = specialtyArr.split(',');
	    } else {
	
	      spec = [];
	    }
	
	    $scope.vm.specialty.selectedSpecialty = [];
	
	    angular.forEach(spec, function (value, key) {
	
	      // GET Specialty description
	      new DRGService($http, $scope).getSpecialtyDesc(value).then(function successCallback(response) {
	
	        var sanitizedDesc = $sanitize(response.data.description);
	        if (sanitizedDesc) {
	          $scope.vm.specialty.selectedSpecialty.push({ "refCodeId": parseInt(value), "description": sanitizedDesc });
	        }
	      }, function errorCallback(response) {
	        if (response.status === 401) {
	          window.location.replace(window.location.origin + '/login?logout=true');
	        }
	      });
	    });
	
	    // reset listener and form state
	    $scope.vm.form.$setPristine();
	    $scope.vm.form.$setValidity();
	    $scope.vm.form.$setUntouched();
	  }
	
	  function specialtyCallback(_newValue, _oldValue) {
	
	    // Join the selected Specialties for comparison against the current model
	    var mappedSpecIds = $scope.vm.specialty.selectedSpecialty.map(function (num) {
	      return num.refCodeId;
	    }).sort(function (a, b) {
	      return a - b;
	    }).join(),
	        sortedTargetedSpecialties = $scope.vm.model.targetedSpecialties ? $scope.vm.model.targetedSpecialties.split(',').map(Number).sort(function (a, b) {
	      return a - b;
	    }).join() : '';
	
	    if (sortedTargetedSpecialties !== mappedSpecIds) $scope.vm.form.$setDirty();
	  }
	
	  this.openDialog = function () {
	    LxDialogService.open("doubleCheck");
	  };
	
	  this.checkValid = function () {
	
	    // dis/enable submit button
	
	    if ($scope.vm.form.$pristine) {
	
	      return true;
	    } else {
	
	      if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {
	
	        return false;
	      } else {
	
	        return true;
	      }
	    }
	  };
	
	  this.submitDRG = function () {
	
	    // add Specialty data
	    $scope.vm.model.targetedSpecialties = $scope.vm.specialty.selectedSpecialty.map(function (num) {
	      return parseInt(num.refCodeId);
	    }).sort(function (a, b) {
	      return a - b;
	    }).join();
	
	    if ($scope.vm.model.targetedSpecialties === '') $scope.vm.model.targetedSpecialties = null;
	
	    $scope.putData($scope.vm.model);
	  };
	
	  $scope.putData = function (data) {
	
	    var drgId = data.wiesId,
	        data = JSON.stringify(data);
	
	    new DRGService($http).putDRG(drgId, data).then(function successCallback(response) {
	
	      $scope.vm.DRG.selectedDRG = $scope.vm.model;
	      $scope.snackBar('DRG updated');
	    }, function errorCallback(response) {
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + '/login?logout=true');
	      }
	    });
	  };
	
	  $scope.snackBar = function (message) {
	
	    // upgrade MDI components
	    window.componentHandler.upgradeAllRegistered();
	
	    var snackbarContainer = document.querySelector('#specialty__notification');
	
	    var data = {
	      message: message,
	      timeout: 2000,
	      actionHandler: $scope.finaliseCheck,
	      actionText: 'test'
	    };
	
	    snackbarContainer.MaterialSnackbar.showSnackbar(data);
	  };
	
	  this.fields = [{
	    type: 'lx-switch',
	    key: 'target',
	    templateOptions: {
	      'label': 'Target DRG'
	    }
	  }, {
	    type: 'lx-input',
	    key: 'comments',
	    templateOptions: {
	      'label': 'Alert / Note',
	      'type': 'text'
	    }
	  }];
	};
	
	exports.default = DrgsController;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _drgs = __webpack_require__(131);
	
	var _drgs2 = _interopRequireDefault(_drgs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var drgsModule = _angular2.default.module('drgs', [_angularUiRouter2.default]).component('drgs', _drgs2.default);
	
	exports.default = drgsModule;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _episodes = __webpack_require__(295);
	
	var _episodes2 = _interopRequireDefault(_episodes);
	
	var _episodes3 = __webpack_require__(135);
	
	var _episodes4 = _interopRequireDefault(_episodes3);
	
	__webpack_require__(350);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var episodesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _episodes2.default,
	  controller: _episodes4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = episodesComponent;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EpisodeService = function () {
	    function EpisodeService($http, $rootScope) {
	        _classCallCheck(this, EpisodeService);
	
	        if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	        this.$http = $http;
	    }
	
	    _createClass(EpisodeService, [{
	        key: 'editEpisodeDetails',
	        value: function editEpisodeDetails(data) {
	            return this.$http({
	                method: 'POST',
	                url: ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodeaudit/',
	                data: data,
	                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	            });
	        }
	    }]);
	
	    return EpisodeService;
	}();
	
	var EpisodesController = function EpisodesController($http, $scope, $timeout, DTOptionsBuilder, DTColumnBuilder, CONST, materialButtons, LxDialogService, $rootScope, FunctionService) {
	    _classCallCheck(this, EpisodesController);
	
	    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    this.name = 'Admin - Episodes';
	    this.specialtyString = '';
	    this.separationString = '';
	    this.datatableApi;
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodeaudit/getepisodes/';
	    this.dtInstance = {};
	    this.model = {};
	    this.dateTypeOptions = [{ value: 'SEPARATION_DATE', viewValue: 'Separation Date' }, { value: 'CODED_DATE', viewValue: 'Coded Date' }];
	    this.EOFY = moment("30/06/" + moment().format('YYYY'), "DD/MM/YYYY");
	    this.startFinYear;
	    this.endFinYear;
	    this.startFinYearDisplay;
	    this.endFinYearDisplay;
	
	    if (moment().isAfter($scope.vm.EOFY)) {
	        this.startFinYear = moment().subtract(1, 'year').month('July').startOf('month');
	        this.endFinYear = moment().add(1, 'year').month('June').endOf('month');
	    } else {
	        this.startFinYear = moment().subtract(2, 'year').month('July').startOf('month');
	        this.endFinYear = moment().month('June').endOf('month');
	    }
	
	    this.startFinYearDisplay = this.startFinYear.format('L');
	    this.endFinYearDisplay = this.endFinYear.format('L');
	
	    // Search filters
	    this.searchFilter = "";
	
	    this.status = {
	        selectedStatus: undefined
	    };
	    this.statusOptions = CONST.STATUS;
	    this.locale = 'en-au';
	
	    materialButtons.render();
	    materialButtons.processing();
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    });
	
	    $scope.drawCallback = function (settings) {
	        componentHandler.upgradeAllRegistered();
	        // reset model
	        $scope.vm.model = [];
	        var table = $('#auditTable').DataTable();
	
	        table.rows().every(function (rowIdx, tableLoop, rowLoop) {
	            var data = this.data();
	            $scope.vm.model[rowLoop] = [];
	            $scope.vm.model[rowLoop].episodeAuditId = data.episodeAuditId;
	        });
	    };
	
	    $scope.initCallback = function (nRow, aData, index) {
	        // Datatables has finished init
	        // Initialise searching
	        if ($scope.vm.datatableApi) return;
	
	        $scope.vm.datatableApi = this.api();
	
	        // Update column headers even when no data returned
	        setDtHeaders($scope.vm.datatableApi);
	
	        // set the table to a fixed height, so it never collapsed up and down
	        $('#auditTable').closest(".dataTables_scrollBody").height(300);
	
	        // setup global search filter
	        search();
	    };
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	        url: $scope.vm.url,
	        type: 'GET',
	        // Send additional data for processing server-side filters
	        data: function data(d) {
	            d.startDate = $scope.vm.startFinYearDisplay;
	            d.endDate = $scope.vm.endFinYearDisplay;
	            d.dateType = $scope.vm.dateTypeOptions[0].value;
	            d.auditCriteria = '';
	            d.status = '';
	            d.specialty = '';
	            d.search = $scope.vm.searchFilter || '';
	        },
	        error: function error(xhr, _error, thrown) {
	            if (thrown == 'Unauthorized') {
	                //window.location.replace(window.location.origin + '/login');
	                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	            }
	        }
	    }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('serverSide', true).withOption('order', [[2, 'asc']]).withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	        // Update column headers if data returned
	        setDtHeaders($('#auditTable').DataTable());
	    }).withOption('initComplete', $scope.initCallback)
	    // .withOption('rowCallback', $scope.rowCallback)
	    .withOption('drawCallback', $scope.drawCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	        extend: 'print',
	        text: ''
	    }, {
	        extend: 'csvHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	        extend: 'excelHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	        text: '',
	        action: function action(e, dt, node, config) {
	            $scope.vm.dtInstance.reloadData();
	        }
	    }]);
	
	    this.dtColumns = [DTColumnBuilder.newColumn('episodeNumber').withTitle('Episode Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('drg').withTitle('Current DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        if (typeof full.currentDRGDescription !== 'undefined') {
	            return full.currentDRG + ' - ' + full.currentDRGDescription;
	        } else {
	            return full.currentDRG;
	        }
	    }), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('status').withTitle('Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')];
	
	    function setDtHeaders(table) {
	        $(table.column(2).header()).html($scope.vm.separationString + ' Date');
	        $(table.column(4).header()).html($scope.vm.specialtyString);
	    }
	
	    this.changeData = changeData;
	
	    this.resetSelectors = resetSelectors;
	
	    function resetSelectors() {
	        $scope.vm.status.selectedStatus = undefined;
	    }
	
	    function checkParam(param) {
	        if (param.length !== 0) {
	            return encodeURIComponent(param.join());
	        } else {
	            return "";
	        }
	    }
	
	    function changeData() {
	        $scope.vm.dtInstance.changeData({
	            method: 'GET',
	            headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	            url: '' + $scope.vm.url + '?startDate=' + $scope.vm.startFinYearDisplay + '&endDate=' + $scope.vm.endFinYearDisplay + '&dateType=' + $scope.vm.dateTypeOptions[0].value + '&auditCriteria=' + '&status=' + '&specialty=' + '&search=' + $scope.vm.searchFilter + '&controller=episodes' + '',
	            error: function error(xhr, _error2, thrown) {
	                if (thrown == 'Unauthorized') {
	                    //window.location.replace(window.location.origin + '/login');
	                    console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                }
	            } });
	    }
	
	    function search() {
	        var timeoutPromise,
	            delayInMs = 500;
	
	        $scope.$watch("vm.searchFilter", function (searchString, oldvalue) {
	            $timeout.cancel(timeoutPromise); //does nothing, if timeout already done
	            timeoutPromise = $timeout(function () {
	                //Set timeout
	                if (searchString !== oldvalue) {
	                    $scope.vm.changeData();
	                }
	            }, delayInMs);
	        });
	    }
	
	    this.openDialog = openDialog;
	
	    function openDialog(_newValue, _oldValue) {
	        if (!_newValue) return;
	
	        if ($scope.vm.model.length !== 0) {
	            LxDialogService.open("doubleCheck");
	        } else {
	            $scope.vm.resetSelectors();
	        }
	    }
	
	    $scope.snackBar = function (message) {
	        // upgrade MDI components
	        window.componentHandler.upgradeAllRegistered();
	
	        var snackbarContainer = document.querySelector('#audit__notification');
	        var data = {
	            message: message,
	            timeout: 2000,
	            actionHandler: $scope.finaliseCheck,
	            actionText: 'test'
	        };
	        snackbarContainer.MaterialSnackbar.showSnackbar(data);
	    };
	
	    // FORM SUBMISSION
	    this.setStatus = setStatus;
	
	    function setStatus() {
	        this.serialize = function (obj) {
	            var str = [];
	            for (var p in obj) {
	                if (obj.hasOwnProperty(p)) {
	                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	                }
	            }return str.join("&");
	        };
	
	        var modelLength = $scope.vm.model.length - 1;
	
	        angular.forEach($scope.vm.model, function (value, key) {
	
	            if ($scope.vm.status.selectedStatus) $scope.vm.model[key].status = $scope.vm.status.selectedStatus;
	
	            new EpisodeService($http).editEpisodeDetails($scope.vm.serialize($scope.vm.model[key])).then(function successCallback(response) {
	                if (key === modelLength) {
	                    // Episodes updated
	                    $scope.vm.dtInstance.reloadData();
	                    $scope.vm.resetSelectors();
	                    $scope.snackBar('Episode/s updated');
	                }
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        });
	    }
	};
	
	exports.default = EpisodesController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _episodes = __webpack_require__(134);
	
	var _episodes2 = _interopRequireDefault(_episodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var episodesModule = _angular2.default.module('episodes', [_angularUiRouter2.default]).component('episodes', _episodes2.default);
	
	exports.default = episodesModule;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _episodevalue = __webpack_require__(296);
	
	var _episodevalue2 = _interopRequireDefault(_episodevalue);
	
	var _episodevalue3 = __webpack_require__(138);
	
	var _episodevalue4 = _interopRequireDefault(_episodevalue3);
	
	__webpack_require__(351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var episodevalueComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _episodevalue2.default,
	  controller: _episodevalue4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = episodevalueComponent;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DRGWiesService = function () {
	  function DRGWiesService($http, $rootScope) {
	    _classCallCheck(this, DRGWiesService);
	
	    if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(DRGWiesService, [{
	    key: 'getWies',
	    value: function getWies(hid) {
	      return this.$http.get('' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/model.wiestarget/hid/' + hid);
	    }
	  }, {
	    key: 'putWies',
	    value: function putWies(wiesId, data) {
	      return this.$http({
	        method: 'PUT',
	        url: ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/model.wiestarget/' + wiesId,
	        data: data,
	        headers: { 'Content-Type': 'application/json' }
	      });
	    }
	  }, {
	    key: 'postWies',
	    value: function postWies(data) {
	      return this.$http.post(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/model.wiestarget', data);
	    }
	  }]);
	
	  return DRGWiesService;
	}();
	
	Object.defineProperty(Object.prototype, 'renameProperty', {
	  writable: false, // Cannot alter this property
	  enumerable: false, // Will not show up in a for-in loop.
	  configurable: false, // Cannot be deleted via the delete operator
	  value: function value(oldName, newName) {
	    // Check for the old property name to
	    // avoid a ReferenceError in strict mode.
	    if (this.hasOwnProperty(oldName)) {
	      this[newName] = this[oldName];
	      delete this[oldName];
	    }
	    return this;
	  }
	});
	
	var EpisodevalueController = function EpisodevalueController($http, $scope, CONST, $location, $rootScope, FunctionService) {
	  _classCallCheck(this, EpisodevalueController);
	
	  $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	
	  this.episodeValue = '';
	  this.name = '';
	  this.options = {
	    removeChromeAutoComplete: true
	  };
	  this.form = "wiesTargets";
	  this.yearOptions = [];
	  this.year = {
	    selectedYear: null
	  };
	  this.model = {};
	  this.yearData = {};
	  this.yearDataCopy = {};
	  this.yearAdded = false;
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.name = $scope.vm.episodeValue + ' Targets';
	  });
	
	  new DRGWiesService($http, $scope).getWies(CONST.HOSPITALID).then(function successCallback(response) {
	
	    var currentYear = true,
	        count = 0;
	
	    // setup Year select and model
	    angular.forEach(response.data, function (value, key) {
	
	      var mom = moment(value.month);
	      var year = mom.format('YYYY'),
	          prevYear = mom.subtract(1, "year").format('YYYY'),
	          monthName = mom.format('MMMM').toUpperCase(),
	          finYear = year + " - " + prevYear;
	
	      // add year
	      if (key === 0) {
	        $scope.vm.yearOptions.push(prevYear + " - " + year);
	      } else if (key % 12 === 0) {
	        count++;
	        $scope.vm.yearOptions.push(prevYear + " - " + year);
	      }
	
	      // add year and month to object
	      if (typeof $scope.vm.yearData[count] === 'undefined') {
	
	        $scope.vm.yearData[count] = _defineProperty({}, monthName, Object());
	      } else {
	
	        $scope.vm.yearData[count][monthName] = Object();
	      }
	
	      $scope.vm.yearData[count][monthName].id = value.id;
	      $scope.vm.yearData[count][monthName].month = value.month;
	      $scope.vm.yearData[count][monthName].target = value.target;
	      $scope.vm.yearData[count][monthName].monthName = value.monthName;
	      $scope.vm.yearData[count][monthName].hospitalId = value.hospitalId;
	    });
	
	    // select the latest
	    $scope.vm.year.selectedYear = $scope.vm.yearOptions[0];
	  }, function errorCallback(response) {
	    if (response.status === 401) {
	      window.location.replace(window.location.origin + '/login?logout=true');
	    }
	  });
	
	  this.addWies = addWies;
	  this.wiesCallback = wiesCallback;
	
	  function addWies() {
	    // add a new blank FY to the model
	    $scope.vm.yearAdded = true;
	    var oldYear = parseInt($scope.vm.yearOptions[0].substring(0, 4)) + 1;
	    var newYear = oldYear + 1;
	    $scope.vm.yearOptions.unshift(oldYear + " - " + newYear);
	
	    angular.copy($scope.vm.yearData, $scope.vm.yearDataCopy);
	    $scope.vm.yearData = {};
	
	    $scope.vm.yearData[0] = {};
	    $scope.vm.yearData[0].JULY = Object();
	    $scope.vm.yearData[0].JULY.monthName = "JULY";
	    $scope.vm.yearData[0].AUGUST = Object();
	    $scope.vm.yearData[0].AUGUST.monthName = "AUGUST";
	    $scope.vm.yearData[0].SEPTEMBER = Object();
	    $scope.vm.yearData[0].SEPTEMBER.monthName = "SEPTEMBER";
	    $scope.vm.yearData[0].OCTOBER = Object();
	    $scope.vm.yearData[0].OCTOBER.monthName = "OCTOBER";
	    $scope.vm.yearData[0].NOVEMBER = Object();
	    $scope.vm.yearData[0].NOVEMBER.monthName = "NOVEMBER";
	    $scope.vm.yearData[0].DECEMBER = Object();
	    $scope.vm.yearData[0].DECEMBER.monthName = "DECEMBER";
	    $scope.vm.yearData[0].JANUARY = Object();
	    $scope.vm.yearData[0].JANUARY.monthName = "JANUARY";
	    $scope.vm.yearData[0].FEBRUARY = Object();
	    $scope.vm.yearData[0].FEBRUARY.monthName = "FEBRUARY";
	    $scope.vm.yearData[0].MARCH = Object();
	    $scope.vm.yearData[0].MARCH.monthName = "MARCH";
	    $scope.vm.yearData[0].APRIL = Object();
	    $scope.vm.yearData[0].APRIL.monthName = "APRIL";
	    $scope.vm.yearData[0].MAY = Object();
	    $scope.vm.yearData[0].MAY.monthName = "MAY";
	    $scope.vm.yearData[0].JUNE = Object();
	    $scope.vm.yearData[0].JUNE.monthName = "JUNE";
	
	    // Bump every FY down one and re-add
	    angular.forEach($scope.vm.yearDataCopy, function (value, key) {
	
	      var newKey = parseInt(key) + 1;
	      $scope.vm.yearData[newKey] = value;
	    });
	
	    // unset
	    $scope.vm.yearDataCopy = {};
	
	    // Select the new FY
	    $scope.vm.year.selectedYear = $scope.vm.yearOptions[0];
	  }
	
	  function wiesCallback(_newValue, _oldValue) {
	
	    var currentYearData = $scope.vm.yearData[$scope.vm.yearOptions.indexOf($scope.vm.year.selectedYear)];
	
	    if (currentYearData !== $scope.vm.model) {
	      angular.copy(currentYearData, $scope.vm.model);
	    }
	
	    // reset listener and form state
	    $scope.vm.form.$setPristine();
	    $scope.vm.form.$setValidity();
	    $scope.vm.form.$setUntouched();
	  }
	
	  this.yearValid = function () {
	    return $scope.vm.yearAdded;
	  };
	
	  this.checkValid = function () {
	
	    // dis/enable submit button
	
	    if ($scope.vm.form.$pristine) {
	
	      return true;
	    } else {
	
	      if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {
	
	        return false;
	      } else {
	
	        return true;
	      }
	    }
	  };
	
	  this.submitWies = function () {
	
	    var currentYearData = $scope.vm.yearData[$scope.vm.yearOptions.indexOf($scope.vm.year.selectedYear)];
	
	    angular.forEach($scope.vm.model, function (value, key) {
	
	      if (value.target !== currentYearData[value.monthName].target) {
	
	        if (value.id) {
	
	          // existing wies = put
	          $scope.putData(value);
	        } else {
	
	          // new wies = post
	          var year = parseInt($scope.vm.year.selectedYear.substring(0, 4));
	
	          if (['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE'].includes(key)) year = parseInt(year) + 1;
	
	          var date = moment('' + year + '-' + value.monthName + '-01', 'YYYY-MMMM-DD').format();
	          value.month = date;
	          value.hospitalId = CONST.HOSPITALID;
	
	          $scope.postData(value, currentYearData);
	        }
	      }
	    });
	  };
	
	  $scope.putData = function (data) {
	
	    var wiesId = data.id,
	        data = JSON.stringify(data);
	
	    new DRGWiesService($http).putWies(wiesId, data).then(function successCallback(response) {
	
	      angular.copy($scope.vm.model, $scope.vm.yearData[$scope.vm.yearOptions.indexOf($scope.vm.year.selectedYear)]);
	      $scope.snackBar($scope.vm.episodeValue + ' updated');
	    }, function errorCallback(response) {
	      $scope.snackBar('Error saving ' + $scope.vm.episodeValue);
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + '/login?logout=true');
	      }
	    });
	  };
	
	  $scope.postData = function (data, count) {
	
	    new DRGWiesService($http).postWies(data).then(function successCallback(response) {
	
	      // add the ID, so it can be edited
	      $scope.vm.model[response.data.data.monthName].id = response.data.data.id;
	
	      angular.copy($scope.vm.model[response.data.data.monthName], $scope.vm.yearData[$scope.vm.yearOptions.indexOf($scope.vm.year.selectedYear)][response.data.data.monthName]);
	
	      if (data.monthName === 'JUNE') {
	        $scope.snackBar($scope.vm.episodeValue + ' added');
	        $scope.vm.yearAdded = false;
	      }
	    }, function errorCallback(response) {
	      $scope.snackBar('Database error, or ' + $scope.vm.episodeValue + 'already exists');
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + '/login?logout=true');
	      }
	    });
	  };
	
	  $scope.snackBar = function (message) {
	
	    // upgrade MDI components
	    window.componentHandler.upgradeAllRegistered();
	
	    var snackbarContainer = document.querySelector('#wies__notification');
	
	    var data = {
	      message: message,
	      timeout: 2000,
	      actionHandler: $scope.finaliseCheck,
	      actionText: 'test'
	    };
	
	    snackbarContainer.MaterialSnackbar.showSnackbar(data);
	  };
	
	  this.fields = [{
	    type: 'lx-input',
	    key: 'JULY.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'July',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'AUGUST.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'August',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'SEPTEMBER.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'September',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'OCTOBER.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'October',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'NOVEMBER.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'November',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'DECEMBER.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'December',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'JANUARY.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'January',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'FEBRUARY.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'February',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'MARCH.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'March',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'APRIL.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'April',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'MAY.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'May',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'JUNE.target',
	    templateOptions: {
	      'type': 'number',
	      'label': 'June',
	      required: true
	    }
	  }];
	};
	
	exports.default = EpisodevalueController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _episodevalue = __webpack_require__(137);
	
	var _episodevalue2 = _interopRequireDefault(_episodevalue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var episodevalueModule = _angular2.default.module('episodevalue', [_angularUiRouter2.default]).component('episodevalue', _episodevalue2.default);
	
	exports.default = episodevalueModule;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _site = __webpack_require__(297);
	
	var _site2 = _interopRequireDefault(_site);
	
	var _site3 = __webpack_require__(141);
	
	var _site4 = _interopRequireDefault(_site3);
	
	__webpack_require__(352);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var siteComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _site2.default,
	  controller: _site4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = siteComponent;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DRGSiteService = function () {
	    function DRGSiteService($http, $rootScope) {
	        _classCallCheck(this, DRGSiteService);
	
	        if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	        this.$http = $http;
	    }
	
	    _createClass(DRGSiteService, [{
	        key: 'getSite',
	        value: function getSite() {
	            return this.$http.get('' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/queryall?domain=SITE');
	        }
	    }, {
	        key: 'putSite',
	        value: function putSite(siteId, data) {
	            return this.$http.put(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/' + siteId + '/', data);
	        }
	    }]);
	
	    return DRGSiteService;
	}();
	
	var QueryTemplateFileService = function () {
	    function QueryTemplateFileService($http) {
	        _classCallCheck(this, QueryTemplateFileService);
	
	        this.$http = $http;
	    }
	
	    _createClass(QueryTemplateFileService, [{
	        key: 'getQueryTemplateFile',
	        value: function getQueryTemplateFile(queryTemplateId) {
	            return this.$http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.querytemplatefile/' + queryTemplateId);
	        }
	    }]);
	
	    return QueryTemplateFileService;
	}();
	
	var SiteController = function SiteController($http, $scope, $rootScope, BuildNumber, $sce, FunctionService) {
	    _classCallCheck(this, SiteController);
	
	    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    this.name = 'Site Settings';
	    this.options = {
	        removeChromeAutoComplete: true
	    };
	    this.dRGSiteService = new DRGSiteService($http, $scope);
	
	    this.hl7NotLoading = true;
	    this.form = "site";
	    this.model = {};
	    this.functionSettings = {};
	    this.buildNumber = BuildNumber;
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.functionSettings = response.functionSettings;
	    });
	
	    $scope.vm.dRGSiteService.getSite().then(function successCallback(response) {
	
	        $scope.vm.model = response.data[0];
	    }, function errorCallback(response) {
	        if (response.status === 401) {
	            window.location.replace(window.location.origin + '/login?logout=true');
	        }
	    });
	
	    this.checkValid = function () {
	
	        // dis/enable submit button
	
	        if ($scope.vm.form.$pristine) {
	
	            return true;
	        } else {
	
	            if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {
	
	                return false;
	            } else {
	
	                return true;
	            }
	        }
	    };
	
	    function base64ToArrayBuffer(data) {
	
	        var binaryString = window.atob(data);
	        var binaryLen = binaryString.length;
	        var bytes = new Uint8Array(binaryLen);
	
	        for (var i = 0; i < binaryLen; i++) {
	
	            var ascii = binaryString.charCodeAt(i);
	            bytes[i] = ascii;
	        }
	
	        return bytes;
	    };
	
	    this.viewTemplate = viewTemplate;
	
	    // Display the template PDF in a new tab or download if docx
	    function viewTemplate(queryTemplateId) {
	        $scope.vm.hl7NotLoading = false;
	        $scope.vm.templateDownloading = true;
	
	        new QueryTemplateFileService($http).getQueryTemplateFile(queryTemplateId).then(function successCallback(response) {
	            var data = response.data;
	            var arrBuffer = base64ToArrayBuffer(data.queryTemplate);
	            var typeString = '';
	
	            switch (data.queryTemplateFormat) {
	                case 'zip':
	                    typeString = 'application/zip';
	                    break;
	                default:
	                // TODO: handle type error
	            }
	
	            var file = new Blob([arrBuffer], { type: typeString });
	            var fileURL = URL.createObjectURL(file);
	            window.open($sce.trustAsResourceUrl(fileURL));
	            $scope.vm.templateDownloading = false;
	
	            $scope.vm.hl7NotLoading = true;
	        }, function errorCallback(response) {
	            $scope.vm.templateDownloading = false;
	            $scope.vm.hl7NotLoading = true;
	        });
	    }
	
	    this.putData = function () {
	
	        var data = JSON.stringify($scope.vm.model);
	
	        $scope.vm.dRGSiteService.putSite($scope.vm.model.refCodeId, data).then(function successCallback(response) {
	
	            $scope.snackBar('Site updated');
	        }, function errorCallback(response) {
	
	            $scope.snackBar("Database error, error saving Site.");
	            if (response.status === 401) {
	                window.location.replace(window.location.origin + '/login?logout=true');
	            }
	        });
	    };
	
	    $scope.snackBar = function (message) {
	
	        // upgrade MDI components
	        window.componentHandler.upgradeAllRegistered();
	
	        var snackbarContainer = document.querySelector('#site__notification');
	
	        var data = {
	            message: message,
	            timeout: 2000,
	            actionHandler: $scope.finaliseCheck,
	            actionText: 'test'
	        };
	
	        snackbarContainer.MaterialSnackbar.showSnackbar(data);
	    };
	
	    this.fields = [{
	        type: 'lx-input',
	        key: 'code',
	        templateOptions: {
	            'label': 'URL',
	            required: true
	        }
	    }];
	};
	
	exports.default = SiteController;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _site = __webpack_require__(140);
	
	var _site2 = _interopRequireDefault(_site);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var siteModule = _angular2.default.module('site', [_angularUiRouter2.default]).component('site', _site2.default);
	
	exports.default = siteModule;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _specialties = __webpack_require__(298);
	
	var _specialties2 = _interopRequireDefault(_specialties);
	
	var _specialties3 = __webpack_require__(144);
	
	var _specialties4 = _interopRequireDefault(_specialties3);
	
	__webpack_require__(353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var specialtiesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _specialties2.default,
	  controller: _specialties4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = specialtiesComponent;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DRGSpecialtyService = function () {
	  function DRGSpecialtyService($http, $rootScope) {
	    _classCallCheck(this, DRGSpecialtyService);
	
	    if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(DRGSpecialtyService, [{
	    key: 'getSpecialties',
	    value: function getSpecialties() {
	      return this.$http.get('' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/queryall?domain=SPECIAL');
	    }
	  }, {
	    key: 'putSpecialty',
	    value: function putSpecialty(specialtyId, data) {
	      return this.$http.put(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/' + specialtyId + '/', data);
	    }
	  }, {
	    key: 'postSpecialty',
	    value: function postSpecialty(data) {
	      return this.$http.post(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/', data);
	    }
	  }]);
	
	  return DRGSpecialtyService;
	}();
	
	var SpecialtiesController = function SpecialtiesController($http, $scope, LxDialogService, User, Constants, CONST, $rootScope, $sanitize, FunctionService) {
	  _classCallCheck(this, SpecialtiesController);
	
	  $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	  this.specialtyString = '';
	  this.user = User.getUser();
	  this.options = {
	    removeChromeAutoComplete: true
	  };
	
	  this.form = "specialties";
	
	  this.coderOptions = [];
	  this.coder = {
	    selectedCoder: null
	  };
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	
	  this.roles = {
	    selectedRole: undefined
	  };
	  this.roles.rolesOptions = CONST.ROLE;
	
	  this.model = {};
	
	  $scope.vm.isSubmitting = false;
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	  });
	
	  // I think this is an unnecessary second call for Queries, which is never used.
	  // But I don't have the guts to totally delete it - Henry Barnett 01/03/2023.
	  /*
	  Constants.getDivisionAndSpecialtyData().then(
	       function successCallback(response) {
	           $scope.vm.specialtyOptions = response.specialties;
	       }
	   );
	  */
	
	  this.fetchSpecialities = function (refCodeToSet) {
	    new DRGSpecialtyService($http, $scope).getSpecialties().then(function successCallback(response) {
	      $scope.vm.coderOptions = [];
	      angular.forEach(response.data, function (value, key) {
	        value.groupName = $sanitize(value.groupName);
	        value.description = $sanitize(value.description).replace(/&amp;/g, "&");
	        $scope.vm.coderOptions.push(value);
	      });
	      var indexOfItem = 0;
	      if (refCodeToSet) {
	        indexOfItem = $scope.vm.coderOptions.map(function (e) {
	          return e.refCodeId;
	        }).indexOf(refCodeToSet);
	      }
	      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[indexOfItem];
	    }, function errorCallback(response) {
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + "/login?logout=true");
	      }
	    });
	  };
	
	  $scope.vm.fetchSpecialities(false);
	
	  this.addSpecialty = addSpecialty;
	  this.coderCallback = coderCallback;
	  this.selectCallback = selectCallback;
	
	  function addSpecialty() {
	
	    // add a new blank user to the model
	    var addNew = $scope.vm.coderOptions.push({});
	    $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[addNew - 1];
	  }
	
	  function coderCallback(_newValue, _oldValue) {
	
	    if ($scope.vm.coder.selectedCoder !== $scope.vm.model) angular.copy($scope.vm.coder.selectedCoder, $scope.vm.model);
	
	    var spec,
	        specialtyArr = $scope.vm.coder.selectedCoder.specialty;
	
	    if (specialtyArr) {
	
	      spec = specialtyArr.split(',');
	    } else {
	
	      spec = [];
	    }
	
	    $scope.vm.specialty.selectedSpecialty = [];
	
	    angular.forEach(spec, function (value, key) {
	      $scope.vm.specialty.selectedSpecialty.push(value);
	    });
	
	    // reset listener and form state
	    // $scope.vm.form.$setPristine();
	    $scope.vm.form.$setValidity();
	    $scope.vm.form.$setUntouched();
	  }
	
	  function selectCallback(_newValue, _oldValue) {
	    if ($scope.vm.model.specialty !== $scope.vm.specialty.selectedSpecialty.join() || $scope.vm.model.dtype !== $scope.vm.roles.selectedRole) $scope.vm.form.$setDirty();
	  }
	
	  this.openDialog = function () {
	    LxDialogService.open("doubleCheck");
	  };
	
	  this.isButtonDisabled = function () {
	    // dis/enable submit button
	
	    if ($scope.vm.form.$pristine) {
	      return true;
	    } else {
	      if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {
	        return $scope.vm.isSubmitting;
	      } else {
	        return true;
	      }
	    }
	  };
	
	  this.submitSpecialty = function () {
	    // add selects data
	    if ($scope.vm.model.refCodeId) {
	      // existing user = put
	      $scope.putData($scope.vm.model);
	    } else {
	      // new user = post
	      $scope.vm.model.domain = 'SPECIAL';
	      $scope.vm.model.hospitalId = CONST.HOSPITALID;
	      $scope.vm.model.modifiedBy = $scope.vm.user.name;
	      $scope.vm.model.createdBy = $scope.vm.user.name;
	      $scope.vm.model.active = $scope.vm.model.active ? true : false;
	
	      $scope.postData($scope.vm.model);
	    }
	  };
	
	  $scope.putData = function (data) {
	    $scope.vm.isSubmitting = true;
	    var userId = data.refCodeId,
	        data = JSON.stringify(data);
	
	    new DRGSpecialtyService($http).putSpecialty(userId, data).then(function successCallback(response) {
	      $scope.vm.coder.selectedCoder = $scope.vm.model;
	      $scope.snackBar('Specialty updated');
	
	      // Update the model in the coder options list
	      for (var i = 0; i < $scope.vm.coderOptions.length; i++) {
	        if ($scope.vm.coderOptions[i].refCodeId === $scope.vm.coder.selectedCoder.refCodeId) {
	          $scope.vm.coderOptions[i].comments = $scope.vm.coder.selectedCoder.comments;
	          $scope.vm.coderOptions[i].description = $scope.vm.coder.selectedCoder.description;
	          $scope.vm.coderOptions[i].code = $scope.vm.coder.selectedCoder.code;
	          $scope.vm.coderOptions[i].hl7 = $scope.vm.coder.selectedCoder.hl7;
	          $scope.vm.coderOptions[i].active = $scope.vm.coder.selectedCoder.active;
	        }
	      }
	      $scope.vm.form.$setPristine();
	      $scope.vm.isSubmitting = false;
	    }, function errorCallback(response) {
	      $scope.snackBar("Database error, error saving User.");
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + '/login?logout=true');
	      }
	      $scope.vm.isSubmitting = false;
	    });
	  };
	
	  $scope.postData = function (data) {
	    $scope.vm.isSubmitting = true;
	    new DRGSpecialtyService($http).postSpecialty(data).then(function successCallback(response) {
	      var parsedResponse = JSON.parse(response.data.context.entity).data;
	      // add the ID, so it can be deleted if required
	      $scope.vm.fetchSpecialities(parsedResponse.refCodeId);
	      $scope.snackBar($scope.vm.specialtyString.charAt(0) + $scope.vm.specialtyString.substr(1).toLowerCase() + ' added');
	      $scope.vm.form.$setPristine();
	      $scope.vm.isSubmitting = false;
	    }, function errorCallback(response) {
	      $scope.snackBar('Database error, or ' + $scope.vm.specialtyString.toLowerCase() + ' already exists.');
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + '/login?logout=true');
	      }
	      $scope.vm.isSubmitting = false;
	    });
	  };
	
	  $scope.snackBar = function (message) {
	
	    // upgrade MDI components
	    window.componentHandler.upgradeAllRegistered();
	
	    var snackbarContainer = document.querySelector('#specialty__notification');
	
	    var data = {
	      message: message,
	      timeout: 2000,
	      actionHandler: $scope.finaliseCheck,
	      actionText: 'test'
	    };
	
	    snackbarContainer.MaterialSnackbar.showSnackbar(data);
	  };
	
	  this.fields = [{
	    type: 'lx-input',
	    key: 'description',
	    templateOptions: {
	      'label': 'Description',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'code',
	    templateOptions: {
	      'label': 'Code',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'hl7',
	    templateOptions: {
	      'label': 'HL7',
	      required: true
	    }
	  }, {
	    type: 'lx-switch',
	    key: 'active',
	    templateOptions: {
	      'label': 'Active'
	    }
	  }, {
	    type: 'lx-input',
	    key: 'comments',
	    templateOptions: {
	      'label': 'Alert / Note',
	      required: false
	    }
	  }];
	};
	
	exports.default = SpecialtiesController;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _specialties = __webpack_require__(143);
	
	var _specialties2 = _interopRequireDefault(_specialties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var specialtiesModule = _angular2.default.module('specialties', [_angularUiRouter2.default]).component('specialties', _specialties2.default);
	
	exports.default = specialtiesModule;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _users = __webpack_require__(299);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _users3 = __webpack_require__(147);
	
	var _users4 = _interopRequireDefault(_users3);
	
	__webpack_require__(354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _users2.default,
	  controller: _users4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = usersComponent;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminUserService = function () {
	  function AdminUserService($http, $rootScope) {
	    _classCallCheck(this, AdminUserService);
	
	    if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(AdminUserService, [{
	    key: 'getUsers',
	    value: function getUsers(roleId) {
	      var isAdministrator = roleId === 1 ? true : false;
	      return this.$http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.person/allusers?administrator=' + isAdministrator);
	    }
	  }, {
	    key: 'putUser',
	    value: function putUser(userId, modifiedById, data) {
	      return this.$http.put(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.person/modifiedBy/' + modifiedById + '/person/' + userId + '/', data);
	    }
	  }, {
	    key: 'postUser',
	    value: function postUser(data) {
	      return this.$http.post(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.person', data);
	    }
	  }, {
	    key: 'getDaysOfTheWeek',
	    value: function getDaysOfTheWeek() {
	      return this.$http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/model.day/findAll');
	    }
	  }]);
	
	  return AdminUserService;
	}();
	
	var UsersController = function UsersController($http, $scope, LxDialogService, User, Constants, CONST, $sanitize, DateFormatter, $rootScope, FunctionService) {
	  _classCallCheck(this, UsersController);
	
	  $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	
	  this.user = User.getUser();
	  this.name = 'User';
	  this.specialtyString = '';
	  this.options = {
	    removeChromeAutoComplete: true
	  };
	  this.form = "users";
	  this.coderOptions = [];
	  this.coder = {
	    selectedCoder: {
	      userSchedule: []
	    }
	  };
	  this.specialty = {
	    selectedSpecialty: [],
	    specialtyOptions: []
	  };
	  this.campus = {
	    selectedCampus: [],
	    campusOptions: []
	  };
	  this.roles = {
	    selectedRole: undefined
	  };
	  this.roles.rolesOptions = CONST.ROLE;
	  if ($rootScope.globals.currentUser.role === 'Manager') {
	    this.roles.rolesOptions = ['Auditor', 'CDS', 'Coder', 'Reporter', 'Clerical', 'Manager'];
	  }
	  this.worklist = {
	    selectedWorklist: [],
	    worklistOptions: []
	  };
	  this.codingOperationsTeam = false;
	  this.model = {};
	  this.userSchedule = [];
	  this.userScheduleDays = [];
	
	  this.worklistsFunc = {};
	
	  Constants.lookupsData($scope.vm.user.id, 'worklists').then(function successCallback(response) {
	    $scope.vm.worklist.worklistOptions = response;
	  });
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.functionSettings = response.functionSettings;
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.worklistsFunc = response.functionSettings.Worklists ? response.functionSettings.Worklists : {};
	    $scope.vm.CDIPlatformActive = response.functionSettings.CDI ? response.functionSettings.CDI.isActive : false;
	    if ($scope.vm.CDIPlatformActive) {
	      $scope.vm.roles.rolesOptions = CONST.ROLE;
	      if ($rootScope.globals.currentUser.role === 'Manager') {
	        $scope.vm.roles.rolesOptions = ['Auditor', 'CDS', 'Coder', 'Reporter', 'Clerical', 'Manager'];
	      }
	    } else {
	      $scope.vm.roles.rolesOptions = ['Administrator', 'Auditor', 'Coder', 'Clerical', 'Manager', 'Reporter'];
	      if ($rootScope.globals.currentUser.role === 'Manager') {
	        $scope.vm.roles.rolesOptions = ['Auditor', 'Coder', 'Reporter', 'Clerical', 'Manager'];
	      }
	    }
	  });
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialty.specialtyOptions = response.specialties;
	  });
	
	  Constants.campusData().then(function successCallback(response) {
	    $scope.vm.campus.campusOptions = response;
	  });
	
	  new AdminUserService($http, $scope).getDaysOfTheWeek().then(function successCallback(response) {
	    $scope.vm.userScheduleDays = response.data;
	    // If first user hasn't got default scheduled days entered then populate with zero
	    if ($scope.vm.coder.selectedCoder.userSchedule.length) {
	      angular.forEach($scope.vm.coder.selectedCoder.userSchedule, function (value, key) {
	        value.hoursNumber = parseFloat((value.minutes / 60).toFixed(2));
	      });
	    }
	  }, function errorCallback(response) {
	    if (response.status === 401) {
	      window.location.replace(window.location.origin + '/login?logout=true');
	    }
	  });
	
	  new AdminUserService($http, $scope).getUsers($rootScope.globals.currentUser.roleId).then(function successCallback(response) {
	    angular.forEach(response.data, function (value, key) {
	      value.firstname = $sanitize(value.firstname);
	      value.lastname = $sanitize(value.lastname);
	      $scope.vm.coderOptions.push(value);
	    });
	
	    $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0];
	
	    angular.forEach($scope.vm.coder.selectedCoder.userSchedule, function (value, key) {
	      value.userId = $scope.vm.coder.selectedCoder.id;
	      value.createdById = $scope.vm.user.id;
	      value.hoursNumber = parseFloat((value.minutes / 60).toFixed(2));
	    });
	  }, function errorCallback(response) {
	    if (response.status === 401) {
	      window.location.replace(window.location.origin + '/login?logout=true');
	    }
	  });
	
	  this.addUser = addUser;
	  this.coderCallback = coderCallback;
	  this.selectCallback = selectCallback;
	  this.userScheduleCallback = userScheduleCallback;
	
	  function addUser() {
	    // add a new blank user to the model
	    var addNew = $scope.vm.coderOptions.push({});
	    $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[addNew - 1];
	    $scope.vm.coder.selectedCoder.dtype = 'Coder';
	  }
	
	  function coderCallback(_newValue, _oldValue) {
	    if (_newValue.id !== _oldValue.id) {
	      if ($scope.vm.coder.selectedCoder !== $scope.vm.model) angular.copy($scope.vm.coder.selectedCoder, $scope.vm.model);
	
	      $scope.vm.model.newPassword = "";
	      $scope.vm.model.newPasswordVerify = "";
	
	      var spec,
	          specialtyArr = $scope.vm.coder.selectedCoder.specialty;
	
	      if (specialtyArr) {
	        spec = specialtyArr.split(',');
	      } else {
	        spec = [];
	      }
	
	      $scope.vm.specialty.selectedSpecialty = [];
	
	      angular.forEach(spec, function (value, key) {
	        $scope.vm.specialty.selectedSpecialty.push(value);
	      });
	
	      $scope.vm.campus.selectedCampus = [];
	      var campus,
	          campusArr = $scope.vm.coder.selectedCoder.campus;
	      if (campusArr) {
	        campus = campusArr.split(',');
	      } else {
	        campus = [];
	      }
	      angular.forEach(campus, function (value, key) {
	        $scope.vm.campus.selectedCampus.push(value);
	      });
	
	      $scope.vm.roles.selectedRole = $scope.vm.coder.selectedCoder.dtype;
	
	      var list,
	          worklistArr = $scope.vm.coder.selectedCoder.worklist;
	
	      if (worklistArr) {
	        list = worklistArr.split(',');
	      } else {
	        list = [];
	      }
	
	      $scope.vm.worklist.selectedWorklist = [];
	
	      angular.forEach(list, function (value, key) {
	        $scope.vm.worklist.selectedWorklist.push(value);
	      });
	
	      if ($scope.vm.coder.selectedCoder.userSchedule && !$scope.vm.coder.selectedCoder.userSchedule.length) {
	        angular.forEach($scope.vm.userScheduleDays, function (value, key) {
	          $scope.vm.coder.selectedCoder.userSchedule.push({ dayId: value.dayId, hours: "00:00:00", hoursNumber: 0, minutes: 0, isDeleted: false, userId: $scope.vm.coder.selectedCoder.id, createdById: $scope.vm.user.id });
	        });
	      }
	
	      angular.forEach($scope.vm.coder.selectedCoder.userSchedule, function (value, key) {
	        value.userId = $scope.vm.coder.selectedCoder.id;
	        value.createdById = $scope.vm.user.id;
	        value.hoursNumber = parseFloat((value.minutes / 60).toFixed(2));
	      });
	
	      $scope.vm.model.codingOperationsTeam = $scope.vm.coder.selectedCoder.codingOperationsTeam;
	
	      // reset listener and form state
	      $scope.vm.form.$setPristine();
	      $scope.vm.form.$setValidity();
	      $scope.vm.form.$setUntouched();
	    }
	  }
	
	  function selectCallback(_newValue, _oldValue) {
	    if ($scope.vm.model.specialty !== $scope.vm.specialty.selectedSpecialty.join() || $scope.vm.model.campus !== $scope.vm.campus.selectedCampus.join() || $scope.vm.model.dtype !== $scope.vm.roles.selectedRole || $scope.vm.model.worklist !== $scope.vm.worklist.selectedWorklist.join() || $scope.vm.model.codingOperationsTeam !== $scope.vm.codingOperationsTeam) $scope.vm.form.$setDirty();
	  }
	
	  function userScheduleCallback(_newValue, _oldValue) {
	    if (_newValue !== _oldValue) {
	      $scope.vm.form.$setDirty();
	    }
	  }
	
	  this.openDialog = function () {
	    LxDialogService.open("doubleCheck");
	  };
	
	  this.checkValid = function () {
	    // dis/enable submit button
	    if ($scope.vm.form.$pristine) {
	      return true;
	    } else {
	      if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {
	        return false;
	      } else {
	        return true;
	      }
	    }
	  };
	
	  this.disableUser = function (userId) {
	    // console.log(userId);
	    $scope.vm.model.active = false;
	    $scope.vm.model.password = '';
	    $scope.putData($scope.vm.model);
	
	    angular.forEach($scope.vm.coderOptions, function (value, key) {
	
	      if (value.id === userId) {
	
	        // remove from options
	        $scope.vm.coderOptions.splice(key, 1);
	        // display first
	        $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0];
	
	        return;
	      }
	    });
	  };
	
	  this.submitUser = function () {
	
	    // add selects data
	    $scope.vm.model.specialty = $scope.vm.specialty.selectedSpecialty.join();
	    $scope.vm.model.campus = checkParam($scope.vm.campus.selectedCampus);
	    $scope.vm.model.dtype = $scope.vm.roles.selectedRole;
	    $scope.vm.model.worklist = $scope.vm.worklist.selectedWorklist.join();
	    $scope.vm.model.password = btoa($scope.vm.model.newPasswordVerify);
	
	    // Update hours into minutes
	    $scope.vm.model.userSchedule = $scope.vm.coder.selectedCoder.userSchedule;
	    angular.forEach($scope.vm.model.userSchedule, function (value, key) {
	      value.minutes = parseFloat((value.hoursNumber * 60).toFixed(2));
	    });
	
	    if ($scope.vm.model.id) {
	      // existing user = put
	      $scope.putData($scope.vm.model);
	    } else {
	      // new user = post
	      $scope.vm.model.active = true;
	      $scope.postData($scope.vm.model);
	    }
	  };
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return '';
	    }
	  }
	
	  $scope.putData = function (data) {
	
	    var userId = data.id,
	        data = JSON.stringify(data);
	
	    new AdminUserService($http).putUser(userId, $scope.vm.user.id, data).then(function successCallback(response) {
	
	      $scope.vm.coder.selectedCoder = $scope.vm.model;
	      $scope.snackBar('User updated');
	
	      // reset listener and form state
	      $scope.vm.form.$setPristine();
	      $scope.vm.form.$setValidity();
	      $scope.vm.form.$setUntouched();
	    }, function errorCallback(response) {
	      $scope.snackBar("Database error, error saving User.");
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + '/login?logout=true');
	      }
	    });
	  };
	
	  $scope.postData = function (data) {
	
	    new AdminUserService($http).postUser(data).then(function successCallback(response) {
	
	      // add the ID, so it can be deleted if required
	      $scope.vm.model.id = response.data.data;
	      angular.copy(data, $scope.vm.coder.selectedCoder);
	
	      $scope.snackBar('User added');
	
	      // reset listener and form state
	      $scope.vm.form.$setPristine();
	      $scope.vm.form.$setValidity();
	      $scope.vm.form.$setUntouched();
	    }, function errorCallback(response) {
	      $scope.snackBar("Database error, or email already exists.");
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + '/login?logout=true');
	      }
	    });
	  };
	
	  $scope.snackBar = function (message) {
	
	    // upgrade MDI components
	    window.componentHandler.upgradeAllRegistered();
	
	    var snackbarContainer = document.querySelector('#users__notification');
	    var data = {
	      message: message,
	      timeout: 2000,
	      actionHandler: $scope.finaliseCheck,
	      actionText: 'test'
	    };
	    snackbarContainer.MaterialSnackbar.showSnackbar(data);
	  };
	
	  this.fields = [{
	    type: 'lx-input',
	    key: 'id',
	    hide: true,
	    watcher: {
	      listener: function listener(field, newValue, oldValue, scope, stopWatching) {
	        if (newValue) {
	          scope.model.passwordRequired = false;
	        } else {
	          scope.model.passwordRequired = true;
	        }
	      }
	    }
	  }, {
	    type: 'lx-input',
	    key: 'firstname',
	    templateOptions: {
	      'label': 'First Name',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'lastname',
	    templateOptions: {
	      'label': 'Surname',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'email',
	    templateOptions: {
	      type: 'email',
	      'label': 'Email Address',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'userName',
	    templateOptions: {
	      'label': 'PAS Username',
	      required: true
	    }
	  }, {
	    type: 'lx-input',
	    key: 'newPassword',
	    templateOptions: {
	      'label': 'New Password (min 12 characters, 1 capital & 1 number)',
	      'minlength': 12
	    },
	    validators: {
	      passwordValidation: {
	        expression: function expression(viewValue, modelValue, scope) {
	          if (viewValue) {
	            if (viewValue.length < 12) {
	              return false;
	            } else {
	              var re = /[A-Z].*\d|\d.*[A-Z]/;
	              return re.test(viewValue);
	            }
	          }
	        },
	        message: 'Invalid password'
	      }
	    },
	    hideExpression: function hideExpression($viewValue, $modelValue, scope) {
	      return scope.model.passwordRequired;
	    }
	  }, {
	    type: 'lx-input',
	    key: 'newPasswordVerify',
	    optionsTypes: ['matchField'],
	    templateOptions: {
	      'label': 'Confirm New Password - must match New Password',
	      'minlength': 12
	    },
	    data: {
	      fieldToMatch: 'newPassword',
	      modelToMatch: $scope.vm.model,
	      matchFieldMessage: '$viewValue + " does not match " + options.data.modelToMatch.newPassword'
	    },
	    hideExpression: function hideExpression($viewValue, $modelValue, scope) {
	      return scope.model.passwordRequired;
	    }
	  },
	  // I couldn't get the expressionProperty.required to work so I've fallen back to show/hide required fields
	  {
	    type: 'lx-input',
	    key: 'newPassword',
	    templateOptions: {
	      'label': 'New Password - min 12 characters',
	      'minlength': 12,
	      required: true
	    },
	    hideExpression: function hideExpression($viewValue, $modelValue, scope) {
	      return !scope.model.passwordRequired;
	    }
	  }, {
	    type: 'lx-input',
	    key: 'newPasswordVerify',
	    optionsTypes: ['matchField'],
	    templateOptions: {
	      'label': 'Confirm New Password - must match New Password',
	      'minlength': 12,
	      required: true
	    },
	    hideExpression: function hideExpression($viewValue, $modelValue, scope) {
	      return !scope.model.passwordRequired;
	    },
	    data: {
	      fieldToMatch: 'newPassword',
	      modelToMatch: $scope.vm.model,
	      matchFieldMessage: '$viewValue + " does not match " + options.data.modelToMatch.newPassword'
	    }
	  }];
	};
	
	exports.default = UsersController;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _users = __webpack_require__(146);
	
	var _users2 = _interopRequireDefault(_users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersModule = _angular2.default.module('users', [_angularUiRouter2.default]).component('users', _users2.default);
	
	exports.default = usersModule;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(254);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _services = __webpack_require__(250);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _utils = __webpack_require__(256);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_user2.default.name, _services2.default.name, _utils2.default.name]);
	
	exports.default = commonModule;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _atsi = __webpack_require__(300);
	
	var _atsi2 = _interopRequireDefault(_atsi);
	
	var _atsi3 = __webpack_require__(151);
	
	var _atsi4 = _interopRequireDefault(_atsi3);
	
	__webpack_require__(355);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var atsiComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _atsi2.default,
	  controller: _atsi4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = atsiComponent;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AtsiController = function AtsiController($scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, FunctionService, CONST, materialButtons, datePicker, $rootScope) {
	  _classCallCheck(this, AtsiController);
	
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "ATSI Episode List";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.locale = "en-au";
	
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.episodeaudit?removeCoding=1&";
	  this.initUrl = this.url + "startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L") + "&atsi=";
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // tell DataTables we're using Aussie-formatted dates for ordering
	    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.functionSettings = response.functionSettings;
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	
	    // All Private Clients should be active, All Public should be inactive
	    if ($scope.vm.episodeValue === '$') {
	      console.log('WIES vars set to private');
	      $scope.vm.wiesDefault = "0.00";
	      $scope.vm.wiesParseAmount = 2;
	    } else {
	      console.log('WIES vars set to public');
	      $scope.vm.wiesDefault = "0.0000";
	      $scope.vm.wiesParseAmount = 4;
	    }
	
	    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
	      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
	        return x.mData === "drgVersion";
	      });
	      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
	      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	      filterCampus($scope.vm.campusOptions);
	    });
	  });
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    }, url: $scope.vm.initUrl, type: "GET", error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") window.location.replace(window.location.origin + "/login");
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print", text: ""
	  }, {
	    extend: "csvHtml5", text: "", filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5", text: "", filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "", action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "number" }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "select" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "date-range" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("atsi").withTitle("ATSI Status").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditCriteria").withTitle("Audit Criteria").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("status").withTitle("Audit Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG Version").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drg").withTitle("Original DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("finalDRG").withTitle("Final DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("wies").withTitle("Original").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data) ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("finalWIES").withTitle("Final").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
	  }), DTColumnBuilder.newColumn("totalWIESChange").withTitle("Difference").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.wiesParseAmount);
	  }), DTColumnBuilder.newColumn("auditFinalisedDateTime").withTitle("Date Audit Finalised").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? moment(data).format('DD/MM/YYYY HH:MM') : '';
	  }), DTColumnBuilder.newColumn("atsi").withTitle("ATSI FOR TESTING").withClass("mdl-data-table__cell--non-numeric").notVisible()];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	
	  this.atsi = {
	    selectedAtsi: []
	  };
	  this.atsiOptions = [];
	
	  Constants.lookupsData($scope.vm.user.id, "atsi").then(function successCallback(response) {
	    $scope.vm.atsiOptions = response;
	  });
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty($scope.vm.specialtyOptions);
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "months").startOf("month"), dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"), dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  datePicker.autoClose($scope);
	  this.specialtyCallback = specialtyCallback;
	
	  function specialtyCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function setDtHeaders(table) {
	    $(table.column(getIndexOfColumn('dischargeDate')).header()).html($scope.vm.separationString + ' Date');
	    $(table.column(getIndexOfColumn('speciality')).header()).html($scope.vm.specialtyString);
	    $(table.column(getIndexOfColumn('wies')).header()).html("Original " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn('finalWIES')).header()).html("Final " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn('totalWIESChange')).header()).html($scope.vm.episodeValue + " Difference");
	  }
	
	  function getIndexOfColumn(columnName) {
	    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === columnName;
	    });
	    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
	  }
	
	  function atsiCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function filterAtsi(swap) {
	    $scope.vm.atsi.selectedAtsi = [];
	    if (swap === "add") {
	      $scope.vm.atsi.selectedAtsi = $scope.vm.atsiOptions;
	    }
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  this.changeData = changeData;
	
	  function changeData() {
	    var campus = "";
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	
	    var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&atsi=" + checkParam($scope.vm.atsi.selectedAtsi) + "&campus=" + checkParam(campus);
	    if ($scope.vm.datatableApi) {
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search("").draw();
	
	    filterCampus("minus");
	    filterSpecialty("minus");
	    filterAtsi([0, 1, 3]);
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.vm.changeData();
	    });
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	  this.atsiCallback = atsiCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	
	    switch (thisFilter) {
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	
	        break;
	
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	
	        break;
	
	      case "atsi":
	        filterAtsi(thisModifier);
	
	        break;
	
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = AtsiController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _atsi = __webpack_require__(150);
	
	var _atsi2 = _interopRequireDefault(_atsi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var atsiModule = _angular2.default.module('atsi', [_angularUiRouter2.default]).component('atsi', _atsi2.default);
	
	exports.default = atsiModule;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auditprogramdrgchanges = __webpack_require__(301);
	
	var _auditprogramdrgchanges2 = _interopRequireDefault(_auditprogramdrgchanges);
	
	var _auditprogramdrgchanges3 = __webpack_require__(154);
	
	var _auditprogramdrgchanges4 = _interopRequireDefault(_auditprogramdrgchanges3);
	
	__webpack_require__(356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditprogramdrgchangesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _auditprogramdrgchanges2.default,
	  controller: _auditprogramdrgchanges4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = auditprogramdrgchangesComponent;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, jQuery, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DRGChangeService = function () {
	  function DRGChangeService($http) {
	    _classCallCheck(this, DRGChangeService);
	
	    this.$http = $http;
	  }
	
	  _createClass(DRGChangeService, [{
	    key: "getChangeTypes",
	    value: function getChangeTypes() {
	      return this.$http.get(("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.drgchangetypes");
	    }
	  }]);
	
	  return DRGChangeService;
	}();
	
	var AuditprogramdrgchangesController = function AuditprogramdrgchangesController($http, $rootScope, $scope, DTOptionsBuilder, DTColumnBuilder, User, CONST, Constants, dateTimeHelper, materialButtons, datePicker, ChangeCategory, EpisodeDrgAuditTypeService, CoderService, FunctionService, AuditRuleService) {
	  _classCallCheck(this, AuditprogramdrgchangesController);
	
	  this.dRGChangeService = new DRGChangeService($http);
	
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Audited Medical Records";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.locale = "en-au";
	  $scope.dateTimeHelper = dateTimeHelper;
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.auditprogramdrgchanges";
	  this.initUrl = this.url + "?startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");
	  this.totalProjectedWiesDifference = 0;
	
	  this.errorCategoryOptions = [];
	  $scope.promise = ChangeCategory.data().then(function successCallback(response) {
	    $scope.vm.errorCategoryOptions = response;
	  }, function errorCallback(response) {
	    console.error(response);
	  });
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    // All Private Clients should be active, All Public should be inactive
	    if ($scope.vm.episodeValue === '$') {
	      console.log('WIES vars set to private');
	      $scope.vm.wiesDefault = "0.00";
	      $scope.vm.wiesParseAmount = 2;
	    } else {
	      console.log('WIES vars set to public');
	      $scope.vm.wiesDefault = "0.0000";
	      $scope.vm.wiesParseAmount = 4;
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  // This is needed to obtain the sum of datatable column values
	  jQuery.fn.dataTable.Api.register("sum()", function () {
	    return this.flatten().reduce(function (a, b) {
	      if (typeof a === "string") {
	        a = a.replace(/[^\d.-]/g, "") * 1;
	      }
	      if (typeof b === "string") {
	        b = b.replace(/[^\d.-]/g, "") * 1;
	      }
	
	      return a + b;
	    }, 0);
	  });
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  $scope.drawCallback = function (nRow) {
	    // tell DataTables we're using Aussie-formatted dates for ordering
	    $.fn.dataTable.moment("DD/MM/YYYY");
	    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");
	
	    var table = $("#auditTable").DataTable(),
	        total = 0;
	
	    for (var i = 0; i < table.data().length; i++) {
	      if (parseFloat(table.data()[i].wiesDiff)) total += parseFloat(table.data()[i].wiesDiff);
	    }
	
	    $(".reports__stats #total-queries").html("Total Episodes: " + table.data().count().toLocaleString());
	
	    $(".reports__stats #total-proj-wies").html($scope.vm.episodeValue + " Difference Sum: " + total.toFixed($scope.vm.wiesParseAmount));
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET"
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "number" }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "date-range" }]
	  });
	
	  function yesNo(data) {
	    return data === true ? "Y" : "N";
	  }
	
	  this.dtColumns = [DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("los").withTitle("LOS").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("originalDrg").withTitle("Prev. DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("originalWies").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("originalCoder").withTitle("Original Coder").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("updateName").withTitle("Update Name").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("typeOfChange").withTitle("Type of Change").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("ruleName").withTitle("Audit Rule").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditType").withTitle("Audit Type").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("queryType").withTitle("Query Type").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("errorCategory").withTitle("Error Category").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("ICUHours").withTitle("ICU Hours").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return $scope.dateTimeHelper.convertICUHours(data);
	  }), DTColumnBuilder.newColumn("mechVentilationHours").withTitle("MV Hours").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("NIVentilationHours").withTitle("NIV Hours").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("currentDrg").withTitle("Current DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("currentWies").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("wiesDiff").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("wiesOnly").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? data.localeCompare('y') === 1 ? 'Yes' : 'No' : '';
	  }), DTColumnBuilder.newColumn("patientClassification").withTitle("Patient Classification").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("status").withTitle("Episode Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric")];
	
	  function setDtHeaders(table) {
	    $(table.column(getIndexOfColumn('dischargeDate')).header()).html($scope.vm.separationString + " Date");
	    $(table.column(getIndexOfColumn('speciality')).header()).html($scope.vm.specialtyString);
	    $(table.column(getIndexOfColumn('originalWies')).header()).html("Prev. " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn('currentWies')).header()).html("Current " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn('wiesDiff')).header()).html($scope.vm.episodeValue + " Difference");
	    $(table.column(getIndexOfColumn('wiesOnly')).header()).html($scope.vm.episodeValue + " Only");
	  }
	
	  function getIndexOfColumn(columnName) {
	    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === columnName;
	    });
	    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
	  }
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = [];
	
	  this.auditType = {
	    selectedAuditType: []
	  };
	  this.auditTypeOptions = [];
	
	  this.changeType = {
	    selectedChangeType: []
	  };
	  this.changeTypeOptions = [];
	
	  this.errorCategory = {
	    selectedErrorCategory: []
	  };
	
	  this.coder = {
	    selectedCoder: []
	  };
	  this.coderOptions = [];
	
	  this.queryModifiedBy = {
	    selectedQueryModifiedBy: []
	  };
	
	  this.queryType = {
	    selectedQueryType: ""
	  };
	  this.queryTypeOptions = [];
	  this.queryTypeOptionsWithIds = [];
	
	  this.auditRule = {
	    selectedAuditRule: []
	  };
	  this.auditRuleOptions = [];
	  this.auditRuleOptionsWithIds = [];
	
	  this.wiesOnly = {
	    selectedWiesOnly: ""
	  };
	  this.wiesOnlyOptions = ["Yes", "No"];
	
	  this.statusOptions = CONST.STATUS;
	  this.status = {
	    selectedStatus: []
	  };
	
	  Constants.campusData().then(function successCallback(response) {
	    $scope.vm.campusOptions = response;
	    filterCampus($scope.vm.campusOptions);
	  });
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty("minus");
	    // Can load divisions if needed??
	  });
	
	  EpisodeDrgAuditTypeService.types().then(function successCallback(response) {
	    $scope.vm.auditTypeOptionsWithIds = response;
	    angular.forEach(response, function (value, key) {
	      if ($scope.vm.auditTypeOptions.indexOf(value.name) === -1) $scope.vm.auditTypeOptions.push(value.name);
	    });
	  });
	
	  AuditRuleService.data().then(function successCallback(response) {
	    $scope.vm.auditRuleOptionsWithIds = response;
	    angular.forEach(response, function (value, key) {
	      if ($scope.vm.auditRuleOptions.indexOf(value.name) === -1) $scope.vm.auditRuleOptions.push(value.name);
	    });
	  });
	
	  $scope.vm.dRGChangeService.getChangeTypes().then(function successCallback(response) {
	    angular.forEach(response.data, function (value, key) {
	      if ($scope.vm.changeTypeOptions.indexOf(value.drgChangeType) === -1) {
	        $scope.vm.changeTypeOptions.push(value.drgChangeType);
	      }
	    });
	  });
	
	  CoderService.data().then(function successCallback(response) {
	    angular.forEach(response, function (item, key) {
	      $scope.vm.coderOptions.push(item.name);
	    });
	  });
	
	  Constants.getQueryTemplateData().then(function (data) {
	    if (!$scope.vm.queryTemplateData) {
	      angular.forEach(data, function (value, key) {
	        $scope.vm.queryTypeOptions.push(value.queryTemplateName);
	      });
	    }
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  datePicker.autoClose($scope);
	  this.filterCallback = filterCallback;
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function filterAuditType(swap) {
	    $scope.vm.auditType.selectedAuditType = [];
	    if (swap === "add") {
	      $scope.vm.auditType.selectedAuditType = $scope.vm.auditTypeOptions;
	    }
	  }
	
	  function filterChangeType(swap) {
	    $scope.vm.changeType.selectedChangeType = [];
	    if (swap === "add") {
	      $scope.vm.changeType.selectedChangeType = $scope.vm.changeTypeOptions;
	    }
	  }
	
	  function filterErrorCategory(swap) {
	    $scope.vm.errorCategory.selectedErrorCategory = [];
	    if (swap !== "minus") {
	      angular.forEach($scope.vm.errorCategoryOptions, function (value, key) {
	        $scope.vm.errorCategory.selectedErrorCategory.push($scope.vm.errorCategoryOptions[$scope.vm.errorCategoryOptions.indexOf(value)].changeCategory);
	      });
	    }
	  }
	
	  function filterCoder(swap) {
	    $scope.vm.coder.selectedCoder = [];
	    if (swap !== "minus") {
	      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions;
	    }
	  }
	
	  function filterQueryModifiedBy(swap) {
	    $scope.vm.queryModifiedBy.selectedQueryModifiedBy = [];
	    if (swap !== "minus") {
	      $scope.vm.queryModifiedBy.selectedQueryModifiedBy = $scope.vm.coderOptions;
	    }
	  }
	
	  function filterStatus(swap) {
	    $scope.vm.status.selectedStatus = [];
	    if (swap !== "minus") {
	      $scope.vm.status.selectedStatus = $scope.vm.statusOptions;
	    }
	  }
	
	  function filterAuditRule(swap) {
	    $scope.vm.auditRule.selectedAuditRule = [];
	    if (swap !== "minus") {
	      $scope.vm.auditRule.selectedAuditRule = $scope.vm.auditRuleOptions;
	    }
	  }
	
	  function filterCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  this.changeData = changeData;
	
	  function changeData() {
	    var campus = "";
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var newUrl = $scope.vm.url + "?startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&speciality=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&campus=" + checkParam(campus) + "&auditType=" + checkParam($scope.vm.auditType.selectedAuditType) + "&changeType=" + checkParam($scope.vm.changeType.selectedChangeType) + "&errorCategory=" + checkParam($scope.vm.errorCategory.selectedErrorCategory) + "&coder=" + checkParam($scope.vm.coder.selectedCoder) + "&queryType=" + ($scope.vm.queryType.selectedQueryType ? $scope.vm.queryType.selectedQueryType : "") + "&modifiedBy=" + checkParam($scope.vm.queryModifiedBy.selectedQueryModifiedBy) + "&wiesOnly=" + ($scope.vm.wiesOnly.selectedWiesOnly ? $scope.vm.wiesOnly.selectedWiesOnly : "") + "&status=" + checkParam($scope.vm.status.selectedStatus) + "&auditRule=" + checkParam($scope.vm.auditRule.selectedAuditRule);
	
	    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search("").draw();
	
	    filterCampus("minus");
	    filterSpecialty("minus");
	    filterAuditType("minus");
	    filterChangeType("minus");
	    filterErrorCategory("minus");
	    filterCoder("minus");
	    filterQueryModifiedBy("minus");
	    filterAuditRule("minus");
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.vm.changeData();
	    });
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	
	        break;
	
	      case "auditType":
	        if (thisModifier === "add") {
	          filterAuditType("add");
	        } else {
	          filterAuditType("minus");
	        }
	
	        break;
	
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	
	        break;
	
	      case "changeType":
	        if (thisModifier === "add") {
	          filterChangeType("add");
	        } else {
	          filterChangeType("minus");
	        }
	
	        break;
	
	      case "errorCategory":
	        if (thisModifier === "add") {
	          filterErrorCategory("add");
	        } else {
	          filterErrorCategory("minus");
	        }
	
	        break;
	
	      case "coder":
	        if (thisModifier === "add") {
	          filterCoder("add");
	        } else {
	          filterCoder("minus");
	        }
	
	        break;
	
	      case "auditRule":
	        if (thisModifier === "add") {
	          filterAuditRule("add");
	        } else {
	          filterAuditRule("minus");
	        }
	
	        break;
	
	      case "queryModifiedBy":
	        if (thisModifier === "add") {
	          filterQueryModifiedBy("add");
	        } else {
	          filterQueryModifiedBy("minus");
	        }
	
	        break;
	
	      case "status":
	        if (thisModifier === "add") {
	          filterStatus("add");
	        } else {
	          filterStatus("minus");
	        }
	
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = AuditprogramdrgchangesController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auditprogramdrgchanges = __webpack_require__(153);
	
	var _auditprogramdrgchanges2 = _interopRequireDefault(_auditprogramdrgchanges);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditprogramdrgchangesModule = _angular2.default.module('auditprogramdrgchanges', [_angularUiRouter2.default]).component('auditprogramdrgchanges', _auditprogramdrgchanges2.default);
	
	exports.default = auditprogramdrgchangesModule;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auditprogramresults = __webpack_require__(302);
	
	var _auditprogramresults2 = _interopRequireDefault(_auditprogramresults);
	
	var _auditprogramresults3 = __webpack_require__(157);
	
	var _auditprogramresults4 = _interopRequireDefault(_auditprogramresults3);
	
	__webpack_require__(357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditprogramresultsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _auditprogramresults2.default,
	  controller: _auditprogramresults4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = auditprogramresultsComponent;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuditProgramResultsController = function AuditProgramResultsController($rootScope, $scope, DTOptionsBuilder, DTColumnBuilder, USER, CONST, materialButtons, datePicker, Constants, EpisodeDrgAuditTypeService, FunctionService) {
	  _classCallCheck(this, AuditProgramResultsController);
	
	  this.datatableApi;
	  this.user = USER;
	  this.name = "Audit Program Results";
	  this.locale = "en-au";
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.auditprogramresults";
	  this.initUrl = this.url + "?startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");
	  this.separationString = "";
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  $scope.drawCallback = function (nRow) {
	    // tell DataTables to sort month names in month order rather than alphabetically
	    $.fn.dataTable.moment("MMMM");
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    url: $scope.vm.initUrl,
	    type: "GET"
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withPaginationType("simple_numbers").withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto")
	  // Sorting by this empty column allows the report to be sorted by date (retaining FY order) by default
	  .withOption("aaSorting", [[1, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]);
	
	  this.dtColumns = [DTColumnBuilder.newColumn("dischargeMonth").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"),
	  // This blank column is to allow manual data entry once exported to Excel
	  DTColumnBuilder.newColumn("").withTitle("Episodes").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("episodesAudited").withTitle("Episodes<br>Audited").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("coderErrors").withTitle("Coder<br>Errors").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditorQueries").withTitle("Auditor<br>Queries").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("coderErrorsAuditorQueries").withTitle("Coder Errors and<br>Auditor Queries").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("otherChanges").withTitle("Other<br>Changes").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalChanges").withTitle("Total<br>Changes").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric")];
	
	  function setDtHeaders(table) {
	    $(table.column(0).header()).html($scope.vm.separationString + "<br>Month");
	  }
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	  this.auditType = {
	    selectedAuditType: []
	  };
	  this.auditTypeOptions = [];
	
	  Constants.campusData().then(function successCallback(response) {
	    $scope.vm.campusOptions = response;
	    filterCampus($scope.vm.campusOptions);
	  });
	
	  EpisodeDrgAuditTypeService.types().then(function successCallback(response) {
	    $scope.vm.auditTypeOptionsWithIds = response;
	    angular.forEach(response, function (value, key) {
	      if ($scope.vm.auditTypeOptions.indexOf(value.name) === -1) $scope.vm.auditTypeOptions.push(value.name);
	    });
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  datePicker.autoClose($scope);
	  this.filterCallback = filterCallback;
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterAuditType(swap) {
	    $scope.vm.auditType.selectedAuditType = [];
	    if (swap === "add") {
	      $scope.vm.auditType.selectedAuditType = $scope.vm.auditTypeOptions;
	    }
	  }
	
	  function filterCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function checkParam(param) {
	    if (param && param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  this.changeData = changeData;
	
	  function changeData() {
	    var campus;
	    if ($scope.vm.functionSettings && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var newUrl = $scope.vm.url + "?startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&campus=" + checkParam(campus) + "&auditType=" + checkParam($scope.vm.auditType.selectedAuditType);
	    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search("").draw();
	
	    filterCampus("minus");
	    filterAuditType("minus");
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.vm.changeData();
	    });
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	
	        break;
	
	      case "auditType":
	        if (thisModifier === "add") {
	          filterAuditType("add");
	        } else {
	          filterAuditType("minus");
	        }
	
	        break;
	
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = AuditProgramResultsController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auditprogramresults = __webpack_require__(156);
	
	var _auditprogramresults2 = _interopRequireDefault(_auditprogramresults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditprogramresultsModule = _angular2.default.module('auditprogramresults', [_angularUiRouter2.default]).component('auditprogramresults', _auditprogramresults2.default);
	
	exports.default = auditprogramresultsModule;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auditprogress = __webpack_require__(303);
	
	var _auditprogress2 = _interopRequireDefault(_auditprogress);
	
	var _auditprogress3 = __webpack_require__(160);
	
	var _auditprogress4 = _interopRequireDefault(_auditprogress3);
	
	__webpack_require__(358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditprogressComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _auditprogress2.default,
	  controller: _auditprogress4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = auditprogressComponent;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, jQuery, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FetchService = function () {
	    function FetchService($http) {
	        _classCallCheck(this, FetchService);
	
	        this.$http = $http;
	    }
	
	    _createClass(FetchService, [{
	        key: 'getCareType',
	        value: function getCareType() {
	            return this.$http.get('' + ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/query?domain=CARE');
	        }
	    }]);
	
	    return FetchService;
	}();
	
	var AuditprogressController = function AuditprogressController($scope, DTOptionsBuilder, DTColumnBuilder, USER, Constants, CONST, materialButtons, datePicker, $http, $rootScope, $location, FunctionService) {
	    _classCallCheck(this, AuditprogressController);
	
	    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    this.datatableApi;
	    this.user = USER;
	    this.name = 'Audit Progress';
	    this.episodeValue = '';
	    this.specialtyString = '';
	    this.TUsers = 0;
	    this.TAudited = 0;
	    this.TFinalised = 0;
	    this.TApproved = 0;
	    this.locale = 'en-au';
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.medicalrecords/audited/?';
	    this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(2, 'days').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L');
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	        $scope.vm.functionSettings = response.functionSettings;
	
	        Constants.campusData().then(function successCallback(response) {
	            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	                var campusOptions = [];
	                if (typeof $scope.vm.user.campus === 'string') {
	                    campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
	                } else {
	                    campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
	                }
	                $scope.vm.campusOptions = campusOptions;
	                $scope.vm.campus.selectedCampus = campusOptions;
	            } else {
	                $scope.vm.campusOptions = response;
	            }
	        });
	
	        $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    });
	
	    materialButtons.render();
	    materialButtons.processing();
	
	    jQuery.fn.dataTable.Api.register('sum()', function () {
	        return this.flatten().reduce(function (a, b) {
	            if (typeof a === 'string') {
	                a = a.replace(/[^\d.-]/g, '') * 1;
	            }
	            if (typeof b === 'string') {
	                b = b.replace(/[^\d.-]/g, '') * 1;
	            }
	            return a + b;
	        }, 0);
	    });
	
	    $scope.drawCallback = function (nRow, aData, index) {
	        $scope.vm.TUsers = this.api().column(0).data().count();
	        $scope.vm.TOpenForAudit = this.api().column(1).data().sum();
	        $scope.vm.TApproved = this.api().column(2).data().sum();
	        $scope.vm.TFinalised = this.api().column(3).data().sum();
	        $scope.vm.TAudited = this.api().column(4).data().sum();
	        $scope.vm.TWIESChange = this.api().column(5).data().sum().toFixed(4);
	    };
	
	    $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	        // Datatables has finished init
	        // Initialise searching
	        if ($scope.vm.datatableApi) return;
	
	        $scope.vm.datatableApi = this.api();
	
	        // Update column headers even when no data returned
	        setDtHeaders($scope.vm.datatableApi);
	
	        // setup search filters
	        search();
	
	        // set the table to a fixed height, so it never collapsed up and down
	        $('#auditTable').closest('.dataTables_scrollBody').height(300);
	    };
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	        url: $scope.vm.initUrl,
	        type: 'GET',
	        error: function error(xhr, _error, thrown) {
	            if (thrown == 'Unauthorized') {
	                //window.location.replace(window.location.origin + '/login');
	                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	            }
	        }
	    }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	        // Update column headers if data returned
	        setDtHeaders($('#auditTable').DataTable());
	    }).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[0, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	        extend: 'print',
	        text: ''
	    }, {
	        extend: 'csvHtml5',
	        text: '',
	        filename: $scope.vm.name + '-' + moment().format('YYYYMMDD-HHmm')
	    }, {
	        extend: 'excelHtml5',
	        text: '',
	        filename: $scope.vm.name + '-' + moment().format('YYYYMMDD-HHmm')
	    }, {
	        text: '',
	        action: function action(e, dt, node, config) {
	            dt.ajax.reload();
	        }
	    }]).withColumnFilter({
	        aoColumns: [{ type: 'select' }, { type: 'number' }, { type: 'number' }, { type: 'number' }]
	    });
	
	    this.dtColumns = [DTColumnBuilder.newColumn('PCCLModifiedUser').withTitle('User').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('openForAudit').withTitle('Currently Open for Audit').withOption('defaultContent', '').withClass('mdl-data-table__cell--numeric'), DTColumnBuilder.newColumn('totalQueriesApproved').withTitle('Ready for Clinician Review').withOption('defaultContent', '').withClass('mdl-data-table__cell--numeric'), DTColumnBuilder.newColumn('totalFinalised').withTitle('Finalised').withClass('mdl-data-table__cell--numeric'), DTColumnBuilder.newColumn('totalAudited').withTitle('Audited').withClass('mdl-data-table__cell--numeric'), DTColumnBuilder.newColumn('WIESChange').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--numeric').renderWith(function (data, type, full) {
	        return parseFloat(data).toFixed(4);
	    })];
	
	    this.careType = {
	        selectedCareType: []
	    };
	    this.careTypeOptions = [];
	    this.campus = {
	        selectedCampus: []
	    };
	    this.campusOptions = [];
	    this.specialty = {
	        selectedSpecialty: []
	    };
	    this.specialtyOptions = {};
	
	    this.los = {
	        selectedLos: []
	    };
	    this.losOptions = {};
	
	    Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	        $scope.vm.specialtyOptions = response.specialties;
	        filterSpecialty('add');
	        // Can load divisions if needed??
	    });
	
	    this.startDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(2, 'days').startOf('month'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	        }
	    };
	    this.endDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'days'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	        }
	    };
	
	    // callbacks for lx-selects and lx-date-picker
	    // TODO sort out specialtyCallback/selectCallback
	    this.specialtyCallback = specialtyCallback;
	    this.selectCallback = selectCallback;
	    this.filterCareType = filterCareType;
	    datePicker.autoClose($scope);
	
	    function setDtHeaders(table) {
	        $(table.column(5).header()).html($scope.vm.episodeValue + ' Change');
	    }
	
	    function specialtyCallback(_newValue, _oldValue) {
	        $scope.vm.changeData();
	    }
	
	    function filterSpecialty(swap) {
	        $scope.vm.specialty.selectedSpecialty = [];
	        if (swap === 'add') {
	            $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	        }
	    }
	
	    function filterLos(swap) {
	        $scope.vm.losOptions = CONST.LOSSIMPLE;
	        $scope.vm.los.selectedLos = [];
	
	        if (swap !== 'minus') {
	            angular.forEach(CONST.LOSSIMPLE, function (value, key) {
	                $scope.vm.los.selectedLos.push($scope.vm.losOptions[$scope.vm.losOptions.indexOf(value)]);
	            });
	        }
	    }
	
	    function filterCampus(modifier) {
	        $scope.vm.campus.selectedCampus = [];
	        if (modifier === 'add') {
	            $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	        }
	    }
	
	    function convertParam(param) {
	        var codes = [];
	
	        if (param.length !== 0) {
	            angular.forEach(param, function (value, key) {
	                codes.push(value.code);
	            });
	            return encodeURIComponent(codes.join());
	        } else {
	            return '';
	        }
	    }
	
	    this.changeData = changeData;
	
	    function changeData() {
	        if ($scope.vm.datatableApi) {
	            var campus = '';
	            if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	                if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
	                    campus = $scope.vm.user.campus;
	                } else {
	                    campus = $scope.vm.campus.selectedCampus;
	                }
	            } else {
	                campus = $scope.vm.campus.selectedCampus;
	            }
	            var newUrl = $scope.vm.url + 'startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '&careType=' + convertParam($scope.vm.careType.selectedCareType) + '&campus=' + encodeURIComponent(campus) + '&specialty=' + encodeURIComponent($scope.vm.specialty.selectedSpecialty) + '&los=' + encodeURIComponent($scope.vm.los.selectedLos);
	            $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	        }
	    }
	
	    function search() {
	        // delete any global searches previously applied
	        if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	        var auditTable = $scope.vm.datatableApi;
	
	        filterSpecialty('minus');
	        filterLos('minus');
	
	        // re-draw tabele on datepicker close
	        $scope.$on('lx-date-picker__close-start', function (e, id) {
	            $scope.vm.changeData();
	        });
	    }
	
	    $scope.getCareType = function () {
	        new FetchService($http, $scope).getCareType().then(function successCallback(response) {
	            angular.forEach(response.data, function (value, key) {
	                $scope.vm.careTypeOptions.push(value);
	            });
	        }, function errorCallback(response) {
	            // $scope.feedback = 'Error loading data';
	            if (response.status === 401) {
	                window.location.replace(window.location.origin + '/login?logout=true');
	            }
	        });
	    };
	
	    $scope.getCareType();
	
	    function selectCallback(_newValue, _oldValue) {
	        $scope.vm.changeData();
	    }
	
	    function filterCareType(swap) {
	        $scope.vm.careType.selectedCareType = [];
	
	        if (swap !== 'minus') {
	            angular.forEach($scope.vm.careTypeOptions, function (value, key) {
	                $scope.vm.careType.selectedCareType.push(value);
	            });
	        }
	    }
	
	    // bind filter swap
	    this.filterSwap = filterSwap;
	
	    function filterSwap(thisFilter, thisModifier) {
	        switch (thisFilter) {
	            case 'specialty':
	                if (thisModifier === 'add') {
	                    filterSpecialty('add');
	                } else {
	                    filterSpecialty('minus');
	                }
	                break;
	            case 'los':
	                if (thisModifier === 'add') {
	                    filterLos('add');
	                } else {
	                    filterLos('minus');
	                }
	                break;
	            case 'campus':
	                if (thisModifier === 'add') {
	                    filterCampus('add');
	                } else {
	                    filterCampus('minus');
	                }
	                break;
	            default:
	                break;
	        }
	    }
	
	    // bind the datatable instance to an object to monitor loading
	    this.dtInstanceCallback = dtInstanceCallback;
	
	    function dtInstanceCallback(dtInstance) {
	        $scope.dtInstance = dtInstance._renderer;
	    }
	};
	
	exports.default = AuditprogressController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auditprogress = __webpack_require__(159);
	
	var _auditprogress2 = _interopRequireDefault(_auditprogress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditprogressModule = _angular2.default.module('auditprogress', [_angularUiRouter2.default]).component('auditprogress', _auditprogress2.default);
	
	exports.default = auditprogressModule;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auditresultsummary = __webpack_require__(304);
	
	var _auditresultsummary2 = _interopRequireDefault(_auditresultsummary);
	
	var _auditresultsummary3 = __webpack_require__(163);
	
	var _auditresultsummary4 = _interopRequireDefault(_auditresultsummary3);
	
	__webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditresultsummaryComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _auditresultsummary2.default,
	  controller: _auditresultsummary4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = auditresultsummaryComponent;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuditresultsummaryController = function AuditresultsummaryController($http, $scope, DTOptionsBuilder, DTColumnBuilder, Constants, CONST, User, materialButtons, datePicker, $rootScope, FunctionService, $location, EpisodeDrgAuditTypeService, QueryModalOptions) {
	  _classCallCheck(this, AuditresultsummaryController);
	
	  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	  this.datatableApi;
	  this.user = User.getUser();
	  this.datatableApi;
	  this.name = "Audit Result Summary";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.fixedValue = "";
	  this.locale = "en-au";
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.auditresultsummary?";
	  this.initUrl = this.url + "&startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.functionSettings = response.functionSettings;
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	
	    // All Private Clients should be active, All Public should be inactive
	    if ($scope.vm.episodeValue === "$") {
	      console.log("WIES vars set to private");
	      $scope.vm.wiesDefault = "0.00";
	      $scope.vm.wiesParseAmount = 2;
	    } else {
	      console.log("WIES vars set to public");
	      $scope.vm.wiesDefault = "0.0000";
	      $scope.vm.wiesParseAmount = 4;
	    }
	
	    $scope.vm.functionSettings = response.functionSettings;
	
	    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
	      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
	        return x.mData === "drgVersion";
	      });
	      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
	      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	      filterCampus($scope.vm.campusOptions);
	    });
	  });
	
	  materialButtons.render();
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  $scope.drawCallback = function (nRow) {
	    var table = $("#auditTable").DataTable();
	
	    // Sum the values in the WIES Change column
	    var sumWiesChange = table.column(getIndexOfColumn("wiesDiff")).data().reduce(function (a, b) {
	      return parseFloat(a) + parseFloat(b);
	    }, 0).toFixed($scope.vm.wiesParseAmount);
	    // Display in header
	    $(".reports__stats #total-wies-change").html($scope.vm.episodeValue + " Difference sum: <strong>" + sumWiesChange + "</strong>");
	
	    var dischargeSpecialtiesCount = 0;
	    var querySpecialtiesCount = 0;
	
	    angular.forEach(table.column(4).data(), function (value) {
	      if (angular.isString(value)) {
	        // If the Query Specialty cell is empty, increment dischargeSpecialtiesCount
	        dischargeSpecialtiesCount += value === "" ? 1 : 0;
	        // Otherwise increment querySpecialtiesCount
	        querySpecialtiesCount += value === "" ? 0 : 1;
	      }
	    });
	
	    // Display in header
	    $(".reports__stats #total-specialty").html($scope.vm.specialtyString.charAt(0) + $scope.vm.specialtyString.substr(1).toLowerCase() + " count: <strong>" + dischargeSpecialtiesCount + "</strong>");
	    $(".reports__stats #total-querySpecialty").html("Query " + $scope.vm.specialtyString.toLowerCase() + " count: <strong>" + querySpecialtiesCount + "</strong>");
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]);
	
	  function yesNo(data) {
	    return data === true ? "Y" : "N";
	  }
	
	  this.dtColumns = [DTColumnBuilder.newColumn("episodeQueryId").withTitle("Query ID").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("querySpecialty").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditType").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("queryTemplateName").withTitle("Query Type").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("queryStatus").withTitle("Query Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    switch (data) {
	      case "true":
	        return "Complete";
	      case "false":
	        return "Open";
	      default:
	        return data;
	    }
	  }), DTColumnBuilder.newColumn("updatedDate").withTitle("Updated Date").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data) {
	    return data ? moment(new Date(data)).format('DD/MM/YYYY HH:MM') : '';
	  }), DTColumnBuilder.newColumn("currentDRGDescription").withTitle("Current DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("currentWies").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("wiesDiff").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("auditFinalisedDateTime").withTitle("Date Finalised").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data) {
	    return data ? moment(new Date(data)).format('DD/MM/YYYY HH:MM') : '';
	  }), DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("originalCoder").withTitle("Original Coder").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric")];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	
	  this.queryStatus = {
	    selectedQueryStatus: []
	  };
	  this.queryStatusOptions = [];
	
	  QueryModalOptions.statuses().then(function (response) {
	    angular.forEach(response, function (item, key) {
	      $scope.vm.queryStatusOptions.push(item.name);
	    });
	  });
	
	  this.auditType = {
	    selectedAuditType: []
	  };
	  this.initAuditTypeOptions = [];
	  this.auditTypeOptions = [];
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	
	  this.querySpecialty = {
	    selectedQuerySpecialty: []
	  };
	
	  QueryModalOptions.types().then(function successCallback(response) {
	    angular.forEach(response, function (value, key) {
	      $scope.vm.auditTypeOptions.push(value.name);
	      $scope.vm.initAuditTypeOptions.push(value.name);
	    });
	  });
	
	  Constants.campusData().then(function successCallback(response) {
	    $scope.vm.campusOptions = response;
	    filterCampus($scope.vm.campusOptions);
	  });
	
	  Constants.getDivisionAndSpecialtyData().then(function (response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty(response.specialties);
	    // Can load divisions if needed??
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  // Populate the audit type options for the current environment
	  $scope.getAuditType = function () {
	    EpisodeDrgAuditTypeService.types().then(function successCallback(response) {
	      angular.forEach(response, function (value, key) {
	        $scope.vm.auditTypeOptions.push(value.name);
	      });
	    }, function errorCallback(response) {
	      // $scope.feedback = "Error loading data";
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + "/login?logout=true");
	      }
	    });
	  };
	
	  $scope.getAuditType();
	
	  // callbacks for lx-selects and lx-date-picker
	  this.specialtyCallback = specialtyCallback;
	  datePicker.autoClose($scope);
	
	  function setDtHeaders(table) {
	    $(table.column(getIndexOfColumn("dischargeDate")).header()).html($scope.vm.separationString + " Date");
	    $(table.column(getIndexOfColumn("speciality")).header()).html($scope.vm.specialtyString);
	    $(table.column(getIndexOfColumn("querySpecialty")).header()).html("Query " + $scope.vm.specialtyString);
	    $(table.column(getIndexOfColumn("auditType")).header()).html($scope.vm.functionSettings.QueryModalQueryType && $scope.vm.functionSettings.QueryModalQueryType.isActive ? "Query By" : "Audit Type");
	    $(table.column(getIndexOfColumn("currentWies")).header()).html("Current " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn("wiesDiff")).header()).html($scope.vm.episodeValue + " Difference");
	  }
	
	  function getIndexOfColumn(columnName) {
	    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === columnName;
	    });
	    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
	  }
	
	  function specialtyCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function filterAuditType(swap) {
	    $scope.vm.auditType.selectedAuditType = [];
	    if (swap === "add") {
	      $scope.vm.auditType.selectedAuditType = $scope.vm.auditTypeOptions;
	    }
	  }
	
	  function filterQueryStatus(modifier) {
	    $scope.vm.queryStatus.selectedQueryStatus = [];
	    if (modifier === "add") {
	      $scope.vm.queryStatus.selectedQueryStatus = $scope.vm.queryStatusOptions;
	    }
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function filterQuerySpecialty(swap) {
	    $scope.vm.querySpecialty.selectedQuerySpecialty = [];
	    if (swap === "add") {
	      $scope.vm.querySpecialty.selectedQuerySpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  $scope.vm.changeData = changeData;
	
	  function changeData() {
	    if ($scope.vm.datatableApi) {
	      var campus = "";
	      if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	          campus = $scope.vm.user.campus;
	        } else {
	          campus = $scope.vm.campus.selectedCampus;
	        }
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	      var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&querySpecialty=" + checkParam($scope.vm.querySpecialty.selectedQuerySpecialty) + "&auditType=" + checkParam($scope.vm.auditType.selectedAuditType) + "&queryStatus=" + checkParam($scope.vm.queryStatus.selectedQueryStatus) + "&campus=" + checkParam(campus);
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search("").draw();
	
	    filterAuditType("minus");
	    filterSpecialty("minus");
	    filterCampus("minus");
	    filterQuerySpecialty("minus");
	    filterQueryStatus("minus");
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.vm.changeData();
	    });
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	
	        break;
	
	      case "auditType":
	        if (thisModifier === "add") {
	          filterAuditType("add");
	        } else {
	          filterAuditType("minus");
	        }
	
	        break;
	
	      case "queryStatus":
	        if (thisModifier === "add") {
	          filterQueryStatus("add");
	        } else {
	          filterQueryStatus("minus");
	        }
	
	        break;
	
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	
	        break;
	
	      case "querySpecialty":
	        if (thisModifier === "add") {
	          filterQuerySpecialty("add");
	        } else {
	          filterQuerySpecialty("minus");
	        }
	
	        break;
	
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = AuditresultsummaryController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auditresultsummary = __webpack_require__(162);
	
	var _auditresultsummary2 = _interopRequireDefault(_auditresultsummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditresultsummaryModule = _angular2.default.module('auditresultsummary', [_angularUiRouter2.default]).component('auditresultsummary', _auditresultsummary2.default);
	
	exports.default = auditresultsummaryModule;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auditsbymonth = __webpack_require__(305);
	
	var _auditsbymonth2 = _interopRequireDefault(_auditsbymonth);
	
	var _auditsbymonth3 = __webpack_require__(166);
	
	var _auditsbymonth4 = _interopRequireDefault(_auditsbymonth3);
	
	__webpack_require__(360);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditsbymonthComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _auditsbymonth2.default,
	  controller: _auditsbymonth4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = auditsbymonthComponent;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FetchService = function () {
	  function FetchService($http, $rootScope) {
	    _classCallCheck(this, FetchService);
	
	    if ($rootScope.globals) $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(FetchService, [{
	    key: "getCareType",
	    value: function getCareType() {
	      return this.$http.get("" + ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.refcode/query?domain=CARE");
	    }
	  }]);
	
	  return FetchService;
	}();
	
	var AuditsbymonthController = function AuditsbymonthController($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, $rootScope, $location, FunctionService) {
	  _classCallCheck(this, AuditsbymonthController);
	
	  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Total Audits by Month";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.yearTypeOptions = ["Financial Year", "Calendar Year"];
	  this.finYearOptions = [];
	  this.calYearOptions = [];
	  this.yearOptions = [];
	  this.year = {
	    selectedFy: undefined,
	    yearTypeSelected: undefined
	  };
	
	  this.caretypeOptions = [];
	  this.caretype = {
	    selectedCaretype: []
	  };
	  this.allCareTypeOptions = [];
	
	  this.patientClassOptions = [];
	  this.patientClass = {
	    selectedPatientClass: []
	  };
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.totalauditsbymonth/query?";
	  this.initUrl = "";
	
	  Constants.getDivisionAndSpecialtyData().then(function (response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty(response.specialties);
	    // Can load divisions if needed??
	  });
	
	  Constants.patientClassificationData().then(function successCallback(response) {
	    $scope.vm.patientClassOptions = response;
	  });
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	
	    $scope.vm.functionSettings = response.functionSettings;
	
	    // All Private Clients should be active, All Public should be inactive
	    if ($scope.vm.episodeValue === "$") {
	      console.log("WIES vars set to private");
	      $scope.vm.wiesDefault = "0.00";
	      $scope.vm.wiesParseAmount = 2;
	    } else {
	      console.log("WIES vars set to public");
	      $scope.vm.wiesDefault = "0.0000";
	      $scope.vm.wiesParseAmount = 4;
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	    var selectedYearType = response.functionSettings.CalendarOrFinancialYearReporting && response.functionSettings.CalendarOrFinancialYearReporting.valueString ? response.functionSettings.CalendarOrFinancialYearReporting.valueString : "Financial";
	    $scope.vm.year.yearTypeSelected = selectedYearType + " Year";
	    var startDate = "";
	    var endDate = "";
	    if (selectedYearType === "Calendar") {
	      $scope.vm.yearOptions = $scope.vm.calYearOptions;
	      $scope.vm.year.selectedFy = $scope.vm.calYearOptions[0];
	      startDate = "01/01/" + moment().format("YYYY");
	      endDate = "31/12/" + moment().format("YYYY");
	    } else {
	      $scope.vm.yearOptions = $scope.vm.finYearOptions;
	      $scope.vm.year.selectedFy = $scope.vm.finYearOptions[1];
	      startDate = "01/07/" + $scope.vm.year.selectedFy.substring(0, 4);
	      endDate = "30/06/" + $scope.vm.year.selectedFy.substring(7);
	    }
	    $scope.vm.initUrl = $scope.vm.url + "startDate=" + startDate + "&endDate=" + endDate + "&careType=" + checkParamCare($scope.vm.caretype.selectedCaretype) + "&patientClass=" + checkParam($scope.vm.patientClass.selectedPatientClass) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "";
	    $scope.vm.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	      headers: {
	        Authorization: "Bearer " + $rootScope.globals.currentUser.token
	      },
	      url: $scope.vm.initUrl,
	      type: "GET",
	      error: function error(xhr, _error, thrown) {
	        if (thrown == "Unauthorized") {
	          //window.location.replace(window.location.origin + '/login');
	          console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	        }
	      }
	    }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true)
	    // .withOption('serverSide', true)
	    .withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("initComplete", $scope.initCallback).withOption("rowCallback", function (row, data, index) {
	      // Update column headers if data returned
	      setDtHeaders($("#auditTable").DataTable());
	    }).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	      extend: "print",
	      text: ""
	    }, {
	      extend: "csvHtml5",
	      text: "",
	      filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	      extend: "excelHtml5",
	      text: "",
	      filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	      text: "",
	      action: function action(e, dt, node, config) {
	        dt.ajax.reload();
	      }
	    }]).withColumnFilter({
	      //sPlaceHolder: "head:after",
	      aoColumns: [{ type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
	    });
	  });
	
	  function initFY() {
	    var year = moment().format("YYYY");
	
	    for (var i = 0; i < 2; i++) {
	      $scope.vm.finYearOptions.push(year + " - " + (Number(year) + 1));
	      year--;
	    }
	
	    // Default to current financial year
	    if (moment().month() < 6) {
	      $scope.vm.year.selectedFy = $scope.vm.finYearOptions[1];
	    } else {
	      $scope.vm.year.selectedFy = $scope.vm.finYearOptions[0];
	    }
	
	    $scope.vm.yearOptions = $scope.vm.finYearOptions;
	  }
	
	  function initCalendarYearOptions() {
	    var year = moment().format("YYYY");
	    for (var i = 0; i < 10; i++) {
	      $scope.vm.calYearOptions.push(year);
	      year--;
	    }
	  }
	
	  initFY();
	  initCalendarYearOptions();
	
	  this.locale = "en-au";
	
	  // callback functions
	  this.selectCallback = selectCallback;
	  this.setYearType = setYearType;
	  this.filterPatientClass = filterPatientClass;
	  this.filterCaretype = filterCaretype;
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // make sure DataTables doesn't sort month names alphabetically
	    $.fn.dataTable.moment("MMMM");
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = {};
	
	  this.dtColumns = [DTColumnBuilder.newColumn("id").withTitle("ID").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").notVisible(), DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("monthDischarged").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodes").withTitle("Total<br>Episodes").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodesRequireAudit").withTitle("Total Episodes<br>Required for Audit").withOption("width", "5%").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageMeetCriteria").withTitle("Episodes that<br>Meet Criteria (%)").withOption("width", "5%").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodesAudited").withTitle("Total<br>Episodes Audited").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("coderQueries").withTitle("Coder<br>Queries").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("allOtherAudits").withTitle("All Other<br>Audits").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageAudited").withTitle("Total<br>Episodes Audited (%)").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed(2) + '%' : '0.00%';
	  }), DTColumnBuilder.newColumn("percentageToBeAudited").withTitle("Episodes<br>to be Audited (%)").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed(2) + '%' : '0.00%';
	  }), DTColumnBuilder.newColumn("totalCodingChange").withTitle("Total Episodes<br>With Coding Changes").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalDRGChange").withTitle("Total Episodes<br>with DRG Change ").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("WIESPerEpisode").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return full.totalEpisodes > 0 ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
	  }), DTColumnBuilder.newColumn("sumTotalWIESChange").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return full.totalEpisodes > 0 ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
	  }), DTColumnBuilder.newColumn("totalFinalWies").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return full.totalEpisodes > 0 ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
	  }), DTColumnBuilder.newColumn("targetWIES").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return full.totalEpisodes > 0 && data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
	  }), DTColumnBuilder.newColumn("WIESDifference").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return full.totalEpisodes > 0 && data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
	  }), DTColumnBuilder.newColumn("WIESDifferencePercentage").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed(2) + '%' : '0.00%';
	  })];
	
	  // Search filters
	  this.locale = "en-au";
	
	  function setDtHeaders(table) {
	    $(table.column(getIndexOfColumn("monthDischarged")).header()).html($scope.vm.separationString + "<br>Month");
	    $(table.column(getIndexOfColumn("WIESPerEpisode")).header()).html($scope.vm.episodeValue + " Per Episode ");
	    $(table.column(getIndexOfColumn("sumTotalWIESChange")).header()).html("Total<br>" + $scope.vm.episodeValue + " Change");
	    $(table.column(getIndexOfColumn("totalFinalWies")).header()).html("Total " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn("targetWIES")).header()).html("Target " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn("WIESDifference")).header()).html($scope.vm.episodeValue + " Difference");
	    $(table.column(getIndexOfColumn("WIESDifferencePercentage")).header()).html($scope.vm.episodeValue + " Difference (%)");
	  }
	
	  function getIndexOfColumn(columnName) {
	    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === columnName;
	    });
	    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function checkParamCare(param) {
	    var codes = [];
	
	    if (param.length !== 0) {
	      angular.forEach(param, function (value, key) {
	        codes.push(value.code);
	      });
	
	      return encodeURIComponent(codes.join());
	    } else {
	      return "";
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  this.filterCampus = filterCampus;
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	
	        break;
	
	      default:
	        break;
	    }
	  }
	
	  $scope.reload = function () {
	    if ($scope.vm.datatableApi) {
	      var startDayMonth = "";
	      var endDayMonth = "";
	      var startYear = "";
	      var endYear = "";
	      if ($scope.vm.year.yearTypeSelected === "Financial Year") {
	        startDayMonth = "01/07/";
	        endDayMonth = "30/06/";
	        startYear = $scope.vm.year.selectedFy.substring(0, 4);
	        endYear = $scope.vm.year.selectedFy.substring(7);
	      } else {
	        startDayMonth = "01/01/";
	        endDayMonth = "31/12/";
	        startYear = $scope.vm.year.selectedFy;
	        endYear = $scope.vm.year.selectedFy;
	      }
	      var campus = "";
	      if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	          campus = $scope.vm.user.campus;
	        } else {
	          campus = $scope.vm.campus.selectedCampus;
	        }
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	      var newUrl = $scope.vm.url + "startDate=" + startDayMonth + startYear + "&endDate=" + endDayMonth + endYear + "&careType=" + checkParamCare($scope.vm.caretype.selectedCaretype) + "&patientClass=" + checkParam($scope.vm.patientClass.selectedPatientClass) + "&campus=" + encodeURIComponent(campus) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "";
	
	      $scope.vm.dateRange = startDayMonth + startYear + " - " + endDayMonth + endYear;
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	  };
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    auditTable.search("").draw();
	
	    filterSpecialty("minus");
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.reload();
	    });
	  }
	
	  $scope.getCareType = function () {
	    new FetchService($http, $scope).getCareType().then(function successCallback(response) {
	      angular.forEach(response.data, function (value, key) {
	        $scope.vm.caretypeOptions.push(value);
	
	        if (value.description === "Acute inc Qual Newborn") $scope.vm.caretype.selectedCaretype.push($scope.vm.caretypeOptions[key]);
	      });
	    }, function errorCallback(response) {
	      // $scope.feedback = "Error loading data";
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + "/login?logout=true");
	      }
	    });
	  };
	
	  $scope.getCareType();
	
	  function selectCallback(_newValue, _oldValue) {
	    $scope.reload();
	  }
	
	  // Format year value from select list
	  function setYearType(newValue, oldValue) {
	    if (newValue === "Financial Year") {
	      $scope.vm.yearOptions = $scope.vm.finYearOptions;
	      $scope.vm.year.selectedFy = $scope.vm.finYearOptions[1];
	    } else {
	      $scope.vm.yearOptions = $scope.vm.calYearOptions;
	      $scope.vm.year.selectedFy = $scope.vm.calYearOptions[0];
	    }
	
	    $scope.reload();
	  }
	
	  function filterCaretype(swap) {
	    $scope.vm.caretype.selectedCaretype = [];
	
	    if (swap !== "minus") {
	      angular.forEach($scope.vm.caretypeOptions, function (value, key) {
	        $scope.vm.caretype.selectedCaretype.push(value);
	      });
	    }
	  }
	
	  function filterPatientClass(swap) {
	    $scope.vm.patientClass.selectedPatientClass = [];
	
	    if (swap !== "minus") {
	      $scope.vm.patientClass.selectedPatientClass = $scope.vm.patientClassOptions;
	    }
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	};
	
	exports.default = AuditsbymonthController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auditsbymonth = __webpack_require__(165);
	
	var _auditsbymonth2 = _interopRequireDefault(_auditsbymonth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auditsbymonthModule = _angular2.default.module('auditsbymonth', [_angularUiRouter2.default]).component('auditsbymonth', _auditsbymonth2.default);
	
	exports.default = auditsbymonthModule;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _awaitingreview = __webpack_require__(306);
	
	var _awaitingreview2 = _interopRequireDefault(_awaitingreview);
	
	var _awaitingreview3 = __webpack_require__(169);
	
	var _awaitingreview4 = _interopRequireDefault(_awaitingreview3);
	
	__webpack_require__(361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var awaitingreviewComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _awaitingreview2.default,
	  controller: _awaitingreview4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = awaitingreviewComponent;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, jQuery, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AwaitingreviewController = function AwaitingreviewController($scope, DTOptionsBuilder, DTColumnBuilder, USER, Constants, CONST, materialButtons, datePicker, $rootScope, FunctionService) {
	        _classCallCheck(this, AwaitingreviewController);
	
	        this.datatableApi;
	        this.user = USER;
	        this.name = 'Queries Awaiting Clinician Review';
	        this.episodeValue = '';
	        this.locale = 'en-au';
	        this.specialtyString = '';
	        this.separationString = '';
	        this.western = $rootScope.westernConfig;
	
	        this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.queryawaitingreview?removeCoding=1&';
	        this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L') + '&status=' + encodeURIComponent('3 - Ready for Clinician');
	
	        FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	                $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	                $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	                $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	        });
	
	        materialButtons.render();
	
	        materialButtons.processing();
	
	        // This is needed to obtain the sum of datatable column values
	        jQuery.fn.dataTable.Api.register('sum()', function () {
	                return this.flatten().reduce(function (a, b) {
	                        if (typeof a === 'string') {
	                                a = a.replace(/[^\d.-]/g, '') * 1;
	                        }
	                        if (typeof b === 'string') {
	                                b = b.replace(/[^\d.-]/g, '') * 1;
	                        }
	
	                        return a + b;
	                }, 0);
	        });
	
	        $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	
	                // Datatables has finished init
	                // Initialise searching
	                if ($scope.vm.datatableApi) return;
	
	                $scope.vm.datatableApi = this.api();
	
	                // Update column headers even when no data returned
	                // if (!$scope.vm.western)
	                setDtHeaders($scope.vm.datatableApi);
	
	                // setup search filters
	                search();
	
	                // set the table to a fixed height, so it never collapsed up and down
	                $('#auditTable').closest(".dataTables_scrollBody").height(300);
	        };
	
	        $scope.drawCallback = function (nRow) {
	
	                // tell DataTables we're using Aussie-formatted dates for ordering
	                $.fn.dataTable.moment('DD/MM/YYYY');
	                $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
	
	                var table = $('#auditTable').DataTable();
	
	                $('.reports__stats #total-queries').html('Total Queries: ' + table.data().count());
	
	                if (!$scope.vm.western) $('.reports__stats #total-proj-wies').html('Total Projected ' + $scope.vm.episodeValue + ': ' + parseFloat(table.column(7).data().sum()).toFixed(4));
	        };
	
	        this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                url: $scope.vm.initUrl,
	                type: 'GET',
	                error: function error(xhr, _error, thrown) {
	                        if (thrown == 'Unauthorized') {
	                                //window.location.replace(window.location.origin + '/login');
	                                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                        }
	                }
	        }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	                // Update column headers if data returned
	                if (!$scope.vm.western) setDtHeaders($('#auditTable').DataTable());
	        }).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('scrollX', 'auto').withOption('aaSorting', [[2, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	                extend: 'print',
	                text: ''
	        }, {
	                extend: 'csvHtml5',
	                text: '',
	                filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	        }, {
	                extend: 'excelHtml5',
	                text: '',
	                filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	        }, {
	                text: '',
	                action: function action(e, dt, node, config) {
	                        dt.ajax.reload();
	                }
	        }]).withColumnFilter({
	                //sPlaceHolder: "head:after",
	                aoColumns: [{ type: 'number' }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "date-range" }]
	        });
	
	        function yesNo(data) {
	                return data === true ? "Y" : "N";
	        }
	
	        this.dtColumns = [DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('querySpecialty').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('modifiedDttm').withTitle('Ready for Clinician').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	                return moment(full.modifiedDttm).locale($scope.vm.locale).format('L');
	        }), DTColumnBuilder.newColumn('currentDRG').withTitle('Current DRG').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')];
	
	        if (!$scope.vm.western) this.dtColumns.push(DTColumnBuilder.newColumn('projectedWIES').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'));
	
	        // Search filters
	        this.specialty = {
	                selectedSpecialty: []
	        };
	        this.specialtyOptions = {};
	
	        this.querySpecialty = {
	                selectedQuerySpecialty: []
	        };
	
	        Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	                $scope.vm.specialtyOptions = response.specialties;
	                filterSpecialty($scope.vm.specialtyOptions);
	        });
	
	        this.startDatePicker = {
	                input: {
	                        date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
	                        dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
	                }
	        };
	        this.endDatePicker = {
	                input: {
	                        date: moment().locale(this.locale).subtract(1, 'days'),
	                        dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	                }
	        };
	
	        // callbacks for lx-selects and lx-date-picker
	        datePicker.autoClose($scope);
	        this.filterCallback = filterCallback;
	
	        function setDtHeaders(table) {
	                $(table.column(2).header()).html($scope.vm.separationString + ' Date');
	                $(table.column(3).header()).html($scope.vm.specialtyString);
	                $(table.column(4).header()).html('Query ' + $scope.vm.specialtyString);
	
	                if (!$scope.vm.western) {
	                        $(table.column(7).header()).html('Projected ' + $scope.vm.episodeValue);
	                }
	        }
	
	        function selectFilter(column, filter) {
	
	                if (filter) {
	
	                        filter = filter.join("|");
	
	                        if (filter !== '') filter = '^' + filter + '$';
	
	                        var auditTable = $scope.vm.datatableApi;
	
	                        auditTable.columns(column).search(filter, true, false).draw();
	                }
	        }
	
	        function filterCallback(_newValue, _oldValue) {
	                $scope.vm.changeData();
	        }
	
	        function filterSpecialty(swap) {
	                $scope.vm.specialty.selectedSpecialty = [];
	                if (swap === 'add') {
	                        $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	                }
	        }
	
	        function filterQuerySpecialty(swap) {
	                $scope.vm.querySpecialty.selectedQuerySpecialty = [];
	                if (swap === 'add') {
	                        $scope.vm.querySpecialty.selectedQuerySpecialty = $scope.vm.specialtyOptions;
	                }
	        }
	
	        function setDefaultDate() {
	
	                $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
	                $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');
	
	                $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
	                $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');
	        }
	
	        function checkParam(param) {
	
	                if (param.length !== 0) {
	
	                        return encodeURIComponent(param.join());
	                } else {
	
	                        return "";
	                }
	        }
	
	        this.changeData = changeData;
	
	        function changeData() {
	
	                var newUrl = $scope.vm.url + 'startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty) + '&querySpecialty=' + checkParam($scope.vm.querySpecialty.selectedQuerySpecialty) + '&status=' + encodeURIComponent('3 - Ready for Clinician');
	                if ($scope.vm.datatableApi) {
	                        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	                }
	        }
	
	        function search() {
	
	                // delete any global searches previously applied
	                if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	                var auditTable = $scope.vm.datatableApi;
	                auditTable.search('').draw();
	
	                filterSpecialty('minus');
	                filterQuerySpecialty('minus');
	
	                // re-draw tabele on datepicker close
	                $scope.$on('lx-date-picker__close-start', function (e, id) {
	
	                        $scope.vm.changeData();
	                });
	        }
	
	        // bind the datatable instance to an object to monitor loading
	        this.dtInstanceCallback = dtInstanceCallback;
	
	        function dtInstanceCallback(dtInstance) {
	
	                $scope.dtInstance = dtInstance._renderer;
	        }
	
	        // bind filter swap
	        this.filterSwap = filterSwap;
	
	        function filterSwap(thisFilter, thisModifier) {
	
	                switch (thisFilter) {
	
	                        case 'specialty':
	
	                                if (thisModifier === 'add') {
	
	                                        filterSpecialty('add');
	                                } else {
	
	                                        filterSpecialty('minus');
	                                }
	
	                                break;
	
	                        case 'querySpecialty':
	
	                                if (thisModifier === 'add') {
	
	                                        filterQuerySpecialty('add');
	                                } else {
	
	                                        filterQuerySpecialty('minus');
	                                }
	
	                                break;
	
	                        default:
	                                break;
	                }
	        }
	};
	
	exports.default = AwaitingreviewController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _awaitingreview = __webpack_require__(168);
	
	var _awaitingreview2 = _interopRequireDefault(_awaitingreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var awaitingreviewModule = _angular2.default.module('awaitingreview', [_angularUiRouter2.default]).component('awaitingreview', _awaitingreview2.default);
	
	exports.default = awaitingreviewModule;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _changespercoder = __webpack_require__(307);
	
	var _changespercoder2 = _interopRequireDefault(_changespercoder);
	
	var _changespercoder3 = __webpack_require__(172);
	
	var _changespercoder4 = _interopRequireDefault(_changespercoder3);
	
	__webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var changespercoderComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _changespercoder2.default,
	  controller: _changespercoder4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = changespercoderComponent;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DRGUserService = function () {
	  function DRGUserService($http, $rootScope) {
	    _classCallCheck(this, DRGUserService);
	
	    if ($rootScope.globals) $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(DRGUserService, [{
	    key: "getUsers",
	    value: function getUsers() {
	      return this.$http.get("" + ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.episodeauditlookupvalues/PCCLModifiedUser");
	    }
	  }]);
	
	  return DRGUserService;
	}();
	
	var ChangespercoderController = function ChangespercoderController($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
	  _classCallCheck(this, ChangespercoderController);
	
	  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Changes Per Coder";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.TEC = "TODO";
	  this.TEA = "TODO";
	  this.currentCoderName = "";
	  this.locale = "en-au";
	
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.changespercoder/query?";
	  this.initUrl = this.url + "startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L") + "&coder=" + this.currentCoderName + "&status=&specialty=";
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    // All Private Clients should be active, All Public should be inactive
	    if ($scope.vm.episodeValue === '$') {
	      console.log('WIES vars set to private');
	      $scope.vm.wiesDefault = "0.00";
	      $scope.vm.wiesParseAmount = 2;
	    } else {
	      console.log('WIES vars set to public');
	      $scope.vm.wiesDefault = "0.0000";
	      $scope.vm.wiesParseAmount = 4;
	    }
	
	    if ($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive) {
	      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
	        return x.mData === "drgVersion";
	      });
	      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
	      $scope.vm.dtColumns[indexOfDRGVersionColumn].visible;
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	      filterCampus($scope.vm.campusOptions);
	    });
	  });
	
	  new DRGUserService($http, $scope).getUsers().then(function successCallback(response) {
	    angular.forEach(response.data, function (data, key) {
	      $scope.vm.coderOptions.push(data);
	
	      var indexOfSplitOfCommaSeparated = data.indexOf(", ");
	      // If calhn then in 'Surname, FirstName' format
	      if (indexOfSplitOfCommaSeparated > -1) {
	        var splitNames = data.split(", ");
	        $scope.vm.currentCoderName = splitNames[1] + " " + splitNames[0];
	      } else {
	        $scope.vm.currentCoderName = data;
	      }
	
	      // If the current coder in this iteration is the currently logged in user then set Coder Filter to them
	      if ($scope.vm.currentCoderName === $scope.vm.user.name) {
	        $scope.vm.coder.selectedCoder = data;
	      }
	    });
	
	    $scope.vm.coderOptions.sort();
	
	    if ($scope.vm.coder.selectedCoder === undefined) {
	      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0].value;
	    }
	  }, function errorCallback(response) {
	    if (response.status === 401) {
	      window.location.replace(window.location.origin + "/login?logout=true");
	    }
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // tell DataTables we're using Aussie-formatted dates for ordering
	    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("scrollX", "auto").withOption("aaSorting", [[2, "desc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    aoColumns: [{ type: "number" }, { type: "date-range" }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "select" }, { type: "select" }, { type: "number" }, {
	      type: "text",
	      bRegex: true,
	      bSmart: true
	    }, { type: "number" }]
	  });
	
	  function yesNo(data) {
	    return data === true ? "Yes" : "No";
	  }
	
	  this.dtColumns = [
	  // DTColumnBuilder.newColumn("PCCLModifiedUser")
	  //   .withTitle("Original Coder")
	  //   .withClass("mdl-data-table__cell--non-numeric")
	  //   .notVisible(),
	  DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditCriteria").withTitle("Audit Criteria").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG<br>Version").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").notVisible(), DTColumnBuilder.newColumn("drg").withTitle("Original<br>DRG").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("finalDRG").withTitle("Final<br>DRG").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    var displayCell = full.drg !== full.finalDRG && data ? '<span class="bold">' + data + "</span>" : data ? data : '';
	    return displayCell;
	  }), DTColumnBuilder.newColumn("wies").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
	  }), DTColumnBuilder.newColumn("finalWIES").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
	  }), DTColumnBuilder.newColumn("totalWiesChange").withTitle("Loading...").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    var toFloat = parseFloat(data).toFixed($scope.vm.wiesParseAmount),
	        displayCell = toFloat !== $scope.vm.wiesDefault && !isNaN(toFloat) ? '<span class="bold">' + toFloat + "</span>" : $scope.vm.wiesDefault;
	    return displayCell;
	  }), DTColumnBuilder.newColumn("auditFinalisedDateTime").withTitle("Date Finalised").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? moment(data).format('DD/MM/YYYY HH:mm') : '';
	  }), DTColumnBuilder.newColumn("codesAdded").withTitle("Codes<br>Added").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("codesRemoved").withTitle("Codes<br>Deleted").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("queryGenerated").withTitle("Query<br>Generated").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return yesNo(data);
	  }), DTColumnBuilder.newColumn("episodeChange").withTitle("Episode<br>Change").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return yesNo(data);
	  }), DTColumnBuilder.newColumn("incompleteDocumentation").withTitle("Inc.<br>Docs").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return yesNo(data);
	  }), DTColumnBuilder.newColumn("status").withTitle("Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").notVisible(), DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric")];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	
	  this.status = {
	    selectedStatus: []
	  };
	  this.statusOptions = {};
	
	  this.coderOptions = [];
	  this.coder = {
	    selectedCoder: null
	  };
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty($scope.vm.specialtyOptions);
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  datePicker.autoClose($scope);
	  this.coderCallback = coderCallback;
	  this.coderDisabled = coderDisabled;
	
	  // Respond to user selection
	  // re-draw table on datepicker close
	  $scope.$on("lx-date-picker__close-start", function (e, id) {
	    $scope.vm.coderCallback();
	  });
	
	  function setDtHeaders(table) {
	    $(table.column(getIndexOfColumn('dischargeDate')).header()).html($scope.vm.separationString + " Date");
	    $(table.column(getIndexOfColumn('speciality')).header()).html($scope.vm.specialtyString);
	    $(table.column(getIndexOfColumn('wies')).header()).html("Original " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn('finalWIES')).header()).html("Final " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn('totalWiesChange')).header()).html($scope.vm.episodeValue + " Change");
	  }
	
	  function getIndexOfColumn(columnName) {
	    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === columnName;
	    });
	    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
	  }
	
	  function coderCallback(_newValue, _oldValue) {
	    if ($scope.vm.coder.selectedCoder === null && $scope.vm.coderOptions[0]) {
	      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0].value;
	    }
	    var campus = "";
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&coder=" + $scope.vm.coder.selectedCoder + "&status=" + checkParam($scope.vm.status.selectedStatus) + "&campus=" + checkParam(campus) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty);
	    if ($scope.vm.datatableApi) {
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function coderDisabled() {
	    return $scope.vm.user.role !== "Administrator" && $scope.vm.user.role !== "Reporter";
	  }
	
	  function filterCoder(swap) {
	    if (coderDisabled()) {
	      $scope.vm.coder.selectedCoder = $scope.vm.currentCoderName;
	      $scope.vm.coderCallback();
	    }
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function filterStatus(STATUSES) {
	    // status
	    $scope.vm.statusOptions = CONST.STATUS;
	    $scope.vm.status.selectedStatus = [];
	
	    angular.forEach(STATUSES, function (value, key) {
	      $scope.vm.status.selectedStatus.push($scope.vm.statusOptions[value]);
	    });
	
	    $scope.vm.coderCallback();
	  }
	
	  function setDefaultDate() {
	    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, "months").startOf("month");
	    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, "months").startOf("month").format("L");
	
	    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, "days");
	    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, "days").format("L");
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    auditTable.search("").draw();
	
	    filterCampus("minus");
	    filterSpecialty("minus");
	    filterStatus();
	    filterCoder();
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      if ($scope.vm.coder.selectedCoder === null) {
	        $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0].value;
	      }
	      var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&coder=" + $scope.vm.coder.selectedCoder + "";
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    });
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	
	        break;
	
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	
	        break;
	
	      case "status":
	        if (thisModifier === "add") {
	          filterStatus([0, 1, 2, 3, 4]);
	        } else {
	          filterStatus([]);
	        }
	
	        break;
	
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = ChangespercoderController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _changespercoder = __webpack_require__(171);
	
	var _changespercoder2 = _interopRequireDefault(_changespercoder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var changespercoderModule = _angular2.default.module('changespercoder', [_angularUiRouter2.default]).component('changespercoder', _changespercoder2.default);
	
	exports.default = changespercoderModule;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _codedmedicalrecords = __webpack_require__(308);
	
	var _codedmedicalrecords2 = _interopRequireDefault(_codedmedicalrecords);
	
	var _codedmedicalrecords3 = __webpack_require__(175);
	
	var _codedmedicalrecords4 = _interopRequireDefault(_codedmedicalrecords3);
	
	__webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var codedmedicalrecordsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _codedmedicalrecords2.default,
	  controller: _codedmedicalrecords4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = codedmedicalrecordsComponent;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, jQuery, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FetchService = function () {
	  function FetchService($http, $rootScope) {
	    _classCallCheck(this, FetchService);
	
	    if ($http && $rootScope.globals) $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(FetchService, [{
	    key: "getCareType",
	    value: function getCareType() {
	      return this.$http.get("" + ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.refcode/query?domain=CARE");
	    }
	  }]);
	
	  return FetchService;
	}();
	
	var CodedmedicalrecordsController = function CodedmedicalrecordsController($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService, $timeout) {
	  _classCallCheck(this, CodedmedicalrecordsController);
	
	  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Coded Medical Records";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.totalUsers = 0;
	  this.grandTotalCoded = 0;
	  this.grandTotalWies = 0;
	  this.locale = "en-au";
	
	  this.dateTypeOptions = [{ id: 0, value: "Coded Date" }];
	  this.dateType = this.dateTypeOptions[0];
	  $scope.vm.selectedDateTypeId = this.dateType.id;
	
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.medicalrecords/coded/?";
	  this.initUrl = this.url + "dateType=" + $scope.vm.selectedDateTypeId + "&startDate=" + moment().locale(this.locale).subtract(1, "days").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    var option = { id: 1, value: $scope.vm.separationString + " Date" };
	    $scope.vm.dateTypeOptions.push(option);
	
	    // All Private Clients should be active, All Public should be inactive
	    if ($scope.vm.episodeValue === '$') {
	      console.log('WIES vars set to private');
	      $scope.vm.wiesDefault = "0.00";
	      $scope.vm.wiesParseAmount = 2;
	    } else {
	      console.log('WIES vars set to public');
	      $scope.vm.wiesDefault = "0.0000";
	      $scope.vm.wiesParseAmount = 4;
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  jQuery.fn.dataTable.Api.register("sum()", function () {
	    return this.flatten().reduce(function (a, b) {
	      if (typeof a === "string") {
	        a = a.replace(/[^\d.-]/g, "") * 1;
	      }
	      if (typeof b === "string") {
	        b = b.replace(/[^\d.-]/g, "") * 1;
	      }
	
	      return a + b;
	    }, 0);
	  });
	
	  $scope.drawCallback = function (nRow, aData, index) {
	    $scope.vm.totalUsers = this.api().column(0).data().count();
	    $scope.vm.grandTotalCoded = this.api().column(1).data().sum();
	    $scope.vm.grandTotalWies = this.api().column(2).data().sum().toFixed($scope.vm.wiesParseAmount);
	  };
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[0, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "select" }, { type: "number" }, { type: "number" }, { type: "number" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn("PCCLModifiedUser").withTitle("User").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalCoded").withTitle("Total Coded").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalWies").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.wiesParseAmount);
	  }), DTColumnBuilder.newColumn("avgWies").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.wiesParseAmount);
	  }), DTColumnBuilder.newColumn("avgLOS").withTitle("Average LOS").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.wiesParseAmount);
	  })];
	
	  function setDtHeaders(table) {
	    $(table.column(getIndexOfColumn('totalWies')).header()).html("Total " + $scope.vm.episodeValue);
	    $(table.column(getIndexOfColumn('avgWies')).header()).html("Average " + $scope.vm.episodeValue);
	  }
	
	  function getIndexOfColumn(columnName) {
	    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === columnName;
	    });
	    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
	  }
	
	  // Search filters
	  this.caretypeOptions = [];
	  this.caretype = {
	    selectedCaretype: []
	  };
	  this.allCareTypeOptions = [];
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	
	  this.los = {
	    selectedLos: []
	  };
	  this.losOptions = {};
	
	  Constants.getDivisionAndSpecialtyData().then(function (response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty(response.specialties);
	    // Can load divisions if needed??
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  this.dischargeDateFromPicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(60, "days").startOf("month"),
	      dateFormatted: moment().locale(this.locale).subtract(60, "days").startOf("month").format("L")
	    }
	  };
	
	  this.dischargeDateEndPicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  datePicker.autoClose($scope);
	
	  // callbacks for lx-selects and lx-date-picker
	  // TODO sort out specialtyCallback/selectCallback
	  this.specialtyCallback = specialtyCallback;
	  this.selectCallback = selectCallback;
	  this.filterCaretype = filterCaretype;
	  datePicker.autoClose($scope);
	
	  function specialtyCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterLos(swap) {
	    $scope.vm.losOptions = CONST.LOSSIMPLE;
	    $scope.vm.los.selectedLos = [];
	
	    if (swap !== "minus") {
	      angular.forEach(CONST.LOSSIMPLE, function (value, key) {
	        $scope.vm.los.selectedLos.push($scope.vm.losOptions[$scope.vm.losOptions.indexOf(value)]);
	      });
	    }
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function checkParamCare(param) {
	    var codes = [];
	
	    if (param.length !== 0) {
	      angular.forEach(param, function (value, key) {
	        codes.push(value.code);
	      });
	
	      return encodeURIComponent(codes.join());
	    } else {
	      return "";
	    }
	  }
	
	  this.changeData = changeData;
	
	  function changeData() {
	    if ($scope.vm.datatableApi) {
	      var campus = "";
	      if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	          campus = $scope.vm.user.campus;
	        } else {
	          campus = $scope.vm.campus.selectedCampus;
	        }
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	
	      var newUrl = $scope.vm.url + "dateType=" + $scope.vm.selectedDateTypeId + "&startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&careType=" + checkParamCare($scope.vm.caretype.selectedCaretype) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&campus=" + checkParam(campus) + "&los=" + encodeURIComponent($scope.vm.los.selectedLos);
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    auditTable.search("").draw();
	
	    filterSpecialty("minus");
	    filterLos("minus");
	
	    // re-draw table on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.vm.changeData();
	    });
	  }
	
	  $scope.getCareType = function () {
	    new FetchService($http, $scope).getCareType().then(function successCallback(response) {
	      angular.forEach(response.data, function (value, key) {
	        $scope.vm.caretypeOptions.push(value);
	      });
	    }, function errorCallback(response) {
	      // $scope.feedback = "Error loading data";
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + "/login?logout=true");
	      }
	    });
	  };
	
	  this.setDateType = setDateType;
	
	  function setDateType(newValue) {
	    $scope.vm.dateType = newValue;
	    $scope.vm.selectedDateTypeId = newValue.id;
	    $scope.vm.selectedDateTypeValue = newValue.value;
	    $scope.vm.changeData();
	  }
	
	  $scope.getCareType();
	
	  function selectCallback(_newValue, _oldValue) {
	    //$scope.reload();
	    $scope.vm.changeData();
	  }
	
	  function filterCaretype(swap) {
	    $scope.vm.caretype.selectedCaretype = [];
	
	    if (swap !== "minus") {
	      angular.forEach($scope.vm.caretypeOptions, function (value, key) {
	        $scope.vm.caretype.selectedCaretype.push(value);
	      });
	    }
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	        break;
	
	      case "los":
	        if (thisModifier === "add") {
	          filterLos("add");
	        } else {
	          filterLos("minus");
	        }
	        break;
	
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	        break;
	
	      case "startDate":
	        $scope.vm.startDatePicker.input.date = null;
	        $scope.vm.startDatePicker.input.dateFormatted = null;
	        break;
	
	      case "endDate":
	        $scope.vm.endDatePicker.input.date = null;
	        $scope.vm.endDatePicker.input.dateFormatted = null;
	        break;
	
	      case "dischargeDateFrom":
	        $scope.vm.dischargeDateFromPicker.input.date = null;
	        $scope.vm.dischargeDateFromPicker.input.dateFormatted = null;
	        break;
	
	      case "dischargeDateEnd":
	        $scope.vm.dischargeDateEndPicker.input.date = null;
	        $scope.vm.dischargeDateEndPicker.input.dateFormatted = null;
	        break;
	      default:
	        break;
	    }
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // Force bindings for totals to update once datatable is drawn after page load/refresh
	  $("#auditTable").on("draw.dt", function () {
	    if ($scope.vm.datatableApi) {
	      $timeout(function () {
	        // anything you want can go here and will safely be run on the next digest.
	        $scope.$apply();
	      });
	    }
	  });
	};
	
	exports.default = CodedmedicalrecordsController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _codedmedicalrecords = __webpack_require__(174);
	
	var _codedmedicalrecords2 = _interopRequireDefault(_codedmedicalrecords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var codedmedicalrecordsModule = _angular2.default.module('codedmedicalrecords', [_angularUiRouter2.default]).component('codedmedicalrecords', _codedmedicalrecords2.default);
	
	exports.default = codedmedicalrecordsModule;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coderreviewed = __webpack_require__(309);
	
	var _coderreviewed2 = _interopRequireDefault(_coderreviewed);
	
	var _coderreviewed3 = __webpack_require__(178);
	
	var _coderreviewed4 = _interopRequireDefault(_coderreviewed3);
	
	__webpack_require__(364);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coderreviewedComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _coderreviewed2.default,
	  controller: _coderreviewed4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = coderreviewedComponent;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, jQuery, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CoderreviewedController = function CoderreviewedController($scope, DTOptionsBuilder, DTColumnBuilder, User, CONST, FunctionService, Constants, materialButtons, datePicker, $rootScope) {
	  _classCallCheck(this, CoderreviewedController);
	
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Coding Review Overview";
	  this.separationString = "";
	  this.TAudited = 0;
	  this.TFinalised = 0;
	  this.TApproved = 0;
	
	  this.locale = "en-au";
	
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.medicalrecords/reviewed/?";
	  this.initUrl = this.url + "startDate=" + moment().locale(this.locale).subtract(1, "month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.functionSettings = response.functionSettings;
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  jQuery.fn.dataTable.Api.register("sum()", function () {
	    return this.flatten().reduce(function (a, b) {
	      if (typeof a === "string") {
	        a = a.replace(/[^\d.-]/g, "") * 1;
	      }
	      if (typeof b === "string") {
	        b = b.replace(/[^\d.-]/g, "") * 1;
	      }
	
	      return a + b;
	    }, 0);
	  });
	
	  $scope.drawCallback = function (nRow, aData, index) {
	    $scope.vm.TAudited = this.api().column(1).data().sum();
	    $scope.vm.TFinalised = this.api().column(3).data().sum();
	    $scope.vm.TApproved = this.api().column(4).data().sum();
	  };
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[0, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "select" }, { type: "number" }, { type: "number" }, { type: "number" }]
	  });
	
	  function yesNo(data) {
	    return data === true ? "Y" : "N";
	  }
	
	  this.dtColumns = [DTColumnBuilder.newColumn("PCCLModifiedUser").withTitle("User").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalAudited").withTitle("Total Coded").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalFinalised").withTitle("Total Audited").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalReviewed").withTitle("Total Reviewed").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalNotReviewed").withTitle("Total Not Yet Reviewed").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric")];
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "month"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "month").format("L")
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  datePicker.autoClose($scope);
	
	  function setDefaultDate() {
	    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, "month");
	    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, "month").format("L");
	
	    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, "days");
	    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, "days").format("L");
	  }
	
	  this.changeData = changeData;
	
	  function changeData() {
	    var campus = "";
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&campus=" + checkParam(campus);
	    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    auditTable.search("").draw();
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.vm.changeData();
	    });
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  this.selectCallback = selectCallback;
	  function selectCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  this.filterSwap = filterSwap;
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = CoderreviewedController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _coderreviewed = __webpack_require__(177);
	
	var _coderreviewed2 = _interopRequireDefault(_coderreviewed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coderreviewedModule = _angular2.default.module('coderreviewed', [_angularUiRouter2.default]).component('coderreviewed', _coderreviewed2.default);
	
	exports.default = coderreviewedModule;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _codingactivity = __webpack_require__(310);
	
	var _codingactivity2 = _interopRequireDefault(_codingactivity);
	
	var _codingactivity3 = __webpack_require__(181);
	
	var _codingactivity4 = _interopRequireDefault(_codingactivity3);
	
	__webpack_require__(365);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var codingactivityComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _codingactivity2.default,
	  controller: _codingactivity4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = codingactivityComponent;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodingactivityController = function CodingactivityController($http, $scope, DTOptionsBuilder, DTColumnBuilder, USER, Constants, CONST, materialButtons, datePicker, CareType, $rootScope, FunctionService) {
	  _classCallCheck(this, CodingactivityController);
	
	  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	  this.user = USER;
	  this.name = "Coding Activity Report";
	  this.episodeValue = "";
	  this.episodeValue = "";
	  this.locale = "en-au";
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.codingactivity/codingactivity";
	  this.dtInstance = {};
	  this.monthOptions = [];
	  this.selectedMonth = undefined;
	  this.fyOptions = [];
	  this.selectedFy = undefined;
	  $scope.promise = CareType.data().then(function (data) {
	    $scope.vm.careTypeOptions = data;
	  });
	  this.selectedCareType = [];
	  this.campusOptions = [];
	  this.selectedCampus = [];
	
	  this.dateTypeOptions = [{ id: 0, value: "Original Coding Date" }];
	  this.dateType = this.dateTypeOptions[0];
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	
	    // All Private Clients should be active, All Public should be inactive
	    if ($scope.vm.episodeValue === "$") {
	      console.log("WIES vars set to private");
	      $scope.vm.wiesDefault = "0.00";
	      $scope.vm.wiesParseAmount = 2;
	    } else {
	      console.log("WIES vars set to public");
	      $scope.vm.wiesDefault = "0.0000";
	      $scope.vm.wiesParseAmount = 4;
	    }
	
	    var option = { id: 1, value: $scope.vm.separationString + " Date" };
	    $scope.vm.dateTypeOptions.push(option);
	    $scope.vm.dateType = $scope.vm.dateTypeOptions[1];
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	      filterCampus($scope.vm.campusOptions);
	    });
	  });
	
	  this.startDate = {
	    input: {
	      date: moment().locale(this.locale).subtract(2, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(2, "days").format("L")
	    }
	  };
	  this.endDate = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  this.dischargeDateFromPicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(60, "days").startOf("month"),
	      dateFormatted: moment().locale(this.locale).subtract(60, "days").startOf("month").format("L")
	    }
	  };
	
	  this.dischargeDateEndPicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  datePicker.autoClose($scope);
	
	  initDropdowns();
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.url,
	    type: "GET",
	    data: function data(d) {
	      d.dateType = $scope.vm.dateType.id, d.startDate = $scope.vm.startDate.input.dateFormatted, d.endDate = $scope.vm.endDate.input.dateFormatted, d.campus = $scope.vm.selectedCampus.join(), d.careType = formatCareTypeParam();
	    },
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withPaginationType("simple_numbers").withOption("aaSorting", [[0, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("initComplete", function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Update column headers even when no data returned
	    setDtHeaders();
	  }).withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders();
	  }).withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]);
	
	  this.dtColumns = [DTColumnBuilder.newColumn("coder").withTitle("Coder").withClass("mdl-data-table__cell--non-numeric").withOption("defaultContent", ""), DTColumnBuilder.newColumn("sameDayEpisodes").withTitle("Same Day<br>Episodes").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("sameDayWies").withTitle("Loading...").withClass("mdl-data-table__cell").withOption("defaultContent", "").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.fixedValue);
	  }), DTColumnBuilder.newColumn("overnightEpisodes").withTitle("Overnight<br>Episodes").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("overnightWies").withTitle("Loading...").withClass("mdl-data-table__cell").withOption("defaultContent", "").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.fixedValue);
	  }), DTColumnBuilder.newColumn("multidayEpisodes").withTitle("Multiday<br>Episodes").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("multidayWies").withTitle("Loading...").withClass("mdl-data-table__cell").withOption("defaultContent", "").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.fixedValue);
	  }), DTColumnBuilder.newColumn("multidayLos").withTitle("Multiday<br>LOS").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("multidayAverageLos").withTitle("Multiday<br>Avg LOS").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("totalEpisodes").withTitle("Total<br>Episodes").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("totalWies").withTitle("Loading...").withClass("mdl-data-table__cell").withOption("defaultContent", "").renderWith(function (data, type, full) {
	    return parseFloat(data) ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("totalDays").withTitle("Total<br>LOS").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("totalNumCodes").withTitle("Total No.<br>Codes").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("codedPerHour").withTitle("Coded<br>Per Hour").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("wiesPerHour").withTitle("Loading...").withClass("mdl-data-table__cell").withOption("defaultContent", "").renderWith(function (data, type, full) {
	    return parseFloat(data) ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("percentSameDayOvernight").withTitle("Same Day/Overnight<br>Episodes Percent").withClass("mdl-data-table__cell").withOption("defaultContent", "").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed(2) + "%";
	  }), DTColumnBuilder.newColumn("percentMultiday").withTitle("Multiday<br>Episodes Percent").withClass("mdl-data-table__cell").withOption("defaultContent", "").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed(2) + "%";
	  }), DTColumnBuilder.newColumn("totalNumCodesPerHour").withTitle("Total Codes<br>Per Hour").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("codingHours").withTitle("Coding<br>Hours").withClass("mdl-data-table__cell").withOption("defaultContent", ""), DTColumnBuilder.newColumn("queriesGenerated").withTitle("Queries<br>Generated").withClass("mdl-data-table__cell").withOption("defaultContent", "")];
	
	  function setDtHeaders() {
	    $($("#auditTable").DataTable().column(getIndexOfColumn("sameDayWies")).header()).html("Same Day<br>" + $scope.vm.episodeValue);
	    $($("#auditTable").DataTable().column(getIndexOfColumn("overnightWies")).header()).html("Overnight<br>" + $scope.vm.episodeValue);
	    $($("#auditTable").DataTable().column(getIndexOfColumn("multidayWies")).header()).html("Multiday<br>" + $scope.vm.episodeValue);
	    $($("#auditTable").DataTable().column(getIndexOfColumn("totalWies")).header()).html("Total<br>" + $scope.vm.episodeValue);
	    $($("#auditTable").DataTable().column(getIndexOfColumn("wiesPerHour")).header()).html($scope.vm.episodeValue + "<br>Per Hour");
	  }
	
	  function getIndexOfColumn(columnName) {
	    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === columnName;
	    });
	    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
	  }
	
	  function initDropdowns() {
	    // Order the months in the dropdown from July to June
	    for (var i = 6; i < 12; i++) {
	      // July to December
	      $scope.vm.monthOptions.push(moment.months(i));
	    }
	
	    for (var i = 0; i < 6; i++) {
	      // January to June
	      $scope.vm.monthOptions.push(moment.months(i));
	    }
	
	    $scope.vm.selectedMonth = moment().format("MMMM"); // Default to current month
	
	    // Format the financial year dropdown values
	    if (moment().month() < 6) {
	      var year = moment().format("YYYY");
	    } else {
	      var year = moment().add(1, "year").format("YYYY");
	    }
	
	    for (var i = 0; i < 2; i++) {
	      // Current finanical year, then the previous one
	      $scope.vm.fyOptions.push(year - 1 + " - " + year);
	      year--;
	    }
	
	    $scope.vm.selectedFy = $scope.vm.fyOptions[0]; // Default to current financial year
	  }
	
	  // Respond to user selection
	  // re-draw table on datepicker close
	  $scope.$on("lx-date-picker__close-start", function (e, id) {
	    var table = $("#auditTable").DataTable();
	    table.ajax.url($scope.vm.url).load().draw();
	  });
	
	  this.setDateType = setDateType;
	
	  function setDateType(newValue) {
	    $scope.vm.dateType = newValue;
	    $scope.vm.selectedDateTypeId = newValue.id;
	    $scope.vm.selectedDateTypeValue = newValue.value;
	    $scope.vm.reloadData();
	  }
	
	  this.setMonth = setMonth;
	
	  function setMonth(newValue) {
	    $scope.vm.selectedMonth = newValue;
	    reloadData();
	  }
	
	  this.setYear = setYear;
	
	  function setYear(newValue) {
	    $scope.vm.selectedFy = newValue;
	    reloadData();
	  }
	
	  this.setCampus = setCampus;
	
	  function setCampus(newValue) {
	    $scope.vm.selectedCampus = newValue;
	    reloadData();
	  }
	
	  this.setCareType = setCareType;
	
	  function setCareType(newValue) {
	    $scope.vm.selectedCareType = newValue;
	    reloadData();
	  }
	
	  this.reloadData = reloadData;
	
	  function reloadData() {
	    $scope.vm.dtInstance.reloadData();
	  }
	
	  // Get the care type codes rather than send the descriptions
	  this.formatCareTypeParam = formatCareTypeParam;
	
	  function formatCareTypeParam() {
	    var codes = [];
	
	    if ($scope.vm.selectedCareType.length !== 0) {
	      angular.forEach($scope.vm.selectedCareType, function (value, key) {
	        codes.push(value.code);
	      });
	
	      return codes.join();
	    } else {
	      return "";
	    }
	  }
	
	  // Plus/minus functionality for filters
	  function filterCareType(modifier) {
	    if ($scope.vm.careType) {
	      $scope.vm.careType.selectedCareType = []; // In case minus was clicked
	
	      if (modifier === "add") {
	        // If minus wasn't clicked, assign all the values
	        $scope.vm.careType.selectedCareType = CONST.CARETYPE;
	      }
	    }
	  }
	
	  function filterCampus(modifier) {
	    if ($scope.vm.campus) {
	      $scope.vm.campus.selectedCampus = []; // In case minus was clicked
	
	      if (modifier === "add") {
	        $scope.vm.campus.selectedCampus = $scope.vm.campusOptions; // If minus wasn't clicked, assign all the values
	      }
	    }
	  }
	
	  // Call the appropriate function to add/remove values
	  this.filterSwap = filterSwap;
	
	  function filterSwap(filter, modifier) {
	    switch (filter) {
	      case "careType":
	        filterCareType(modifier);
	        break;
	
	      case "campus":
	        filterCampus(modifier);
	        break;
	      case "startDate":
	        $scope.vm.startDate.input.date = null;
	        $scope.vm.startDate.input.dateFormatted = null;
	        break;
	
	      case "endDate":
	        $scope.vm.endDate.input.date = null;
	        $scope.vm.endDate.input.dateFormatted = null;
	        break;
	
	      case "dischargeDateFrom":
	        $scope.vm.dischargeDateFromPicker.input.date = null;
	        $scope.vm.dischargeDateFromPicker.input.dateFormatted = null;
	        break;
	
	      case "dischargeDateEnd":
	        $scope.vm.dischargeDateEndPicker.input.date = null;
	        $scope.vm.dischargeDateEndPicker.input.dateFormatted = null;
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = CodingactivityController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _codingactivity = __webpack_require__(180);
	
	var _codingactivity2 = _interopRequireDefault(_codingactivity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var codingactivityModule = _angular2.default.module('codingactivity', [_angularUiRouter2.default]).component('codingactivity', _codingactivity2.default);
	
	exports.default = codingactivityModule;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _commonchangedtodrg = __webpack_require__(311);
	
	var _commonchangedtodrg2 = _interopRequireDefault(_commonchangedtodrg);
	
	var _commonchangedtodrg3 = __webpack_require__(184);
	
	var _commonchangedtodrg4 = _interopRequireDefault(_commonchangedtodrg3);
	
	__webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonchangedtodrgComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _commonchangedtodrg2.default,
	  controller: _commonchangedtodrg4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = commonchangedtodrgComponent;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommonchangedtodrgController = function CommonchangedtodrgController($scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, datePicker, $rootScope, FunctionService) {
	  _classCallCheck(this, CommonchangedtodrgController);
	
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Common Changed to DRG";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.locale = "en-au";
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.commonchangetodrg/query?";
	  this.initUrl = this.url + "startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L") + "";
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    // All Private Clients should be active, All Public should be inactive
	    if ($scope.vm.episodeValue === "$") {
	      console.log("WIES vars set to private");
	      $scope.vm.wiesDefault = "0.00";
	      $scope.vm.wiesParseAmount = 2;
	    } else {
	      console.log("WIES vars set to public");
	      $scope.vm.wiesDefault = "0.0000";
	      $scope.vm.wiesParseAmount = 4;
	    }
	
	    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
	      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
	        return x.mData === "drgVersion";
	      });
	      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
	      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  datePicker.autoClose($scope);
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true)
	  // .withOption('serverSide', true)
	  .withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("initComplete", $scope.initCallback).withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "desc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]);
	
	  this.dtColumns = [DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG<br>Version").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drg").withTitle("DRG").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalChangesOfDRG").withTitle("Total Changed to DRG").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("sumTotalWIESChange").withTitle("Loading...").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("avgChangePerEpisode").withTitle("Average Change per Episode").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
	  }), DTColumnBuilder.newColumn("totalQueryGenerated").withTitle("Query Generated by Coder").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalQueryGeneratedCoder").withTitle("Query Generated by Auditor").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodeChange").withTitle("Episode Change").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalIncompleteDocumentation").withTitle("Incomplete Documentation").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric")];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	  this.auditCriteria = {
	    selectedCriteria: []
	  };
	  this.auditCriteriaOptions = {};
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty($scope.vm.specialtyOptions);
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  this.campusCallback = campusCallback;
	  function campusCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	
	  this.specialtyCallback = specialtyCallback;
	  function specialtyCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	
	  function selectFilter(column, filter) {
	    if (filter) {
	      // convert array to datatables permissable regex string
	      filter = filter.join("|");
	
	      if (filter !== "") filter = "^" + filter + "$";
	
	      var auditTable = $scope.vm.datatableApi;
	
	      auditTable.columns(column).search(filter, true, false).draw();
	    }
	  }
	
	  function setDtHeaders(table) {
	    $(table.column(getIndexOfColumn('speciality')).header()).html($scope.vm.specialtyString);
	    $(table.column(getIndexOfColumn('sumTotalWIESChange')).header()).html("Total " + $scope.vm.episodeValue + " Change");
	  }
	
	  function getIndexOfColumn(columnName) {
	    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === columnName;
	    });
	    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function setDefaultDate() {
	    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, "months").startOf("month");
	    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, "months").startOf("month").format("L");
	
	    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, "days");
	    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, "days").format("L");
	  }
	
	  function filterDate() {
	    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
	        endDate = $scope.vm.endDatePicker.input.dateFormatted,
	        campus = "";
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var url = $scope.vm.url + "&startDate=" + startDate + "&endDate=" + endDate + "&campus=" + checkParam(campus) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty);
	    $scope.vm.datatableApi.ajax.url(url).load().draw();
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search("").draw();
	
	    filterSpecialty("minus");
	
	    filterDate();
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "";
	      $scope.vm.datatableApi.ajax.url(newUrl).load();
	    });
	
	    // Trigger filtering
	    // $('.reports__filters').find('div').first().find('div:last-child').click();
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	        break;
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = CommonchangedtodrgController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _commonchangedtodrg = __webpack_require__(183);
	
	var _commonchangedtodrg2 = _interopRequireDefault(_commonchangedtodrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonchangedtodrgModule = _angular2.default.module('commonchangedtodrg', [_angularUiRouter2.default]).component('commonchangedtodrg', _commonchangedtodrg2.default);
	
	exports.default = commonchangedtodrgModule;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _commondrgchanges = __webpack_require__(312);
	
	var _commondrgchanges2 = _interopRequireDefault(_commondrgchanges);
	
	var _commondrgchanges3 = __webpack_require__(187);
	
	var _commondrgchanges4 = _interopRequireDefault(_commondrgchanges3);
	
	__webpack_require__(367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commondrgchangesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _commondrgchanges2.default,
	  controller: _commondrgchanges4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = commondrgchangesComponent;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommondrgchangesController = function CommondrgchangesController($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, USER, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
	  _classCallCheck(this, CommondrgchangesController);
	
	  this.datatableApi;
	  this.user = USER;
	  this.name = 'Common DRG Changes';
	  this.episodeValue = '';
	  this.specialtyString = '';
	  this.separationString = '';
	  this.locale = 'en-au';
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.commondrgchanges/query?';
	  this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L') + '';
	  this.showEpisodeChangeColumn = true;
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === 'string') {
	          campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    $scope.vm.showEpisodeChangeColumn = $scope.vm.functionSettings.CommonDRGChangesReportEpisodeChangeColumn.isActive ? true : false;
	
	    if (!$scope.vm.showEpisodeChangeColumn) {
	      var episodeChangeColumn = $scope.vm.dtColumns.filter(function (x) {
	        return x.mData === 'totalEpisodeChange';
	      });
	      var indexOfEpisodeChangeColumn = $scope.vm.dtColumns.indexOf(episodeChangeColumn[0]);
	      $scope.vm.dtColumns.splice(indexOfEpisodeChangeColumn, 1);
	    }
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $('#auditTable').closest(".dataTables_scrollBody").height(300);
	  };
	
	  $scope.drawCallback = function (nRow, aData, index) {
	
	    $('#auditTable tbody').on('dblclick', 'tr', function () {
	
	      var table = $('#auditTable').DataTable();
	      var data = table.row(this).data();
	      // On double click navigate to details page
	      $scope.$apply(function () {
	
	        // ng-router with param
	        $state.go("reports.commonicdchangesbydrg", { drg: data.drg, startDate: $scope.vm.startDatePicker.input.dateFormatted, endDate: $scope.vm.endDatePicker.input.dateFormatted, specialty: $scope.vm.specialty.selectedSpecialty });
	      });
	    });
	  };
	
	  datePicker.autoClose($scope);
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	    url: $scope.vm.initUrl,
	    // url: '/app/JSON-backup/auditList.json',
	    type: 'GET',
	    error: function error(xhr, _error, thrown) {
	      if (thrown == 'Unauthorized') {
	        //window.location.replace(window.location.origin + '/login');
	        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true)
	  // .withOption('serverSide', true)
	  .withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('initComplete', $scope.initCallback).withOption('rowCallback', function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($('#auditTable').DataTable());
	  }).withOption('drawCallback', $scope.drawCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[4, 'desc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: 'print',
	    text: ''
	  }, {
	    extend: 'csvHtml5',
	    text: '',
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: 'excelHtml5',
	    text: '',
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: '',
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "select" }, { type: "number" }, {
	      type: "text",
	      bRegex: true,
	      bSmart: true
	    }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn('campus').withTitle('Campus').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('drg').withTitle('Original DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalDRGOccurrence').withTitle('Total DRG Occurrence').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalDRGAudited').withTitle('Finalised DRGs').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalChange').withTitle('Audited DRGs').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalWIESChange').withTitle('Loading...').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('avgChangePerEpisode').withTitle('Average Change per Episode').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalQueryGeneratedCoder').withTitle('Query Generated by Coder').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalGeneratedAuditor').withTitle('Query Generated by Auditor').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalEpisodeChange').withTitle('Episode Change').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalIncompleteDocumentation').withTitle('Incomplete Documentation').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric')];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	  this.auditCriteria = {
	    selectedCriteria: []
	  };
	  this.auditCriteriaOptions = {};
	
	  this.locale = 'en-au';
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty($scope.vm.specialtyOptions);
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
	      dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, 'days'),
	      dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  this.campusCallback = campusCallback;
	  function campusCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	
	  this.specialtyCallback = specialtyCallback;
	  function specialtyCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	  function setDtHeaders(table) {
	    $(table.column(1).header()).html($scope.vm.specialtyString);
	    $(table.column(6).header()).html('Total ' + $scope.vm.episodeValue + ' Change');
	  }
	
	  function selectFilter(column, filter) {
	
	    if (filter) {
	
	      // convert array to datatables permissable regex string
	      filter = filter.join("|");
	
	      if (filter !== '') filter = '^' + filter + '$';
	
	      var auditTable = $scope.vm.datatableApi;
	
	      auditTable.columns(column).search(filter, true, false).draw();
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === 'add') {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === 'add') {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function setDefaultDate() {
	
	    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
	    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');
	
	    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
	    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');
	  }
	
	  function filterDate() {
	    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
	        endDate = $scope.vm.endDatePicker.input.dateFormatted;
	    var campus = '';
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var url = $scope.vm.url + '&startDate=' + startDate + '&endDate=' + endDate + '&campus=' + checkParam(campus) + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty);
	    $scope.vm.datatableApi.ajax.url(url).load().draw();
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function search() {
	
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search('').draw();
	
	    filterSpecialty('minus');
	
	    filterDate();
	
	    // re-draw tabele on datepicker close
	    $scope.$on('lx-date-picker__close-start', function (e, id) {
	
	      filterDate();
	    });
	
	    // Trigger filtering
	    $('.reports__filters').find('div').first().find('div:last-child').click();
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case 'specialty':
	        if (thisModifier === 'add') {
	          filterSpecialty('add');
	        } else {
	          filterSpecialty('minus');
	        }
	        break;
	      case 'campus':
	        if (thisModifier === 'add') {
	          filterCampus('add');
	        } else {
	          filterCampus('minus');
	        }
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = CommondrgchangesController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _commondrgchanges = __webpack_require__(186);
	
	var _commondrgchanges2 = _interopRequireDefault(_commondrgchanges);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commondrgchangesModule = _angular2.default.module('commondrgchanges', [_angularUiRouter2.default]).component('commondrgchanges', _commondrgchanges2.default);
	
	exports.default = commondrgchangesModule;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _commonicdchanges = __webpack_require__(313);
	
	var _commonicdchanges2 = _interopRequireDefault(_commonicdchanges);
	
	var _commonicdchanges3 = __webpack_require__(190);
	
	var _commonicdchanges4 = _interopRequireDefault(_commonicdchanges3);
	
	__webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonicdchangesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _commonicdchanges2.default,
	  controller: _commonicdchanges4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = commonicdchangesComponent;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommonicdchangesController = function CommonicdchangesController($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
	  _classCallCheck(this, CommonicdchangesController);
	
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = 'Common Coding Changes';
	  this.episodeValue = '';
	  this.specialtyString = '';
	  this.separationString = '';
	  this.locale = 'en-au';
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodedg1detail/querychanges?';
	  this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L') + '';
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === 'string') {
	          campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $('#auditTable').closest(".dataTables_scrollBody").height(300);
	  };
	
	  datePicker.autoClose($scope);
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	    url: $scope.vm.initUrl,
	    // url: '/app/JSON-backup/auditList.json',
	    type: 'GET',
	    error: function error(xhr, _error, thrown) {
	      if (thrown == 'Unauthorized') {
	        //window.location.replace(window.location.origin + '/login');
	        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true)
	  // .withOption('serverSide', true)
	  .withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($('#auditTable').DataTable());
	  }).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[4, 'desc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: 'print',
	    text: ''
	  }, {
	    extend: 'csvHtml5',
	    text: '',
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: 'excelHtml5',
	    text: '',
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: '',
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "select" }, {
	      type: "text",
	      bRegex: true,
	      bSmart: true
	    }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn('campus').withTitle('Campus').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('diagCode').withTitle('ICD/ACHI Code & Description').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalDRGOccurrence').withTitle('Total Occurrence').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalDRGAudited').withTitle('Total Added').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalRemoved').withTitle('Total Removed').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalChange').withTitle('DRG Change').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalWIESChange').withTitle('Loading...').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('avgChangePerEpisode').withTitle('Average Change per Episode').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalQueryGeneratedCoder').withTitle('Query Generated by Coder').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalGeneratedAuditor').withTitle('Query Generated by Auditor').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalEpisodeChange').withTitle('Episode Change').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalIncompleteDocumentation').withTitle('Incomplete Documentation').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric')];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	  this.auditCriteria = {
	    selectedCriteria: []
	  };
	  this.auditCriteriaOptions = {};
	
	  this.locale = 'en-au';
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty($scope.vm.specialtyOptions);
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
	      dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, 'days'),
	      dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  this.campusCallback = campusCallback;
	  function campusCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	
	  this.specialtyCallback = specialtyCallback;
	  function specialtyCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	
	  function setDtHeaders(table) {
	    $(table.column(1).header()).html($scope.vm.specialtyString);
	    $(table.column(7).header()).html($scope.vm.episodeValue + ' Change');
	  }
	
	  function selectFilter(column, filter) {
	
	    if (filter) {
	
	      // convert array to datatables permissable regex string
	      filter = filter.join("|");
	
	      if (filter !== '') filter = '^' + filter + '$';
	
	      var auditTable = $scope.vm.datatableApi;
	
	      auditTable.columns(column).search(filter, true, false).draw();
	    }
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === 'add') {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === 'add') {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function setDefaultDate() {
	
	    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
	    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');
	
	    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
	    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');
	  }
	
	  function filterDate() {
	    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
	        endDate = $scope.vm.endDatePicker.input.dateFormatted;
	    var campus = '';
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var url = $scope.vm.url + '&startDate=' + startDate + '&endDate=' + endDate + '&campus=' + checkParam(campus) + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty);
	    $scope.vm.datatableApi.ajax.url(url).load().draw();
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function search() {
	
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search('').draw();
	
	    filterSpecialty('minus');
	
	    filterDate();
	
	    // re-draw tabele on datepicker close
	    $scope.$on('lx-date-picker__close-start', function (e, id) {
	
	      filterDate();
	    });
	
	    // Trigger filtering
	    $('.reports__filters').find('div').first().find('div:last-child').click();
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case 'specialty':
	        if (thisModifier === 'add') {
	          filterSpecialty('add');
	        } else {
	          filterSpecialty('minus');
	        }
	        break;
	      case 'campus':
	        if (thisModifier === 'add') {
	          filterCampus('add');
	        } else {
	          filterCampus('minus');
	        }
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = CommonicdchangesController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _commonicdchanges = __webpack_require__(189);
	
	var _commonicdchanges2 = _interopRequireDefault(_commonicdchanges);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonicdchangesModule = _angular2.default.module('commonicdchanges', [_angularUiRouter2.default]).component('commonicdchanges', _commonicdchanges2.default);
	
	exports.default = commonicdchangesModule;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _commonicdchangesbydrg = __webpack_require__(314);
	
	var _commonicdchangesbydrg2 = _interopRequireDefault(_commonicdchangesbydrg);
	
	var _commonicdchangesbydrg3 = __webpack_require__(193);
	
	var _commonicdchangesbydrg4 = _interopRequireDefault(_commonicdchangesbydrg3);
	
	__webpack_require__(369);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonicdchangesbydrgComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _commonicdchangesbydrg2.default,
	  controller: _commonicdchangesbydrg4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = commonicdchangesbydrgComponent;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommonicdchangesbydrgController = function CommonicdchangesbydrgController($state, $scope, $q, $timeout, $stateParams, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
	  _classCallCheck(this, CommonicdchangesbydrgController);
	
	  this.selectedDRG = $stateParams.drg;
	  this.selectedSpecialty = $stateParams.specialty;
	  this.startDate = $stateParams.startDate;
	  this.endDate = $stateParams.endDate;
	  this.episodeValue = '';
	  this.specialtyString = '';
	  this.separationString = '';
	  this.locale = 'en-au';
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty($scope.vm.specialtyOptions);
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment($scope.vm.startDate, "DD/MM/YYYY").locale($scope.vm.locale),
	      dateFormatted: $scope.vm.startDate
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment($scope.vm.endDate, "DD/MM/YYYY").locale($scope.vm.locale),
	      dateFormatted: $scope.vm.endDate
	    }
	  };
	
	  if ($scope.vm.startDate === '0') setDefaultDate();
	
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = 'Common Coding Changes by DRG';
	  this.locale = 'en-au';
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodedg1detail/querychangesbydrg?';
	  this.initUrl = this.url + 'startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '&DRG=' + $scope.vm.selectedDRG + '';
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === 'string') {
	          campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $('#auditTable').closest(".dataTables_scrollBody").height(300);
	  };
	
	  datePicker.autoClose($scope);
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	    url: $scope.vm.initUrl,
	    // url: '/app/JSON-backup/auditList.json',
	    type: 'GET',
	    error: function error(xhr, _error, thrown) {
	      if (thrown == 'Unauthorized') {
	        window.location.replace(window.location.origin + '/login');
	        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true)
	  // .withOption('serverSide', true)
	  .withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($('#auditTable').DataTable());
	  }).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[4, 'desc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: 'print',
	    text: ''
	  }, {
	    extend: 'csvHtml5',
	    text: '',
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: 'excelHtml5',
	    text: '',
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: '',
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "select" }, {
	      type: "text",
	      bRegex: true,
	      bSmart: true
	    }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn('campus').withTitle('Campus').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('diagCode').withTitle('ICD/ACHI Code & Description').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalDRGOccurrence').withTitle('Total Occurrence').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalDRGAudited').withTitle('Total Added').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalRemoved').withTitle('Total Removed').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalChange').withTitle('DRG Change').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalWIESChange').withTitle('Loading...').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('avgChangePerEpisode').withTitle('Average Change per Episode').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalQueryGeneratedCoder').withTitle('Query Generated by Coder').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalGeneratedAuditor').withTitle('Query Generated by Auditor').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalEpisodeChange').withTitle('Episode Change').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalIncompleteDocumentation').withTitle('Incomplete Documentation').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric')];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	  this.auditCriteria = {
	    selectedCriteria: []
	  };
	  this.auditCriteriaOptions = {};
	
	  // callbacks for lx-selects and lx-date-picker
	  this.campusCallback = campusCallback;
	  function campusCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	
	  this.specialtyCallback = specialtyCallback;
	  function specialtyCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	
	  function setDtHeaders(table) {
	    $(table.column(1).header()).html($scope.vm.specialtyString);
	    $(table.column(7).header()).html($scope.vm.episodeValue + ' Change');
	  }
	
	  function selectFilter(column, filter) {
	
	    if (filter) {
	
	      // convert array to datatables permissable regex string
	      filter = filter.join("|");
	
	      if (filter !== '') filter = '^' + filter + '$';
	
	      var auditTable = $scope.vm.datatableApi;
	
	      auditTable.columns(column).search(filter, true, false).draw();
	    }
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === 'add') {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === 'add') {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function setDefaultDate() {
	
	    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
	    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');
	
	    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
	    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');
	
	    $scope.vm.selectedDRG = '';
	  }
	
	  function filterDate() {
	    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
	        endDate = $scope.vm.endDatePicker.input.dateFormatted;
	    var campus = '';
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var url = $scope.vm.url + 'startDate=' + startDate + '&endDate=' + endDate + '&DRG=' + $scope.vm.selectedDRG + '&campus=' + checkParam(campus) + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty);
	    $scope.vm.datatableApi.ajax.url(url).load().draw();
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function search() {
	
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search('').draw();
	
	    filterSpecialty('minus');
	
	    filterDate();
	
	    // re-draw tabele on datepicker close
	    $scope.$on('lx-date-picker__close-start', function (e, id) {
	
	      filterDate();
	    });
	
	    var timeoutPromise,
	        delayInMs = 500;
	
	    $scope.$watch("vm.selectedDRG", function (searchString, oldvalue) {
	
	      $timeout.cancel(timeoutPromise); //does nothing, if timeout already done
	
	      timeoutPromise = $timeout(function () {
	        //Set timeout
	
	        if (searchString !== oldvalue) {
	
	          filterDate();
	        }
	      }, delayInMs);
	    });
	
	    // Trigger filtering
	    // $('.reports__filters').find('div').first().find('div:last-child').click();
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case 'specialty':
	        if (thisModifier === 'add') {
	          filterSpecialty('add');
	        } else {
	          filterSpecialty('minus');
	        }
	        break;
	      case 'campus':
	        if (thisModifier === 'add') {
	          filterCampus('add');
	        } else {
	          filterCampus('minus');
	        }
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = CommonicdchangesbydrgController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _commonicdchangesbydrg = __webpack_require__(192);
	
	var _commonicdchangesbydrg2 = _interopRequireDefault(_commonicdchangesbydrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonicdchangesbydrgModule = _angular2.default.module('commonicdchangesbydrg', [_angularUiRouter2.default]).component('commonicdchangesbydrg', _commonicdchangesbydrg2.default);
	
	exports.default = commonicdchangesbydrgModule;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _episodechangereport = __webpack_require__(315);
	
	var _episodechangereport2 = _interopRequireDefault(_episodechangereport);
	
	var _episodechangereport3 = __webpack_require__(196);
	
	var _episodechangereport4 = _interopRequireDefault(_episodechangereport3);
	
	__webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var episodechangereportComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _episodechangereport2.default,
	  controller: _episodechangereport4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = episodechangereportComponent;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EpisodechangereportController = function EpisodechangereportController($scope, DTOptionsBuilder, DTColumnBuilder, CONST, materialButtons, datePicker, $rootScope, FunctionService, $filter, CoderService, Constants, ModalService) {
	  _classCallCheck(this, EpisodechangereportController);
	
	  this.datatableApi;
	  this.name = 'Episode Change';
	  this.startDate = moment().subtract(1, 'months').format("DD/MM/YYYY");
	  this.endDate = moment().format("DD/MM/YYYY");
	  this.separationString = '';
	  this.locale = 'en-au';
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodechangereport';
	  this.startDatePicker = {
	    input: {
	      date: moment($scope.vm.startDate, "DD/MM/YYYY").locale($scope.vm.locale),
	      dateFormatted: $scope.vm.startDate
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment($scope.vm.endDate, "DD/MM/YYYY").locale($scope.vm.locale),
	      dateFormatted: $scope.vm.endDate
	    }
	  };
	  this.dischargeUnit = {
	    selectedDischargeUnit: []
	  };
	  this.dischargeUnitOptions = {};
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.dischargeUnitOptions = response.specialties;
	  });
	
	  this.coder = {
	    selectedCoder: []
	  };
	  this.coderOptions = [];
	  this.coderOptionsWithIds = {};
	  this.selectedCoderIds = [];
	
	  this.createdBy = {
	    selectedCreatedBy: [],
	    selectedCreatedByIds: []
	  };
	  this.createdByOptions = [];
	  this.createdByOptionsWithIds = [];
	
	  CoderService.data().then(function successCallback(response) {
	    angular.forEach(response, function (item, key) {
	      $scope.vm.coderOptions.push(item.name);
	      $scope.vm.coderOptionsWithIds[item.name] = item.id;
	      $scope.vm.createdByOptions.push(item.name);
	      $scope.vm.createdByOptionsWithIds[item.name] = item.id;
	    });
	  });
	
	  this.episodeChangeType = {
	    selectedEpisodeChangeType: []
	  };
	  this.episodeChangeTypeOptions = [];
	
	  ModalService.getIncDocTypes().then(function (response) {
	    angular.forEach(response.INCDOCTYPES, function (item, key) {
	      if (item.isActive && item.toggleModalTypeId === 1) {
	        $scope.vm.episodeChangeTypeOptions.push(item.toggleLabel);
	      }
	    });
	    $scope.vm.episodeChangeTypeOptions.sort();
	  });
	
	  this.episodeActiveOptions = {
	    activeOnly: 'Active Episodes Only',
	    allEpisodes: 'All Episodes'
	  };
	  this.episodeActive = this.episodeActiveOptions.activeOnly;
	  this.episodeActiveChoices = Object.values(this.episodeActiveOptions);
	
	  this.episodeOpenOptions = {
	    open: 'Open',
	    closed: 'Completed',
	    all: 'Open and Completed'
	  };
	  this.episodeOpen = this.episodeOpenOptions.open;
	  this.episodeOpenChoices = Object.values(this.episodeOpenOptions);
	
	  this.dateTypeDefaultId = 1;
	  this.dateTypeOptions = [{ id: 0, value: 'Date Created' }];
	  this.dateType = { id: this.dateTypeDefaultId = 1 };
	
	  $scope.vm.selectedDateTypeId = this.dateType.id;
	
	  this.search = '';
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    var option = { id: $scope.vm.dateTypeDefaultId, value: $scope.vm.separationString + ' Date' };
	    $scope.vm.dateTypeOptions.push(option);
	    $scope.vm.dateType = $scope.vm.dateTypeOptions[1];
	  });
	
	  datePicker.autoClose($scope);
	  materialButtons.render();
	  materialButtons.processing();
	  $scope.initCallback = function () {
	
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	    search();
	
	    // Set the table to a fixed height, so it never collapses up or down
	    $('#auditTable').closest(".dataTables_scrollBody").height(300);
	  };
	
	  $scope.drawCallback = function (nRow) {
	
	    // Tell DataTables we're using Aussie-formatted dates for ordering
	    $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	    url: $scope.vm.url + '?startDate=' + this.startDatePicker.input.dateFormatted + '&endDate=' + this.endDatePicker.input.dateFormatted + '&dateType=' + $scope.vm.dateType.id,
	    type: 'GET',
	    error: function error(xhr, _error, thrown) {
	      if (thrown == 'Unauthorized') {
	        //window.location.replace(window.location.origin + '/login');
	        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($('#auditTable').DataTable());
	  }).withOption('rowCallback', $scope.rowCallback).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[0, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    'extend': 'print',
	    'text': ''
	  }, {
	    'extend': 'csvHtml5',
	    'text': '',
	    'filename': $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    'extend': 'excelHtml5',
	    'text': '',
	    'filename': $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    'text': '',
	    'action': function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]);
	
	  this.dtColumns = [DTColumnBuilder.newColumn('urn').withOption('defaultContent', '').withTitle('URN').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('episodeNumber').withOption('defaultContent', '').withTitle('Episode').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withOption('defaultContent', '').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withOption('defaultContent', '').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeUnit').withOption('defaultContent', '').withTitle('Unit').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('originalCoder').withOption('defaultContent', '').withTitle('Original Coder').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('episodeChangeType').withOption('defaultContent', '').withTitle('Episode Change Type').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('comments').withOption('defaultContent', '').withTitle('Comments').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('createdBy').withOption('defaultContent', '').withTitle('Created By').withClass('mdl-data-table__cell--non-numeric')];
	
	  this.dischargeUnitCallback = dischargeUnitCallback;
	
	  function dischargeUnitCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  this.filterDischargeUnit = filterDischargeUnit;
	
	  function filterDischargeUnit(swap) {
	    $scope.vm.dischargeUnit.selectedDischargeUnit = [];
	    if (swap === 'add') {
	      angular.forEach($scope.vm.dischargeUnitOptions, function (value, key) {
	        $scope.vm.dischargeUnit.selectedDischargeUnit.push($scope.vm.dischargeUnitOptions[$scope.vm.dischargeUnitOptions.indexOf(value)]);
	      });
	    }
	  }
	
	  this.coderCallback = coderCallback;
	
	  function coderCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  this.filterCoder = filterCoder;
	
	  function filterCoder(swap) {
	    $scope.vm.coder.selectedCoder = [];
	    if (swap === 'add') {
	      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions;
	    }
	  }
	
	  this.episodeChangeTypeCallback = episodeChangeTypeCallback;
	
	  function episodeChangeTypeCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  this.filterEpisodeChangeType = filterEpisodeChangeType;
	
	  function filterEpisodeChangeType(swap) {
	    $scope.vm.episodeChangeType.selectedEpisodeChangeType = [];
	    if (swap === 'add') {
	      angular.forEach($scope.vm.episodeChangeTypeOptions, function (value, key) {
	        $scope.vm.episodeChangeType.selectedEpisodeChangeType.push($scope.vm.episodeChangeTypeOptions[$scope.vm.episodeChangeTypeOptions.indexOf(value)]);
	      });
	    }
	  }
	
	  this.filterCreatedBy = filterCreatedBy;
	
	  function filterCreatedBy(swap) {
	    $scope.vm.createdBy.selectedCreatedBy = [];
	    $scope.vm.createdBy.selectedCreatedByIds = [];
	    if (swap === 'add') {
	      angular.forEach($scope.vm.createdByOptions, function (value, key) {
	        $scope.vm.createdBy.selectedCreatedBy.push($scope.vm.createdByOptions[$scope.vm.createdByOptions.indexOf(value)]);
	      });
	    }
	  }
	
	  function checkParam(param) {
	
	    if (param && param.length && param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  this.changeData = changeData;
	
	  function changeData() {
	
	    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
	        endDate = $scope.vm.endDatePicker.input.dateFormatted,
	        selectedDateType = $scope.vm.selectedDateTypeId,
	        selectedDischargeUnit = $scope.vm.dischargeUnit.selectedDischargeUnit,
	        selectedCoder = $scope.vm.coder.selectedCoder,
	        selectedCoderIds = $scope.vm.selectedCoderIds,
	        selectedCreatedBy = $scope.vm.createdBy.selectedCreatedBy,
	        selectedCreatedByIds = $scope.vm.createdBy.selectedCreatedByIds,
	        selectedEpisodeChangeType = $scope.vm.episodeChangeType.selectedEpisodeChangeType,
	        selectedEpisodeActive = $scope.vm.episodeActive === $scope.vm.episodeActiveOptions.allEpisodes ? 0 : 1,
	        selectedEpisodeOpen = $scope.vm.episodeOpen,
	        searchString = $scope.vm.search,
	        newUrl = $scope.vm.url + '?startDate=' + startDate + '&endDate=' + endDate + '&dateType=' + selectedDateType + '&dischargeUnit=' + checkParam(selectedDischargeUnit) + '&coder=' + checkParam(selectedCoder) + '&coderIds=' + checkParam(selectedCoderIds) + '&createdBy=' + checkParam(selectedCreatedBy) + '&createdByIds=' + checkParam(selectedCreatedByIds) + '&episodeChangeType=' + checkParam(selectedEpisodeChangeType) + '&episodeActive=' + selectedEpisodeActive + '&episodeOpen=' + String(selectedEpisodeOpen) + '&search=' + String(searchString || '');
	
	    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	  }
	
	  function setDtHeaders(table) {
	    $(table.column(3).header()).html($scope.vm.separationString + ' Date');
	  }
	
	  function search() {
	
	    filterDischargeUnit('minus');
	    filterCoder('minus');
	    // filterCampus('minus');
	
	    $scope.$on('lx-date-picker__close-start', function (e, id) {
	
	      $scope.vm.changeData();
	    });
	  }
	
	  this.setDateType = setDateType;
	
	  function setDateType(newValue) {
	    $scope.vm.dateType = newValue;
	    $scope.vm.selectedDateTypeId = newValue.id;
	    $scope.vm.selectedDateTypeValue = newValue.value;
	    $scope.vm.changeData();
	  }
	  this.setCoder = setCoder;
	
	  function setCoder(newValue) {
	    $scope.vm.selectedCoder = newValue;
	
	    $scope.vm.selectedCoderIds = [];
	    angular.forEach($scope.vm.selectedCoder, function (model, index) {
	      $scope.vm.selectedCoderIds.push($scope.vm.coderOptionsWithIds[model]);
	    });
	
	    $scope.vm.changeData();
	  }
	
	  this.setCreatedBy = setCreatedBy;
	
	  function setCreatedBy(newValue) {
	    $scope.vm.selectedCreatedBy = newValue;
	
	    $scope.vm.createdBy.selectedCreatedByIds = [];
	    angular.forEach($scope.vm.selectedCreatedBy, function (model) {
	      $scope.vm.createdBy.selectedCreatedByIds.push($scope.vm.createdByOptionsWithIds[model]);
	    });
	
	    $scope.vm.changeData();
	  }
	
	  // Bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	};
	
	exports.default = EpisodechangereportController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _episodechangereport = __webpack_require__(195);
	
	var _episodechangereport2 = _interopRequireDefault(_episodechangereport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var episodechangereportModule = _angular2.default.module('episodechangereport', [_angularUiRouter2.default]).component('episodechangereport', _episodechangereport2.default);
	
	exports.default = episodechangereportModule;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _episodelist = __webpack_require__(316);
	
	var _episodelist2 = _interopRequireDefault(_episodelist);
	
	var _episodelist3 = __webpack_require__(199);
	
	var _episodelist4 = _interopRequireDefault(_episodelist3);
	
	__webpack_require__(371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var episodelistComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _episodelist2.default,
	  controller: _episodelist4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = episodelistComponent;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EpisodelistController = function EpisodelistController($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, USER, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
	    _classCallCheck(this, EpisodelistController);
	
	    this.datatableApi;
	    this.user = USER;
	    this.name = 'Episode List';
	    this.episodeValue = '';
	    this.specialtyString = '';
	    this.separationString = '';
	    this.TEC = "TODO";
	    this.TEA = "TODO";
	
	    this.locale = 'en-au';
	
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodeaudit?removeCoding=1&';
	    this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L');
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    });
	
	    materialButtons.render();
	
	    materialButtons.processing();
	
	    $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	
	        // Datatables has finished init
	        // Initialise searching
	        if ($scope.vm.datatableApi) return;
	
	        $scope.vm.datatableApi = this.api();
	
	        // Update column headers even when no data returned
	        setDtHeaders($scope.vm.datatableApi);
	
	        // setup search filters
	        search();
	
	        // set the table to a fixed height, so it never collapsed up and down
	        $('#auditTable').closest(".dataTables_scrollBody").height(300);
	    };
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	        url: $scope.vm.initUrl,
	        type: 'GET',
	        error: function error(xhr, _error, thrown) {
	            if (thrown == 'Unauthorized') {
	                //window.location.replace(window.location.origin + '/login');
	                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	            }
	        }
	    }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	        // Update column headers if data returned
	        setDtHeaders($('#auditTable').DataTable());
	    }).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[2, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	        extend: 'print',
	        text: ''
	    }, {
	        extend: 'csvHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	        extend: 'excelHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	        text: '',
	        action: function action(e, dt, node, config) {
	            dt.ajax.reload();
	        }
	    }]).withColumnFilter({
	        //sPlaceHolder: "head:after",
	        aoColumns: [{ type: 'number' }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "select" }, { type: "select" }, { type: "number" }, {
	            type: "text",
	            bRegex: true,
	            bSmart: true
	        }, { type: "number" }]
	    });
	
	    function yesNo(data) {
	        return data === true ? "Y" : "N";
	    }
	
	    this.dtColumns = [DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('auditCriteria').withTitle('Audit Criteria').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('status').withTitle('Audit Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('drg').withTitle('Original DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('finalDRG').withTitle('Final DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('wies').withTitle('Loading...').withOption('defaultContent', '0.0000').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        return parseFloat(data).toFixed(4);
	    }), DTColumnBuilder.newColumn('finalWIES').withTitle('Loading...').withOption('defaultContent', '0.0000').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        if (typeof data !== 'undefined') return parseFloat(data).toFixed(4);
	    }), DTColumnBuilder.newColumn('totalWIESChange').withTitle('Loading...').withOption('defaultContent', '0.0000').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        return parseFloat(data).toFixed(4);
	    }), DTColumnBuilder.newColumn('auditFinalisedDateTime').withTitle('Date Audit Finalised').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')];
	
	    // Search filters
	    this.specialty = {
	        selectedSpecialty: []
	    };
	    this.specialtyOptions = {};
	
	    Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	        $scope.vm.specialtyOptions = response.specialties;
	        filterSpecialty($scope.vm.specialtyOptions);
	        // Can load divisions if needed??
	    });
	
	    this.startDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
	        }
	    };
	    this.endDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'days'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	        }
	    };
	
	    // callbacks for lx-selects and lx-date-picker
	    this.specialtyCallback = specialtyCallback;
	    datePicker.autoClose($scope);
	
	    function setDtHeaders(table) {
	        $(table.column(2).header()).html($scope.vm.separationString + ' Date');
	        $(table.column(3).header()).html($scope.vm.specialtyString);
	        $(table.column(8).header()).html('Original ' + $scope.vm.episodeValue);
	        $(table.column(9).header()).html('Final ' + $scope.vm.episodeValue);
	        $(table.column(10).header()).html($scope.vm.episodeValue + ' Change');
	    }
	
	    function specialtyCallback(_newValue, _oldValue) {
	        $scope.vm.changeData();
	    }
	
	    function filterSpecialty(swap) {
	        $scope.vm.specialty.selectedSpecialty = [];
	        if (swap === 'add') {
	            $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	        }
	    }
	
	    function setDefaultDate() {
	
	        $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
	        $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');
	
	        $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
	        $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');
	    }
	
	    function checkParam(param) {
	
	        if (param.length !== 0) {
	
	            return encodeURIComponent(param.join());
	        } else {
	
	            return "";
	        }
	    }
	
	    this.changeData = changeData;
	
	    function changeData() {
	
	        var newUrl = $scope.vm.url + 'startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty);
	        // + '&auditCriteria=' + checkParam($scope.vm.auditCriteria.selectedCriteria);
	        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	
	    function search() {
	
	        // delete any global searches previously applied
	        if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	        var auditTable = $scope.vm.datatableApi;
	        var clearAuditTable = auditTable.search('').draw();
	
	        filterSpecialty('minus');
	
	        // re-draw tabele on datepicker close
	        $scope.$on('lx-date-picker__close-start', function (e, id) {
	
	            $scope.vm.changeData();
	        });
	    }
	
	    // bind the datatable instance to an object to monitor loading
	    this.dtInstanceCallback = dtInstanceCallback;
	
	    function dtInstanceCallback(dtInstance) {
	
	        $scope.dtInstance = dtInstance._renderer;
	    }
	
	    // bind filter swap
	    this.filterSwap = filterSwap;
	
	    function filterSwap(thisFilter, thisModifier) {
	
	        switch (thisFilter) {
	
	            case 'specialty':
	
	                if (thisModifier === 'add') {
	
	                    filterSpecialty('add');
	                } else {
	
	                    filterSpecialty('minus');
	                }
	
	                break;
	
	            default:
	                break;
	        }
	    }
	};
	
	exports.default = EpisodelistController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _episodelist = __webpack_require__(198);
	
	var _episodelist2 = _interopRequireDefault(_episodelist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var episodelistModule = _angular2.default.module('episodelist', [_angularUiRouter2.default]).component('episodelist', _episodelist2.default);
	
	exports.default = episodelistModule;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _executivesummary = __webpack_require__(317);
	
	var _executivesummary2 = _interopRequireDefault(_executivesummary);
	
	var _executivesummary3 = __webpack_require__(202);
	
	var _executivesummary4 = _interopRequireDefault(_executivesummary3);
	
	__webpack_require__(372);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var executivesummaryComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _executivesummary2.default,
	  controller: _executivesummary4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = executivesummaryComponent;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExecutivesummaryController = function ExecutivesummaryController($scope, Constants, $filter, $rootScope, FunctionService, User) {
	    _classCallCheck(this, ExecutivesummaryController);
	
	    var Highcharts = __webpack_require__(19);
	    __webpack_require__(18)(Highcharts);
	
	    Highcharts.setOptions({
	        lang: {
	            decimalPoint: '.',
	            thousandsSep: ','
	        }
	    });
	
	    Highcharts.getOptions().colors = Highcharts.map(Highcharts.getOptions().colors, function (color) {
	        return Highcharts.Color(color).setOpacity(1).get('rgba');
	    });
	    this.user = User.getUser();
	    this.episodeValue = '';
	    this.fixedValue = '';
	    this.specialtyString = '';
	    this.specialtyStringSentenceCase = '';
	    this.showCriteriaSummary = false;
	    this.title = '';
	    this.byMonthHeading = '';
	    this.bySpecialtyHeading = '';
	    this.criteriaSummaryHeading = 'Criteria Breakdown Summary';
	    this.auditTypeSummaryHeading = 'Audit Type Summary';
	    this.functionSettings = {};
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.functionSettings = response.functionSettings;
	        $scope.vm.episodeValue = response.functionSettings.EpisodeValue && response.functionSettings.EpisodeValue.valueString ? response.functionSettings.EpisodeValue.valueString : 'WIES';
	        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	        $scope.vm.specialtyStringSentenceCase = $scope.vm.specialtyString.charAt(0).toUpperCase() + $scope.vm.specialtyString.slice(1).toLowerCase();
	        var selectedYearType = response.functionSettings.CalendarOrFinancialYearReporting && response.functionSettings.CalendarOrFinancialYearReporting.valueString ? response.functionSettings.CalendarOrFinancialYearReporting.valueString : 'Financial';
	        $scope.vm.yearTypeSelected = selectedYearType + ' Year';
	        if (selectedYearType === 'Calendar') {
	            $scope.vm.yearOptions = $scope.vm.calYearOptions;
	            $scope.vm.yearSelected = $scope.vm.calYearOptions[0];
	        } else {
	            $scope.vm.yearOptions = $scope.vm.finYearOptions;
	            $scope.vm.yearSelected = $scope.vm.finYearOptions[0];
	        }
	        $scope.vm.fixedValue = $scope.vm.episodeValue === '$' ? 2 : 4;
	        if (response.functionSettings.CriteriaSummary && response.functionSettings.CriteriaSummary.isActive) {
	            $scope.vm.showCriteriaSummary = true;
	        }
	        $scope.vm.title = response.functionSettings.ExecutiveSummaryTitle.valueString;
	        $scope.vm.byMonthHeading = 'Overall Audit DRG and ' + $scope.vm.episodeValue + ' Achievement';
	        $scope.vm.bySpecialtyHeading = 'Unit DRG and ' + $scope.vm.episodeValue + ' Audit Results';
	        $scope.vm.excludedSpecialties = response.functionSettings.ExcludedSpecialties.valueString ? response.functionSettings.ExcludedSpecialties.valueString.replace(/\|/g, ', ') : '';
	        $scope.vm.excludedPatientClasses = response.functionSettings.ExcludedPatientClassifications.valueString ? response.functionSettings.ExcludedPatientClassifications.valueString.replace(/\|/g, ', ') : '';
	        //Initalise the tables after we get the episode value type
	        drawByMonthDt();
	        drawBySpecialtyDt();
	        if ($scope.vm.showCriteriaSummary) {
	            drawCriteriaSummaryDt();
	        };
	        drawAuditTypeSummaryDt();
	
	        Constants.campusData().then(function successCallback(response) {
	            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	                var campusOptions = [];
	                if (typeof $scope.vm.user.campus === 'string') {
	                    campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
	                } else {
	                    campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
	                }
	                $scope.vm.campusOptions = campusOptions;
	                $scope.vm.campusSelected = campusOptions.length > 0 ? campusOptions[0] : '';
	            } else {
	                $scope.vm.campusOptions = response;
	            }
	        });
	    });
	
	    this.byMonthDt;
	    this.bySpecialtyDt;
	    this.criteriaSummaryDt;
	    this.auditTypeSummaryDt;
	    this.byMonthDtInitComplete = byMonthDtInitComplete;
	    this.bySpecialtyDtInitComplete = bySpecialtyDtInitComplete;
	    this.criteriaSummaryDtInitComplete = criteriaSummaryDtInitComplete;
	    this.auditTypeSummaryDtInitComplete = auditTypeSummaryDtInitComplete;
	    this.bySpecialtyDtRowCallback = bySpecialtyDtRowCallback;
	    this.byMonthDtDrawCallback = byMonthDtDrawCallback;
	    this.bySpecialtyDtDrawCallback = bySpecialtyDtDrawCallback;
	
	    this.printByMonthDt = true;
	    this.printBySpecialtyDt = true;
	    this.printCriteriaSummaryDt = true;
	    this.printAuditTypeSummaryDt = true;
	    this.printWiesByMonthTable = true;
	    this.printWiesByMonthChart = true;
	    this.printWiesBySpecialtyTable = true;
	    this.printWiesBySpecialtyChart = true;
	
	    this.yearOptions = [];
	    this.finYearOptions = [];
	    this.calYearOptions = [];
	    this.yearSelected = undefined;
	
	    this.yearTypeOptions = ['Financial Year', 'Calendar Year'];
	    this.yearTypeSelected = undefined;
	
	    this.monthOptions = [];
	    this.monthSelected = undefined;
	
	    this.campusOptions = [];
	    this.campusSelected = undefined;
	
	    this.divisionOptions = [];
	    this.divisionSelected = undefined;
	
	    this.byMonthDtColsOptions = [];
	    this.byMonthDtColsSelected = [];
	
	    this.bySpecialtyDtColsOptions = [];
	    this.bySpecialtyDtColsSelected = [];
	
	    this.criteriaSummaryDtColsOptions = [];
	    this.criteriaSummaryDtColsSelected = [];
	
	    this.auditTypeSummaryDtColsOptions = [];
	    this.auditTypeSummaryDtColsSelected = [];
	
	    this.currentMonth = moment().format('MM');
	    this.currentYear = moment().format('YYYY');
	    this.currentDate = moment().format('DD/MM/YYYY');
	    this.startDate = moment($scope.vm.currentMonth + '/' + $scope.vm.currentYear, 'MM/YYYY').startOf('month').format('DD/MM/YYYY');
	    this.startDateDisplay = moment($scope.vm.startDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
	    this.endDate = moment($scope.vm.currentMonth + '/' + $scope.vm.currentYear, 'MM/YYYY').endOf('month').format('DD/MM/YYYY');
	    this.endDateDisplay = moment($scope.vm.endDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
	
	    this.setYearType = setYearType;
	    this.setYear = setYear;
	    this.setMonth = setMonth;
	    this.setDates = setDates;
	
	    Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	        $scope.vm.divisionOptions = response.divisions;
	    });
	
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.executivesummary/query';
	    this.byMonthDtUrl = $scope.vm.url + '?tableFlag=0' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected) + '&division=' + encodeParam($scope.vm.divisionSelected);
	    this.bySpecialtyDtUrl = $scope.vm.url + '?tableFlag=1' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected) + '&division=' + encodeParam($scope.vm.divisionSelected);
	    this.criteriaSummaryDtUrl = $scope.vm.url + '?tableFlag=2' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected) + '&division=' + encodeParam($scope.vm.divisionSelected);
	    this.auditTypeSummaryDtUrl = $scope.vm.url + '?tableFlag=3' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected) + '&division=' + encodeParam($scope.vm.divisionSelected);
	
	    this.changeData = changeData;
	    this.printPage = printPage;
	    this.togglePrint = togglePrint;
	    this.toggleColumns = toggleColumns;
	
	    // Hide the tables and charts until they have data
	    $('#table__wiesByMonth, #chart__wiesByMonth').hide();
	    $('#table__wiesBySpecialty, #chart__wiesBySpecialty').hide();
	
	    // Initialise select values
	    initFinYear();
	    initMonth();
	    initCalendarYearOptions();
	
	    // Draw the by month table
	    function drawByMonthDt() {
	        $scope.vm.byMonthDt = $('#byMonthDt').DataTable({
	            ajax: {
	                url: $scope.vm.byMonthDtUrl,
	                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                dataSrc: "", // Required so that DataTables expects an array instead of an object
	                type: "GET",
	                error: function error(xhr, _error, thrown) {
	                    if (thrown == 'Unauthorized') {
	                        //window.location.replace(window.location.origin + '/login');
	                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                    }
	                }
	            },
	            initComplete: $scope.vm.byMonthDtInitComplete,
	            drawCallback: $scope.vm.byMonthDtDrawCallback,
	            bFilter: false,
	            bInfo: false,
	            paging: false,
	            ordering: false,
	            columns: [{
	                data: "dischargeMonth",
	                className: "mdl-data-table__cell--non-numeric"
	            }, { data: "episodes" }, { data: "episodesRequiringAudit" }, { data: "episodesRequiringAuditPC" }, { data: "episodesAudited" }, { data: "episodesAuditedPC" }, { data: "episodesToBeAudited" }, { data: "episodesToBeAuditedPC" }, { data: "queriesGenerated" }, { data: "queriesAwaitingReview" }, { data: "codingChanges" }, { data: "drgChanges" }, { data: "drgChangesPC" }, { data: "wiesChange" }, { data: "wies" }, { data: "wiesTarget" }, { data: "wiesVariance" }],
	            columnDefs: [{
	                render: function render(data, type, row, meta) {
	                    return data.toFixed(2);
	                },
	                targets: [3, 5, 7, 12]
	            }, {
	                render: function render(data, type, row, meta) {
	                    return data ? data.toFixed($scope.vm.fixedValue) : '0.00';
	                },
	                targets: [13, 14]
	            }]
	        });
	    };
	
	    // Draw the by specialty table
	    function drawBySpecialtyDt() {
	        $scope.vm.bySpecialtyDt = $('#bySpecialtyDt').DataTable({
	            ajax: {
	                url: $scope.vm.bySpecialtyDtUrl,
	                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                dataSrc: "", // Required so that DataTables expects an array instead of an object
	                type: "GET",
	                error: function error(xhr, _error2, thrown) {
	                    if (thrown == 'Unauthorized') {
	                        //window.location.replace(window.location.origin + '/login');
	                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                    }
	                }
	            },
	            initComplete: $scope.vm.bySpecialtyDtInitComplete,
	            rowCallback: $scope.vm.bySpecialtyDtRowCallback,
	            drawCallback: $scope.vm.bySpecialtyDtDrawCallback,
	            bFilter: false,
	            bInfo: false,
	            paging: false,
	            ordering: false,
	            columns: [{ data: "division" }, {
	                data: "speciality",
	                className: "mdl-data-table__cell--non-numeric"
	            }, { data: "episodes" }, { data: "episodesRequiringAudit" }, { data: "episodesRequiringAuditPC" }, { data: "episodesAudited" }, { data: "episodesAuditedPC" }, { data: "episodesToBeAudited" }, { data: "episodesToBeAuditedPC" }, { data: "queriesGenerated" }, { data: "queriesAwaitingReview" }, { data: "codingChanges" }, { data: "drgChanges" }, { data: "drgChangesPC" }, { data: "wiesChange" }, { data: "wies" }, { data: "complexityIndex" }],
	            columnDefs: [{ visible: false, targets: 0 }, {
	                render: function render(data, type, row, meta) {
	                    return data.toFixed(2);
	                },
	                targets: [4, 6, 8, 13, 16]
	            }, {
	                render: function render(data, type, row, meta) {
	                    return data.toFixed($scope.vm.fixedValue);
	                },
	                targets: [14, 15]
	            }]
	        });
	    };
	
	    // Draw the criteria summary table
	    function drawCriteriaSummaryDt() {
	        $scope.vm.criteriaSummaryDt = $('#criteriaSummaryDt').DataTable({
	            ajax: {
	                url: $scope.vm.criteriaSummaryDtUrl,
	                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                dataSrc: "", // Required so that DataTables expects an array instead of an object
	                type: "GET",
	                error: function error(xhr, _error3, thrown) {
	                    if (thrown == 'Unauthorized') {
	                        //window.location.replace(window.location.origin + '/login');
	                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                    }
	                }
	            },
	            initComplete: $scope.vm.criteriaSummaryDtInitComplete,
	            rowCallback: $scope.vm.criteriaSummaryDtRowCallback,
	            bFilter: false,
	            bInfo: false,
	            paging: false,
	            ordering: false,
	            columns: [{
	                data: "groupName",
	                className: "mdl-data-table__cell--non-numeric"
	            }, { data: "doesNotMeetCriteria" }, { data: "doesNotMeetCriteriaPC" }, { data: "originalCoderQuery" }, { data: "originalCoderQueryPC" }, { data: "targetDRG" }, { data: "targetDRGPC" }, { data: "borCDRG" }, { data: "borCDRGPC" }, { data: "other" }, { data: "otherPC" }, { data: "total" }],
	            columnDefs: [{
	                render: function render(data, type, row, meta) {
	                    return data.toFixed(2);
	                },
	                targets: [2, 4, 6, 8, 10]
	            }]
	        });
	    };
	
	    // Draw the audit type summary table
	    function drawAuditTypeSummaryDt() {
	        $scope.vm.auditTypeSummaryDt = $('#auditTypeSummaryDt').DataTable({
	            ajax: {
	                url: $scope.vm.auditTypeSummaryDtUrl,
	                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                dataSrc: "", // Required so that DataTables expects an array instead of an object
	                type: "GET",
	                error: function error(xhr, _error4, thrown) {
	                    if (thrown == 'Unauthorized') {
	                        //window.location.replace(window.location.origin + '/login');
	                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                    }
	                }
	            },
	            initComplete: $scope.vm.auditTypeSummaryDtInitComplete,
	            rowCallback: $scope.vm.auditTypeSummaryDtRowCallback,
	            bFilter: false,
	            bInfo: false,
	            paging: false,
	            ordering: false,
	            columns: [{
	                data: "auditType",
	                className: "mdl-data-table__cell--non-numeric"
	            }, { data: "flagged" }, { data: "audited" }, { data: "percentAudited" }, { data: "changed" }, { data: "percentChanged" }, { data: "wiesDifference" }],
	            columnDefs: [{
	                render: function render(data, type, row, meta) {
	                    return data.toFixed(2);
	                },
	                targets: [3, 5]
	            }, {
	                render: function render(data, type, row, meta) {
	                    return parseFloat(data).toFixed($scope.vm.fixedValue);
	                },
	                targets: [6]
	            }]
	        });
	    };
	
	    // Show loading message on tables during new ajax call
	    $('#byMonthDt, #bySpecialtyDt, #criteriaSummaryDt, #auditTypeSummaryDt').on('preXhr.dt', function (e, settings, data) {
	        $(this).dataTable().api().clear();
	        settings.iDraw = 0; // 0 means "initial draw", which, after clearing table, will show "Loading..." again
	        $(this).dataTable().api().draw();
	    });
	
	    // Initialise financial year select values
	    function initFinYear() {
	        if (moment().month() < 6) {
	            var year = moment().format('YYYY');
	        } else {
	            var year = moment().add(1, 'year').format('YYYY');
	        }
	
	        for (var i = 0; i < 10; i++) {
	            $scope.vm.finYearOptions.push(year - 1 + ' - ' + year);
	            year--;
	        }
	    }
	
	    function initCalendarYearOptions() {
	        var year = moment().format('YYYY');
	        for (var i = 0; i < 10; i++) {
	            $scope.vm.calYearOptions.push(year);
	            year--;
	        }
	    }
	
	    // Initialise month select values
	    function initMonth() {
	        var months = [];
	
	        // Order the months in the dropdown from July to June,
	        // starting with Jul to Dec
	        for (var i = 6; i < 12; i++) {
	            months.push(moment.months(i));
	        }
	
	        // Then Jan to Jun
	        for (var i = 0; i < 6; i++) {
	            months.push(moment.months(i));
	        }
	
	        $scope.vm.monthOptions = months;
	        // Stick 'All months' at the top
	        $scope.vm.monthOptions.unshift('All months');
	        // Default to current month
	        $scope.vm.monthSelected = moment().format('MMMM');
	    }
	
	    function byMonthDtInitComplete(settings, json) {
	        // Get the list of columns for the show/hide select
	        $("#byMonthDt thead tr th").each(function () {
	            $scope.vm.byMonthDtColsOptions.push(this.innerHTML);
	            $scope.vm.byMonthDtColsSelected.push(this.innerHTML);
	        });
	    }
	
	    function bySpecialtyDtInitComplete(settings, json) {
	        // Get the list of columns for the show/hide select
	        $("#bySpecialtyDt thead tr th").each(function () {
	            $scope.vm.bySpecialtyDtColsOptions.push(this.innerHTML);
	            $scope.vm.bySpecialtyDtColsSelected.push(this.innerHTML);
	        });
	    }
	
	    function criteriaSummaryDtInitComplete(settings, json) {
	        // Get the list of columns for the show/hide select
	        $("#criteriaSummaryDt thead tr th").each(function () {
	            $scope.vm.criteriaSummaryDtColsOptions.push(this.innerHTML.replace(/<br>/g, ' '));
	            $scope.vm.criteriaSummaryDtColsSelected.push(this.innerHTML.replace(/<br>/g, ' '));
	        });
	    }
	
	    function auditTypeSummaryDtInitComplete(settings, json) {
	        // Get the list of columns for the show/hide select
	        $("#auditTypeSummaryDt thead tr th").each(function () {
	            $scope.vm.auditTypeSummaryDtColsOptions.push(this.innerHTML.replace(/<br>/g, ' '));
	            $scope.vm.auditTypeSummaryDtColsSelected.push(this.innerHTML.replace(/<br>/g, ' '));
	        });
	    }
	
	    function bySpecialtyDtRowCallback(row, data, index) {
	        // Shade cells to highlight number of outstanding queries
	        if (data.queriesAwaitingReview > 50) {
	            $(row).find('td:eq(9)').addClass('bgc-red-500 tc-white bt-white');
	        } else if (data.queriesAwaitingReview > 29) {
	            $(row).find('td:eq(9)').addClass('bgc-orange-500 tc-white bt-white');
	        } else {
	            $(row).find('td:eq(9)').addClass('bgc-green-500 tc-white bt-white');
	        }
	    }
	
	    function byMonthDtDrawCallback(settings) {
	
	        function sum(a, b) {
	            return a + b;
	        }
	
	        var api = this.api(),
	            rows = api.rows().nodes(),
	
	        // Calculate totals for footer
	        episodesTotal = api.column(1).data().reduce(sum, 0),
	            episodesRequiringAuditTotal = api.column(2).data().reduce(sum, 0),
	            episodesRequiringAuditPcTotal = episodesRequiringAuditTotal / episodesTotal * 100,
	            episodesAuditedTotal = api.column(4).data().reduce(sum, 0),
	            episodesAuditedPcTotal = episodesAuditedTotal / episodesRequiringAuditTotal * 100,
	            episodesToBeAuditedTotal = api.column(6).data().reduce(sum, 0),
	            episodesToBeAuditedPcTotal = episodesToBeAuditedTotal / episodesRequiringAuditTotal * 100,
	            queriesGeneratedTotal = api.column(8).data().reduce(sum, 0),
	            queriesAwaitingReviewTotal = api.column(9).data().reduce(sum, 0),
	            codingChangesTotal = api.column(10).data().reduce(sum, 0),
	            drgChangesTotal = api.column(11).data().reduce(sum, 0),
	            drgChangesPcTotal = drgChangesTotal / episodesAuditedTotal * 100,
	            wiesChangeTotal = api.column(13).data().reduce(sum, 0),
	            wiesTotal = api.column(14).data().reduce(sum, 0),
	            wiesTargetTotal = api.column(15).data().reduce(sum, 0),
	            wiesVarianceTotal = api.column(16).data().reduce(sum, 0);
	
	        $(rows).eq(api.column(0).data().length - 1).after('<tr class="group-footer">' + '<td class="mdl-data-table__cell--non-numeric">Total</td>' + '<td>' + episodesTotal + '</td>' + '<td>' + episodesRequiringAuditTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesRequiringAuditPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesRequiringAuditPcTotal).toFixed(2)) + '</td>' + '<td>' + episodesAuditedTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesAuditedPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesAuditedPcTotal).toFixed(2)) + '</td>' + '<td>' + episodesToBeAuditedTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesToBeAuditedPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesToBeAuditedPcTotal).toFixed(2)) + '</td>' + '<td>' + queriesGeneratedTotal + '</td>' + '<td>' + queriesAwaitingReviewTotal + '</td>' + '<td>' + codingChangesTotal + '</td>' + '<td>' + drgChangesTotal + '</td>' + '<td>' + (!isFinite(parseFloat(drgChangesPcTotal).toFixed(2)) ? '0.00' : parseFloat(drgChangesPcTotal).toFixed(2)) + '</td>' + '<td>' + parseFloat(wiesChangeTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + wiesTargetTotal + '</td>' + '<td>' + wiesVarianceTotal + '</td>' + '</tr>');
	
	        // If columns were hidden while the table was empty, we need to hide the footer cells here
	        toggleColumns('byMonthDt');
	    }
	
	    function bySpecialtyDtDrawCallback(settings) {
	
	        var api = this.api(),
	            rows = api.rows().nodes(),
	            cellData = null,
	            division = null,
	            lastDivision = null,
	
	        // Totals
	        episodesTotal = 0,
	            episodesRequiringAuditTotal = 0,
	            episodesAuditedTotal = 0,
	            episodesToBeAuditedTotal = 0,
	            queriesGeneratedTotal = 0,
	            queriesAwaitingReviewTotal = 0,
	            codingChangesTotal = 0,
	            drgChangesTotal = 0,
	            wiesChangeTotal = 0,
	            wiesTotal = 0,
	
	        // Grand totals
	        episodesGrandTotal = 0,
	            episodesRequiringAuditGrandTotal = 0,
	            episodesAuditedGrandTotal = 0,
	            episodesToBeAuditedGrandTotal = 0,
	            queriesGeneratedGrandTotal = 0,
	            queriesAwaitingReviewGrandTotal = 0,
	            codingChangesGrandTotal = 0,
	            drgChangesGrandTotal = 0,
	            wiesChangeGrandTotal = 0,
	            wiesGrandTotal = 0;
	
	        // Iterate through the division names in the first column (which is hidden)
	        api.column(0).data().each(function (division, i) {
	
	            cellData = api.row(api.row($(rows).eq(i)).index()).data();
	
	            // If the division name's missing, make it explicit
	            if (division === '' || division === null) {
	                division = 'No division assigned';
	            }
	
	            // First division group header
	            if (lastDivision === null) {
	                $(rows).eq(i).before('<tr class="group-header"><td colspan="15" class="mdl-data-table__cell--non-numeric">' + division + '</td></tr>');
	            }
	
	            // All group footers but the last one, and all group headers but the first one
	            if (lastDivision && lastDivision !== division) {
	                $(rows).eq(i).before('<tr class="group-footer">' + '<td class="mdl-data-table__cell--non-numeric">Total</td>' + '<td>' + episodesTotal + '</td>' + '<td>' + episodesRequiringAuditTotal + '</td>' + '<td>' + (episodesTotal ? parseFloat(episodesRequiringAuditTotal / episodesTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesAuditedTotal + '</td>' + '<td>' + (episodesRequiringAuditTotal ? parseFloat(episodesAuditedTotal / episodesRequiringAuditTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesToBeAuditedTotal + '</td>' + '<td>' + (episodesRequiringAuditTotal ? parseFloat(episodesToBeAuditedTotal / episodesRequiringAuditTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + queriesGeneratedTotal + '</td>' + '<td>' + queriesAwaitingReviewTotal + '</td>' + '<td>' + codingChangesTotal + '</td>' + '<td>' + drgChangesTotal + '</td>' + '<td>' + (episodesAuditedTotal ? parseFloat(drgChangesTotal / episodesAuditedTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + parseFloat(wiesChangeTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + (episodesTotal ? parseFloat(wiesTotal / episodesTotal) : 0).toFixed(2) + '</td>' + '</tr>' + '<tr class="group-header"><td colspan="15" class="mdl-data-table__cell--non-numeric">' + division + '</td></tr>');
	
	                // We've reached the start of a new group, so start the totals again
	                episodesTotal = cellData.episodes;
	                episodesRequiringAuditTotal = cellData.episodesRequiringAudit;
	                episodesAuditedTotal = cellData.episodesAudited;
	                episodesToBeAuditedTotal = cellData.episodesToBeAudited;
	                queriesGeneratedTotal = cellData.queriesGenerated;
	                queriesAwaitingReviewTotal = cellData.queriesAwaitingReview;
	                codingChangesTotal = cellData.codingChanges;
	                drgChangesTotal = cellData.drgChanges;
	                wiesChangeTotal = cellData.wiesChange;
	                wiesTotal = cellData.wies;
	            } else {
	                // We haven't reached the start of a new group, so keep adding to the totals
	                episodesTotal += cellData.episodes;
	                episodesRequiringAuditTotal += cellData.episodesRequiringAudit;
	                episodesAuditedTotal += cellData.episodesAudited;
	                episodesToBeAuditedTotal += cellData.episodesToBeAudited;
	                queriesGeneratedTotal += cellData.queriesGenerated;
	                queriesAwaitingReviewTotal += cellData.queriesAwaitingReview;
	                codingChangesTotal += cellData.codingChanges;
	                drgChangesTotal += cellData.drgChanges;
	                wiesChangeTotal += cellData.wiesChange;
	                wiesTotal += cellData.wies;
	            }
	
	            // Always add to the grand totals
	            episodesGrandTotal += cellData.episodes;
	            episodesRequiringAuditGrandTotal += cellData.episodesRequiringAudit;
	            episodesAuditedGrandTotal += cellData.episodesAudited;
	            episodesToBeAuditedGrandTotal += cellData.episodesToBeAudited;
	            queriesGeneratedGrandTotal += cellData.queriesGenerated;
	            queriesAwaitingReviewGrandTotal += cellData.queriesAwaitingReview;
	            codingChangesGrandTotal += cellData.codingChanges;
	            drgChangesGrandTotal += cellData.drgChanges;
	            wiesChangeGrandTotal += cellData.wiesChange;
	            wiesGrandTotal += cellData.wies;
	
	            // We've reached the final row, so add the last group footer and table footer
	            if (i === api.column(0).data().length - 1) {
	                $(rows).eq(i).after('<tr class="group-footer">' + '<td class="mdl-data-table__cell--non-numeric">Total</td>' + '<td>' + episodesTotal + '</td>' + '<td>' + episodesRequiringAuditTotal + '</td>' + '<td>' + (episodesTotal ? parseFloat(episodesRequiringAuditTotal / episodesTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesAuditedTotal + '</td>' + '<td>' + (episodesRequiringAuditTotal ? parseFloat(episodesAuditedTotal / episodesRequiringAuditTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesToBeAuditedTotal + '</td>' + '<td>' + (episodesRequiringAuditTotal ? parseFloat(episodesToBeAuditedTotal / episodesRequiringAuditTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + queriesGeneratedTotal + '</td>' + '<td>' + queriesAwaitingReviewTotal + '</td>' + '<td>' + codingChangesTotal + '</td>' + '<td>' + drgChangesTotal + '</td>' + '<td>' + (episodesAuditedTotal ? parseFloat(drgChangesTotal / episodesAuditedTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + parseFloat(wiesChangeTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + (episodesTotal ? parseFloat(wiesTotal / episodesTotal) : 0).toFixed(2) + '</td>' + '</tr>' + '<tr class="grand-footer">' + '<td class="mdl-data-table__cell--non-numeric">Grand total</td>' + '<td>' + episodesGrandTotal + '</td>' + '<td>' + episodesRequiringAuditGrandTotal + '</td>' + '<td>' + (episodesGrandTotal ? parseFloat(episodesRequiringAuditGrandTotal / episodesGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesAuditedGrandTotal + '</td>' + '<td>' + (episodesRequiringAuditGrandTotal ? parseFloat(episodesAuditedGrandTotal / episodesRequiringAuditGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesToBeAuditedGrandTotal + '</td>' + '<td>' + (episodesRequiringAuditGrandTotal ? parseFloat(episodesToBeAuditedGrandTotal / episodesRequiringAuditGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + queriesGeneratedGrandTotal + '</td>' + '<td>' + queriesAwaitingReviewGrandTotal + '</td>' + '<td>' + codingChangesGrandTotal + '</td>' + '<td>' + drgChangesGrandTotal + '</td>' + '<td>' + (episodesAuditedGrandTotal ? parseFloat(drgChangesGrandTotal / episodesAuditedGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + parseFloat(wiesChangeGrandTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesGrandTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + (episodesGrandTotal ? parseFloat(wiesGrandTotal / episodesGrandTotal) : 0).toFixed(2) + '</td>' + '</tr>');
	            }
	
	            lastDivision = division;
	        });
	
	        // If columns were hidden while the table was empty, we need to hide the footer cells here
	        toggleColumns('bySpecialtyDt');
	    }
	
	    // Redo the wiesByMonth table and chart whenever the corresponding datatable is redrawn
	    $('#byMonthDt').on('xhr.dt', function (e, settings, json, xhr) {
	
	        function sum(a, b) {
	            return a + b;
	        }
	
	        var tableWiesByMonth = $('.table-chart__wiesByMonth tbody'),
	            series = [],
	            months = [],
	            target = [],
	            variance = [],
	            originalWies = [],
	            actualWies = [],
	            totalRetrieved = [];
	
	        tableWiesByMonth.empty();
	
	        angular.forEach(json, function (value, key) {
	
	            var month = value.dischargeMonth;
	
	            months.push(month);
	
	            var varianceClass = value.wiesVariance < 0 ? "tc-red-500" : "tc-green-500";
	            var original = value.originalWies ? parseFloat(value.originalWies).toFixed($scope.vm.fixedValue) : parseFloat(0).toFixed($scope.vm.fixedValue);
	            var retrieved = value.wiesChange ? parseFloat(value.wiesChange).toFixed($scope.vm.fixedValue) : parseFloat(0).toFixed($scope.vm.fixedValue);
	
	            tableWiesByMonth.append('<tr><td class="mdl-data-table__cell--non-numeric">' + month + '</td><td class="mdl-data-table__cell">' + original + '</td><td class="mdl-data-table__cell">' + parseFloat(value.currentWies).toFixed($scope.vm.fixedValue) + '</td><td class="mdl-data-table__cell">' + retrieved + '</td><td class="mdl-data-table__cell">' + value.wiesTarget + '</td><td class="mdl-data-table__cell ' + varianceClass + '"">' + value.wiesVariance + '</td></tr>');
	
	            target.push(value.wiesTarget);
	            originalWies.push(value.originalWies);
	            actualWies.push(value.currentWies);
	            totalRetrieved.push(parseInt(retrieved));
	        });
	
	        // If the array's empty, appending to the table will throw an error
	        if ($scope.vm.episodeValue === '$' && totalRetrieved.length || $scope.vm.episodeValue !== '$' && actualWies.length) {
	
	            tableWiesByMonth.append('<tr class="oa-footer"><td colspan="2" class="mdl-data-table__cell--non-numeric">Total ' + $scope.vm.episodeValue + ' retrieved</td><td class="mdl-data-table__cell" class="mdl-data-table__cell">' + ($scope.vm.episodeValue === '$' ? '' : parseFloat(actualWies.reduce(sum, 0)).toFixed($scope.vm.fixedValue)) + '</td><td>' + ($scope.vm.episodeValue === '$' ? parseFloat(totalRetrieved.reduce(sum, 0)).toFixed($scope.vm.fixedValue) : '') + '</td><td></td><td></td></tr>');
	
	            // If the array's empty, we have no data, so don't display the tables or charts
	            $('#table__wiesByMonth, #chart__wiesByMonth').show();
	            $('#table__wiesBySpecialty, #chart__wiesBySpecialty').show();
	        }
	
	        Highcharts.chart('chart__wiesByMonth', {
	            chart: {
	                type: 'bar',
	                width: 1000,
	                options3d: {
	                    enabled: false
	                }
	            },
	            title: {
	                text: ''
	            },
	            legend: {
	                enabled: $scope.vm.episodeValue !== '$'
	            },
	            xAxis: {
	                categories: months
	            },
	            yAxis: {
	                title: {
	                    enabled: false
	                }
	            },
	            plotOptions: {
	                bar: {
	                    grouping: true
	                    // grouping: false,
	                    // depth: 1,
	                    // borderWidth: 5,
	                }
	            },
	            series: [{
	                name: 'Target ' + $scope.vm.episodeValue,
	                type: 'spline',
	                data: target,
	                color: 'rgba(233, 30, 99, 1)',
	                tooltip: {
	                    pointFormat: 'Target ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
	                },
	                zIndex: 1
	            }, {
	                name: 'Original ' + $scope.vm.episodeValue,
	                visible: $scope.vm.episodeValue !== '$',
	                data: originalWies,
	                // pointPadding: 0.2,
	                pointPadding: 0,
	                color: 'rgba(33, 150, 243, 1)',
	                tooltip: {
	                    pointFormat: 'Original ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
	                }
	            }, {
	                name: 'Actual ' + $scope.vm.episodeValue,
	                visible: $scope.vm.episodeValue !== '$',
	                data: actualWies,
	                // pointPadding: 0.1,
	                pointPadding: 0,
	                color: 'rgba(67, 67, 72, 1)',
	                tooltip: {
	                    pointFormat: 'Actual ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
	                }
	            }, {
	                name: 'Retrieved ' + $scope.vm.episodeValue,
	                visible: $scope.vm.episodeValue === '$',
	                data: totalRetrieved,
	                pointPadding: 0,
	                color: 'rgba(33, 150, 243, 1)',
	                tooltip: {
	                    pointFormat: 'Retrieved ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
	                }
	            }]
	        });
	    });
	
	    // Redo the wiesBySpecialty table and chart whenever the corresponding datatable is redrawn
	    $('#bySpecialtyDt').on('xhr.dt', function (e, settings, json, xhr) {
	        var tableWiesBySpecialty = $('.table-chart__wiesBySpecialty tbody'),
	            series = [],
	            otherSpecialties = 0,
	            otherWiesChange = 0;
	
	        tableWiesBySpecialty.empty();
	
	        // Sort data by WIES change
	        var jsonSorted = $filter('orderBy')(json, 'wiesChange', true);
	
	        angular.forEach(jsonSorted, function (value, key) {
	
	            // Explicitly show the top 10 specialties
	            if (key < 10) {
	                tableWiesBySpecialty.append('<tr><td class="mdl-data-table__cell--non-numeric">' + value.speciality + '</td><td class="mdl-data-table__cell">' + parseFloat(value.wiesChange).toFixed($scope.vm.fixedValue) + '</td></tr>');
	
	                series.push({ 'name': value.speciality, 'y': value.wiesChange });
	            } else {
	                otherWiesChange += value.wiesChange;
	                otherSpecialties++;
	            }
	        });
	
	        // Group the rest of the specialties together
	        tableWiesBySpecialty.append('<tr><td class="mdl-data-table__cell--non-numeric">Other (' + otherSpecialties + ')</td><td class="mdl-data-table__cell">' + parseFloat(otherWiesChange).toFixed($scope.vm.fixedValue) + '</td></tr>');
	
	        series.push({ 'name': 'Other (' + otherSpecialties + ')', 'y': otherWiesChange });
	
	        Highcharts.chart('chart__wiesBySpecialty', {
	            chart: {
	                type: 'pie',
	                width: 1000
	            },
	            title: {
	                text: ''
	            },
	            colors: ['#2196f3', '#434348', '#8bc34a', '#ff9800', '#7f84e9', '#9c27b0', '#e91e63', '#ffeb3b', '#009688', '#f44336', '#795548'],
	            tooltip: {
	                pointFormat: '<b>{point.percentage:.4f}%</b>'
	            },
	            plotOptions: {
	                pie: {
	                    allowPointSelect: true,
	                    cursor: 'pointer',
	                    depth: 25,
	                    dataLabels: {
	                        enabled: true
	                    },
	                    size: '100%'
	                }
	            },
	            series: [{
	                type: 'pie',
	                data: series
	            }]
	        });
	    });
	
	    function encodeParam(param) {
	        return encodeURIComponent(param === undefined ? '' : param);
	    }
	
	    // Update HTTP request URL and request new data
	    function changeData() {
	        var campus = '';
	        if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campusSelected.length === 0) {
	                campus = $scope.vm.user.campus;
	            } else {
	                campus = $scope.vm.campusSelected;
	            }
	        } else {
	            campus = $scope.vm.campusSelected;
	        }
	
	        var newUrl = $scope.vm.url + '?startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam(campus) + '&division=' + encodeParam($scope.vm.divisionSelected);
	
	        // Hide the current tables and charts until they have new data
	        $('#table__wiesByMonth, #chart__wiesByMonth').hide();
	        $('#table__wiesBySpecialty, #chart__wiesBySpecialty').hide();
	
	        $scope.vm.byMonthDt.ajax.url(newUrl + '&tableFlag=0').load();
	        $scope.vm.bySpecialtyDt.ajax.url(newUrl + '&tableFlag=1').load();
	        if ($scope.vm.showCriteriaSummary) {
	            $scope.vm.criteriaSummaryDt.ajax.url(newUrl + '&tableFlag=2').load();
	        }
	        $scope.vm.auditTypeSummaryDt.ajax.url(newUrl + '&tableFlag=3').load();
	    }
	
	    // Format year value from select list
	    function setYearType(newValue, oldValue) {
	        var year = '';
	        if (newValue === 'Financial Year') {
	            $scope.vm.yearOptions = $scope.vm.finYearOptions;
	            $scope.vm.yearSelected = $scope.vm.finYearOptions[0];
	            year = newValue.substring(7, 11);
	        } else {
	            $scope.vm.yearOptions = $scope.vm.calYearOptions;
	            $scope.vm.yearSelected = $scope.vm.calYearOptions[0];
	            year = newValue;
	        }
	
	        if (oldValue) {
	            setDates($scope.vm.monthSelected, year);
	        }
	    }
	
	    // Format year value from select list
	    function setYear(newValue, oldValue) {
	        var year = '';
	        if ($scope.vm.yearTypeSelected === 'Financial Year') {
	            var year = newValue.substring(7, 11);
	        } else {
	            year = newValue;
	        }
	
	        if (oldValue) {
	            setDates($scope.vm.monthSelected, year);
	        }
	    }
	
	    // Format month value from select list
	    function setMonth(newValue, oldValue) {
	        var year = '';
	        if ($scope.vm.yearTypeSelected === 'Financial Year') {
	            year = $scope.vm.yearSelected.toString().substring(7, 11);
	        } else {
	            year = $scope.vm.yearSelected.toString();
	        }
	
	        if (oldValue) {
	            setDates(newValue, year);
	        }
	    }
	
	    // Set the start and end dates for data queries
	    function setDates(month, year) {
	        if (month === 'All months') {
	            if ($scope.vm.yearTypeSelected === 'Financial Year') {
	                $scope.vm.startDate = moment('01/07/' + year, 'DD/MM/YYYY').subtract(1, 'year').format('DD/MM/YYYY');
	                $scope.vm.endDate = moment('30/06/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
	            } else {
	                $scope.vm.startDate = moment('01/01/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
	                $scope.vm.endDate = moment('31/12/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
	            }
	        } else {
	            // Create Moment object from month and year
	            var monthYearMoment = moment(month + '/' + year, 'MMMM/YYYY');
	
	            if (monthYearMoment.format('M') >= 7 && $scope.vm.yearTypeSelected === 'Financial Year') {
	                $scope.vm.startDate = moment(monthYearMoment).subtract(1, 'year').startOf('month').format('DD/MM/YYYY');
	                $scope.vm.endDate = moment(monthYearMoment).subtract(1, 'year').endOf('month').format('DD/MM/YYYY');
	            } else {
	                $scope.vm.startDate = moment(monthYearMoment).startOf('month').format('DD/MM/YYYY');
	                $scope.vm.endDate = moment(monthYearMoment).endOf('month').format('DD/MM/YYYY');
	            }
	        }
	
	        // Request new dataset
	        $scope.vm.changeData();
	        // Update displayed dates
	        $scope.vm.startDateDisplay = moment($scope.vm.startDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
	        $scope.vm.endDateDisplay = moment($scope.vm.endDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
	    }
	
	    // Print only the elements encapsulated by id="print", set dimensions as appropriate for A4 landscape
	    function printPage() {
	        var documentHead = document.head.outerHTML,
	            contentToPrint = document.getElementById('print').outerHTML,
	            windowSpecs = 'height=792, width=1124, menubar=no, statusbar=no, titlebar=no',
	            printWindow = window.open('', '_blank', windowSpecs),
	            printEvent = printWindow.matchMedia('print');
	
	        printWindow.document.open();
	        printWindow.document.write('<!doctype html><html>' + documentHead + '<body onLoad="window.print()">' + contentToPrint + '</body></html>');
	        printWindow.document.close();
	
	        // Close the print window once the print dialog box closes
	        printEvent.addListener(function (printEnd) {
	            if (!printEnd.matches) {
	                printWindow.close();
	            }
	        });
	    }
	
	    // Add or remove page elements to be printed
	    function togglePrint() {
	        if ($scope.vm.printByMonthDt) {
	            $('#byMonthDtContainer').removeClass('no-print');
	        } else {
	            $('#byMonthDtContainer').addClass('no-print');
	        }
	
	        if ($scope.vm.printBySpecialtyDt) {
	            $('#bySpecialtyDtContainer').removeClass('no-print');
	        } else {
	            $('#bySpecialtyDtContainer').addClass('no-print');
	        }
	
	        if ($scope.vm.printCriteriaSummaryDt) {
	            $('#criteriaSummaryDtContainer').removeClass('no-print');
	        } else {
	            $('#criteriaSummaryDtContainer').addClass('no-print');
	        }
	
	        if ($scope.vm.printAuditTypeSummaryDt) {
	            $('#auditTypeSummaryDtContainer').removeClass('no-print');
	        } else {
	            $('#auditTypeSummaryDtContainer').addClass('no-print');
	        }
	
	        if ($scope.vm.printWiesByMonthTable) {
	            $('#table__wiesByMonth').removeClass('no-print');
	        } else {
	            $('#table__wiesByMonth').addClass('no-print');
	        }
	
	        if ($scope.vm.printWiesByMonthChart) {
	            $('#chart__wiesByMonth').removeClass('no-print');
	        } else {
	            $('#chart__wiesByMonth').addClass('no-print');
	        }
	
	        // Only print section if one or more of its elements is to be printed
	        if (!$scope.vm.printWiesByMonthTable && !$scope.vm.printWiesByMonthChart) {
	            $('#wiesByMonth').addClass('no-print');
	        } else {
	            $('#wiesByMonth').removeClass('no-print');
	        }
	
	        if ($scope.vm.printWiesBySpecialtyTable) {
	            $('#table__wiesBySpecialty').removeClass('no-print');
	        } else {
	            $('#table__wiesBySpecialty').addClass('no-print');
	        }
	
	        if ($scope.vm.printWiesBySpecialtyChart) {
	            $('#chart__wiesBySpecialty').removeClass('no-print');
	        } else {
	            $('#chart__wiesBySpecialty').addClass('no-print');
	        }
	
	        // Only print section if one or more of its elements is to be printed
	        if (!$scope.vm.printWiesBySpecialtyTable && !$scope.vm.printWiesBySpecialtyChart) {
	            $('#wiesBySpecialty').addClass('no-print');
	        } else {
	            $('#wiesBySpecialty').removeClass('no-print');
	        }
	    }
	
	    // Show or hide columns according to select list
	    function toggleColumns(datatable) {
	
	        var table = $('#' + datatable).DataTable(),
	            colsToHide = [],
	            colsToShow = [];
	
	        if (datatable === 'byMonthDt') {
	            // Iterate through available columns
	            angular.forEach($scope.vm.byMonthDtColsOptions, function (value, key) {
	                // If column is not in list of selected columns
	                if ($filter('filter')($scope.vm.byMonthDtColsSelected, value, true).length === 0) {
	                    // Add to array of column indexes to hide
	                    colsToHide.push(key);
	                    // Hide the corresponding footer cell
	                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + ')').hide();
	                    // If column is in list of selected columns
	                } else {
	                    // Add to array of column indexes to show
	                    colsToShow.push(key);
	                    // Show the corresponding footer cell
	                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + ')').show();
	                }
	            });
	        }
	
	        if (datatable === 'bySpecialtyDt') {
	            angular.forEach($scope.vm.bySpecialtyDtColsOptions, function (value, key) {
	                if ($filter('filter')($scope.vm.bySpecialtyDtColsSelected, value, true).length === 0) {
	                    colsToHide.push(key + 1);
	                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + '), .grand-footer td:nth-child(' + (key + 1) + ')').hide();
	                } else {
	                    colsToShow.push(key + 1);
	                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + '), .grand-footer td:nth-child(' + (key + 1) + ')').show();
	                }
	            });
	        }
	
	        if (datatable === 'criteriaSummaryDt') {
	            angular.forEach($scope.vm.criteriaSummaryDtColsOptions, function (value, key) {
	                if ($filter('filter')($scope.vm.criteriaSummaryDtColsSelected, value, true).length === 0) {
	                    colsToHide.push(key);
	                } else {
	                    colsToShow.push(key);
	                }
	            });
	        }
	
	        if (datatable === 'auditTypeSummaryDt') {
	            angular.forEach($scope.vm.auditTypeSummaryDtColsOptions, function (value, key) {
	                if ($filter('filter')($scope.vm.auditTypeSummaryDtColsSelected, value, true).length === 0) {
	                    colsToHide.push(key);
	                } else {
	                    colsToShow.push(key);
	                }
	            });
	        }
	
	        // Hide/show columns
	        table.columns(colsToHide).visible(false, false);
	        table.columns(colsToShow).visible(true, true);
	        // Adjust group header colspan to match number of visible columns
	        $('#' + datatable + ' .group-header td').attr('colspan', $scope.vm.bySpecialtyDtColsOptions.length - colsToHide.length);
	        // Ensure correct padding on last cells when last column hidden
	        $('#' + datatable + ' tr').find('td:visible:last').css('padding-right', '24px', 'important');
	    }
	};
	
	exports.default = ExecutivesummaryController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _executivesummary = __webpack_require__(201);
	
	var _executivesummary2 = _interopRequireDefault(_executivesummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var executivesummaryModule = _angular2.default.module('executivesummary', [_angularUiRouter2.default]).component('executivesummary', _executivesummary2.default);
	
	exports.default = executivesummaryModule;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _executivesummaryPoc = __webpack_require__(318);
	
	var _executivesummaryPoc2 = _interopRequireDefault(_executivesummaryPoc);
	
	var _executivesummaryPoc3 = __webpack_require__(205);
	
	var _executivesummaryPoc4 = _interopRequireDefault(_executivesummaryPoc3);
	
	__webpack_require__(373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var executivesummaryPOCComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _executivesummaryPoc2.default,
	  controller: _executivesummaryPoc4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = executivesummaryPOCComponent;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExecutivesummaryPOCController = function ExecutivesummaryPOCController($scope, Constants, $filter, $rootScope, FunctionService, User) {
	    _classCallCheck(this, ExecutivesummaryPOCController);
	
	    var Highcharts = __webpack_require__(19);
	    __webpack_require__(18)(Highcharts);
	
	    Highcharts.setOptions({
	        lang: {
	            decimalPoint: '.',
	            thousandsSep: ','
	        }
	    });
	
	    Highcharts.getOptions().colors = Highcharts.map(Highcharts.getOptions().colors, function (color) {
	        return Highcharts.Color(color).setOpacity(1).get('rgba');
	    });
	
	    this.user = User.getUser();
	    this.episodeValue = '';
	    this.fixedValue = '';
	    this.specialtyString = '';
	    this.separationString = '';
	    this.showCriteriaSummary = false;
	    this.title = '';
	    this.byMonthHeading = '';
	    this.bySpecialtyHeading = '';
	    this.criteriaSummaryHeading = 'Criteria Breakdown Summary';
	    this.auditTypeSummaryHeading = 'Audit Type Summary';
	    this.sqlDateOptions = ['Audit Date'];
	    this.sqlDateSelected = 'Audit Date';
	    this.sqlDateParameter = 'PCCLModifiedDate';
	    this.sqlGroupByOptions = ['Campus'];
	    this.sqlGroupBySelected = 'Campus';
	    this.sqlGroupByParameter = 'Campus';
	    this.showQueriesCurrentDiffValue = true;
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.executivesummary/querypoc';
	    this.byMonthDtUrl = $scope.vm.url + '?tableFlag=0' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected ? $scope.vm.campusSelected : $scope.vm.campusOptions) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + encodeParam($scope.vm.sqlDateSelected) + '&sqlGroupByParameter=' + encodeParam($scope.vm.sqlGroupByParameter);
	    this.bySpecialtyDtUrl = $scope.vm.url + '?tableFlag=1' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected ? $scope.vm.campusSelected : $scope.vm.campusOptions) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + encodeParam($scope.vm.sqlDateSelected) + '&sqlGroupByParameter=' + encodeParam($scope.vm.sqlGroupByParameter);
	    this.criteriaSummaryDtUrl = $scope.vm.url + '?tableFlag=2' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected ? $scope.vm.campusSelected : $scope.vm.campusOptions) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + encodeParam($scope.vm.sqlDateSelected) + '&sqlGroupByParameter=' + encodeParam($scope.vm.sqlGroupByParameter);
	    this.auditTypeSummaryDtUrl = $scope.vm.url + '?tableFlag=3' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusSelected ? $scope.vm.campusSelected : $scope.vm.campusOptions) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + encodeParam($scope.vm.sqlDateSelected) + '&sqlGroupByParameter=' + encodeParam($scope.vm.sqlGroupByParameter);
	
	    this.functionSettings = {};
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.functionSettings = response.functionSettings;
	        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	        $scope.vm.showQueriesCurrentDiffValue = response.functionSettings.QueryItemCurrentDollarField && response.functionSettings.QueryItemCurrentDollarField.isActive ? true : false;
	        $scope.vm.sqlGroupByOptions.push($scope.vm.specialtyString);
	        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	        $scope.vm.sqlDateOptions.push($scope.vm.separationString + ' Date');
	        $scope.vm.episodeValue = response.functionSettings.EpisodeValue && response.functionSettings.EpisodeValue.valueString ? response.functionSettings.EpisodeValue.valueString : 'WIES';
	        var selectedYearType = response.functionSettings.CalendarOrFinancialYearReporting && response.functionSettings.CalendarOrFinancialYearReporting.valueString ? response.functionSettings.CalendarOrFinancialYearReporting.valueString : 'Financial';
	        $scope.vm.yearTypeSelected = selectedYearType + ' Year';
	        if (selectedYearType === 'Calendar') {
	            $scope.vm.yearOptions = $scope.vm.calYearOptions;
	            $scope.vm.yearSelected = $scope.vm.calYearOptions[0];
	        } else {
	            $scope.vm.yearOptions = $scope.vm.finYearOptions;
	            $scope.vm.yearSelected = $scope.vm.finYearOptions[0];
	        }
	        $scope.vm.fixedValue = $scope.vm.episodeValue === '$' ? 0 : 4;
	        if (response.functionSettings.CriteriaSummary && response.functionSettings.CriteriaSummary.isActive) {
	            $scope.vm.showCriteriaSummary = true;
	        }
	        $scope.vm.title = response.functionSettings.ExecutiveSummaryTitle.valueString;
	        $scope.vm.byMonthHeading = 'Overall Audit DRG and ' + $scope.vm.episodeValue + ' Achievement';
	        $scope.vm.bySpecialtyHeading = 'Unit DRG and ' + $scope.vm.episodeValue + ' Audit Results';
	        $scope.vm.excludedSpecialties = response.functionSettings.ExcludedSpecialties.valueString ? response.functionSettings.ExcludedSpecialties.valueString.replace(/\|/g, ', ') : '';
	
	        $scope.vm.sqlDateParameter = response.functionSettings.ExecutiveSummaryReportDefaultDate.valueString;
	        if ($scope.vm.sqlDateParameter === 'PCCLModifiedDate') {
	            $scope.vm.sqlDateSelected = 'Audit Date';
	        } else {
	            $scope.vm.sqlDateSelected = $scope.vm.separationString + ' Date';
	        }
	        if (response.functionSettings.ExecAuditingDRGVisibleFields && response.functionSettings.ExecAuditingDRGVisibleFields.valueString) {
	            var values = response.functionSettings.ExecAuditingDRGVisibleFields.valueString;
	            $scope.vm.bySpecialtyDtColsSelectedFromSettings = values;
	        }
	
	        Constants.campusData().then(function successCallback(response) {
	            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	                var campusOptions = [];
	                if (typeof $scope.vm.user.campus === 'string') {
	                    campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
	                } else {
	                    campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
	                }
	                $scope.vm.campusOptions = campusOptions;
	            } else {
	                $scope.vm.campusOptions = response;
	            }
	
	            //Initalise the tables after we get the episode value type
	            $scope.vm.byMonthDtUrl = $scope.vm.url + '?tableFlag=0' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusOptions) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + encodeParam($scope.vm.sqlDateSelected) + '&sqlGroupByParameter=' + encodeParam($scope.vm.sqlGroupByParameter);
	
	            $scope.vm.bySpecialtyDtUrl = $scope.vm.url + '?tableFlag=1' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusOptions) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + encodeParam($scope.vm.sqlDateSelected) + '&sqlGroupByParameter=' + encodeParam($scope.vm.sqlGroupByParameter);
	            $scope.vm.criteriaSummaryDtUrl = $scope.vm.url + '?tableFlag=2' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusOptions) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + encodeParam($scope.vm.sqlDateSelected) + '&sqlGroupByParameter=' + encodeParam($scope.vm.sqlGroupByParameter);
	            $scope.vm.auditTypeSummaryDtUrl = $scope.vm.url + '?tableFlag=3' + '&startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam($scope.vm.campusOptions) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + encodeParam($scope.vm.sqlDateSelected) + '&sqlGroupByParameter=' + encodeParam($scope.vm.sqlGroupByParameter);
	            drawByMonthDt();
	            drawBySpecialtyDt();
	            if ($scope.vm.showCriteriaSummary) {
	                drawCriteriaSummaryDt();
	            };
	            drawAuditTypeSummaryDt();
	        });
	    });
	
	    this.byMonthDt;
	    this.bySpecialtyDt;
	    this.criteriaSummaryDt;
	    this.auditTypeSummaryDt;
	    this.byMonthDtInitComplete = byMonthDtInitComplete;
	    this.bySpecialtyDtInitComplete = bySpecialtyDtInitComplete;
	    this.criteriaSummaryDtInitComplete = criteriaSummaryDtInitComplete;
	    this.auditTypeSummaryDtInitComplete = auditTypeSummaryDtInitComplete;
	    this.bySpecialtyDtRowCallback = bySpecialtyDtRowCallback;
	    this.byMonthDtDrawCallback = byMonthDtDrawCallback;
	    this.bySpecialtyDtDrawCallback = bySpecialtyDtDrawCallback;
	
	    this.printByMonthDt = true;
	    this.printBySpecialtyDt = true;
	    this.printCriteriaSummaryDt = true;
	    this.printAuditTypeSummaryDt = true;
	    this.printWiesByMonthTable = true;
	    this.printWiesByMonthChart = true;
	    this.printWiesBySpecialtyTable = true;
	    this.printWiesBySpecialtyChart = true;
	
	    this.yearOptions = [];
	    this.finYearOptions = [];
	    this.calYearOptions = [];
	    this.yearSelected = undefined;
	
	    this.yearTypeOptions = ['Financial Year', 'Calendar Year'];
	    this.yearTypeSelected = undefined;
	
	    this.monthOptions = [];
	    this.monthSelected = undefined;
	
	    this.campusOptions = [];
	    this.campusSelected = undefined;
	
	    this.divisionOptions = [];
	    this.divisionSelected = undefined;
	
	    this.byMonthDtColsOptions = [];
	    this.byMonthDtColsSelected = [];
	
	    this.bySpecialtyDtColsOptions = [];
	    this.bySpecialtyDtColsSelected = [];
	
	    this.criteriaSummaryDtColsOptions = [];
	    this.criteriaSummaryDtColsSelected = [];
	
	    this.auditTypeSummaryDtColsOptions = [];
	    this.auditTypeSummaryDtColsSelected = [];
	
	    this.currentMonth = moment().format('MM');
	    this.currentYear = moment().format('YYYY');
	    this.currentDate = moment().format('DD/MM/YYYY');
	    this.startDate = moment($scope.vm.currentMonth + '/' + $scope.vm.currentYear, 'MM/YYYY').startOf('month').format('DD/MM/YYYY');
	    this.startDateDisplay = moment($scope.vm.startDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
	    this.endDate = moment($scope.vm.currentMonth + '/' + $scope.vm.currentYear, 'MM/YYYY').endOf('month').format('DD/MM/YYYY');
	    this.endDateDisplay = moment($scope.vm.endDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
	
	    this.setYearType = setYearType;
	    this.setYear = setYear;
	    this.setMonth = setMonth;
	    this.setDates = setDates;
	    this.setSQLDate = setSQLDate;
	    this.setSQLGroupBy = setSQLGroupBy;
	
	    Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	        $scope.vm.divisionOptions = response.divisions;
	    });
	
	    this.changeData = changeData;
	    this.printPage = printPage;
	    this.togglePrint = togglePrint;
	    this.toggleColumns = toggleColumns;
	
	    // Hide the tables and charts until they have data
	    $('#table__wiesByMonth, #chart__wiesByMonth').hide();
	    $('#table__wiesBySpecialty, #chart__wiesBySpecialty').hide();
	
	    // Initialise select values
	    initFinYear();
	    initMonth();
	    initCalendarYearOptions();
	
	    // Draw the by month table
	    function drawByMonthDt() {
	        $scope.vm.byMonthDt = $('#byMonthDt').DataTable({
	            ajax: {
	                url: $scope.vm.byMonthDtUrl,
	                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                dataSrc: "", // Required so that DataTables expects an array instead of an object
	                type: "GET",
	                error: function error(xhr, _error, thrown) {
	                    if (thrown == 'Unauthorized') {
	                        //window.location.replace(window.location.origin + '/login');
	                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                    }
	                }
	            },
	            initComplete: $scope.vm.byMonthDtInitComplete,
	            drawCallback: $scope.vm.byMonthDtDrawCallback,
	            bFilter: false,
	            bInfo: false,
	            paging: false,
	            ordering: false,
	            columns: [{
	                data: "dischargeMonth",
	                className: "mdl-data-table__cell--non-numeric"
	            }, { data: "episodes" }, { data: "episodesRequiringAudit" }, { data: "episodesRequiringAuditPC" }, { data: "episodesAudited" }, { data: "episodesAuditedPC" }, { data: "episodesToBeAudited" }, { data: "episodesToBeAuditedPC" }, { data: "queriesGenerated" }, { data: "queriesAwaitingReview" }, $scope.vm.showQueriesCurrentDiffValue ? { data: "queriesCurrentDiffValue" } : { data: "queriesEpisodeDiffValue" }, { data: "codingChanges" }, { data: "drgChanges" }, { data: "drgChangesPC" }, { data: "wiesChange" }, { data: "wies" }, { data: "wiesTarget" }, { data: "wiesVariance" }],
	            columnDefs: [{
	                render: function render(data, type, row, meta) {
	                    return data.toFixed(2);
	                },
	                targets: [3, 5, 7, 13]
	            }, {
	                render: function render(data, type, row, meta) {
	                    return data.toFixed($scope.vm.fixedValue);
	                },
	                targets: [10, 14, 15]
	            }]
	        });
	    };
	
	    // Draw the by specialty table
	    function drawBySpecialtyDt() {
	        if ($scope.vm.sqlGroupBySelected.localeCompare('Campus') === 0) {
	            $scope.vm.bySpecialtyDt = $('#bySpecialtyDt').DataTable({
	                ajax: {
	                    url: $scope.vm.bySpecialtyDtUrl,
	                    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                    dataSrc: "", // Required so that DataTables expects an array instead of an object
	                    type: "GET",
	                    error: function error(xhr, _error2, thrown) {
	                        if (thrown == 'Unauthorized') {
	                            console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                        }
	                    }
	                },
	                initComplete: $scope.vm.bySpecialtyDtInitComplete,
	                rowCallback: $scope.vm.bySpecialtyDtRowCallback,
	                drawCallback: $scope.vm.bySpecialtyDtDrawCallback,
	                bFilter: false,
	                bInfo: false,
	                paging: false,
	                ordering: false,
	                columns: [{
	                    data: "campus",
	                    className: "mdl-data-table__cell--non-numeric"
	                }, { data: "episodes" }, { data: "episodesRequiringAudit" }, { data: "episodesRequiringAuditPC" }, { data: "episodesAudited" }, { data: "episodesAuditedPC" }, { data: "episodesToBeAudited" }, { data: "episodesToBeAuditedPC" }, { data: "queriesGenerated" }, { data: "queriesAwaitingReview" }, $scope.vm.showQueriesCurrentDiffValue ? { data: "queriesCurrentDiffValue" } : { data: "queriesEpisodeDiffValue" }, { data: "codingChanges" }, { data: "drgChanges" }, { data: "drgChangesPC" }, { data: "wiesChange" }, { data: "wies" }, { data: "complexityIndex" }],
	                columnDefs: [{
	                    render: function render(data, type, row, meta) {
	                        return data ? data.toFixed(2) : '0.00';
	                    },
	                    targets: [3, 5, 7, 13]
	                }, {
	                    render: function render(data, type, row, meta) {
	                        return data.toFixed($scope.vm.fixedValue);
	                    },
	                    targets: [10, 14, 15, 16]
	                }]
	            });
	        } else {
	            $scope.vm.bySpecialtyDt = $('#bySpecialtyDt').DataTable({
	                ajax: {
	                    url: $scope.vm.bySpecialtyDtUrl,
	                    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                    dataSrc: "", // Required so that DataTables expects an array instead of an object
	                    type: "GET",
	                    error: function error(xhr, _error3, thrown) {
	                        if (thrown == 'Unauthorized') {
	                            console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                        }
	                    }
	                },
	                initComplete: $scope.vm.bySpecialtyDtInitComplete,
	                rowCallback: $scope.vm.bySpecialtyDtRowCallback,
	                drawCallback: $scope.vm.bySpecialtyDtDrawCallback,
	                bFilter: false,
	                bInfo: false,
	                paging: false,
	                ordering: false,
	                columns: [{
	                    data: "speciality",
	                    className: "mdl-data-table__cell--non-numeric"
	                }, { data: "episodes" }, { data: "episodesRequiringAudit" }, { data: "episodesRequiringAuditPC" }, { data: "episodesAudited" }, { data: "episodesAuditedPC" }, { data: "episodesToBeAudited" }, { data: "episodesToBeAuditedPC" }, { data: "queriesGenerated" }, { data: "queriesAwaitingReview" }, $scope.vm.showQueriesCurrentDiffValue ? { data: "queriesCurrentDiffValue" } : { data: "queriesEpisodeDiffValue" }, { data: "codingChanges" }, { data: "drgChanges" }, { data: "drgChangesPC" }, { data: "wiesChange" }, { data: "wies" }, { data: "complexityIndex" }],
	                columnDefs: [{
	                    render: function render(data, type, row, meta) {
	                        return data.toFixed(3);
	                    },
	                    targets: [3, 5, 7, 13]
	                }, {
	                    render: function render(data, type, row, meta) {
	                        return data.toFixed($scope.vm.fixedValue);
	                    },
	                    targets: [10, 14, 15, 16]
	                }]
	            });
	        }
	    };
	
	    // Draw the criteria summary table
	    function drawCriteriaSummaryDt() {
	        $scope.vm.criteriaSummaryDt = $('#criteriaSummaryDt').DataTable({
	            ajax: {
	                url: $scope.vm.criteriaSummaryDtUrl,
	                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                dataSrc: "", // Required so that DataTables expects an array instead of an object
	                type: "GET",
	                error: function error(xhr, _error4, thrown) {
	                    if (thrown == 'Unauthorized') {
	                        //window.location.replace(window.location.origin + '/login');
	                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                    }
	                }
	            },
	            initComplete: $scope.vm.criteriaSummaryDtInitComplete,
	            rowCallback: $scope.vm.criteriaSummaryDtRowCallback,
	            bFilter: false,
	            bInfo: false,
	            paging: false,
	            ordering: false,
	            columns: [{
	                data: "groupName",
	                className: "mdl-data-table__cell--non-numeric"
	            }, { data: "doesNotMeetCriteria" }, { data: "doesNotMeetCriteriaPC" }, { data: "originalCoderQuery" }, { data: "originalCoderQueryPC" }, { data: "targetDRG" }, { data: "targetDRGPC" }, { data: "borCDRG" }, { data: "borCDRGPC" }, { data: "other" }, { data: "otherPC" }, { data: "total" }],
	            columnDefs: [{
	                render: function render(data, type, row, meta) {
	                    return data.toFixed(2);
	                },
	                targets: [2, 4, 6, 8, 10]
	            }]
	        });
	    };
	
	    // Draw the audit type summary table
	    function drawAuditTypeSummaryDt() {
	        $scope.vm.auditTypeSummaryDt = $('#auditTypeSummaryDt').DataTable({
	            ajax: {
	                url: $scope.vm.auditTypeSummaryDtUrl,
	                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	                dataSrc: "", // Required so that DataTables expects an array instead of an object
	                type: "GET",
	                error: function error(xhr, _error5, thrown) {
	                    if (thrown == 'Unauthorized') {
	                        //window.location.replace(window.location.origin + '/login');
	                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	                    }
	                }
	            },
	            initComplete: $scope.vm.auditTypeSummaryDtInitComplete,
	            rowCallback: $scope.vm.auditTypeSummaryDtRowCallback,
	            bFilter: false,
	            bInfo: false,
	            paging: false,
	            ordering: false,
	            columns: [{
	                data: "auditType",
	                className: "mdl-data-table__cell--non-numeric"
	            }, { data: "flagged" }, { data: "audited" }, { data: "percentAudited" }, { data: "changed" }, { data: "percentChanged" }, { data: "wiesDifference" }],
	            columnDefs: [{
	                render: function render(data, type, row, meta) {
	                    return data.toFixed(2);
	                },
	                targets: [3, 5]
	            }, {
	                render: function render(data, type, row, meta) {
	                    return parseFloat(data).toFixed($scope.vm.fixedValue);
	                },
	                targets: [6]
	            }]
	        });
	    };
	
	    // Show loading message on tables during new ajax call
	    $('#byMonthDt, #bySpecialtyDt, #criteriaSummaryDt, #auditTypeSummaryDt').on('preXhr.dt', function (e, settings, data) {
	        $(this).dataTable().api().clear();
	        settings.iDraw = 0; // 0 means "initial draw", which, after clearing table, will show "Loading..." again
	        $(this).dataTable().api().draw();
	    });
	
	    // Initialise financial year select values
	    function initFinYear() {
	        if (moment().month() < 6) {
	            var year = moment().format('YYYY');
	        } else {
	            var year = moment().add(1, 'year').format('YYYY');
	        }
	
	        for (var i = 0; i < 10; i++) {
	            $scope.vm.finYearOptions.push(year - 1 + ' - ' + year);
	            year--;
	        }
	    }
	
	    function initCalendarYearOptions() {
	        var year = moment().format('YYYY');
	        for (var i = 0; i < 10; i++) {
	            $scope.vm.calYearOptions.push(year);
	            year--;
	        }
	    }
	
	    // Initialise month select values
	    function initMonth() {
	        var months = [];
	
	        // Order the months in the dropdown from July to June,
	        // starting with Jul to Dec
	        for (var i = 6; i < 12; i++) {
	            months.push(moment.months(i));
	        }
	
	        // Then Jan to Jun
	        for (var i = 0; i < 6; i++) {
	            months.push(moment.months(i));
	        }
	
	        $scope.vm.monthOptions = months;
	        // Stick 'All months' at the top
	        $scope.vm.monthOptions.unshift('All months');
	        // Default to current month
	        $scope.vm.monthSelected = moment().format('MMMM');
	    }
	
	    function byMonthDtInitComplete(settings, json) {
	        // Get the list of columns for the show/hide select
	        $("#byMonthDt thead tr th").each(function () {
	            $scope.vm.byMonthDtColsOptions.push(this.innerHTML);
	            $scope.vm.byMonthDtColsSelected.push(this.innerHTML);
	        });
	    }
	
	    function bySpecialtyDtInitComplete(settings, json) {
	        // Get the list of columns for the show/hide select
	        var counter = 0;
	        $("#bySpecialtyDt thead tr th").each(function () {
	            $scope.vm.bySpecialtyDtColsOptions.push(this.innerHTML);
	            if ($scope.vm.bySpecialtyDtColsSelectedFromSettings.indexOf(counter) >= 0) {
	                $scope.vm.bySpecialtyDtColsSelected.push(this.innerHTML);
	            }
	            counter++;
	        });
	    }
	
	    function criteriaSummaryDtInitComplete(settings, json) {
	        // Get the list of columns for the show/hide select
	        $("#criteriaSummaryDt thead tr th").each(function () {
	            $scope.vm.criteriaSummaryDtColsOptions.push(this.innerHTML.replace(/<br>/g, ' '));
	            $scope.vm.criteriaSummaryDtColsSelected.push(this.innerHTML.replace(/<br>/g, ' '));
	        });
	    }
	
	    function auditTypeSummaryDtInitComplete(settings, json) {
	        // Get the list of columns for the show/hide select
	        $("#auditTypeSummaryDt thead tr th").each(function () {
	            $scope.vm.auditTypeSummaryDtColsOptions.push(this.innerHTML.replace(/<br>/g, ' '));
	            $scope.vm.auditTypeSummaryDtColsSelected.push(this.innerHTML.replace(/<br>/g, ' '));
	        });
	    }
	
	    function bySpecialtyDtRowCallback(row, data, index) {
	        if ($scope.vm.functionSettings.ExecutiveSummaryReportColour && $scope.vm.functionSettings.ExecutiveSummaryReportColour.isActive) {
	            // Shade cells to highlight number of outstanding queries
	            if (data.queriesAwaitingReview > 50) {
	                $(row).find('td:eq(9)').addClass('bgc-red-500 tc-white bt-white');
	            } else if (data.queriesAwaitingReview > 29) {
	                $(row).find('td:eq(9)').addClass('bgc-orange-500 tc-white bt-white');
	            } else {
	                $(row).find('td:eq(9)').addClass('bgc-green-500 tc-white bt-white');
	            }
	        }
	    }
	
	    function byMonthDtDrawCallback(settings) {
	
	        function sum(a, b) {
	            return a + b;
	        }
	        var api = this.api(),
	            rows = api.rows().nodes(),
	
	        // Calculate totals for footer
	        episodesTotal = api.column(1).data().reduce(sum, 0),
	            episodesRequiringAuditTotal = api.column(2).data().reduce(sum, 0),
	            episodesRequiringAuditPcTotal = episodesRequiringAuditTotal / episodesTotal * 100,
	            episodesAuditedTotal = api.column(4).data().reduce(sum, 0),
	            episodesAuditedPcTotal = episodesAuditedTotal / episodesRequiringAuditTotal * 100,
	            episodesToBeAuditedTotal = api.column(6).data().reduce(sum, 0),
	            episodesToBeAuditedPcTotal = episodesToBeAuditedTotal / episodesRequiringAuditTotal * 100,
	            queriesGeneratedTotal = api.column(8).data().reduce(sum, 0),
	            queriesAwaitingReviewTotal = api.column(9).data().reduce(sum, 0),
	            queriesEpisodeProjectedAmountTotal = api.column(10).data().reduce(sum, 0),
	            queriesCurrentProjectedAmountTotal = api.column(10).data().reduce(sum, 0),
	            codingChangesTotal = api.column(11).data().reduce(sum, 0),
	            drgChangesTotal = api.column(12).data().reduce(sum, 0),
	            drgChangesPcTotal = drgChangesTotal / episodesAuditedTotal * 100,
	            wiesChangeTotal = api.column(14).data().reduce(sum, 0),
	            wiesTotal = api.column(15).data().reduce(sum, 0),
	            wiesTargetTotal = api.column(16).data().reduce(sum, 0),
	            wiesVarianceTotal = api.column(17).data().reduce(sum, 0);
	
	        $(rows).eq(api.column(0).data().length - 1).after('<tr class="group-footer">' + '<td class="mdl-data-table__cell--non-numeric">Total</td>' + '<td>' + episodesTotal + '</td>' + '<td>' + episodesRequiringAuditTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesRequiringAuditPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesRequiringAuditPcTotal).toFixed(2)) + '</td>' + '<td>' + episodesAuditedTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesAuditedPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesAuditedPcTotal).toFixed(2)) + '</td>' + '<td>' + episodesToBeAuditedTotal + '</td>' + '<td>' + (isNaN(parseFloat(episodesToBeAuditedPcTotal).toFixed(2)) ? '0.00' : parseFloat(episodesToBeAuditedPcTotal).toFixed(2)) + '</td>' + '<td>' + queriesGeneratedTotal + '</td>' + '<td>' + queriesAwaitingReviewTotal + '</td>' + ($scope.vm.showQueriesCurrentDiffValue ? '<td>' + queriesCurrentProjectedAmountTotal.toFixed($scope.vm.fixedValue) + '</td>' : '<td>' + queriesEpisodeProjectedAmountTotal.toFixed($scope.vm.fixedValue) + '</td>') + '<td>' + codingChangesTotal + '</td>' + '<td>' + drgChangesTotal + '</td>' + '<td>' + (!isFinite(parseFloat(drgChangesPcTotal).toFixed(2)) ? '0.00' : parseFloat(drgChangesPcTotal).toFixed(2)) + '</td>' + '<td>' + parseFloat(wiesChangeTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + wiesTargetTotal + '</td>' + '<td>' + wiesVarianceTotal + '</td>' + '</tr>');
	
	        // If columns were hidden while the table was empty, we need to hide the footer cells here
	        toggleColumns('byMonthDt');
	    }
	
	    function bySpecialtyDtDrawCallback(settings) {
	
	        var api = this.api(),
	            rows = api.rows().nodes(),
	            cellData = null,
	
	        // Grand totals
	        episodesGrandTotal = 0,
	            episodesRequiringAuditGrandTotal = 0,
	            episodesAuditedGrandTotal = 0,
	            episodesToBeAuditedGrandTotal = 0,
	            queriesGeneratedGrandTotal = 0,
	            queriesAwaitingReviewGrandTotal = 0,
	            queriesEpisodeProjectedAmountGrandTotal = 0,
	            queriesCurrentProjectedAmountGrandTotal = 0,
	            codingChangesGrandTotal = 0,
	            drgChangesGrandTotal = 0,
	            wiesChangeGrandTotal = 0,
	            wiesGrandTotal = 0;
	
	        // Iterate through the division names in the first column (which is hidden)
	        api.column(0).data().each(function (campus, i) {
	
	            cellData = api.row(api.row($(rows).eq(i)).index()).data();
	
	            // If the division name's missing, make it explicit
	            if (campus === '' || campus === null) {
	                campus = 'No campus assigned';
	            }
	
	            // Always add to the grand totals
	            episodesGrandTotal += cellData.episodes;
	            episodesRequiringAuditGrandTotal += cellData.episodesRequiringAudit;
	            episodesAuditedGrandTotal += cellData.episodesAudited;
	            episodesToBeAuditedGrandTotal += cellData.episodesToBeAudited;
	            queriesGeneratedGrandTotal += cellData.queriesGenerated;
	            queriesAwaitingReviewGrandTotal += cellData.queriesAwaitingReview;
	            queriesEpisodeProjectedAmountGrandTotal += cellData.queriesEpisodeDiffValue;
	            queriesCurrentProjectedAmountGrandTotal += cellData.queriesCurrentDiffValue;
	            codingChangesGrandTotal += cellData.codingChanges;
	            drgChangesGrandTotal += cellData.drgChanges;
	            wiesChangeGrandTotal += cellData.wiesChange;
	            wiesGrandTotal += cellData.wies;
	
	            // We've reached the final row, so add the last group footer and table footer
	            if (i === api.column(0).data().length - 1) {
	                $(rows).eq(i).after('<tr class="grand-footer">' + '<td class="mdl-data-table__cell--non-numeric">Total</td>' + '<td>' + episodesGrandTotal + '</td>' + '<td>' + episodesRequiringAuditGrandTotal + '</td>' + '<td>' + (episodesGrandTotal ? parseFloat(episodesRequiringAuditGrandTotal / episodesGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesAuditedGrandTotal + '</td>' + '<td>' + (episodesRequiringAuditGrandTotal ? parseFloat(episodesAuditedGrandTotal / episodesRequiringAuditGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + episodesToBeAuditedGrandTotal + '</td>' + '<td>' + (episodesRequiringAuditGrandTotal ? parseFloat(episodesToBeAuditedGrandTotal / episodesRequiringAuditGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + queriesGeneratedGrandTotal + '</td>' + '<td>' + queriesAwaitingReviewGrandTotal + '</td>' + ($scope.vm.showQueriesCurrentDiffValue ? '<td>' + parseFloat(queriesCurrentProjectedAmountGrandTotal).toFixed($scope.vm.fixedValue) + '</td>' : '<td>' + parseFloat(queriesEpisodeProjectedAmountGrandTotal).toFixed($scope.vm.fixedValue) + '</td>') + '<td>' + codingChangesGrandTotal + '</td>' + '<td>' + drgChangesGrandTotal + '</td>' + '<td>' + (episodesAuditedGrandTotal ? parseFloat(drgChangesGrandTotal / episodesAuditedGrandTotal * 100) : 0).toFixed(2) + '</td>' + '<td>' + parseFloat(wiesChangeGrandTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + parseFloat(wiesGrandTotal).toFixed($scope.vm.fixedValue) + '</td>' + '<td>' + (episodesGrandTotal ? parseFloat(wiesGrandTotal / episodesGrandTotal) : 0).toFixed($scope.vm.fixedValue) + '</td>' + '</tr>');
	            }
	        });
	        // If columns were hidden while the table was empty, we need to hide the footer cells here
	        toggleColumns('bySpecialtyDt');
	    }
	
	    // Redo the wiesByMonth table and chart whenever the corresponding datatable is redrawn
	    $('#byMonthDt').on('xhr.dt', function (e, settings, json, xhr) {
	
	        function sum(a, b) {
	            return a + b;
	        }
	
	        var tableWiesByMonth = $('.table-chart__wiesByMonth tbody'),
	            series = [],
	            months = [],
	            target = [],
	            variance = [],
	            originalWies = [],
	            actualWies = [],
	            totalRetrieved = [];
	
	        tableWiesByMonth.empty();
	
	        angular.forEach(json, function (value, key) {
	
	            var month = value.dischargeMonth;
	
	            months.push(month);
	
	            var original = value.originalWies ? parseFloat(value.originalWies).toFixed($scope.vm.fixedValue) : parseFloat(0).toFixed($scope.vm.fixedValue);
	            var retrieved = value.wiesChange ? parseFloat(value.wiesChange).toFixed($scope.vm.fixedValue) : parseFloat(0).toFixed($scope.vm.fixedValue);
	            var variance = retrieved - value.wiesTarget;
	            var varianceClass = variance < 0 ? "tc-red-500" : "tc-green-500";
	
	            tableWiesByMonth.append('<tr><td colspan="2" class="mdl-data-table__cell--non-numeric">' + month +
	            // '</td><td class="mdl-data-table__cell">' + original +
	            // '</td><td class="mdl-data-table__cell">' + parseFloat(value.currentWies).toFixed($scope.vm.fixedValue) +
	            '</td><td class="mdl-data-table__cell">' + retrieved + '</td><td class="mdl-data-table__cell">' + parseFloat(value.wiesTarget).toFixed($scope.vm.fixedValue) + '</td><td class="mdl-data-table__cell ' + varianceClass + '"">' + parseFloat(variance).toFixed($scope.vm.fixedValue) + '</td></tr>');
	
	            target.push(value.wiesTarget);
	            originalWies.push(value.originalWies);
	            actualWies.push(value.currentWies);
	            totalRetrieved.push(parseInt(retrieved));
	        });
	
	        // If the array's empty, appending to the table will throw an error
	        if ($scope.vm.episodeValue === '$' && totalRetrieved.length || $scope.vm.episodeValue !== '$' && actualWies.length) {
	
	            tableWiesByMonth.append('<tr class="oa-footer"><td colspan="2" class="mdl-data-table__cell--non-numeric">Total ' + $scope.vm.episodeValue + ' retrieved</td><td>' + ($scope.vm.episodeValue === '$' ? parseFloat(totalRetrieved.reduce(sum, 0)).toFixed($scope.vm.fixedValue) : '') + '</td><td></td><td></td></tr>');
	
	            // If the array's empty, we have no data, so don't display the tables or charts
	            $('#table__wiesByMonth, #chart__wiesByMonth').show();
	            $('#table__wiesBySpecialty, #chart__wiesBySpecialty').show();
	        }
	
	        Highcharts.chart('chart__wiesByMonth', {
	            chart: {
	                type: 'bar',
	                width: 1000,
	                options3d: {
	                    enabled: false
	                }
	            },
	            title: {
	                text: ''
	            },
	            legend: {
	                enabled: $scope.vm.episodeValue !== '$'
	            },
	            xAxis: {
	                categories: months
	            },
	            yAxis: {
	                title: {
	                    enabled: false
	                }
	            },
	            plotOptions: {
	                bar: {
	                    grouping: true
	                    // grouping: false,
	                    // depth: 1,
	                    // borderWidth: 5,
	                }
	            },
	            series: [{
	                name: 'Target ' + $scope.vm.episodeValue,
	                type: 'spline',
	                data: target,
	                color: 'rgba(233, 30, 99, 1)',
	                tooltip: {
	                    pointFormat: 'Target ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
	                },
	                zIndex: 1
	            }, {
	                name: 'Original ' + $scope.vm.episodeValue,
	                visible: $scope.vm.episodeValue !== '$',
	                data: originalWies,
	                // pointPadding: 0.2,
	                pointPadding: 0,
	                color: 'rgba(33, 150, 243, 1)',
	                tooltip: {
	                    pointFormat: 'Original ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
	                }
	            }, {
	                name: 'Actual ' + $scope.vm.episodeValue,
	                visible: $scope.vm.episodeValue !== '$',
	                data: actualWies,
	                // pointPadding: 0.1,
	                pointPadding: 0,
	                color: 'rgba(67, 67, 72, 1)',
	                tooltip: {
	                    pointFormat: 'Actual ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
	                }
	            }, {
	                name: 'Retrieved ' + $scope.vm.episodeValue,
	                visible: $scope.vm.episodeValue === '$',
	                data: totalRetrieved,
	                pointPadding: 0,
	                color: 'rgba(33, 150, 243, 1)',
	                tooltip: {
	                    pointFormat: 'Retrieved ' + $scope.vm.episodeValue + ': {point.y:,.0f}'
	                }
	            }]
	        });
	    });
	
	    // Redo the wiesBySpecialty table and chart whenever the corresponding datatable is redrawn
	    $('#bySpecialtyDt').on('xhr.dt', function (e, settings, json, xhr) {
	        var tableWiesBySpecialty = $('.table-chart__wiesBySpecialty tbody'),
	            series = [],
	            otherSpecialties = 0,
	            otherWiesChange = 0;
	
	        tableWiesBySpecialty.empty();
	
	        // Sort data by WIES change
	        var jsonSorted = $filter('orderBy')(json, 'wiesChange', true);
	
	        angular.forEach(jsonSorted, function (value, key) {
	
	            // Explicitly show the top 10 specialties
	            if (key < 10) {
	                if ($scope.vm.sqlGroupBySelected.localeCompare('Campus') === 0) {
	                    tableWiesBySpecialty.append('<tr><td class="mdl-data-table__cell--non-numeric">' + value.campus + '</td><td class="mdl-data-table__cell">' + parseFloat(value.wiesChange).toFixed($scope.vm.fixedValue) + '</td></tr>');
	
	                    series.push({ 'name': value.campus, 'y': value.wiesChange });
	                } else {
	                    tableWiesBySpecialty.append('<tr><td class="mdl-data-table__cell--non-numeric">' + value.speciality + '</td><td class="mdl-data-table__cell">' + parseFloat(value.wiesChange).toFixed($scope.vm.fixedValue) + '</td></tr>');
	
	                    series.push({ 'name': value.speciality, 'y': value.wiesChange });
	                }
	            } else {
	                otherWiesChange += value.wiesChange;
	                otherSpecialties++;
	            }
	        });
	
	        // Group the rest of the specialties together
	        tableWiesBySpecialty.append('<tr><td class="mdl-data-table__cell--non-numeric">Other ' + $scope.vm.sqlGroupBySelected + ' (' + otherSpecialties + ')</td><td class="mdl-data-table__cell">' + parseFloat(otherWiesChange).toFixed($scope.vm.fixedValue) + '</td></tr>');
	
	        series.push({ 'name': 'Other ' + $scope.vm.sqlGroupBySelected + ' (' + otherSpecialties + ')', 'y': otherWiesChange });
	
	        Highcharts.chart('chart__wiesBySpecialty', {
	            chart: {
	                type: 'pie',
	                width: 1000
	            },
	            title: {
	                text: ''
	            },
	            colors: ['#2196f3', '#434348', '#8bc34a', '#ff9800', '#7f84e9', '#9c27b0', '#e91e63', '#ffeb3b', '#009688', '#f44336', '#795548'],
	            tooltip: {
	                pointFormat: '<b>{point.percentage:.2f}%</b>'
	            },
	            plotOptions: {
	                pie: {
	                    allowPointSelect: true,
	                    cursor: 'pointer',
	                    depth: 25,
	                    dataLabels: {
	                        enabled: true
	                    },
	                    size: '100%'
	                }
	            },
	            series: [{
	                type: 'pie',
	                data: series
	            }]
	        });
	    });
	
	    function encodeParam(param) {
	        return encodeURIComponent(param === undefined ? '' : param);
	    }
	
	    // Update HTTP request URL and request new data
	    function changeData() {
	        var campus = '';
	        if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campusSelected.length === 0) {
	                campus = $scope.vm.user.campus;
	            } else {
	                campus = $scope.vm.campusSelected;
	            }
	        } else {
	            campus = $scope.vm.campusSelected;
	        }
	
	        var newUrl = $scope.vm.url + '?startDate=' + $scope.vm.startDate + '&endDate=' + $scope.vm.endDate + '&campus=' + encodeParam(campus) + '&division=' + encodeParam($scope.vm.divisionSelected) + '&sqlDateParameter=' + $scope.vm.sqlDateParameter + '&sqlGroupByParameter=' + $scope.vm.sqlGroupByParameter;
	
	        // Hide the current tables and charts until they have new data
	        $('#table__wiesByMonth, #chart__wiesByMonth').hide();
	        $('#table__wiesBySpecialty, #chart__wiesBySpecialty').hide();
	
	        $scope.vm.byMonthDt.ajax.url(newUrl + '&tableFlag=0').load();
	        $scope.vm.bySpecialtyDt.ajax.url(newUrl + '&tableFlag=1').load();
	        if ($scope.vm.showCriteriaSummary) {
	            $scope.vm.criteriaSummaryDt.ajax.url(newUrl + '&tableFlag=2').load();
	        }
	        $scope.vm.auditTypeSummaryDt.ajax.url(newUrl + '&tableFlag=3').load();
	    }
	
	    // Format year value from select list
	    function setYearType(newValue, oldValue) {
	        var year = '';
	        if (newValue === 'Financial Year') {
	            $scope.vm.yearOptions = $scope.vm.finYearOptions;
	            $scope.vm.yearSelected = $scope.vm.finYearOptions[0];
	            year = newValue.substring(7, 11);
	        } else {
	            $scope.vm.yearOptions = $scope.vm.calYearOptions;
	            $scope.vm.yearSelected = $scope.vm.calYearOptions[0];
	            year = newValue;
	        }
	
	        if (oldValue) {
	            setDates($scope.vm.monthSelected, year);
	        }
	    }
	
	    // Format year value from select list
	    function setYear(newValue, oldValue) {
	        var year = '';
	        if ($scope.vm.yearTypeSelected === 'Financial Year') {
	            var year = newValue.substring(7, 11);
	        } else {
	            year = newValue;
	        }
	
	        if (oldValue) {
	            setDates($scope.vm.monthSelected, year);
	        }
	    }
	
	    // Format month value from select list
	    function setMonth(newValue, oldValue) {
	        var year = '';
	        if ($scope.vm.yearTypeSelected === 'Financial Year') {
	            year = $scope.vm.yearSelected.toString().substring(7, 11);
	        } else {
	            year = $scope.vm.yearSelected.toString();
	        }
	
	        if (oldValue) {
	            setDates(newValue, year);
	        }
	    }
	
	    function setSQLDate(newValue, oldValue) {
	        if ($scope.vm.sqlDateSelected === 'Audit Date') {
	            $scope.vm.sqlDateParameter = 'PCCLModifiedDate';
	        } else {
	            $scope.vm.sqlDateParameter = 'DischargeDate';
	        }
	        // Request new dataset
	        $scope.vm.changeData();
	    }
	
	    function setSQLGroupBy(newValue, oldValue) {
	        $scope.vm.bySpecialtyDt.rows().invalidate().draw(false);
	        if ($scope.vm.sqlGroupBySelected === 'Campus') {
	            $scope.vm.sqlGroupByParameter = 'Campus';
	        } else {
	            $scope.vm.sqlGroupByParameter = 'DischargeUnit';
	        }
	        $scope.vm.bySpecialtyDt.destroy();
	        drawBySpecialtyDt();
	        // Request new dataset
	        $scope.vm.changeData();
	    }
	
	    // Set the start and end dates for data queries
	    function setDates(month, year) {
	        if (month === 'All months') {
	            if ($scope.vm.yearTypeSelected === 'Financial Year') {
	                $scope.vm.startDate = moment('01/07/' + year, 'DD/MM/YYYY').subtract(1, 'year').format('DD/MM/YYYY');
	                $scope.vm.endDate = moment('30/06/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
	            } else {
	                $scope.vm.startDate = moment('01/01/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
	                $scope.vm.endDate = moment('31/12/' + year, 'DD/MM/YYYY').format('DD/MM/YYYY');
	            }
	        } else {
	            // Create Moment object from month and year
	            var monthYearMoment = moment(month + '/' + year, 'MMMM/YYYY');
	            if (monthYearMoment.format('M') >= 7 && $scope.vm.yearTypeSelected === 'Financial Year') {
	                $scope.vm.startDate = moment(monthYearMoment).subtract(1, 'year').startOf('month').format('DD/MM/YYYY');
	                $scope.vm.endDate = moment(monthYearMoment).subtract(1, 'year').endOf('month').format('DD/MM/YYYY');
	            } else {
	                $scope.vm.startDate = moment(monthYearMoment).startOf('month').format('DD/MM/YYYY');
	                $scope.vm.endDate = moment(monthYearMoment).endOf('month').format('DD/MM/YYYY');
	            }
	        }
	
	        // Request new dataset
	        $scope.vm.changeData();
	        // Update displayed dates
	        $scope.vm.startDateDisplay = moment($scope.vm.startDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
	        $scope.vm.endDateDisplay = moment($scope.vm.endDate, 'DD/MM/YYYY').format('DD MMMM YYYY');
	    }
	
	    // Print only the elements encapsulated by id="print", set dimensions as appropriate for A4 landscape
	    function printPage() {
	        var documentHead = document.head.outerHTML,
	            contentToPrint = document.getElementById('print').outerHTML,
	            windowSpecs = 'height=792, width=1124, menubar=no, statusbar=no, titlebar=no',
	            printWindow = window.open('', '_blank', windowSpecs),
	            printEvent = printWindow.matchMedia('print');
	
	        printWindow.document.open();
	        printWindow.document.write('<!doctype html><html>' + documentHead + '<body onLoad="window.print()">' + contentToPrint + '</body></html>');
	        printWindow.document.close();
	
	        // Close the print window once the print dialog box closes
	        printEvent.addListener(function (printEnd) {
	            if (!printEnd.matches) {
	                printWindow.close();
	            }
	        });
	    }
	
	    // Add or remove page elements to be printed
	    function togglePrint() {
	        if ($scope.vm.printByMonthDt) {
	            $('#byMonthDtContainer').removeClass('no-print');
	        } else {
	            $('#byMonthDtContainer').addClass('no-print');
	        }
	
	        if ($scope.vm.printBySpecialtyDt) {
	            $('#bySpecialtyDtContainer').removeClass('no-print');
	        } else {
	            $('#bySpecialtyDtContainer').addClass('no-print');
	        }
	
	        if ($scope.vm.printCriteriaSummaryDt) {
	            $('#criteriaSummaryDtContainer').removeClass('no-print');
	        } else {
	            $('#criteriaSummaryDtContainer').addClass('no-print');
	        }
	
	        if ($scope.vm.printAuditTypeSummaryDt) {
	            $('#auditTypeSummaryDtContainer').removeClass('no-print');
	        } else {
	            $('#auditTypeSummaryDtContainer').addClass('no-print');
	        }
	
	        if ($scope.vm.printWiesByMonthTable) {
	            $('#table__wiesByMonth').removeClass('no-print');
	        } else {
	            $('#table__wiesByMonth').addClass('no-print');
	        }
	
	        if ($scope.vm.printWiesByMonthChart) {
	            $('#chart__wiesByMonth').removeClass('no-print');
	        } else {
	            $('#chart__wiesByMonth').addClass('no-print');
	        }
	
	        // Only print section if one or more of its elements is to be printed
	        if (!$scope.vm.printWiesByMonthTable && !$scope.vm.printWiesByMonthChart) {
	            $('#wiesByMonth').addClass('no-print');
	        } else {
	            $('#wiesByMonth').removeClass('no-print');
	        }
	
	        if ($scope.vm.printWiesBySpecialtyTable) {
	            $('#table__wiesBySpecialty').removeClass('no-print');
	        } else {
	            $('#table__wiesBySpecialty').addClass('no-print');
	        }
	
	        if ($scope.vm.printWiesBySpecialtyChart) {
	            $('#chart__wiesBySpecialty').removeClass('no-print');
	        } else {
	            $('#chart__wiesBySpecialty').addClass('no-print');
	        }
	
	        // Only print section if one or more of its elements is to be printed
	        if (!$scope.vm.printWiesBySpecialtyTable && !$scope.vm.printWiesBySpecialtyChart) {
	            $('#wiesBySpecialty').addClass('no-print');
	        } else {
	            $('#wiesBySpecialty').removeClass('no-print');
	        }
	    }
	
	    // Show or hide columns according to select list
	    function toggleColumns(datatable) {
	        var table = $('#' + datatable).DataTable(),
	            colsToHide = [],
	            colsToShow = [];
	
	        if (datatable === 'byMonthDt') {
	            // Iterate through available columns
	            angular.forEach($scope.vm.byMonthDtColsOptions, function (value, key) {
	                // If column is not in list of selected columns
	                if ($filter('filter')($scope.vm.byMonthDtColsSelected, value, true).length === 0) {
	                    // Add to array of column indexes to hide
	                    colsToHide.push(key);
	                    // Hide the corresponding footer cell
	                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + ')').hide();
	                    // If column is in list of selected columns
	                } else {
	                    // Add to array of column indexes to show
	                    colsToShow.push(key);
	                    // Show the corresponding footer cell
	                    $('#' + datatable + ' .group-footer td:nth-child(' + (key + 1) + ')').show();
	                }
	            });
	        }
	
	        if (datatable === 'bySpecialtyDt') {
	            angular.forEach($scope.vm.bySpecialtyDtColsOptions, function (value, key) {
	                if ($filter('filter')($scope.vm.bySpecialtyDtColsSelected, value, true).length === 0) {
	                    colsToHide.push(key);
	                    $('#' + datatable + ' .grand-footer td:nth-child(' + (key + 1) + ')').hide();
	                } else {
	                    colsToShow.push(key);
	                    $('#' + datatable + ' .grand-footer td:nth-child(' + (key + 1) + ')').show();
	                }
	            });
	        }
	
	        if (datatable === 'criteriaSummaryDt') {
	            angular.forEach($scope.vm.criteriaSummaryDtColsOptions, function (value, key) {
	                if ($filter('filter')($scope.vm.criteriaSummaryDtColsSelected, value, true).length === 0) {
	                    colsToHide.push(key);
	                } else {
	                    colsToShow.push(key);
	                }
	            });
	        }
	
	        if (datatable === 'auditTypeSummaryDt') {
	            angular.forEach($scope.vm.auditTypeSummaryDtColsOptions, function (value, key) {
	                if ($filter('filter')($scope.vm.auditTypeSummaryDtColsSelected, value, true).length === 0) {
	                    colsToHide.push(key);
	                } else {
	                    colsToShow.push(key);
	                }
	            });
	        }
	
	        // Hide/show columns
	        table.columns(colsToHide).visible(false, false);
	        table.columns(colsToShow).visible(true, true);
	        // Adjust group header colspan to match number of visible columns
	        $('#' + datatable + ' .group-header td').attr('colspan', $scope.vm.bySpecialtyDtColsOptions.length - colsToHide.length);
	        // Ensure correct padding on last cells when last column hidden
	        $('#' + datatable + ' tr').find('td:visible:last').css('padding-right', '24px', 'important');
	    }
	};
	
	exports.default = ExecutivesummaryPOCController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _executivesummaryPoc = __webpack_require__(204);
	
	var _executivesummaryPoc2 = _interopRequireDefault(_executivesummaryPoc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var executivesummaryPOCModule = _angular2.default.module('executivesummaryPOC', [_angularUiRouter2.default]).component('executivesummarypoc', _executivesummaryPoc2.default);
	
	exports.default = executivesummaryPOCModule;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _incompletedocumentation = __webpack_require__(319);
	
	var _incompletedocumentation2 = _interopRequireDefault(_incompletedocumentation);
	
	var _incompletedocumentation3 = __webpack_require__(208);
	
	var _incompletedocumentation4 = _interopRequireDefault(_incompletedocumentation3);
	
	__webpack_require__(374);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var incompletedocumentationComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _incompletedocumentation2.default,
	  controller: _incompletedocumentation4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = incompletedocumentationComponent;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IncompletedocumentationController = function IncompletedocumentationController($scope, DTOptionsBuilder, DTColumnBuilder, Constants, CONST, User, FunctionService, materialButtons, datePicker, $rootScope, $sanitize, CoderService, ModalService) {
	  _classCallCheck(this, IncompletedocumentationController);
	
	  this.user = User.getUser();
	  this.datatableApi;
	  this.name = "Incomplete Documentation";
	  this.specialtyString = "";
	  this.separationString = "";
	
	  // Start of financial year
	  var yearOfStartDate = new Date().getMonth() < 6 ? new Date().getFullYear() - 1 : new Date().getFullYear();
	  var startDate = new Date(yearOfStartDate, 6, 1);
	
	  this.startDate = moment(startDate).format("DD/MM/YYYY");
	  this.endDate = moment().format("DD/MM/YYYY");
	  this.locale = "en-au";
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.incompletedocumentation";
	  this.startDatePicker = {
	    input: {
	      date: moment($scope.vm.startDate, "DD/MM/YYYY").locale($scope.vm.locale),
	      dateFormatted: $scope.vm.startDate
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment($scope.vm.endDate, "DD/MM/YYYY").locale($scope.vm.locale),
	      dateFormatted: $scope.vm.endDate
	    }
	  };
	  this.dischargeUnit = {
	    selectedDischargeUnit: []
	  };
	  this.dischargeUnitOptions = {};
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = {};
	  this.hasOutstandingDocuments = "";
	  this.outstandingDocsOptions = [{ value: true, label: "Open" }, { value: false, label: "Completed" }, { value: "", label: "Open & Completed" }];
	  this.hasOutstandingDocumentsId = "";
	
	  this.coder = {
	    selectedCoder: []
	  };
	  this.coderOptions = [];
	  this.coderOptionsWithIds = {};
	  this.selectedCoderIds = [];
	
	  this.createdBy = {
	    selectedCreatedBy: [],
	    selectedCreatedByIds: []
	  };
	  this.createdByOptions = [];
	  this.createdByOptionsWithIds = [];
	
	  this.docType = {
	    selectedDocType: []
	  };
	  this.docTypeOptions = [];
	
	  this.dateTypeDefaultId = 1;
	  this.dateTypeOptions = [{ id: 0, value: "Date Created" }];
	  this.dateType = { id: this.dateTypeDefaultId };
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    var option = {
	      id: $scope.vm.dateTypeDefaultId,
	      value: $scope.vm.separationString + " Date"
	    };
	    $scope.vm.dateTypeOptions.push(option);
	    $scope.vm.dateType = $scope.vm.dateTypeOptions[1];
	    $scope.vm.selectedDateTypeId = $scope.vm.dateTypeOptions[1].id;
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          if ($scope.vm.user.campus === undefined) {
	            campusOptions = [];
	          } else {
	            campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	          }
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	  });
	
	  CoderService.data().then(function successCallback(response) {
	    angular.forEach(response, function (item, key) {
	      $scope.vm.coderOptions.push(item.name);
	      $scope.vm.coderOptionsWithIds[item.name] = item.id;
	      $scope.vm.createdByOptions.push(item.name);
	      $scope.vm.createdByOptionsWithIds[item.name] = item.id;
	    });
	  });
	
	  ModalService.getIncDocTypes().then(function (response) {
	    angular.forEach(response.INCDOCTYPES, function (item, key) {
	      if (item.isActive && item.toggleModalTypeId === 2) {
	        $scope.vm.docTypeOptions.push(item.toggleLabel);
	      }
	    });
	    $scope.vm.docTypeOptions.push("Dummy Coded");
	    $scope.vm.docTypeOptions.sort();
	  });
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.dischargeUnitOptions = response.specialties;
	  });
	
	  datePicker.autoClose($scope);
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function () {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    search();
	
	    // Set the table to a fixed height, so it never collapses up or down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  $scope.drawCallback = function (nRow) {
	    // Tell DataTables we're using Aussie-formatted dates for ordering
	    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.url + "?startDate=" + this.startDatePicker.input.dateFormatted + "&endDate=" + this.endDatePicker.input.dateFormatted + "" + "&dateType=" + this.dateType.id,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[0, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]);
	
	  this.dtColumns = [DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("urn").withOption("defaultContent", "").withTitle("URN").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("episodeNumber").withOption("defaultContent", "").withTitle("Episode Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withOption("defaultContent", "").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withOption("defaultContent", "").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeUnit").withOption("defaultContent", "").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("clinician").withOption("defaultContent", "").withTitle("Clinician").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("originalCoder").withOption("defaultContent", "").withTitle("Original Coder").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("documentationType").withOption("defaultContent", "").withTitle("Documentation Type").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("createdBy").withOption("defaultContent", "").withTitle("Created By").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("commentsDate").withOption("defaultContent", "").withTitle("Created Date").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    var date = moment(data).format("DD/MM/YYYY HH:mm");
	    if (date === "Invalid date") {
	      date = "";
	    }
	    return date;
	  }), DTColumnBuilder.newColumn("comments").withOption("defaultContent", "").withTitle("Comments").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return $sanitize(full.comments);
	  }), DTColumnBuilder.newColumn("completedDttm").withOption("defaultContent", "").withTitle("Completed Date").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    var date = moment(data).format("DD/MM/YYYY HH:mm");
	    if (date === "Invalid date") {
	      date = "";
	    }
	    return date;
	  }), DTColumnBuilder.newColumn("hasOutstandingDocumentation").withOption("defaultContent", "").withTitle("Incomplete Documentation").withClass("mdl-data-table__cell--non-numeric")];
	
	  this.dischargeUnitCallback = dischargeUnitCallback;
	
	  function dischargeUnitCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function setDtHeaders(table) {
	    $(table.column(4).header()).html($scope.vm.separationString + " Date");
	    $(table.column(5).header()).html($scope.vm.specialtyString);
	  }
	
	  this.filterDischargeUnit = filterDischargeUnit;
	
	  function filterDischargeUnit(swap) {
	    $scope.vm.dischargeUnit.selectedDischargeUnit = [];
	    if (swap === "add") {
	      $scope.vm.dischargeUnit.selectedDischargeUnit = $scope.vm.dischargeUnitOptions;
	    }
	  }
	
	  this.filterCoder = filterCoder;
	
	  function filterCoder(swap) {
	    $scope.vm.coder.selectedCoder = [];
	    if (swap === "add") {
	      $scope.vm.coder.selectedCoder = coderOptions;
	    }
	  }
	
	  this.filterCreatedBy = filterCreatedBy;
	
	  function filterCreatedBy(swap) {
	    $scope.vm.createdBy.selectedCreatedBy = [];
	    $scope.vm.createdBy.selectedCreatedByIds = [];
	    if (swap === "add") {
	      angular.forEach($scope.vm.createdByOptions, function (value, key) {
	        $scope.vm.createdBy.selectedCreatedBy.push($scope.vm.createdByOptions[$scope.vm.createdByOptions.indexOf(value)]);
	      });
	    }
	  }
	
	  this.campusCallback = campusCallback;
	
	  function campusCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  this.coderCallback = coderCallback;
	
	  function coderCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  this.filterCampus = filterCampus;
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = []; // In case minus was clicked
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions; // If minus wasn't clicked, assign all the values
	    }
	  }
	
	  this.docTypeCallback = docTypeCallback;
	
	  function docTypeCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  this.filterDocType = filterDocType;
	
	  function filterDocType(swap) {
	    $scope.vm.docType.selectedDocType = [];
	    if (swap === "add") {
	      $scope.vm.docType.selectedDocType = $scope.vm.docTypeOptions;
	    }
	  }
	
	  this.filterIncompleteDocumentation = filterIncompleteDocumentation;
	
	  function filterIncompleteDocumentation(swap) {
	    $scope.vm.hasOutstandingDocuments = "";
	    if (swap === "add") {
	      $scope.vm.hasOutstandingDocuments = "Open & Completed";
	    }
	  }
	
	  this.outstandingDocsCallback = outstandingDocsCallback;
	
	  function outstandingDocsCallback(_newValue, _oldValue) {
	    $scope.vm.hasOutstandingDocuments = _newValue;
	    $scope.vm.hasOutstandingDocumentsId = _newValue.value;
	    $scope.vm.hasOutstandingDocumentsValue = _newValue.label;
	    $scope.vm.changeData();
	  }
	
	  function checkParam(param) {
	    if (param !== undefined && param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  this.changeData = changeData;
	
	  function changeData() {
	    var campus = "";
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
	        endDate = $scope.vm.endDatePicker.input.dateFormatted,
	        selectedDateType = $scope.vm.selectedDateTypeId,
	        selectedDischargeUnit = $scope.vm.dischargeUnit.selectedDischargeUnit,
	        selectedCoder = $scope.vm.coder.selectedCoder,
	        selectedCoderIds = $scope.vm.selectedCoderIds,
	        selectedCreatedBy = $scope.vm.createdBy.selectedCreatedBy,
	        selectedCreatedByIds = $scope.vm.createdBy.selectedCreatedByIds,
	        hasOutstandingDocuments = $scope.vm.hasOutstandingDocumentsId,
	        selectedDocType = $scope.vm.docType.selectedDocType,
	        newUrl = $scope.vm.url + "?startDate=" + startDate + "&endDate=" + endDate + "&dateType=" + selectedDateType + "&dischargeUnit=" + checkParam(selectedDischargeUnit) + "&coder=" + checkParam(selectedCoder) + "&coderIds=" + checkParam(selectedCoderIds) + "&createdBy=" + checkParam(selectedCreatedBy) + "&createdByIds=" + checkParam(selectedCreatedByIds) + "&campus=" + checkParam(campus) + "&hasOutstandingDocuments=" + hasOutstandingDocuments + "&docType=" + checkParam(selectedDocType);
	
	    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	  }
	
	  function search() {
	    filterDischargeUnit("minus");
	    filterCoder("minus");
	    filterCampus("minus");
	
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.vm.changeData();
	    });
	  }
	
	  this.setDateType = setDateType;
	
	  function setDateType(newValue) {
	    $scope.vm.dateType = newValue;
	    $scope.vm.selectedDateTypeId = newValue.id;
	    $scope.vm.selectedDateTypeValue = newValue.value;
	    $scope.vm.changeData();
	  }
	
	  this.setCoder = setCoder;
	
	  function setCoder(newValue) {
	    $scope.vm.selectedCoder = newValue;
	    if ($scope.vm.selectedCoder.length) {
	      $scope.vm.selectedCoderIds = [];
	      angular.forEach($scope.vm.selectedCoder, function (model, index) {
	        $scope.vm.selectedCoderIds.push($scope.vm.coderOptionsWithIds[model]);
	      });
	    } else {
	      $scope.vm.selectedCoderIds = [];
	    }
	    $scope.vm.changeData();
	  }
	
	  this.setCreatedBy = setCreatedBy;
	
	  function setCreatedBy(newValue) {
	    $scope.vm.selectedCreatedBy = newValue;
	
	    $scope.vm.createdBy.selectedCreatedByIds = [];
	    angular.forEach($scope.vm.selectedCreatedBy, function (model) {
	      $scope.vm.createdBy.selectedCreatedByIds.push($scope.vm.createdByOptionsWithIds[model]);
	    });
	
	    $scope.vm.changeData();
	  }
	
	  // Bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	};
	
	exports.default = IncompletedocumentationController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _incompletedocumentation = __webpack_require__(207);
	
	var _incompletedocumentation2 = _interopRequireDefault(_incompletedocumentation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var incompletedocumentationModule = _angular2.default.module('incompletedocumentation', [_angularUiRouter2.default]).component('incompletedocumentation', _incompletedocumentation2.default);
	
	exports.default = incompletedocumentationModule;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mechvent = __webpack_require__(320);
	
	var _mechvent2 = _interopRequireDefault(_mechvent);
	
	var _mechvent3 = __webpack_require__(211);
	
	var _mechvent4 = _interopRequireDefault(_mechvent3);
	
	__webpack_require__(375);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mechventComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _mechvent2.default,
	  controller: _mechvent4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = mechventComponent;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MechventController = function MechventController($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService, dateTimeHelper) {
	  _classCallCheck(this, MechventController);
	
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Mechanical Ventilation Hours";
	  this.episodeValue = "";
	  this.fixedValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.locale = "en-au";
	  $scope.dateTimeHelper = dateTimeHelper;
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.episodeaudit?removeCoding=1&removeVent=1&";
	  this.initUrl = this.url + "startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.fixedValue = $scope.vm.episodeValue === "$" ? 2 : 4;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
	      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
	        return x.mData === "drgVersion";
	      });
	      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
	      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	      filterCampus($scope.vm.campusOptions);
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	
	    if ($scope.vm.functionSettings.MechanicalVentReportCodingStatusColumn && $scope.vm.functionSettings.MechanicalVentReportCodingStatusColumn.isActive) {
	      $scope.vm.dtColumns.push(DTColumnBuilder.newColumn("codingStatus").withTitle("Coding Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"));
	    }
	
	    if ($scope.vm.functionSettings.MechanicalVentReportHealthFundColumn && $scope.vm.functionSettings.MechanicalVentReportHealthFundColumn.isActive) {
	      $scope.vm.dtColumns.push(DTColumnBuilder.newColumn("healthCareFund").withTitle("Health Fund").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"));
	    }
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // tell DataTables we're using Aussie-formatted dates for ordering
	    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") window.location.replace(window.location.origin + "/login");
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "number" }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "select" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("PCCLModifiedUser").withTitle("Coder Name").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("ICUHours").withTitle("ICU Hours").withOption("defaultContent", "0").withOption('type', 'any-number').withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return $scope.dateTimeHelper.convertICUHours(data);
	  }), DTColumnBuilder.newColumn("mechVenitilationHours").withTitle("MV Hours").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("NIVentilationHours").withTitle("NIV Hours").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG<br>Version").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drg").withTitle("Original DRG").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("currentDRG").withTitle("Final DRG").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("wies").withTitle("Loading...").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.fixedValue);
	  }), DTColumnBuilder.newColumn("finalWIES").withTitle("Loading...").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    if (typeof data !== "undefined") {
	      return parseFloat(data).toFixed($scope.vm.fixedValue);
	    } else {
	      return parseFloat("0").toFixed($scope.vm.fixedValue);
	    }
	  }), DTColumnBuilder.newColumn("totalWIESChange").withTitle("Loading...").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.fixedValue);
	  })];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty($scope.vm.specialtyOptions);
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, "days"),
	      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  datePicker.autoClose($scope);
	  this.specialtyCallback = specialtyCallback;
	
	  function setDtHeaders(table) {
	    var dischargeDateColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === "dischargeDate";
	    });
	    var indexOfDischargeDateColumn = $scope.vm.dtColumns.indexOf(dischargeDateColumn[0]);
	    $(table.column(indexOfDischargeDateColumn).header()).html($scope.vm.separationString + " Date");
	
	    var specialityColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === "speciality";
	    });
	    var indexOfSpecialityColumn = $scope.vm.dtColumns.indexOf(specialityColumn[0]);
	    $(table.column(indexOfSpecialityColumn).header()).html($scope.vm.specialtyString);
	
	    var wiesColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === "wies";
	    });
	    var indexOfWiesColumn = $scope.vm.dtColumns.indexOf(wiesColumn[0]);
	    $(table.column(indexOfWiesColumn).header()).html("Original " + $scope.vm.episodeValue);
	
	    var finalWIESColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === "finalWIES";
	    });
	    var indexOfFinalWIESColumn = $scope.vm.dtColumns.indexOf(finalWIESColumn[0]);
	    $(table.column(indexOfFinalWIESColumn).header()).html("Final " + $scope.vm.episodeValue);
	
	    var totalWIESChangeColumn = $scope.vm.dtColumns.filter(function (x) {
	      return x.mData === "totalWIESChange";
	    });
	    var indexOfTotalWIESChangeColumn = $scope.vm.dtColumns.indexOf(totalWIESChangeColumn[0]);
	    $(table.column(indexOfTotalWIESChangeColumn).header()).html($scope.vm.episodeValue + " Difference");
	  }
	
	  function specialtyCallback(_newValue, _oldValue) {
	    $scope.vm.changeData();
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  this.changeData = changeData;
	
	  function changeData() {
	    var campus = "";
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	
	    var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&campus=" + checkParam(campus);
	    if ($scope.vm.datatableApi) {
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search("").draw();
	
	    filterCampus("minus");
	    filterSpecialty("minus");
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.vm.changeData();
	    });
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	
	        break;
	
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	
	        break;
	
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = MechventController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mechvent = __webpack_require__(210);
	
	var _mechvent2 = _interopRequireDefault(_mechvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mechventModule = _angular2.default.module('mechvent', [_angularUiRouter2.default]).component('mechvent', _mechvent2.default);
	
	exports.default = mechventModule;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _picq = __webpack_require__(321);
	
	var _picq2 = _interopRequireDefault(_picq);
	
	var _picq3 = __webpack_require__(214);
	
	var _picq4 = _interopRequireDefault(_picq3);
	
	__webpack_require__(376);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var picqComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _picq2.default,
	  controller: _picq4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = picqComponent;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PicqController = function PicqController($scope, DTOptionsBuilder, DTColumnBuilder, CONST, materialButtons, datePicker, $rootScope, $location) {
	    _classCallCheck(this, PicqController);
	
	    this.datatableApi;
	    this.name = 'PICQ Report';
	    this.locale = 'en-au';
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.picq';
	    this.startDatePicker = {
	        input: {
	            date: moment().locale(this.locale),
	            dateFormatted: moment().locale(this.locale).format('L')
	        }
	    };
	    this.endDatePicker = {
	        input: {
	            date: moment().locale(this.locale),
	            dateFormatted: moment().locale(this.locale).format('L')
	        }
	    };
	
	    datePicker.autoClose($scope);
	    materialButtons.render();
	    materialButtons.processing();
	    $scope.initCallback = function () {
	        // Datatables has finished init
	        // Initialise searching
	        if ($scope.vm.datatableApi) return;
	
	        $scope.vm.datatableApi = this.api();
	        // filterDate();
	        search();
	        // Set the table to a fixed height, so it never collapses up or down
	        $('#auditTable').closest(".dataTables_scrollBody").height(300);
	    };
	
	    $scope.drawCallback = function (nRow) {
	        // Tell DataTables we're using Aussie-formatted dates for ordering
	        $.fn.dataTable.moment('DD/MM/YYYY');
	    };
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	        url: $scope.vm.url + '?startDate=' + this.startDatePicker.input.dateFormatted + '&endDate=' + this.endDatePicker.input.dateFormatted + '',
	        type: 'GET',
	        error: function error(xhr, _error, thrown) {
	            if (thrown == 'Unauthorized') {
	                //window.location.replace(window.location.origin + '/login');
	                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	            }
	        }
	    }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('deferRender', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', $scope.rowCallback).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[0, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	        extend: 'print',
	        text: ''
	    }, {
	        extend: 'csvHtml5',
	        text: '',
	        filename: $scope.vm.name + '-' + moment().format('YYYYMMDD-HHmm')
	    }, {
	        extend: 'excelHtml5',
	        text: '',
	        filename: $scope.vm.name + '-' + moment().format('YYYYMMDD-HHmm')
	    }, {
	        text: '',
	        action: function action(e, dt, node, config) {
	            dt.ajax.reload();
	        }
	    }]);
	
	    this.dtColumns = [DTColumnBuilder.newColumn('episodeNumber').withOption('defaultContent', '').withTitle('UEID').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('refHospCode').withOption('defaultContent', '').withTitle('HOSPITAL').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('urn').withOption('defaultContent', '').withTitle('MRN').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withOption('defaultContent', '').withTitle('DOA').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withOption('defaultContent', '').withTitle('DOS').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dob').withOption('defaultContent', '').withTitle('DOB').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('sex').withOption('defaultContent', '').withTitle('SEX').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d01').withOption('defaultContent', '').withTitle('D01').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF01').withOption('defaultContent', '').withTitle('COF01').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d02').withOption('defaultContent', '').withTitle('D02').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF02').withOption('defaultContent', '').withTitle('COF02').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d03').withOption('defaultContent', '').withTitle('D03').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF03').withOption('defaultContent', '').withTitle('COF03').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d04').withOption('defaultContent', '').withTitle('D04').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF04').withOption('defaultContent', '').withTitle('COF04').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d05').withOption('defaultContent', '').withTitle('D05').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF05').withOption('defaultContent', '').withTitle('COF05').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d06').withOption('defaultContent', '').withTitle('D06').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF06').withOption('defaultContent', '').withTitle('COF06').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d07').withOption('defaultContent', '').withTitle('D07').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF07').withOption('defaultContent', '').withTitle('COF07').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d08').withOption('defaultContent', '').withTitle('D08').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF08').withOption('defaultContent', '').withTitle('COF08').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d09').withOption('defaultContent', '').withTitle('D09').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF09').withOption('defaultContent', '').withTitle('COF09').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d10').withOption('defaultContent', '').withTitle('D10').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF10').withOption('defaultContent', '').withTitle('COF10').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d11').withOption('defaultContent', '').withTitle('D11').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF11').withOption('defaultContent', '').withTitle('COF11').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d12').withOption('defaultContent', '').withTitle('D12').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF12').withOption('defaultContent', '').withTitle('COF12').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d13').withOption('defaultContent', '').withTitle('D13').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF13').withOption('defaultContent', '').withTitle('COF13').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d14').withOption('defaultContent', '').withTitle('D14').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF14').withOption('defaultContent', '').withTitle('COF14').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d15').withOption('defaultContent', '').withTitle('D15').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF15').withOption('defaultContent', '').withTitle('COF15').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d16').withOption('defaultContent', '').withTitle('D16').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF16').withOption('defaultContent', '').withTitle('COF16').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d17').withOption('defaultContent', '').withTitle('D17').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF17').withOption('defaultContent', '').withTitle('COF17').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d18').withOption('defaultContent', '').withTitle('D18').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF18').withOption('defaultContent', '').withTitle('COF18').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d19').withOption('defaultContent', '').withTitle('D19').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF19').withOption('defaultContent', '').withTitle('COF19').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d20').withOption('defaultContent', '').withTitle('D20').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF20').withOption('defaultContent', '').withTitle('COF20').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d21').withOption('defaultContent', '').withTitle('D21').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF21').withOption('defaultContent', '').withTitle('COF21').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d22').withOption('defaultContent', '').withTitle('D22').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF22').withOption('defaultContent', '').withTitle('COF22').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d23').withOption('defaultContent', '').withTitle('D23').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF23').withOption('defaultContent', '').withTitle('COF23').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d24').withOption('defaultContent', '').withTitle('D24').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF24').withOption('defaultContent', '').withTitle('COF24').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d25').withOption('defaultContent', '').withTitle('D25').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF25').withOption('defaultContent', '').withTitle('COF25').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d26').withOption('defaultContent', '').withTitle('D26').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF26').withOption('defaultContent', '').withTitle('COF26').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d27').withOption('defaultContent', '').withTitle('D27').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF27').withOption('defaultContent', '').withTitle('COF27').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d28').withOption('defaultContent', '').withTitle('D28').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF28').withOption('defaultContent', '').withTitle('COF28').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d29').withOption('defaultContent', '').withTitle('D29').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF29').withOption('defaultContent', '').withTitle('COF29').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d30').withOption('defaultContent', '').withTitle('D30').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF30').withOption('defaultContent', '').withTitle('COF30').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d31').withOption('defaultContent', '').withTitle('D31').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF31').withOption('defaultContent', '').withTitle('COF31').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d32').withOption('defaultContent', '').withTitle('D32').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF32').withOption('defaultContent', '').withTitle('COF32').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d33').withOption('defaultContent', '').withTitle('D33').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF33').withOption('defaultContent', '').withTitle('COF33').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d34').withOption('defaultContent', '').withTitle('D34').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF34').withOption('defaultContent', '').withTitle('COF34').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d35').withOption('defaultContent', '').withTitle('D35').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF35').withOption('defaultContent', '').withTitle('COF35').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d36').withOption('defaultContent', '').withTitle('D36').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF36').withOption('defaultContent', '').withTitle('COF36').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d37').withOption('defaultContent', '').withTitle('D37').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF37').withOption('defaultContent', '').withTitle('COF37').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d38').withOption('defaultContent', '').withTitle('D38').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF38').withOption('defaultContent', '').withTitle('COF38').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d39').withOption('defaultContent', '').withTitle('D39').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF39').withOption('defaultContent', '').withTitle('COF39').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d40').withOption('defaultContent', '').withTitle('D40').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF40').withOption('defaultContent', '').withTitle('COF40').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d41').withOption('defaultContent', '').withTitle('D41').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF41').withOption('defaultContent', '').withTitle('COF41').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d42').withOption('defaultContent', '').withTitle('D42').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF42').withOption('defaultContent', '').withTitle('COF42').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d43').withOption('defaultContent', '').withTitle('D43').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF43').withOption('defaultContent', '').withTitle('COF43').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d44').withOption('defaultContent', '').withTitle('D44').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF44').withOption('defaultContent', '').withTitle('COF44').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d45').withOption('defaultContent', '').withTitle('D45').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF45').withOption('defaultContent', '').withTitle('COF45').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d46').withOption('defaultContent', '').withTitle('D46').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF46').withOption('defaultContent', '').withTitle('COF46').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d47').withOption('defaultContent', '').withTitle('D47').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF47').withOption('defaultContent', '').withTitle('COF47').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d48').withOption('defaultContent', '').withTitle('D48').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF48').withOption('defaultContent', '').withTitle('COF48').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d49').withOption('defaultContent', '').withTitle('D49').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF49').withOption('defaultContent', '').withTitle('COF49').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d50').withOption('defaultContent', '').withTitle('D50').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF50').withOption('defaultContent', '').withTitle('COF50').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d51').withOption('defaultContent', '').withTitle('D51').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF51').withOption('defaultContent', '').withTitle('COF51').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d52').withOption('defaultContent', '').withTitle('D52').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF52').withOption('defaultContent', '').withTitle('COF52').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d53').withOption('defaultContent', '').withTitle('D53').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF53').withOption('defaultContent', '').withTitle('COF53').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d54').withOption('defaultContent', '').withTitle('D54').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF54').withOption('defaultContent', '').withTitle('COF54').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d55').withOption('defaultContent', '').withTitle('D55').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF55').withOption('defaultContent', '').withTitle('COF55').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d56').withOption('defaultContent', '').withTitle('D56').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF56').withOption('defaultContent', '').withTitle('COF56').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d57').withOption('defaultContent', '').withTitle('D57').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF57').withOption('defaultContent', '').withTitle('COF57').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d58').withOption('defaultContent', '').withTitle('D58').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF58').withOption('defaultContent', '').withTitle('COF58').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d59').withOption('defaultContent', '').withTitle('D59').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF59').withOption('defaultContent', '').withTitle('COF59').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d60').withOption('defaultContent', '').withTitle('D60').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF60').withOption('defaultContent', '').withTitle('COF60').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d61').withOption('defaultContent', '').withTitle('D61').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF61').withOption('defaultContent', '').withTitle('COF61').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d62').withOption('defaultContent', '').withTitle('D62').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF62').withOption('defaultContent', '').withTitle('COF62').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d63').withOption('defaultContent', '').withTitle('D63').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF63').withOption('defaultContent', '').withTitle('COF63').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d64').withOption('defaultContent', '').withTitle('D64').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF64').withOption('defaultContent', '').withTitle('COF64').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d65').withOption('defaultContent', '').withTitle('D65').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF65').withOption('defaultContent', '').withTitle('COF65').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d66').withOption('defaultContent', '').withTitle('D66').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF66').withOption('defaultContent', '').withTitle('COF66').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d67').withOption('defaultContent', '').withTitle('D67').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF67').withOption('defaultContent', '').withTitle('COF67').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d68').withOption('defaultContent', '').withTitle('D68').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF68').withOption('defaultContent', '').withTitle('COF68').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d69').withOption('defaultContent', '').withTitle('D69').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF69').withOption('defaultContent', '').withTitle('COF69').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d70').withOption('defaultContent', '').withTitle('D70').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF70').withOption('defaultContent', '').withTitle('COF70').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d71').withOption('defaultContent', '').withTitle('D71').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF71').withOption('defaultContent', '').withTitle('COF71').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d72').withOption('defaultContent', '').withTitle('D72').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF72').withOption('defaultContent', '').withTitle('COF72').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d73').withOption('defaultContent', '').withTitle('D73').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF73').withOption('defaultContent', '').withTitle('COF73').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d74').withOption('defaultContent', '').withTitle('D74').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF74').withOption('defaultContent', '').withTitle('COF74').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d75').withOption('defaultContent', '').withTitle('D75').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF75').withOption('defaultContent', '').withTitle('COF75').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d76').withOption('defaultContent', '').withTitle('D76').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF76').withOption('defaultContent', '').withTitle('COF76').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d77').withOption('defaultContent', '').withTitle('D77').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF77').withOption('defaultContent', '').withTitle('COF77').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d78').withOption('defaultContent', '').withTitle('D78').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF78').withOption('defaultContent', '').withTitle('COF78').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d79').withOption('defaultContent', '').withTitle('D79').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF79').withOption('defaultContent', '').withTitle('COF79').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d80').withOption('defaultContent', '').withTitle('D80').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF80').withOption('defaultContent', '').withTitle('COF80').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d81').withOption('defaultContent', '').withTitle('D81').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF81').withOption('defaultContent', '').withTitle('COF81').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d82').withOption('defaultContent', '').withTitle('D82').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF82').withOption('defaultContent', '').withTitle('COF82').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d83').withOption('defaultContent', '').withTitle('D83').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF83').withOption('defaultContent', '').withTitle('COF83').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d84').withOption('defaultContent', '').withTitle('D84').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF84').withOption('defaultContent', '').withTitle('COF84').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d85').withOption('defaultContent', '').withTitle('D85').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF85').withOption('defaultContent', '').withTitle('COF85').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d86').withOption('defaultContent', '').withTitle('D86').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF86').withOption('defaultContent', '').withTitle('COF86').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d87').withOption('defaultContent', '').withTitle('D87').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF87').withOption('defaultContent', '').withTitle('COF87').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d88').withOption('defaultContent', '').withTitle('D88').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF88').withOption('defaultContent', '').withTitle('COF88').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d89').withOption('defaultContent', '').withTitle('D89').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF89').withOption('defaultContent', '').withTitle('COF89').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d90').withOption('defaultContent', '').withTitle('D90').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF90').withOption('defaultContent', '').withTitle('COF90').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d91').withOption('defaultContent', '').withTitle('D91').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF91').withOption('defaultContent', '').withTitle('COF91').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d92').withOption('defaultContent', '').withTitle('D92').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF92').withOption('defaultContent', '').withTitle('COF92').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d93').withOption('defaultContent', '').withTitle('D93').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF93').withOption('defaultContent', '').withTitle('COF93').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d94').withOption('defaultContent', '').withTitle('D94').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF94').withOption('defaultContent', '').withTitle('COF94').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d95').withOption('defaultContent', '').withTitle('D95').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF95').withOption('defaultContent', '').withTitle('COF95').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d96').withOption('defaultContent', '').withTitle('D96').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF96').withOption('defaultContent', '').withTitle('COF96').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d97').withOption('defaultContent', '').withTitle('D97').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF97').withOption('defaultContent', '').withTitle('COF97').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d98').withOption('defaultContent', '').withTitle('D98').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF98').withOption('defaultContent', '').withTitle('COF98').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('d99').withOption('defaultContent', '').withTitle('D99').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('COF99').withOption('defaultContent', '').withTitle('COF99').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p01').withOption('defaultContent', '').withTitle('P01').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p02').withOption('defaultContent', '').withTitle('P02').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p03').withOption('defaultContent', '').withTitle('P03').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p04').withOption('defaultContent', '').withTitle('P04').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p05').withOption('defaultContent', '').withTitle('P05').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p06').withOption('defaultContent', '').withTitle('P06').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p07').withOption('defaultContent', '').withTitle('P07').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p08').withOption('defaultContent', '').withTitle('P08').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p09').withOption('defaultContent', '').withTitle('P09').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p10').withOption('defaultContent', '').withTitle('P10').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p11').withOption('defaultContent', '').withTitle('P11').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p12').withOption('defaultContent', '').withTitle('P12').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p13').withOption('defaultContent', '').withTitle('P13').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p14').withOption('defaultContent', '').withTitle('P14').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p15').withOption('defaultContent', '').withTitle('P15').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p16').withOption('defaultContent', '').withTitle('P16').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p17').withOption('defaultContent', '').withTitle('P17').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p18').withOption('defaultContent', '').withTitle('P18').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p19').withOption('defaultContent', '').withTitle('P19').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p20').withOption('defaultContent', '').withTitle('P20').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p21').withOption('defaultContent', '').withTitle('P21').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p22').withOption('defaultContent', '').withTitle('P22').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p23').withOption('defaultContent', '').withTitle('P23').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p24').withOption('defaultContent', '').withTitle('P24').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p25').withOption('defaultContent', '').withTitle('P25').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p26').withOption('defaultContent', '').withTitle('P26').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p27').withOption('defaultContent', '').withTitle('P27').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p28').withOption('defaultContent', '').withTitle('P28').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p29').withOption('defaultContent', '').withTitle('P29').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p30').withOption('defaultContent', '').withTitle('P30').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p31').withOption('defaultContent', '').withTitle('P31').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p32').withOption('defaultContent', '').withTitle('P32').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p33').withOption('defaultContent', '').withTitle('P33').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p34').withOption('defaultContent', '').withTitle('P34').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p35').withOption('defaultContent', '').withTitle('P35').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p36').withOption('defaultContent', '').withTitle('P36').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p37').withOption('defaultContent', '').withTitle('P37').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p38').withOption('defaultContent', '').withTitle('P38').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p39').withOption('defaultContent', '').withTitle('P39').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p40').withOption('defaultContent', '').withTitle('P40').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p41').withOption('defaultContent', '').withTitle('P41').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p42').withOption('defaultContent', '').withTitle('P42').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p43').withOption('defaultContent', '').withTitle('P43').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p44').withOption('defaultContent', '').withTitle('P44').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p45').withOption('defaultContent', '').withTitle('P45').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p46').withOption('defaultContent', '').withTitle('P46').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p47').withOption('defaultContent', '').withTitle('P47').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p48').withOption('defaultContent', '').withTitle('P48').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p49').withOption('defaultContent', '').withTitle('P49').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p50').withOption('defaultContent', '').withTitle('P50').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p51').withOption('defaultContent', '').withTitle('P51').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p52').withOption('defaultContent', '').withTitle('P52').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p53').withOption('defaultContent', '').withTitle('P53').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p54').withOption('defaultContent', '').withTitle('P54').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p55').withOption('defaultContent', '').withTitle('P55').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p56').withOption('defaultContent', '').withTitle('P56').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p57').withOption('defaultContent', '').withTitle('P57').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p58').withOption('defaultContent', '').withTitle('P58').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p59').withOption('defaultContent', '').withTitle('P59').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p60').withOption('defaultContent', '').withTitle('P60').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p61').withOption('defaultContent', '').withTitle('P61').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p62').withOption('defaultContent', '').withTitle('P62').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p63').withOption('defaultContent', '').withTitle('P63').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p64').withOption('defaultContent', '').withTitle('P64').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p65').withOption('defaultContent', '').withTitle('P65').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p66').withOption('defaultContent', '').withTitle('P66').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p67').withOption('defaultContent', '').withTitle('P67').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p68').withOption('defaultContent', '').withTitle('P68').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p69').withOption('defaultContent', '').withTitle('P69').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p70').withOption('defaultContent', '').withTitle('P70').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p71').withOption('defaultContent', '').withTitle('P71').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p72').withOption('defaultContent', '').withTitle('P72').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p73').withOption('defaultContent', '').withTitle('P73').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p74').withOption('defaultContent', '').withTitle('P74').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p75').withOption('defaultContent', '').withTitle('P75').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p76').withOption('defaultContent', '').withTitle('P76').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p77').withOption('defaultContent', '').withTitle('P77').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p78').withOption('defaultContent', '').withTitle('P78').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p79').withOption('defaultContent', '').withTitle('P79').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p80').withOption('defaultContent', '').withTitle('P80').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p81').withOption('defaultContent', '').withTitle('P81').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p82').withOption('defaultContent', '').withTitle('P82').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p83').withOption('defaultContent', '').withTitle('P83').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p84').withOption('defaultContent', '').withTitle('P84').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p85').withOption('defaultContent', '').withTitle('P85').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p86').withOption('defaultContent', '').withTitle('P86').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p87').withOption('defaultContent', '').withTitle('P87').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p88').withOption('defaultContent', '').withTitle('P88').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p89').withOption('defaultContent', '').withTitle('P89').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p90').withOption('defaultContent', '').withTitle('P90').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p91').withOption('defaultContent', '').withTitle('P91').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p92').withOption('defaultContent', '').withTitle('P92').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p93').withOption('defaultContent', '').withTitle('P93').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p94').withOption('defaultContent', '').withTitle('P94').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p95').withOption('defaultContent', '').withTitle('P95').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p96').withOption('defaultContent', '').withTitle('P96').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p97').withOption('defaultContent', '').withTitle('P97').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p98').withOption('defaultContent', '').withTitle('P98').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('p99').withOption('defaultContent', '').withTitle('P99').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('careType').withOption('defaultContent', '').withTitle('CARETYPE').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeMode').withOption('defaultContent', '').withTitle('SEPMODE').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('drg').withOption('defaultContent', '').withTitle('DRG').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('daysInICU').withOption('defaultContent', '').withTitle('ICUDAYS').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('intendedLengthOfStay').withOption('defaultContent', '').withTitle('ILOS').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('neonatalAdmWeightG').withOption('defaultContent', '').withTitle('WEIGHT').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('mechVentilationHours').withOption('defaultContent', '').withTitle('VENT').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('leaveDays').withOption('defaultContent', '').withTitle('LEAVE').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('mentalHealthLegalStatus').withOption('defaultContent', '').withTitle('MSTATUS').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('PCCLModifiedUser').withOption('defaultContent', '').withTitle('CODERID').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('episodeAuditId').withOption('defaultContent', '').withTitle('AUDITID').withClass('mdl-data-table__cell--non-numeric')];
	
	    function filterDate() {
	        var newUrl = $scope.vm.url + '?startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted;
	        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	
	    function search() {
	        $scope.$on('lx-date-picker__close-start', function (e, id) {
	            filterDate();
	        });
	    }
	
	    // Bind the datatable instance to an object to monitor loading
	    this.dtInstanceCallback = dtInstanceCallback;
	
	    function dtInstanceCallback(dtInstance) {
	        $scope.dtInstance = dtInstance._renderer;
	    }
	};
	
	exports.default = PicqController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _picq = __webpack_require__(213);
	
	var _picq2 = _interopRequireDefault(_picq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var picqModule = _angular2.default.module('picq', [_angularUiRouter2.default]).component('picq', _picq2.default);
	
	exports.default = picqModule;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _queries = __webpack_require__(322);
	
	var _queries2 = _interopRequireDefault(_queries);
	
	var _queries3 = __webpack_require__(217);
	
	var _queries4 = _interopRequireDefault(_queries3);
	
	__webpack_require__(377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var queriesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _queries2.default,
	  controller: _queries4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = queriesComponent;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, jQuery, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueriesController = function QueriesController($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, datePicker, $rootScope, FunctionService, QueryModalOptions, CoderService) {
	    _classCallCheck(this, QueriesController);
	
	    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	    this.datatableApi;
	    this.user = User.getUser();
	    this.name = 'Queries';
	    this.episodeValue = '';
	    this.separationString = '';
	    this.showAdmissionNumberColumn = false;
	    this.showAuditTypeColumn = false;
	    this.showClinicianResponseColumn = false;
	    this.showQueryByColumn = false;
	    this.showQueryReasonColumn = false;
	    this.showSendsColumns = false;
	    this.queryAuditTypeTableUrl = 'queryaudittype/base';
	    this.functionSettings = {};
	    this.locale = 'en-au';
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.queriesreport';
	    this.initUrl = this.url + '?startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L') + '&episodeActive=YES';
	    this.specialtyString = '';
	    this.totalProjectedWiesDifference = 0;
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.functionSettings = response.functionSettings;
	        $scope.vm.episodeValue = $scope.vm.functionSettings.EpisodeValue ? $scope.vm.functionSettings.EpisodeValue.valueString : '';
	        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	        $scope.vm.showQueryReasonColumn = $scope.vm.functionSettings.QueryReasonColumn ? $scope.vm.functionSettings.QueryReasonColumn.isActive : false;
	        $scope.vm.showAuditTypeColumn = $scope.vm.functionSettings.AuditTypeColumn ? $scope.vm.functionSettings.AuditTypeColumn.isActive : false;
	        $scope.vm.showClinicianResponseColumn = $scope.vm.functionSettings.ClinicianResponseColumn ? $scope.vm.functionSettings.ClinicianResponseColumn.isActive : false;
	        $scope.vm.showQueryByColumn = $scope.vm.functionSettings.QueryByColumn ? $scope.vm.functionSettings.QueryByColumn.isActive : false;
	        $scope.vm.showAdmissionNumberColumn = $scope.vm.functionSettings.AdmissionNumberReplacesUrn ? $scope.vm.functionSettings.AdmissionNumberReplacesUrn.isActive : false;
	        $scope.vm.queryAuditTypeTableUrl = $scope.vm.functionSettings.QueryAuditTypeTableUrl ? $scope.vm.functionSettings.QueryAuditTypeTableUrl.valueString : $scope.vm.queryAuditTypeTableUrl;
	        $scope.vm.showSendsColumns = $scope.vm.functionSettings.QuerySendReceive ? $scope.vm.functionSettings.QuerySendReceive.isActive : false;
	        $scope.vm.showQueryCategoryColumn = $scope.vm.functionSettings.QueryCategory ? $scope.vm.functionSettings.QueryCategory.isActive : false;
	        QueryModalOptions.types($scope.vm.queryAuditTypeTableUrl).then(function (data) {
	            angular.forEach(data, function (value, key) {
	                if ($scope.vm.queryTypeOptions.indexOf(value.name) === -1) {
	                    $scope.vm.queryTypeOptions.push(value.name);
	                }
	            });
	        });
	
	        Constants.campusData().then(function successCallback(response) {
	            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	                var campusOptions = [];
	                if (typeof $scope.vm.user.campus === 'string') {
	                    campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
	                } else {
	                    campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
	                }
	                $scope.vm.campusOptions = campusOptions;
	                $scope.vm.campus.selectedCampus = campusOptions;
	            } else {
	                $scope.vm.campusOptions = response;
	            }
	        });
	
	        if (!$scope.vm.showSendsColumns) {
	            var sendsColumns = $scope.vm.dtColumns.filter(function (x) {
	                return x.mData === 'sentCount';
	            });
	            if (sendsColumns.length > 0) {
	                var indexOfSendsColumns = $scope.vm.dtColumns.indexOf(sendsColumns[0]);
	                $scope.vm.dtColumns.splice(indexOfSendsColumns, 2);
	            }
	        }
	        if (!$scope.vm.showQueryByColumn) {
	            var queryByColumns = $scope.vm.dtColumns.filter(function (x) {
	                return x.mData === 'queryType';
	            });
	            if (queryByColumns.length > 0) {
	                var indexOfQueryByColumn = $scope.vm.dtColumns.indexOf(queryByColumns[0]);
	                $scope.vm.dtColumns.splice(indexOfQueryByColumn, 1);
	            }
	        }
	        if (!$scope.vm.showAdmissionNumberColumn) {
	            var admissionNumberColumns = $scope.vm.dtColumns.filter(function (x) {
	                return x.mData === 'admissionNumber';
	            });
	            if (admissionNumberColumns.length > 0) {
	                var indexOfAdmissionNumberColumn = $scope.vm.dtColumns.indexOf(admissionNumberColumns[0]);
	                $scope.vm.dtColumns.splice(indexOfAdmissionNumberColumn, 1);
	            }
	        }
	        if (!$scope.vm.showQueryReasonColumn) {
	            var queryReasonColumns = $scope.vm.dtColumns.filter(function (x) {
	                return x.mData === 'queryReason';
	            });
	            if (queryReasonColumns.length > 0) {
	                var indexOfQueryReasonColumn = $scope.vm.dtColumns.indexOf(queryReasonColumns[0]);
	                $scope.vm.dtColumns.splice(indexOfQueryReasonColumn, 1);
	            }
	        }
	        if (!$scope.vm.showClinicianResponseColumn) {
	            var clinicianResponseColumns = $scope.vm.dtColumns.filter(function (x) {
	                return x.mData === 'clinicianResponse';
	            });
	            if (clinicianResponseColumns.length > 0) {
	                var indexOfClinicianResponseColumnsColumn = $scope.vm.dtColumns.indexOf(clinicianResponseColumns[0]);
	                $scope.vm.dtColumns.splice(indexOfClinicianResponseColumnsColumn, 1);
	            }
	        }
	        if (!$scope.vm.showQueryCategoryColumn) {
	            var queryCategoryColumns = $scope.vm.dtColumns.filter(function (x) {
	                return x.mData === 'queryCategory';
	            });
	            if (queryCategoryColumns.length > 0) {
	                var indexOfQueryCategoryColumn = $scope.vm.dtColumns.indexOf(queryCategoryColumns[0]);
	                $scope.vm.dtColumns.splice(indexOfQueryCategoryColumn, 1);
	            }
	        }
	        var auditTypeColumns = $scope.vm.dtColumns.filter(function (x) {
	            return x.mData === 'auditType';
	        });
	        if (auditTypeColumns.length > 0) {
	            var auditTypeColumnIndex = $scope.vm.dtColumns.indexOf(auditTypeColumns[0]);
	            if (!$scope.vm.showAuditTypeColumn) {
	                $scope.vm.dtColumns.splice(auditTypeColumnIndex, 1);
	            } else {
	                $scope.vm.dtColumns[auditTypeColumnIndex].sTitle = $scope.vm.functionSettings.AuditTypeColumn ? $scope.vm.functionSettings.AuditTypeColumn.valueString : 'Audit Type';
	            }
	        }
	        var currentDrgColumns = $scope.vm.dtColumns.filter(function (x) {
	            return x.mData === 'currentDrg';
	        });
	        if (currentDrgColumns.length > 0) {
	            var indexOfCurrentDrgColumn = $scope.vm.dtColumns.indexOf(currentDrgColumns[0]);
	            $scope.vm.dtColumns[indexOfCurrentDrgColumn + 1].sTitle = 'Current ' + $scope.vm.episodeValue;
	            $scope.vm.dtColumns[indexOfCurrentDrgColumn + 2].sTitle = 'Projected ' + $scope.vm.episodeValue;
	            $scope.vm.dtColumns[indexOfCurrentDrgColumn + 3].sTitle = 'Projected<br>' + $scope.vm.episodeValue + ' Difference';
	            $scope.vm.dtColumns[indexOfCurrentDrgColumn + 4].sTitle = $scope.vm.episodeValue + ' Difference';
	        }
	        var dischargeDateColumn = $scope.vm.dtColumns.filter(function (x) {
	            return x.mData === 'dischargeDate';
	        });
	        if (dischargeDateColumn.length > 0) {
	            var indexOfDischargeDateColumn = $scope.vm.dtColumns.indexOf(dischargeDateColumn[0]);
	            $scope.vm.dtColumns[indexOfDischargeDateColumn].sTitle = $scope.vm.separationString + ' Date';
	        }
	        var specialtyColumn = $scope.vm.dtColumns.filter(function (x) {
	            return x.mData === 'speciality';
	        });
	        if (specialtyColumn.length > 0) {
	            var indexOfSpecialtyColumn = $scope.vm.dtColumns.indexOf(specialtyColumn[0]);
	            $scope.vm.dtColumns[indexOfSpecialtyColumn].sTitle = $scope.vm.specialtyString;
	        }
	        var querySpecialtyColumn = $scope.vm.dtColumns.filter(function (x) {
	            return x.mData === 'querySpecialty';
	        });
	        if (querySpecialtyColumn.length > 0) {
	            var indexOfQuerySpecialtyColumn = $scope.vm.dtColumns.indexOf(querySpecialtyColumn[0]);
	            $scope.vm.dtColumns[indexOfQuerySpecialtyColumn].sTitle = 'Query ' + $scope.vm.specialtyString;
	        }
	    });
	
	    materialButtons.render();
	
	    materialButtons.processing();
	
	    // This is needed to obtain the sum of datatable column values
	    jQuery.fn.dataTable.Api.register('sum()', function () {
	        return this.flatten().reduce(function (a, b) {
	            if (typeof a === 'string') {
	                a = a.replace(/[^\d.-]/g, '') * 1;
	            }
	            if (typeof b === 'string') {
	                b = b.replace(/[^\d.-]/g, '') * 1;
	            }
	
	            return a + b;
	        }, 0);
	    });
	
	    $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	
	        // Datatables has finished init
	        // Initialise searching
	        if ($scope.vm.datatableApi) return;
	
	        $scope.vm.datatableApi = this.api();
	
	        // setup search filters
	        search();
	
	        // set the table to a fixed height, so it never collapsed up and down
	        $('#auditTable').closest(".dataTables_scrollBody").height(300);
	    };
	
	    $scope.drawCallback = function (nRow) {
	
	        // tell DataTables we're using Aussie-formatted dates for ordering
	        $.fn.dataTable.moment('DD/MM/YYYY');
	        $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
	
	        var table = $('#auditTable').DataTable(),
	            total = 0;
	
	        for (var i = 0; i < table.data().length; i++) {
	            if (parseFloat(table.data()[i].projectedWiesDifference)) total += parseFloat(table.data()[i].projectedWiesDifference);
	        }
	
	        $('.reports__stats #total-queries').html('Total Queries: ' + table.data().count().toLocaleString());
	
	        $('.reports__stats #total-proj-wies').html('Total Projected ' + $scope.vm.episodeValue + ' Difference: ' + total.toFixed(4));
	    };
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	        url: $scope.vm.initUrl,
	        type: 'GET',
	        error: function error(xhr, _error, thrown) {
	            if (thrown == 'Unauthorized' && $rootScope.globals.currentUser) {
	                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	            }
	        }
	    }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[2, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	        extend: 'print',
	        text: ''
	    }, {
	        extend: 'csvHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	        extend: 'excelHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	        text: '',
	        action: function action(e, dt, node, config) {
	            dt.ajax.reload();
	        }
	    }]).withColumnFilter({
	        //sPlaceHolder: "head:after",
	        aoColumns: [{ type: 'number' }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "date-range" }]
	    });
	
	    function yesNo(data) {
	        return data === true ? "Y" : "N";
	    }
	
	    this.dtColumns = [DTColumnBuilder.newColumn('episodeQueryId').withTitle('Query ID').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('campus').withTitle('Campus').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionNumber').withTitle('Admission Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('episodeStatus').withTitle('Episode Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('coder').withTitle('Coder').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('auditType').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('queryType').withTitle('Query By').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('queryTemplateName').withTitle('Query Type').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('queryReason').withTitle('Query Reason').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('queryCreatedBy').withTitle('Query Created By').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('createdDate').withTitle('Query Created Date').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('clinicianResponse').withTitle('Clinician Response').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('queryStatus').withTitle('Query Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('sentCount').withTitle('Send Count').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('lastSend').withTitle('Last Send Date').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('lastSendBy').withTitle('Last Send By').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('queryCategory').withTitle('Query Category').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('querySpecialty').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('currentDrg').withTitle('Current DRG').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('currentWies').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('projectedWies').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn(null).withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        full['projectedWiesDifference'] = data['projectedWies'] ? data['projectedWies'] - data['currentWies'] : '';
	        return data['projectedWies'] ? (data['projectedWies'] - (data['currentWies'] ? data['currentWies'] : 0.0000)).toFixed(4) : '';
	    }), DTColumnBuilder.newColumn('wiesDiff').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('patientClassification').withTitle('Patient Classification').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')];
	
	    // Search filters
	    this.campus = {
	        selectedCampus: []
	    };
	    this.campusOptions = [];
	
	    this.specialty = {
	        selectedSpecialty: []
	    };
	    this.specialtyOptions = [];
	
	    this.auditType = {
	        selectedAuditType: []
	    };
	    this.auditTypeOptions = [];
	
	    this.queryTemplate = {
	        selectedQueryTemplates: []
	    };
	    this.queryTemplateData = {};
	    this.queryTemplateOptions = [];
	    this.episodeActive = {
	        selectedEpisodeActive: ['YES']
	    };
	    this.episodeActiveOptions = ['YES', 'NO'];
	
	    $scope.promise = Constants.getQueryTemplateData().then(function (data) {
	        $scope.vm.queryTemplateData = data;
	        angular.forEach($scope.vm.queryTemplateData, function (value, key) {
	            $scope.vm.queryTemplateOptions.push(value.queryTemplateName);
	        });
	    });
	
	    this.queryType = {
	        selectedQueryType: []
	    };
	    this.queryTypeOptions = [];
	
	    this.queryStatus = {
	        selectedQueryStatus: []
	    };
	
	    this.queryStatusOptions = [];
	
	    this.querySpecialty = {
	        selectedQuerySpecialty: []
	    };
	
	    QueryModalOptions.statuses().then(function (response) {
	        angular.forEach(response, function (item, key) {
	            $scope.vm.queryStatusOptions.push(item.name);
	        });
	    });
	
	    Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	        $scope.vm.specialtyOptions = response.specialties.sort();
	    });
	
	    this.startDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
	        }
	    };
	    this.endDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'days'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	        }
	    };
	
	    this.coder = {
	        selectedCoder: []
	    };
	    this.coderOptions = [];
	
	    this.queryCreatedBy = {
	        selectedQueryCreatedBy: []
	    };
	
	    CoderService.data().then(function successCallback(response) {
	        angular.forEach(response, function (item, key) {
	            $scope.vm.coderOptions.push(item.name);
	        });
	    });
	
	    // callbacks for lx-selects and lx-date-picker
	    datePicker.autoClose($scope);
	    this.filterCallback = filterCallback;
	
	    function filterCampus(swap) {
	        $scope.vm.campus.selectedCampus = [];
	        if (swap !== 'minus') {
	            $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	        }
	    }
	
	    function filterSpecialty(swap) {
	        $scope.vm.specialty.selectedSpecialty = [];
	        if (swap === 'add') {
	            $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	        }
	    }
	
	    function filterEpisodeActive(swap) {
	        $scope.vm.episodeActive.selectedEpisodeActive = [];
	        if (swap === 'add') {
	            $scope.vm.episodeActive.selectedEpisodeActive = ['YES', 'NO'];
	        }
	    }
	
	    function filterAuditType(swap) {
	
	        // audit type
	        $scope.vm.auditTypeOptions = CONST.AUDITTYPE;
	        $scope.vm.auditType.selectedAuditType = [];
	
	        if (swap !== 'minus') {
	
	            angular.forEach(CONST.AUDITTYPE, function (value, key) {
	                $scope.vm.auditType.selectedAuditType.push($scope.vm.auditTypeOptions[$scope.vm.auditTypeOptions.indexOf(value)]);
	            });
	        }
	    }
	
	    function filterQueryType(swap) {
	        // query type
	        $scope.vm.queryType.selectedQueryType = [];
	
	        if (swap !== 'minus') {
	            $scope.vm.queryType.selectedQueryType = [$scope.vm.queryTypeOptions[0]];
	        }
	    }
	
	    function filterQueryTemplate(swap) {
	
	        // query type
	        $scope.vm.queryTemplate.selectedQueryTemplates = [];
	
	        if (swap !== 'minus') {
	            $scope.vm.queryType.selectedQueryTemplates = $scope.vm.queryTemplateOptions;
	        }
	    }
	
	    function filterQueryStatus(swap) {
	
	        // query status
	        $scope.vm.queryStatus.selectedQueryStatus = [];
	
	        if (swap !== 'minus') {
	            $scope.vm.queryType.selectedQueryStatus = $scope.vm.queryStatusOptions;
	        }
	    }
	
	    function filterQuerySpecialty(swap) {
	
	        $scope.vm.querySpecialty.selectedQuerySpecialty = [];
	
	        if (swap !== 'minus') {
	            $scope.vm.querySpecialty.selectedQuerySpecialty = $scope.vm.specialtyOptions;
	        }
	    }
	
	    function filterCoder(swap) {
	
	        $scope.vm.coder.selectedCoder = [];
	
	        if (swap !== 'minus') {
	            $scope.vm.coder.selectedCoder = $scope.vm.coderOptions;
	        }
	    }
	
	    function filterQueryCreatedBy(swap) {
	
	        $scope.vm.queryCreatedBy.selectedQueryCreatedBy = [];
	
	        if (swap !== 'minus') {
	            $scope.vm.queryCreatedBy.selectedQueryCreatedBy = $scope.vm.coderOptions;
	        }
	    }
	
	    function filterCallback(_newValue, _oldValue) {
	        $scope.vm.changeData();
	    }
	
	    function checkParam(param) {
	
	        if (param && param.length !== 0) {
	            return encodeURIComponent(param.join());
	        } else {
	
	            return '';
	        }
	    }
	
	    this.changeData = changeData;
	
	    function changeData() {
	        var campus = '';
	        if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	            if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
	                campus = $scope.vm.user.campus;
	            } else {
	                campus = $scope.vm.campus.selectedCampus;
	            }
	        } else {
	            campus = $scope.vm.campus.selectedCampus;
	        }
	        var newUrl = $scope.vm.url + '?startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '&speciality=' + checkParam($scope.vm.specialty.selectedSpecialty) + '&campus=' + checkParam(campus) + '&auditType=' + checkParam($scope.vm.auditType.selectedAuditType) + '&queryType=' + checkParam($scope.vm.queryType.selectedQueryType) + '&queryTemplate=' + checkParam($scope.vm.queryTemplate.selectedQueryTemplates) + '&queryStatus=' + checkParam($scope.vm.queryStatus.selectedQueryStatus) + '&querySpecialty=' + checkParam($scope.vm.querySpecialty.selectedQuerySpecialty) + '&coder=' + checkParam($scope.vm.coder.selectedCoder) + '&episodeActive=' + checkParam($scope.vm.episodeActive.selectedEpisodeActive) + '&queryCreatedBy=' + checkParam($scope.vm.queryCreatedBy.selectedQueryCreatedBy);
	
	        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	
	    function search() {
	        // delete any global searches previously applied
	        if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	        var auditTable = $scope.vm.datatableApi;
	        var clearAuditTable = auditTable.search('').draw();
	
	        filterCampus('minus');
	        filterSpecialty('minus');
	        filterAuditType('minus');
	        filterQueryType('minus');
	        filterQueryStatus('minus');
	        filterQuerySpecialty('minus');
	        filterCoder('minus');
	        filterQueryCreatedBy('minus');
	
	        // re-draw tabele on datepicker close
	        $scope.$on('lx-date-picker__close-start', function (e, id) {
	
	            $scope.vm.changeData();
	        });
	    }
	
	    // bind the datatable instance to an object to monitor loading
	    this.dtInstanceCallback = dtInstanceCallback;
	
	    function dtInstanceCallback(dtInstance) {
	
	        $scope.dtInstance = dtInstance._renderer;
	    }
	
	    // bind filter swap
	    this.filterSwap = filterSwap;
	
	    function filterSwap(thisFilter, thisModifier) {
	
	        switch (thisFilter) {
	
	            case 'campus':
	
	                if (thisModifier === 'add') {
	
	                    filterCampus('add');
	                } else {
	
	                    filterCampus('minus');
	                }
	
	                break;
	
	            case 'auditType':
	
	                if (thisModifier === 'add') {
	
	                    filterAuditType('add');
	                } else {
	
	                    filterAuditType('minus');
	                }
	
	                break;
	
	            case 'episodeActive':
	
	                if (thisModifier === 'add') {
	
	                    filterEpisodeActive('add');
	                } else {
	
	                    filterEpisodeActive('minus');
	                }
	
	                break;
	
	            case 'specialty':
	
	                if (thisModifier === 'add') {
	
	                    filterSpecialty('add');
	                } else {
	
	                    filterSpecialty('minus');
	                }
	
	                break;
	
	            case 'queryType':
	
	                if (thisModifier === 'add') {
	
	                    filterQueryType('add');
	                } else {
	
	                    filterQueryType('minus');
	                }
	
	                break;
	
	            case 'queryTemplate':
	
	                if (thisModifier === 'add') {
	
	                    filterQueryTemplate('add');
	                } else {
	
	                    filterQueryTemplate('minus');
	                }
	
	                break;
	
	            case 'queryStatus':
	
	                if (thisModifier === 'add') {
	
	                    filterQueryStatus('add');
	                } else {
	
	                    filterQueryStatus('minus');
	                }
	
	                break;
	
	            case 'querySpecialty':
	
	                if (thisModifier === 'add') {
	
	                    filterQuerySpecialty('add');
	                } else {
	
	                    filterQuerySpecialty('minus');
	                }
	
	                break;
	
	            case 'coder':
	
	                if (thisModifier === 'add') {
	
	                    filterCoder('add');
	                } else {
	
	                    filterCoder('minus');
	                }
	
	                break;
	
	            case 'queryCreatedBy':
	
	                if (thisModifier === 'add') {
	
	                    filterQueryCreatedBy('add');
	                } else {
	
	                    filterQueryCreatedBy('minus');
	                }
	
	                break;
	
	            default:
	                break;
	        }
	    }
	};
	
	exports.default = QueriesController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _queries = __webpack_require__(216);
	
	var _queries2 = _interopRequireDefault(_queries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var queriesModule = _angular2.default.module('queries', [_angularUiRouter2.default]).component('queries', _queries2.default);
	
	exports.default = queriesModule;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _querychanges = __webpack_require__(323);
	
	var _querychanges2 = _interopRequireDefault(_querychanges);
	
	var _querychanges3 = __webpack_require__(220);
	
	var _querychanges4 = _interopRequireDefault(_querychanges3);
	
	__webpack_require__(378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var querychangesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _querychanges2.default,
	  controller: _querychanges4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = querychangesComponent;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuerychangesController = function QuerychangesController($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
	  _classCallCheck(this, QuerychangesController);
	
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = 'Query Changes';
	  this.episodeValue = '';
	  this.specialtyString = '';
	  this.separationString = '';
	  this.locale = 'en-au';
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.querychanges/query?';
	  this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L') + '';
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.episodeValueDecimalPlaces = $scope.vm.episodeValue === "$" ? 2 : 4;
	    $scope.vm.queryModalQueryType = response.functionSettings.QueryCategoryDropdownConfig;
	    $scope.vm.functionSettings = response.functionSettings;
	    if ($scope.vm.queryModalQueryType && !$scope.vm.queryModalQueryType.isActive) {
	      $scope.vm.dtColumns[2].visible = false;
	    }
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === 'string') {
	          campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $('#auditTable').closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	    url: $scope.vm.initUrl,
	    type: 'GET',
	    error: function error(xhr, _error, thrown) {
	      if (thrown == 'Unauthorized') {
	        //window.location.replace(window.location.origin + '/login');
	        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true)
	  // .withOption('serverSide', true)
	  .withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($('#auditTable').DataTable());
	  }).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: 'print',
	    text: ''
	  }, {
	    extend: 'csvHtml5',
	    text: '',
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: 'excelHtml5',
	    text: '',
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: '',
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "select" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn('campus').withTitle('Campus').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('queryType').withTitle('Query type').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalQueryGenerated').withTitle('Queries').withOption('defaultContent', '').withOption('width', '5%').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalOriginalQuery').withTitle('Original<br>Queries').withOption('defaultContent', '').withOption('width', '5%').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalQueryAdded').withTitle('Added<br>Queries').withOption('defaultContent', '').withOption('width', '5%').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalQueryAltered').withTitle('Altered<br>Queries').withOption('defaultContent', '').withOption('width', '5%').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalQueryDeleted').withTitle('Queries<br>Deleted').withOption('defaultContent', '').withOption('width', '5%').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalChangesOfDRG').withTitle('DRG Changes from Queries').withOption('defaultContent', '').withOption('width', '5%').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('sumTotalWIESChange').withTitle('Total $ Change').withOption('defaultContent', '').withOption('width', '5%').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.episodeValueDecimalPlaces);
	  }), DTColumnBuilder.newColumn('avgChangePerEpisode').withTitle('Avg Change per Episode').withOption('defaultContent', '').withOption('width', '5%').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.episodeValueDecimalPlaces);
	  })];
	
	  // Search filters
	  this.campus = {
	    selectedCampus: []
	  };
	  this.campusOptions = [];
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	  this.auditCriteria = {
	    selectedCriteria: []
	  };
	  this.auditCriteriaOptions = {};
	
	  this.locale = 'en-au';
	
	  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty($scope.vm.specialtyOptions);
	  });
	
	  this.startDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
	      dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: moment().locale(this.locale).subtract(1, 'days'),
	      dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	    }
	  };
	
	  // callbacks for lx-selects and lx-date-picker
	  this.campusCallback = campusCallback;
	  function campusCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	
	  this.specialtyCallback = specialtyCallback;
	  function specialtyCallback(_newValue, _oldValue) {
	    filterDate();
	  }
	  datePicker.autoClose($scope);
	
	  function setDtHeaders(table) {
	    $(table.column(1).header()).html($scope.vm.specialtyString);
	    $(table.column(9).header()).html($scope.vm.episodeValue + ' Change from Queries');
	    $(table.column(10).header()).html('Average ' + $scope.vm.episodeValue + ' Increase from Queries');
	  }
	
	  function selectFilter(column, filter) {
	
	    if (filter) {
	
	      // convert array to datatables permissable regex string
	      filter = filter.join("|");
	
	      if (filter !== '') filter = '^' + filter + '$';
	
	      var auditTable = $scope.vm.datatableApi;
	
	      auditTable.columns(column).search(filter, true, false).draw();
	    }
	  }
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === 'add') {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === 'add') {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function setDefaultDate() {
	
	    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
	    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');
	
	    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
	    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');
	  }
	
	  function filterDate() {
	    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
	        endDate = $scope.vm.endDatePicker.input.dateFormatted;
	    var campus = '';
	    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
	        campus = $scope.vm.user.campus;
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	    } else {
	      campus = $scope.vm.campus.selectedCampus;
	    }
	    var url = $scope.vm.url + '&startDate=' + startDate + '&endDate=' + endDate + '&campus=' + checkParam(campus) + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty);
	    $scope.vm.datatableApi.ajax.url(url).load().draw();
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function search() {
	
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search('').draw();
	
	    filterSpecialty('minus');
	
	    filterDate();
	
	    // re-draw tabele on datepicker close
	    $scope.$on('lx-date-picker__close-start', function (e, id) {
	
	      var newUrl = $scope.vm.url + 'startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '';
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    });
	
	    // Trigger filtering
	    $('.reports__filters').find('div').first().find('div:last-child').click();
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case 'specialty':
	        if (thisModifier === 'add') {
	          filterSpecialty('add');
	        } else {
	          filterSpecialty('minus');
	        }
	        break;
	      case 'campus':
	        if (thisModifier === 'add') {
	          filterCampus('add');
	        } else {
	          filterCampus('minus');
	        }
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = QuerychangesController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _querychanges = __webpack_require__(219);
	
	var _querychanges2 = _interopRequireDefault(_querychanges);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var querychangesModule = _angular2.default.module('querychanges', [_angularUiRouter2.default]).component('querychanges', _querychanges2.default);
	
	exports.default = querychangesModule;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _readmissions = __webpack_require__(324);
	
	var _readmissions2 = _interopRequireDefault(_readmissions);
	
	var _readmissions3 = __webpack_require__(223);
	
	var _readmissions4 = _interopRequireDefault(_readmissions3);
	
	__webpack_require__(379);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var readmissionsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _readmissions2.default,
	  controller: _readmissions4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = readmissionsComponent;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReadmissionsController = function ReadmissionsController($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, USER, CONST, materialButtons, datePicker, $rootScope, Constants, FunctionService) {
	    _classCallCheck(this, ReadmissionsController);
	
	    this.datatableApi;
	    this.name = 'Readmissions Within 28 Days';
	    this.episodeValue = '';
	    this.specialtyString = '';
	    this.separationString = '';
	    this.locale = 'en-au';
	    this.startDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
	        }
	    };
	    this.endDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'months').endOf('months'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'months').endOf('months').format('L')
	        }
	    };
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.readmissions?removeCoding=1';
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    });
	
	    datePicker.autoClose($scope);
	
	    materialButtons.render();
	
	    materialButtons.processing();
	
	    $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	
	        // Datatables has finished init
	        // Initialise searching
	        if ($scope.vm.datatableApi) return;
	
	        $scope.vm.datatableApi = this.api();
	
	        // Update column headers even when no data returned
	        setDtHeaders($scope.vm.datatableApi);
	
	        // tell DataTables we're using Aussie-formatted dates for ordering
	        $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
	
	        // set the table to a fixed height, so it never collapsed up and down
	        $('#auditTable').closest(".dataTables_scrollBody").height(300);
	    };
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	        url: $scope.vm.url + '&startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted,
	        type: 'GET',
	        error: function error(xhr, _error, thrown) {
	            if (thrown == 'Unauthorized') {
	                //window.location.replace(window.location.origin + '/login');
	                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
	            }
	        }
	    }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	        // Update column headers if data returned
	        setDtHeaders($('#auditTable').DataTable());
	    }).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[2, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	        extend: 'print',
	        text: ''
	    }, {
	        extend: 'csvHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	        extend: 'excelHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	    }, {
	        text: '',
	        action: function action(e, dt, node, config) {
	            dt.ajax.reload();
	        }
	    }]);
	
	    //   .withColumnFilter({
	    //     //sPlaceHolder: "head:after",
	    //     aoColumns: [
	    //       { type: 'number' },
	    //       { type: "date-range" },
	    //       { type: "date-range" },
	    //       { type: "select" },
	    //       { type: "select" },
	    //       { type: "select" },
	    //       { type: "number" }, {
	    //         type: "text",
	    //         bRegex: true,
	    //         bSmart: true
	    //       },
	    //       { type: "number" }
	    //     ]
	    //   });
	
	    // function yesNo(data) {
	    //   return (data === true) ? "Y" : "N";
	    // }
	
	    this.dtColumns = [DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('auditCriteria').withTitle('Audit Criteria').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('status').withTitle('Audit Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('drg').withTitle('Original DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('finalDRG').withTitle('Final DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('wies').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        return data ? parseFloat(data).toFixed(4) : '0.0000';
	    }), DTColumnBuilder.newColumn('finalWIES').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        return data ? parseFloat(data).toFixed(4) : '0.0000';
	    }), DTColumnBuilder.newColumn('totalWIESChange').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        return data ? parseFloat(data).toFixed(4) : '0.0000';
	    }), DTColumnBuilder.newColumn('auditFinalisedDateTime').withTitle('Date Audit Finalised').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('patientClassification').withTitle('Patient Classification').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('healthCareFund').withTitle('Health Care Fund').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')];
	
	    // Search filters
	    this.specialty = {
	        selectedSpecialty: []
	    };
	
	    Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
	        $scope.vm.specialtyOptions = response.specialties.sort();
	    });
	
	    this.healthCareFund = {
	        selectedHealthCareFund: []
	    };
	
	    Constants.healthCareFundData().then(function successCallback(response) {
	        $scope.vm.healthCareFundOptions = response;
	    });
	
	    this.patientClassification = {
	        selectedPatientClassification: []
	    };
	
	    Constants.patientClassificationData().then(function successCallback(response) {
	        $scope.vm.patientClassificationOptions = response;
	    });
	
	    function setDtHeaders(table) {
	        $(table.column(2).header()).html($scope.vm.separationString + ' Date');
	        $(table.column(3).header()).html($scope.vm.specialtyString);
	        $(table.column(8).header()).html('Original ' + $scope.vm.episodeValue);
	        $(table.column(9).header()).html('Final ' + $scope.vm.episodeValue);
	        $(table.column(10).header()).html($scope.vm.episodeValue + ' Change');
	    }
	
	    // Re-draw table on datepicker close
	    $scope.$on('lx-date-picker__close-start', function (e, id) {
	        changeData();
	    });
	
	    // callbacks for lx-selects
	    this.specialtyCallback = specialtyCallback;
	
	    function specialtyCallback(_newValue, _oldValue) {
	        $scope.vm.changeData();
	    }
	
	    function filterSpecialty(swap) {
	
	        $scope.vm.specialty.selectedSpecialty = [];
	
	        if (swap !== 'minus') {
	
	            angular.forEach($scope.vm.specialtyOptions, function (value, key) {
	                $scope.vm.specialty.selectedSpecialty.push($scope.vm.specialtyOptions[$scope.vm.specialtyOptions.indexOf(value)]);
	            });
	        }
	    }
	
	    this.healthCareFundCallback = healthCareFundCallback;
	
	    function healthCareFundCallback(_newValue, _oldValue) {
	        $scope.vm.changeData();
	    }
	
	    function filterHealthCareFund(swap) {
	
	        $scope.vm.healthCareFund.selectedHealthCareFund = [];
	
	        if (swap !== 'minus') {
	
	            angular.forEach($scope.vm.healthCareFundOptions, function (value, key) {
	                $scope.vm.healthCareFund.selectedHealthCareFund.push($scope.vm.healthCareFundOptions[$scope.vm.healthCareFundOptions.indexOf(value)]);
	            });
	        }
	    }
	
	    this.patientClassificationCallback = patientClassificationCallback;
	
	    function patientClassificationCallback(_newValue, _oldValue) {
	        $scope.vm.changeData();
	    }
	
	    function filterPatientClassification(swap) {
	
	        $scope.vm.patientClassification.selectedPatientClassification = [];
	
	        if (swap !== 'minus') {
	
	            angular.forEach($scope.vm.patientClassificationOptions, function (value, key) {
	                $scope.vm.patientClassification.selectedPatientClassification.push($scope.vm.patientClassificationOptions[$scope.vm.patientClassificationOptions.indexOf(value)]);
	            });
	        }
	    }
	
	    this.finYearCallback = finYearCallback;
	
	    function finYearCallback(_newValue, _oldValue) {
	        setDates(_newValue);
	        $scope.vm.changeData();
	    }
	
	    function checkParam(param) {
	
	        if (param.length !== 0) {
	
	            return encodeURIComponent(param.join());
	        } else {
	
	            return "";
	        }
	    }
	
	    this.changeData = changeData;
	
	    function changeData() {
	
	        var newUrl = $scope.vm.url + '&startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty) + '&healthCareFund=' + checkParam($scope.vm.healthCareFund.selectedHealthCareFund) + '&patientClassification=' + checkParam($scope.vm.patientClassification.selectedPatientClassification);
	
	        if ($scope.vm.datatableApi) {
	            $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	        }
	    }
	
	    // bind the datatable instance to an object to monitor loading
	    this.dtInstanceCallback = dtInstanceCallback;
	
	    function dtInstanceCallback(dtInstance) {
	
	        $scope.dtInstance = dtInstance._renderer;
	    }
	
	    // bind filter swap
	    this.filterSwap = filterSwap;
	
	    function filterSwap(thisFilter, thisModifier) {
	
	        switch (thisFilter) {
	
	            case 'specialty':
	
	                if (thisModifier === 'add') {
	
	                    filterSpecialty('add');
	                } else {
	
	                    filterSpecialty('minus');
	                }
	
	                break;
	
	            case 'healthCareFund':
	
	                if (thisModifier === 'add') {
	
	                    filterHealthCareFund('add');
	                } else {
	
	                    filterHealthCareFund('minus');
	                }
	
	                break;
	
	            case 'patientClassification':
	
	                if (thisModifier === 'add') {
	
	                    filterPatientClassification('add');
	                } else {
	
	                    filterPatientClassification('minus');
	                }
	
	                break;
	
	            default:
	                break;
	        }
	    }
	};
	
	exports.default = ReadmissionsController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _readmissions = __webpack_require__(222);
	
	var _readmissions2 = _interopRequireDefault(_readmissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var readmissionsModule = _angular2.default.module('readmissions', [_angularUiRouter2.default]).component('readmissions', _readmissions2.default);
	
	exports.default = readmissionsModule;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sentqueries = __webpack_require__(325);
	
	var _sentqueries2 = _interopRequireDefault(_sentqueries);
	
	var _sentqueries3 = __webpack_require__(226);
	
	var _sentqueries4 = _interopRequireDefault(_sentqueries3);
	
	__webpack_require__(380);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sentqueriesComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _sentqueries2.default,
	  controller: _sentqueries4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = sentqueriesComponent;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SentQueriesController = function SentQueriesController($scope, DTOptionsBuilder, DTColumnBuilder, USER, CONST, materialButtons, datePicker, $rootScope, $timeout, QueryModalOptions, FunctionService) {
	    _classCallCheck(this, SentQueriesController);
	
	    this.datatableApi;
	    this.user = USER;
	    this.name = 'Sent Queries';
	    this.separationString = '';
	    this.locale = 'en-au';
	    this.url = ("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.sentqueries';
	    this.initUrl = this.url + '?startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L');
	    this.totalProjectedWiesDifference = 0;
	
	    materialButtons.render();
	    materialButtons.processing();
	
	    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	    });
	
	    $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	        // Datatables has finished init
	        // Initialise searching
	        if ($scope.vm.datatableApi) return;
	
	        $scope.vm.datatableApi = this.api();
	
	        // Update column headers even when no data returned
	        setDtHeaders($scope.vm.datatableApi);
	
	        // setup search filters
	        search();
	        // set the table to a fixed height, so it never collapsed up and down
	        $('#auditTable').closest('.dataTables_scrollBody').height(300);
	    };
	
	    $scope.drawCallback = function (nRow) {
	        // tell DataTables we're using Aussie-formatted dates for ordering
	        $.fn.dataTable.moment('DD/MM/YYYY');
	        $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
	    };
	
	    this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
	        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
	        url: $scope.vm.initUrl,
	        type: 'GET',
	        error: function error(xhr, _error, thrown) {
	            if (thrown == 'Unauthorized') window.location.replace(window.location.origin + '/login');
	        }
	    }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
	        // Update column headers if data returned
	        setDtHeaders($('#auditTable').DataTable());
	    }).withOption('rowCallback', $scope.rowCallback).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[2, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	        extend: 'print',
	        text: ''
	    }, {
	        extend: 'csvHtml5',
	        text: '',
	        filename: $scope.vm.name + '-' + moment().format('YYYYMMDD-HHmm')
	    }, {
	        extend: 'excelHtml5',
	        text: '',
	        filename: $scope.vm.name + "-" + moment().format('YYYYMMDD-HHmm')
	    }, {
	        text: '',
	        action: function action(e, dt, node, config) {
	            dt.ajax.reload();
	        }
	    }]);
	
	    this.dtColumns = [DTColumnBuilder.newColumn('episodeQueryId').withTitle('Query ID').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('urn').withTitle('UR Number').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withOption('defaultContent', '').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withOption('defaultContent', '').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('sentDate').withTitle('Sent Date').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
	        return moment(data).format('DD/MM/YYYY HH:mm');
	    }), DTColumnBuilder.newColumn('sentBy').withTitle('Sent By').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('queryStatus').withTitle('Query Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')];
	
	    // Search filters
	    this.searchFilter = '';
	    this.queryStatus = {
	        selectedQueryStatus: []
	    };
	    this.queryStatusOptions = [];
	
	    QueryModalOptions.statuses().then(function successCallback(response) {
	        angular.forEach(response, function (value, key) {
	            if ($scope.vm.queryStatusOptions.indexOf(value.name) === -1) $scope.vm.queryStatusOptions.push(value.name);
	        });
	    });
	
	    this.startDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
	        }
	    };
	    this.endDatePicker = {
	        input: {
	            date: moment().locale(this.locale).subtract(1, 'days'),
	            dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
	        }
	    };
	
	    // callbacks for lx-selects and lx-date-picker
	    datePicker.autoClose($scope);
	    this.filterCallback = filterCallback;
	
	    function filterQueryStatus(swap) {
	        // query status
	        $scope.vm.queryStatus.selectedQueryStatus = [];
	
	        if (swap !== 'minus') {
	            angular.forEach($scope.vm.queryStatusOptions, function (value, key) {
	                $scope.vm.queryStatus.selectedQueryStatus.push($scope.vm.queryStatusOptions[$scope.vm.queryStatusOptions.indexOf(value)]);
	            });
	        }
	    }
	
	    function filterCallback(_newValue, _oldValue) {
	        $scope.vm.changeData();
	    }
	
	    function checkParam(param) {
	        if (param.length !== 0) {
	            return encodeURIComponent(param.join());
	        } else {
	            return '';
	        }
	    }
	
	    this.changeData = changeData;
	
	    function changeData() {
	        var newUrl = $scope.vm.url + '?startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '&queryStatus=' + checkParam($scope.vm.queryStatus.selectedQueryStatus) + '&search=' + $scope.vm.searchFilter;
	        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	
	    function setDtHeaders(table) {
	        $(table.column(3).header()).html($scope.vm.separationString + ' Date');
	    }
	
	    function search() {
	        var timeoutPromise,
	            delayInMs = 500;
	
	        $scope.$watch("vm.searchFilter", function (searchString, oldvalue) {
	            $timeout.cancel(timeoutPromise); // Does nothing if timeout already done
	            timeoutPromise = $timeout(function () {
	                // Set timeout
	                if (searchString !== oldvalue) {
	                    $scope.vm.changeData();
	                }
	            }, delayInMs);
	        });
	
	        // delete any global searches previously applied
	        if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	        filterQueryStatus('minus');
	
	        // re-draw tabele on datepicker close
	        $scope.$on('lx-date-picker__close-start', function (e, id) {
	            $scope.vm.changeData();
	        });
	    }
	
	    // bind the datatable instance to an object to monitor loading
	    this.dtInstanceCallback = dtInstanceCallback;
	
	    function dtInstanceCallback(dtInstance) {
	        $scope.dtInstance = dtInstance._renderer;
	    }
	
	    // bind filter swap
	    this.filterSwap = filterSwap;
	
	    function filterSwap(thisFilter, thisModifier) {
	        switch (thisFilter) {
	            case 'queryStatus':
	                if (thisModifier === 'add') {
	                    filterQueryStatus('add');
	                } else {
	                    filterQueryStatus('minus');
	                }
	                break;
	            default:
	                break;
	        }
	    }
	};
	
	exports.default = SentQueriesController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sentqueries = __webpack_require__(225);
	
	var _sentqueries2 = _interopRequireDefault(_sentqueries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sentqueriesModule = _angular2.default.module('sentqueries', [_angularUiRouter2.default]).component('sentqueries', _sentqueries2.default);
	
	exports.default = sentqueriesModule;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _targetdrgs = __webpack_require__(326);
	
	var _targetdrgs2 = _interopRequireDefault(_targetdrgs);
	
	var _targetdrgs3 = __webpack_require__(229);
	
	var _targetdrgs4 = _interopRequireDefault(_targetdrgs3);
	
	__webpack_require__(381);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetdrgsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _targetdrgs2.default,
	  controller: _targetdrgs4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = targetdrgsComponent;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, moment) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TargetdrgsController = function TargetdrgsController($scope, DTOptionsBuilder, DTColumnBuilder, USER, CONST, materialButtons, $rootScope, FunctionService) {
	  _classCallCheck(this, TargetdrgsController);
	
	  this.datatableApi;
	  this.user = USER;
	  this.name = "Target DRGs";
	  this.locale = "en-au";
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.targetdrgs/targetdrgs";
	  this.initUrl = this.url;
	
	  materialButtons.render();
	  materialButtons.processing();
	
	  $scope.initCallback = function () {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.functionSettings = response.functionSettings;
	
	    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
	      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
	        return x.mData === "drgVersion";
	      });
	      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
	      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
	    }
	  });
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") window.location.replace(window.location.origin + "/login");
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[0, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    aoColumns: [{ type: "text" }, { type: "text" }, { type: "text" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn("DRGCode").withTitle("DRG Code").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG Version").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("label").withTitle("DRG Type").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("comments").withTitle("Alert / Notes").withClass("mdl-data-table__cell--non-numeric").withOption("defaultContent", ""), DTColumnBuilder.newColumn("descriptions").withTitle("Speciality").withClass("mdl-data-table__cell--non-numeric").withOption("defaultContent", "")];
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	};
	
	exports.default = TargetdrgsController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(6)))

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _targetdrgs = __webpack_require__(228);
	
	var _targetdrgs2 = _interopRequireDefault(_targetdrgs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetdrgsModule = _angular2.default.module('targetdrgs', [_angularUiRouter2.default]).component('targetdrgs', _targetdrgs2.default);
	
	exports.default = targetdrgsModule;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _totalaudit = __webpack_require__(327);
	
	var _totalaudit2 = _interopRequireDefault(_totalaudit);
	
	var _totalaudit3 = __webpack_require__(232);
	
	var _totalaudit4 = _interopRequireDefault(_totalaudit3);
	
	__webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var totalauditComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _totalaudit2.default,
	  controller: _totalaudit4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = totalauditComponent;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FetchService = function () {
	  function FetchService($http, $rootScope) {
	    _classCallCheck(this, FetchService);
	
	    if ($rootScope.globals) $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(FetchService, [{
	    key: "getCareType",
	    value: function getCareType() {
	      return this.$http.get("" + ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.refcode/query?domain=CARE");
	    }
	  }]);
	
	  return FetchService;
	}();
	
	var TotalauditController = function TotalauditController($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
	  _classCallCheck(this, TotalauditController);
	
	  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Total Audit Summary";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.EOFY = moment("30/06/" + moment().format("YYYY"), "DD/MM/YYYY");
	  this.startFinYear;
	  this.endFinYear;
	  this.startFinYearDisplay;
	  this.endFinYearDisplay;
	
	  if (moment().isAfter($scope.vm.EOFY)) {
	    this.startFinYear = moment().month("July").startOf("month");
	    this.endFinYear = moment().add(1, "year").month("June").endOf("month");
	    // TODO - testing remove
	    // this.startFinYear = moment().month('July').startOf('month').subtract(1, 'year');
	    // this.endFinYear = moment().add(1, 'year').month('June').endOf('month').subtract(1, 'year');
	  } else {
	    this.startFinYear = moment().subtract(1, "year").month("July").startOf("month");
	    this.endFinYear = moment().month("June").endOf("month");
	  }
	
	  this.startFinYearDisplay = this.startFinYear.format("L");
	  this.endFinYearDisplay = this.endFinYear.format("L");
	
	  this.caretypeOptions = [];
	  this.caretype = {
	    selectedCaretype: []
	  };
	  this.allCareTypeOptions = [];
	
	  this.patientclassOptions = [];
	  this.patientclass = {
	    selectedPatientclass: []
	  };
	
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	
	  Constants.getDivisionAndSpecialtyData().then(function (response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty(response.specialties);
	    // Can load divisions if needed??
	  });
	
	  Constants.patientClassificationData().then(function successCallback(response) {
	    $scope.vm.patientclassOptions = response;
	  });
	
	  this.locale = "en-au";
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.totalauditsummary/query?";
	  this.initUrl = this.url + "startDate=" + $scope.vm.startFinYearDisplay + "&endDate=" + $scope.vm.endFinYearDisplay + "&careType=Acute inc Qual Newborn" + "&patientClass=Overseas Non Eligible,Workcover - Acute,Workcover - Non-Acute&specialty=";
	
	  this.dateRange = this.startFinYearDisplay + " - " + this.endFinYearDisplay;
	
	  datePicker.autoClose($scope);
	
	  // callback functions
	  this.selectCallback = selectCallback;
	  this.filterPatientclass = filterPatientclass;
	  this.filterCaretype = filterCaretype;
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.episodeValueDecimalPlaces = $scope.vm.episodeValue === "$" ? 2 : 4;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl,
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true)
	  // .withOption('serverSide', true)
	  .withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("initComplete", $scope.initCallback).withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]).withColumnFilter({
	    //sPlaceHolder: "head:after",
	    aoColumns: [{ type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
	  });
	
	  this.dtColumns = [DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").notVisible(), DTColumnBuilder.newColumn("totalEpisodes").withTitle("Total<br>Episodes").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodesRequireAudit").withTitle("Total Episodes<br>Required for Audit").withOption("width", "5%").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageMeetCriteria").withTitle("Episodes that<br>Meet Criteria (%)").withOption("width", "5%").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodesAudited").withTitle("Total<br>Episodes Audited").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageAudited").withTitle("Total<br>Episodes Audited (%)").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageToBeAudited").withTitle("Episodes<br>to be Audited (%)").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalCodingChange").withTitle("Total Episodes<br>With Coding Changes").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalDRGChange").withTitle("Total Episodes<br>with DRG Change ").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("WIESPerEpisode").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    if (full.totalEpisodes > 0) return parseFloat(data).toFixed($scope.vm.episodeValueDecimalPlaces);
	  }), DTColumnBuilder.newColumn("sumTotalWIESChange").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    if (full.totalEpisodes > 0) return parseFloat(data).toFixed($scope.vm.episodeValueDecimalPlaces);
	  }), DTColumnBuilder.newColumn("totalFinalWies").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    if (full.totalEpisodes > 0) return parseFloat(data).toFixed($scope.vm.episodeValueDecimalPlaces);
	  }), DTColumnBuilder.newColumn("targetWIES").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("WIESDifference").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("WIESDIfferencePercentage").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric")];
	
	  // Search filters
	  this.locale = "en-au";
	  this.startDatePicker = {
	    input: {
	      date: $scope.vm.startFinYear,
	      dateFormatted: $scope.vm.startFinYearDisplay
	    }
	  };
	  this.endDatePicker = {
	    input: {
	      date: $scope.vm.startFinYear,
	      dateFormatted: $scope.vm.endFinYearDisplay
	    }
	  };
	
	  function setDtHeaders(table) {
	    $(table.column(9).header()).html($scope.vm.episodeValue + "<br>Per Episode");
	    $(table.column(10).header()).html("Total<br>" + $scope.vm.episodeValue + " Change");
	    $(table.column(11).header()).html("Total<br>" + $scope.vm.episodeValue);
	    $(table.column(12).header()).html("Target<br>" + $scope.vm.episodeValue);
	    $(table.column(13).header()).html($scope.vm.episodeValue + "<br>difference");
	    $(table.column(14).header()).html($scope.vm.episodeValue + "<br>difference (%)");
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function checkParamCare(param) {
	    var codes = [];
	
	    if (param.length !== 0) {
	      angular.forEach(param, function (value, key) {
	        codes.push(value.code);
	      });
	
	      return encodeURIComponent(codes.join());
	    } else {
	      return "";
	    }
	  }
	
	  this.campusCallback = campusCallback;
	
	  function campusCallback(_newValue, _oldValue) {
	    $scope.reload();
	  }
	
	  this.filterCampus = filterCampus;
	
	  function filterCampus(modifier) {
	    $scope.vm.campus.selectedCampus = [];
	    if (modifier === "add") {
	      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
	    }
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	        break;
	      case "campus":
	        if (thisModifier === "add") {
	          filterCampus("add");
	        } else {
	          filterCampus("minus");
	        }
	        break;
	      default:
	        break;
	    }
	  }
	
	  $scope.reload = function () {
	    if ($scope.vm.datatableApi) {
	      var campus = "";
	      if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	          campus = $scope.vm.user.campus;
	        } else {
	          if ($scope.vm.campus) {
	            campus = $scope.vm.campus.selectedCampus;
	          } else {
	            campus = "";
	          }
	        }
	      } else {
	        if ($scope.vm.campus) {
	          campus = $scope.vm.campus.selectedCampus;
	        } else {
	          campus = "";
	        }
	      }
	      var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&careType=" + checkParamCare($scope.vm.caretype.selectedCaretype) + "&patientClass=" + checkParam($scope.vm.patientclass.selectedPatientclass) + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&campus=" + campus + "";
	
	      // update dates in heading
	      $scope.vm.dateRange = $scope.vm.startDatePicker.input.dateFormatted + " - " + $scope.vm.endDatePicker.input.dateFormatted;
	
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	  };
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search("").draw();
	
	    filterSpecialty("minus");
	
	    // re-draw tabele on datepicker close
	    $scope.$on("lx-date-picker__close-start", function (e, id) {
	      $scope.reload();
	    });
	  }
	
	  $scope.getCareType = function () {
	    new FetchService($http, $scope).getCareType().then(function successCallback(response) {
	      angular.forEach(response.data, function (value, key) {
	        $scope.vm.caretypeOptions.push(value);
	
	        if (value.description === "Acute inc Qual Newborn") $scope.vm.caretype.selectedCaretype.push($scope.vm.caretypeOptions[key]);
	      });
	    }, function errorCallback(response) {
	      // $scope.feedback = "Error loading data";
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + "/login?logout=true");
	      }
	    });
	  };
	
	  $scope.getCareType();
	
	  function selectCallback(_newValue, _oldValue) {
	    $scope.reload();
	  }
	
	  function filterCaretype(swap) {
	    $scope.vm.caretype.selectedCaretype = [];
	
	    if (swap !== "minus") {
	      angular.forEach($scope.vm.caretypeOptions, function (value, key) {
	        $scope.vm.caretype.selectedCaretype.push(value);
	      });
	    }
	  }
	
	  function filterPatientclass(swap) {
	    $scope.vm.patientclass.selectedPatientclass = [];
	
	    if (swap !== "minus") {
	      $scope.vm.patientclass.selectedPatientclass = $scope.vm.patientclassOptions;
	    }
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	};
	
	exports.default = TotalauditController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _totalaudit = __webpack_require__(231);
	
	var _totalaudit2 = _interopRequireDefault(_totalaudit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var totalauditModule = _angular2.default.module('totalaudit', [_angularUiRouter2.default]).component('totalaudit', _totalaudit2.default);
	
	exports.default = totalauditModule;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _unitaudit = __webpack_require__(328);
	
	var _unitaudit2 = _interopRequireDefault(_unitaudit);
	
	var _unitaudit3 = __webpack_require__(235);
	
	var _unitaudit4 = _interopRequireDefault(_unitaudit3);
	
	__webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unitauditComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _unitaudit2.default,
	  controller: _unitaudit4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = unitauditComponent;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FetchService = function () {
	  function FetchService($http, $rootScope) {
	    _classCallCheck(this, FetchService);
	
	    if ($rootScope.globals) $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	    this.$http = $http;
	  }
	
	  _createClass(FetchService, [{
	    key: "getCareType",
	    value: function getCareType() {
	      return this.$http.get("" + ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.refcode/query?domain=CARE");
	    }
	  }]);
	
	  return FetchService;
	}();
	
	var UnitauditController = function UnitauditController($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, CONST, materialButtons, $rootScope, $location, FunctionService) {
	  _classCallCheck(this, UnitauditController);
	
	  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
	  this.datatableApi;
	  this.user = User.getUser();
	  this.name = "Unit Audit Summary";
	  this.episodeValue = "";
	  this.specialtyString = "";
	  this.separationString = "";
	  this.locale = "en-au";
	
	  this.fytdOptions = [];
	  this.fytd = {
	    selectedFytd: undefined
	  };
	
	  this.months = {
	    selectedMonth: undefined
	  };
	  this.monthOptions = {};
	
	  // Search filters
	  this.campus = {
	    selectedCampus: null
	  };
	  this.campusOptions = [];
	  this.specialty = {
	    selectedSpecialty: []
	  };
	  this.specialtyOptions = {};
	  this.caretypeOptions = [];
	  this.caretype = {
	    selectedCaretype: []
	  };
	  this.allCareTypeOptions = [];
	  this.patientclassOptions = [];
	  this.patientclass = {
	    selectedPatientclass: []
	  };
	
	  Constants.getDivisionAndSpecialtyData().then(function (response) {
	    $scope.vm.specialtyOptions = response.specialties;
	    filterSpecialty(response.specialties);
	    // Can load divisions if needed??
	  });
	
	  Constants.patientClassificationData().then(function successCallback(response) {
	    $scope.vm.patientclassOptions = response;
	  });
	
	  // callbacks for lx-selects and lx-date-picker
	  this.specialtyCallback = specialtyCallback;
	  this.campusCallback = campusCallback;
	  this.monthCallback = monthCallback;
	  this.yearCallback = yearCallback;
	  this.caretypeCallback = caretypeCallback;
	  this.patientclassCallback = patientclassCallback;
	  this.filterPatientclass = filterPatientclass;
	  this.filterCaretype = filterCaretype;
	
	  this.currentYear = moment().format("YYYY");
	  this.startMonthMoment = moment("01/01/" + $scope.vm.currentYear, "DD/MMMM/YYYY").startOf("month").format("L");
	  this.endMonthMoment = moment("31/01/" + $scope.vm.currentYear, "DD/MMMM/YYYY").endOf("month").format("L");
	  this.url = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.unitauditsummary/query?";
	  this.initUrl = this.url;
	  this.EOFY = moment("31/12/" + $scope.vm.currentYear, "DD/MM/YYYY");
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	    $scope.vm.episodeValueDecimalPlaces = $scope.vm.episodeValue === '$' ? 2 : 4;
	    $scope.vm.functionSettings = response.functionSettings;
	
	    Constants.campusData().then(function successCallback(response) {
	      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        var campusOptions = [];
	        if (typeof $scope.vm.user.campus === "string") {
	          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
	        } else {
	          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
	        }
	        $scope.vm.campusOptions = campusOptions;
	        $scope.vm.campus.selectedCampus = campusOptions;
	      } else {
	        $scope.vm.campusOptions = response;
	      }
	    });
	
	    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
	  });
	
	  materialButtons.render();
	
	  materialButtons.processing();
	
	  function initFYTD() {
	    if (moment().month() < 6) {
	      var year = moment().format("YYYY");
	    } else {
	      var year = moment().add(1, "year").format("YYYY");
	    }
	
	    for (var i = 0; i < 10; i++) {
	      $scope.vm.fytdOptions.push(year - 1 + " - " + year);
	      year--;
	    }
	
	    // Default to current financial year
	    $scope.vm.fytd.selectedFytd = $scope.vm.fytdOptions[0];
	  }
	
	  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	    // Datatables has finished init
	    // Initialise searching
	    if ($scope.vm.datatableApi) return;
	
	    $scope.vm.datatableApi = this.api();
	
	    // Update column headers even when no data returned
	    setDtHeaders($scope.vm.datatableApi);
	
	    // setup search filters
	    search();
	
	    // make sure DataTables doesn't sort month names alphabetically
	    $.fn.dataTable.moment("MMMM");
	
	    // set the table to a fixed height, so it never collapsed up and down
	    $("#auditTable").closest(".dataTables_scrollBody").height(300);
	  };
	
	  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
	    headers: {
	      Authorization: "Bearer " + $rootScope.globals.currentUser.token
	    },
	    url: $scope.vm.initUrl + "startDate=" + $scope.vm.startMonthMoment + "&endDate=" + $scope.vm.endMonthMoment + "&careType=" + checkParamCare($scope.vm.caretype.selectedCaretype) + "&patientClass=" + checkParam($scope.vm.patientclass.selectedPatientclass) + "",
	    type: "GET",
	    error: function error(xhr, _error, thrown) {
	      if (thrown == "Unauthorized") {
	        //window.location.replace(window.location.origin + '/login');
	        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
	      }
	    }
	  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true)
	  // .withOption('serverSide', true)
	  .withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
	    // Update column headers if data returned
	    setDtHeaders($("#auditTable").DataTable());
	  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
	    extend: "print",
	    text: ""
	  }, {
	    extend: "csvHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    extend: "excelHtml5",
	    text: "",
	    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
	  }, {
	    text: "",
	    action: function action(e, dt, node, config) {
	      dt.ajax.reload();
	    }
	  }]);
	
	  this.dtColumns = [DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeMonth").withTitle("Loading...").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodes").withTitle("Total Number<br>of Episodes").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodesRequireAudit").withTitle("Total<br>Require Auditing").withOption("width", "5%").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalEpisodesAudited").withTitle("Total<br>Episodes Audited").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageAudited").withTitle("Total<br>Episodes Audited (%)").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed(2);
	  }), DTColumnBuilder.newColumn("episodesToBeAudited").withTitle("Episodes<br>to be Audited").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("percentageToBeAudited").withTitle("Episodes<br>to be Audited (%)").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed(2);
	  }), DTColumnBuilder.newColumn("totalCodingChange").withTitle("Total<br>Coding Changes").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalDRGChange").withTitle("Total<br>DRG Change").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("totalQueryGenerated").withTitle("Total<br>Query Generated").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("sumTotalWIESChange").withTitle("Loading...").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
	    return parseFloat(data).toFixed($scope.vm.episodeValueDecimalPlaces);
	  }), DTColumnBuilder.newColumn("monthStatus").withTitle("Status of<br>Audit Month").withOption("defaultContent", "0").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric")];
	
	  function setDtHeaders(table) {
	    $(table.column(0).header()).html($scope.vm.specialtyString);
	    $(table.column(1).header()).html($scope.vm.separationString + "<br>Month");
	    $(table.column(11).header()).html("Total<br>" + $scope.vm.episodeValue + " Change");
	  }
	
	  function checkParam(param) {
	    if (param.length !== 0) {
	      return encodeURIComponent(param.join());
	    } else {
	      return "";
	    }
	  }
	
	  function checkParamCare(param) {
	    var codes = [];
	
	    if (param.length !== 0) {
	      angular.forEach(param, function (value, key) {
	        codes.push(value.code);
	      });
	
	      return encodeURIComponent(codes.join());
	    } else {
	      return "";
	    }
	  }
	
	  function selectFilter(column, filter) {
	    if (typeof filter === "string") filter = ["" + filter + ""];
	
	    if (column === 1 && typeof filter === "undefined") filter = [""];
	
	    if (filter) {
	      // convert array to datatables permissable regex string
	      filter = filter.join("|");
	
	      var auditTable = $scope.vm.datatableApi;
	
	      auditTable.columns(column).search(filter, true, false).draw();
	    }
	  }
	
	  $scope.reload = function () {
	    if ($scope.vm.datatableApi) {
	      var campus = "";
	      if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
	        if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
	          campus = $scope.vm.user.campus;
	        } else {
	          campus = $scope.vm.campus.selectedCampus;
	        }
	      } else {
	        campus = $scope.vm.campus.selectedCampus;
	      }
	      var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startMonthDisplay + "&endDate=" + $scope.vm.endMonthDisplay + "&careType=" + checkParamCare($scope.vm.caretype.selectedCaretype) + "&patientClass=" + checkParam($scope.vm.patientclass.selectedPatientclass) + "&campus=" + campus + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "";
	      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
	    }
	  };
	
	  function campusCallback(_newValue, _oldValue) {
	    $scope.reload();
	  }
	
	  function specialtyCallback(_newValue, _oldValue) {
	    $scope.reload();
	  }
	
	  function yearCallback(_newValue, _oldValue) {
	    var year = _newValue.substring(7, 11),
	        year2 = _newValue.substring(0, 4),
	        month = moment($scope.vm.startMonthMoment, "DD/MM/YYYY").format("MM"),
	        startMonthMoment = moment("01/" + month + "/" + year, "DD/MM/YYYY"),
	        startMonthDisplay,
	        endMonthDisplay;
	
	    // console.log(year2);
	
	    $scope.vm.EOFY = moment("31/12/" + year2, "DD/MM/YYYY");
	
	    // if month is after EOFY, we need to look at data from last year
	    if (month > 6) {
	      $scope.vm.startMonthDisplay = startMonthMoment.clone().subtract(1, "y").startOf("month").format("L");
	      $scope.vm.endMonthDisplay = startMonthMoment.clone().subtract(1, "y").endOf("month").format("L");
	    } else {
	      $scope.vm.startMonthDisplay = startMonthMoment.clone().startOf("month").format("L");
	      $scope.vm.endMonthDisplay = startMonthMoment.clone().endOf("month").format("L");
	    }
	
	    // All Months
	    if ($scope.vm.months.selectedMonth === "All Months") {
	      $scope.vm.startMonthDisplay = moment("01/07/" + (year - 1), "DD/MM/YYYY").format("L");
	      $scope.vm.endMonthDisplay = moment("30/06/" + year, "DD/MM/YYYY").format("L");
	    }
	
	    $scope.reload();
	  }
	
	  function monthCallback(_newValue, _oldValue) {
	    var year = $scope.vm.fytd.selectedFytd.substring(7, 11),
	        month = moment("01/" + _newValue + "/" + year, "DD/MMMM/YYYY").format("MM"),
	        startMonthMoment = moment("01/" + month + "/" + year, "DD/MM/YYYY").startOf("month"),
	        endMonthMoment = moment("01/" + month + "/" + year, "DD/MM/YYYY").endOf("month"),
	        startMonthDisplay,
	        endMonthDisplay;
	
	    $scope.vm.startMonthMoment = startMonthMoment.clone();
	
	    // if month is before EOFY, we need to look at data from last year
	    if (month > 6) {
	      $scope.vm.startMonthDisplay = startMonthMoment.subtract(1, "y").format("L");
	      $scope.vm.endMonthDisplay = endMonthMoment.subtract(1, "y").format("L");
	    } else {
	      $scope.vm.startMonthDisplay = startMonthMoment.format("L");
	      $scope.vm.endMonthDisplay = endMonthMoment.format("L");
	    }
	
	    // All Months
	    if (_newValue === "All Months") {
	      $scope.vm.startMonthDisplay = moment("01/07/" + (year - 1), "DD/MM/YYYY").format("L");
	      $scope.vm.endMonthDisplay = moment("30/06/" + year, "DD/MM/YYYY").format("L");
	    }
	
	    $scope.reload();
	  }
	
	  function filterSpecialty(swap) {
	    $scope.vm.specialty.selectedSpecialty = [];
	    if (swap === "add") {
	      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
	    }
	  }
	
	  function filterMonth() {
	    var months = moment.months(),
	        thisMonth = moment().format("MM"),
	        year;
	
	    $scope.vm.monthOptions = months;
	    $scope.vm.monthOptions.unshift("All Months");
	    $scope.vm.months.selectedMonth = $scope.vm.monthOptions[thisMonth - 1];
	
	    if (moment().startOf("month").isAfter($scope.vm.EOFY)) {
	      year = moment().format("YYYY");
	    } else {
	      year = moment().add(1, "year").format("YYYY");
	    }
	
	    $scope.vm.startMonthMoment = moment("01/" + thisMonth + "/" + year, "DD/MM/YYYY").startOf("month");
	  }
	
	  function search() {
	    // delete any global searches previously applied
	    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();
	
	    var auditTable = $scope.vm.datatableApi;
	    var clearAuditTable = auditTable.search("").draw();
	
	    filterSpecialty("minus");
	
	    filterMonth();
	    initFYTD();
	
	    // Trigger filtering
	    $(".reports__filters").find("div").first().find("div:last-child").click();
	  }
	
	  $scope.getCareType = function () {
	    new FetchService($http, $scope).getCareType().then(function successCallback(response) {
	      angular.forEach(response.data, function (value, key) {
	        $scope.vm.caretypeOptions.push(value);
	
	        if (value.description === "Acute inc Qual Newborn") $scope.vm.caretype.selectedCaretype.push($scope.vm.caretypeOptions[key]);
	      });
	    }, function errorCallback(response) {
	      // $scope.feedback = "Error loading data";
	      if (response.status === 401) {
	        window.location.replace(window.location.origin + "/login?logout=true");
	      }
	    });
	  };
	
	  $scope.getCareType();
	
	  function caretypeCallback(_newValue, _oldValue) {
	    $scope.reload();
	  }
	
	  function patientclassCallback(_newValue, _oldValue) {
	    $scope.reload();
	  }
	
	  function filterCaretype(swap) {
	    $scope.vm.caretype.selectedCaretype = [];
	
	    if (swap !== "minus") {
	      angular.forEach($scope.vm.caretypeOptions, function (value, key) {
	        $scope.vm.caretype.selectedCaretype.push(value);
	      });
	    }
	  }
	
	  function filterPatientclass(swap) {
	    $scope.vm.patientclass.selectedPatientclass = [];
	
	    if (swap !== "minus") {
	      $scope.vm.patientclass.selectedPatientclass = $scope.vm.patientclassOptions;
	    }
	  }
	
	  // bind the datatable instance to an object to monitor loading
	  this.dtInstanceCallback = dtInstanceCallback;
	
	  function dtInstanceCallback(dtInstance) {
	    $scope.dtInstance = dtInstance._renderer;
	  }
	
	  // bind filter swap
	  this.filterSwap = filterSwap;
	
	  function filterSwap(thisFilter, thisModifier) {
	    switch (thisFilter) {
	      case "specialty":
	        if (thisModifier === "add") {
	          filterSpecialty("add");
	        } else {
	          filterSpecialty("minus");
	        }
	        break;
	      default:
	        break;
	    }
	  }
	};
	
	exports.default = UnitauditController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(1)))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _unitaudit = __webpack_require__(234);
	
	var _unitaudit2 = _interopRequireDefault(_unitaudit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unitauditModule = _angular2.default.module('unitaudit', [_angularUiRouter2.default]).component('unitaudit', _unitaudit2.default);
	
	exports.default = unitauditModule;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ActivityTypeService = function ActivityTypeService($http, $rootScope) {
	
	    var activityTypeArray = [];
	
	    /**
	     * Get a list of activity types for select lists
	     */
	
	    var data = function data() {
	        if (activityTypeArray.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            activityTypeArray = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.activity/selectlist').then(function (response) {
	                return response.data;
	            });
	        }
	
	        return activityTypeArray;
	    };
	
	    return { data: data };
	};
	
	exports.default = ActivityTypeService;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var AuditRuleService = function AuditRuleService($http, $q, $rootScope, $sanitize) {
	
	    var ruleArray = [];
	
	    /**
	     * Get the list of rules
	     */
	
	    var data = function data() {
	        var deferred = $q.defer();
	        if (ruleArray.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.ruleconfig').then(function successCallback(response) {
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedName = $sanitize(value['name']);
	                    if (sterilizedName && ruleArray.indexOf(sterilizedName) === -1) {
	                        ruleArray.push({ ruleId: value['ruleId'], name: sterilizedName, auditTypeId: value.auditTypeId });
	                    }
	                });
	                deferred.resolve(ruleArray);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(ruleArray);
	        }
	        return deferred.promise;
	    };
	
	    return { data: data };
	};
	
	exports.default = AuditRuleService;

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BuildNumber = function BuildNumber() {
	  return 'Sprint 16 Nov 2022';
	};exports.default = BuildNumber;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CareTypeService = function CareTypeService($http, $rootScope) {
	
	    var careTypeArray = [];
	
	    /**
	     * Get the list of care types
	     */
	
	    var data = function data() {
	        if (careTypeArray.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            careTypeArray = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/query?domain=CARE').then(function (response) {
	                return response.data;
	            });
	        }
	
	        return careTypeArray;
	    };
	
	    return { data: data };
	};
	
	exports.default = CareTypeService;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ChangeCategoryService = function ChangeCategoryService($http) {
	
	    var changeCategoryArray = [];
	
	    /**
	     * Get the list of care types
	     */
	
	    var data = function data() {
	        if (changeCategoryArray.length === 0) {
	            changeCategoryArray = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.changecategory/').then(function (response) {
	                return response.data;
	            });
	        }
	
	        return changeCategoryArray;
	    };
	
	    return { data: data };
	};
	
	exports.default = ChangeCategoryService;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CoderService = function CoderService($http, $q, $rootScope, $sanitize, $location) {
	
	    var coderArray = [];
	
	    /**
	     * Get the list of coders
	     */
	
	    var data = function data() {
	        var deferred = $q.defer();
	        if (!coderArray.Promise) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            coderArray = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.person/allusers').then(function successCallback(response) {
	                var names = [];
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedFn = $sanitize(value['firstname']);
	                    var sterilizedLn = $sanitize(value['lastname']);
	                    if (sterilizedFn && sterilizedLn) {
	                        names.push({ id: value['id'], name: sterilizedFn + ' ' + sterilizedLn });
	                    }
	                });
	                coderArray = names;
	                deferred.resolve(names);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(coderArray);
	        }
	        return deferred.promise;
	    };
	
	    return { data: data };
	};
	
	exports.default = CoderService;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ConstantsService = function ConstantsService($filter, $http, $q, $rootScope, $sanitize) {
	    var CAMPUS = [];
	    var CODERS = [];
	    var CODINGSTANDARDS = [];
	    var DIVSANDSPECS = {};
	    var HEALTHCAREFUND = [];
	    var PATIENTCLASSIFICATION = [];
	    var QUERYTEMPLATE = {};
	    var lookups = { atsi: [], los: [], worklists: [] };
	
	    /**
	     * Get the query template names with their IDs
	     */
	    var getQueryTemplateData = function getQueryTemplateData() {
	        var deferred = $q.defer();
	        if (!QUERYTEMPLATE.queryTemplateId) {
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.querytemplate').then(function successCallback(response) {
	                QUERYTEMPLATE = $filter('orderBy')(response.data, 'queryTemplateName');
	                deferred.resolve(QUERYTEMPLATE);
	            }, function errorCallback(response) {});
	        } else {
	            deferred.resolve(QUERYTEMPLATE);
	        }
	        return deferred.promise;
	    };
	
	    /**
	     * Get the list of campuses
	     */
	    var campusData = function campusData() {
	        var deferred = $q.defer();
	        if (CAMPUS.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodeaudit/campus').then(function successCallback(response) {
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedCampus = $sanitize(value['campus']).replace(/&amp;/g, '&');
	                    if (sterilizedCampus && CAMPUS.indexOf(sterilizedCampus) === -1) {
	                        CAMPUS.push(sterilizedCampus);
	                    }
	                });
	                deferred.resolve(CAMPUS);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(CAMPUS);
	        }
	        return deferred.promise;
	    };
	
	    /**
	     * Get the list of coders
	     */
	    var coderData = function coderData() {
	        var deferred = $q.defer();
	        if (CODERS.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/query?domain=CODER').then(function successCallback(response) {
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedDescription = $sanitize(value['description']).replace(/&amp;/g, '&');
	                    if (sterilizedDescription && CODERS.indexOf(sterilizedDescription) === -1) {
	                        CODERS.push(sterilizedDescription);
	                    }
	                });
	                deferred.resolve(CODERS);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(CODERS);
	        }
	        return deferred.promise;
	    };
	
	    /**
	     * Combined function to fetch and populate the divisions and specialties
	     */
	    var getDivisionAndSpecialtyData = function getDivisionAndSpecialtyData() {
	        var deferred = $q.defer();
	        if (!DIVSANDSPECS.specialties) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/query?domain=SPECIAL').then(function successCallback(response) {
	                var divisionsAndSpecialties = { divisions: [], specialties: [] };
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedGroupName = $sanitize(value['groupName']).replace(/&amp;/g, '&');
	                    if (sterilizedGroupName && divisionsAndSpecialties.divisions.indexOf(sterilizedGroupName) === -1) {
	                        divisionsAndSpecialties.divisions.push(sterilizedGroupName);
	                    }
	                    // angular-sanitize is causing the HTML representation of ampersands to be passed to
	                    // encodeURIComponent(), which is breaking select lists. Maybe we can just sanitise
	                    // before saving to the DB and trust what we pull out of it, but Mike's on holidays,
	                    // so replace() is my solution for now.
	                    var sterilizedDescription = $sanitize(value['description']).replace(/&amp;/g, '&');
	                    if (sterilizedDescription && divisionsAndSpecialties.specialties.indexOf(sterilizedDescription) === -1) {
	                        divisionsAndSpecialties.specialties.push(sterilizedDescription);
	                    }
	                });
	                DIVSANDSPECS = divisionsAndSpecialties;
	                deferred.resolve(DIVSANDSPECS);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(DIVSANDSPECS);
	        }
	        return deferred.promise;
	    };
	
	    /**
	     * Get the list of health care funds
	     */
	    var healthCareFundData = function healthCareFundData() {
	        var deferred = $q.defer();
	        if (HEALTHCAREFUND.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.columntabledistinctvaluelookup/healthcarefunds').then(function successCallback(response) {
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedHcf = $sanitize(value['healthCareFund']).replace(/&amp;/g, '&');
	                    if (sterilizedHcf && HEALTHCAREFUND.indexOf(sterilizedHcf) === -1 && typeof value.healthCareFund !== 'undefined' && value.healthCareFund !== 'undefined') {
	                        HEALTHCAREFUND.push(sterilizedHcf);
	                    }
	                });
	                deferred.resolve(HEALTHCAREFUND);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(HEALTHCAREFUND);
	        }
	        return deferred.promise;
	    };
	
	    /**
	     * Get the list of patient classifications
	     */
	    var patientClassificationData = function patientClassificationData() {
	        var deferred = $q.defer();
	        if (PATIENTCLASSIFICATION.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.columntabledistinctvaluelookup/patientclassifications').then(function successCallback(response) {
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedPc = $sanitize(value['patientClassification']).replace(/&amp;/g, '&');
	                    if (sterilizedPc && PATIENTCLASSIFICATION.indexOf(sterilizedPc) === -1) {
	                        PATIENTCLASSIFICATION.push(sterilizedPc);
	                    }
	                });
	                deferred.resolve(PATIENTCLASSIFICATION);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(PATIENTCLASSIFICATION);
	        }
	        return deferred.promise;
	    };
	
	    /**
	     * Get the list of coding standards
	     */
	    var codingStandardsData = function codingStandardsData() {
	        var deferred = $q.defer();
	        if (CODINGSTANDARDS.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.refcode/query?domain=CODINGSTANDARDS').then(function successCallback(response) {
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedDescription = $sanitize(value['description']).replace(/&amp;/g, '&');
	                    if (CODINGSTANDARDS.indexOf(sterilizedDescription) === -1) {
	                        CODINGSTANDARDS.push(sterilizedDescription);
	                    }
	                });
	                deferred.resolve(CODINGSTANDARDS);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(CODINGSTANDARDS);
	        }
	        return deferred.promise;
	    };
	
	    /**
	     * Get the list of lookups via it's refCodeDomain
	     */
	    var lookupsData = function lookupsData(userId, refCode) {
	        var deferred = $q.defer();
	        if (lookups[refCode].length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodeauditlookupvalues/userId/' + userId + '/getLookups?' + refCode + '=true').then(function successCallback(response) {
	                lookups[refCode] = response.data[refCode];
	                deferred.resolve(lookups[refCode]);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(lookups[refCode]);
	        }
	        return deferred.promise;
	    };
	
	    return { campusData: campusData, coderData: coderData, getDivisionAndSpecialtyData: getDivisionAndSpecialtyData, healthCareFundData: healthCareFundData, lookupsData: lookupsData,
	        patientClassificationData: patientClassificationData, codingStandardsData: codingStandardsData, getQueryTemplateData: getQueryTemplateData };
	};
	
	exports.default = ConstantsService;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DateFormatterService = function DateFormatterService() {
	
	    /**
	    * Convert a number to HH:MM:SS string format
	    */
	    var toHHMMSS = function toHHMMSS(num) {
	        var sec_num = parseInt(num * 3600, 10); // don't forget the second param
	        var hours = Math.floor(sec_num / 3600);
	        var minutes = Math.floor((sec_num - hours * 3600) / 60);
	        var seconds = sec_num - hours * 3600 - minutes * 60;
	
	        if (hours < 10) {
	            hours = "0" + hours;
	        }
	        if (minutes < 10) {
	            minutes = "0" + minutes;
	        }
	        if (seconds < 10) {
	            seconds = "0" + seconds;
	        }
	        return hours + ':' + minutes + ':' + seconds;
	    };
	
	    /**
	    * Convert a number to HH:MM:SS string format
	    */
	
	    var fromHHMMSSToNumber = function fromHHMMSSToNumber(timeString) {
	        var a = timeString;
	        if (timeString.lastIndexOf('\+') > -1) {
	            a = timeString.substr(0, timeString.lastIndexOf('\+')); // discard timezone offset
	        }
	        a = a.toString().split(":"); // split it at the colons
	        var hours = +a[0] + +a[1] / 60 + +a[2] / 3600 ? +a[0] + +a[1] / 60 + +a[2] / 3600 : 0;
	        return parseFloat(hours.toFixed(2));
	    };
	
	    return { toHHMMSS: toHHMMSS, fromHHMMSSToNumber: fromHHMMSSToNumber };
	};
	
	exports.default = DateFormatterService;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var EpisodeDrgAuditTypeService = function EpisodeDrgAuditTypeService($http, $q, $rootScope) {
	
	    var auditTypeOptions = {};
	
	    var types = function types() {
	        var deferred = $q.defer();
	        if (!auditTypeOptions.Promise) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            auditTypeOptions = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.drgaudittype').then(function successCallback(response) {
	                auditTypeOptions = response.data;
	                deferred.resolve(auditTypeOptions);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(auditTypeOptions);
	        }
	        return deferred.promise;
	    };
	
	    return { types: types };
	};
	
	exports.default = EpisodeDrgAuditTypeService;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var FunctionService = function FunctionService($http, $q, $rootScope) {
	    var FUNCTIONS = [];
	    var FUNCTIONSETTINGS = {};
	    var FUNCTIONSCONFIG = {};
	
	    /**
	     * Get the list of functionality for the application for the current user as per their role
	     */
	    var getFunctions = function getFunctions(roleId) {
	        var deferred = $q.defer();
	        if (roleId == undefined || !roleId) {
	            window.location.replace(window.location.origin + '/login');
	            deferred.resolve(FUNCTIONS);
	        } else {
	            if (FUNCTIONS.length === 0) {
	                $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	                $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.function/' + roleId).then(function successCallback(response) {
	                    if (FUNCTIONS.length === 0) {
	                        for (var i = 0; i < response.data.length; i++) {
	                            if (FUNCTIONS.indexOf(response.data[i]) === -1) {
	                                FUNCTIONS.push(response.data[i]);
	                                FUNCTIONSETTINGS[response.data[i].name.replace(/ /g, '')] = response.data[i];
	                            }
	                        }
	                        FUNCTIONSCONFIG = { functionSettings: FUNCTIONSETTINGS, functions: FUNCTIONS };
	                    }
	                    deferred.resolve(FUNCTIONSCONFIG);
	                    $rootScope.$emit('functions-fetched-event', FUNCTIONSCONFIG);
	                }, function errorCallback(response) {
	                    if (response.status === 401) {
	                        window.location.replace(window.location.origin + '/login?logout=true');
	                    }
	                });
	            } else {
	                deferred.resolve(FUNCTIONSCONFIG);
	            }
	        }
	        return deferred.promise;
	    };
	
	    var resetFunctions = function resetFunctions() {
	        var deferred = $q.defer();
	        FUNCTIONS = [];
	        FUNCTIONSETTINGS = {};
	        FUNCTIONSCONFIG = {};
	        deferred.resolve(FUNCTIONSCONFIG);
	        return deferred.promise;
	    };
	
	    return {
	        getFunctions: getFunctions,
	        // See https://www.codelord.net/2015/05/04/angularjs-notifying-about-changes-from-services-to-controllers/
	        subscribe: function subscribe(scope, callback) {
	            var handler = $rootScope.$on('functions-fetched-event', callback);
	            scope.$on('$destroy', handler);
	        },
	        resetFunctions: resetFunctions,
	        FUNCTIONSCONFIG: FUNCTIONSCONFIG
	    };
	};
	
	exports.default = FunctionService;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ModalService = function ModalService($http, $q, $rootScope) {
	    var INCDOCTYPES = [];
	    var LastEpisodeIncDocs = [];
	    var MODALSSCONFIG = { INCDOCTYPES: [] };
	
	    /**
	     * Get the list of incdoc types
	     */
	    var getIncDocTypes = function getIncDocTypes() {
	        var deferred = $q.defer();
	        if (INCDOCTYPES.length === 0) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.toggleselectiontype').then(function successCallback(response) {
	                if (INCDOCTYPES.length === 0) {
	                    for (var i = 0; i < response.data.length; i++) {
	                        if (INCDOCTYPES.indexOf(response.data[i]) === -1) {
	                            INCDOCTYPES.push(response.data[i]);
	                        }
	                    }
	                    MODALSSCONFIG.INCDOCTYPES = INCDOCTYPES;
	                }
	                deferred.resolve(MODALSSCONFIG);
	                $rootScope.$emit('incDocTypes-fetched-event', MODALSSCONFIG);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(MODALSSCONFIG);
	        }
	        return deferred.promise;
	    };
	
	    /**
	     * Get the list of episode toggle selections
	     */
	    var getEpisodeIncDocs = function getEpisodeIncDocs(episodeAuditId) {
	        LastEpisodeIncDocs = [];
	        var deferred = $q.defer();
	        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	        $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodetoggleselection/' + episodeAuditId + '/getIncDocsForEpisode').then(function successCallback(response) {
	            for (var i = 0; i < response.data.length; i++) {
	                if (LastEpisodeIncDocs.indexOf(response.data[i]) === -1) {
	                    LastEpisodeIncDocs.push(response.data[i]);
	                }
	            }
	            deferred.resolve(LastEpisodeIncDocs);
	            $rootScope.$emit('incDocTypes-fetched-event', LastEpisodeIncDocs);
	        }, function errorCallback(response) {
	            if (response.status === 401) {
	                window.location.replace(window.location.origin + '/login?logout=true');
	            }
	        });
	        return deferred.promise;
	    };
	
	    /**
	     * Update the list of incdoc types
	     */
	    var updateEpisodeIncDocs = function updateEpisodeIncDocs(episodeAuditId, userId, episodeIncDocs) {
	        LastEpisodeIncDocs = [];
	        var deferred = $q.defer();
	        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	        $http.post(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.episodetoggleselection/' + episodeAuditId + '/user/' + userId + '/updateIncDocsForEpisode', episodeIncDocs).then(function successCallback(response) {
	            for (var i = 0; i < response.data.length; i++) {
	                if (LastEpisodeIncDocs.indexOf(response.data[i]) === -1) {
	                    LastEpisodeIncDocs.push(response.data[i]);
	                }
	            }
	            deferred.resolve(LastEpisodeIncDocs);
	            $rootScope.$emit('incDocTypes-fetched-event', LastEpisodeIncDocs);
	        }, function errorCallback(response) {
	            if (response.status === 401) {
	                window.location.replace(window.location.origin + '/login?logout=true');
	            }
	        });
	        return deferred.promise;
	    };
	
	    return {
	        getEpisodeIncDocs: getEpisodeIncDocs,
	        getIncDocTypes: getIncDocTypes,
	        MODALSSCONFIG: MODALSSCONFIG,
	        updateEpisodeIncDocs: updateEpisodeIncDocs
	    };
	};
	
	exports.default = ModalService;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var QueryDetailsService = function QueryDetailsService($http, $q, $rootScope) {
	
	    var queryTypeOptions = {};
	
	    var types = function types() {
	        var deferred = $q.defer();
	        if (!queryTypeOptions.Promise) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            queryTypeOptions = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.queryaudittype/parentChild').then(function successCallback(response) {
	                queryTypeOptions = response.data;
	                deferred.resolve(queryTypeOptions);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(queryTypeOptions);
	        }
	        return deferred.promise;
	    };
	
	    return { types: types };
	};
	
	exports.default = QueryDetailsService;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var QueryTypeOptionService = function QueryTypeOptionService($http, $q, $rootScope, $sanitize, $location) {
	
	    var queryTypeOptions = [];
	    var queryCategoryOptions = [];
	    var querySubjectOptions = [];
	    var queryStatuses = [];
	    var queryReasons = [];
	
	    var categories = function categories() {
	        var deferred = $q.defer();
	        if (!queryCategoryOptions.Promise) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            queryCategoryOptions = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.querycategory').then(function successCallback(response) {
	                var options = [];
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedName = $sanitize(value['name']);
	                    if (sterilizedName) {
	                        options.push({ id: value['queryCategoryId'], value: sterilizedName });
	                    }
	                });
	                queryCategoryOptions = options;
	                deferred.resolve(options);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(queryCategoryOptions);
	        }
	        return deferred.promise;
	    };
	
	    var reasons = function reasons() {
	        var deferred = $q.defer();
	        if (!queryReasons.Promise) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            queryReasons = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.queryreason').then(function successCallback(response) {
	                var options = [];
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedName = $sanitize(value['name']);
	                    if (sterilizedName) {
	                        options.push({ id: value['queryReasonId'], value: sterilizedName });
	                    }
	                });
	                queryReasons = options;
	                deferred.resolve(options);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(queryReasons);
	        }
	        return deferred.promise;
	    };
	
	    var types = function types(queryAuditTypeTableUrl) {
	        var deferred = $q.defer();
	        if (!queryTypeOptions.Promise && !queryTypeOptions.length) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            queryTypeOptions = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.' + queryAuditTypeTableUrl) // wchn: queryaudittype/base, alfred endpoint: drgaudittype
	            .then(function successCallback(response) {
	                var options = [];
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedName = $sanitize(value['name']);
	                    if (sterilizedName) {
	                        options.push({ name: sterilizedName, id: value['queryAuditTypeId'] });
	                    }
	                });
	                queryTypeOptions = options;
	                deferred.resolve(options);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(queryTypeOptions);
	        }
	        return deferred.promise;
	    };
	
	    var subjects = function subjects() {
	        var deferred = $q.defer();
	        if (!querySubjectOptions.Promise) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            querySubjectOptions = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.querysubject').then(function successCallback(response) {
	                var options = [];
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedName = $sanitize(value['name']);
	                    if (sterilizedName && options.indexOf(sterilizedName) === -1) {
	                        options.push(sterilizedName);
	                    }
	                });
	                querySubjectOptions = options;
	                deferred.resolve(options);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(querySubjectOptions);
	        }
	        return deferred.promise;
	    };
	
	    var statuses = function statuses() {
	        var deferred = $q.defer();
	        if (!queryStatuses.Promise) {
	            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
	            queryStatuses = $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.querystatus').then(function successCallback(response) {
	                var options = [];
	                angular.forEach(response.data, function (value, key) {
	                    var sterilizedName = $sanitize(value['name']);
	                    if (sterilizedName && value['isActive']) {
	                        options.push({ name: sterilizedName, id: value['queryStatusId'] });
	                    }
	                });
	                queryStatuses = options;
	                deferred.resolve(options);
	            }, function errorCallback(response) {
	                if (response.status === 401) {
	                    window.location.replace(window.location.origin + '/login?logout=true');
	                }
	            });
	        } else {
	            deferred.resolve(queryStatuses);
	        }
	        return deferred.promise;
	    };
	
	    return { types: types, categories: categories, subjects: subjects, statuses: statuses, reasons: reasons };
	};
	
	exports.default = QueryTypeOptionService;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _activityType = __webpack_require__(237);
	
	var _activityType2 = _interopRequireDefault(_activityType);
	
	var _buildNumber = __webpack_require__(239);
	
	var _buildNumber2 = _interopRequireDefault(_buildNumber);
	
	var _careType = __webpack_require__(240);
	
	var _careType2 = _interopRequireDefault(_careType);
	
	var _changeCategory = __webpack_require__(241);
	
	var _changeCategory2 = _interopRequireDefault(_changeCategory);
	
	var _coder = __webpack_require__(242);
	
	var _coder2 = _interopRequireDefault(_coder);
	
	var _constant = __webpack_require__(243);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _dateFormatter = __webpack_require__(244);
	
	var _dateFormatter2 = _interopRequireDefault(_dateFormatter);
	
	var _function = __webpack_require__(246);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _queryModalOption = __webpack_require__(249);
	
	var _queryModalOption2 = _interopRequireDefault(_queryModalOption);
	
	var _queryDetails = __webpack_require__(248);
	
	var _queryDetails2 = _interopRequireDefault(_queryDetails);
	
	var _auditRule = __webpack_require__(238);
	
	var _auditRule2 = _interopRequireDefault(_auditRule);
	
	var _episodeDrgAuditType = __webpack_require__(245);
	
	var _episodeDrgAuditType2 = _interopRequireDefault(_episodeDrgAuditType);
	
	var _v = __webpack_require__(251);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _modal = __webpack_require__(247);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _version = __webpack_require__(252);
	
	var _version2 = _interopRequireDefault(_version);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var servicesModule = _angular2.default.module('services', [])
	
	// Register new services here
	.factory('ActivityType', _activityType2.default).factory('BuildNumber', _buildNumber2.default).factory('CareType', _careType2.default).factory('ChangeCategory', _changeCategory2.default).factory('CoderService', _coder2.default).factory('Constants', _constant2.default).factory('DateFormatter', _dateFormatter2.default).factory('QueryDetails', _queryDetails2.default).factory('FunctionService', _function2.default).factory('QueryModalOptions', _queryModalOption2.default).factory('EpisodeDrgAuditTypeService', _episodeDrgAuditType2.default).factory('V2Service', _v2.default).factory('AuditRuleService', _auditRule2.default).factory('ModalService', _modal2.default).factory('VersionService', _version2.default);
	
	exports.default = servicesModule;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var V2Service = function V2Service($cookieStore, $rootScope) {
	
	    var redirectToV2 = function redirectToV2(roleId) {
	        $rootScope.globals.currentUser.roleId = roleId;
	        var stringCookie = 'globals=' + JSON.stringify($rootScope.globals) + '; path=/' + ("v2") + '/;';
	        // Delete V2 cookie by setting the expiry date in the past
	        var d = new Date();
	        d.setTime(d.getTime() - 1);
	        var expires = 'expires=' + d.toUTCString() + ';';
	        document.cookie = stringCookie + expires;
	
	        // $cookieStore.put('globals', $rootScope.globals);
	        // Update v2 cookie with updated token
	        document.cookie = stringCookie;
	        window.location = window.location.origin + '/' + ("v2") + '/index.html';
	    };
	
	    return { redirectToV2: redirectToV2 };
	};
	
	exports.default = V2Service;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var VersionService = function VersionService($http, $rootScope) {
	  var VERSION_CHECK_INTERVAL_IN_MS = 5 * 60 * 1000; // 5 minutes
	  var VERSION_CHECK_WITH_SERVER_AFTER = 3 * 60 * 60 * 1000; // 3 hours
	  var versionUrl = ("https://fd-codefocus-nonprod.azurefd.net") + "/dataagility/api/service.version";
	
	  function ensureVersionMatchWithServerLoop() {
	    // Check localstorage
	    if (shouldCheckForNewVersion()) {
	      var lastVersion = localStorage.getItem("lastVersion");
	
	      getVersionFromServer().then(function (res) {
	        localStorage.setItem("lastVersionCheckedAt", Date.now() + "");
	        localStorage.setItem("lastVersion", res.version);
	
	        if (lastVersion != null && res.version != lastVersion) {
	          localStorage.setItem("lastVersionReload", Date.now() + "");
	          window.location.reload();
	        }
	      });
	    }
	
	    setTimeout(function () {
	      ensureVersionMatchWithServerLoop();
	    }, VERSION_CHECK_INTERVAL_IN_MS);
	  }
	
	  function getVersionFromServer() {
	    return $http.get(versionUrl).then(function (res) {
	      return res.data;
	    });
	  }
	
	  function shouldCheckForNewVersion() {
	    var lastVersionCheckedAt = localStorage.getItem("lastVersionCheckedAt");
	    if (lastVersionCheckedAt == null) {
	      return true;
	    }
	
	    if (Date.now() - Number(lastVersionCheckedAt) > VERSION_CHECK_WITH_SERVER_AFTER) {
	      return true;
	    }
	
	    return false;
	  }
	
	  return {
	    ensureVersionMatchWithServerLoop: ensureVersionMatchWithServerLoop
	  };
	};
	
	exports.default = VersionService;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UserFactory = function UserFactory() {
	  var user = {
	    codingOperationsTeam: '',
	    name: '',
	    email: '',
	    specialty: '',
	    role: '',
	    worklist: '',
	    id: '',
	    token: '',
	    roleId: '',
	    initialLogin: '',
	    activeDirectoryToken: '',
	    campus: ''
	  };
	
	  var setUser = function setUser(codingOperationsTeam, name, email, specialty, role, worklist, id, token, roleId, activeDirectoryToken, initialLogin, campus) {
	    user.codingOperationsTeam = codingOperationsTeam, user.name = name;
	    user.email = email;
	    user.specialty = specialty;
	    user.role = role;
	    user.worklist = worklist;
	    user.id = id;
	    user.token = token;
	    user.roleId = roleId;
	    user.activeDirectoryToken = activeDirectoryToken;
	    user.initialLogin = initialLogin;
	    user.campus = campus;
	  };
	
	  var getUser = function getUser() {
	    return user;
	  };
	
	  var isSignedIn = function isSignedIn() {
	    return user.isSignedIn;
	  };
	
	  return { getUser: getUser, isSignedIn: isSignedIn, setUser: setUser };
	};
	
	exports.default = UserFactory;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(253);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module('user', []).factory('User', _user2.default);
	
	exports.default = userModule;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DateTimeHelper = function () {
	    function DateTimeHelper() {
	        _classCallCheck(this, DateTimeHelper);
	    }
	
	    _createClass(DateTimeHelper, [{
	        key: 'convertICUHours',
	        value: function convertICUHours(inputInMinutes) {
	            // Convert minutes to seconds
	            var seconds = inputInMinutes ? inputInMinutes * 60 : 0;
	
	            // Calculate (and subtract) whole hours
	            var hours = Math.floor(seconds / 3600);
	            seconds -= hours * 3600;
	
	            // Calculate (and subtract) whole minutes
	            var minutes = Math.floor(seconds / 60) % 60;
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes);
	        }
	    }]);
	
	    return DateTimeHelper;
	}();
	
	exports.default = DateTimeHelper;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _DateTimeHelper = __webpack_require__(255);
	
	var _DateTimeHelper2 = _interopRequireDefault(_DateTimeHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utilsModule = _angular2.default.module('utils', []).service('dateTimeHelper', _DateTimeHelper2.default);
	
	exports.default = utilsModule;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _admin = __webpack_require__(329);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(258);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	__webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _admin2.default,
	  controller: _admin4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = adminComponent;

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminController = function AdminController(User, $scope, $rootScope, $cookieStore, FunctionService) {
	  _classCallCheck(this, AdminController);
	
	  console.log('Admin Controller...');
	  this.name = 'admin';
	  this.user = User.getUser();
	  this.episodeValue = '';
	  this.specialtyString = '';
	
	  $rootScope.globals = $cookieStore.get('globals') || {};
	  $cookieStore.remove('redirectURL');
	
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    if (response.functionSettings.EpisodeValue) {
	      $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
	      $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
	    }
	  });
	};
	
	exports.default = AdminController;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _admin = __webpack_require__(257);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _episodes = __webpack_require__(136);
	
	var _episodes2 = _interopRequireDefault(_episodes);
	
	var _users = __webpack_require__(148);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _specialties = __webpack_require__(145);
	
	var _specialties2 = _interopRequireDefault(_specialties);
	
	var _episodevalue = __webpack_require__(139);
	
	var _episodevalue2 = _interopRequireDefault(_episodevalue);
	
	var _drgs = __webpack_require__(133);
	
	var _drgs2 = _interopRequireDefault(_drgs);
	
	var _site = __webpack_require__(142);
	
	var _site2 = _interopRequireDefault(_site);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reports
	var adminModule = _angular2.default.module('admin', [_angularUiRouter2.default, _episodes2.default.name, _users2.default.name, _specialties2.default.name, _episodevalue2.default.name, _drgs2.default.name, _site2.default.name]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('admin', {
	    url: '/admin',
	    template: '<admin></admin>',
	    authenticate: true,
	    admin: "Reporter"
	  }).state('admin.episodes', {
	    url: '/episodes',
	    template: '<episodes></episodes>',
	    authenticate: true,
	    admin: true
	  }).state('admin.users', {
	    url: '/users',
	    template: '<users></users>',
	    authenticate: true,
	    admin: true
	  }).state('admin.specialties', {
	    url: '/specialties',
	    template: '<specialties></specialties>',
	    authenticate: true,
	    admin: true
	  }).state('admin.episodevalue', {
	    url: '/episodevalue',
	    template: '<episodevalue></episodevalue>',
	    authenticate: true,
	    admin: 'Reporter'
	  }).state('admin.drgs', {
	    url: '/drgs',
	    template: '<drgs></drgs>',
	    authenticate: true,
	    admin: true
	  }).state('admin.site', {
	    url: '/site',
	    template: '<site></site>',
	    authenticate: true,
	    admin: true
	  });
	}]).component('admin', _admin2.default);
	
	exports.default = adminModule;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authentication = __webpack_require__(330);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _authentication3 = __webpack_require__(261);
	
	var _authentication4 = _interopRequireDefault(_authentication3);
	
	__webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authenticationComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _authentication2.default,
	  controller: _authentication4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = authenticationComponent;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthenticationController = function AuthenticationController($state, $scope, $location, AuthenticationService, CONST, formlyConfig, FunctionService, $rootScope, V2Service) {
	  _classCallCheck(this, AuthenticationController);
	
	  FunctionService.resetFunctions();
	  var splitUrl = $location.absUrl().split('?');
	  // If logout was selected then sent logout type
	  var logoutTypeParameter = splitUrl.length > 1 && splitUrl[1].toString() ? splitUrl[1] : '';
	  var logoutType = logoutTypeParameter.indexOf('logout=true') > -1 ? 3 : 4;
	
	  formlyConfig.extras.removeChromeAutoComplete = true;
	
	  this.name = 'authentication';
	  this.form = 'authentication';
	  this.activeDirectoryErrorMsg = '';
	
	  this.options = {
	    removeChromeAutoComplete: true
	  };
	
	  this.userFields = [{
	    "key": "username",
	    "id": "username",
	    "wrapper": "lx-wrapper-errors",
	    "type": "lx-input",
	    "templateOptions": {
	      "label": "Email",
	      "required": true,
	      "icon": "account",
	      "minlength": 1,
	      "type": "email"
	    },
	    "modelOptions": {
	      "allowInvalid": false,
	      "updateOn": "keydown blur",
	      "debounce": {
	        "keydown": 100,
	        "default": 100,
	        "blur": 0
	      }
	    }
	  }, {
	    "key": "password",
	    "id": "password",
	    "wrapper": "lx-wrapper-errors",
	    "type": "lx-input",
	    "templateOptions": {
	      type: "password",
	      "label": "Password",
	      "required": true,
	      "icon": "key-variant",
	      "minlength": 1
	    },
	    "modelOptions": {
	      "allowInvalid": false,
	      "updateOn": "keydown blur",
	      "debounce": {
	        "keydown": 100,
	        "default": 100,
	        "blur": 0
	      }
	    }
	  }];
	
	  // reset login status
	  // AuthenticationService.ClearCredentials(logoutType);
	
	  // reset MYVIEW
	  if (typeof CONST != 'undefined') {
	    CONST.MYVIEW.assignedCoder = undefined;
	    CONST.MYVIEW.active = false;
	    CONST.MYVIEW.selectedStatus = [];
	    CONST.MYVIEW.selectedSpecialty = [];
	    CONST.MYVIEW.selectedCriteria = [];
	    CONST.MYVIEW.startDate = undefined;
	    CONST.MYVIEW.startDateFormatted = undefined;
	    CONST.MYVIEW.endDate = undefined;
	    CONST.MYVIEW.endDateFormatted = undefined;
	  }
	
	  $scope.activeDirectoryError = function () {
	    $scope.vm.activeDirectoryErrorMsg = $rootScope.activeDirectoryErrorMsg;
	    return $rootScope.activeDirectoryError;
	  };
	
	  $scope.login = function () {
	    $scope.dataLoading = true;
	
	    AuthenticationService.Login($scope, function (response) {
	      if (response.success) {
	        AuthenticationService.SetCredentials(response.success.codingOperationsTeam, response.success.email, response.success.firstname + " " + response.success.lastname, response.success.specialty, response.success.dtype, response.success.worklist, response.success.id, response.success.token, response.success.roleId, 'home', undefined, undefined, response.success.campus);
	
	        var cfDomain = '.codefocus.com.au';
	        var cfDomainIndex = window.location.hostname.indexOf(cfDomain) || window.location.hostname.indexOf('10.0.1.1');
	
	        if (window.location.hostname.indexOf('localhost') > -1) {
	          if (response.success.roleId) {
	            window.location = 'http://localhost:4200/' + ("v2") + '?token=' + response.success.token + '&roleId=' + response.success.roleId + '&redirectRoute=home';
	          }
	        } else if (cfDomainIndex > -1) {
	          V2Service.redirectToV2(response.success.roleId);
	        }
	      } else {
	        $scope.error = response.message;
	        $scope.dataLoading = false;
	      }
	    });
	  };
	};
	
	exports.default = AuthenticationController;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _authentication = __webpack_require__(260);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authenticationModule = _angular2.default.module('authentication', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('login', {
	    url: '/login',
	    template: '<authentication></authentication>',
	    authenticate: true
	  });
	}]).component('authentication', _authentication2.default);
	
	exports.default = authenticationModule;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _authentication = __webpack_require__(262);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _admin = __webpack_require__(259);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _reports = __webpack_require__(269);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _v = __webpack_require__(272);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _logout = __webpack_require__(266);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_authentication2.default.name, _admin2.default.name, _logout2.default.name, _reports2.default.name, _v2.default.name]);
	
	exports.default = componentModule;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logout = __webpack_require__(331);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _logout3 = __webpack_require__(265);
	
	var _logout4 = _interopRequireDefault(_logout3);
	
	__webpack_require__(386);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoutComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _logout2.default,
	  controller: _logout4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = logoutComponent;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LogoutController = function LogoutController($state, $scope, $rootScope, $location, $http, $cookieStore) {
	  _classCallCheck(this, LogoutController);
	
	  this.name = 'Logout';
	  this.form = 'Logout';
	
	  $http.get(("https://fd-codefocus-nonprod.azurefd.net") + '/dataagility/api/service.function/init').then(function successCallback(response) {
	    $scope.vm.logOutAppFunction = response.data.find(function (x) {
	      return x.code === 'LOGOUT';
	    });
	    if ($scope.vm.logOutAppFunction && $scope.vm.logOutAppFunction.valueString) {
	      $scope.vm.loginURL = $scope.vm.logOutAppFunction.valueString;
	    } else {
	      $scope.vm.loginURL = window.location.hostname + '/v2/login';
	    }
	  });
	  localStorage.clear();
	  $cookieStore.remove('globals');
	  $cookieStore.remove('globals');
	  $cookieStore.remove('globals');
	  $cookieStore.remove('io');
	};
	
	exports.default = LogoutController;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _logout = __webpack_require__(264);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoutModule = _angular2.default.module('logout', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('logout', {
	    url: '/logout',
	    template: '<logout></logout>',
	    authenticate: true
	  });
	}]).component('logout', _logout2.default);
	
	exports.default = logoutModule;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reports = __webpack_require__(332);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _reports3 = __webpack_require__(268);
	
	var _reports4 = _interopRequireDefault(_reports3);
	
	__webpack_require__(387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _reports2.default,
	  controller: _reports4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = reportsComponent;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReportsController = function ReportsController($rootScope, $scope, User, AuthenticationService, FunctionService, $cookieStore, V2Service, CONST) {
	  _classCallCheck(this, ReportsController);
	
	  this.appFunctions = [];
	  this.name = "reports";
	  this.user = User.getUser();
	
	  // Subscribe to functions fetched event then populate side menu lists
	  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
	    // $scope.vm.appFunctions = response.functions.filter(x => x.functionType === 'REP');
	    $scope.vm.appFunctions = response.functions.filter(function (func) {
	      return func.functionType === "REP";
	    }).sort(function (repFuncA, repFuncB) {
	      return repFuncA.name.localeCompare(repFuncB.name);
	    });
	  });
	
	  $scope.navItemClick = function (route, toggleMenu) {
	    $rootScope.globals = $cookieStore.get("globals");
	    var roleId = $rootScope.globals.currentUser.roleId ? $rootScope.globals.currentUser.roleId : $scope.vm.userRoleId;
	
	    // If on login page assume logged out so clear function settings
	    if (route.indexOf($scope.vm.loginRoute) > -1) {
	      $scope.vm.appFunctionSettings = {};
	      $scope.vm.appFunctions = [];
	    }
	
	    // Close nav menu when left hand menu item clicked
	    if (toggleMenu) {
	      var d = document.querySelector(".mdl-layout");
	      d.MaterialLayout.toggleDrawer();
	    }
	
	    if (route.indexOf("v2") > -1) {
	      $rootScope.stopTokenRefresh = true;
	      var cfDomain = ".codefocus.com.au";
	      var cfDomainIndex = window.location.hostname.indexOf(cfDomain) || window.location.hostname.indexOf("10.0.1.1");
	
	      $rootScope.globals.currentUser.redirectRoute = route.replace("" + ("v2") + "/", "");
	
	      AuthenticationService.SetCredentials($scope.vm.user.codingOperationsTeam, $scope.vm.user.email, $scope.vm.user.name, $scope.vm.user.specialty, $scope.vm.user.role, $scope.vm.user.worklist, $scope.vm.user.id, $scope.vm.user.token, roleId, $rootScope.globals.currentUser.redirectRoute, $rootScope.globals.currentUser.activeDirectoryToken, $rootScope.globals.currentUser.initialLogin, $scope.vm.user.campus);
	
	      if (window.location.hostname.indexOf("localhost") > -1) {
	        if (roleId) {
	          window.location = "http://localhost:4200/" + ("v2") + "?token=" + $rootScope.globals.currentUser.token + "&roleId=" + roleId + "&redirectRoute=" + $rootScope.globals.currentUser.redirectRoute;
	        }
	      } else if (cfDomainIndex) {
	        V2Service.redirectToV2(roleId);
	      }
	    }
	  };
	};
	
	exports.default = ReportsController;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reports = __webpack_require__(267);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _executivesummary = __webpack_require__(203);
	
	var _executivesummary2 = _interopRequireDefault(_executivesummary);
	
	var _episodelist = __webpack_require__(200);
	
	var _episodelist2 = _interopRequireDefault(_episodelist);
	
	var _changespercoder = __webpack_require__(173);
	
	var _changespercoder2 = _interopRequireDefault(_changespercoder);
	
	var _commondrgchanges = __webpack_require__(188);
	
	var _commondrgchanges2 = _interopRequireDefault(_commondrgchanges);
	
	var _commonicdchanges = __webpack_require__(191);
	
	var _commonicdchanges2 = _interopRequireDefault(_commonicdchanges);
	
	var _commonicdchangesbydrg = __webpack_require__(194);
	
	var _commonicdchangesbydrg2 = _interopRequireDefault(_commonicdchangesbydrg);
	
	var _commonchangedtodrg = __webpack_require__(185);
	
	var _commonchangedtodrg2 = _interopRequireDefault(_commonchangedtodrg);
	
	var _awaitingreview = __webpack_require__(170);
	
	var _awaitingreview2 = _interopRequireDefault(_awaitingreview);
	
	var _queries = __webpack_require__(218);
	
	var _queries2 = _interopRequireDefault(_queries);
	
	var _querychanges = __webpack_require__(221);
	
	var _querychanges2 = _interopRequireDefault(_querychanges);
	
	var _sentqueries = __webpack_require__(227);
	
	var _sentqueries2 = _interopRequireDefault(_sentqueries);
	
	var _mechvent = __webpack_require__(212);
	
	var _mechvent2 = _interopRequireDefault(_mechvent);
	
	var _atsi = __webpack_require__(152);
	
	var _atsi2 = _interopRequireDefault(_atsi);
	
	var _unitaudit = __webpack_require__(236);
	
	var _unitaudit2 = _interopRequireDefault(_unitaudit);
	
	var _totalaudit = __webpack_require__(233);
	
	var _totalaudit2 = _interopRequireDefault(_totalaudit);
	
	var _auditsbymonth = __webpack_require__(167);
	
	var _auditsbymonth2 = _interopRequireDefault(_auditsbymonth);
	
	var _auditprogress = __webpack_require__(161);
	
	var _auditprogress2 = _interopRequireDefault(_auditprogress);
	
	var _codedmedicalrecords = __webpack_require__(176);
	
	var _codedmedicalrecords2 = _interopRequireDefault(_codedmedicalrecords);
	
	var _coderreviewed = __webpack_require__(179);
	
	var _coderreviewed2 = _interopRequireDefault(_coderreviewed);
	
	var _targetdrgs = __webpack_require__(230);
	
	var _targetdrgs2 = _interopRequireDefault(_targetdrgs);
	
	var _picq = __webpack_require__(215);
	
	var _picq2 = _interopRequireDefault(_picq);
	
	var _auditresultsummary = __webpack_require__(164);
	
	var _auditresultsummary2 = _interopRequireDefault(_auditresultsummary);
	
	var _incompletedocumentation = __webpack_require__(209);
	
	var _incompletedocumentation2 = _interopRequireDefault(_incompletedocumentation);
	
	var _codingactivity = __webpack_require__(182);
	
	var _codingactivity2 = _interopRequireDefault(_codingactivity);
	
	var _readmissions = __webpack_require__(224);
	
	var _readmissions2 = _interopRequireDefault(_readmissions);
	
	var _episodechangereport = __webpack_require__(197);
	
	var _episodechangereport2 = _interopRequireDefault(_episodechangereport);
	
	var _auditprogramdrgchanges = __webpack_require__(155);
	
	var _auditprogramdrgchanges2 = _interopRequireDefault(_auditprogramdrgchanges);
	
	var _auditprogramresults = __webpack_require__(158);
	
	var _auditprogramresults2 = _interopRequireDefault(_auditprogramresults);
	
	var _executivesummary3 = __webpack_require__(206);
	
	var _executivesummary4 = _interopRequireDefault(_executivesummary3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsModule = _angular2.default.module('reports', [_angularUiRouter2.default, _executivesummary2.default.name, _episodelist2.default.name, _changespercoder2.default.name, _commondrgchanges2.default.name, _commonicdchanges2.default.name, _commonicdchangesbydrg2.default.name, _commonchangedtodrg2.default.name, _queries2.default.name, _awaitingreview2.default.name, _querychanges2.default.name, _sentqueries2.default.name, _mechvent2.default.name, _atsi2.default.name, _unitaudit2.default.name, _totalaudit2.default.name, _auditsbymonth2.default.name, _auditprogress2.default.name, _codedmedicalrecords2.default.name, _coderreviewed2.default.name, _targetdrgs2.default.name, _picq2.default.name, _auditresultsummary2.default.name, _incompletedocumentation2.default.name, _codingactivity2.default.name, _readmissions2.default.name, _episodechangereport2.default.name, _auditprogramdrgchanges2.default.name, _auditprogramresults2.default.name, _executivesummary4.default.name]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('reports', {
	    url: '/reports',
	    template: '<reports></reports>',
	    authenticate: true
	  }).state('reports.episodelist', {
	    url: '/episodelist',
	    template: '<episodelist></episodelist>',
	    authenticate: true
	  }).state('reports.changespercoder', {
	    url: '/changespercoder',
	    template: '<changespercoder></changespercoder>',
	    authenticate: true
	  }).state('reports.commondrgchanges', {
	    url: '/commondrgchanges',
	    template: '<commondrgchanges></commondrgchanges>',
	    authenticate: true
	  }).state('reports.commonicdchanges', {
	    url: '/commonicdchanges',
	    template: '<commonicdchanges></commonicdchanges>',
	    authenticate: true
	  }).state('reports.commonicdchangesbydrg', {
	    url: '/commonicdchangesbydrg',
	    template: '<commonicdchangesbydrg></commonicdchangesbydrg>',
	    authenticate: true,
	    params: {
	      drg: {
	        value: '0',
	        squash: false
	      },
	      specialty: {
	        value: '0',
	        squash: false
	      },
	      startDate: {
	        value: '0',
	        squash: false
	      },
	      endDate: {
	        value: '0',
	        squash: false
	      }
	    }
	  }).state('reports.executivesummary', {
	    url: '/executive-summary',
	    template: '<executivesummary></executivesummary>',
	    authenticate: true
	  }).state('reports.executivesummary-auditing', {
	    url: '/executive-summary-auditing',
	    template: '<executivesummarypoc></executivesummarypoc>',
	    authenticate: true
	  }).state('reports.commonchangedtodrg', {
	    url: '/commonchangedtodrg',
	    template: '<commonchangedtodrg></commonchangedtodrg>',
	    authenticate: true
	  }).state('reports.awaitingreview', {
	    url: '/awaitingreview',
	    template: '<awaitingreview></awaitingreview>',
	    authenticate: true
	  }).state('reports.queries', {
	    url: '/queries',
	    template: '<queries></queries>',
	    authenticate: true
	  }).state('reports.querychanges', {
	    url: '/querychanges',
	    template: '<querychanges></querychanges>',
	    authenticate: true
	  }).state('reports.mechvent', {
	    url: '/mechanical-ventilation',
	    template: '<mechvent></mechvent>',
	    authenticate: true
	  }).state('reports.atsi', {
	    url: '/atsi',
	    template: '<atsi></atsi>',
	    authenticate: true
	  }).state('reports.unitaudit', {
	    url: '/unit-audit',
	    template: '<unitaudit></unitaudit>',
	    authenticate: true
	  }).state('reports.totalaudit', {
	    url: '/total-audit',
	    template: '<totalaudit></totalaudit>',
	    authenticate: true
	  }).state('reports.auditsbymonth', {
	    url: '/audits-by-month',
	    template: '<auditsbymonth></auditsbymonth>',
	    authenticate: true
	  }).state('reports.auditprogress', {
	    url: '/audit-progress',
	    template: '<auditprogress></auditprogress>',
	    authenticate: true
	  }).state('reports.codedmedicalrecords', {
	    url: '/coded-medical-records',
	    template: '<codedmedicalrecords></codedmedicalrecords>',
	    authenticate: true
	  }).state('reports.codingreview', {
	    url: '/codingreview',
	    template: '<coderreviewed></coderreviewed>',
	    authenticate: true
	  }).state('reports.targetdrgs', {
	    url: '/target-drgs',
	    template: '<targetdrgs></targetdrgs>',
	    authenticate: true
	  }).state('reports.picq', {
	    url: '/picq',
	    template: '<picq></picq>',
	    authenticate: true
	  }).state('reports.auditresultsummary', {
	    url: '/audit-result-summary',
	    template: '<auditresultsummary></auditresultsummary>',
	    authenticate: true
	  }).state('reports.incompletedocumentation', {
	    url: '/incompletedocumentation',
	    template: '<incompletedocumentation></incompletedocumentation>',
	    authenticate: true
	  }).state('reports.codingactivity', {
	    url: '/coding-activity',
	    template: '<codingactivity></codingactivity>',
	    authenticate: true
	  }).state('reports.readmissions', {
	    url: '/readmissions',
	    template: '<readmissions></readmissions>',
	    authenticate: true
	  }).state('reports.episodechangereport', {
	    url: '/episodechangereport',
	    template: '<episodechangereport></episodechangereport>',
	    authenticate: true
	  }).state('reports.sentqueries', {
	    url: '/sentqueries',
	    template: '<sentqueries></sentqueries>',
	    authenticate: true
	  }).state('reports.auditprogramdrgchanges', {
	    url: '/audited-medical-drg-records',
	    template: '<auditprogramdrgchanges></auditprogramdrgchanges>',
	    authenticate: true
	  }).state('reports.auditprogramresults', {
	    url: '/audit-program-results',
	    template: '<auditprogramresults></auditprogramresults>',
	    authenticate: true
	  });
	}]).component('reports', _reports2.default);
	
	// Reports
	exports.default = reportsModule;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _v = __webpack_require__(333);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _v3 = __webpack_require__(271);
	
	var _v4 = _interopRequireDefault(_v3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var v2Component = {
	  restrict: 'E',
	  bindings: {},
	  template: _v2.default,
	  controller: _v4.default,
	  controllerAs: 'vm'
	};
	
	exports.default = v2Component;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var V2Controller = function V2Controller($scope, User, AuthenticationService, $rootScope, $cookieStore, V2Service, CONST) {
	  _classCallCheck(this, V2Controller);
	
	  $rootScope.stopTokenRefresh = true;
	  this.user = User.getUser();
	  this.name = 'v2';
	  var cfDomain = '.codefocus.com.au';
	  var cfDomainIndex = window.location.hostname.indexOf(cfDomain) || window.location.hostname.indexOf('10.0.1.1');
	  $rootScope.globals = $cookieStore.get('globals');
	
	  this.userRoleId = 0;
	  if ($rootScope.globals.currentUser && $rootScope.globals.currentUser.roleId) {
	    $scope.vm.userRoleId = $rootScope.globals.currentUser.roleId ? $rootScope.globals.currentUser.roleId : this.user.roleId;
	  }
	
	  AuthenticationService.SetCredentials($rootScope.globals.currentUser.codingOperationsTeam, this.user.email, this.user.name, this.user.specialty, this.user.role, this.user.worklist, this.user.id, this.user.token, $scope.vm.userRoleId, $rootScope.globals.currentUser.redirectRoute, $rootScope.globals.currentUser.activeDirectoryToken, $rootScope.globals.currentUser.initialLogin, this.user.campus);
	
	  if (window.location.hostname.indexOf('localhost') > -1) {
	    if ($scope.vm.userRoleId) {
	      window.location = 'http://localhost:4200/' + ("v2") + '?token=' + $rootScope.globals.currentUser.token + '&roleId=' + $scope.vm.userRoleId + '&redirectRoute=' + $rootScope.globals.currentUser.redirectRoute;
	    }
	  } else if (cfDomainIndex) {
	    V2Service.redirectToV2($scope.vm.userRoleId);
	  }
	};
	
	exports.default = V2Controller;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(5);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _v = __webpack_require__(270);
	
	var _v2 = _interopRequireDefault(_v);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var v2Module = _angular2.default.module('v2', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('v2', {
	    url: '/v2',
	    template: '<v2></v2>',
	    authenticate: true
	  });
	}]).component('v2', _v2.default);
	
	exports.default = v2Module;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	/*!
	 * angular-datatables - v0.5.3
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables';
	}
	(function (window, document, $, angular) {
	
	    'use strict';
	
	    angular.module('datatables.directive', ['datatables.instances', 'datatables.renderer', 'datatables.options', 'datatables.util']).directive('datatable', dataTable);
	
	    /* @ngInject */
	    function dataTable($q, $http, DTRendererFactory, DTRendererService, DTPropertyUtil) {
	        compileDirective.$inject = ['tElm'];
	        ControllerDirective.$inject = ['$scope'];
	        return {
	            restrict: 'A',
	            scope: {
	                dtOptions: '=',
	                dtColumns: '=',
	                dtColumnDefs: '=',
	                datatable: '@',
	                dtInstance: '='
	            },
	            compile: compileDirective,
	            controller: ControllerDirective
	        };
	
	        /* @ngInject */
	        function compileDirective(tElm) {
	            var _staticHTML = tElm[0].innerHTML;
	
	            return function postLink($scope, $elem, iAttrs, ctrl) {
	                function handleChanges(newVal, oldVal) {
	                    if (newVal !== oldVal) {
	                        ctrl.render($elem, ctrl.buildOptionsPromise(), _staticHTML);
	                    }
	                }
	
	                // Options can hold heavy data, and other deep/large objects.
	                // watchcollection can improve this by only watching shallowly
	                var watchFunction = iAttrs.dtDisableDeepWatchers ? '$watchCollection' : '$watch';
	                angular.forEach(['dtColumns', 'dtColumnDefs', 'dtOptions'], function (tableDefField) {
	                    $scope[watchFunction].call($scope, tableDefField, handleChanges, true);
	                });
	                DTRendererService.showLoading($elem, $scope);
	                ctrl.render($elem, ctrl.buildOptionsPromise(), _staticHTML);
	            };
	        }
	
	        /* @ngInject */
	        function ControllerDirective($scope) {
	            var _dtInstance;
	            var vm = this;
	            vm.buildOptionsPromise = buildOptionsPromise;
	            vm.render = render;
	
	            function buildOptionsPromise() {
	                var defer = $q.defer();
	                // Build options
	                $q.all([$q.when($scope.dtOptions), $q.when($scope.dtColumns), $q.when($scope.dtColumnDefs)]).then(function (results) {
	                    var dtOptions = results[0],
	                        dtColumns = results[1],
	                        dtColumnDefs = results[2];
	                    // Since Angular 1.3, the promise throws a "Maximum call stack size exceeded" when cloning
	                    // See https://github.com/l-lin/angular-datatables/issues/110
	                    DTPropertyUtil.deleteProperty(dtOptions, '$promise');
	                    DTPropertyUtil.deleteProperty(dtColumns, '$promise');
	                    DTPropertyUtil.deleteProperty(dtColumnDefs, '$promise');
	                    var options;
	                    if (angular.isDefined(dtOptions)) {
	                        options = {};
	                        angular.extend(options, dtOptions);
	                        // Set the columns
	                        if (angular.isArray(dtColumns)) {
	                            options.aoColumns = dtColumns;
	                        }
	
	                        // Set the column defs
	                        if (angular.isArray(dtColumnDefs)) {
	                            options.aoColumnDefs = dtColumnDefs;
	                        }
	
	                        // HACK to resolve the language source manually instead of DT
	                        // See https://github.com/l-lin/angular-datatables/issues/181
	                        if (options.language && options.language.url) {
	                            var languageDefer = $q.defer();
	                            $http.get(options.language.url).success(function (language) {
	                                languageDefer.resolve(language);
	                            });
	                            options.language = languageDefer.promise;
	                        }
	                    }
	                    return DTPropertyUtil.resolveObjectPromises(options, ['data', 'aaData', 'fnPromise']);
	                }).then(function (options) {
	                    defer.resolve(options);
	                });
	                return defer.promise;
	            }
	
	            function render($elem, optionsPromise, staticHTML) {
	                optionsPromise.then(function (options) {
	                    DTRendererService.preRender(options);
	
	                    var isNgDisplay = $scope.datatable && $scope.datatable === 'ng';
	                    // Render dataTable
	                    if (_dtInstance && _dtInstance._renderer) {
	                        _dtInstance._renderer.withOptions(options).render($elem, $scope, staticHTML).then(function (dtInstance) {
	                            _dtInstance = dtInstance;
	                            _setDTInstance(dtInstance);
	                        });
	                    } else {
	                        DTRendererFactory.fromOptions(options, isNgDisplay).render($elem, $scope, staticHTML).then(function (dtInstance) {
	                            _dtInstance = dtInstance;
	                            _setDTInstance(dtInstance);
	                        });
	                    }
	                });
	            }
	
	            function _setDTInstance(dtInstance) {
	                if (angular.isFunction($scope.dtInstance)) {
	                    $scope.dtInstance(dtInstance);
	                } else if (angular.isDefined($scope.dtInstance)) {
	                    $scope.dtInstance = dtInstance;
	                }
	            }
	        }
	    }
	    dataTable.$inject = ['$q', '$http', 'DTRendererFactory', 'DTRendererService', 'DTPropertyUtil'];
	
	    'use strict';
	    angular.module('datatables.factory', []).factory('DTOptionsBuilder', dtOptionsBuilder).factory('DTColumnBuilder', dtColumnBuilder).factory('DTColumnDefBuilder', dtColumnDefBuilder).factory('DTLoadingTemplate', dtLoadingTemplate);
	
	    /* @ngInject */
	    function dtOptionsBuilder() {
	        /**
	         * The wrapped datatables options class
	         * @param sAjaxSource the ajax source to fetch the data
	         * @param fnPromise the function that returns a promise to fetch the data
	         */
	        var DTOptions = {
	            hasOverrideDom: false,
	
	            /**
	             * Add the option to the datatables optoins
	             * @param key the key of the option
	             * @param value an object or a function of the option
	             * @returns {DTOptions} the options
	             */
	            withOption: function withOption(key, value) {
	                if (angular.isString(key)) {
	                    this[key] = value;
	                }
	                return this;
	            },
	
	            /**
	             * Add the Ajax source to the options.
	             * This corresponds to the "ajax" option
	             * @param ajax the ajax source
	             * @returns {DTOptions} the options
	             */
	            withSource: function withSource(ajax) {
	                this.ajax = ajax;
	                return this;
	            },
	
	            /**
	             * Add the ajax data properties.
	             * @param sAjaxDataProp the ajax data property
	             * @returns {DTOptions} the options
	             */
	            withDataProp: function withDataProp(sAjaxDataProp) {
	                this.sAjaxDataProp = sAjaxDataProp;
	                return this;
	            },
	
	            /**
	             * Set the server data function.
	             * @param fn the function of the server retrieval
	             * @returns {DTOptions} the options
	             */
	            withFnServerData: function withFnServerData(fn) {
	                if (!angular.isFunction(fn)) {
	                    throw new Error('The parameter must be a function');
	                }
	                this.fnServerData = fn;
	                return this;
	            },
	
	            /**
	             * Set the pagination type.
	             * @param sPaginationType the pagination type
	             * @returns {DTOptions} the options
	             */
	            withPaginationType: function withPaginationType(sPaginationType) {
	                if (angular.isString(sPaginationType)) {
	                    this.sPaginationType = sPaginationType;
	                } else {
	                    throw new Error('The pagination type must be provided');
	                }
	                return this;
	            },
	
	            /**
	             * Set the language of the datatables
	             * @param language the language
	             * @returns {DTOptions} the options
	             */
	            withLanguage: function withLanguage(language) {
	                this.language = language;
	                return this;
	            },
	
	            /**
	             * Set the language source
	             * @param languageSource the language source
	             * @returns {DTOptions} the options
	             */
	            withLanguageSource: function withLanguageSource(languageSource) {
	                return this.withLanguage({
	                    url: languageSource
	                });
	            },
	
	            /**
	             * Set default number of items per page to display
	             * @param iDisplayLength the number of items per page
	             * @returns {DTOptions} the options
	             */
	            withDisplayLength: function withDisplayLength(iDisplayLength) {
	                this.iDisplayLength = iDisplayLength;
	                return this;
	            },
	
	            /**
	             * Set the promise to fetch the data
	             * @param fnPromise the function that returns a promise
	             * @returns {DTOptions} the options
	             */
	            withFnPromise: function withFnPromise(fnPromise) {
	                this.fnPromise = fnPromise;
	                return this;
	            },
	
	            /**
	             * Set the Dom of the DataTables.
	             * @param dom the dom
	             * @returns {DTOptions} the options
	             */
	            withDOM: function withDOM(dom) {
	                this.dom = dom;
	                return this;
	            }
	        };
	
	        return {
	            /**
	             * Create a wrapped datatables options
	             * @returns {DTOptions} a wrapped datatables option
	             */
	            newOptions: function newOptions() {
	                return Object.create(DTOptions);
	            },
	            /**
	             * Create a wrapped datatables options with the ajax source setted
	             * @param ajax the ajax source
	             * @returns {DTOptions} a wrapped datatables option
	             */
	            fromSource: function fromSource(ajax) {
	                var options = Object.create(DTOptions);
	                options.ajax = ajax;
	                return options;
	            },
	            /**
	             * Create a wrapped datatables options with the data promise.
	             * @param fnPromise the function that returns a promise to fetch the data
	             * @returns {DTOptions} a wrapped datatables option
	             */
	            fromFnPromise: function fromFnPromise(fnPromise) {
	                var options = Object.create(DTOptions);
	                options.fnPromise = fnPromise;
	                return options;
	            }
	        };
	    }
	
	    function dtColumnBuilder() {
	        /**
	         * The wrapped datatables column
	         * @param mData the data to display of the column
	         * @param sTitle the sTitle of the column title to display in the DOM
	         */
	        var DTColumn = {
	            /**
	             * Add the option of the column
	             * @param key the key of the option
	             * @param value an object or a function of the option
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            withOption: function withOption(key, value) {
	                if (angular.isString(key)) {
	                    this[key] = value;
	                }
	                return this;
	            },
	
	            /**
	             * Set the title of the colum
	             * @param sTitle the sTitle of the column
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            withTitle: function withTitle(sTitle) {
	                this.sTitle = sTitle;
	                return this;
	            },
	
	            /**
	             * Set the CSS class of the column
	             * @param sClass the CSS class
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            withClass: function withClass(sClass) {
	                this.sClass = sClass;
	                return this;
	            },
	
	            /**
	             * Hide the column
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            notVisible: function notVisible() {
	                this.bVisible = false;
	                return this;
	            },
	
	            /**
	             * Set the column as not sortable
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            notSortable: function notSortable() {
	                this.bSortable = false;
	                return this;
	            },
	
	            /**
	             * Render each cell with the given parameter
	             * @mRender mRender the function/string to render the data
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            renderWith: function renderWith(mRender) {
	                this.mRender = mRender;
	                return this;
	            }
	        };
	
	        return {
	            /**
	             * Create a new wrapped datatables column
	             * @param mData the data of the column to display
	             * @param sTitle the sTitle of the column title to display in the DOM
	             * @returns {DTColumn} the wrapped datatables column
	             */
	            newColumn: function newColumn(mData, sTitle) {
	                if (angular.isUndefined(mData)) {
	                    throw new Error('The parameter "mData" is not defined!');
	                }
	                var column = Object.create(DTColumn);
	                column.mData = mData;
	                if (angular.isDefined(sTitle)) {
	                    column.sTitle = sTitle;
	                }
	                return column;
	            },
	            DTColumn: DTColumn
	        };
	    }
	
	    /* @ngInject */
	    function dtColumnDefBuilder(DTColumnBuilder) {
	        return {
	            newColumnDef: function newColumnDef(targets) {
	                if (angular.isUndefined(targets)) {
	                    throw new Error('The parameter "targets" must be defined! See https://datatables.net/reference/option/columnDefs.targets');
	                }
	                var column = Object.create(DTColumnBuilder.DTColumn);
	                if (angular.isArray(targets)) {
	                    column.aTargets = targets;
	                } else {
	                    column.aTargets = [targets];
	                }
	                return column;
	            }
	        };
	    }
	    dtColumnDefBuilder.$inject = ['DTColumnBuilder'];
	
	    function dtLoadingTemplate($compile, DTDefaultOptions, DT_LOADING_CLASS) {
	        return {
	            compileHtml: function compileHtml($scope) {
	                return $compile(angular.element('<div class="' + DT_LOADING_CLASS + '">' + DTDefaultOptions.loadingTemplate + '</div>'))($scope);
	            },
	            isLoading: function isLoading(elem) {
	                return elem.hasClass(DT_LOADING_CLASS);
	            }
	        };
	    }
	    dtLoadingTemplate.$inject = ['$compile', 'DTDefaultOptions', 'DT_LOADING_CLASS'];
	
	    'use strict';
	
	    angular.module('datatables.instances', ['datatables.util']).factory('DTInstanceFactory', dtInstanceFactory);
	
	    function dtInstanceFactory() {
	        var DTInstance = {
	            reloadData: reloadData,
	            changeData: changeData,
	            rerender: rerender
	        };
	        return {
	            newDTInstance: newDTInstance,
	            copyDTProperties: copyDTProperties
	        };
	
	        function newDTInstance(renderer) {
	            var dtInstance = Object.create(DTInstance);
	            dtInstance._renderer = renderer;
	            return dtInstance;
	        }
	
	        function copyDTProperties(result, dtInstance) {
	            dtInstance.id = result.id;
	            dtInstance.DataTable = result.DataTable;
	            dtInstance.dataTable = result.dataTable;
	        }
	
	        function reloadData(callback, resetPaging) {
	            /*jshint validthis:true */
	            this._renderer.reloadData(callback, resetPaging);
	        }
	
	        function changeData(data) {
	            /*jshint validthis:true */
	            this._renderer.changeData(data);
	        }
	
	        function rerender() {
	            /*jshint validthis:true */
	            this._renderer.rerender();
	        }
	    }
	
	    'use strict';
	
	    angular.module('datatables', ['datatables.directive', 'datatables.factory']).run(initAngularDataTables);
	
	    /* @ngInject */
	    function initAngularDataTables() {
	        if ($.fn.DataTable.Api) {
	            /**
	             * Register an API to destroy a DataTable without detaching the tbody so that we can add new data
	             * when rendering with the "Angular way".
	             */
	            $.fn.DataTable.Api.register('ngDestroy()', function (remove) {
	                remove = remove || false;
	
	                return this.iterator('table', function (settings) {
	                    var orig = settings.nTableWrapper.parentNode;
	                    var classes = settings.oClasses;
	                    var table = settings.nTable;
	                    var tbody = settings.nTBody;
	                    var thead = settings.nTHead;
	                    var tfoot = settings.nTFoot;
	                    var jqTable = $(table);
	                    var jqTbody = $(tbody);
	                    var jqWrapper = $(settings.nTableWrapper);
	                    var rows = $.map(settings.aoData, function (r) {
	                        return r.nTr;
	                    });
	                    var ien;
	
	                    // Flag to note that the table is currently being destroyed - no action
	                    // should be taken
	                    settings.bDestroying = true;
	
	                    // Fire off the destroy callbacks for plug-ins etc
	                    $.fn.DataTable.ext.internal._fnCallbackFire(settings, 'aoDestroyCallback', 'destroy', [settings]);
	
	                    // If not being removed from the document, make all columns visible
	                    if (!remove) {
	                        new $.fn.DataTable.Api(settings).columns().visible(true);
	                    }
	
	                    // Blitz all `DT` namespaced events (these are internal events, the
	                    // lowercase, `dt` events are user subscribed and they are responsible
	                    // for removing them
	                    jqWrapper.unbind('.DT').find(':not(tbody *)').unbind('.DT');
	                    $(window).unbind('.DT-' + settings.sInstance);
	
	                    // When scrolling we had to break the table up - restore it
	                    if (table !== thead.parentNode) {
	                        jqTable.children('thead').detach();
	                        jqTable.append(thead);
	                    }
	
	                    if (tfoot && table !== tfoot.parentNode) {
	                        jqTable.children('tfoot').detach();
	                        jqTable.append(tfoot);
	                    }
	
	                    // Remove the DataTables generated nodes, events and classes
	                    jqTable.detach();
	                    jqWrapper.detach();
	
	                    settings.aaSorting = [];
	                    settings.aaSortingFixed = [];
	                    $.fn.DataTable.ext.internal._fnSortingClasses(settings);
	
	                    $(rows).removeClass(settings.asStripeClasses.join(' '));
	
	                    $('th, td', thead).removeClass(classes.sSortable + ' ' + classes.sSortableAsc + ' ' + classes.sSortableDesc + ' ' + classes.sSortableNone);
	
	                    if (settings.bJUI) {
	                        $('th span.' + classes.sSortIcon + ', td span.' + classes.sSortIcon, thead).detach();
	                        $('th, td', thead).each(function () {
	                            var wrapper = $('div.' + classes.sSortJUIWrapper, this);
	                            $(this).append(wrapper.contents());
	                            wrapper.detach();
	                        });
	                    }
	
	                    // -------------------------------------------------------------------------
	                    // This is the only change with the "destroy()" API (with DT v1.10.1)
	                    // -------------------------------------------------------------------------
	                    if (!remove && orig) {
	                        // insertBefore acts like appendChild if !arg[1]
	                        if (orig.contains(settings.nTableReinsertBefore)) {
	                            orig.insertBefore(table, settings.nTableReinsertBefore);
	                        } else {
	                            orig.appendChild(table);
	                        }
	                    }
	                    // Add the TR elements back into the table in their original order
	                    // jqTbody.children().detach();
	                    // jqTbody.append( rows );
	                    // -------------------------------------------------------------------------
	
	                    // Restore the width of the original table - was read from the style property,
	                    // so we can restore directly to that
	                    jqTable.css('width', settings.sDestroyWidth).removeClass(classes.sTable);
	
	                    // If the were originally stripe classes - then we add them back here.
	                    // Note this is not fool proof (for example if not all rows had stripe
	                    // classes - but it's a good effort without getting carried away
	                    ien = settings.asDestroyStripes.length;
	
	                    if (ien) {
	                        jqTbody.children().each(function (i) {
	                            $(this).addClass(settings.asDestroyStripes[i % ien]);
	                        });
	                    }
	
	                    /* Remove the settings object from the settings array */
	                    var idx = $.inArray(settings, $.fn.DataTable.settings);
	                    if (idx !== -1) {
	                        $.fn.DataTable.settings.splice(idx, 1);
	                    }
	                });
	            });
	        }
	    }
	
	    'use strict';
	    angular.module('datatables.options', []).constant('DT_DEFAULT_OPTIONS', {
	        // Default dom
	        dom: 'lfrtip',
	        // Default ajax properties. See http://legacy.datatables.net/usage/options#sAjaxDataProp
	        sAjaxDataProp: '',
	        // Set default columns (used when none are provided)
	        aoColumns: []
	    }).constant('DT_LOADING_CLASS', 'dt-loading').service('DTDefaultOptions', dtDefaultOptions);
	
	    function dtDefaultOptions() {
	        var options = {
	            loadingTemplate: '<h3>Loading...</h3>',
	            bootstrapOptions: {},
	            setLoadingTemplate: setLoadingTemplate,
	            setLanguageSource: setLanguageSource,
	            setLanguage: setLanguage,
	            setDisplayLength: setDisplayLength,
	            setBootstrapOptions: setBootstrapOptions
	        };
	
	        return options;
	
	        /**
	         * Set the default loading template
	         * @param loadingTemplate the HTML to display when loading the table
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setLoadingTemplate(loadingTemplate) {
	            options.loadingTemplate = loadingTemplate;
	            return options;
	        }
	
	        /**
	         * Set the default language source for all datatables
	         * @param sLanguageSource the language source
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setLanguageSource(sLanguageSource) {
	            // HACK to resolve the language source manually instead of DT
	            // See https://github.com/l-lin/angular-datatables/issues/356
	            $.ajax({
	                dataType: 'json',
	                url: sLanguageSource,
	                success: function success(json) {
	                    $.extend(true, $.fn.dataTable.defaults, {
	                        oLanguage: json
	                    });
	                }
	            });
	            return options;
	        }
	
	        /**
	         * Set the language for all datatables
	         * @param oLanguage the language
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setLanguage(oLanguage) {
	            $.extend(true, $.fn.dataTable.defaults, {
	                oLanguage: oLanguage
	            });
	            return options;
	        }
	
	        /**
	         * Set the default number of items to display for all datatables
	         * @param iDisplayLength the number of items to display
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setDisplayLength(iDisplayLength) {
	            $.extend($.fn.dataTable.defaults, {
	                iDisplayLength: iDisplayLength
	            });
	            return options;
	        }
	
	        /**
	         * Set the default options to be use for Bootstrap integration.
	         * See https://github.com/l-lin/angular-datatables/blob/dev/src/angular-datatables.bootstrap.options.js to check
	         * what default options Angular DataTables is using.
	         * @param oBootstrapOptions an object containing the default options for Bootstreap integration
	         * @returns {DTDefaultOptions} the default option config
	         */
	        function setBootstrapOptions(oBootstrapOptions) {
	            options.bootstrapOptions = oBootstrapOptions;
	            return options;
	        }
	    }
	
	    'use strict';
	    angular.module('datatables.renderer', ['datatables.instances', 'datatables.factory', 'datatables.options', 'datatables.instances']).factory('DTRendererService', dtRendererService).factory('DTRenderer', dtRenderer).factory('DTDefaultRenderer', dtDefaultRenderer).factory('DTNGRenderer', dtNGRenderer).factory('DTPromiseRenderer', dtPromiseRenderer).factory('DTAjaxRenderer', dtAjaxRenderer).factory('DTRendererFactory', dtRendererFactory);
	
	    /* @ngInject */
	    function dtRendererService(DTLoadingTemplate) {
	        var plugins = [];
	        var rendererService = {
	            showLoading: showLoading,
	            hideLoading: hideLoading,
	            renderDataTable: renderDataTable,
	            hideLoadingAndRenderDataTable: hideLoadingAndRenderDataTable,
	            registerPlugin: registerPlugin,
	            postRender: postRender,
	            preRender: preRender
	        };
	        return rendererService;
	
	        function showLoading($elem, $scope) {
	            var $loading = angular.element(DTLoadingTemplate.compileHtml($scope));
	            $elem.after($loading);
	            $elem.hide();
	            $loading.show();
	        }
	
	        function hideLoading($elem) {
	            $elem.show();
	            var next = $elem.next();
	            if (DTLoadingTemplate.isLoading(next)) {
	                next.remove();
	            }
	        }
	
	        function renderDataTable($elem, options) {
	            var dtId = '#' + $elem.attr('id');
	            if ($.fn.dataTable.isDataTable(dtId) && angular.isObject(options)) {
	                options.destroy = true;
	            }
	            // See http://datatables.net/manual/api#Accessing-the-API to understand the difference between DataTable and dataTable
	            var DT = $elem.DataTable(options);
	            var dt = $elem.dataTable();
	
	            var result = {
	                id: $elem.attr('id'),
	                DataTable: DT,
	                dataTable: dt
	            };
	
	            postRender(options, result);
	
	            return result;
	        }
	
	        function hideLoadingAndRenderDataTable($elem, options) {
	            rendererService.hideLoading($elem);
	            return rendererService.renderDataTable($elem, options);
	        }
	
	        function registerPlugin(plugin) {
	            plugins.push(plugin);
	        }
	
	        function postRender(options, result) {
	            angular.forEach(plugins, function (plugin) {
	                if (angular.isFunction(plugin.postRender)) {
	                    plugin.postRender(options, result);
	                }
	            });
	        }
	
	        function preRender(options) {
	            angular.forEach(plugins, function (plugin) {
	                if (angular.isFunction(plugin.preRender)) {
	                    plugin.preRender(options);
	                }
	            });
	        }
	    }
	    dtRendererService.$inject = ['DTLoadingTemplate'];
	
	    function dtRenderer() {
	        return {
	            withOptions: function withOptions(options) {
	                this.options = options;
	                return this;
	            }
	        };
	    }
	
	    /* @ngInject */
	    function dtDefaultRenderer($q, DTRenderer, DTRendererService, DTInstanceFactory) {
	        return {
	            create: create
	        };
	
	        function create(options) {
	            var _oTable;
	            var _$elem;
	            var _$scope;
	            var renderer = Object.create(DTRenderer);
	            renderer.name = 'DTDefaultRenderer';
	            renderer.options = options;
	            renderer.render = render;
	            renderer.reloadData = reloadData;
	            renderer.changeData = changeData;
	            renderer.rerender = rerender;
	
	            function render($elem, $scope) {
	                _$elem = $elem;
	                _$scope = $scope;
	                var dtInstance = DTInstanceFactory.newDTInstance(renderer);
	                var result = DTRendererService.hideLoadingAndRenderDataTable($elem, renderer.options);
	                _oTable = result.DataTable;
	                DTInstanceFactory.copyDTProperties(result, dtInstance);
	                return $q.when(dtInstance);
	            }
	
	            function reloadData() {
	                // Do nothing
	            }
	
	            function changeData() {
	                // Do nothing
	            }
	
	            function rerender() {
	                _oTable.destroy();
	                DTRendererService.showLoading(_$elem, _$scope);
	                render(_$elem);
	            }
	            return renderer;
	        }
	    }
	    dtDefaultRenderer.$inject = ['$q', 'DTRenderer', 'DTRendererService', 'DTInstanceFactory'];
	
	    /* @ngInject */
	    function dtNGRenderer($log, $q, $compile, $timeout, DTRenderer, DTRendererService, DTInstanceFactory) {
	        /**
	         * Renderer for displaying the Angular way
	         * @param options
	         * @returns {{options: *}} the renderer
	         * @constructor
	         */
	        return {
	            create: create
	        };
	
	        function create(options) {
	            var _staticHTML;
	            var _oTable;
	            var _$elem;
	            var _parentScope;
	            var _newParentScope;
	            var dtInstance;
	            var renderer = Object.create(DTRenderer);
	            renderer.name = 'DTNGRenderer';
	            renderer.options = options;
	            renderer.render = render;
	            renderer.reloadData = reloadData;
	            renderer.changeData = changeData;
	            renderer.rerender = rerender;
	            return renderer;
	
	            function render($elem, $scope, staticHTML) {
	                _staticHTML = staticHTML;
	                _$elem = $elem;
	                _parentScope = $scope.$parent;
	                dtInstance = DTInstanceFactory.newDTInstance(renderer);
	
	                var defer = $q.defer();
	                var _expression = $elem.find('tbody').html();
	                // Find the resources from the comment <!-- ngRepeat: item in items --> displayed by angular in the DOM
	                // This regexp is inspired by the one used in the "ngRepeat" directive
	                var _match = _expression.match(/^\s*.+?\s+in\s+(\S*)\s*/m);
	
	                if (!_match) {
	                    throw new Error('Expected expression in form of "_item_ in _collection_[ track by _id_]" but got "{0}".', _expression);
	                }
	                var _ngRepeatAttr = _match[1];
	
	                var _alreadyRendered = false;
	
	                _parentScope.$watchCollection(_ngRepeatAttr, function () {
	                    if (_oTable && _alreadyRendered) {
	                        _destroyAndCompile();
	                    }
	                    $timeout(function () {
	                        _alreadyRendered = true;
	                        // Ensure that prerender is called when the collection is updated
	                        // See https://github.com/l-lin/angular-datatables/issues/502
	                        DTRendererService.preRender(renderer.options);
	                        var result = DTRendererService.hideLoadingAndRenderDataTable(_$elem, renderer.options);
	                        _oTable = result.DataTable;
	                        DTInstanceFactory.copyDTProperties(result, dtInstance);
	                        defer.resolve(dtInstance);
	                    }, 0, false);
	                }, true);
	                return defer.promise;
	            }
	
	            function reloadData() {
	                $log.warn('The Angular Renderer does not support reloading data. You need to do it directly on your model');
	            }
	
	            function changeData() {
	                $log.warn('The Angular Renderer does not support changing the data. You need to change your model directly.');
	            }
	
	            function rerender() {
	                _destroyAndCompile();
	                DTRendererService.showLoading(_$elem, _parentScope);
	                // Ensure that prerender is called after loadData from promise
	                // See https://github.com/l-lin/angular-datatables/issues/563
	                DTRendererService.preRender(options);
	                $timeout(function () {
	                    var result = DTRendererService.hideLoadingAndRenderDataTable(_$elem, renderer.options);
	                    _oTable = result.DataTable;
	                    DTInstanceFactory.copyDTProperties(result, dtInstance);
	                }, 0, false);
	            }
	
	            function _destroyAndCompile() {
	                if (_newParentScope) {
	                    _newParentScope.$destroy();
	                }
	                _oTable.ngDestroy();
	                // Re-compile because we lost the angular binding to the existing data
	                _$elem.html(_staticHTML);
	                _newParentScope = _parentScope.$new();
	                $compile(_$elem.contents())(_newParentScope);
	            }
	        }
	    }
	    dtNGRenderer.$inject = ['$log', '$q', '$compile', '$timeout', 'DTRenderer', 'DTRendererService', 'DTInstanceFactory'];
	
	    /* @ngInject */
	    function dtPromiseRenderer($q, $timeout, $log, DTRenderer, DTRendererService, DTInstanceFactory) {
	        /**
	         * Renderer for displaying with a promise
	         * @param options the options
	         * @returns {{options: *}} the renderer
	         * @constructor
	         */
	        return {
	            create: create
	        };
	
	        function create(options) {
	            var _oTable;
	            var _loadedPromise = null;
	            var _$elem;
	            var _$scope;
	
	            var dtInstance;
	            var renderer = Object.create(DTRenderer);
	            renderer.name = 'DTPromiseRenderer';
	            renderer.options = options;
	            renderer.render = render;
	            renderer.reloadData = reloadData;
	            renderer.changeData = changeData;
	            renderer.rerender = rerender;
	            return renderer;
	
	            function render($elem, $scope) {
	                var defer = $q.defer();
	                dtInstance = DTInstanceFactory.newDTInstance(renderer);
	                _$elem = $elem;
	                _$scope = $scope;
	                _resolve(renderer.options.fnPromise, DTRendererService.renderDataTable).then(function (result) {
	                    _oTable = result.DataTable;
	                    DTInstanceFactory.copyDTProperties(result, dtInstance);
	                    defer.resolve(dtInstance);
	                });
	                return defer.promise;
	            }
	
	            function reloadData(callback, resetPaging) {
	                var previousPage = _oTable && _oTable.page() ? _oTable.page() : 0;
	                if (angular.isFunction(renderer.options.fnPromise)) {
	                    _resolve(renderer.options.fnPromise, _redrawRows).then(function (result) {
	                        if (angular.isFunction(callback)) {
	                            callback(result.DataTable.data());
	                        }
	                        if (resetPaging === false) {
	                            result.DataTable.page(previousPage).draw(false);
	                        }
	                    });
	                } else {
	                    $log.warn('In order to use the reloadData functionality with a Promise renderer, you need to provide a function that returns a promise.');
	                }
	            }
	
	            function changeData(fnPromise) {
	                renderer.options.fnPromise = fnPromise;
	                // We also need to set the $scope.dtOptions, otherwise, when we change the columns, it will revert to the old data
	                // See https://github.com/l-lin/angular-datatables/issues/359
	                _$scope.dtOptions.fnPromise = fnPromise;
	                _resolve(renderer.options.fnPromise, _redrawRows);
	            }
	
	            function rerender() {
	                _oTable.destroy();
	                DTRendererService.showLoading(_$elem, _$scope);
	                // Ensure that prerender is called after loadData from promise
	                // See https://github.com/l-lin/angular-datatables/issues/563
	                DTRendererService.preRender(options);
	                render(_$elem, _$scope);
	            }
	
	            function _resolve(fnPromise, callback) {
	                var defer = $q.defer();
	                if (angular.isUndefined(fnPromise)) {
	                    throw new Error('You must provide a promise or a function that returns a promise!');
	                }
	                if (_loadedPromise) {
	                    _loadedPromise.then(function () {
	                        defer.resolve(_startLoading(fnPromise, callback));
	                    });
	                } else {
	                    defer.resolve(_startLoading(fnPromise, callback));
	                }
	                return defer.promise;
	            }
	
	            function _startLoading(fnPromise, callback) {
	                var defer = $q.defer();
	                if (angular.isFunction(fnPromise)) {
	                    _loadedPromise = fnPromise();
	                } else {
	                    _loadedPromise = fnPromise;
	                }
	                _loadedPromise.then(function (result) {
	                    var data = result;
	                    // In case the data is nested in an object
	                    if (renderer.options.sAjaxDataProp) {
	                        var properties = renderer.options.sAjaxDataProp.split('.');
	                        while (properties.length) {
	                            var property = properties.shift();
	                            if (property in data) {
	                                data = data[property];
	                            }
	                        }
	                    }
	                    _loadedPromise = null;
	                    defer.resolve(_doRender(renderer.options, _$elem, data, callback));
	                });
	                return defer.promise;
	            }
	
	            function _doRender(options, $elem, data, callback) {
	                var defer = $q.defer();
	                // Since Angular 1.3, the promise renderer is throwing "Maximum call stack size exceeded"
	                // By removing the $promise attribute, we avoid an infinite loop when jquery is cloning the data
	                // See https://github.com/l-lin/angular-datatables/issues/110
	                delete data.$promise;
	                options.aaData = data;
	                // Add $timeout to be sure that angular has finished rendering before calling datatables
	                $timeout(function () {
	                    DTRendererService.hideLoading($elem);
	                    // Set it to true in order to be able to redraw the dataTable
	                    options.bDestroy = true;
	                    defer.resolve(callback($elem, options));
	                }, 0, false);
	                return defer.promise;
	            }
	
	            function _redrawRows($elem, options) {
	                _oTable.clear();
	                _oTable.rows.add(options.aaData).draw(options.redraw);
	                return {
	                    id: dtInstance.id,
	                    DataTable: dtInstance.DataTable,
	                    dataTable: dtInstance.dataTable
	                };
	            }
	        }
	    }
	    dtPromiseRenderer.$inject = ['$q', '$timeout', '$log', 'DTRenderer', 'DTRendererService', 'DTInstanceFactory'];
	
	    /* @ngInject */
	    function dtAjaxRenderer($q, $timeout, DTRenderer, DTRendererService, DT_DEFAULT_OPTIONS, DTInstanceFactory) {
	        /**
	         * Renderer for displaying with Ajax
	         * @param options the options
	         * @returns {{options: *}} the renderer
	         * @constructor
	         */
	        return {
	            create: create
	        };
	
	        function create(options) {
	            var _oTable;
	            var _$elem;
	            var _$scope;
	            var renderer = Object.create(DTRenderer);
	            renderer.name = 'DTAjaxRenderer';
	            renderer.options = options;
	            renderer.render = render;
	            renderer.reloadData = reloadData;
	            renderer.changeData = changeData;
	            renderer.rerender = rerender;
	            return renderer;
	
	            function render($elem, $scope) {
	                _$elem = $elem;
	                _$scope = $scope;
	                var defer = $q.defer();
	                var dtInstance = DTInstanceFactory.newDTInstance(renderer);
	                // Define default values in case it is an ajax datatables
	                if (angular.isUndefined(renderer.options.sAjaxDataProp)) {
	                    renderer.options.sAjaxDataProp = DT_DEFAULT_OPTIONS.sAjaxDataProp;
	                }
	                if (angular.isUndefined(renderer.options.aoColumns)) {
	                    renderer.options.aoColumns = DT_DEFAULT_OPTIONS.aoColumns;
	                }
	                _doRender(renderer.options, $elem).then(function (result) {
	                    _oTable = result.DataTable;
	                    DTInstanceFactory.copyDTProperties(result, dtInstance);
	                    defer.resolve(dtInstance);
	                });
	                return defer.promise;
	            }
	
	            function reloadData(callback, resetPaging) {
	                if (_oTable) {
	                    _oTable.ajax.reload(callback, resetPaging);
	                }
	            }
	
	            function changeData(ajax) {
	                renderer.options.ajax = ajax;
	                // We also need to set the $scope.dtOptions, otherwise, when we change the columns, it will revert to the old data
	                // See https://github.com/l-lin/angular-datatables/issues/359
	                _$scope.dtOptions.ajax = ajax;
	            }
	
	            function rerender() {
	                // Ensure that prerender is called after loadData from promise
	                // See https://github.com/l-lin/angular-datatables/issues/563
	                DTRendererService.preRender(options);
	                render(_$elem, _$scope);
	            }
	
	            function _doRender(options, $elem) {
	                var defer = $q.defer();
	                // Destroy the table if it exists in order to be able to redraw the dataTable
	                options.bDestroy = true;
	                if (_oTable) {
	                    _oTable.destroy();
	                    DTRendererService.showLoading(_$elem, _$scope);
	                    // Empty in case of columns change
	                    $elem.empty();
	                }
	                DTRendererService.hideLoading($elem);
	                // Condition to refresh the dataTable
	                if (_shouldDeferRender(options)) {
	                    $timeout(function () {
	                        defer.resolve(DTRendererService.renderDataTable($elem, options));
	                    }, 0, false);
	                } else {
	                    defer.resolve(DTRendererService.renderDataTable($elem, options));
	                }
	                return defer.promise;
	            }
	            // See https://github.com/l-lin/angular-datatables/issues/147
	            function _shouldDeferRender(options) {
	                if (angular.isDefined(options) && angular.isDefined(options.dom)) {
	                    // S for scroller plugin
	                    return options.dom.indexOf('S') >= 0;
	                }
	                return false;
	            }
	        }
	    }
	    dtAjaxRenderer.$inject = ['$q', '$timeout', 'DTRenderer', 'DTRendererService', 'DT_DEFAULT_OPTIONS', 'DTInstanceFactory'];
	
	    /* @ngInject */
	    function dtRendererFactory(DTDefaultRenderer, DTNGRenderer, DTPromiseRenderer, DTAjaxRenderer) {
	        return {
	            fromOptions: fromOptions
	        };
	
	        function fromOptions(options, isNgDisplay) {
	            if (isNgDisplay) {
	                if (options && options.serverSide) {
	                    throw new Error('You cannot use server side processing along with the Angular renderer!');
	                }
	                return DTNGRenderer.create(options);
	            }
	            if (angular.isDefined(options)) {
	                if (angular.isDefined(options.fnPromise) && options.fnPromise !== null) {
	                    if (options.serverSide) {
	                        throw new Error('You cannot use server side processing along with the Promise renderer!');
	                    }
	                    return DTPromiseRenderer.create(options);
	                }
	                if (angular.isDefined(options.ajax) && options.ajax !== null || angular.isDefined(options.ajax) && options.ajax !== null) {
	                    return DTAjaxRenderer.create(options);
	                }
	                return DTDefaultRenderer.create(options);
	            }
	            return DTDefaultRenderer.create();
	        }
	    }
	    dtRendererFactory.$inject = ['DTDefaultRenderer', 'DTNGRenderer', 'DTPromiseRenderer', 'DTAjaxRenderer'];
	
	    'use strict';
	
	    angular.module('datatables.util', []).factory('DTPropertyUtil', dtPropertyUtil);
	
	    /* @ngInject */
	    function dtPropertyUtil($q) {
	        return {
	            overrideProperties: overrideProperties,
	            deleteProperty: deleteProperty,
	            resolveObjectPromises: resolveObjectPromises,
	            resolveArrayPromises: resolveArrayPromises
	        };
	
	        /**
	         * Overrides the source property with the given target properties.
	         * Source is not written. It's making a fresh copy of it in order to ensure that we do not change the parameters.
	         * @param source the source properties to override
	         * @param target the target properties
	         * @returns {*} the object overrided
	         */
	        function overrideProperties(source, target) {
	            var result = angular.copy(source);
	
	            if (angular.isUndefined(result) || result === null) {
	                result = {};
	            }
	            if (angular.isUndefined(target) || target === null) {
	                return result;
	            }
	            if (angular.isObject(target)) {
	                for (var prop in target) {
	                    if (target.hasOwnProperty(prop)) {
	                        result[prop] = overrideProperties(result[prop], target[prop]);
	                    }
	                }
	            } else {
	                result = angular.copy(target);
	            }
	            return result;
	        }
	
	        /**
	         * Delete the property from the given object
	         * @param obj the object
	         * @param propertyName the property name
	         */
	        function deleteProperty(obj, propertyName) {
	            if (angular.isObject(obj)) {
	                delete obj[propertyName];
	            }
	        }
	
	        /**
	         * Resolve any promises from a given object if there are any.
	         * @param obj the object
	         * @param excludedPropertiesName the list of properties to ignore
	         * @returns {promise} the promise that the object attributes promises are all resolved
	         */
	        function resolveObjectPromises(obj, excludedPropertiesName) {
	            var defer = $q.defer(),
	                promises = [],
	                resolvedObj = {},
	                excludedProp = excludedPropertiesName || [];
	            if (!angular.isObject(obj) || angular.isArray(obj)) {
	                defer.resolve(obj);
	            } else {
	                resolvedObj = angular.extend(resolvedObj, obj);
	                for (var prop in resolvedObj) {
	                    if (resolvedObj.hasOwnProperty(prop) && $.inArray(prop, excludedProp) === -1) {
	                        if (angular.isArray(resolvedObj[prop])) {
	                            promises.push(resolveArrayPromises(resolvedObj[prop]));
	                        } else {
	                            promises.push($q.when(resolvedObj[prop]));
	                        }
	                    }
	                }
	                $q.all(promises).then(function (result) {
	                    var index = 0;
	                    for (var prop in resolvedObj) {
	                        if (resolvedObj.hasOwnProperty(prop) && $.inArray(prop, excludedProp) === -1) {
	                            resolvedObj[prop] = result[index++];
	                        }
	                    }
	                    defer.resolve(resolvedObj);
	                });
	            }
	            return defer.promise;
	        }
	
	        /**
	         * Resolve the given array promises
	         * @param array the array containing promise or not
	         * @returns {promise} the promise that the array contains a list of objects/values promises that are resolved
	         */
	        function resolveArrayPromises(array) {
	            var defer = $q.defer(),
	                promises = [],
	                resolveArray = [];
	            if (!angular.isArray(array)) {
	                defer.resolve(array);
	            } else {
	                angular.forEach(array, function (item) {
	                    if (angular.isObject(item)) {
	                        promises.push(resolveObjectPromises(item));
	                    } else {
	                        promises.push($q.when(item));
	                    }
	                });
	                $q.all(promises).then(function (result) {
	                    angular.forEach(result, function (item) {
	                        resolveArray.push(item);
	                    });
	                    defer.resolve(resolveArray);
	                });
	            }
	            return defer.promise;
	        }
	    }
	    dtPropertyUtil.$inject = ['$q'];
	})(window, document, jQuery, angular);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * This plug-in for DataTables represents the ultimate option in extensibility
	 * for sorting date / time strings correctly. It uses
	 * [Moment.js](http://momentjs.com) to create automatic type detection and
	 * sorting plug-ins for DataTables based on a given format. This way, DataTables
	 * will automatically detect your temporal information and sort it correctly.
	 *
	 * For usage instructions, please see the DataTables blog
	 * post that [introduces it](//datatables.net/blog/2014-12-18).
	 *
	 * @name Ultimate Date / Time sorting
	 * @summary Sort date and time in any format using Moment.js
	 * @author [Allan Jardine](//datatables.net)
	 * @depends DataTables 1.10+, Moment.js 1.7+
	 *
	 * @example
	 *    $.fn.dataTable.moment( 'HH:mm MMM D, YY' );
	 *    $.fn.dataTable.moment( 'dddd, MMMM Do, YYYY' );
	 *
	 *    $('#example').DataTable();
	 */
	
	(function (factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(6), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			factory(jQuery, moment);
		}
	})(function ($, moment) {
	
		$.fn.dataTable.moment = function (format, locale) {
			var types = $.fn.dataTable.ext.type;
	
			// Add type detection
			types.detect.unshift(function (d) {
				if (d) {
					// Strip HTML tags and newline characters if possible
					if (d.replace) {
						d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
					}
	
					// Strip out surrounding white space
					d = $.trim(d);
				}
	
				// Null and empty values are acceptable
				if (d === '' || d === null) {
					return 'moment-' + format;
				}
	
				return moment(d, format, locale, true).isValid() ? 'moment-' + format : null;
			});
	
			// Add sorting method - use an integer for the sorting
			types.order['moment-' + format + '-pre'] = function (d) {
				if (d) {
					// Strip HTML tags and newline characters if possible
					if (d.replace) {
						d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
					}
	
					// Strip out surrounding white space
					d = $.trim(d);
				}
	
				return d === '' || d === null ? -Infinity : parseInt(moment(d, format, locale, true).format('x'), 10);
			};
		};
	});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	/*!
	  Paper Collapse v0.4.0
	
	  Collapsible paper cards.
	
	  Made with love by bbo - ©2015 Alexander Rühle
	  MIT License http://opensource.org/licenses/MIT
	 */
	
	(function () {
	  (function ($) {
	    'use strict';
	
	    $.fn.paperCollapse = function (options) {
	      var settings;
	      settings = $.extend({}, $.fn.paperCollapse.defaults, options);
	      $(this).find('.collapse-card__heading').add(settings.closeHandler).click(function () {
	        if ($(this).closest('.collapse-card').hasClass('active')) {
	          settings.onHide.call(this);
	          $(this).closest('.collapse-card').removeClass('active');
	          $(this).closest('.collapse-card').find('.collapse-card__body').stop().slideUp(settings.animationDuration, settings.onHideComplete);
	        } else {
	          settings.onShow.call(this);
	          $(this).closest('.collapse-card').addClass('active');
	          $(this).closest('.collapse-card').find('.collapse-card__body').stop().slideDown(settings.animationDuration, settings.onShowComplete);
	        }
	      });
	      return this;
	    };
	    $.fn.paperCollapse.defaults = {
	      animationDuration: 400,
	      easing: 'swing',
	      closeHandler: '.collapse-card__close_handler',
	      onShow: function onShow() {},
	      onHide: function onHide() {},
	      onShowComplete: function onShowComplete() {},
	      onHideComplete: function onHideComplete() {}
	    };
	  })(jQuery);
	}).call(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';
	
	// See https://datatables.net/extensions/buttons/
	
	dtButtonsConfig.$inject = ["$provide", "DT_DEFAULT_OPTIONS"];
	initButtonsPlugin.$inject = ["DTRendererService"];
	angular.module('datatables.buttons', ['datatables']).config(dtButtonsConfig).run(initButtonsPlugin);
	
	/* @ngInject */
	function dtButtonsConfig($provide, DT_DEFAULT_OPTIONS) {
	    dtOptionsBuilderDecorator.$inject = ["$delegate"];
	    $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	    function dtOptionsBuilderDecorator($delegate) {
	        var newOptions = $delegate.newOptions;
	        var fromSource = $delegate.fromSource;
	        var fromFnPromise = $delegate.fromFnPromise;
	
	        $delegate.newOptions = function () {
	            return _decorateOptions(newOptions);
	        };
	        $delegate.fromSource = function (ajax) {
	            return _decorateOptions(fromSource, ajax);
	        };
	        $delegate.fromFnPromise = function (fnPromise) {
	            return _decorateOptions(fromFnPromise, fnPromise);
	        };
	
	        return $delegate;
	
	        function _decorateOptions(fn, params) {
	            var options = fn(params);
	            options.withButtons = withButtons;
	            return options;
	
	            /**
	             * Add buttons compatibility
	             * @param buttonsOptions the options of the buttons extension (see https://datatables.net/reference/option/buttons#Examples)
	             * @returns {DTOptions} the options
	             */
	            function withButtons(buttonsOptions) {
	                var buttonsPrefix = 'B';
	                options.dom = options.dom ? options.dom : DT_DEFAULT_OPTIONS.dom;
	                if (options.dom.indexOf(buttonsPrefix) === -1) {
	                    options.dom = buttonsPrefix + options.dom;
	                }
	                if (angular.isUndefined(buttonsOptions)) {
	                    throw new Error('You must define the options for the button extension. See https://datatables.net/reference/option/buttons#Examples for some example');
	                }
	                options.buttons = buttonsOptions;
	                return options;
	            }
	        }
	    }
	}
	
	/* @ngInject */
	function initButtonsPlugin(DTRendererService) {
	    var buttonsPlugin = {
	        preRender: preRender,
	        postRender: postRender
	    };
	    DTRendererService.registerPlugin(buttonsPlugin);
	
	    function preRender(options) {
	        if (angular.isArray(options.buttons)) {
	            // The extension buttons seems to clear the content of the options.buttons for some reasons...
	            // So, we save it in a tmp variable so that we can restore it afterwards
	            // See https://github.com/l-lin/angular-datatables/issues/502
	            options.buttonsTmp = options.buttons.slice();
	        }
	    }
	
	    function postRender(options) {
	        if (angular.isDefined(options.buttonsTmp)) {
	            // Restore the buttons options
	            options.buttons = options.buttonsTmp;
	            delete options.buttonsTmp;
	        }
	    }
	}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * HTML5 export buttons for Buttons and DataTables.
	 * 2015 SpryMedia Ltd - datatables.net/license
	 *
	 * FileSaver.js (2015-05-07.2) - MIT license
	 * Copyright © 2015 Eli Grey - http://eligrey.com
	 */
	
	(function (factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(9), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	      return factory($, window, document);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    // CommonJS
	    module.exports = function (root, $) {
	      if (!root) {
	        root = window;
	      }
	
	      if (!$ || !$.fn.dataTable) {
	        $ = require('datatables.net')(root, $).$;
	      }
	
	      if (!$.fn.dataTable.Buttons) {
	        require('datatables.net-buttons')(root, $);
	      }
	
	      return factory($, root, root.document);
	    };
	  } else {
	    // Browser
	    factory(jQuery, window, document);
	  }
	})(function ($, window, document, undefined) {
	  'use strict';
	
	  var DataTable = $.fn.dataTable;
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   * FileSaver.js dependency
	   */
	
	  /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	  var _saveAs = function (view) {
	    // IE <10 is explicitly unsupported
	    if (typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
	      return;
	    }
	    var doc = view.document
	    // only get URL when necessary in case Blob.js hasn't overridden it yet
	    ,
	        get_URL = function get_URL() {
	      return view.URL || view.webkitURL || view;
	    },
	        save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"),
	        can_use_save_link = "download" in save_link,
	        click = function click(node) {
	      var event = doc.createEvent("MouseEvents");
	      event.initMouseEvent("click", true, false, view, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	      node.dispatchEvent(event);
	    },
	        webkit_req_fs = view.webkitRequestFileSystem,
	        req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem,
	        throw_outside = function throw_outside(ex) {
	      (view.setImmediate || view.setTimeout)(function () {
	        throw ex;
	      }, 0);
	    },
	        force_saveable_type = "application/octet-stream",
	        fs_min_size = 0
	    // See https://code.google.com/p/chromium/issues/detail?id=375297#c7 and
	    // https://github.com/eligrey/FileSaver.js/commit/485930a#commitcomment-8768047
	    // for the reasoning behind the timeout and revocation flow
	    ,
	        arbitrary_revoke_timeout = 500 // in ms
	    ,
	        revoke = function revoke(file) {
	      var revoker = function revoker() {
	        if (typeof file === "string") {
	          // file is an object URL
	          get_URL().revokeObjectURL(file);
	        } else {
	          // file is a File
	          file.remove();
	        }
	      };
	      if (view.chrome) {
	        revoker();
	      } else {
	        setTimeout(revoker, arbitrary_revoke_timeout);
	      }
	    },
	        dispatch = function dispatch(filesaver, event_types, event) {
	      event_types = [].concat(event_types);
	      var i = event_types.length;
	      while (i--) {
	        var listener = filesaver["on" + event_types[i]];
	        if (typeof listener === "function") {
	          try {
	            listener.call(filesaver, event || filesaver);
	          } catch (ex) {
	            throw_outside(ex);
	          }
	        }
	      }
	    },
	        auto_bom = function auto_bom(blob) {
	      // prepend BOM for UTF-8 XML and text/* types (including HTML)
	      if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
	        return new Blob(['\uFEFF', blob], { type: blob.type });
	      }
	      return blob;
	    },
	        FileSaver = function FileSaver(blob, name) {
	      blob = auto_bom(blob);
	      // First try a.download, then web filesystem, then object URLs
	      var filesaver = this,
	          type = blob.type,
	          blob_changed = false,
	          object_url,
	          target_view,
	          dispatch_all = function dispatch_all() {
	        dispatch(filesaver, "writestart progress write writeend".split(" "));
	      }
	      // on any filesys errors revert to saving with object URLs
	      ,
	          fs_error = function fs_error() {
	        // don't create more object URLs than needed
	        if (blob_changed || !object_url) {
	          object_url = get_URL().createObjectURL(blob);
	        }
	        if (target_view) {
	          target_view.location.href = object_url;
	        } else {
	          var new_tab = view.open(object_url, "_blank");
	          if (new_tab === undefined && typeof safari !== "undefined") {
	            //Apple do not allow window.open, see http://bit.ly/1kZffRI
	            view.location.href = object_url;
	          }
	        }
	        filesaver.readyState = filesaver.DONE;
	        dispatch_all();
	        revoke(object_url);
	      },
	          abortable = function abortable(func) {
	        return function () {
	          if (filesaver.readyState !== filesaver.DONE) {
	            return func.apply(this, arguments);
	          }
	        };
	      },
	          create_if_not_found = { create: true, exclusive: false },
	          slice;
	      filesaver.readyState = filesaver.INIT;
	      if (!name) {
	        name = "download";
	      }
	      if (can_use_save_link) {
	        object_url = get_URL().createObjectURL(blob);
	        save_link.href = object_url;
	        save_link.download = name;
	        click(save_link);
	        filesaver.readyState = filesaver.DONE;
	        dispatch_all();
	        revoke(object_url);
	        return;
	      }
	      // Object and web filesystem URLs have a problem saving in Google Chrome when
	      // viewed in a tab, so I force save with application/octet-stream
	      // http://code.google.com/p/chromium/issues/detail?id=91158
	      // Update: Google errantly closed 91158, I submitted it again:
	      // https://code.google.com/p/chromium/issues/detail?id=389642
	      if (view.chrome && type && type !== force_saveable_type) {
	        slice = blob.slice || blob.webkitSlice;
	        blob = slice.call(blob, 0, blob.size, force_saveable_type);
	        blob_changed = true;
	      }
	      // Since I can't be sure that the guessed media type will trigger a download
	      // in WebKit, I append .download to the filename.
	      // https://bugs.webkit.org/show_bug.cgi?id=65440
	      if (webkit_req_fs && name !== "download") {
	        name += ".download";
	      }
	      if (type === force_saveable_type || webkit_req_fs) {
	        target_view = view;
	      }
	      if (!req_fs) {
	        fs_error();
	        return;
	      }
	      fs_min_size += blob.size;
	      req_fs(view.TEMPORARY, fs_min_size, abortable(function (fs) {
	        fs.root.getDirectory("saved", create_if_not_found, abortable(function (dir) {
	          var save = function save() {
	            dir.getFile(name, create_if_not_found, abortable(function (file) {
	              file.createWriter(abortable(function (writer) {
	                writer.onwriteend = function (event) {
	                  target_view.location.href = file.toURL();
	                  filesaver.readyState = filesaver.DONE;
	                  dispatch(filesaver, "writeend", event);
	                  revoke(file);
	                };
	                writer.onerror = function () {
	                  var error = writer.error;
	                  if (error.code !== error.ABORT_ERR) {
	                    fs_error();
	                  }
	                };
	                "writestart progress write abort".split(" ").forEach(function (event) {
	                  writer["on" + event] = filesaver["on" + event];
	                });
	                writer.write(blob);
	                filesaver.abort = function () {
	                  writer.abort();
	                  filesaver.readyState = filesaver.DONE;
	                };
	                filesaver.readyState = filesaver.WRITING;
	              }), fs_error);
	            }), fs_error);
	          };
	          dir.getFile(name, { create: false }, abortable(function (file) {
	            // delete file if it already exists
	            file.remove();
	            save();
	          }), abortable(function (ex) {
	            if (ex.code === ex.NOT_FOUND_ERR) {
	              save();
	            } else {
	              fs_error();
	            }
	          }));
	        }), fs_error);
	      }), fs_error);
	    },
	        FS_proto = FileSaver.prototype,
	        saveAs = function saveAs(blob, name) {
	      return new FileSaver(blob, name);
	    };
	    // IE 10+ (native saveAs)
	    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
	      return function (blob, name) {
	        return navigator.msSaveOrOpenBlob(auto_bom(blob), name);
	      };
	    }
	
	    FS_proto.abort = function () {
	      var filesaver = this;
	      filesaver.readyState = filesaver.DONE;
	      dispatch(filesaver, "abort");
	    };
	    FS_proto.readyState = FS_proto.INIT = 0;
	    FS_proto.WRITING = 1;
	    FS_proto.DONE = 2;
	
	    FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
	
	    return saveAs;
	  }(window);
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   * Local (private) functions
	   */
	
	  /**
	   * Get the file name for an exported file.
	   *
	   * @param {object}  config       Button configuration
	   * @param {boolean} incExtension Include the file name extension
	   */
	  var _filename = function _filename(config, incExtension) {
	    // Backwards compatibility
	    var filename = config.filename === '*' && config.title !== '*' && config.title !== undefined ? config.title : config.filename;
	
	    if (typeof filename === 'function') {
	      filename = filename();
	    }
	
	    if (filename.indexOf('*') !== -1) {
	      filename = filename.replace('*', $('title').text());
	    }
	
	    // Strip characters which the OS will object to
	    filename = filename.replace(/[^a-zA-Z0-9_\u00A1-\uFFFF\.,\-_ !\(\)]/g, "");
	
	    return incExtension === undefined || incExtension === true ? filename + config.extension : filename;
	  };
	
	  /**
	   * Get the sheet name for Excel exports.
	   *
	   * @param {object}  config       Button configuration
	   */
	  var _sheetname = function _sheetname(config) {
	    var sheetName = 'Sheet1';
	
	    if (config.sheetName) {
	      sheetName = config.sheetName.replace(/[\[\]\*\/\\\?\:]/g, '');
	    }
	
	    return sheetName;
	  };
	
	  /**
	   * Get the title for an exported file.
	   *
	   * @param {object}  config  Button configuration
	   */
	  var _title = function _title(config) {
	    var title = config.title;
	
	    if (typeof title === 'function') {
	      title = title();
	    }
	
	    return title.indexOf('*') !== -1 ? title.replace('*', $('title').text()) : title;
	  };
	
	  /**
	   * Get the newline character(s)
	   *
	   * @param {object}  config Button configuration
	   * @return {string}        Newline character
	   */
	  var _newLine = function _newLine(config) {
	    return config.newline ? config.newline : navigator.userAgent.match(/Windows/) ? '\r\n' : '\n';
	  };
	
	  /**
	   * Combine the data from the `buttons.exportData` method into a string that
	   * will be used in the export file.
	   *
	   * @param  {DataTable.Api} dt     DataTables API instance
	   * @param  {object}        config Button configuration
	   * @return {object}               The data to export
	   */
	  var _exportData = function _exportData(dt, config) {
	    var newLine = _newLine(config);
	    var data = dt.buttons.exportData(config.exportOptions);
	    var boundary = config.fieldBoundary;
	    var separator = config.fieldSeparator;
	    var reBoundary = new RegExp(boundary, 'g');
	    var escapeChar = config.escapeChar !== undefined ? config.escapeChar : '\\';
	    var join = function join(a) {
	      var s = '';
	
	      // If there is a field boundary, then we might need to escape it in
	      // the source data
	      for (var i = 0, ien = a.length; i < ien; i++) {
	        if (i > 0) {
	          s += separator;
	        }
	
	        s += boundary ? boundary + ('' + a[i]).replace(reBoundary, escapeChar + boundary) + boundary : a[i];
	      }
	
	      return s;
	    };
	
	    var header = config.header ? join(data.header) + newLine : '';
	    var footer = config.footer && data.footer ? newLine + join(data.footer) : '';
	    var body = [];
	
	    for (var i = 0, ien = data.body.length; i < ien; i++) {
	      body.push(join(data.body[i]));
	    }
	
	    return {
	      str: header + body.join(newLine) + footer,
	      rows: body.length
	    };
	  };
	
	  /**
	   * Safari's data: support for creating and downloading files is really poor, so
	   * various options need to be disabled in it. See
	   * https://bugs.webkit.org/show_bug.cgi?id=102914
	   *
	   * @return {Boolean} `true` if Safari
	   */
	  var _isSafari = function _isSafari() {
	    return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 && navigator.userAgent.indexOf('Opera') === -1;
	  };
	
	  // Excel - Pre-defined strings to build a minimal XLSX file
	  var excelStrings = {
	    "_rels/.rels": '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\
	<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\
	  <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>\
	</Relationships>',
	
	    "xl/_rels/workbook.xml.rels": '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\
	<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\
	  <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>\
	</Relationships>',
	
	    "[Content_Types].xml": '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\
	<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">\
	  <Default Extension="xml" ContentType="application/xml"/>\
	  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>\
	  <Default Extension="jpeg" ContentType="image/jpeg"/>\
	  <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>\
	  <Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>\
	</Types>',
	
	    "xl/workbook.xml": '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\
	<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">\
	  <fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="24816"/>\
	  <workbookPr showInkAnnotation="0" autoCompressPictures="0"/>\
	  <bookViews>\
	    <workbookView xWindow="0" yWindow="0" windowWidth="25600" windowHeight="19020" tabRatio="500"/>\
	  </bookViews>\
	  <sheets>\
	    <sheet name="__SHEET_NAME__" sheetId="1" r:id="rId1"/>\
	  </sheets>\
	</workbook>',
	
	    "xl/worksheets/sheet1.xml": '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\
	<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">\
	  <sheetData>\
	    __DATA__\
	  </sheetData>\
	</worksheet>'
	  };
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   * Buttons
	   */
	
	  //
	  // Copy to clipboard
	  //
	  DataTable.ext.buttons.copyHtml5 = {
	    className: 'buttons-copy buttons-html5',
	
	    text: function text(dt) {
	      return dt.i18n('buttons.copy', 'Copy');
	    },
	
	    action: function action(e, dt, button, config) {
	      var exportData = _exportData(dt, config);
	      var output = exportData.str;
	      var hiddenDiv = $('<div/>').css({
	        height: 1,
	        width: 1,
	        overflow: 'hidden',
	        position: 'fixed',
	        top: 0,
	        left: 0
	      });
	
	      if (config.customize) {
	        output = config.customize(output, config);
	      }
	
	      var textarea = $('<textarea readonly/>').val(output).appendTo(hiddenDiv);
	
	      // For browsers that support the copy execCommand, try to use it
	      if (document.queryCommandSupported('copy')) {
	        hiddenDiv.appendTo(dt.table().container());
	        textarea[0].focus();
	        textarea[0].select();
	
	        try {
	          document.execCommand('copy');
	          hiddenDiv.remove();
	
	          dt.buttons.info(dt.i18n('buttons.copyTitle', 'Copy to clipboard'), dt.i18n('buttons.copySuccess', {
	            1: "Copied one row to clipboard",
	            _: "Copied %d rows to clipboard"
	          }, exportData.rows), 2000);
	
	          return;
	        } catch (t) {}
	      }
	
	      // Otherwise we show the text box and instruct the user to use it
	      var message = $('<span>' + dt.i18n('buttons.copyKeys', 'Press <i>ctrl</i> or <i>\u2318</i> + <i>C</i> to copy the table data<br>to your system clipboard.<br><br>' + 'To cancel, click this message or press escape.') + '</span>').append(hiddenDiv);
	
	      dt.buttons.info(dt.i18n('buttons.copyTitle', 'Copy to clipboard'), message, 0);
	
	      // Select the text so when the user activates their system clipboard
	      // it will copy that text
	      textarea[0].focus();
	      textarea[0].select();
	
	      // Event to hide the message when the user is done
	      var container = $(message).closest('.dt-button-info');
	      var close = function close() {
	        container.off('click.buttons-copy');
	        $(document).off('.buttons-copy');
	        dt.buttons.info(false);
	      };
	
	      container.on('click.buttons-copy', close);
	      $(document).on('keydown.buttons-copy', function (e) {
	        if (e.keyCode === 27) {
	          // esc
	          close();
	        }
	      }).on('copy.buttons-copy cut.buttons-copy', function () {
	        close();
	      });
	    },
	
	    exportOptions: {},
	
	    fieldSeparator: '\t',
	
	    fieldBoundary: '',
	
	    header: true,
	
	    footer: false
	  };
	
	  //
	  // CSV export
	  //
	  DataTable.ext.buttons.csvHtml5 = {
	    className: 'buttons-csv buttons-html5',
	
	    available: function available() {
	      return window.FileReader !== undefined && window.Blob;
	    },
	
	    text: function text(dt) {
	      return dt.i18n('buttons.csv', 'CSV');
	    },
	
	    action: function action(e, dt, button, config) {
	      // Set the text
	      var newLine = _newLine(config);
	      var output = _exportData(dt, config).str;
	
	      if (config.customize) {
	        output = config.customize(output, config);
	      }
	
	      _saveAs(new Blob([output], { type: 'text/csv' }), _filename(config));
	    },
	
	    filename: '*',
	
	    extension: '.csv',
	
	    exportOptions: {},
	
	    fieldSeparator: ',',
	
	    fieldBoundary: '"',
	
	    escapeChar: '"',
	
	    charset: null,
	
	    header: true,
	
	    footer: false
	  };
	
	  //
	  // Excel (xlsx) export
	  //
	  DataTable.ext.buttons.excelHtml5 = {
	    className: 'buttons-excel buttons-html5',
	
	    available: function available() {
	      return window.FileReader !== undefined && window.JSZip !== undefined && !_isSafari();
	    },
	
	    text: function text(dt) {
	      return dt.i18n('buttons.excel', 'Excel');
	    },
	
	    action: function action(e, dt, button, config) {
	      // Set the text
	      var xml = '';
	      var data = dt.buttons.exportData(config.exportOptions);
	      var addRow = function addRow(row) {
	        var cells = [];
	
	        for (var i = 0, ien = row.length; i < ien; i++) {
	          if (row[i] === null || row[i] === undefined) {
	            row[i] = '';
	          }
	
	          // Don't match numbers with leading zeros or a negative anywhere
	          // but the start
	          cells.push(typeof row[i] === 'number' || row[i].match && $.trim(row[i]).match(/^-?\d+(\.\d+)?$/) ? '<c t="n"><v>' + row[i] + '</v></c>' : '<c t="inlineStr"><is><t>' + (!row[i].replace ? row[i] : row[i].replace(/&(?!amp;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '')) + // remove control characters
	          '</t></is></c>' // they are not valid in XML
	          );
	        }
	
	        return '<row>' + cells.join('') + '</row>';
	      };
	
	      if (config.header) {
	        xml += addRow(data.header);
	      }
	
	      for (var i = 0, ien = data.body.length; i < ien; i++) {
	        xml += addRow(data.body[i]);
	      }
	
	      if (config.footer) {
	        xml += addRow(data.footer);
	      }
	
	      var zip = new window.JSZip();
	      var _rels = zip.folder("_rels");
	      var xl = zip.folder("xl");
	      var xl_rels = zip.folder("xl/_rels");
	      var xl_worksheets = zip.folder("xl/worksheets");
	
	      zip.file('[Content_Types].xml', excelStrings['[Content_Types].xml']);
	      _rels.file('.rels', excelStrings['_rels/.rels']);
	      xl.file('workbook.xml', excelStrings['xl/workbook.xml'].replace('__SHEET_NAME__', _sheetname(config)));
	      xl_rels.file('workbook.xml.rels', excelStrings['xl/_rels/workbook.xml.rels']);
	      xl_worksheets.file('sheet1.xml', excelStrings['xl/worksheets/sheet1.xml'].replace('__DATA__', xml));
	
	      _saveAs(zip.generate({ type: "blob", mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), _filename(config));
	    },
	
	    filename: '*',
	
	    extension: '.xlsx',
	
	    exportOptions: {},
	
	    header: true,
	
	    footer: false
	  };
	
	  //
	  // PDF export - using pdfMake - http://pdfmake.org
	  //
	  DataTable.ext.buttons.pdfHtml5 = {
	    className: 'buttons-pdf buttons-html5',
	
	    available: function available() {
	      return window.FileReader !== undefined && window.pdfMake;
	    },
	
	    text: function text(dt) {
	      return dt.i18n('buttons.pdf', 'PDF');
	    },
	
	    action: function action(e, dt, button, config) {
	      var newLine = _newLine(config);
	      var data = dt.buttons.exportData(config.exportOptions);
	      var rows = [];
	
	      if (config.header) {
	        rows.push($.map(data.header, function (d) {
	          return {
	            text: typeof d === 'string' ? d : d + '',
	            style: 'tableHeader'
	          };
	        }));
	      }
	
	      for (var i = 0, ien = data.body.length; i < ien; i++) {
	        rows.push($.map(data.body[i], function (d) {
	          return {
	            text: typeof d === 'string' ? d : d + '',
	            style: i % 2 ? 'tableBodyEven' : 'tableBodyOdd'
	          };
	        }));
	      }
	
	      if (config.footer) {
	        rows.push($.map(data.footer, function (d) {
	          return {
	            text: typeof d === 'string' ? d : d + '',
	            style: 'tableFooter'
	          };
	        }));
	      }
	
	      var doc = {
	        pageSize: config.pageSize,
	        pageOrientation: config.orientation,
	        content: [{
	          table: {
	            headerRows: 1,
	            body: rows
	          },
	          layout: 'noBorders'
	        }],
	        styles: {
	          tableHeader: {
	            bold: true,
	            fontSize: 11,
	            color: 'white',
	            fillColor: '#2d4154',
	            alignment: 'center'
	          },
	          tableBodyEven: {},
	          tableBodyOdd: {
	            fillColor: '#f3f3f3'
	          },
	          tableFooter: {
	            bold: true,
	            fontSize: 11,
	            color: 'white',
	            fillColor: '#2d4154'
	          },
	          title: {
	            alignment: 'center',
	            fontSize: 15
	          },
	          message: {}
	        },
	        defaultStyle: {
	          fontSize: 10
	        }
	      };
	
	      if (config.message) {
	        doc.content.unshift({
	          text: config.message,
	          style: 'message',
	          margin: [0, 0, 0, 12]
	        });
	      }
	
	      if (config.title) {
	        doc.content.unshift({
	          text: _title(config, false),
	          style: 'title',
	          margin: [0, 0, 0, 12]
	        });
	      }
	
	      if (config.customize) {
	        config.customize(doc, config);
	      }
	
	      var pdf = window.pdfMake.createPdf(doc);
	
	      if (config.download === 'open' && !_isSafari()) {
	        pdf.open();
	      } else {
	        pdf.getBuffer(function (buffer) {
	          var blob = new Blob([buffer], { type: 'application/pdf' });
	
	          _saveAs(blob, _filename(config));
	        });
	      }
	    },
	
	    title: '*',
	
	    filename: '*',
	
	    extension: '.pdf',
	
	    exportOptions: {},
	
	    orientation: 'portrait',
	
	    pageSize: 'A4',
	
	    header: true,
	
	    footer: false,
	
	    message: null,
	
	    customize: null,
	
	    download: 'download'
	  };
	
	  return DataTable.Buttons;
	});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Print button for Buttons and DataTables.
	 * 2015 SpryMedia Ltd - datatables.net/license
	 */
	
	(function (factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(9), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	      return factory($, window, document);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	    // CommonJS
	    module.exports = function (root, $) {
	      if (!root) {
	        root = window;
	      }
	
	      if (!$ || !$.fn.dataTable) {
	        $ = require('datatables.net')(root, $).$;
	      }
	
	      if (!$.fn.dataTable.Buttons) {
	        require('datatables.net-buttons')(root, $);
	      }
	
	      return factory($, root, root.document);
	    };
	  } else {
	    // Browser
	    factory(jQuery, window, document);
	  }
	})(function ($, window, document, undefined) {
	  'use strict';
	
	  var DataTable = $.fn.dataTable;
	
	  var _link = document.createElement('a');
	
	  /**
	   * Convert a `link` tag's URL from a relative to an absolute address so it will
	   * work correctly in the popup window which has no base URL.
	   *
	   * @param  {node}     el Element to convert
	   */
	  var _relToAbs = function _relToAbs(el) {
	    var url;
	    var clone = $(el).clone()[0];
	    var linkHost;
	
	    if (clone.nodeName.toLowerCase() === 'link') {
	      _link.href = clone.href;
	      linkHost = _link.host;
	
	      // IE doesn't have a trailing slash on the host
	      // Chrome has it on the pathname
	      if (linkHost.indexOf('/') === -1 && _link.pathname.indexOf('/') !== 0) {
	        linkHost += '/';
	      }
	
	      clone.href = _link.protocol + "//" + linkHost + _link.pathname + _link.search;
	    }
	
	    return clone.outerHTML;
	  };
	
	  DataTable.ext.buttons.print = {
	    className: 'buttons-print',
	
	    text: function text(dt) {
	      return dt.i18n('buttons.print', 'Print');
	    },
	
	    action: function action(e, dt, button, config) {
	      var data = dt.buttons.exportData(config.exportOptions);
	      var addRow = function addRow(d, tag) {
	        var str = '<tr>';
	
	        for (var i = 0, ien = d.length; i < ien; i++) {
	          str += '<' + tag + '>' + d[i] + '</' + tag + '>';
	        }
	
	        return str + '</tr>';
	      };
	
	      // Construct a table for printing
	      var html = '<table class="' + dt.table().node().className + '">';
	
	      if (config.header) {
	        html += '<thead>' + addRow(data.header, 'th') + '</thead>';
	      }
	
	      html += '<tbody>';
	      for (var i = 0, ien = data.body.length; i < ien; i++) {
	        html += addRow(data.body[i], 'td');
	      }
	      html += '</tbody>';
	
	      if (config.footer) {
	        html += '<tfoot>' + addRow(data.footer, 'th') + '</tfoot>';
	      }
	
	      // Open a new window for the printable table
	      var win = window.open('', '');
	      var title = config.title;
	
	      if (typeof title === 'function') {
	        title = title();
	      }
	
	      if (title.indexOf('*') !== -1) {
	        title = title.replace('*', $('title').text());
	      }
	
	      win.document.close();
	
	      // Inject the title and also a copy of the style and link tags from this
	      // document so the table can retain its base styling. Note that we have
	      // to use string manipulation as IE won't allow elements to be created
	      // in the host document and then appended to the new window.
	      var head = '<title>' + title + '</title>';
	      $('style, link').each(function () {
	        head += _relToAbs(this);
	      });
	
	      $(win.document.head).html(head);
	
	      // Inject the table and other surrounding information
	      $(win.document.body).html('<h1>' + title + '</h1>' + '<div>' + config.message + '</div>' + html);
	
	      if (config.customize) {
	        config.customize(win);
	      }
	
	      setTimeout(function () {
	        if (config.autoPrint) {
	          win.print(); // blocking - so close will not
	          win.close(); // execute until this is done
	        }
	      }, 250);
	    },
	
	    title: '*',
	
	    message: '',
	
	    exportOptions: {},
	
	    header: true,
	
	    footer: false,
	
	    autoPrint: true,
	
	    customize: null
	  };
	
	  return DataTable.Buttons;
	});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	/*!
	 * angular-datatables - v0.5.3
	 * https://github.com/l-lin/angular-datatables
	 * License: MIT
	 */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	    module.exports = 'datatables.columnfilter';
	}
	(function (window, document, $, angular) {
	
	    'use strict';
	
	    // See http://jquery-datatables-column-filter.googlecode.com/svn/trunk/index.html
	
	    angular.module('datatables.columnfilter', ['datatables']).config(dtColumnFilterConfig).run(initColumnFilterPlugin);
	
	    /* @ngInject */
	    function dtColumnFilterConfig($provide) {
	        $provide.decorator('DTOptionsBuilder', dtOptionsBuilderDecorator);
	
	        function dtOptionsBuilderDecorator($delegate) {
	            var newOptions = $delegate.newOptions;
	            var fromSource = $delegate.fromSource;
	            var fromFnPromise = $delegate.fromFnPromise;
	
	            $delegate.newOptions = function () {
	                return _decorateOptions(newOptions);
	            };
	            $delegate.fromSource = function (ajax) {
	                return _decorateOptions(fromSource, ajax);
	            };
	            $delegate.fromFnPromise = function (fnPromise) {
	                return _decorateOptions(fromFnPromise, fnPromise);
	            };
	
	            return $delegate;
	
	            function _decorateOptions(fn, params) {
	                var options = fn(params);
	                options.withColumnFilter = withColumnFilter;
	                return options;
	
	                /**
	                 * Add column filter support
	                 * @param columnFilterOptions the plugins options
	                 * @returns {DTOptions} the options
	                 */
	                function withColumnFilter(columnFilterOptions) {
	                    options.hasColumnFilter = true;
	                    if (columnFilterOptions) {
	                        options.columnFilterOptions = columnFilterOptions;
	                    }
	                    return options;
	                }
	            }
	        }
	        dtOptionsBuilderDecorator.$inject = ['$delegate'];
	    }
	    dtColumnFilterConfig.$inject = ['$provide'];
	
	    /* @ngInject */
	    function initColumnFilterPlugin(DTRendererService) {
	        var columnFilterPlugin = {
	            postRender: postRender
	        };
	        DTRendererService.registerPlugin(columnFilterPlugin);
	
	        function postRender(options, result) {
	            if (options && options.hasColumnFilter) {
	                result.dataTable.columnFilter(options.columnFilterOptions);
	            }
	        }
	    }
	    initColumnFilterPlugin.$inject = ['DTRendererService'];
	})(window, document, jQuery, angular);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	* File:        jquery.dataTables.columnFilter.js
	* Version:     1.5.6.
	* Author:      Jovan Popovic 
	* 
	* Copyright 2011-2014 Jovan Popovic, all rights reserved.
	*
	* This source file is free software, under either the GPL v2 license or a
	* BSD style license, as supplied with this software.
	* 
	* This source file is distributed in the hope that it will be useful, but 
	* WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY 
	* or FITNESS FOR A PARTICULAR PURPOSE. 
	* 
	* Parameters:"
	* @sPlaceHolder                 String      Place where inline filtering function should be placed ("tfoot", "thead:before", "thead:after"). Default is "tfoot"
	* @sRangeSeparator              String      Separator that will be used when range values are sent to the server-side. Default value is "~".
	* @sRangeFormat                 string      Default format of the From ... to ... range inputs. Default is From {from} to {to}
	* @aoColumns                    Array       Array of the filter settings that will be applied on the columns
	*/
	
	(function ($) {
	
	    $.fn.columnFilter = function (options) {
	
	        var asInitVals, i, label, th;
	
	        //var sTableId = "table";
	        var sRangeFormat = "From {from} to {to}";
	        //Array of the functions that will override sSearch_ parameters
	        var afnSearch_ = new Array();
	        var aiCustomSearch_Indexes = new Array();
	
	        var oFunctionTimeout = null;
	
	        var fnOnFiltered = function fnOnFiltered() {};
	
	        function _fnGetColumnValues(oSettings, iColumn, bUnique, bFiltered, bIgnoreEmpty) {
	            ///<summary>
	            ///Return values in the column
	            ///</summary>
	            ///<param name="oSettings" type="Object">DataTables settings</param>
	            ///<param name="iColumn" type="int">Id of the column</param>
	            ///<param name="bUnique" type="bool">Return only distinct values</param>
	            ///<param name="bFiltered" type="bool">Return values only from the filtered rows</param>
	            ///<param name="bIgnoreEmpty" type="bool">Ignore empty cells</param>
	
	            // check that we have a column id
	            if (typeof iColumn == "undefined") return new Array();
	
	            // by default we only wany unique data
	            if (typeof bUnique == "undefined") bUnique = true;
	
	            // by default we do want to only look at filtered data
	            if (typeof bFiltered == "undefined") bFiltered = true;
	
	            // by default we do not wany to include empty values
	            if (typeof bIgnoreEmpty == "undefined") bIgnoreEmpty = true;
	
	            // list of rows which we're going to loop through
	            var aiRows;
	
	            // use only filtered rows
	            if (bFiltered == true) aiRows = oSettings.aiDisplay;
	            // use all rows
	            else aiRows = oSettings.aiDisplayMaster; // all row numbers
	
	            // set up data array	
	            var asResultData = new Array();
	
	            for (var i = 0, c = aiRows.length; i < c; i++) {
	                var iRow = aiRows[i];
	                var aData = oTable.fnGetData(iRow);
	                var sValue = aData[iColumn];
	
	                // ignore empty values?
	                if (bIgnoreEmpty == true && sValue.length == 0) continue;
	
	                // ignore unique values?
	                else if (bUnique == true && jQuery.inArray(sValue, asResultData) > -1) continue;
	
	                    // else push the value onto the result data array
	                    else asResultData.push(sValue);
	            }
	
	            return asResultData.sort();
	        }
	
	        function _fnColumnIndex(iColumnIndex) {
	            if (properties.bUseColVis) return iColumnIndex;else return oTable.fnSettings().oApi._fnVisibleToColumnIndex(oTable.fnSettings(), iColumnIndex);
	            //return iColumnIndex;
	            //return oTable.fnSettings().oApi._fnColumnIndexToVisible(oTable.fnSettings(), iColumnIndex);
	        }
	
	        function fnCreateInput(oTable, regex, smart, bIsNumber, iFilterLength, iMaxLenght) {
	            var sCSSClass = "text_filter form-control";
	            if (bIsNumber) sCSSClass = "number_filter form-control";
	
	            label = label.replace(/(^\s*)|(\s*$)/g, "");
	            var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
	            var search_init = 'search_init ';
	            var inputvalue = label;
	            if (currentFilter != '' && currentFilter != '^') {
	                if (bIsNumber && currentFilter.charAt(0) == '^') inputvalue = currentFilter.substr(1); //ignore trailing ^
	                else inputvalue = currentFilter;
	                search_init = '';
	            }
	
	            var input = $('<input type="text" class="' + search_init + sCSSClass + '" value="' + inputvalue + '" rel="' + i + '"/>');
	            if (iMaxLenght != undefined && iMaxLenght != -1) {
	                input.attr('maxlength', iMaxLenght);
	            }
	            th.html(input);
	            if (bIsNumber) th.wrapInner('<span class="filter_column filter_number" />');else th.wrapInner('<span class="filter_column filter_text" />');
	
	            asInitVals[i] = label;
	            var index = i;
	
	            if (bIsNumber && !oTable.fnSettings().oFeatures.bServerSide) {
	                input.keyup(function () {
	                    /* Filter on the column all numbers that starts with the entered value */
	                    oTable.fnFilter('^' + this.value, _fnColumnIndex(index), true, false); //Issue 37
	                    fnOnFiltered();
	                });
	            } else {
	                input.keyup(function () {
	                    if (oTable.fnSettings().oFeatures.bServerSide && iFilterLength != 0) {
	                        //If filter length is set in the server-side processing mode
	                        //Check has the user entered at least iFilterLength new characters
	
	                        var currentFilter = oTable.fnSettings().aoPreSearchCols[index].sSearch;
	                        var iLastFilterLength = $(this).data("dt-iLastFilterLength");
	                        if (typeof iLastFilterLength == "undefined") iLastFilterLength = 0;
	                        var iCurrentFilterLength = this.value.length;
	                        if (Math.abs(iCurrentFilterLength - iLastFilterLength) < iFilterLength
	                        //&& currentFilter.length == 0 //Why this?
	                        ) {
	                                //Cancel the filtering
	                                return;
	                            } else {
	                            //Remember the current filter length
	                            $(this).data("dt-iLastFilterLength", iCurrentFilterLength);
	                        }
	                    }
	                    /* Filter on the column (the index) of this element */
	                    oTable.fnFilter(this.value, _fnColumnIndex(index), regex, smart); //Issue 37
	                    fnOnFiltered();
	                });
	            }
	
	            input.focus(function () {
	                if ($(this).hasClass("search_init")) {
	                    $(this).removeClass("search_init");
	                    this.value = "";
	                }
	            });
	            input.blur(function () {
	                if (this.value == "") {
	                    $(this).addClass("search_init");
	                    this.value = asInitVals[index];
	                }
	            });
	        }
	
	        function fnCreateRangeInput(oTable) {
	
	            //var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
	            th.html(_fnRangeLabelPart(0));
	            var sFromId = oTable.attr("id") + '_range_from_' + i;
	            var from = $('<input type="text" class="number_range_filter form-control" id="' + sFromId + '" rel="' + i + '"/>');
	            th.append(from);
	            th.append(_fnRangeLabelPart(1));
	            var sToId = oTable.attr("id") + '_range_to_' + i;
	            var to = $('<input type="text" class="number_range_filter form-control" id="' + sToId + '" rel="' + i + '"/>');
	            th.append(to);
	            th.append(_fnRangeLabelPart(2));
	            th.wrapInner('<span class="filter_column filter_number_range form-control" />');
	            var index = i;
	            aiCustomSearch_Indexes.push(i);
	
	            //------------start range filtering function
	
	
	            /* 	Custom filtering function which will filter data in column four between two values
	            *	Author: 	Allan Jardine, Modified by Jovan Popovic
	            */
	            //$.fn.dataTableExt.afnFiltering.push(
	            oTable.dataTableExt.afnFiltering.push(function (oSettings, aData, iDataIndex) {
	                if (oTable.attr("id") != oSettings.sTableId) return true;
	                // Try to handle missing nodes more gracefully
	                if (document.getElementById(sFromId) == null) return true;
	                var iMin = document.getElementById(sFromId).value * 1;
	                var iMax = document.getElementById(sToId).value * 1;
	                var iValue = aData[_fnColumnIndex(index)] == "-" ? 0 : aData[_fnColumnIndex(index)] * 1;
	                if (iMin == "" && iMax == "") {
	                    return true;
	                } else if (iMin == "" && iValue <= iMax) {
	                    return true;
	                } else if (iMin <= iValue && "" == iMax) {
	                    return true;
	                } else if (iMin <= iValue && iValue <= iMax) {
	                    return true;
	                }
	                return false;
	            });
	            //------------end range filtering function
	
	
	            $('#' + sFromId + ',#' + sToId, th).keyup(function () {
	
	                var iMin = document.getElementById(sFromId).value * 1;
	                var iMax = document.getElementById(sToId).value * 1;
	                if (iMin != 0 && iMax != 0 && iMin > iMax) return;
	
	                oTable.fnDraw();
	                fnOnFiltered();
	            });
	        }
	
	        function fnCreateDateRangeInput(oTable) {
	
	            var aoFragments = sRangeFormat.split(/[}{]/);
	
	            th.html("");
	            //th.html(_fnRangeLabelPart(0));
	            var sFromId = oTable.attr("id") + '_range_from_' + i;
	            var from = $('<input type="text" class="date_range_filter form-control" id="' + sFromId + '" rel="' + i + '"/>');
	            from.datepicker();
	            //th.append(from);
	            //th.append(_fnRangeLabelPart(1));
	            var sToId = oTable.attr("id") + '_range_to_' + i;
	            var to = $('<input type="text" class="date_range_filter form-control" id="' + sToId + '" rel="' + i + '"/>');
	            //th.append(to);
	            //th.append(_fnRangeLabelPart(2));
	            var ti = 0;
	
	            for (ti = 0; ti < aoFragments.length; ti++) {
	
	                if (aoFragments[ti] == properties.sDateFromToken) {
	                    th.append(from);
	                } else {
	                    if (aoFragments[ti] == properties.sDateToToken) {
	                        th.append(to);
	                    } else {
	                        th.append(aoFragments[ti]);
	                    }
	                }
	            }
	
	            th.wrapInner('<span class="filter_column filter_date_range" />');
	            to.datepicker();
	            var index = i;
	            aiCustomSearch_Indexes.push(i);
	
	            //------------start date range filtering function
	
	            //$.fn.dataTableExt.afnFiltering.push(
	            oTable.dataTableExt.afnFiltering.push(function (oSettings, aData, iDataIndex) {
	                if (oTable.attr("id") != oSettings.sTableId) return true;
	
	                var dStartDate = from.datepicker("getDate");
	
	                var dEndDate = to.datepicker("getDate");
	
	                if (dStartDate == null && dEndDate == null) {
	                    return true;
	                }
	
	                var dCellDate = null;
	                try {
	                    if (aData[_fnColumnIndex(index)] == null || aData[_fnColumnIndex(index)] == "") return false;
	                    dCellDate = $.datepicker.parseDate($.datepicker.regional[""].dateFormat, aData[_fnColumnIndex(index)]);
	                } catch (ex) {
	                    return false;
	                }
	                if (dCellDate == null) return false;
	
	                if (dStartDate == null && dCellDate <= dEndDate) {
	                    return true;
	                } else if (dStartDate <= dCellDate && dEndDate == null) {
	                    return true;
	                } else if (dStartDate <= dCellDate && dCellDate <= dEndDate) {
	                    return true;
	                }
	                return false;
	            });
	            //------------end date range filtering function
	
	            $('#' + sFromId + ',#' + sToId, th).change(function () {
	                oTable.fnDraw();
	                fnOnFiltered();
	            });
	        }
	
	        function fnCreateColumnSelect(oTable, aData, iColumn, nTh, sLabel, bRegex, oSelected, bMultiselect) {
	            if (aData == null) aData = _fnGetColumnValues(oTable.fnSettings(), iColumn, true, false, true);
	            var index = iColumn;
	            var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
	            if (currentFilter == null || currentFilter == "") //Issue 81
	                currentFilter = oSelected;
	
	            var r = '<select class="search_init select_filter form-control" rel="' + i + '"><option value="" class="search_init">' + sLabel + '</option>';
	            if (bMultiselect) {
	                r = '<select class="search_init select_filter form-control" rel="' + i + '" multiple>';
	            }
	            var j = 0;
	            var iLen = aData.length;
	            for (j = 0; j < iLen; j++) {
	                if (_typeof(aData[j]) != 'object') {
	                    var selected = '';
	                    if (escape(aData[j]) == currentFilter || escape(aData[j]) == escape(currentFilter)) selected = 'selected ';
	                    r += '<option ' + selected + ' value="' + escape(aData[j]) + '">' + aData[j] + '</option>';
	                } else {
	                    var selected = '';
	                    if (bRegex) {
	                        //Do not escape values if they are explicitely set to avoid escaping special characters in the regexp
	                        if (aData[j].value == currentFilter) selected = 'selected ';
	                        r += '<option ' + selected + 'value="' + aData[j].value + '">' + aData[j].label + '</option>';
	                    } else {
	                        if (escape(aData[j].value) == currentFilter) selected = 'selected ';
	                        r += '<option ' + selected + 'value="' + escape(aData[j].value) + '">' + aData[j].label + '</option>';
	                    }
	                }
	            }
	
	            var select = $(r + '</select>');
	            nTh.html(select);
	            nTh.wrapInner('<span class="filter_column filter_select" />');
	
	            if (bMultiselect) {
	                select.change(function () {
	                    if ($(this).val() != "") {
	                        $(this).removeClass("search_init");
	                    } else {
	                        $(this).addClass("search_init");
	                    }
	                    var selectedOptions = $(this).val();
	                    var asEscapedFilters = [];
	                    if (selectedOptions == null || selectedOptions == []) {
	                        var re = '^(.*)$';
	                    } else {
	                        $.each(selectedOptions, function (i, sFilter) {
	                            asEscapedFilters.push(fnRegExpEscape(sFilter));
	                        });
	                        var re = '^(' + asEscapedFilters.join('|') + ')$';
	                    }
	
	                    oTable.fnFilter(re, index, true, false);
	                });
	            } else {
	                select.change(function () {
	                    //var val = $(this).val();
	                    if ($(this).val() != "") {
	                        $(this).removeClass("search_init");
	                    } else {
	                        $(this).addClass("search_init");
	                    }
	                    if (bRegex) oTable.fnFilter($(this).val(), iColumn, bRegex); //Issue 41
	                    else oTable.fnFilter(unescape($(this).val()), iColumn); //Issue 25
	                    fnOnFiltered();
	                });
	                if (currentFilter != null && currentFilter != "") //Issue 81
	                    oTable.fnFilter(unescape(currentFilter), iColumn);
	            }
	        }
	
	        function fnCreateSelect(oTable, aData, bRegex, oSelected, bMultiselect) {
	            var oSettings = oTable.fnSettings();
	            if ((aData == null || typeof aData == 'function') && oSettings.sAjaxSource != "" && !oSettings.oFeatures.bServerSide) {
	                // Add a function to the draw callback, which will check for the Ajax data having 
	                // been loaded. Use a closure for the individual column elements that are used to 
	                // built the column filter, since 'i' and 'th' (etc) are locally "global".
	                oSettings.aoDrawCallback.push({
	                    "fn": function (iColumn, nTh, sLabel) {
	                        return function (oSettings) {
	                            // Only rebuild the select on the second draw - i.e. when the Ajax
	                            // data has been loaded.
	                            if (oSettings.iDraw == 2 && oSettings.sAjaxSource != null && oSettings.sAjaxSource != "" && !oSettings.oFeatures.bServerSide) {
	                                return fnCreateColumnSelect(oTable, aData && aData(oSettings.aoData, oSettings), _fnColumnIndex(iColumn), nTh, sLabel, bRegex, oSelected, bMultiselect); //Issue 37
	                            }
	                        };
	                    }(i, th, label),
	                    "sName": "column_filter_" + i
	                });
	            }
	            // Regardless of the Ajax state, build the select on first pass
	            fnCreateColumnSelect(oTable, typeof aData == 'function' ? null : aData, _fnColumnIndex(i), th, label, bRegex, oSelected, bMultiselect); //Issue 37
	        }
	
	        function fnRegExpEscape(sText) {
	            return sText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	        };
	
	        function fnCreateDropdown(aData) {
	            var index = i;
	            var r = '<div class="dropdown select_filter form-control"><a class="dropdown-toggle" data-toggle="dropdown" href="#">' + label + '<b class="caret"></b></a><ul class="dropdown-menu" role="menu"><li data-value=""><a>Show All</a></li>',
	                j,
	                iLen = aData.length;
	
	            for (j = 0; j < iLen; j++) {
	                r += '<li data-value="' + aData[j] + '"><a>' + aData[j] + '</a></li>';
	            }
	            var select = $(r + '</ul></div>');
	            th.html(select);
	            th.wrapInner('<span class="filterColumn filter_select" />');
	            select.find('li').click(function () {
	                oTable.fnFilter($(this).data('value'), index);
	            });
	        }
	
	        function fnCreateCheckbox(oTable, aData) {
	
	            if (aData == null) aData = _fnGetColumnValues(oTable.fnSettings(), i, true, true, true);
	            var index = i;
	
	            var r = '',
	                j,
	                iLen = aData.length;
	
	            //clean the string
	            var localLabel = label.replace('%', 'Perc').replace("&", "AND").replace("$", "DOL").replace("£", "STERL").replace("@", "AT").replace(/\s/g, "_");
	            localLabel = localLabel.replace(/[^a-zA-Z 0-9]+/g, '');
	            //clean the string
	
	            //button label override
	            var labelBtn = label;
	            if (properties.sFilterButtonText != null || properties.sFilterButtonText != undefined) {
	                labelBtn = properties.sFilterButtonText;
	            }
	
	            var relativeDivWidthToggleSize = 10;
	            var numRow = 12; //numero di checkbox per colonna
	            var numCol = Math.floor(iLen / numRow);
	            if (iLen % numRow > 0) {
	                numCol = numCol + 1;
	            };
	
	            //count how many column should be generated and split the div size
	            var divWidth = 100 / numCol - 2;
	
	            var divWidthToggle = relativeDivWidthToggleSize * numCol;
	
	            if (numCol == 1) {
	                divWidth = 20;
	            }
	
	            var divRowDef = '<div style="float:left; min-width: ' + divWidth + '%; " >';
	            var divClose = '</div>';
	
	            var uniqueId = oTable.attr("id") + localLabel;
	            var buttonId = "chkBtnOpen" + uniqueId;
	            var checkToggleDiv = uniqueId + "-flt-toggle";
	            r += '<button id="' + buttonId + '" class="checkbox_filter btn btn-default" > ' + labelBtn + '</button>'; //filter button witch open dialog
	            r += '<div id="' + checkToggleDiv + '" ' + 'title="' + label + '" ' + 'rel="' + i + '" ' + 'class="toggle-check ui-widget-content ui-corner-all"  style="width: ' + divWidthToggle + '%; " >'; //dialog div
	            //r+= '<div align="center" style="margin-top: 5px; "> <button id="'+buttonId+'Reset" class="checkbox_filter" > reset </button> </div>'; //reset button and its div
	            r += divRowDef;
	
	            for (j = 0; j < iLen; j++) {
	
	                //if last check close div
	                if (j % numRow == 0 && j != 0) {
	                    r += divClose + divRowDef;
	                }
	
	                var sLabel = aData[j];
	                var sValue = aData[j];
	
	                if (_typeof(aData[j]) == 'object') {
	                    sLabel = aData[j].label;
	                    sValue = aData[j].value;
	                }
	
	                //check button
	                r += '<input class="search_init checkbox_filter btn btn-default" type="checkbox" id= "' + uniqueId + '_cb_' + sValue + '" name= "' + localLabel + '" value="' + sValue + '" >' + sLabel + '<br/>';
	
	                var checkbox = $(r);
	                th.html(checkbox);
	                th.wrapInner('<span class="filter_column filter_checkbox" />');
	                //on every checkbox selection
	                checkbox.change(function () {
	
	                    var search = '';
	                    var or = '|'; //var for select checks in 'or' into the regex
	                    var resSize = $('input:checkbox[name="' + localLabel + '"]:checked').size();
	                    $('input:checkbox[name="' + localLabel + '"]:checked').each(function (index) {
	
	                        //search = search + ' ' + $(this).val();
	                        //concatenation for selected checks in or
	                        if (index == 0 && resSize == 1 || index != 0 && index == resSize - 1) {
	                            or = '';
	                        }
	                        //trim
	                        search = search.replace(/^\s+|\s+$/g, "");
	                        search = search + $(this).val() + or;
	                        or = '|';
	                    });
	
	                    if (search != "") {
	                        $('input:checkbox[name="' + localLabel + '"]').removeClass("search_init");
	                    } else {
	                        $('input:checkbox[name="' + localLabel + '"]').addClass("search_init");
	                    }
	                    /* Old code for setting search_init CSS class on checkboxes if any of them is checked
	                    for (var jj = 0; jj < iLen; jj++) {
	                        if (search != "") {
	                            $('#' + aData[jj]).removeClass("search_init");
	                        } else {
	                            $('#' + aData[jj]).addClass("search_init");
	                        }
	                    }
	                    */
	
	                    //execute search
	                    oTable.fnFilter(search, index, true, false);
	                    fnOnFiltered();
	                });
	            }
	
	            //filter button
	            $('#' + buttonId).button();
	            //dialog
	            $('#' + checkToggleDiv).dialog({
	                //height: 140,
	                autoOpen: false,
	                //show: "blind",
	                hide: "blind",
	                buttons: [{
	                    text: "Reset",
	                    click: function click() {
	                        //$('#'+buttonId).removeClass("filter_selected"); //LM remove border if filter selected
	                        $('input:checkbox[name="' + localLabel + '"]:checked').each(function (index3) {
	                            $(this).attr('checked', false);
	                            $(this).addClass("search_init");
	                        });
	                        oTable.fnFilter('', index, true, false);
	                        fnOnFiltered();
	                        return false;
	                    }
	                }, {
	                    text: "Close",
	                    click: function click() {
	                        $(this).dialog("close");
	                    }
	                }]
	            });
	
	            $('#' + buttonId).click(function () {
	
	                $('#' + checkToggleDiv).dialog('open');
	                var target = $(this);
	                $('#' + checkToggleDiv).dialog("widget").position({ my: 'top',
	                    at: 'bottom',
	                    of: target
	                });
	
	                return false;
	            });
	
	            var fnOnFilteredCurrent = fnOnFiltered;
	
	            fnOnFiltered = function fnOnFiltered() {
	                var target = $('#' + buttonId);
	                $('#' + checkToggleDiv).dialog("widget").position({ my: 'top',
	                    at: 'bottom',
	                    of: target
	                });
	                fnOnFilteredCurrent();
	            };
	            //reset
	            /*
	            $('#'+buttonId+"Reset").button();
	            $('#'+buttonId+"Reset").click(function(){
	            $('#'+buttonId).removeClass("filter_selected"); //LM remove border if filter selected
	            $('input:checkbox[name="'+localLabel+'"]:checked').each(function(index3) {
	            $(this).attr('checked', false);
	            $(this).addClass("search_init");
	            });
	            oTable.fnFilter('', index, true, false);
	            return false;
	            }); 
	            */
	        }
	
	        function _fnRangeLabelPart(iPlace) {
	            switch (iPlace) {
	                case 0:
	                    return sRangeFormat.substring(0, sRangeFormat.indexOf("{from}"));
	                case 1:
	                    return sRangeFormat.substring(sRangeFormat.indexOf("{from}") + 6, sRangeFormat.indexOf("{to}"));
	                default:
	                    return sRangeFormat.substring(sRangeFormat.indexOf("{to}") + 4);
	            }
	        }
	
	        var oTable = this;
	
	        var defaults = {
	            sPlaceHolder: "foot",
	            sRangeSeparator: "~",
	            iFilteringDelay: 500,
	            aoColumns: null,
	            sRangeFormat: "From {from} to {to}",
	            sDateFromToken: "from",
	            sDateToToken: "to"
	        };
	
	        var properties = $.extend(defaults, options);
	
	        return this.each(function () {
	
	            if (!oTable.fnSettings().oFeatures.bFilter) return;
	            asInitVals = new Array();
	
	            var aoFilterCells = oTable.fnSettings().aoFooter[0];
	
	            var oHost = oTable.fnSettings().nTFoot; //Before fix for ColVis
	            var sFilterRow = "tr"; //Before fix for ColVis
	            var bRegex, bSmart, j;
	
	            //$(sFilterRow + " th", oHost).each(function (index) {//bug with ColVis
	            $(aoFilterCells).each(function (index) {
	                //fix for ColVis
	                i = index;
	                var aoColumn = { type: "text",
	                    bRegex: false,
	                    bSmart: true,
	                    iMaxLenght: -1,
	                    iFilterLength: 0
	                };
	                if (properties.aoColumns != null) {
	                    if (properties.aoColumns.length < i || properties.aoColumns[i] == null) return;
	                    aoColumn = properties.aoColumns[i];
	                }
	                //label = $(this).text(); //Before fix for ColVis
	                label = $($(this)[0].cell).text(); //Fix for ColVis
	                if (aoColumn.sSelector == null) {
	                    //th = $($(this)[0]);//Before fix for ColVis
	                    th = $($(this)[0].cell); //Fix for ColVis
	                } else {
	                    th = $(aoColumn.sSelector);
	                    if (th.length == 0) th = $($(this)[0].cell);
	                }
	
	                if (aoColumn != null) {
	                    if (aoColumn.sRangeFormat != null) sRangeFormat = aoColumn.sRangeFormat;else sRangeFormat = properties.sRangeFormat;
	                    switch (aoColumn.type) {
	                        case "null":
	                            break;
	                        case "number":
	                            fnCreateInput(oTable, true, false, true, aoColumn.iFilterLength, aoColumn.iMaxLenght);
	                            break;
	                        case "select":
	                            if (aoColumn.bRegex != true) aoColumn.bRegex = false;
	                            fnCreateSelect(oTable, aoColumn.values, aoColumn.bRegex, aoColumn.selected, aoColumn.multiple);
	                            break;
	                        case "number-range":
	                            fnCreateRangeInput(oTable);
	                            break;
	                        case "date-range":
	                            fnCreateDateRangeInput(oTable);
	                            break;
	                        case "checkbox":
	                            fnCreateCheckbox(oTable, aoColumn.values);
	                            break;
	                        case "twitter-dropdown":
	                        case "dropdown":
	                            fnCreateDropdown(aoColumn.values);
	                            break;
	                        case "text":
	                        default:
	                            bRegex = aoColumn.bRegex == null ? false : aoColumn.bRegex;
	                            bSmart = aoColumn.bSmart == null ? false : aoColumn.bSmart;
	                            fnCreateInput(oTable, bRegex, bSmart, false, aoColumn.iFilterLength, aoColumn.iMaxLenght);
	                            break;
	
	                    }
	                }
	            });
	
	            for (j = 0; j < aiCustomSearch_Indexes.length; j++) {
	                //var index = aiCustomSearch_Indexes[j];
	                var fnSearch_ = function fnSearch_() {
	                    var id = oTable.attr("id");
	                    return $("#" + id + "_range_from_" + aiCustomSearch_Indexes[j]).val() + properties.sRangeSeparator + $("#" + id + "_range_to_" + aiCustomSearch_Indexes[j]).val();
	                };
	                afnSearch_.push(fnSearch_);
	            }
	
	            if (oTable.fnSettings().oFeatures.bServerSide) {
	
	                var fnServerDataOriginal = oTable.fnSettings().fnServerData;
	
	                oTable.fnSettings().fnServerData = function (sSource, aoData, fnCallback) {
	
	                    for (j = 0; j < aiCustomSearch_Indexes.length; j++) {
	                        var index = aiCustomSearch_Indexes[j];
	
	                        for (k = 0; k < aoData.length; k++) {
	                            if (aoData[k].name == "sSearch_" + index) aoData[k].value = afnSearch_[j]();
	                        }
	                    }
	                    aoData.push({ "name": "sRangeSeparator", "value": properties.sRangeSeparator });
	
	                    if (fnServerDataOriginal != null) {
	                        try {
	                            fnServerDataOriginal(sSource, aoData, fnCallback, oTable.fnSettings()); //TODO: See Issue 18
	                        } catch (ex) {
	                            fnServerDataOriginal(sSource, aoData, fnCallback);
	                        }
	                    } else {
	                        $.getJSON(sSource, aoData, function (json) {
	                            fnCallback(json);
	                        });
	                    }
	                };
	            }
	        });
	    };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	(function () {
	  'use strict';
	
	  setWrappers.$inject = ["formlyConfigProvider"];
	  setFields.$inject = ["formlyConfig", "formlyApiCheck"];
	  setDefaults.$inject = ["formlyConfig", "formlyValidationMessages"];
	  cacheTemplates.$inject = ["$templateCache"];
	  var USING_TEMPLATES = true;
	  /* Custom validation message defaults here */
	  var VALIDATION_MESSAGES = [{
	    name: 'required', message: 'This field is required'
	  }, {
	    name: 'maxlength', message: 'This field is too long.'
	  }, {
	    name: 'minlength', message: 'This field is too short.'
	  }];
	  /* Module Templates + Data */
	  var MODULE_NAME = 'formlyLumx';
	  var PREFIX = 'lx';
	  var FIELDS = [{
	    name: 'checkbox',
	    template: __webpack_require__(334),
	    apiCheck: function apiCheck(check) {
	      return {
	        templateOptions: {
	          label: check.string,
	          description: check.string,
	          checked: check.boolean,
	          required: check.boolean
	        }
	      };
	    }
	  }, {
	    name: 'date-picker',
	    template: __webpack_require__(335),
	    apiCheck: function apiCheck(check) {
	      return {
	        templateOptions: {
	          'label': check.string,
	          'required': check.boolean
	        }
	      };
	    }
	    //}, {
	    //  name: 'dropdown',
	    //  template: require('./fields/lx-dropdown.html')
	  }, {
	    name: 'flex',
	    template: __webpack_require__(336),
	    apiCheck: function apiCheck(check) {
	      return {};
	    }
	  }, {
	    name: 'input',
	    template: __webpack_require__(337),
	    apiCheck: function apiCheck(check) {
	      return {
	        templateOptions: {
	          label: check.string,
	          icon: check.string,
	          fixedLabel: check.boolean,
	          disabled: check.boolean,
	          className: check.string,
	          theme: check.oneOf(['light', 'dark']),
	          type: check.oneOf(['text', 'number', 'email', 'password', 'url', 'tel']),
	          required: check.boolean
	        }
	      };
	    }
	  }, {
	    name: 'radio',
	    template: __webpack_require__(338),
	    apiCheck: function apiCheck(check) {
	      return {
	        templateOptions: {
	          label: check.string,
	          description: check.string,
	          options: check.arrayOf({
	            name: check.string,
	            value: check.oneOfType([check.string, check.number]),
	            disabled: check.boolean
	          }),
	          inline: check.boolean,
	          required: check.boolean
	        }
	      };
	    }
	  }, {
	    name: 'select',
	    template: __webpack_require__(339),
	    apiCheck: function apiCheck(check) {
	      return {
	        templateOptions: {
	          label: check.string,
	          placeholder: check.string,
	          'min-length': check.number,
	          'allow-clear': check.boolean,
	          'ng-attr-multiple': check.boolean,
	          selected: check.string,
	          selected2: check.string,
	          choice: check.string,
	          choice2: check.string,
	          choices: check.array,
	          required: check.boolean
	        }
	      };
	    }
	    //}, {
	    //	name: 'select-async',
	    //	template: require('./fields/lx-select-async.html')
	  }, {
	    name: 'switch',
	    template: __webpack_require__(340),
	    apiCheck: function apiCheck(check) {
	      return {
	        templateOptions: {
	          label: check.string,
	          description: check.string,
	          checked: check.boolean,
	          required: check.boolean
	        }
	      };
	    }
	  }, {
	    name: 'textarea',
	    template: __webpack_require__(341),
	    apiCheck: function apiCheck(check) {
	      return {
	        templateOptions: {
	          label: check.string,
	          icon: check.string,
	          theme: check.oneOf(['light', 'dark']),
	          required: check.boolean,
	          rows: check.number,
	          cols: check.number
	        }
	      };
	    }
	  }];
	  var WRAPPERS = [{
	    name: 'wrapper-div',
	    template: __webpack_require__(342)
	  }, {
	    name: 'wrapper-errors',
	    template: __webpack_require__(343)
	  }, {
	    name: 'wrapper-flex',
	    template: __webpack_require__(344)
	  }, {
	    name: 'wrapper-inline',
	    template: __webpack_require__(345)
	  }];
	
	  function _prefixer(name) {
	    return PREFIX + '-' + name;
	  }
	
	  function _wrapperTemplateUrl(name) {
	    return 'wrappers/formly-wrappers-' + _prefixer(name) + '.html';
	  }
	
	  function _fieldTemplateUrl(name) {
	    return 'fields/formly-fields-' + _prefixer(name) + '.html';
	  }
	
	  /*@ngInject*/
	  function setWrappers(formlyConfigProvider) {
	    if (USING_TEMPLATES) {
	      WRAPPERS.map(function (wrapper) {
	        formlyConfigProvider.setWrapper({
	          name: _prefixer(wrapper.name),
	          templateUrl: _wrapperTemplateUrl(wrapper.name)
	        });
	        return _prefixer(wrapper.name);
	      });
	    }
	  }
	
	  /*@ngInject*/
	  function setFields(formlyConfig, formlyApiCheck) {
	    var c = formlyApiCheck;
	    if (USING_TEMPLATES) {
	      FIELDS.map(function (field) {
	        formlyConfig.setType({
	          name: _prefixer(field.name),
	          templateUrl: _fieldTemplateUrl(field.name),
	          apiCheck: function apiCheck(c) {
	            return field.apiCheck;
	          }
	        });
	      });
	    }
	  }
	
	  function setDefaults(formlyConfig, formlyValidationMessages) {
	    formlyConfig.extras.ngModelAttrsManipulatorPreferBound = true;
	    VALIDATION_MESSAGES.map(function (validation) {
	      formlyValidationMessages.addStringMessage(validation.name, validation.message);
	    });
	    formlyValidationMessages.messages.pattern = function (viewValue, modelValue) {
	      return (viewValue || modelValue) + ' is invalid';
	    };
	  }
	
	  function cacheTemplates($templateCache) {
	    if (USING_TEMPLATES) {
	      FIELDS.map(function (field) {
	        $templateCache.put(_fieldTemplateUrl(field.name), field.template);
	      });
	      WRAPPERS.map(function (wrapper) {
	        $templateCache.put(_wrapperTemplateUrl(wrapper.name), wrapper.template);
	      });
	    }
	  }
	
	  angular.module(MODULE_NAME, ['formly']).config(setWrappers).run(setFields).run(setDefaults).run(cacheTemplates);
	})();

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';
	
	/*
	 LumX v1.0.0rc4
	 (c) 2014-2016 LumApps http://ui.lumapps.com
	 License: MIT
	*/
	(function () {
	    'use strict';
	
	    angular.module('lumx.utils.depth', []);
	    angular.module('lumx.utils.event-scheduler', []);
	    angular.module('lumx.utils.transclude-replace', []);
	    angular.module('lumx.utils.utils', []);
	
	    angular.module('lumx.utils', ['lumx.utils.depth', 'lumx.utils.event-scheduler', 'lumx.utils.transclude-replace', 'lumx.utils.utils']);
	
	    angular.module('lumx.button', []);
	    angular.module('lumx.checkbox', []);
	    angular.module('lumx.date-picker', []);
	    angular.module('lumx.dialog', ['lumx.utils.event-scheduler']);
	    angular.module('lumx.dropdown', ['lumx.utils.event-scheduler']);
	    angular.module('lumx.fab', []);
	    angular.module('lumx.file-input', []);
	    angular.module('lumx.icon', []);
	    angular.module('lumx.notification', ['lumx.utils.event-scheduler']);
	    angular.module('lumx.progress', []);
	    angular.module('lumx.radio-button', []);
	    angular.module('lumx.ripple', []);
	    angular.module('lumx.search-filter', []);
	    angular.module('lumx.select', []);
	    angular.module('lumx.switch', []);
	    angular.module('lumx.tabs', []);
	    angular.module('lumx.text-field', []);
	    angular.module('lumx.tooltip', []);
	
	    angular.module('lumx', ['lumx.button', 'lumx.checkbox', 'lumx.date-picker', 'lumx.dialog', 'lumx.dropdown', 'lumx.fab', 'lumx.file-input', 'lumx.icon', 'lumx.notification', 'lumx.progress', 'lumx.radio-button', 'lumx.ripple', 'lumx.search-filter', 'lumx.select', 'lumx.switch', 'lumx.tabs', 'lumx.text-field', 'lumx.tooltip', 'lumx.utils']);
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.utils.depth').service('LxDepthService', LxDepthService);
	
	    function LxDepthService() {
	        var service = this;
	        var depth = 1000;
	
	        service.getDepth = getDepth;
	        service.register = register;
	
	        ////////////
	
	        function getDepth() {
	            return depth;
	        }
	
	        function register() {
	            depth++;
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.utils.event-scheduler').service('LxEventSchedulerService', LxEventSchedulerService);
	
	    LxEventSchedulerService.$inject = ['$document', 'LxUtils'];
	
	    function LxEventSchedulerService($document, LxUtils) {
	        var service = this;
	        var handlers = {};
	        var schedule = {};
	
	        service.register = register;
	        service.unregister = unregister;
	
	        ////////////
	
	        function handle(event) {
	            var scheduler = schedule[event.type];
	
	            if (angular.isDefined(scheduler)) {
	                for (var i = 0, length = scheduler.length; i < length; i++) {
	                    var handler = scheduler[i];
	
	                    if (angular.isDefined(handler) && angular.isDefined(handler.callback) && angular.isFunction(handler.callback)) {
	                        handler.callback(event);
	
	                        if (event.isPropagationStopped()) {
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	
	        function register(eventName, callback) {
	            var handler = {
	                eventName: eventName,
	                callback: callback
	            };
	
	            var id = LxUtils.generateUUID();
	            handlers[id] = handler;
	
	            if (angular.isUndefined(schedule[eventName])) {
	                schedule[eventName] = [];
	
	                $document.on(eventName, handle);
	            }
	            schedule[eventName].unshift(handlers[id]);
	
	            return id;
	        }
	
	        function unregister(id) {
	            var found = false;
	            var handler = handlers[id];
	
	            if (angular.isDefined(handler) && angular.isDefined(schedule[handler.eventName])) {
	                var index = schedule[handler.eventName].indexOf(handler);
	
	                if (angular.isDefined(index) && index > -1) {
	                    schedule[handler.eventName].splice(index, 1);
	
	                    delete handlers[id];
	                    found = true;
	                }
	
	                if (schedule[handler.eventName].length === 0) {
	                    delete schedule[handler.eventName];
	
	                    $document.off(handler.eventName, handle);
	                }
	            }
	
	            return found;
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.utils.transclude-replace').directive('ngTranscludeReplace', ngTranscludeReplace);
	
	    ngTranscludeReplace.$inject = ['$log'];
	
	    function ngTranscludeReplace($log) {
	        return {
	            terminal: true,
	            restrict: 'EA',
	            link: link
	        };
	
	        function link(scope, element, attrs, ctrl, transclude) {
	            if (!transclude) {
	                $log.error('orphan', 'Illegal use of ngTranscludeReplace directive in the template! ' + 'No parent directive that requires a transclusion found. ');
	                return;
	            }
	
	            transclude(function (clone) {
	                if (clone.length) {
	                    element.replaceWith(clone);
	                } else {
	                    element.remove();
	                }
	            });
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.utils.utils').service('LxUtils', LxUtils);
	
	    function LxUtils() {
	        var service = this;
	
	        service.generateUUID = generateUUID;
	
	        ////////////
	
	        function generateUUID() {
	            var d = new Date().getTime();
	
	            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = (d + Math.random() * 16) % 16 | 0;
	                d = Math.floor(d / 16);
	                return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	            });
	
	            return uuid.toUpperCase();
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.button').directive('lxButton', lxButton);
	
	    function lxButton() {
	        var buttonClass;
	
	        return {
	            restrict: 'E',
	            templateUrl: getTemplateUrl,
	            compile: compile,
	            replace: true,
	            transclude: true
	        };
	
	        function compile(element, attrs) {
	            setButtonStyle(element, attrs.lxSize, attrs.lxColor, attrs.lxType);
	
	            return function (scope, element, attrs) {
	                attrs.$observe('lxSize', function (lxSize) {
	                    setButtonStyle(element, lxSize, attrs.lxColor, attrs.lxType);
	                });
	
	                attrs.$observe('lxColor', function (lxColor) {
	                    setButtonStyle(element, attrs.lxSize, lxColor, attrs.lxType);
	                });
	
	                attrs.$observe('lxType', function (lxType) {
	                    setButtonStyle(element, attrs.lxSize, attrs.lxColor, lxType);
	                });
	
	                element.on('click', function (event) {
	                    if (attrs.disabled === true) {
	                        event.preventDefault();
	                        event.stopImmediatePropagation();
	                    }
	                });
	            };
	        }
	
	        function getTemplateUrl(element, attrs) {
	            return isAnchor(attrs) ? 'link.html' : 'button.html';
	        }
	
	        function isAnchor(attrs) {
	            return angular.isDefined(attrs.href) || angular.isDefined(attrs.ngHref) || angular.isDefined(attrs.ngLink) || angular.isDefined(attrs.uiSref);
	        }
	
	        function setButtonStyle(element, size, color, type) {
	            var buttonBase = 'btn';
	            var buttonSize = angular.isDefined(size) ? size : 'm';
	            var buttonColor = angular.isDefined(color) ? color : 'primary';
	            var buttonType = angular.isDefined(type) ? type : 'raised';
	
	            element.removeClass(buttonClass);
	
	            buttonClass = buttonBase + ' btn--' + buttonSize + ' btn--' + buttonColor + ' btn--' + buttonType;
	
	            element.addClass(buttonClass);
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.checkbox').directive('lxCheckbox', lxCheckbox).directive('lxCheckboxLabel', lxCheckboxLabel).directive('lxCheckboxHelp', lxCheckboxHelp);
	
	    function lxCheckbox() {
	        return {
	            restrict: 'E',
	            templateUrl: 'checkbox.html',
	            scope: {
	                lxColor: '@?',
	                name: '@?',
	                ngChange: '&?',
	                ngDisabled: '=?',
	                ngFalseValue: '@?',
	                ngModel: '=',
	                ngTrueValue: '@?'
	            },
	            controller: LxCheckboxController,
	            controllerAs: 'lxCheckbox',
	            bindToController: true,
	            transclude: true,
	            replace: true
	        };
	    }
	
	    LxCheckboxController.$inject = ['$scope', '$timeout', 'LxUtils'];
	
	    function LxCheckboxController($scope, $timeout, LxUtils) {
	        var lxCheckbox = this;
	        var checkboxId;
	        var checkboxHasChildren;
	        var timer;
	
	        lxCheckbox.getCheckboxId = getCheckboxId;
	        lxCheckbox.getCheckboxHasChildren = getCheckboxHasChildren;
	        lxCheckbox.setCheckboxId = setCheckboxId;
	        lxCheckbox.setCheckboxHasChildren = setCheckboxHasChildren;
	        lxCheckbox.triggerNgChange = triggerNgChange;
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer);
	        });
	
	        init();
	
	        ////////////
	
	        function getCheckboxId() {
	            return checkboxId;
	        }
	
	        function getCheckboxHasChildren() {
	            return checkboxHasChildren;
	        }
	
	        function init() {
	            setCheckboxId(LxUtils.generateUUID());
	            setCheckboxHasChildren(false);
	
	            lxCheckbox.ngTrueValue = angular.isUndefined(lxCheckbox.ngTrueValue) ? true : lxCheckbox.ngTrueValue;
	            lxCheckbox.ngFalseValue = angular.isUndefined(lxCheckbox.ngFalseValue) ? false : lxCheckbox.ngFalseValue;
	            lxCheckbox.lxColor = angular.isUndefined(lxCheckbox.lxColor) ? 'accent' : lxCheckbox.lxColor;
	        }
	
	        function setCheckboxId(_checkboxId) {
	            checkboxId = _checkboxId;
	        }
	
	        function setCheckboxHasChildren(_checkboxHasChildren) {
	            checkboxHasChildren = _checkboxHasChildren;
	        }
	
	        function triggerNgChange() {
	            timer = $timeout(lxCheckbox.ngChange);
	        }
	    }
	
	    function lxCheckboxLabel() {
	        return {
	            restrict: 'AE',
	            require: ['^lxCheckbox', '^lxCheckboxLabel'],
	            templateUrl: 'checkbox-label.html',
	            link: link,
	            controller: LxCheckboxLabelController,
	            controllerAs: 'lxCheckboxLabel',
	            bindToController: true,
	            transclude: true,
	            replace: true
	        };
	
	        function link(scope, element, attrs, ctrls) {
	            ctrls[0].setCheckboxHasChildren(true);
	            ctrls[1].setCheckboxId(ctrls[0].getCheckboxId());
	        }
	    }
	
	    function LxCheckboxLabelController() {
	        var lxCheckboxLabel = this;
	        var checkboxId;
	
	        lxCheckboxLabel.getCheckboxId = getCheckboxId;
	        lxCheckboxLabel.setCheckboxId = setCheckboxId;
	
	        ////////////
	
	        function getCheckboxId() {
	            return checkboxId;
	        }
	
	        function setCheckboxId(_checkboxId) {
	            checkboxId = _checkboxId;
	        }
	    }
	
	    function lxCheckboxHelp() {
	        return {
	            restrict: 'AE',
	            require: '^lxCheckbox',
	            templateUrl: 'checkbox-help.html',
	            transclude: true,
	            replace: true
	        };
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.date-picker').directive('lxDatePicker', lxDatePicker);
	
	    lxDatePicker.$inject = ['LxDatePickerService', 'LxUtils'];
	
	    function lxDatePicker(LxDatePickerService, LxUtils) {
	        return {
	            restrict: 'AE',
	            templateUrl: 'date-picker.html',
	            scope: {
	                autoClose: '=?lxAutoClose',
	                callback: '&?lxCallback',
	                color: '@?lxColor',
	                escapeClose: '=?lxEscapeClose',
	                inputFormat: '@?lxInputFormat',
	                maxDate: '=?lxMaxDate',
	                ngModel: '=',
	                minDate: '=?lxMinDate',
	                locale: '@lxLocale',
	                completedDates: '=lxCompletedDates',
	                incompleteDates: '=lxIncompletedDates'
	            },
	            link: link,
	            controller: LxDatePickerController,
	            controllerAs: 'lxDatePicker',
	            bindToController: true,
	            replace: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs) {
	            if (angular.isDefined(attrs.id)) {
	                attrs.$observe('id', function (_newId) {
	                    scope.lxDatePicker.pickerId = _newId;
	                    LxDatePickerService.registerScope(scope.lxDatePicker.pickerId, scope);
	                });
	            } else {
	                scope.lxDatePicker.pickerId = LxUtils.generateUUID();
	                LxDatePickerService.registerScope(scope.lxDatePicker.pickerId, scope);
	            }
	        }
	    }
	
	    LxDatePickerController.$inject = ['$element', '$scope', '$timeout', '$transclude', 'LxDatePickerService'];
	
	    function LxDatePickerController($element, $scope, $timeout, $transclude, LxDatePickerService) {
	        var lxDatePicker = this;
	        var input;
	        var modelController;
	        var timer1;
	        var timer2;
	
	        lxDatePicker.closeDatePicker = closeDatePicker;
	        lxDatePicker.displayYearSelection = displayYearSelection;
	        lxDatePicker.hideYearSelection = hideYearSelection;
	        lxDatePicker.getDateFormatted = getDateFormatted;
	        lxDatePicker.nextMonth = nextMonth;
	        lxDatePicker.openDatePicker = openDatePicker;
	        lxDatePicker.previousMonth = previousMonth;
	        lxDatePicker.select = select;
	        lxDatePicker.selectYear = selectYear;
	
	        lxDatePicker.autoClose = angular.isDefined(lxDatePicker.autoClose) ? lxDatePicker.autoClose : true;
	        lxDatePicker.color = angular.isDefined(lxDatePicker.color) ? lxDatePicker.color : 'primary';
	        lxDatePicker.element = $element.find('.lx-date-picker');
	        lxDatePicker.escapeClose = angular.isDefined(lxDatePicker.escapeClose) ? lxDatePicker.escapeClose : true;
	        lxDatePicker.isOpen = false;
	        lxDatePicker.moment = moment;
	        lxDatePicker.yearSelection = false;
	
	        $transclude(function (clone) {
	            if (clone.length) {
	                lxDatePicker.hasInput = true;
	
	                timer1 = $timeout(function () {
	                    input = $element.find('.lx-date-input input');
	                    modelController = input.data('$ngModelController');
	                });
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer1);
	            $timeout.cancel(timer2);
	        });
	
	        init();
	
	        ////////////
	
	        function closeDatePicker() {
	            LxDatePickerService.close(lxDatePicker.pickerId);
	        }
	
	        function displayYearSelection() {
	            lxDatePicker.yearSelection = true;
	
	            timer2 = $timeout(function () {
	                var yearSelector = $element.find('.lx-date-picker__year-selector');
	                var activeYear = yearSelector.find('.lx-date-picker__year--is-active');
	
	                yearSelector.scrollTop(yearSelector.scrollTop() + activeYear.position() ? activeYear.position().top : 0 - yearSelector.height() / 2 + activeYear.height() / 2);
	            });
	        }
	
	        function hideYearSelection() {
	            lxDatePicker.yearSelection = false;
	        }
	
	        function generateCalendar() {
	            lxDatePicker.days = [];
	
	            var previousDay = angular.copy(lxDatePicker.ngModelMoment).date(0);
	            var firstDayOfMonth = angular.copy(lxDatePicker.ngModelMoment).date(1);
	            var lastDayOfMonth = moment(firstDayOfMonth).endOf('month');
	            var maxDays = lastDayOfMonth.date();
	
	            lxDatePicker.emptyFirstDays = [];
	
	            for (var i = firstDayOfMonth.day() === 0 ? 6 : firstDayOfMonth.day() - 1; i > 0; i--) {
	                lxDatePicker.emptyFirstDays.push({});
	            }
	
	            $timeout(function () {
	                for (var j = 0; j < maxDays; j++) {
	                    var date = angular.copy(previousDay.add(1, 'days'));
	                    date.selected = angular.isDefined(lxDatePicker.ngModel) && date.isSame(lxDatePicker.ngModel, 'day');
	                    date.today = date.isSame(moment(), 'day');
	
	                    if (angular.isDefined(lxDatePicker.incompleteDates) && lxDatePicker.incompleteDates.indexOf(date.format('DD/MM/YYYY')) > -1 && !date.selected) {
	                        date.incomplete = true;
	                    }
	
	                    if (angular.isDefined(lxDatePicker.completedDates) && lxDatePicker.completedDates.indexOf(date.format('DD/MM/YYYY')) > -1 && !date.selected) {
	                        date.complete = true;
	                    }
	
	                    if (angular.isDefined(lxDatePicker.minDate) && date.toDate() < lxDatePicker.minDate) {
	                        date.disabled = true;
	                    }
	
	                    if (angular.isDefined(lxDatePicker.maxDate) && date.toDate() > lxDatePicker.maxDate) {
	                        date.disabled = true;
	                    }
	
	                    lxDatePicker.days.push(date);
	                }
	            }, 100);
	
	            lxDatePicker.emptyLastDays = [];
	
	            for (var k = 7 - (lastDayOfMonth.day() === 0 ? 7 : lastDayOfMonth.day()); k > 0; k--) {
	                lxDatePicker.emptyLastDays.push({});
	            }
	        }
	
	        function getDateFormatted() {
	            var dateFormatted = lxDatePicker.ngModelMoment.format('llll').replace(lxDatePicker.ngModelMoment.format('LT'), '').trim().replace(lxDatePicker.ngModelMoment.format('YYYY'), '').trim();
	            var dateFormattedLastChar = dateFormatted.slice(-1);
	
	            if (dateFormattedLastChar === ',') {
	                dateFormatted = dateFormatted.slice(0, -1);
	            }
	
	            return dateFormatted;
	        }
	
	        function init() {
	            moment.locale(lxDatePicker.locale);
	
	            lxDatePicker.ngModelMoment = angular.isDefined(lxDatePicker.ngModel) ? moment(angular.copy(lxDatePicker.ngModel)) : moment();
	            lxDatePicker.days = [];
	            lxDatePicker.daysOfWeek = [moment.weekdaysMin(1), moment.weekdaysMin(2), moment.weekdaysMin(3), moment.weekdaysMin(4), moment.weekdaysMin(5), moment.weekdaysMin(6), moment.weekdaysMin(0)];
	            lxDatePicker.years = [];
	
	            for (var y = moment().year() - 100; y <= moment().year() + 100; y++) {
	                lxDatePicker.years.push(y);
	            }
	
	            generateCalendar();
	        }
	
	        function nextMonth() {
	            lxDatePicker.ngModelMoment = lxDatePicker.ngModelMoment.add(1, 'month');
	            $scope.$emit('calendarRefresh', { message: lxDatePicker.ngModelMoment });
	            $timeout(function () {
	                generateCalendar();
	            }, 150);
	        }
	
	        function openDatePicker() {
	            LxDatePickerService.open(lxDatePicker.pickerId);
	        }
	
	        function previousMonth() {
	            lxDatePicker.ngModelMoment = lxDatePicker.ngModelMoment.subtract(1, 'month');
	            $scope.$emit("calendarRefresh", { message: lxDatePicker.ngModelMoment });
	            $timeout(function () {
	                generateCalendar();
	            }, 150);
	        }
	
	        function select(_day) {
	            if (!_day.disabled) {
	                lxDatePicker.ngModel = _day.toDate();
	                lxDatePicker.ngModelMoment = angular.copy(_day);
	
	                if (angular.isDefined(lxDatePicker.callback)) {
	                    lxDatePicker.callback({
	                        newDate: lxDatePicker.ngModel
	                    });
	                }
	
	                if (angular.isDefined(modelController) && lxDatePicker.inputFormat) {
	                    modelController.$setViewValue(angular.copy(_day).format(lxDatePicker.inputFormat));
	                    modelController.$render();
	                }
	
	                generateCalendar();
	            }
	        }
	
	        function selectYear(_year) {
	            lxDatePicker.yearSelection = false;
	
	            lxDatePicker.ngModelMoment = lxDatePicker.ngModelMoment.year(_year);
	
	            $scope.$emit("calendarRefresh", { message: lxDatePicker.ngModelMoment });
	            $timeout(function () {
	                generateCalendar();
	            }, 150);
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.date-picker').service('LxDatePickerService', LxDatePickerService);
	
	    LxDatePickerService.$inject = ['$rootScope', '$timeout', 'LxDepthService', 'LxEventSchedulerService'];
	
	    function LxDatePickerService($rootScope, $timeout, LxDepthService, LxEventSchedulerService) {
	        var service = this;
	        var activeDatePickerId;
	        var datePickerFilter;
	        var idEventScheduler;
	        var scopeMap = {};
	
	        service.close = closeDatePicker;
	        service.open = openDatePicker;
	        service.registerScope = registerScope;
	
	        ////////////
	
	        function closeDatePicker(_datePickerId) {
	            if (angular.isDefined(idEventScheduler)) {
	                LxEventSchedulerService.unregister(idEventScheduler);
	                idEventScheduler = undefined;
	            }
	
	            activeDatePickerId = undefined;
	
	            $rootScope.$broadcast('lx-date-picker__close-start', _datePickerId);
	
	            datePickerFilter.removeClass('lx-date-picker-filter--is-shown');
	            scopeMap[_datePickerId] ? scopeMap[_datePickerId].element.removeClass('lx-date-picker--is-shown') : null;
	
	            $timeout(function () {
	                angular.element('body').css({
	                    overflow: 'visible'
	                });
	
	                datePickerFilter.remove();
	
	                scopeMap[_datePickerId].element.hide().appendTo(scopeMap[_datePickerId].elementParent);
	
	                scopeMap[_datePickerId].isOpen = false;
	                $rootScope.$broadcast('lx-date-picker__close-end', _datePickerId);
	            }, 600);
	        }
	
	        function onKeyUp(_event) {
	            if (_event.keyCode == 27 && angular.isDefined(activeDatePickerId)) {
	                closeDatePicker(activeDatePickerId);
	            }
	
	            _event.stopPropagation();
	        }
	
	        function openDatePicker(_datePickerId) {
	            LxDepthService.register();
	
	            activeDatePickerId = _datePickerId;
	
	            angular.element('body').css({
	                overflow: 'hidden'
	            });
	
	            datePickerFilter = angular.element('<div/>', {
	                class: 'lx-date-picker-filter'
	            });
	
	            datePickerFilter.css('z-index', LxDepthService.getDepth()).appendTo('body');
	
	            if (scopeMap[activeDatePickerId].autoClose) {
	                datePickerFilter.on('click', function () {
	                    closeDatePicker(activeDatePickerId);
	                });
	            }
	
	            if (scopeMap[activeDatePickerId].escapeClose) {
	                idEventScheduler = LxEventSchedulerService.register('keyup', onKeyUp);
	            }
	
	            scopeMap[activeDatePickerId].element.css('z-index', LxDepthService.getDepth() + 1).appendTo('body').show();
	
	            $timeout(function () {
	                $rootScope.$broadcast('lx-date-picker__open-start', activeDatePickerId);
	
	                scopeMap[activeDatePickerId].isOpen = true;
	
	                datePickerFilter.addClass('lx-date-picker-filter--is-shown');
	                scopeMap[activeDatePickerId].element.addClass('lx-date-picker--is-shown');
	            }, 100);
	
	            $timeout(function () {
	                $rootScope.$broadcast('lx-date-picker__open-end', activeDatePickerId);
	            }, 700);
	        }
	
	        function registerScope(_datePickerId, _datePickerScope) {
	            scopeMap[_datePickerId] = _datePickerScope.lxDatePicker;
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.dialog').directive('lxDialog', lxDialog).directive('lxDialogHeader', lxDialogHeader).directive('lxDialogContent', lxDialogContent).directive('lxDialogFooter', lxDialogFooter).directive('lxDialogClose', lxDialogClose);
	
	    lxDialog.$inject = ['LxDialogService'];
	
	    function lxDialog(LxDialogService) {
	        return {
	            restrict: 'E',
	            template: '<div class="dialog dialog--l"><div ng-if="lxDialog.isOpen" ng-transclude></div></div>',
	            scope: {
	                autoClose: '=?lxAutoClose',
	                escapeClose: '=?lxEscapeClose'
	            },
	            link: link,
	            controller: LxDialogController,
	            controllerAs: 'lxDialog',
	            bindToController: true,
	            replace: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs) {
	            attrs.$observe('id', function (_newId) {
	                LxDialogService.registerScope(_newId, scope);
	            });
	        }
	    }
	
	    LxDialogController.$inject = ['$element'];
	
	    function LxDialogController($element) {
	        var lxDialog = this;
	
	        lxDialog.autoClose = angular.isDefined(lxDialog.autoClose) ? lxDialog.autoClose : true;
	        lxDialog.element = $element;
	        lxDialog.elementParent = $element.parent();
	        lxDialog.escapeClose = angular.isDefined(lxDialog.escapeClose) ? lxDialog.escapeClose : true;
	        lxDialog.isOpen = false;
	    }
	
	    function lxDialogHeader() {
	        return {
	            restrict: 'E',
	            template: '<div class="dialog__header" ng-transclude></div>',
	            replace: true,
	            transclude: true
	        };
	    }
	
	    function lxDialogContent() {
	        return {
	            restrict: 'E',
	            template: '<div class="dialog__content" ng-transclude></div>',
	            replace: true,
	            transclude: true
	        };
	    }
	
	    function lxDialogFooter() {
	        return {
	            restrict: 'E',
	            template: '<div class="dialog__footer" ng-transclude></div>',
	            replace: true,
	            transclude: true
	        };
	    }
	
	    lxDialogClose.$inject = ['LxDialogService'];
	
	    function lxDialogClose(LxDialogService) {
	        return {
	            restrict: 'A',
	            link: function link(scope, element) {
	                element.on('click', function () {
	                    LxDialogService.close(element.parents('.dialog').attr('id'));
	                });
	
	                scope.$on('$destroy', function () {
	                    element.off();
	                });
	            }
	        };
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.dialog').service('LxDialogService', LxDialogService);
	
	    LxDialogService.$inject = ['$interval', '$rootScope', '$timeout', '$window', 'LxDepthService', 'LxEventSchedulerService'];
	
	    function LxDialogService($interval, $rootScope, $timeout, $window, LxDepthService, LxEventSchedulerService) {
	        var service = this;
	        var activeDialogId;
	        var dialog;
	        var dialogContent;
	        var dialogFilter;
	        var dialogFooter;
	        var dialogHeader;
	        var dialogHeight;
	        var dialogInterval;
	        var dialogScrollable;
	        var idEventScheduler;
	        var resizeDebounce;
	        var scopeMap = {};
	        var windowHeight;
	
	        service.close = closeDialog;
	        service.open = openDialog;
	        service.registerScope = registerScope;
	
	        ////////////
	
	        function closeDialog(_dialogId) {
	            if (angular.isDefined(idEventScheduler)) {
	                LxEventSchedulerService.unregister(idEventScheduler);
	                idEventScheduler = undefined;
	            }
	
	            angular.element($window).off('resize', checkDialogHeightOnResize);
	            angular.element('.dialog__scrollable').off('scroll', checkScrollEnd);
	
	            activeDialogId = undefined;
	
	            $rootScope.$broadcast('lx-dialog__close-start', _dialogId);
	
	            if (resizeDebounce) {
	                $timeout.cancel(resizeDebounce);
	            }
	
	            $interval.cancel(dialogInterval);
	
	            dialogFilter.removeClass('dialog-filter--is-shown');
	            scopeMap[_dialogId].element.removeClass('dialog--is-shown');
	
	            $timeout(function () {
	                angular.element('body').css({
	                    overflow: 'visible'
	                });
	
	                dialogFilter.remove();
	
	                dialog = undefined;
	                dialogHeader = undefined;
	                dialogContent = undefined;
	                dialogFooter = undefined;
	                dialogScrollable = undefined;
	
	                scopeMap[_dialogId].element.hide().removeClass('dialog--is-fixed').appendTo(scopeMap[_dialogId].elementParent);
	
	                scopeMap[_dialogId].isOpen = false;
	                dialogHeight = undefined;
	                $rootScope.$broadcast('lx-dialog__close-end', _dialogId);
	            }, 600);
	        }
	
	        function checkDialogHeight(_dialogId) {
	            if (angular.isUndefined(_dialogId)) {
	                var unclosedDialog = angular.element('.dialog-filter');
	                unclosedDialog.remove();
	                return;
	            }
	            if (angular.isUndefined(dialogHeader) && scopeMap[_dialogId]) {
	                dialog = scopeMap[_dialogId].element;
	                dialogHeader = dialog.find('.dialog__header');
	                dialogContent = dialog.find('.dialog__content');
	                dialogFooter = dialog.find('.dialog__footer');
	
	                if (!dialogFooter.length) {
	                    dialogFooter = dialog.find('.dialog__actions');
	                }
	
	                if (angular.isUndefined(dialogHeader)) {
	                    return;
	                }
	            }
	
	            var heightToCheck = 60 + dialogHeader.outerHeight() + dialogContent.outerHeight() + dialogFooter.outerHeight();
	
	            if (dialogHeight === heightToCheck && windowHeight === $window.innerHeight) {
	                return;
	            }
	
	            dialogHeight = heightToCheck;
	            windowHeight = $window.innerHeight;
	
	            if (heightToCheck >= $window.innerHeight) {
	                dialog.addClass('dialog--is-fixed');
	
	                if (dialog.find('.dialog__scrollable').length === 0) {
	                    var dialogScrollable = angular.element('<div/>', {
	                        class: 'dialog__scrollable'
	                    });
	
	                    dialogScrollable.css({
	                        top: dialogHeader.outerHeight(),
	                        bottom: dialogFooter.outerHeight()
	                    }).on('scroll', checkScrollEnd);
	
	                    dialogContent.wrap(dialogScrollable);
	                }
	            } else {
	                dialog.removeClass('dialog--is-fixed');
	
	                if (dialog.find('.dialog__scrollable').length > 0) {
	                    dialogContent.unwrap();
	                }
	            }
	        }
	
	        function checkDialogHeightOnResize() {
	            if (angular.isDefined(activeDialogId)) {
	                if (resizeDebounce) {
	                    $timeout.cancel(resizeDebounce);
	                }
	
	                resizeDebounce = $timeout(function () {
	                    checkDialogHeight(activeDialogId);
	                }, 200);
	            }
	        }
	
	        function checkScrollEnd() {
	            if (angular.isUndefined(dialogScrollable)) {
	                dialogScrollable = angular.element('.dialog__scrollable');
	
	                if (angular.isUndefined(dialogScrollable)) {
	                    return;
	                }
	            }
	
	            if (angular.isDefined(scopeMap[activeDialogId])) {
	                if (dialogScrollable.scrollTop() + dialogScrollable.innerHeight() >= dialogScrollable[0].scrollHeight) {
	                    $rootScope.$broadcast('lx-dialog__scroll-end', activeDialogId);
	
	                    dialogScrollable.off('scroll', checkScrollEnd);
	
	                    $timeout(function () {
	                        dialogScrollable.on('scroll', checkScrollEnd);
	                    }, 500);
	                }
	            }
	        }
	
	        function onKeyUp(_event) {
	            if (_event.keyCode == 27 && angular.isDefined(activeDialogId)) {
	                closeDialog(activeDialogId);
	            }
	
	            _event.stopPropagation();
	        }
	
	        function openDialog(_dialogId) {
	            LxDepthService.register();
	
	            activeDialogId = _dialogId;
	
	            angular.element('body').css({
	                overflow: 'hidden'
	            });
	
	            dialogFilter = angular.element('<div/>', {
	                class: 'dialog-filter'
	            });
	
	            dialogFilter.css('z-index', LxDepthService.getDepth()).appendTo('body');
	
	            if (scopeMap[activeDialogId].autoClose) {
	                dialogFilter.on('click', function () {
	                    closeDialog(activeDialogId);
	                });
	            }
	
	            if (scopeMap[activeDialogId].escapeClose) {
	                idEventScheduler = LxEventSchedulerService.register('keyup', onKeyUp);
	            }
	
	            scopeMap[activeDialogId].element.css('z-index', LxDepthService.getDepth() + 1).appendTo('body').show();
	
	            $timeout(function () {
	                $rootScope.$broadcast('lx-dialog__open-start', activeDialogId);
	
	                scopeMap[activeDialogId].isOpen = true;
	
	                dialogFilter.addClass('dialog-filter--is-shown');
	                scopeMap[activeDialogId].element.addClass('dialog--is-shown');
	            }, 100);
	
	            $timeout(function () {
	                $rootScope.$broadcast('lx-dialog__open-end', activeDialogId);
	            }, 700);
	
	            dialogInterval = $interval(function () {
	                checkDialogHeight(activeDialogId);
	            }, 500);
	
	            angular.element($window).on('resize', checkDialogHeightOnResize);
	        }
	
	        function registerScope(_dialogId, _dialogScope) {
	            scopeMap[_dialogId] = _dialogScope.lxDialog;
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.dropdown').directive('lxDropdown', lxDropdown).directive('lxDropdownToggle', lxDropdownToggle).directive('lxDropdownMenu', lxDropdownMenu).directive('lxDropdownFilter', lxDropdownFilter);
	
	    lxDropdown.$inject = ['$document', '$timeout'];
	
	    function lxDropdown($document, $timeout) {
	        return {
	            restrict: 'E',
	            templateUrl: 'dropdown.html',
	            scope: {
	                escapeClose: '=?lxEscapeClose',
	                overToggle: '=?lxOverToggle',
	                position: '@?lxPosition',
	                width: '@?lxWidth'
	            },
	            link: link,
	            controller: LxDropdownController,
	            controllerAs: 'lxDropdown',
	            bindToController: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs, ctrl) {
	            var backwardOneWay = ['position', 'width'];
	            var backwardTwoWay = ['escapeClose', 'overToggle'];
	            var timer;
	
	            angular.forEach(backwardOneWay, function (attribute) {
	                if (angular.isDefined(attrs[attribute])) {
	                    attrs.$observe(attribute, function (newValue) {
	                        scope.lxDropdown[attribute] = newValue;
	                    });
	                }
	            });
	
	            angular.forEach(backwardTwoWay, function (attribute) {
	                if (angular.isDefined(attrs[attribute])) {
	                    scope.$watch(function () {
	                        return scope.$parent.$eval(attrs[attribute]);
	                    }, function (newValue) {
	                        scope.lxDropdown[attribute] = newValue;
	                    });
	                }
	            });
	
	            $document.on('click', closeDropdownMenu);
	
	            scope.$on('$destroy', function () {
	                ctrl.closeDropdownMenu();
	                $document.off('click', closeDropdownMenu);
	                $timeout.cancel(timer);
	            });
	
	            function closeDropdownMenu() {
	                if (scope.lxDropdown.isOpen) {
	                    timer = $timeout(function () {
	                        scope.$apply(function () {
	                            ctrl.closeDropdownMenu();
	                        });
	                    });
	                }
	            }
	        }
	    }
	
	    LxDropdownController.$inject = ['$element', '$interval', '$scope', '$timeout', '$window', 'LxDepthService', 'LxEventSchedulerService'];
	
	    function LxDropdownController($element, $interval, $scope, $timeout, $window, LxDepthService, LxEventSchedulerService) {
	        var lxDropdown = this;
	        var dropdownInterval;
	        var dropdownMenu;
	        var dropdownToggle;
	        var idEventScheduler;
	        var timer;
	
	        lxDropdown.closeDropdownMenu = closeDropdownMenu;
	        lxDropdown.registerDropdownMenu = registerDropdownMenu;
	        lxDropdown.registerDropdownToggle = registerDropdownToggle;
	        lxDropdown.toggle = toggle;
	
	        lxDropdown.escapeClose = angular.isDefined(lxDropdown.escapeClose) ? lxDropdown.escapeClose : true;
	        lxDropdown.isOpen = false;
	        lxDropdown.overToggle = angular.isDefined(lxDropdown.overToggle) ? lxDropdown.overToggle : false;
	        lxDropdown.position = angular.isDefined(lxDropdown.position) ? lxDropdown.position : 'left';
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer);
	        });
	
	        ////////////
	
	        function closeDropdownMenu() {
	            $interval.cancel(dropdownInterval);
	
	            dropdownMenu.css({
	                overflow: 'hidden'
	            });
	
	            dropdownMenu.velocity({
	                width: 0,
	                height: 0
	            }, {
	                duration: 200,
	                easing: 'easeOutQuint',
	                complete: function complete() {
	                    $element.find('.dropdown').removeClass('dropdown--is-open');
	
	                    dropdownMenu.removeAttr('style').removeClass('dropdown-menu--is-open').appendTo($element.find('.dropdown'));
	
	                    $scope.$apply(function () {
	                        lxDropdown.isOpen = false;
	
	                        if (lxDropdown.escapeClose) {
	                            LxEventSchedulerService.unregister(idEventScheduler);
	                            idEventScheduler = undefined;
	                        }
	                    });
	                }
	            });
	        }
	
	        function openDropdownMenu() {
	            LxDepthService.register();
	
	            lxDropdown.isOpen = true;
	
	            $element.find('.dropdown').addClass('dropdown--is-open');
	
	            dropdownMenu.addClass('dropdown-menu--is-open').css('z-index', LxDepthService.getDepth()).appendTo('body');
	
	            if (lxDropdown.escapeClose) {
	                idEventScheduler = LxEventSchedulerService.register('keyup', onKeyUp);
	            }
	
	            timer = $timeout(function () {
	                var enoughtHeight = true;
	                var availableHeight = setDropdownMenuCss();
	                var width = dropdownMenu.outerWidth();
	                var height = dropdownMenu.outerHeight();
	
	                if (availableHeight < height) {
	                    enoughtHeight = false;
	                    height = availableHeight;
	                }
	
	                dropdownMenu.css({
	                    width: 0,
	                    height: 0,
	                    opacity: 1,
	                    overflow: 'hidden'
	                });
	
	                dropdownMenu.find('.dropdown-menu__content').css({
	                    width: width,
	                    height: height
	                });
	
	                dropdownMenu.velocity({
	                    width: width
	                }, {
	                    duration: 200,
	                    easing: 'easeOutQuint',
	                    queue: false
	                });
	
	                dropdownMenu.velocity({
	                    height: height
	                }, {
	                    duration: 500,
	                    easing: 'easeOutQuint',
	                    queue: false,
	                    complete: function complete() {
	                        dropdownMenu.css({
	                            overflow: 'auto'
	                        });
	
	                        if (enoughtHeight) {
	                            dropdownMenu.css({
	                                height: 'auto'
	                            });
	                        }
	
	                        if (angular.isUndefined(lxDropdown.width)) {
	                            dropdownMenu.css({
	                                width: 'auto'
	                            });
	                        }
	
	                        dropdownMenu.find('.dropdown-menu__content').removeAttr('style');
	
	                        dropdownInterval = $interval(function () {
	                            setDropdownMenuCss();
	                        }, 500);
	                    }
	                });
	            });
	        }
	
	        function onKeyUp(_event) {
	            if (_event.keyCode == 27) {
	                closeDropdownMenu();
	            }
	
	            _event.stopPropagation();
	        }
	
	        function registerDropdownMenu(_dropdownMenu) {
	            dropdownMenu = _dropdownMenu;
	        }
	
	        function registerDropdownToggle(_dropdownToggle) {
	            dropdownToggle = _dropdownToggle;
	        }
	
	        function setDropdownMenuCss() {
	            var windowWidth = $window.innerWidth;
	            var windowHeight = $window.innerHeight;
	            var dropdownToggleWidth = dropdownToggle.outerWidth();
	            var dropdownToggleHeight = dropdownToggle.outerHeight();
	            var dropdownToggleTop = dropdownToggle.offset().top - angular.element($window).scrollTop();
	            var dropdownMenuTopAvailable;
	            var dropdownMenuBottomAvailable;
	            var dropdownMenuWidth;
	
	            if (lxDropdown.overToggle) {
	                dropdownMenuTopAvailable = dropdownToggleTop + dropdownToggleHeight;
	                dropdownMenuBottomAvailable = windowHeight - dropdownToggleTop;
	            } else {
	                dropdownMenuTopAvailable = dropdownToggleTop;
	                dropdownMenuBottomAvailable = windowHeight - (dropdownToggleTop + dropdownToggleHeight);
	            }
	
	            if (angular.isDefined(lxDropdown.width)) {
	                if (lxDropdown.width.indexOf('%') > -1) {
	                    dropdownMenuWidth = dropdownToggleWidth * (lxDropdown.width.slice(0, -1) / 100);
	                } else {
	                    dropdownMenuWidth = lxDropdown.width;
	                }
	            } else {
	                dropdownMenuWidth = 'auto';
	            }
	
	            dropdownMenu.css({
	                right: lxDropdown.position === 'right' ? windowWidth - dropdownToggle.offset().left - dropdownToggleWidth : 'auto',
	                left: lxDropdown.position === 'right' ? 'auto' : dropdownToggle.offset().left,
	                width: dropdownMenuWidth
	            });
	
	            if (dropdownMenuTopAvailable > dropdownMenuBottomAvailable) {
	                dropdownMenu.css({
	                    bottom: lxDropdown.overToggle ? windowHeight - dropdownToggle.offset().top - dropdownToggleHeight : windowHeight - dropdownToggle.offset().top
	                });
	
	                return dropdownMenuTopAvailable;
	            } else {
	                dropdownMenu.css({
	                    top: lxDropdown.overToggle ? dropdownToggle.offset().top : dropdownToggle.offset().top + dropdownToggleHeight
	                });
	
	                return dropdownMenuBottomAvailable;
	            }
	        }
	
	        function toggle() {
	            if (!lxDropdown.isOpen) {
	                openDropdownMenu();
	            } else {
	                closeDropdownMenu();
	            }
	        }
	    }
	
	    function lxDropdownToggle() {
	        return {
	            restrict: 'AE',
	            templateUrl: 'dropdown-toggle.html',
	            require: '^lxDropdown',
	            scope: true,
	            link: link,
	            replace: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs, ctrl) {
	            ctrl.registerDropdownToggle(element);
	
	            element.on('click', function (_event) {
	                _event.stopPropagation();
	
	                angular.element('.dropdown').each(function (index, dropdownElem) {
	                    if (angular.isDefined(angular.element(dropdownElem).scope().lxDropdown) && angular.element(dropdownElem).scope().lxDropdown.isOpen) {
	                        angular.element(dropdownElem).scope().lxDropdown.closeDropdownMenu();
	                    }
	                });
	
	                scope.$apply(function () {
	                    ctrl.toggle();
	                });
	            });
	
	            scope.$on('$destroy', function () {
	                element.off();
	            });
	        }
	    }
	
	    function lxDropdownMenu() {
	        return {
	            restrict: 'E',
	            templateUrl: 'dropdown-menu.html',
	            require: ['lxDropdownMenu', '^lxDropdown'],
	            scope: true,
	            link: link,
	            controller: LxDropdownMenuController,
	            controllerAs: 'lxDropdownMenu',
	            bindToController: true,
	            replace: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs, ctrls) {
	            ctrls[1].registerDropdownMenu(element);
	            ctrls[0].setParentController(ctrls[1]);
	        }
	    }
	
	    function LxDropdownMenuController() {
	        var lxDropdownMenu = this;
	
	        lxDropdownMenu.setParentController = setParentController;
	
	        ////////////
	
	        function setParentController(_parentCtrl) {
	            lxDropdownMenu.parentCtrl = _parentCtrl;
	        }
	    }
	
	    lxDropdownFilter.$inject = ['$timeout'];
	
	    function lxDropdownFilter($timeout) {
	        return {
	            restrict: 'A',
	            link: link
	        };
	
	        function link(scope, element) {
	            var timer;
	
	            element.on('click', function (_event) {
	                _event.stopPropagation();
	            });
	
	            timer = $timeout(function () {
	                element.find('input').focus();
	            }, 200);
	
	            scope.$on('$destroy', function () {
	                $timeout.cancel(timer);
	                element.off();
	            });
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.fab').directive('lxFab', lxFab).directive('lxFabTrigger', lxFabTrigger).directive('lxFabActions', lxFabActions);
	
	    function lxFab() {
	        return {
	            restrict: 'E',
	            templateUrl: 'fab.html',
	            scope: true,
	            link: link,
	            controller: LxFabController,
	            controllerAs: 'lxFab',
	            bindToController: true,
	            transclude: true,
	            replace: true
	        };
	
	        function link(scope, element, attrs, ctrl) {
	            attrs.$observe('lxDirection', function (newDirection) {
	                ctrl.setFabDirection(newDirection);
	            });
	        }
	    }
	
	    function LxFabController() {
	        var lxFab = this;
	
	        lxFab.setFabDirection = setFabDirection;
	
	        ////////////
	
	        function setFabDirection(_direction) {
	            lxFab.lxDirection = _direction;
	        }
	    }
	
	    function lxFabTrigger() {
	        return {
	            restrict: 'E',
	            require: '^lxFab',
	            templateUrl: 'fab-trigger.html',
	            transclude: true,
	            replace: true
	        };
	    }
	
	    function lxFabActions() {
	        return {
	            restrict: 'E',
	            require: '^lxFab',
	            templateUrl: 'fab-actions.html',
	            link: link,
	            transclude: true,
	            replace: true
	        };
	
	        function link(scope, element, attrs, ctrl) {
	            scope.parentCtrl = ctrl;
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.file-input').directive('lxFileInput', lxFileInput);
	
	    function lxFileInput() {
	        return {
	            restrict: 'E',
	            templateUrl: 'file-input.html',
	            scope: {
	                label: '@lxLabel',
	                callback: '&?lxCallback'
	            },
	            link: link,
	            controller: LxFileInputController,
	            controllerAs: 'lxFileInput',
	            bindToController: true,
	            replace: true
	        };
	
	        function link(scope, element, attrs, ctrl) {
	            var input = element.find('input');
	
	            input.on('change', ctrl.updateModel).on('blur', function () {
	                element.removeClass('input-file--is-focus');
	            });
	
	            scope.$on('$destroy', function () {
	                input.off();
	            });
	        }
	    }
	
	    LxFileInputController.$inject = ['$element', '$scope', '$timeout'];
	
	    function LxFileInputController($element, $scope, $timeout) {
	        var lxFileInput = this;
	        var input = $element.find('input');
	        var timer;
	
	        lxFileInput.updateModel = updateModel;
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer);
	        });
	
	        ////////////
	
	        function setFileName() {
	            if (input.val()) {
	                lxFileInput.fileName = input.val().replace(/C:\\fakepath\\/i, '');
	
	                $element.addClass('input-file--is-focus');
	                $element.addClass('input-file--is-active');
	            } else {
	                lxFileInput.fileName = undefined;
	
	                $element.removeClass('input-file--is-active');
	            }
	
	            input.val(undefined);
	        }
	
	        function updateModel() {
	            if (angular.isDefined(lxFileInput.callback)) {
	                lxFileInput.callback({
	                    newFile: input[0].files[0]
	                });
	            }
	
	            timer = $timeout(setFileName);
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.icon').directive('lxIcon', lxIcon);
	
	    function lxIcon() {
	        return {
	            restrict: 'E',
	            templateUrl: 'icon.html',
	            scope: {
	                color: '@?lxColor',
	                id: '@lxId',
	                size: '@?lxSize',
	                type: '@?lxType'
	            },
	            controller: LxIconController,
	            controllerAs: 'lxIcon',
	            bindToController: true,
	            replace: true
	        };
	    }
	
	    function LxIconController() {
	        var lxIcon = this;
	
	        lxIcon.getClass = getClass;
	
	        ////////////
	
	        function getClass() {
	            var iconClass = [];
	
	            iconClass.push('mdi-' + lxIcon.id);
	
	            if (angular.isDefined(lxIcon.size)) {
	                iconClass.push('icon--' + lxIcon.size);
	            }
	
	            if (angular.isDefined(lxIcon.color)) {
	                iconClass.push('icon--' + lxIcon.color);
	            }
	
	            if (angular.isDefined(lxIcon.type)) {
	                iconClass.push('icon--' + lxIcon.type);
	            }
	
	            return iconClass;
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.notification').service('LxNotificationService', LxNotificationService);
	
	    LxNotificationService.$inject = ['$injector', '$interval', '$rootScope', '$timeout', 'LxDepthService', 'LxEventSchedulerService'];
	
	    function LxNotificationService($injector, $interval, $rootScope, $timeout, LxDepthService, LxEventSchedulerService) {
	        var service = this;
	        var dialogFilter;
	        var dialog;
	        var idEventScheduler;
	        var notificationList = [];
	
	        service.alert = showAlertDialog;
	        service.confirm = showConfirmDialog;
	        service.error = notifyError;
	        service.info = notifyInfo;
	        service.notify = notify;
	        service.success = notifySuccess;
	        service.warning = notifyWarning;
	
	        ////////////
	
	        //
	        // NOTIFICATION
	        //
	
	        function deleteNotification(_notification) {
	            var notifIndex = notificationList.indexOf(_notification);
	
	            var dnOffset = 24 + notificationList[notifIndex].height;
	
	            for (var idx = 0; idx < notifIndex; idx++) {
	                if (notificationList.length > 1) {
	                    notificationList[idx].margin -= dnOffset;
	                    notificationList[idx].elem.css('marginBottom', notificationList[idx].margin + 'px');
	                }
	            }
	
	            _notification.elem.removeClass('notification--is-shown');
	
	            $timeout(function () {
	                _notification.elem.remove();
	                notificationList.splice(notifIndex, 1);
	            }, 400);
	        }
	
	        function getElementHeight(_elem) {
	            return parseFloat(window.getComputedStyle(_elem, null).height);
	        }
	
	        function moveNotificationUp() {
	            var newNotifIndex = notificationList.length - 1;
	            notificationList[newNotifIndex].height = getElementHeight(notificationList[newNotifIndex].elem[0]);
	
	            var upOffset = 0;
	
	            for (var idx = newNotifIndex; idx >= 0; idx--) {
	                if (notificationList.length > 1 && idx !== newNotifIndex) {
	                    upOffset = 24 + notificationList[newNotifIndex].height;
	
	                    notificationList[idx].margin += upOffset;
	                    notificationList[idx].elem.css('marginBottom', notificationList[idx].margin + 'px');
	                }
	            }
	        }
	
	        function notify(_text, _icon, _sticky, _color) {
	            LxDepthService.register();
	
	            var notification = angular.element('<div/>', {
	                class: 'notification'
	            });
	            var notificationText = angular.element('<span/>', {
	                class: 'notification__content',
	                html: _text
	            });
	            var notificationTimeout;
	
	            if (angular.isDefined(_icon)) {
	                var notificationIcon = angular.element('<i/>', {
	                    class: 'notification__icon mdi mdi-' + _icon
	                });
	
	                notification.addClass('notification--has-icon').append(notificationIcon);
	            }
	
	            if (angular.isDefined(_color)) {
	                notification.addClass('notification--' + _color);
	            }
	
	            notification.append(notificationText).css('z-index', LxDepthService.getDepth()).appendTo('body');
	
	            $timeout(function () {
	                notification.addClass('notification--is-shown');
	            }, 100);
	
	            var data = {
	                elem: notification,
	                margin: 0
	            };
	            notificationList.push(data);
	            moveNotificationUp();
	
	            notification.bind('click', function () {
	                deleteNotification(data);
	
	                if (angular.isDefined(notificationTimeout)) {
	                    $timeout.cancel(notificationTimeout);
	                }
	            });
	
	            if (angular.isUndefined(_sticky) || !_sticky) {
	                notificationTimeout = $interval(function () {
	                    deleteNotification(data);
	                }, 6000, 1);
	            }
	        }
	
	        function notifyError(_text, _sticky) {
	            notify(_text, 'alert-circle', _sticky, 'red');
	        }
	
	        function notifyInfo(_text, _sticky) {
	            notify(_text, 'information-outline', _sticky, 'blue');
	        }
	
	        function notifySuccess(_text, _sticky) {
	            notify(_text, 'check', _sticky, 'green');
	        }
	
	        function notifyWarning(_text, _sticky) {
	            notify(_text, 'alert', _sticky, 'orange');
	        }
	
	        //
	        // ALERT & CONFIRM
	        //
	
	        function buildDialogActions(_buttons, _callback, _unbind) {
	            var $compile = $injector.get('$compile');
	
	            var dialogActions = angular.element('<div/>', {
	                class: 'dialog__actions'
	            });
	
	            var dialogLastBtn = angular.element('<button/>', {
	                class: 'btn btn--m btn--blue btn--flat',
	                text: _buttons.ok
	            });
	
	            if (angular.isDefined(_buttons.cancel)) {
	                var dialogFirstBtn = angular.element('<button/>', {
	                    class: 'btn btn--m btn--red btn--flat',
	                    text: _buttons.cancel
	                });
	
	                dialogFirstBtn.attr('lx-ripple', '');
	                $compile(dialogFirstBtn)($rootScope);
	
	                dialogActions.append(dialogFirstBtn);
	
	                dialogFirstBtn.bind('click', function () {
	                    _callback(false);
	                    closeDialog();
	                });
	            }
	
	            dialogLastBtn.attr('lx-ripple', '');
	            $compile(dialogLastBtn)($rootScope);
	
	            dialogActions.append(dialogLastBtn);
	
	            dialogLastBtn.bind('click', function () {
	                _callback(true);
	                closeDialog();
	            });
	
	            if (!_unbind) {
	                idEventScheduler = LxEventSchedulerService.register('keyup', function (event) {
	                    if (event.keyCode == 13) {
	                        _callback(true);
	                        closeDialog();
	                    } else if (event.keyCode == 27) {
	                        _callback(angular.isUndefined(_buttons.cancel));
	                        closeDialog();
	                    }
	
	                    event.stopPropagation();
	                });
	            }
	
	            return dialogActions;
	        }
	
	        function buildDialogContent(_text) {
	            var dialogContent = angular.element('<div/>', {
	                class: 'dialog__content p++ pt0 tc-black-2',
	                text: _text
	            });
	
	            return dialogContent;
	        }
	
	        function buildDialogHeader(_title) {
	            var dialogHeader = angular.element('<div/>', {
	                class: 'dialog__header p++ fs-title',
	                text: _title
	            });
	
	            return dialogHeader;
	        }
	
	        function closeDialog() {
	            if (angular.isDefined(idEventScheduler)) {
	                $timeout(function () {
	                    LxEventSchedulerService.unregister(idEventScheduler);
	                    idEventScheduler = undefined;
	                }, 1);
	            }
	
	            dialogFilter.removeClass('dialog-filter--is-shown');
	            dialog.removeClass('dialog--is-shown');
	
	            $timeout(function () {
	                dialogFilter.remove();
	                dialog.remove();
	            }, 600);
	        }
	
	        function showAlertDialog(_title, _text, _button, _callback, _unbind) {
	            LxDepthService.register();
	
	            dialogFilter = angular.element('<div/>', {
	                class: 'dialog-filter'
	            });
	
	            dialog = angular.element('<div/>', {
	                class: 'dialog dialog--alert'
	            });
	
	            var dialogHeader = buildDialogHeader(_title);
	            var dialogContent = buildDialogContent(_text);
	            var dialogActions = buildDialogActions({
	                ok: _button
	            }, _callback, _unbind);
	
	            dialogFilter.css('z-index', LxDepthService.getDepth()).appendTo('body');
	
	            dialog.append(dialogHeader).append(dialogContent).append(dialogActions).css('z-index', LxDepthService.getDepth() + 1).appendTo('body').show().focus();
	
	            $timeout(function () {
	                angular.element(document.activeElement).blur();
	
	                dialogFilter.addClass('dialog-filter--is-shown');
	                dialog.addClass('dialog--is-shown');
	            }, 100);
	        }
	
	        function showConfirmDialog(_title, _text, _buttons, _callback, _unbind) {
	            LxDepthService.register();
	
	            dialogFilter = angular.element('<div/>', {
	                class: 'dialog-filter'
	            });
	
	            dialog = angular.element('<div/>', {
	                class: 'dialog dialog--alert'
	            });
	
	            var dialogHeader = buildDialogHeader(_title);
	            var dialogContent = buildDialogContent(_text);
	            var dialogActions = buildDialogActions(_buttons, _callback, _unbind);
	
	            dialogFilter.css('z-index', LxDepthService.getDepth()).appendTo('body');
	
	            dialog.append(dialogHeader).append(dialogContent).append(dialogActions).css('z-index', LxDepthService.getDepth() + 1).appendTo('body').show().focus();
	
	            $timeout(function () {
	                angular.element(document.activeElement).blur();
	
	                dialogFilter.addClass('dialog-filter--is-shown');
	                dialog.addClass('dialog--is-shown');
	            }, 100);
	        }
	    }
	})();
	
	(function () {
	    'use strict';
	
	    angular.module('lumx.progress').directive('lxProgress', lxProgress);
	
	    function lxProgress() {
	        return {
	            restrict: 'E',
	            templateUrl: 'progress.html',
	            scope: {
	                lxColor: '@?',
	                lxDiameter: '@?',
	                lxType: '@'
	            },
	            controller: LxProgressController,
	            controllerAs: 'lxProgress',
	            bindToController: true,
	            replace: true
	        };
	    }
	
	    function LxProgressController() {
	        var lxProgress = this;
	
	        lxProgress.getProgressDiameter = getProgressDiameter;
	
	        init();
	
	        ////////////
	
	        function getProgressDiameter() {
	            if (lxProgress.lxType === 'circular') {
	                return {
	                    'transform': 'scale(' + parseInt(lxProgress.lxDiameter) / 100 + ')'
	                };
	            }
	
	            return;
	        }
	
	        function init() {
	            lxProgress.lxDiameter = angular.isDefined(lxProgress.lxDiameter) ? lxProgress.lxDiameter : 100;
	            lxProgress.lxColor = angular.isDefined(lxProgress.lxColor) ? lxProgress.lxColor : 'primary';
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.radio-button').directive('lxRadioGroup', lxRadioGroup).directive('lxRadioButton', lxRadioButton).directive('lxRadioButtonLabel', lxRadioButtonLabel).directive('lxRadioButtonHelp', lxRadioButtonHelp);
	
	    function lxRadioGroup() {
	        return {
	            restrict: 'E',
	            templateUrl: 'radio-group.html',
	            transclude: true,
	            replace: true
	        };
	    }
	
	    function lxRadioButton() {
	        return {
	            restrict: 'E',
	            templateUrl: 'radio-button.html',
	            scope: {
	                lxColor: '@?',
	                name: '@',
	                ngChange: '&?',
	                ngDisabled: '=?',
	                ngModel: '=',
	                ngValue: '=?',
	                value: '@?'
	            },
	            controller: LxRadioButtonController,
	            controllerAs: 'lxRadioButton',
	            bindToController: true,
	            transclude: true,
	            replace: true
	        };
	    }
	
	    LxRadioButtonController.$inject = ['$scope', '$timeout', 'LxUtils'];
	
	    function LxRadioButtonController($scope, $timeout, LxUtils) {
	        var lxRadioButton = this;
	        var radioButtonId;
	        var radioButtonHasChildren;
	        var timer;
	
	        lxRadioButton.getRadioButtonId = getRadioButtonId;
	        lxRadioButton.getRadioButtonHasChildren = getRadioButtonHasChildren;
	        lxRadioButton.setRadioButtonId = setRadioButtonId;
	        lxRadioButton.setRadioButtonHasChildren = setRadioButtonHasChildren;
	        lxRadioButton.triggerNgChange = triggerNgChange;
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer);
	        });
	
	        init();
	
	        ////////////
	
	        function getRadioButtonId() {
	            return radioButtonId;
	        }
	
	        function getRadioButtonHasChildren() {
	            return radioButtonHasChildren;
	        }
	
	        function init() {
	            setRadioButtonId(LxUtils.generateUUID());
	            setRadioButtonHasChildren(false);
	
	            if (angular.isDefined(lxRadioButton.value) && angular.isUndefined(lxRadioButton.ngValue)) {
	                lxRadioButton.ngValue = lxRadioButton.value;
	            }
	
	            lxRadioButton.lxColor = angular.isUndefined(lxRadioButton.lxColor) ? 'accent' : lxRadioButton.lxColor;
	        }
	
	        function setRadioButtonId(_radioButtonId) {
	            radioButtonId = _radioButtonId;
	        }
	
	        function setRadioButtonHasChildren(_radioButtonHasChildren) {
	            radioButtonHasChildren = _radioButtonHasChildren;
	        }
	
	        function triggerNgChange() {
	            timer = $timeout(lxRadioButton.ngChange);
	        }
	    }
	
	    function lxRadioButtonLabel() {
	        return {
	            restrict: 'AE',
	            require: ['^lxRadioButton', '^lxRadioButtonLabel'],
	            templateUrl: 'radio-button-label.html',
	            link: link,
	            controller: LxRadioButtonLabelController,
	            controllerAs: 'lxRadioButtonLabel',
	            bindToController: true,
	            transclude: true,
	            replace: true
	        };
	
	        function link(scope, element, attrs, ctrls) {
	            ctrls[0].setRadioButtonHasChildren(true);
	            ctrls[1].setRadioButtonId(ctrls[0].getRadioButtonId());
	        }
	    }
	
	    function LxRadioButtonLabelController() {
	        var lxRadioButtonLabel = this;
	        var radioButtonId;
	
	        lxRadioButtonLabel.getRadioButtonId = getRadioButtonId;
	        lxRadioButtonLabel.setRadioButtonId = setRadioButtonId;
	
	        ////////////
	
	        function getRadioButtonId() {
	            return radioButtonId;
	        }
	
	        function setRadioButtonId(_radioButtonId) {
	            radioButtonId = _radioButtonId;
	        }
	    }
	
	    function lxRadioButtonHelp() {
	        return {
	            restrict: 'AE',
	            require: '^lxRadioButton',
	            templateUrl: 'radio-button-help.html',
	            transclude: true,
	            replace: true
	        };
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.ripple').directive('lxRipple', lxRipple);
	
	    lxRipple.$inject = ['$timeout'];
	
	    function lxRipple($timeout) {
	        return {
	            restrict: 'A',
	            link: link
	        };
	
	        function link(scope, element, attrs) {
	            var timer;
	
	            element.css({
	                position: 'relative',
	                overflow: 'hidden'
	            }).on('mousedown', function (e) {
	                var ripple;
	
	                if (element.find('.ripple').length === 0) {
	                    ripple = angular.element('<span/>', {
	                        class: 'ripple'
	                    });
	
	                    if (attrs.lxRipple) {
	                        ripple.addClass('bgc-' + attrs.lxRipple);
	                    }
	
	                    element.prepend(ripple);
	                } else {
	                    ripple = element.find('.ripple');
	                }
	
	                ripple.removeClass('ripple--is-animated');
	
	                if (!ripple.height() && !ripple.width()) {
	                    var diameter = Math.max(element.outerWidth(), element.outerHeight());
	
	                    ripple.css({
	                        height: diameter,
	                        width: diameter
	                    });
	                }
	
	                var x = e.pageX - element.offset().left - ripple.width() / 2;
	                var y = e.pageY - element.offset().top - ripple.height() / 2;
	
	                ripple.css({
	                    top: y + 'px',
	                    left: x + 'px'
	                }).addClass('ripple--is-animated');
	
	                timer = $timeout(function () {
	                    ripple.removeClass('ripple--is-animated');
	                }, 651);
	            });
	
	            scope.$on('$destroy', function () {
	                $timeout.cancel(timer);
	                element.off();
	            });
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.search-filter').directive('lxSearchFilter', lxSearchFilter);
	
	    function lxSearchFilter() {
	        return {
	            restrict: 'E',
	            templateUrl: 'search-filter.html',
	            scope: {
	                closed: '=?lxClosed',
	                color: '@?lxColor',
	                width: '@?lxWidth'
	            },
	            link: link,
	            controller: LxSearchFilterController,
	            controllerAs: 'lxSearchFilter',
	            bindToController: true,
	            replace: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs, ctrl, transclude) {
	            var input;
	
	            attrs.$observe('lxWidth', function (newWidth) {
	                if (angular.isDefined(scope.lxSearchFilter.closed) && scope.lxSearchFilter.closed) {
	                    element.find('.search-filter__container').css('width', newWidth);
	                }
	            });
	
	            transclude(function () {
	                input = element.find('input');
	
	                ctrl.setInput(input);
	                ctrl.setModel(input.data('$ngModelController'));
	
	                input.on('blur', ctrl.blurInput);
	            });
	
	            scope.$on('$destroy', function () {
	                input.off();
	            });
	        }
	    }
	
	    LxSearchFilterController.$inject = ['$element'];
	
	    function LxSearchFilterController($element) {
	        var lxSearchFilter = this;
	        var input;
	        var modelController;
	
	        lxSearchFilter.blurInput = blurInput;
	        lxSearchFilter.clearInput = clearInput;
	        lxSearchFilter.getClass = getClass;
	        lxSearchFilter.openInput = openInput;
	        lxSearchFilter.setInput = setInput;
	        lxSearchFilter.setModel = setModel;
	
	        lxSearchFilter.color = angular.isDefined(lxSearchFilter.color) ? lxSearchFilter.color : 'black';
	
	        ////////////
	
	        function blurInput() {
	            if (angular.isDefined(lxSearchFilter.closed) && lxSearchFilter.closed && !input.val()) {
	                $element.velocity({
	                    width: 40
	                }, {
	                    duration: 400,
	                    easing: 'easeOutQuint',
	                    queue: false
	                });
	            }
	        }
	
	        function clearInput() {
	            modelController.$setViewValue(undefined);
	            modelController.$render();
	
	            input.focus();
	        }
	
	        function getClass() {
	            var searchFilterClass = [];
	
	            if (angular.isUndefined(lxSearchFilter.closed) || !lxSearchFilter.closed) {
	                searchFilterClass.push('search-filter--opened-mode');
	            }
	
	            if (angular.isDefined(lxSearchFilter.closed) && lxSearchFilter.closed) {
	                searchFilterClass.push('search-filter--closed-mode');
	            }
	
	            if (input.val()) {
	                searchFilterClass.push('search-filter--has-clear-button');
	            }
	
	            if (angular.isDefined(lxSearchFilter.color)) {
	                searchFilterClass.push('search-filter--' + lxSearchFilter.color);
	            }
	
	            return searchFilterClass;
	        }
	
	        function openInput() {
	            if (angular.isDefined(lxSearchFilter.closed) && lxSearchFilter.closed) {
	                $element.velocity({
	                    width: angular.isDefined(lxSearchFilter.width) ? lxSearchFilter.width : 240
	                }, {
	                    duration: 400,
	                    easing: 'easeOutQuint',
	                    queue: false,
	                    complete: function complete() {
	                        input.focus();
	                    }
	                });
	            } else {
	                input.focus();
	            }
	        }
	
	        function setInput(_input) {
	            input = _input;
	        }
	
	        function setModel(_modelControler) {
	            modelController = _modelControler;
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    LxSelectChoicesController.$inject = ["$scope", "$timeout"];
	    angular.module('lumx.select').filter('filterChoices', filterChoices).directive('lxSelect', lxSelect).directive('lxSelectSelected', lxSelectSelected).directive('lxSelectChoices', lxSelectChoices);
	
	    filterChoices.$inject = ['$filter'];
	
	    function filterChoices($filter) {
	        return function (choices, externalFilter, textFilter) {
	            if (externalFilter) {
	                return choices;
	            }
	
	            var toFilter = [];
	
	            if (!angular.isArray(choices)) {
	                if (angular.isObject(choices)) {
	                    for (var idx in choices) {
	                        if (angular.isArray(choices[idx])) {
	                            toFilter = toFilter.concat(choices[idx]);
	                        }
	                    }
	                }
	            } else {
	                toFilter = choices;
	            }
	
	            return $filter('filter')(toFilter, textFilter);
	        };
	    }
	
	    function lxSelect() {
	        return {
	            restrict: 'E',
	            templateUrl: 'select.html',
	            scope: {
	                allowClear: '=?lxAllowClear',
	                choices: '=?lxChoices',
	                customStyle: '@?lxCustomStyle',
	                displayFilter: '=?lxDisplayFilter',
	                error: '=?lxError',
	                filter: '&?lxFilter',
	                fixedLabel: '=?lxFixedLabel',
	                helper: '=?lxHelper',
	                helperMessage: '@?lxHelperMessage',
	                label: '@?lxLabel',
	                loading: '=?lxLoading',
	                modelToSelection: '&?lxModelToSelection',
	                multiple: '=?lxMultiple',
	                ngChange: '&?',
	                ngDisabled: '=?',
	                ngModel: '=',
	                selectionToModel: '&?lxSelectionToModel',
	                theme: '@?lxTheme',
	                valid: '=?lxValid'
	            },
	            link: link,
	            controller: LxSelectController,
	            controllerAs: 'lxSelect',
	            bindToController: true,
	            replace: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs) {
	            var backwardOneWay = ['customStyle'];
	            var backwardTwoWay = ['allowClear', 'choices', 'error', 'loading', 'multiple', 'valid'];
	
	            angular.forEach(backwardOneWay, function (attribute) {
	                if (angular.isDefined(attrs[attribute])) {
	                    attrs.$observe(attribute, function (newValue) {
	                        scope.lxSelect[attribute] = newValue;
	                    });
	                }
	            });
	
	            angular.forEach(backwardTwoWay, function (attribute) {
	                if (angular.isDefined(attrs[attribute])) {
	                    scope.$watch(function () {
	                        return scope.$parent.$eval(attrs[attribute]);
	                    }, function (newValue) {
	                        if (attribute === 'multiple' && angular.isUndefined(newValue)) {
	                            scope.lxSelect[attribute] = true;
	                        } else {
	                            scope.lxSelect[attribute] = newValue;
	                        }
	                    });
	                }
	            });
	
	            attrs.$observe('placeholder', function (newValue) {
	                scope.lxSelect.label = newValue;
	            });
	
	            attrs.$observe('change', function (newValue) {
	                scope.lxSelect.ngChange = function (data) {
	                    return scope.$parent.$eval(newValue, data);
	                };
	            });
	
	            attrs.$observe('filter', function (newValue) {
	                scope.lxSelect.filter = function (data) {
	                    return scope.$parent.$eval(newValue, data);
	                };
	                scope.lxSelect.displayFilter = true;
	            });
	
	            attrs.$observe('modelToSelection', function (newValue) {
	                scope.lxSelect.modelToSelection = function (data) {
	                    return scope.$parent.$eval(newValue, data);
	                };
	            });
	
	            attrs.$observe('selectionToModel', function (newValue) {
	                scope.lxSelect.selectionToModel = function (data) {
	                    return scope.$parent.$eval(newValue, data);
	                };
	            });
	        }
	    }
	
	    LxSelectController.$inject = ['$interpolate', '$sce'];
	
	    function LxSelectController($interpolate, $sce) {
	        var lxSelect = this;
	        var choiceTemplate;
	        var selectedTemplate;
	
	        lxSelect.displayChoice = displayChoice;
	        lxSelect.displaySelected = displaySelected;
	        lxSelect.displaySubheader = displaySubheader;
	        lxSelect.getSelectedModel = getSelectedModel;
	        lxSelect.registerChoiceTemplate = registerChoiceTemplate;
	        lxSelect.registerSelectedTemplate = registerSelectedTemplate;
	        lxSelect.select = select;
	        lxSelect.unselect = unselect;
	
	        lxSelect.ngModel = angular.isUndefined(lxSelect.ngModel) && lxSelect.multiple ? [] : lxSelect.ngModel;
	        lxSelect.unconvertedModel = lxSelect.multiple ? [] : undefined;
	
	        ////////////
	
	        function displayChoice(_choice) {
	            var choiceScope = {
	                $choice: _choice
	            };
	
	            return $sce.trustAsHtml($interpolate(choiceTemplate)(choiceScope));
	        }
	
	        function displaySelected(_selected) {
	            var selectedScope = {};
	
	            if (!angular.isArray(lxSelect.choices)) {
	                var found = false;
	
	                for (var header in lxSelect.choices) {
	                    if (found) {
	                        break;
	                    }
	
	                    if (lxSelect.choices.hasOwnProperty(header)) {
	                        for (var idx = 0, len = lxSelect.choices[header].length; idx < len; idx++) {
	                            if (angular.equals(_selected, lxSelect.choices[header][idx])) {
	                                selectedScope.$selectedSubheader = header;
	
	                                found = true;
	
	                                break;
	                            }
	                        }
	                    }
	                }
	            }
	
	            if (angular.isDefined(_selected)) {
	                selectedScope.$selected = _selected;
	            } else {
	                selectedScope.$selected = getSelectedModel();
	            }
	
	            return $sce.trustAsHtml($interpolate(selectedTemplate)(selectedScope));
	        }
	
	        function displaySubheader(_subheader) {
	            return $sce.trustAsHtml(_subheader);
	        }
	
	        function getSelectedModel() {
	            if (angular.isDefined(lxSelect.modelToSelection) || angular.isDefined(lxSelect.selectionToModel)) {
	                return lxSelect.unconvertedModel;
	            } else {
	                return lxSelect.ngModel;
	            }
	        }
	
	        function registerChoiceTemplate(_choiceTemplate) {
	            choiceTemplate = _choiceTemplate;
	        }
	
	        function registerSelectedTemplate(_selectedTemplate) {
	            selectedTemplate = _selectedTemplate;
	        }
	
	        function select(_choice) {
	            if (lxSelect.multiple && angular.isUndefined(lxSelect.ngModel)) {
	                lxSelect.ngModel = [];
	            }
	
	            if (angular.isDefined(lxSelect.selectionToModel)) {
	                lxSelect.selectionToModel({
	                    data: _choice,
	                    callback: function callback(resp) {
	                        if (lxSelect.multiple) {
	                            lxSelect.ngModel.push(resp);
	                        } else {
	                            lxSelect.ngModel = resp;
	                        }
	                    }
	                });
	            } else {
	                if (lxSelect.multiple) {
	                    lxSelect.ngModel.push(_choice);
	                } else {
	                    lxSelect.ngModel = _choice;
	                }
	            }
	        }
	
	        function unselect(_choice) {
	            if (angular.isDefined(lxSelect.selectionToModel)) {
	                lxSelect.selectionToModel({
	                    data: _choice,
	                    callback: function callback(resp) {
	                        lxSelect.ngModel.splice(lxSelect.ngModel.indexOf(resp), 1);
	                    }
	                });
	
	                lxSelect.unconvertedModel.splice(lxSelect.unconvertedModel.indexOf(_choice), 1);
	            } else {
	                lxSelect.ngModel.splice(lxSelect.ngModel.indexOf(_choice), 1);
	            }
	        }
	    }
	
	    function lxSelectSelected() {
	        return {
	            restrict: 'E',
	            require: ['lxSelectSelected', '^lxSelect'],
	            templateUrl: 'select-selected.html',
	            link: link,
	            controller: LxSelectSelectedController,
	            controllerAs: 'lxSelectSelected',
	            bindToController: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs, ctrls, transclude) {
	            ctrls[0].setParentController(ctrls[1]);
	
	            transclude(scope, function (clone) {
	                var template = '';
	
	                for (var i = 0; i < clone.length; i++) {
	                    template += clone[i].outerHTML || '';
	                }
	
	                ctrls[1].registerSelectedTemplate(template);
	            });
	        }
	    }
	
	    function LxSelectSelectedController() {
	        var lxSelectSelected = this;
	
	        lxSelectSelected.clearModel = clearModel;
	        lxSelectSelected.setParentController = setParentController;
	        lxSelectSelected.removeSelected = removeSelected;
	
	        ////////////
	
	        function clearModel(_event) {
	            _event.stopPropagation();
	
	            lxSelectSelected.parentCtrl.ngModel = undefined;
	            lxSelectSelected.parentCtrl.unconvertedModel = undefined;
	        }
	
	        function setParentController(_parentCtrl) {
	            lxSelectSelected.parentCtrl = _parentCtrl;
	        }
	
	        function removeSelected(_selected, _event) {
	            _event.stopPropagation();
	
	            lxSelectSelected.parentCtrl.unselect(_selected);
	        }
	    }
	
	    function lxSelectChoices() {
	        return {
	            restrict: 'E',
	            require: ['lxSelectChoices', '^lxSelect'],
	            templateUrl: 'select-choices.html',
	            link: link,
	            controller: LxSelectChoicesController,
	            controllerAs: 'lxSelectChoices',
	            bindToController: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs, ctrls, transclude) {
	            ctrls[0].setParentController(ctrls[1]);
	
	            transclude(scope, function (clone) {
	                var template = '';
	
	                for (var i = 0; i < clone.length; i++) {
	                    template += clone[i].outerHTML || '';
	                }
	
	                ctrls[1].registerChoiceTemplate(template);
	            });
	        }
	    }
	
	    LxSelectSelectedController.$inject = ['$scope', '$timeout'];
	
	    function LxSelectChoicesController($scope, $timeout) {
	        var lxSelectChoices = this;
	        var timer;
	
	        lxSelectChoices.isArray = isArray;
	        lxSelectChoices.isSelected = isSelected;
	        lxSelectChoices.setParentController = setParentController;
	        lxSelectChoices.toggleChoice = toggleChoice;
	        lxSelectChoices.updateFilter = updateFilter;
	
	        lxSelectChoices.filterModel = undefined;
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer);
	        });
	
	        // This listener updates providers in dropdown after auto-complete input changed (from querygenerated.controller) (CFS-520)
	        $scope.$on('providersUpdated', function (providers, data) {
	            if ($scope.lxSelectSelected.parentCtrl.label === 'Clinicians') {
	                $scope.lxSelectChoices.parentCtrl.choices = data;
	            }
	        });
	
	        // This listener updates query details dropdown after query type drop-down changed (from querygenerated.controller) (CFS-520)
	        $scope.$on('queryTypeUpdated', function (details, data) {
	            if (lxSelectChoices.parentCtrl.choices === data.old) {
	                lxSelectChoices.parentCtrl.choices = data.new;
	            }
	        });
	
	        function arrayObjectIndexOf(arr, obj) {
	            for (var i = 0; i < arr.length; i++) {
	                if (angular.equals(arr[i], obj)) {
	                    return i;
	                }
	            }
	
	            return -1;
	        }
	
	        function isArray() {
	            return angular.isArray(lxSelectChoices.parentCtrl.choices);
	        }
	
	        function isSelected(_choice) {
	            if (lxSelectChoices.parentCtrl.multiple && angular.isDefined(lxSelectChoices.parentCtrl.getSelectedModel())) {
	                return arrayObjectIndexOf(lxSelectChoices.parentCtrl.getSelectedModel(), _choice) !== -1;
	            } else if (angular.isDefined(lxSelectChoices.parentCtrl.getSelectedModel())) {
	                return angular.equals(lxSelectChoices.parentCtrl.getSelectedModel(), _choice);
	            }
	        }
	
	        function setParentController(_parentCtrl) {
	            lxSelectChoices.parentCtrl = _parentCtrl;
	
	            $scope.$watch(function () {
	                return lxSelectChoices.parentCtrl.ngModel;
	            }, function (newModel, oldModel) {
	                timer = $timeout(function () {
	                    if (newModel !== oldModel && angular.isDefined(lxSelectChoices.parentCtrl.ngChange)) {
	                        lxSelectChoices.parentCtrl.ngChange({
	                            newValue: newModel,
	                            oldValue: oldModel
	                        });
	                    }
	
	                    if (angular.isDefined(lxSelectChoices.parentCtrl.modelToSelection) || angular.isDefined(lxSelectChoices.parentCtrl.selectionToModel)) {
	                        toSelection();
	                    }
	                });
	            }, true);
	        }
	
	        function toggleChoice(_choice, _event) {
	            if (lxSelectChoices.parentCtrl.multiple) {
	                _event.stopPropagation();
	            }
	
	            if (lxSelectChoices.parentCtrl.multiple && isSelected(_choice)) {
	                lxSelectChoices.parentCtrl.unselect(_choice);
	            } else {
	                lxSelectChoices.parentCtrl.select(_choice);
	            }
	        }
	
	        function toSelection() {
	            if (lxSelectChoices.parentCtrl.multiple) {
	                lxSelectChoices.parentCtrl.unconvertedModel = [];
	
	                angular.forEach(lxSelectChoices.parentCtrl.ngModel, function (item) {
	                    lxSelectChoices.parentCtrl.modelToSelection({
	                        data: item,
	                        callback: function callback(resp) {
	                            lxSelectChoices.parentCtrl.unconvertedModel.push(resp);
	                        }
	                    });
	                });
	            } else {
	                lxSelectChoices.parentCtrl.modelToSelection({
	                    data: lxSelectChoices.parentCtrl.ngModel,
	                    callback: function callback(resp) {
	                        lxSelectChoices.parentCtrl.unconvertedModel = resp;
	                    }
	                });
	            }
	        }
	
	        function updateFilter() {
	            // This emit lets the parent component (querygenerated.controller) know to update list of providers (CFS-520)
	            $scope.$emit('updateProviders', lxSelectChoices.filterModel);
	            if (angular.isDefined(lxSelectChoices.parentCtrl.filter)) {
	                lxSelectChoices.parentCtrl.filter({
	                    newValue: lxSelectChoices.filterModel
	                });
	            }
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.switch').directive('lxSwitch', lxSwitch).directive('lxSwitchLabel', lxSwitchLabel).directive('lxSwitchHelp', lxSwitchHelp);
	
	    function lxSwitch() {
	        return {
	            restrict: 'E',
	            templateUrl: 'switch.html',
	            scope: {
	                ngModel: '=',
	                name: '@?',
	                ngTrueValue: '@?',
	                ngFalseValue: '@?',
	                ngChange: '&?',
	                ngDisabled: '=?',
	                lxColor: '@?'
	            },
	            controller: LxSwitchController,
	            controllerAs: 'lxSwitch',
	            bindToController: true,
	            transclude: true,
	            replace: true
	        };
	    }
	
	    LxSwitchController.$inject = ['$scope', '$timeout', 'LxUtils'];
	
	    function LxSwitchController($scope, $timeout, LxUtils) {
	        var lxSwitch = this;
	        var switchId;
	        var switchHasChildren;
	        var timer;
	
	        lxSwitch.getSwitchId = getSwitchId;
	        lxSwitch.getSwitchHasChildren = getSwitchHasChildren;
	        lxSwitch.setSwitchId = setSwitchId;
	        lxSwitch.setSwitchHasChildren = setSwitchHasChildren;
	        lxSwitch.triggerNgChange = triggerNgChange;
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer);
	        });
	
	        init();
	
	        ////////////
	
	        function getSwitchId() {
	            return switchId;
	        }
	
	        function getSwitchHasChildren() {
	            return switchHasChildren;
	        }
	
	        function init() {
	            setSwitchId(LxUtils.generateUUID());
	            setSwitchHasChildren(false);
	
	            lxSwitch.ngTrueValue = angular.isUndefined(lxSwitch.ngTrueValue) ? true : lxSwitch.ngTrueValue;
	            lxSwitch.ngFalseValue = angular.isUndefined(lxSwitch.ngFalseValue) ? false : lxSwitch.ngFalseValue;
	            lxSwitch.lxColor = angular.isUndefined(lxSwitch.lxColor) ? 'accent' : lxSwitch.lxColor;
	        }
	
	        function setSwitchId(_switchId) {
	            switchId = _switchId;
	        }
	
	        function setSwitchHasChildren(_switchHasChildren) {
	            switchHasChildren = _switchHasChildren;
	        }
	
	        function triggerNgChange() {
	            timer = $timeout(lxSwitch.ngChange);
	        }
	    }
	
	    function lxSwitchLabel() {
	        return {
	            restrict: 'AE',
	            require: ['^lxSwitch', '^lxSwitchLabel'],
	            templateUrl: 'switch-label.html',
	            link: link,
	            controller: LxSwitchLabelController,
	            controllerAs: 'lxSwitchLabel',
	            bindToController: true,
	            transclude: true,
	            replace: true
	        };
	
	        function link(scope, element, attrs, ctrls) {
	            ctrls[0].setSwitchHasChildren(true);
	            ctrls[1].setSwitchId(ctrls[0].getSwitchId());
	        }
	    }
	
	    function LxSwitchLabelController() {
	        var lxSwitchLabel = this;
	        var switchId;
	
	        lxSwitchLabel.getSwitchId = getSwitchId;
	        lxSwitchLabel.setSwitchId = setSwitchId;
	
	        ////////////
	
	        function getSwitchId() {
	            return switchId;
	        }
	
	        function setSwitchId(_switchId) {
	            switchId = _switchId;
	        }
	    }
	
	    function lxSwitchHelp() {
	        return {
	            restrict: 'AE',
	            require: '^lxSwitch',
	            templateUrl: 'switch-help.html',
	            transclude: true,
	            replace: true
	        };
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.tabs').directive('lxTabs', lxTabs).directive('lxTab', lxTab).directive('lxTabsPanes', lxTabsPanes).directive('lxTabPane', lxTabPane);
	
	    function lxTabs() {
	        return {
	            restrict: 'E',
	            templateUrl: 'tabs.html',
	            scope: {
	                layout: '@?lxLayout',
	                theme: '@?lxTheme',
	                color: '@?lxColor',
	                indicator: '@?lxIndicator',
	                activeTab: '=?lxActiveTab',
	                panesId: '@?lxPanesId',
	                links: '=?lxLinks'
	            },
	            controller: LxTabsController,
	            controllerAs: 'lxTabs',
	            bindToController: true,
	            replace: true,
	            transclude: true
	        };
	    }
	
	    LxTabsController.$inject = ['LxUtils', '$element', '$scope', '$timeout'];
	
	    function LxTabsController(LxUtils, $element, $scope, $timeout) {
	        var lxTabs = this;
	        var tabsLength;
	        var timer1;
	        var timer2;
	        var timer3;
	        var timer4;
	
	        lxTabs.removeTab = removeTab;
	        lxTabs.setActiveTab = setActiveTab;
	        lxTabs.setViewMode = setViewMode;
	        lxTabs.tabIsActive = tabIsActive;
	        lxTabs.updateTabs = updateTabs;
	
	        lxTabs.activeTab = angular.isDefined(lxTabs.activeTab) ? lxTabs.activeTab : 0;
	        lxTabs.color = angular.isDefined(lxTabs.color) ? lxTabs.color : 'primary';
	        lxTabs.indicator = angular.isDefined(lxTabs.indicator) ? lxTabs.indicator : 'accent';
	        lxTabs.layout = angular.isDefined(lxTabs.layout) ? lxTabs.layout : 'full';
	        lxTabs.tabs = [];
	        lxTabs.theme = angular.isDefined(lxTabs.theme) ? lxTabs.theme : 'light';
	        lxTabs.viewMode = angular.isDefined(lxTabs.links) ? 'separate' : 'gather';
	
	        $scope.$watch(function () {
	            return lxTabs.activeTab;
	        }, function (_newActiveTab, _oldActiveTab) {
	            timer1 = $timeout(function () {
	                setIndicatorPosition(_oldActiveTab);
	
	                if (lxTabs.viewMode === 'separate') {
	                    angular.element('#' + lxTabs.panesId).find('.tabs__pane').hide();
	                    angular.element('#' + lxTabs.panesId).find('.tabs__pane').eq(lxTabs.activeTab).show();
	                }
	            });
	        });
	
	        $scope.$watch(function () {
	            return lxTabs.links;
	        }, function (_newLinks) {
	            angular.forEach(_newLinks, function (link, index) {
	                var tab = {
	                    uuid: LxUtils.generateUUID(),
	                    index: index,
	                    label: link.label,
	                    icon: link.icon,
	                    disabled: link.disabled
	                };
	
	                updateTabs(tab);
	            });
	        });
	
	        timer2 = $timeout(function () {
	            tabsLength = lxTabs.tabs.length;
	        });
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer1);
	            $timeout.cancel(timer2);
	            $timeout.cancel(timer3);
	            $timeout.cancel(timer4);
	        });
	
	        ////////////
	
	        function removeTab(_tab) {
	            lxTabs.tabs.splice(_tab.index, 1);
	
	            angular.forEach(lxTabs.tabs, function (tab, index) {
	                tab.index = index;
	            });
	
	            if (lxTabs.activeTab === 0) {
	                timer3 = $timeout(function () {
	                    setIndicatorPosition();
	                });
	            } else {
	                setActiveTab(lxTabs.tabs[0]);
	            }
	        }
	
	        function setActiveTab(_tab) {
	            if (!_tab.disabled) {
	                lxTabs.activeTab = _tab.index;
	            }
	        }
	
	        function setIndicatorPosition(_previousActiveTab) {
	            var direction = lxTabs.activeTab > _previousActiveTab ? 'right' : 'left';
	            var indicator = $element.find('.tabs__indicator');
	            var activeTab = $element.find('.tabs__link').eq(lxTabs.activeTab);
	            var indicatorLeft = activeTab.position().left;
	            var indicatorRight = $element.outerWidth() - (indicatorLeft + activeTab.outerWidth());
	
	            if (angular.isUndefined(_previousActiveTab)) {
	                indicator.css({
	                    left: indicatorLeft,
	                    right: indicatorRight
	                });
	            } else {
	                var animationProperties = {
	                    duration: 200,
	                    easing: 'easeOutQuint'
	                };
	
	                if (direction === 'left') {
	                    indicator.velocity({
	                        left: indicatorLeft
	                    }, animationProperties);
	
	                    indicator.velocity({
	                        right: indicatorRight
	                    }, animationProperties);
	                } else {
	                    indicator.velocity({
	                        right: indicatorRight
	                    }, animationProperties);
	
	                    indicator.velocity({
	                        left: indicatorLeft
	                    }, animationProperties);
	                }
	            }
	        }
	
	        function setViewMode(_viewMode) {
	            lxTabs.viewMode = _viewMode;
	        }
	
	        function tabIsActive(_index) {
	            return lxTabs.activeTab === _index;
	        }
	
	        function updateTabs(_tab) {
	            var newTab = true;
	
	            angular.forEach(lxTabs.tabs, function (tab) {
	                if (tab.uuid === _tab.uuid) {
	                    newTab = false;
	
	                    tab.index = _tab.index;
	                    tab.icon = _tab.icon;
	                    tab.label = _tab.label;
	                }
	            });
	
	            if (newTab) {
	                lxTabs.tabs.push(_tab);
	
	                if (angular.isDefined(tabsLength)) {
	                    timer4 = $timeout(function () {
	                        setIndicatorPosition();
	                    });
	                }
	            }
	        }
	    }
	
	    function lxTab() {
	        return {
	            restrict: 'E',
	            require: ['lxTab', '^lxTabs'],
	            templateUrl: 'tab.html',
	            scope: {
	                ngDisabled: '=?'
	            },
	            link: link,
	            controller: LxTabController,
	            controllerAs: 'lxTab',
	            bindToController: true,
	            replace: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs, ctrls) {
	            ctrls[0].init(ctrls[1], element.index());
	
	            attrs.$observe('lxLabel', function (_newLabel) {
	                ctrls[0].setLabel(_newLabel);
	            });
	
	            attrs.$observe('lxIcon', function (_newIcon) {
	                ctrls[0].setIcon(_newIcon);
	            });
	        }
	    }
	
	    LxTabController.$inject = ['$scope', 'LxUtils'];
	
	    function LxTabController($scope, LxUtils) {
	        var lxTab = this;
	        var parentCtrl;
	        var tab = {
	            uuid: LxUtils.generateUUID(),
	            index: undefined,
	            label: undefined,
	            icon: undefined,
	            disabled: false
	        };
	
	        lxTab.init = init;
	        lxTab.setIcon = setIcon;
	        lxTab.setLabel = setLabel;
	        lxTab.tabIsActive = tabIsActive;
	
	        $scope.$watch(function () {
	            return lxTab.ngDisabled;
	        }, function (_isDisabled) {
	            if (_isDisabled) {
	                tab.disabled = true;
	            } else {
	                tab.disabled = false;
	            }
	
	            parentCtrl.updateTabs(tab);
	        });
	
	        $scope.$on('$destroy', function () {
	            parentCtrl.removeTab(tab);
	        });
	
	        ////////////
	
	        function init(_parentCtrl, _index) {
	            parentCtrl = _parentCtrl;
	            tab.index = _index;
	
	            parentCtrl.updateTabs(tab);
	        }
	
	        function setIcon(_icon) {
	            tab.icon = _icon;
	
	            parentCtrl.updateTabs(tab);
	        }
	
	        function setLabel(_label) {
	            tab.label = _label;
	
	            parentCtrl.updateTabs(tab);
	        }
	
	        function tabIsActive() {
	            return parentCtrl.tabIsActive(tab.index);
	        }
	    }
	
	    function lxTabsPanes() {
	        return {
	            restrict: 'E',
	            templateUrl: 'tabs-panes.html',
	            scope: true,
	            replace: true,
	            transclude: true
	        };
	    }
	
	    function lxTabPane() {
	        return {
	            restrict: 'E',
	            templateUrl: 'tab-pane.html',
	            scope: true,
	            replace: true,
	            transclude: true
	        };
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.text-field').directive('lxTextField', lxTextField);
	
	    lxTextField.$inject = ['$timeout'];
	
	    function lxTextField($timeout) {
	        return {
	            restrict: 'E',
	            templateUrl: 'text-field.html',
	            scope: {
	                allowClear: '=?lxAllowClear',
	                error: '=?lxError',
	                fixedLabel: '=?lxFixedLabel',
	                icon: '@?lxIcon',
	                label: '@lxLabel',
	                ngDisabled: '=?',
	                theme: '@?lxTheme',
	                valid: '=?lxValid'
	            },
	            link: link,
	            controller: LxTextFieldController,
	            controllerAs: 'lxTextField',
	            bindToController: true,
	            replace: true,
	            transclude: true
	        };
	
	        function link(scope, element, attrs, ctrl, transclude) {
	            var backwardOneWay = ['icon', 'label', 'theme'];
	            var backwardTwoWay = ['error', 'fixedLabel', 'valid'];
	            var input;
	            var timer;
	
	            angular.forEach(backwardOneWay, function (attribute) {
	                if (angular.isDefined(attrs[attribute])) {
	                    attrs.$observe(attribute, function (newValue) {
	                        scope.lxTextField[attribute] = newValue;
	                    });
	                }
	            });
	
	            angular.forEach(backwardTwoWay, function (attribute) {
	                if (angular.isDefined(attrs[attribute])) {
	                    scope.$watch(function () {
	                        return scope.$parent.$eval(attrs[attribute]);
	                    }, function (newValue) {
	                        scope.lxTextField[attribute] = newValue;
	                    });
	                }
	            });
	
	            transclude(function () {
	                input = element.find('textarea');
	
	                if (input[0]) {
	                    input.on('cut paste drop keydown', function () {
	                        timer = $timeout(ctrl.updateTextareaHeight);
	                    });
	                } else {
	                    input = element.find('input');
	                }
	
	                input.addClass('text-field__input');
	
	                ctrl.setInput(input);
	                ctrl.setModel(input.data('$ngModelController'));
	
	                input.on('focus', ctrl.focusInput);
	                input.on('blur', ctrl.blurInput);
	            });
	
	            scope.$on('$destroy', function () {
	                $timeout.cancel(timer);
	                input.off();
	            });
	        }
	    }
	
	    LxTextFieldController.$inject = ['$scope', '$timeout'];
	
	    function LxTextFieldController($scope, $timeout) {
	        var lxTextField = this;
	        var input;
	        var modelController;
	        var timer1;
	        var timer2;
	        var timer3;
	
	        lxTextField.blurInput = blurInput;
	        lxTextField.clearInput = clearInput;
	        lxTextField.focusInput = focusInput;
	        lxTextField.hasValue = hasValue;
	        lxTextField.setInput = setInput;
	        lxTextField.setModel = setModel;
	        lxTextField.updateTextareaHeight = updateTextareaHeight;
	
	        $scope.$watch(function () {
	            return modelController.$viewValue;
	        }, function (newValue, oldValue) {
	            if (angular.isDefined(newValue) && newValue) {
	                lxTextField.isActive = true;
	            } else {
	                lxTextField.isActive = false;
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            $timeout.cancel(timer1);
	            $timeout.cancel(timer2);
	            $timeout.cancel(timer3);
	        });
	
	        ////////////
	
	        function blurInput() {
	            if (!hasValue()) {
	                $scope.$apply(function () {
	                    lxTextField.isActive = false;
	                });
	            }
	
	            $scope.$apply(function () {
	                lxTextField.isFocus = false;
	            });
	        }
	
	        function clearInput() {
	            modelController.$setViewValue(undefined);
	            modelController.$render();
	
	            timer1 = $timeout(function () {
	                input.focus();
	            });
	        }
	
	        function focusInput() {
	            $scope.$apply(function () {
	                lxTextField.isActive = true;
	                lxTextField.isFocus = true;
	            });
	        }
	
	        function hasValue() {
	            return input.val();
	        }
	
	        function init() {
	            lxTextField.isActive = hasValue();
	            lxTextField.isFocus = false;
	        }
	
	        function setInput(_input) {
	            input = _input;
	
	            timer2 = $timeout(init);
	
	            if (input.selector === 'textarea') {
	                timer3 = $timeout(updateTextareaHeight);
	            }
	        }
	
	        function setModel(_modelControler) {
	            modelController = _modelControler;
	        }
	
	        function updateTextareaHeight() {
	            var tmpTextArea = angular.element('<textarea class="text-field__input" style="width: ' + input.width() + 'px;">' + input.val() + '</textarea>');
	
	            tmpTextArea.appendTo('body');
	
	            input.css({
	                height: tmpTextArea[0].scrollHeight + 'px'
	            });
	
	            tmpTextArea.remove();
	        }
	    }
	})();
	(function () {
	    'use strict';
	
	    angular.module('lumx.tooltip').directive('lxTooltip', lxTooltip);
	
	    function lxTooltip() {
	        return {
	            restrict: 'A',
	            scope: {
	                tooltip: '@lxTooltip',
	                position: '@?lxTooltipPosition'
	            },
	            link: link,
	            controller: LxTooltipController,
	            controllerAs: 'lxTooltip',
	            bindToController: true
	        };
	
	        function link(scope, element, attrs, ctrl) {
	            if (angular.isDefined(attrs.tooltipPosition)) {
	                attrs.$observe('tooltipPosition', function (newValue) {
	                    scope.lxTooltip.position = newValue;
	                });
	            }
	
	            element.on('mouseenter', ctrl.showTooltip);
	            element.on('mouseleave', ctrl.hideTooltip);
	
	            scope.$on('$destroy', function () {
	                element.off();
	            });
	        }
	    }
	
	    LxTooltipController.$inject = ['$element', '$scope', '$timeout', 'LxDepthService'];
	
	    function LxTooltipController($element, $scope, $timeout, LxDepthService) {
	        var lxTooltip = this;
	        var timer1;
	        var timer2;
	        var tooltip;
	        var tooltipBackground;
	        var tooltipLabel;
	
	        lxTooltip.hideTooltip = hideTooltip;
	        lxTooltip.showTooltip = showTooltip;
	
	        lxTooltip.position = angular.isDefined(lxTooltip.position) ? lxTooltip.position : 'top';
	
	        $scope.$on('$destroy', function () {
	            if (angular.isDefined(tooltip)) {
	                tooltip.remove();
	            }
	
	            $timeout.cancel(timer1);
	            $timeout.cancel(timer2);
	        });
	
	        ////////////
	
	        function hideTooltip() {
	            if (angular.isDefined(tooltip)) {
	                tooltip.removeClass('tooltip--is-active');
	
	                timer1 = $timeout(function () {
	                    tooltip.remove();
	                }, 200);
	            }
	        }
	
	        function setTooltipPosition() {
	            var width = $element.outerWidth(),
	                height = $element.outerHeight(),
	                top = $element.offset().top,
	                left = $element.offset().left;
	
	            tooltip.append(tooltipBackground).append(tooltipLabel).appendTo('body');
	
	            if (lxTooltip.position === 'top') {
	                tooltip.css({
	                    left: left - tooltip.outerWidth() / 2 + width / 2,
	                    top: top - tooltip.outerHeight()
	                });
	            } else if (lxTooltip.position === 'bottom') {
	                tooltip.css({
	                    left: left - tooltip.outerWidth() / 2 + width / 2,
	                    top: top + height
	                });
	            } else if (lxTooltip.position === 'left') {
	                tooltip.css({
	                    left: left - tooltip.outerWidth(),
	                    top: top + height / 2 - tooltip.outerHeight() / 2
	                });
	            } else if (lxTooltip.position === 'right') {
	                tooltip.css({
	                    left: left + width,
	                    top: top + height / 2 - tooltip.outerHeight() / 2
	                });
	            }
	        }
	
	        function showTooltip() {
	            LxDepthService.register();
	
	            tooltip = angular.element('<div/>', {
	                class: 'tooltip tooltip--' + lxTooltip.position
	            });
	
	            tooltipBackground = angular.element('<div/>', {
	                class: 'tooltip__background'
	            });
	
	            tooltipLabel = angular.element('<span/>', {
	                class: 'tooltip__label',
	                text: lxTooltip.tooltip
	            });
	
	            setTooltipPosition();
	
	            tooltip.append(tooltipBackground).append(tooltipLabel).css('z-index', LxDepthService.getDepth()).appendTo('body');
	
	            timer2 = $timeout(function () {
	                tooltip.addClass('tooltip--is-active');
	            });
	        }
	    }
	})();
	angular.module("lumx.dropdown").run(['$templateCache', function (a) {
	    a.put('dropdown.html', '<div class="dropdown" ng-transclude></div>\n' + '');
	    a.put('dropdown-toggle.html', '<div class="dropdown-toggle" ng-transclude></div>\n' + '');
	    a.put('dropdown-menu.html', '<div class="dropdown-menu">\n' + '    <div class="dropdown-menu__content" ng-transclude ng-if="lxDropdownMenu.parentCtrl.isOpen"></div>\n' + '</div>\n' + '');
	}]);
	angular.module("lumx.file-input").run(['$templateCache', function (a) {
	    a.put('file-input.html', '<div class="input-file">\n' + '    <span class="input-file__label">{{ lxFileInput.label }}</span>\n' + '    <span class="input-file__filename">{{ lxFileInput.fileName }}</span>\n' + '    <input type="file" class="input-file__input">\n' + '</div>\n' + '');
	}]);
	angular.module("lumx.text-field").run(['$templateCache', function (a) {
	    a.put('text-field.html', '<div class="text-field"\n' + '     ng-class="{ \'text-field--error\': lxTextField.error,\n' + '                 \'text-field--fixed-label\': lxTextField.fixedLabel,\n' + '                 \'text-field--has-icon\': lxTextField.icon,\n' + '                 \'text-field--has-value\': lxTextField.hasValue(),\n' + '                 \'text-field--is-active\': lxTextField.isActive,\n' + '                 \'text-field--is-disabled\': lxTextField.ngDisabled,\n' + '                 \'text-field--is-focus\': lxTextField.isFocus,\n' + '                 \'text-field--theme-light\': !lxTextField.theme || lxTextField.theme === \'light\',\n' + '                 \'text-field--theme-dark\': lxTextField.theme === \'dark\',\n' + '                 \'text-field--valid\': lxTextField.valid }">\n' + '    <div class="text-field__icon" ng-if="lxTextField.icon">\n' + '        <i class="mdi mdi-{{ lxTextField.icon }}"></i>\n' + '    </div>\n' + '\n' + '    <label class="text-field__label">\n' + '        {{ lxTextField.label }}\n' + '    </label>\n' + '\n' + '    <div ng-transclude></div>\n' + '\n' + '    <span class="text-field__clear" ng-click="lxTextField.clearInput()" ng-if="lxTextField.allowClear">\n' + '        <i class="mdi mdi-close-circle"></i>\n' + '    </span>\n' + '</div>\n' + '');
	}]);
	angular.module("lumx.search-filter").run(['$templateCache', function (a) {
	    a.put('search-filter.html', '<div class="search-filter" ng-class="lxSearchFilter.getClass()">\n' + '    <div class="search-filter__container">\n' + '        <div class="search-filter__button">\n' + '            <lx-button lx-size="l" lx-color="{{ lxSearchFilter.color }}" lx-type="icon" ng-click="lxSearchFilter.openInput()">\n' + '                <i class="mdi mdi-magnify"></i>\n' + '            </lx-button>\n' + '        </div>\n' + '\n' + '        <div class="search-filter__input" ng-transclude></div>\n' + '\n' + '        <span class="search-filter__clear" ng-click="lxSearchFilter.clearInput()">\n' + '            <i class="mdi mdi-close-circle"></i>\n' + '        </span>\n' + '    </div>\n' + '</div>');
	}]);
	angular.module("lumx.select").run(['$templateCache', function (a) {
	    a.put('select.html', '<div class="lx-select"\n' + '     ng-class="{ \'lx-select--error\': lxSelect.error,\n' + '                 \'lx-select--fixed-label\': lxSelect.fixedLabel,\n' + '                 \'lx-select--is-active\': (!lxSelect.multiple && lxSelect.getSelectedModel()) || (lxSelect.multiple && lxSelect.getSelectedModel().length),\n' + '                 \'lx-select--is-disabled\': lxSelect.ngDisabled,\n' + '                 \'lx-select--is-multiple\': lxSelect.multiple,\n' + '                 \'lx-select--is-unique\': !lxSelect.multiple,\n' + '                 \'lx-select--theme-light\': !lxSelect.theme || lxSelect.theme === \'light\',\n' + '                 \'lx-select--theme-dark\': lxSelect.theme === \'dark\',\n' + '                 \'lx-select--valid\': lxSelect.valid }" error="fc.$invalid && fc.$touched">\n' + '    <span class="lx-select-label">\n' + '        {{ ::lxSelect.label }}\n' + '    </span>\n' + '\n' + '    <lx-dropdown lx-width="100%">\n' + '        <ng-transclude></ng-transclude>\n' + '    </lx-dropdown>\n' + '</div>\n' + '');
	    a.put('select-selected.html', '<div lx-dropdown-toggle>\n' + '    <div class="lx-select-selected-wrapper">\n' + '        <div class="lx-select-selected" ng-if="!lxSelectSelected.parentCtrl.multiple && lxSelectSelected.parentCtrl.getSelectedModel()">\n' + '            <span class="lx-select-selected__value"\n' + '                  ng-bind-html="lxSelectSelected.parentCtrl.displaySelected()"></span>\n' + '\n' + '            <a class="lx-select-selected__clear"\n' + '               ng-click="lxSelectSelected.clearModel($event)"\n' + '               ng-if="::lxSelectSelected.parentCtrl.allowClear">\n' + '                <i class="mdi mdi-close-circle"></i>\n' + '            </a>\n' + '        </div>\n' + '\n' + '        <div class="lx-select-selected" ng-if="lxSelectSelected.parentCtrl.multiple && lxSelectSelected.parentCtrl.getSelectedModel().length">\n' + '            <span class="lx-select-selected__tag"\n' + '                  ng-click="lxSelectSelected.removeSelected(selected, $event)"\n' + '                  ng-repeat="selected in lxSelectSelected.parentCtrl.getSelectedModel()"\n' + '                  ng-bind-html="lxSelectSelected.parentCtrl.displaySelected(selected)"></span>\n' + '        </div>\n' + '    </div>\n' + '</div>\n' + '');
	    a.put('select-choices.html', '<lx-dropdown-menu class="lx-select-choices"\n' + '                  ng-class="{ \'lx-select-choices--custom-style\': lxSelectChoices.parentCtrl.customStyle,\n' + '                              \'lx-select-choices--default-style\': !lxSelectChoices.parentCtrl.customStyle,\n' + '                              \'lx-select-choices--is-multiple\': lxSelectChoices.parentCtrl.multiple,\n' + '                              \'lx-select-choices--is-unique\': !lxSelectChoices.parentCtrl.multiple, }">\n' + '    <ul>\n' + '        <li class="lx-select-choices__filter" ng-if="::lxSelectChoices.parentCtrl.displayFilter">\n' + '            <lx-search-filter lx-dropdown-filter>\n' + '                <input type="text" ng-model="lxSelectChoices.filterModel" ng-change="lxSelectChoices.updateFilter()">\n' + '            </lx-search-filter>\n' + '        </li>\n' + '        \n' + '        <div ng-if="::lxSelectChoices.isArray()">\n' +
	    // TODO: This hack is the only way I can figure out how have tooltips for lx-select items (CFS-484)
	    '            <li ng-if="choice.errorCategory" lx-tooltip="{{ choice.description }}" class="lx-select-choices__choice"\n' + '                ng-class="{ \'lx-select-choices__choice--is-selected\': lxSelectChoices.isSelected(choice.errorCategory) }"\n' + '                ng-repeat="choice in lxSelectChoices.parentCtrl.choices | filterChoices:lxSelectChoices.parentCtrl.filter:lxSelectChoices.filterModel"\n' + '                ng-bind-html="::lxSelectChoices.parentCtrl.displayChoice(choice.errorCategory)"\n' + '                ng-click="lxSelectChoices.toggleChoice(choice.errorCategory, $event)"></li>\n' + '            <li ng-if="choice.changeCategory" lx-tooltip="{{ choice.description }}" class="lx-select-choices__choice"\n' + '                ng-class="{ \'lx-select-choices__choice--is-selected\': lxSelectChoices.isSelected(choice.changeCategory) }"\n' + '                ng-repeat="choice in lxSelectChoices.parentCtrl.choices | filterChoices:lxSelectChoices.parentCtrl.filter:lxSelectChoices.filterModel"\n' + '                ng-bind-html="::lxSelectChoices.parentCtrl.displayChoice(choice.changeCategory)"\n' + '                ng-click="lxSelectChoices.toggleChoice(choice.changeCategory, $event)"></li>\n' + '            <li ng-if="!choice.errorCategory && !choice.changeCategory" class="lx-select-choices__choice"\n' + '                ng-class="{ \'lx-select-choices__choice--is-selected\': lxSelectChoices.isSelected(choice) }"\n' + '                ng-repeat="choice in lxSelectChoices.parentCtrl.choices | filterChoices:lxSelectChoices.parentCtrl.filter:lxSelectChoices.filterModel"\n' + '                ng-bind-html="::lxSelectChoices.parentCtrl.displayChoice(choice)"\n' + '                ng-click="lxSelectChoices.toggleChoice(choice, $event)"></li>\n' + '        </div>\n' + '\n' + '        <div ng-if="::!lxSelectChoices.isArray()">\n' + '            <li class="lx-select-choices__subheader"\n' + '                ng-repeat-start="(subheader, children) in lxSelectChoices.parentCtrl.choices"\n' + '                ng-bind-html="::lxSelectChoices.parentCtrl.displaySubheader(subheader)"></li>\n' + '\n' + '            <li class="lx-select-choices__choice"\n' + '                ng-class="{ \'lx-select-choices__choice--is-selected\': lxSelectChoices.isSelected(choice) }"\n' + '                ng-repeat-end\n' + '                ng-repeat="choice in children | filterChoices:lxSelectChoices.parentCtrl.filter:lxSelectChoices.filterModel"\n' + '                ng-bind-html="::lxSelectChoices.parentCtrl.displayChoice(choice)"\n' + '                ng-click="lxSelectChoices.toggleChoice(choice, $event)"></li>\n' + '        </div>\n' + '\n' + '        <li class="lx-select-choices__subheader" ng-if="lxSelectChoices.parentCtrl.helper">\n' + '            {{ lxSelectChoices.parentCtrl.helperMessage }}\n' + '        </li>\n' + '\n' + '        <li class="lx-select-choices__loader" ng-if="lxSelectChoices.parentCtrl.loading">\n' + '            <lx-progress lx-type="circular" lx-color="primary" lx-diameter="20"></lx-progress>\n' + '        </li>\n' + '    </ul>\n' + '</lx-dropdown-menu>\n' + '');
	}]);
	angular.module("lumx.tabs").run(['$templateCache', function (a) {
	    a.put('tabs.html', '<div class="tabs tabs--layout-{{ lxTabs.layout }} tabs--theme-{{ lxTabs.theme }} tabs--color-{{ lxTabs.color }} tabs--indicator-{{ lxTabs.indicator }}">\n' + '    <div class="tabs__links">\n' + '        <a class="tabs__link"\n' + '           ng-class="{ \'tabs__link--is-active\': lxTabs.tabIsActive(tab.index),\n' + '                       \'tabs__link--is-disabled\': tab.disabled }"\n' + '           ng-repeat="tab in lxTabs.tabs"\n' + '           ng-click="lxTabs.setActiveTab(tab)"\n' + '           lx-ripple>\n' + '           <i class="mdi mdi-{{ tab.icon }}" ng-if="tab.icon"></i>\n' + '           <span ng-if="tab.label">{{ tab.label }}</span>\n' + '        </a>\n' + '    </div>\n' + '    \n' + '    <div class="tabs__panes" ng-if="lxTabs.viewMode === \'gather\'" ng-transclude></div>\n' + '    <div class="tabs__indicator"></div>\n' + '</div>\n' + '');
	    a.put('tabs-panes.html', '<div class="tabs">\n' + '    <div class="tabs__panes" ng-transclude></div>\n' + '</div>');
	    a.put('tab.html', '<div class="tabs__pane" ng-class="{ \'tabs__pane--is-disabled\': lxTab.ngDisabled }" ng-show="lxTab.tabIsActive()" ng-transclude></div>\n' + '');
	    a.put('tab-pane.html', '<div class="tabs__pane" ng-transclude></div>\n' + '');
	}]);
	angular.module("lumx.date-picker").run(['$templateCache', function (a) {
	    a.put('date-picker.html', '<div class="lx-date">\n' + '    <!-- Date picker input -->\n' + '    <div class="lx-date-input" ng-click="lxDatePicker.openDatePicker()" ng-if="lxDatePicker.hasInput">\n' + '        <ng-transclude></ng-transclude>\n' + '    </div>\n' + '    \n' + '    <!-- Date picker -->\n' + '    <div class="lx-date-picker lx-date-picker--{{ lxDatePicker.color }}">\n' + '        <div ng-if="lxDatePicker.isOpen">\n' + '            <!-- Date picker: header -->\n' + '            <div class="lx-date-picker__header">\n' + '                <a class="lx-date-picker__current-year"\n' + '                   ng-class="{ \'lx-date-picker__current-year--is-active\': lxDatePicker.yearSelection }"\n' + '                   ng-click="lxDatePicker.displayYearSelection()">\n' + '                    {{ lxDatePicker.moment(lxDatePicker.ngModel).format(\'YYYY\') }}\n' + '                </a>\n' + '\n' + '                <a class="lx-date-picker__current-date"\n' + '                   ng-class="{ \'lx-date-picker__current-date--is-active\': !lxDatePicker.yearSelection }"\n' + '                   ng-click="lxDatePicker.hideYearSelection()">\n' + '                    {{ lxDatePicker.getDateFormatted() }}\n' + '                </a>\n' + '            </div>\n' + '            \n' + '            <!-- Date picker: content -->\n' + '            <div class="lx-date-picker__content">\n' + '                <!-- Calendar -->\n' + '                <div class="lx-date-picker__calendar" ng-if="!lxDatePicker.yearSelection">\n' + '                    <div class="lx-date-picker__nav">\n' + '                        <lx-button lx-size="l" lx-color="black" lx-type="icon" ng-click="lxDatePicker.previousMonth()">\n' + '                            <i class="mdi mdi-chevron-left"></i>\n' + '                        </lx-button>\n' + '\n' + '                        <span>{{ lxDatePicker.ngModelMoment.format(\'MMMM YYYY\') }}</span>\n' + '                        \n' + '                        <lx-button lx-size="l" lx-color="black" lx-type="icon" ng-click="lxDatePicker.nextMonth()">\n' + '                            <i class="mdi mdi-chevron-right"></i>\n' + '                        </lx-button>\n' + '                    </div>\n' + '\n' + '                    <div class="lx-date-picker__days-of-week">\n' + '                        <span ng-repeat="day in lxDatePicker.daysOfWeek">{{ day }}</span>\n' + '                    </div>\n' + '\n' + '                    <div class="lx-date-picker__days">\n' + '                        <span class="lx-date-picker__day lx-date-picker__day--is-empty"\n' + '                              ng-repeat="x in lxDatePicker.emptyFirstDays">&nbsp;</span>\n' + '\n' + '                        <div class="lx-date-picker__day"\n' + '                             ng-class="{ \'lx-date-picker__day--is-selected\': day.selected,\n' + '                                         \'lx-date-picker__day--is-today\': day.today && !day.selected,\n' + '                                         \'lx-date-picker__day--is-disabled\': day.disabled,\n' + '                                         \'lx-date-picker__day--is-incomplete\': day.incomplete,\n' + '                                         \'lx-date-picker__day--is-complete\': day.complete }"\n' + '                             ng-repeat="day in lxDatePicker.days">\n' + '                            <a ng-click="lxDatePicker.select(day)">{{ day ? day.format(\'D\') : \'\' }}</a>\n' + '                        </div>\n' + '\n' + '                        <span class="lx-date-picker__day lx-date-picker__day--is-empty"\n' + '                              ng-repeat="x in lxDatePicker.emptyLastDays">&nbsp;</span>\n' + '                    </div>\n' + '                </div>\n' + '\n' + '                <!-- Year selection -->\n' + '                <div class="lx-date-picker__year-selector" ng-if="lxDatePicker.yearSelection">\n' + '                    <a class="lx-date-picker__year"\n' + '                         ng-class="{ \'lx-date-picker__year--is-active\': year == lxDatePicker.moment(lxDatePicker.ngModel).format(\'YYYY\') }"\n' + '                         ng-repeat="year in lxDatePicker.years"\n' + '                         ng-click="lxDatePicker.selectYear(year)"\n' + '                         ng-if="lxDatePicker.yearSelection">\n' + '                        {{ year }}\n' + '                    </a>\n' + '                </div>\n' + '            </div>\n' + '\n' + '            <!-- Actions -->\n' + '            <div class="lx-date-picker__actions">\n' + '                <lx-button lx-color="{{ lxDatePicker.color }}" lx-type="flat" ng-click="lxDatePicker.closeDatePicker()">\n' + '                    Ok\n' + '                </lx-button>\n' + '            </div>\n' + '        </div>\n' + '    </div>\n' + '</div>');
	}]);
	angular.module("lumx.progress").run(['$templateCache', function (a) {
	    a.put('progress.html', '<div class="progress-container progress-container--{{ lxProgress.lxType }} progress-container--{{ lxProgress.lxColor }}">\n' + '    <div class="progress-circular"\n' + '         ng-if="lxProgress.lxType === \'circular\'"\n' + '         ng-style="lxProgress.getProgressDiameter()">\n' + '        <svg class="progress-circular__svg">\n' + '            <circle class="progress-circular__path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/>\n' + '        </svg>\n' + '    </div>\n' + '\n' + '    <div class="progress-linear" ng-if="lxProgress.lxType === \'linear\'">\n' + '        <div class="progress-linear__background"></div>\n' + '        <div class="progress-linear__bar progress-linear__bar--first"></div>\n' + '        <div class="progress-linear__bar progress-linear__bar--second"></div>\n' + '    </div>\n' + '</div>\n' + '');
	}]);
	angular.module("lumx.button").run(['$templateCache', function (a) {
	    a.put('link.html', '<a ng-transclude lx-ripple></a>\n' + '');
	    a.put('button.html', '<button ng-transclude lx-ripple></button>\n' + '');
	}]);
	angular.module("lumx.checkbox").run(['$templateCache', function (a) {
	    a.put('checkbox.html', '<div class="checkbox checkbox--{{ lxCheckbox.lxColor }}">\n' + '    <input id="{{ lxCheckbox.getCheckboxId() }}"\n' + '           type="checkbox"\n' + '           class="checkbox__input"\n' + '           name="{{ lxCheckbox.name }}"\n' + '           ng-model="lxCheckbox.ngModel"\n' + '           ng-true-value="{{ lxCheckbox.ngTrueValue }}"\n' + '           ng-false-value="{{ lxCheckbox.ngFalseValue }}"\n' + '           ng-change="lxCheckbox.triggerNgChange()"\n' + '           ng-disabled="lxCheckbox.ngDisabled">\n' + '\n' + '    <label for="{{ lxCheckbox.getCheckboxId() }}" class="checkbox__label" ng-transclude ng-if="!lxCheckbox.getCheckboxHasChildren()"></label>\n' + '    <ng-transclude-replace ng-if="lxCheckbox.getCheckboxHasChildren()"></ng-transclude-replace>\n' + '</div>\n' + '');
	    a.put('checkbox-label.html', '<label for="{{ lxCheckboxLabel.getCheckboxId() }}" class="checkbox__label" ng-transclude></label>\n' + '');
	    a.put('checkbox-help.html', '<span class="checkbox__help" ng-transclude></span>\n' + '');
	}]);
	angular.module("lumx.radio-button").run(['$templateCache', function (a) {
	    a.put('radio-group.html', '<div class="radio-group" ng-transclude></div>\n' + '');
	    a.put('radio-button.html', '<div class="radio-button radio-button--{{ lxRadioButton.lxColor }}">\n' + '    <input id="{{ lxRadioButton.getRadioButtonId() }}"\n' + '           type="radio"\n' + '           class="radio-button__input"\n' + '           name="{{ lxRadioButton.name }}"\n' + '           ng-model="lxRadioButton.ngModel"\n' + '           ng-value="lxRadioButton.ngValue"\n' + '           ng-change="lxRadioButton.triggerNgChange()"\n' + '           ng-disabled="lxRadioButton.ngDisabled">\n' + '\n' + '    <label for="{{ lxRadioButton.getRadioButtonId() }}" class="radio-button__label" ng-transclude ng-if="!lxRadioButton.getRadioButtonHasChildren()"></label>\n' + '    <ng-transclude-replace ng-if="lxRadioButton.getRadioButtonHasChildren()"></ng-transclude-replace>\n' + '</div>\n' + '');
	    a.put('radio-button-label.html', '<label for="{{ lxRadioButtonLabel.getRadioButtonId() }}" class="radio-button__label" ng-transclude></label>\n' + '');
	    a.put('radio-button-help.html', '<span class="radio-button__help" ng-transclude></span>\n' + '');
	}]);
	angular.module("lumx.switch").run(['$templateCache', function (a) {
	    a.put('switch.html', '<div class="switch switch--{{ lxSwitch.lxColor }}">\n' + '    <input id="{{ lxSwitch.getSwitchId() }}"\n' + '           type="checkbox"\n' + '           class="switch__input"\n' + '           name="{{ lxSwitch.name }}"\n' + '           ng-model="lxSwitch.ngModel"\n' + '           ng-true-value="{{ lxSwitch.ngTrueValue }}"\n' + '           ng-false-value="{{ lxSwitch.ngFalseValue }}"\n' + '           ng-change="lxSwitch.triggerNgChange()"\n' + '           ng-disabled="lxSwitch.ngDisabled">\n' + '\n' + '    <label for="{{ lxSwitch.getSwitchId() }}" class="switch__label" ng-transclude ng-if="!lxSwitch.getSwitchHasChildren()"></label>\n' + '    <ng-transclude-replace ng-if="lxSwitch.getSwitchHasChildren()"></ng-transclude-replace>\n' + '</div>\n' + '');
	    a.put('switch-label.html', '<label for="{{ lxSwitchLabel.getSwitchId() }}" class="switch__label" ng-transclude></label>\n' + '');
	    a.put('switch-help.html', '<span class="switch__help" ng-transclude></span>\n' + '');
	}]);
	angular.module("lumx.fab").run(['$templateCache', function (a) {
	    a.put('fab.html', '<div class="fab">\n' + '    <ng-transclude-replace></ng-transclude-replace>\n' + '</div>\n' + '');
	    a.put('fab-trigger.html', '<div class="fab__primary" ng-transclude></div>\n' + '');
	    a.put('fab-actions.html', '<div class="fab__actions fab__actions--{{ parentCtrl.lxDirection }}" ng-transclude></div>\n' + '');
	}]);
	angular.module("lumx.icon").run(['$templateCache', function (a) {
	    a.put('icon.html', '<i class="icon mdi" ng-class="lxIcon.getClass()"></i>');
	}]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function () {
	    "use strict";
	
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	
	    /**
	     * A component handler interface using the revealing module design pattern.
	     * More details on this design pattern here:
	     * https://github.com/jasonmayes/mdl-component-design-pattern
	     *
	     * @author Jason Mayes.
	     */
	    /* exported componentHandler */
	
	    // Pre-defining the componentHandler interface, for closure documentation and
	    // static verification.
	
	    var componentHandler = {
	        /**
	         * Searches existing DOM for elements of our component type and upgrades them
	         * if they have not already been upgraded.
	         *
	         * @param {string=} optJsClass the programatic name of the element class we
	         * need to create a new instance of.
	         * @param {string=} optCssClass the name of the CSS class elements of this
	         * type will have.
	         */
	        upgradeDom: function upgradeDom(optJsClass, optCssClass) {},
	        /**
	         * Upgrades a specific element rather than all in the DOM.
	         *
	         * @param {!Element} element The element we wish to upgrade.
	         * @param {string=} optJsClass Optional name of the class we want to upgrade
	         * the element to.
	         */
	        upgradeElement: function upgradeElement(element, optJsClass) {},
	        /**
	         * Upgrades a specific list of elements rather than all in the DOM.
	         *
	         * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
	         * The elements we wish to upgrade.
	         */
	        upgradeElements: function upgradeElements(elements) {},
	        /**
	         * Upgrades all registered components found in the current DOM. This is
	         * automatically called on window load.
	         */
	        upgradeAllRegistered: function upgradeAllRegistered() {},
	        /**
	         * Allows user to be alerted to any upgrades that are performed for a given
	         * component type
	         *
	         * @param {string} jsClass The class name of the MDL component we wish
	         * to hook into for any upgrades performed.
	         * @param {function(!HTMLElement)} callback The function to call upon an
	         * upgrade. This function should expect 1 parameter - the HTMLElement which
	         * got upgraded.
	         */
	        registerUpgradedCallback: function registerUpgradedCallback(jsClass, callback) {},
	        /**
	         * Registers a class for future use and attempts to upgrade existing DOM.
	         *
	         * @param {componentHandler.ComponentConfigPublic} config the registration configuration
	         */
	        register: function register(config) {},
	        /**
	         * Downgrade either a given node, an array of nodes, or a NodeList.
	         *
	         * @param {!Node|!Array<!Node>|!NodeList} nodes
	         */
	        downgradeElements: function downgradeElements(nodes) {}
	    };
	
	    componentHandler = function () {
	        'use strict';
	
	        /** @type {!Array<componentHandler.ComponentConfig>} */
	
	        var registeredComponents_ = [];
	
	        /** @type {!Array<componentHandler.Component>} */
	        var createdComponents_ = [];
	
	        var componentConfigProperty_ = 'mdlComponentConfigInternal_';
	
	        /**
	         * Searches registered components for a class we are interested in using.
	         * Optionally replaces a match with passed object if specified.
	         *
	         * @param {string} name The name of a class we want to use.
	         * @param {componentHandler.ComponentConfig=} optReplace Optional object to replace match with.
	         * @return {!Object|boolean}
	         * @private
	         */
	        function findRegisteredClass_(name, optReplace) {
	            for (var i = 0; i < registeredComponents_.length; i++) {
	                if (registeredComponents_[i].className === name) {
	                    if (typeof optReplace !== 'undefined') {
	                        registeredComponents_[i] = optReplace;
	                    }
	                    return registeredComponents_[i];
	                }
	            }
	            return false;
	        }
	
	        /**
	         * Returns an array of the classNames of the upgraded classes on the element.
	         *
	         * @param {!Element} element The element to fetch data from.
	         * @return {!Array<string>}
	         * @private
	         */
	        function getUpgradedListOfElement_(element) {
	            var dataUpgraded = element.getAttribute('data-upgraded');
	            // Use `['']` as default value to conform the `,name,name...` style.
	            return dataUpgraded === null ? [''] : dataUpgraded.split(',');
	        }
	
	        /**
	         * Returns true if the given element has already been upgraded for the given
	         * class.
	         *
	         * @param {!Element} element The element we want to check.
	         * @param {string} jsClass The class to check for.
	         * @returns {boolean}
	         * @private
	         */
	        function isElementUpgraded_(element, jsClass) {
	            var upgradedList = getUpgradedListOfElement_(element);
	            return upgradedList.indexOf(jsClass) !== -1;
	        }
	
	        /**
	         * Searches existing DOM for elements of our component type and upgrades them
	         * if they have not already been upgraded.
	         *
	         * @param {string=} optJsClass the programatic name of the element class we
	         * need to create a new instance of.
	         * @param {string=} optCssClass the name of the CSS class elements of this
	         * type will have.
	         */
	        function upgradeDomInternal(optJsClass, optCssClass) {
	            if (typeof optJsClass === 'undefined' && typeof optCssClass === 'undefined') {
	                for (var i = 0; i < registeredComponents_.length; i++) {
	                    upgradeDomInternal(registeredComponents_[i].className, registeredComponents_[i].cssClass);
	                }
	            } else {
	                var jsClass = /** @type {string} */optJsClass;
	                if (typeof optCssClass === 'undefined') {
	                    var registeredClass = findRegisteredClass_(jsClass);
	                    if (registeredClass) {
	                        optCssClass = registeredClass.cssClass;
	                    }
	                }
	
	                var elements = document.querySelectorAll('.' + optCssClass);
	                for (var n = 0; n < elements.length; n++) {
	                    upgradeElementInternal(elements[n], jsClass);
	                }
	            }
	        }
	
	        /**
	         * Upgrades a specific element rather than all in the DOM.
	         *
	         * @param {!Element} element The element we wish to upgrade.
	         * @param {string=} optJsClass Optional name of the class we want to upgrade
	         * the element to.
	         */
	        function upgradeElementInternal(element, optJsClass) {
	            // Verify argument type.
	            if (!((typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && element instanceof Element)) {
	                throw new Error('Invalid argument provided to upgrade MDL element.');
	            }
	            var upgradedList = getUpgradedListOfElement_(element);
	            var classesToUpgrade = [];
	            // If jsClass is not provided scan the registered components to find the
	            // ones matching the element's CSS classList.
	            if (!optJsClass) {
	                var classList = element.classList;
	                registeredComponents_.forEach(function (component) {
	                    // Match CSS & Not to be upgraded & Not upgraded.
	                    if (classList.contains(component.cssClass) && classesToUpgrade.indexOf(component) === -1 && !isElementUpgraded_(element, component.className)) {
	                        classesToUpgrade.push(component);
	                    }
	                });
	            } else if (!isElementUpgraded_(element, optJsClass)) {
	                classesToUpgrade.push(findRegisteredClass_(optJsClass));
	            }
	
	            // Upgrade the element for each classes.
	            for (var i = 0, n = classesToUpgrade.length, registeredClass; i < n; i++) {
	                registeredClass = classesToUpgrade[i];
	                if (registeredClass) {
	                    // Mark element as upgraded.
	                    upgradedList.push(registeredClass.className);
	                    element.setAttribute('data-upgraded', upgradedList.join(','));
	                    var instance = new registeredClass.classConstructor(element);
	                    instance[componentConfigProperty_] = registeredClass;
	                    createdComponents_.push(instance);
	                    // Call any callbacks the user has registered with this component type.
	                    for (var j = 0, m = registeredClass.callbacks.length; j < m; j++) {
	                        registeredClass.callbacks[j](element);
	                    }
	
	                    if (registeredClass.widget) {
	                        // Assign per element instance for control over API
	                        element[registeredClass.className] = instance;
	                    }
	                } else {
	                    throw new Error('Unable to find a registered component for the given class.');
	                }
	
	                var ev = document.createEvent('Events');
	                ev.initEvent('mdl-componentupgraded', true, true);
	                element.dispatchEvent(ev);
	            }
	        }
	
	        /**
	         * Upgrades a specific list of elements rather than all in the DOM.
	         *
	         * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
	         * The elements we wish to upgrade.
	         */
	        function upgradeElementsInternal(elements) {
	            if (!Array.isArray(elements)) {
	                if (typeof elements.item === 'function') {
	                    elements = Array.prototype.slice.call( /** @type {Array} */elements);
	                } else {
	                    elements = [elements];
	                }
	            }
	            for (var i = 0, n = elements.length, element; i < n; i++) {
	                element = elements[i];
	                if (element instanceof HTMLElement) {
	                    upgradeElementInternal(element);
	                    if (element.children.length > 0) {
	                        upgradeElementsInternal(element.children);
	                    }
	                }
	            }
	        }
	
	        /**
	         * Registers a class for future use and attempts to upgrade existing DOM.
	         *
	         * @param {componentHandler.ComponentConfigPublic} config
	         */
	        function registerInternal(config) {
	            // In order to support both Closure-compiled and uncompiled code accessing
	            // this method, we need to allow for both the dot and array syntax for
	            // property access. You'll therefore see the `foo.bar || foo['bar']`
	            // pattern repeated across this method.
	            var widgetMissing = typeof config.widget === 'undefined' && typeof config['widget'] === 'undefined';
	            var widget = true;
	
	            if (!widgetMissing) {
	                widget = config.widget || config['widget'];
	            }
	
	            var newConfig = /** @type {componentHandler.ComponentConfig} */{
	                classConstructor: config.constructor || config['constructor'],
	                className: config.classAsString || config['classAsString'],
	                cssClass: config.cssClass || config['cssClass'],
	                widget: widget,
	                callbacks: []
	            };
	
	            registeredComponents_.forEach(function (item) {
	                if (item.cssClass === newConfig.cssClass) {
	                    throw new Error('The provided cssClass has already been registered: ' + item.cssClass);
	                }
	                if (item.className === newConfig.className) {
	                    throw new Error('The provided className has already been registered');
	                }
	            });
	
	            if (config.constructor.prototype.hasOwnProperty(componentConfigProperty_)) {
	                throw new Error('MDL component classes must not have ' + componentConfigProperty_ + ' defined as a property.');
	            }
	
	            var found = findRegisteredClass_(config.classAsString, newConfig);
	
	            if (!found) {
	                registeredComponents_.push(newConfig);
	            }
	        }
	
	        /**
	         * Allows user to be alerted to any upgrades that are performed for a given
	         * component type
	         *
	         * @param {string} jsClass The class name of the MDL component we wish
	         * to hook into for any upgrades performed.
	         * @param {function(!HTMLElement)} callback The function to call upon an
	         * upgrade. This function should expect 1 parameter - the HTMLElement which
	         * got upgraded.
	         */
	        function registerUpgradedCallbackInternal(jsClass, callback) {
	            var regClass = findRegisteredClass_(jsClass);
	            if (regClass) {
	                regClass.callbacks.push(callback);
	            }
	        }
	
	        /**
	         * Upgrades all registered components found in the current DOM. This is
	         * automatically called on window load.
	         */
	        function upgradeAllRegisteredInternal() {
	            for (var n = 0; n < registeredComponents_.length; n++) {
	                upgradeDomInternal(registeredComponents_[n].className);
	            }
	        }
	
	        /**
	         * Check the component for the downgrade method.
	         * Execute if found.
	         * Remove component from createdComponents list.
	         *
	         * @param {?componentHandler.Component} component
	         */
	        function deconstructComponentInternal(component) {
	            var componentIndex = createdComponents_.indexOf(component);
	            createdComponents_.splice(componentIndex, 1);
	
	            var upgrades = component.element_.getAttribute('data-upgraded').split(',');
	            var componentPlace = upgrades.indexOf(component[componentConfigProperty_].classAsString);
	            upgrades.splice(componentPlace, 1);
	            component.element_.setAttribute('data-upgraded', upgrades.join(','));
	
	            var ev = document.createEvent('Events');
	            ev.initEvent('mdl-componentdowngraded', true, true);
	            component.element_.dispatchEvent(ev);
	        }
	
	        /**
	         * Downgrade either a given node, an array of nodes, or a NodeList.
	         *
	         * @param {!Node|!Array<!Node>|!NodeList} nodes
	         */
	        function downgradeNodesInternal(nodes) {
	            /**
	             * Auxiliary function to downgrade a single node.
	             * @param  {!Node} node the node to be downgraded
	             */
	            var downgradeNode = function downgradeNode(node) {
	                createdComponents_.filter(function (item) {
	                    return item.element_ === node;
	                }).forEach(deconstructComponentInternal);
	            };
	            if (nodes instanceof Array || nodes instanceof NodeList) {
	                for (var n = 0; n < nodes.length; n++) {
	                    downgradeNode(nodes[n]);
	                }
	            } else if (nodes instanceof Node) {
	                downgradeNode(nodes);
	            } else {
	                throw new Error('Invalid argument provided to downgrade MDL nodes.');
	            }
	        }
	
	        // Now return the functions that should be made public with their publicly
	        // facing names...
	        return {
	            upgradeDom: upgradeDomInternal,
	            upgradeElement: upgradeElementInternal,
	            upgradeElements: upgradeElementsInternal,
	            upgradeAllRegistered: upgradeAllRegisteredInternal,
	            registerUpgradedCallback: registerUpgradedCallbackInternal,
	            register: registerInternal,
	            downgradeElements: downgradeNodesInternal
	        };
	    }();
	
	    /**
	     * Describes the type of a registered component type managed by
	     * componentHandler. Provided for benefit of the Closure compiler.
	     *
	     * @typedef {{
	     *   constructor: Function,
	     *   classAsString: string,
	     *   cssClass: string,
	     *   widget: (string|boolean|undefined)
	     * }}
	     */
	    componentHandler.ComponentConfigPublic; // jshint ignore:line
	
	    /**
	     * Describes the type of a registered component type managed by
	     * componentHandler. Provided for benefit of the Closure compiler.
	     *
	     * @typedef {{
	     *   constructor: !Function,
	     *   className: string,
	     *   cssClass: string,
	     *   widget: (string|boolean),
	     *   callbacks: !Array<function(!HTMLElement)>
	     * }}
	     */
	    componentHandler.ComponentConfig; // jshint ignore:line
	
	    /**
	     * Created component (i.e., upgraded element) type as managed by
	     * componentHandler. Provided for benefit of the Closure compiler.
	     *
	     * @typedef {{
	     *   element_: !HTMLElement,
	     *   className: string,
	     *   classAsString: string,
	     *   cssClass: string,
	     *   widget: string
	     * }}
	     */
	    componentHandler.Component; // jshint ignore:line
	
	    // Export all symbols, for the benefit of Closure compiler.
	    // No effect on uncompiled code.
	    componentHandler['upgradeDom'] = componentHandler.upgradeDom;
	    componentHandler['upgradeElement'] = componentHandler.upgradeElement;
	    componentHandler['upgradeElements'] = componentHandler.upgradeElements;
	    componentHandler['upgradeAllRegistered'] = componentHandler.upgradeAllRegistered;
	    componentHandler['registerUpgradedCallback'] = componentHandler.registerUpgradedCallback;
	    componentHandler['register'] = componentHandler.register;
	    componentHandler['downgradeElements'] = componentHandler.downgradeElements;
	    window.componentHandler = componentHandler;
	    window['componentHandler'] = componentHandler;
	
	    window.addEventListener('load', function () {
	        'use strict';
	
	        /**
	         * Performs a "Cutting the mustard" test. If the browser supports the features
	         * tested, adds a mdl-js class to the <html> element. It then upgrades all MDL
	         * components requiring JavaScript.
	         */
	
	        if ('classList' in document.createElement('div') && 'querySelector' in document && 'addEventListener' in window && Array.prototype.forEach) {
	            document.documentElement.classList.add('mdl-js');
	            componentHandler.upgradeAllRegistered();
	        } else {
	            /**
	             * Dummy function to avoid JS errors.
	             */
	            componentHandler.upgradeElement = function () {};
	            /**
	             * Dummy function to avoid JS errors.
	             */
	            componentHandler.register = function () {};
	        }
	    });
	
	    // Source: https://github.com/darius/requestAnimationFrame/blob/master/requestAnimationFrame.js
	    // Adapted from https://gist.github.com/paulirish/1579671 which derived from
	    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	    // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	    // requestAnimationFrame polyfill by Erik Möller.
	    // Fixes from Paul Irish, Tino Zijdel, Andrew Mao, Klemen Slavič, Darius Bacon
	    // MIT license
	    if (!Date.now) {
	        /**
	        * Date.now polyfill.
	        * @return {number} the current Date
	        */
	        Date.now = function () {
	            return new Date().getTime();
	        };
	        Date['now'] = Date.now;
	    }
	    var vendors = ['webkit', 'moz'];
	    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
	        var vp = vendors[i];
	        window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
	        window['requestAnimationFrame'] = window.requestAnimationFrame;
	        window['cancelAnimationFrame'] = window.cancelAnimationFrame;
	    }
	    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
	        var lastTime = 0;
	        /**
	        * requestAnimationFrame polyfill.
	        * @param  {!Function} callback the callback function.
	        */
	        window.requestAnimationFrame = function (callback) {
	            var now = Date.now();
	            var nextTime = Math.max(lastTime + 16, now);
	            return setTimeout(function () {
	                callback(lastTime = nextTime);
	            }, nextTime - now);
	        };
	        window.cancelAnimationFrame = clearTimeout;
	        window['requestAnimationFrame'] = window.requestAnimationFrame;
	        window['cancelAnimationFrame'] = window.cancelAnimationFrame;
	    }
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Button MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialButton = function MaterialButton(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialButton'] = MaterialButton;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialButton.prototype.Constant_ = {};
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialButton.prototype.CssClasses_ = {
	        RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	        RIPPLE_CONTAINER: 'mdl-button__ripple-container',
	        RIPPLE: 'mdl-ripple'
	    };
	    /**
	       * Handle blur of element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialButton.prototype.blurHandler_ = function (event) {
	        if (event) {
	            this.element_.blur();
	        }
	    };
	    // Public methods.
	    /**
	       * Disable button.
	       *
	       * @public
	       */
	    MaterialButton.prototype.disable = function () {
	        this.element_.disabled = true;
	    };
	    MaterialButton.prototype['disable'] = MaterialButton.prototype.disable;
	    /**
	       * Enable button.
	       *
	       * @public
	       */
	    MaterialButton.prototype.enable = function () {
	        this.element_.disabled = false;
	    };
	    MaterialButton.prototype['enable'] = MaterialButton.prototype.enable;
	    /**
	       * Initialize element.
	       */
	    MaterialButton.prototype.init = function () {
	        if (this.element_) {
	            if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	                var rippleContainer = document.createElement('span');
	                rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	                this.rippleElement_ = document.createElement('span');
	                this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
	                rippleContainer.appendChild(this.rippleElement_);
	                this.boundRippleBlurHandler = this.blurHandler_.bind(this);
	                this.rippleElement_.addEventListener('mouseup', this.boundRippleBlurHandler);
	                this.element_.appendChild(rippleContainer);
	            }
	            this.boundButtonBlurHandler = this.blurHandler_.bind(this);
	            this.element_.addEventListener('mouseup', this.boundButtonBlurHandler);
	            this.element_.addEventListener('mouseleave', this.boundButtonBlurHandler);
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialButton,
	        classAsString: 'MaterialButton',
	        cssClass: 'mdl-js-button',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Checkbox MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialCheckbox = function MaterialCheckbox(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialCheckbox'] = MaterialCheckbox;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialCheckbox.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialCheckbox.prototype.CssClasses_ = {
	        INPUT: 'mdl-checkbox__input',
	        BOX_OUTLINE: 'mdl-checkbox__box-outline',
	        FOCUS_HELPER: 'mdl-checkbox__focus-helper',
	        TICK_OUTLINE: 'mdl-checkbox__tick-outline',
	        RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	        RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	        RIPPLE_CONTAINER: 'mdl-checkbox__ripple-container',
	        RIPPLE_CENTER: 'mdl-ripple--center',
	        RIPPLE: 'mdl-ripple',
	        IS_FOCUSED: 'is-focused',
	        IS_DISABLED: 'is-disabled',
	        IS_CHECKED: 'is-checked',
	        IS_UPGRADED: 'is-upgraded'
	    };
	    /**
	       * Handle change of state.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialCheckbox.prototype.onChange_ = function (event) {
	        this.updateClasses_();
	    };
	    /**
	       * Handle focus of element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialCheckbox.prototype.onFocus_ = function (event) {
	        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle lost focus of element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialCheckbox.prototype.onBlur_ = function (event) {
	        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle mouseup.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialCheckbox.prototype.onMouseUp_ = function (event) {
	        this.blur_();
	    };
	    /**
	       * Handle class updates.
	       *
	       * @private
	       */
	    MaterialCheckbox.prototype.updateClasses_ = function () {
	        this.checkDisabled();
	        this.checkToggleState();
	    };
	    /**
	       * Add blur.
	       *
	       * @private
	       */
	    MaterialCheckbox.prototype.blur_ = function () {
	        // TODO: figure out why there's a focus event being fired after our blur,
	        // so that we can avoid this hack.
	        window.setTimeout(function () {
	            this.inputElement_.blur();
	        }.bind(this), this.Constant_.TINY_TIMEOUT);
	    };
	    // Public methods.
	    /**
	       * Check the inputs toggle state and update display.
	       *
	       * @public
	       */
	    MaterialCheckbox.prototype.checkToggleState = function () {
	        if (this.inputElement_.checked) {
	            this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	        }
	    };
	    MaterialCheckbox.prototype['checkToggleState'] = MaterialCheckbox.prototype.checkToggleState;
	    /**
	       * Check the inputs disabled state and update display.
	       *
	       * @public
	       */
	    MaterialCheckbox.prototype.checkDisabled = function () {
	        if (this.inputElement_.disabled) {
	            this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	        }
	    };
	    MaterialCheckbox.prototype['checkDisabled'] = MaterialCheckbox.prototype.checkDisabled;
	    /**
	       * Disable checkbox.
	       *
	       * @public
	       */
	    MaterialCheckbox.prototype.disable = function () {
	        this.inputElement_.disabled = true;
	        this.updateClasses_();
	    };
	    MaterialCheckbox.prototype['disable'] = MaterialCheckbox.prototype.disable;
	    /**
	       * Enable checkbox.
	       *
	       * @public
	       */
	    MaterialCheckbox.prototype.enable = function () {
	        this.inputElement_.disabled = false;
	        this.updateClasses_();
	    };
	    MaterialCheckbox.prototype['enable'] = MaterialCheckbox.prototype.enable;
	    /**
	       * Check checkbox.
	       *
	       * @public
	       */
	    MaterialCheckbox.prototype.check = function () {
	        this.inputElement_.checked = true;
	        this.updateClasses_();
	    };
	    MaterialCheckbox.prototype['check'] = MaterialCheckbox.prototype.check;
	    /**
	       * Uncheck checkbox.
	       *
	       * @public
	       */
	    MaterialCheckbox.prototype.uncheck = function () {
	        this.inputElement_.checked = false;
	        this.updateClasses_();
	    };
	    MaterialCheckbox.prototype['uncheck'] = MaterialCheckbox.prototype.uncheck;
	    /**
	       * Initialize element.
	       */
	    MaterialCheckbox.prototype.init = function () {
	        if (this.element_) {
	            this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	            var boxOutline = document.createElement('span');
	            boxOutline.classList.add(this.CssClasses_.BOX_OUTLINE);
	            var tickContainer = document.createElement('span');
	            tickContainer.classList.add(this.CssClasses_.FOCUS_HELPER);
	            var tickOutline = document.createElement('span');
	            tickOutline.classList.add(this.CssClasses_.TICK_OUTLINE);
	            boxOutline.appendChild(tickOutline);
	            this.element_.appendChild(tickContainer);
	            this.element_.appendChild(boxOutline);
	            if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	                this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	                this.rippleContainerElement_ = document.createElement('span');
	                this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	                this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	                this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	                this.boundRippleMouseUp = this.onMouseUp_.bind(this);
	                this.rippleContainerElement_.addEventListener('mouseup', this.boundRippleMouseUp);
	                var ripple = document.createElement('span');
	                ripple.classList.add(this.CssClasses_.RIPPLE);
	                this.rippleContainerElement_.appendChild(ripple);
	                this.element_.appendChild(this.rippleContainerElement_);
	            }
	            this.boundInputOnChange = this.onChange_.bind(this);
	            this.boundInputOnFocus = this.onFocus_.bind(this);
	            this.boundInputOnBlur = this.onBlur_.bind(this);
	            this.boundElementMouseUp = this.onMouseUp_.bind(this);
	            this.inputElement_.addEventListener('change', this.boundInputOnChange);
	            this.inputElement_.addEventListener('focus', this.boundInputOnFocus);
	            this.inputElement_.addEventListener('blur', this.boundInputOnBlur);
	            this.element_.addEventListener('mouseup', this.boundElementMouseUp);
	            this.updateClasses_();
	            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialCheckbox,
	        classAsString: 'MaterialCheckbox',
	        cssClass: 'mdl-js-checkbox',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for icon toggle MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialIconToggle = function MaterialIconToggle(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialIconToggle'] = MaterialIconToggle;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialIconToggle.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialIconToggle.prototype.CssClasses_ = {
	        INPUT: 'mdl-icon-toggle__input',
	        JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	        RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	        RIPPLE_CONTAINER: 'mdl-icon-toggle__ripple-container',
	        RIPPLE_CENTER: 'mdl-ripple--center',
	        RIPPLE: 'mdl-ripple',
	        IS_FOCUSED: 'is-focused',
	        IS_DISABLED: 'is-disabled',
	        IS_CHECKED: 'is-checked'
	    };
	    /**
	       * Handle change of state.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialIconToggle.prototype.onChange_ = function (event) {
	        this.updateClasses_();
	    };
	    /**
	       * Handle focus of element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialIconToggle.prototype.onFocus_ = function (event) {
	        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle lost focus of element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialIconToggle.prototype.onBlur_ = function (event) {
	        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle mouseup.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialIconToggle.prototype.onMouseUp_ = function (event) {
	        this.blur_();
	    };
	    /**
	       * Handle class updates.
	       *
	       * @private
	       */
	    MaterialIconToggle.prototype.updateClasses_ = function () {
	        this.checkDisabled();
	        this.checkToggleState();
	    };
	    /**
	       * Add blur.
	       *
	       * @private
	       */
	    MaterialIconToggle.prototype.blur_ = function () {
	        // TODO: figure out why there's a focus event being fired after our blur,
	        // so that we can avoid this hack.
	        window.setTimeout(function () {
	            this.inputElement_.blur();
	        }.bind(this), this.Constant_.TINY_TIMEOUT);
	    };
	    // Public methods.
	    /**
	       * Check the inputs toggle state and update display.
	       *
	       * @public
	       */
	    MaterialIconToggle.prototype.checkToggleState = function () {
	        if (this.inputElement_.checked) {
	            this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	        }
	    };
	    MaterialIconToggle.prototype['checkToggleState'] = MaterialIconToggle.prototype.checkToggleState;
	    /**
	       * Check the inputs disabled state and update display.
	       *
	       * @public
	       */
	    MaterialIconToggle.prototype.checkDisabled = function () {
	        if (this.inputElement_.disabled) {
	            this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	        }
	    };
	    MaterialIconToggle.prototype['checkDisabled'] = MaterialIconToggle.prototype.checkDisabled;
	    /**
	       * Disable icon toggle.
	       *
	       * @public
	       */
	    MaterialIconToggle.prototype.disable = function () {
	        this.inputElement_.disabled = true;
	        this.updateClasses_();
	    };
	    MaterialIconToggle.prototype['disable'] = MaterialIconToggle.prototype.disable;
	    /**
	       * Enable icon toggle.
	       *
	       * @public
	       */
	    MaterialIconToggle.prototype.enable = function () {
	        this.inputElement_.disabled = false;
	        this.updateClasses_();
	    };
	    MaterialIconToggle.prototype['enable'] = MaterialIconToggle.prototype.enable;
	    /**
	       * Check icon toggle.
	       *
	       * @public
	       */
	    MaterialIconToggle.prototype.check = function () {
	        this.inputElement_.checked = true;
	        this.updateClasses_();
	    };
	    MaterialIconToggle.prototype['check'] = MaterialIconToggle.prototype.check;
	    /**
	       * Uncheck icon toggle.
	       *
	       * @public
	       */
	    MaterialIconToggle.prototype.uncheck = function () {
	        this.inputElement_.checked = false;
	        this.updateClasses_();
	    };
	    MaterialIconToggle.prototype['uncheck'] = MaterialIconToggle.prototype.uncheck;
	    /**
	       * Initialize element.
	       */
	    MaterialIconToggle.prototype.init = function () {
	        if (this.element_) {
	            this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	            if (this.element_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)) {
	                this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	                this.rippleContainerElement_ = document.createElement('span');
	                this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	                this.rippleContainerElement_.classList.add(this.CssClasses_.JS_RIPPLE_EFFECT);
	                this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	                this.boundRippleMouseUp = this.onMouseUp_.bind(this);
	                this.rippleContainerElement_.addEventListener('mouseup', this.boundRippleMouseUp);
	                var ripple = document.createElement('span');
	                ripple.classList.add(this.CssClasses_.RIPPLE);
	                this.rippleContainerElement_.appendChild(ripple);
	                this.element_.appendChild(this.rippleContainerElement_);
	            }
	            this.boundInputOnChange = this.onChange_.bind(this);
	            this.boundInputOnFocus = this.onFocus_.bind(this);
	            this.boundInputOnBlur = this.onBlur_.bind(this);
	            this.boundElementOnMouseUp = this.onMouseUp_.bind(this);
	            this.inputElement_.addEventListener('change', this.boundInputOnChange);
	            this.inputElement_.addEventListener('focus', this.boundInputOnFocus);
	            this.inputElement_.addEventListener('blur', this.boundInputOnBlur);
	            this.element_.addEventListener('mouseup', this.boundElementOnMouseUp);
	            this.updateClasses_();
	            this.element_.classList.add('is-upgraded');
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialIconToggle,
	        classAsString: 'MaterialIconToggle',
	        cssClass: 'mdl-js-icon-toggle',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for dropdown MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialMenu = function MaterialMenu(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialMenu'] = MaterialMenu;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialMenu.prototype.Constant_ = {
	        // Total duration of the menu animation.
	        TRANSITION_DURATION_SECONDS: 0.3,
	        // The fraction of the total duration we want to use for menu item animations.
	        TRANSITION_DURATION_FRACTION: 0.8,
	        // How long the menu stays open after choosing an option (so the user can see
	        // the ripple).
	        CLOSE_TIMEOUT: 150
	    };
	    /**
	       * Keycodes, for code readability.
	       *
	       * @enum {number}
	       * @private
	       */
	    MaterialMenu.prototype.Keycodes_ = {
	        ENTER: 13,
	        ESCAPE: 27,
	        SPACE: 32,
	        UP_ARROW: 38,
	        DOWN_ARROW: 40
	    };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialMenu.prototype.CssClasses_ = {
	        CONTAINER: 'mdl-menu__container',
	        OUTLINE: 'mdl-menu__outline',
	        ITEM: 'mdl-menu__item',
	        ITEM_RIPPLE_CONTAINER: 'mdl-menu__item-ripple-container',
	        RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	        RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	        RIPPLE: 'mdl-ripple',
	        // Statuses
	        IS_UPGRADED: 'is-upgraded',
	        IS_VISIBLE: 'is-visible',
	        IS_ANIMATING: 'is-animating',
	        // Alignment options
	        BOTTOM_LEFT: 'mdl-menu--bottom-left',
	        // This is the default.
	        BOTTOM_RIGHT: 'mdl-menu--bottom-right',
	        TOP_LEFT: 'mdl-menu--top-left',
	        TOP_RIGHT: 'mdl-menu--top-right',
	        UNALIGNED: 'mdl-menu--unaligned'
	    };
	    /**
	       * Initialize element.
	       */
	    MaterialMenu.prototype.init = function () {
	        if (this.element_) {
	            // Create container for the menu.
	            var container = document.createElement('div');
	            container.classList.add(this.CssClasses_.CONTAINER);
	            this.element_.parentElement.insertBefore(container, this.element_);
	            this.element_.parentElement.removeChild(this.element_);
	            container.appendChild(this.element_);
	            this.container_ = container;
	            // Create outline for the menu (shadow and background).
	            var outline = document.createElement('div');
	            outline.classList.add(this.CssClasses_.OUTLINE);
	            this.outline_ = outline;
	            container.insertBefore(outline, this.element_);
	            // Find the "for" element and bind events to it.
	            var forElId = this.element_.getAttribute('for') || this.element_.getAttribute('data-mdl-for');
	            var forEl = null;
	            if (forElId) {
	                forEl = document.getElementById(forElId);
	                if (forEl) {
	                    this.forElement_ = forEl;
	                    forEl.addEventListener('click', this.handleForClick_.bind(this));
	                    forEl.addEventListener('keydown', this.handleForKeyboardEvent_.bind(this));
	                }
	            }
	            var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	            this.boundItemKeydown_ = this.handleItemKeyboardEvent_.bind(this);
	            this.boundItemClick_ = this.handleItemClick_.bind(this);
	            for (var i = 0; i < items.length; i++) {
	                // Add a listener to each menu item.
	                items[i].addEventListener('click', this.boundItemClick_);
	                // Add a tab index to each menu item.
	                items[i].tabIndex = '-1';
	                // Add a keyboard listener to each menu item.
	                items[i].addEventListener('keydown', this.boundItemKeydown_);
	            }
	            // Add ripple classes to each item, if the user has enabled ripples.
	            if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	                this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	                for (i = 0; i < items.length; i++) {
	                    var item = items[i];
	                    var rippleContainer = document.createElement('span');
	                    rippleContainer.classList.add(this.CssClasses_.ITEM_RIPPLE_CONTAINER);
	                    var ripple = document.createElement('span');
	                    ripple.classList.add(this.CssClasses_.RIPPLE);
	                    rippleContainer.appendChild(ripple);
	                    item.appendChild(rippleContainer);
	                    item.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	                }
	            }
	            // Copy alignment classes to the container, so the outline can use them.
	            if (this.element_.classList.contains(this.CssClasses_.BOTTOM_LEFT)) {
	                this.outline_.classList.add(this.CssClasses_.BOTTOM_LEFT);
	            }
	            if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	                this.outline_.classList.add(this.CssClasses_.BOTTOM_RIGHT);
	            }
	            if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	                this.outline_.classList.add(this.CssClasses_.TOP_LEFT);
	            }
	            if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	                this.outline_.classList.add(this.CssClasses_.TOP_RIGHT);
	            }
	            if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
	                this.outline_.classList.add(this.CssClasses_.UNALIGNED);
	            }
	            container.classList.add(this.CssClasses_.IS_UPGRADED);
	        }
	    };
	    /**
	       * Handles a click on the "for" element, by positioning the menu and then
	       * toggling it.
	       *
	       * @param {Event} evt The event that fired.
	       * @private
	       */
	    MaterialMenu.prototype.handleForClick_ = function (evt) {
	        if (this.element_ && this.forElement_) {
	            var rect = this.forElement_.getBoundingClientRect();
	            var forRect = this.forElement_.parentElement.getBoundingClientRect();
	            if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {} else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	                // Position below the "for" element, aligned to its right.
	                this.container_.style.right = forRect.right - rect.right + 'px';
	                this.container_.style.top = this.forElement_.offsetTop + this.forElement_.offsetHeight + 'px';
	            } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	                // Position above the "for" element, aligned to its left.
	                this.container_.style.left = this.forElement_.offsetLeft + 'px';
	                this.container_.style.bottom = forRect.bottom - rect.top + 'px';
	            } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	                // Position above the "for" element, aligned to its right.
	                this.container_.style.right = forRect.right - rect.right + 'px';
	                this.container_.style.bottom = forRect.bottom - rect.top + 'px';
	            } else {
	                // Default: position below the "for" element, aligned to its left.
	                this.container_.style.left = this.forElement_.offsetLeft + 'px';
	                this.container_.style.top = this.forElement_.offsetTop + this.forElement_.offsetHeight + 'px';
	            }
	        }
	        this.toggle(evt);
	    };
	    /**
	       * Handles a keyboard event on the "for" element.
	       *
	       * @param {Event} evt The event that fired.
	       * @private
	       */
	    MaterialMenu.prototype.handleForKeyboardEvent_ = function (evt) {
	        if (this.element_ && this.container_ && this.forElement_) {
	            var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM + ':not([disabled])');
	            if (items && items.length > 0 && this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	                if (evt.keyCode === this.Keycodes_.UP_ARROW) {
	                    evt.preventDefault();
	                    items[items.length - 1].focus();
	                } else if (evt.keyCode === this.Keycodes_.DOWN_ARROW) {
	                    evt.preventDefault();
	                    items[0].focus();
	                }
	            }
	        }
	    };
	    /**
	       * Handles a keyboard event on an item.
	       *
	       * @param {Event} evt The event that fired.
	       * @private
	       */
	    MaterialMenu.prototype.handleItemKeyboardEvent_ = function (evt) {
	        if (this.element_ && this.container_) {
	            var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM + ':not([disabled])');
	            if (items && items.length > 0 && this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	                var currentIndex = Array.prototype.slice.call(items).indexOf(evt.target);
	                if (evt.keyCode === this.Keycodes_.UP_ARROW) {
	                    evt.preventDefault();
	                    if (currentIndex > 0) {
	                        items[currentIndex - 1].focus();
	                    } else {
	                        items[items.length - 1].focus();
	                    }
	                } else if (evt.keyCode === this.Keycodes_.DOWN_ARROW) {
	                    evt.preventDefault();
	                    if (items.length > currentIndex + 1) {
	                        items[currentIndex + 1].focus();
	                    } else {
	                        items[0].focus();
	                    }
	                } else if (evt.keyCode === this.Keycodes_.SPACE || evt.keyCode === this.Keycodes_.ENTER) {
	                    evt.preventDefault();
	                    // Send mousedown and mouseup to trigger ripple.
	                    var e = new MouseEvent('mousedown');
	                    evt.target.dispatchEvent(e);
	                    e = new MouseEvent('mouseup');
	                    evt.target.dispatchEvent(e);
	                    // Send click.
	                    evt.target.click();
	                } else if (evt.keyCode === this.Keycodes_.ESCAPE) {
	                    evt.preventDefault();
	                    this.hide();
	                }
	            }
	        }
	    };
	    /**
	       * Handles a click event on an item.
	       *
	       * @param {Event} evt The event that fired.
	       * @private
	       */
	    MaterialMenu.prototype.handleItemClick_ = function (evt) {
	        if (evt.target.hasAttribute('disabled')) {
	            evt.stopPropagation();
	        } else {
	            // Wait some time before closing menu, so the user can see the ripple.
	            this.closing_ = true;
	            window.setTimeout(function (evt) {
	                this.hide();
	                this.closing_ = false;
	            }.bind(this), this.Constant_.CLOSE_TIMEOUT);
	        }
	    };
	    /**
	       * Calculates the initial clip (for opening the menu) or final clip (for closing
	       * it), and applies it. This allows us to animate from or to the correct point,
	       * that is, the point it's aligned to in the "for" element.
	       *
	       * @param {number} height Height of the clip rectangle
	       * @param {number} width Width of the clip rectangle
	       * @private
	       */
	    MaterialMenu.prototype.applyClip_ = function (height, width) {
	        if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
	            // Do not clip.
	            this.element_.style.clip = '';
	        } else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	            // Clip to the top right corner of the menu.
	            this.element_.style.clip = 'rect(0 ' + width + 'px ' + '0 ' + width + 'px)';
	        } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	            // Clip to the bottom left corner of the menu.
	            this.element_.style.clip = 'rect(' + height + 'px 0 ' + height + 'px 0)';
	        } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	            // Clip to the bottom right corner of the menu.
	            this.element_.style.clip = 'rect(' + height + 'px ' + width + 'px ' + height + 'px ' + width + 'px)';
	        } else {
	            // Default: do not clip (same as clipping to the top left corner).
	            this.element_.style.clip = '';
	        }
	    };
	    /**
	       * Cleanup function to remove animation listeners.
	       *
	       * @param {Event} evt
	       * @private
	       */
	    MaterialMenu.prototype.removeAnimationEndListener_ = function (evt) {
	        evt.target.classList.remove(MaterialMenu.prototype.CssClasses_.IS_ANIMATING);
	    };
	    /**
	       * Adds an event listener to clean up after the animation ends.
	       *
	       * @private
	       */
	    MaterialMenu.prototype.addAnimationEndListener_ = function () {
	        this.element_.addEventListener('transitionend', this.removeAnimationEndListener_);
	        this.element_.addEventListener('webkitTransitionEnd', this.removeAnimationEndListener_);
	    };
	    /**
	       * Displays the menu.
	       *
	       * @public
	       */
	    MaterialMenu.prototype.show = function (evt) {
	        if (this.element_ && this.container_ && this.outline_) {
	            // Measure the inner element.
	            var height = this.element_.getBoundingClientRect().height;
	            var width = this.element_.getBoundingClientRect().width;
	            // Apply the inner element's size to the container and outline.
	            this.container_.style.width = width + 'px';
	            this.container_.style.height = height + 'px';
	            this.outline_.style.width = width + 'px';
	            this.outline_.style.height = height + 'px';
	            var transitionDuration = this.Constant_.TRANSITION_DURATION_SECONDS * this.Constant_.TRANSITION_DURATION_FRACTION;
	            // Calculate transition delays for individual menu items, so that they fade
	            // in one at a time.
	            var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	            for (var i = 0; i < items.length; i++) {
	                var itemDelay = null;
	                if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT) || this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	                    itemDelay = (height - items[i].offsetTop - items[i].offsetHeight) / height * transitionDuration + 's';
	                } else {
	                    itemDelay = items[i].offsetTop / height * transitionDuration + 's';
	                }
	                items[i].style.transitionDelay = itemDelay;
	            }
	            // Apply the initial clip to the text before we start animating.
	            this.applyClip_(height, width);
	            // Wait for the next frame, turn on animation, and apply the final clip.
	            // Also make it visible. This triggers the transitions.
	            window.requestAnimationFrame(function () {
	                this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
	                this.element_.style.clip = 'rect(0 ' + width + 'px ' + height + 'px 0)';
	                this.container_.classList.add(this.CssClasses_.IS_VISIBLE);
	            }.bind(this));
	            // Clean up after the animation is complete.
	            this.addAnimationEndListener_();
	            // Add a click listener to the document, to close the menu.
	            var callback = function (e) {
	                // Check to see if the document is processing the same event that
	                // displayed the menu in the first place. If so, do nothing.
	                // Also check to see if the menu is in the process of closing itself, and
	                // do nothing in that case.
	                // Also check if the clicked element is a menu item
	                // if so, do nothing.
	                if (e !== evt && !this.closing_ && e.target.parentNode !== this.element_) {
	                    document.removeEventListener('click', callback);
	                    this.hide();
	                }
	            }.bind(this);
	            document.addEventListener('click', callback);
	        }
	    };
	    MaterialMenu.prototype['show'] = MaterialMenu.prototype.show;
	    /**
	       * Hides the menu.
	       *
	       * @public
	       */
	    MaterialMenu.prototype.hide = function () {
	        if (this.element_ && this.container_ && this.outline_) {
	            var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	            // Remove all transition delays; menu items fade out concurrently.
	            for (var i = 0; i < items.length; i++) {
	                items[i].style.removeProperty('transition-delay');
	            }
	            // Measure the inner element.
	            var rect = this.element_.getBoundingClientRect();
	            var height = rect.height;
	            var width = rect.width;
	            // Turn on animation, and apply the final clip. Also make invisible.
	            // This triggers the transitions.
	            this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
	            this.applyClip_(height, width);
	            this.container_.classList.remove(this.CssClasses_.IS_VISIBLE);
	            // Clean up after the animation is complete.
	            this.addAnimationEndListener_();
	        }
	    };
	    MaterialMenu.prototype['hide'] = MaterialMenu.prototype.hide;
	    /**
	       * Displays or hides the menu, depending on current state.
	       *
	       * @public
	       */
	    MaterialMenu.prototype.toggle = function (evt) {
	        if (this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	            this.hide();
	        } else {
	            this.show(evt);
	        }
	    };
	    MaterialMenu.prototype['toggle'] = MaterialMenu.prototype.toggle;
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialMenu,
	        classAsString: 'MaterialMenu',
	        cssClass: 'mdl-js-menu',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Progress MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialProgress = function MaterialProgress(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialProgress'] = MaterialProgress;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialProgress.prototype.Constant_ = {};
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialProgress.prototype.CssClasses_ = { INDETERMINATE_CLASS: 'mdl-progress__indeterminate' };
	    /**
	       * Set the current progress of the progressbar.
	       *
	       * @param {number} p Percentage of the progress (0-100)
	       * @public
	       */
	    MaterialProgress.prototype.setProgress = function (p) {
	        if (this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS)) {
	            return;
	        }
	        this.progressbar_.style.width = p + '%';
	    };
	    MaterialProgress.prototype['setProgress'] = MaterialProgress.prototype.setProgress;
	    /**
	       * Set the current progress of the buffer.
	       *
	       * @param {number} p Percentage of the buffer (0-100)
	       * @public
	       */
	    MaterialProgress.prototype.setBuffer = function (p) {
	        this.bufferbar_.style.width = p + '%';
	        this.auxbar_.style.width = 100 - p + '%';
	    };
	    MaterialProgress.prototype['setBuffer'] = MaterialProgress.prototype.setBuffer;
	    /**
	       * Initialize element.
	       */
	    MaterialProgress.prototype.init = function () {
	        if (this.element_) {
	            var el = document.createElement('div');
	            el.className = 'progressbar bar bar1';
	            this.element_.appendChild(el);
	            this.progressbar_ = el;
	            el = document.createElement('div');
	            el.className = 'bufferbar bar bar2';
	            this.element_.appendChild(el);
	            this.bufferbar_ = el;
	            el = document.createElement('div');
	            el.className = 'auxbar bar bar3';
	            this.element_.appendChild(el);
	            this.auxbar_ = el;
	            this.progressbar_.style.width = '0%';
	            this.bufferbar_.style.width = '100%';
	            this.auxbar_.style.width = '0%';
	            this.element_.classList.add('is-upgraded');
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialProgress,
	        classAsString: 'MaterialProgress',
	        cssClass: 'mdl-js-progress',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Radio MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialRadio = function MaterialRadio(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialRadio'] = MaterialRadio;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialRadio.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialRadio.prototype.CssClasses_ = {
	        IS_FOCUSED: 'is-focused',
	        IS_DISABLED: 'is-disabled',
	        IS_CHECKED: 'is-checked',
	        IS_UPGRADED: 'is-upgraded',
	        JS_RADIO: 'mdl-js-radio',
	        RADIO_BTN: 'mdl-radio__button',
	        RADIO_OUTER_CIRCLE: 'mdl-radio__outer-circle',
	        RADIO_INNER_CIRCLE: 'mdl-radio__inner-circle',
	        RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	        RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	        RIPPLE_CONTAINER: 'mdl-radio__ripple-container',
	        RIPPLE_CENTER: 'mdl-ripple--center',
	        RIPPLE: 'mdl-ripple'
	    };
	    /**
	       * Handle change of state.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialRadio.prototype.onChange_ = function (event) {
	        // Since other radio buttons don't get change events, we need to look for
	        // them to update their classes.
	        var radios = document.getElementsByClassName(this.CssClasses_.JS_RADIO);
	        for (var i = 0; i < radios.length; i++) {
	            var button = radios[i].querySelector('.' + this.CssClasses_.RADIO_BTN);
	            // Different name == different group, so no point updating those.
	            if (button.getAttribute('name') === this.btnElement_.getAttribute('name')) {
	                radios[i]['MaterialRadio'].updateClasses_();
	            }
	        }
	    };
	    /**
	       * Handle focus.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialRadio.prototype.onFocus_ = function (event) {
	        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle lost focus.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialRadio.prototype.onBlur_ = function (event) {
	        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle mouseup.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialRadio.prototype.onMouseup_ = function (event) {
	        this.blur_();
	    };
	    /**
	       * Update classes.
	       *
	       * @private
	       */
	    MaterialRadio.prototype.updateClasses_ = function () {
	        this.checkDisabled();
	        this.checkToggleState();
	    };
	    /**
	       * Add blur.
	       *
	       * @private
	       */
	    MaterialRadio.prototype.blur_ = function () {
	        // TODO: figure out why there's a focus event being fired after our blur,
	        // so that we can avoid this hack.
	        window.setTimeout(function () {
	            this.btnElement_.blur();
	        }.bind(this), this.Constant_.TINY_TIMEOUT);
	    };
	    // Public methods.
	    /**
	       * Check the components disabled state.
	       *
	       * @public
	       */
	    MaterialRadio.prototype.checkDisabled = function () {
	        if (this.btnElement_.disabled) {
	            this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	        }
	    };
	    MaterialRadio.prototype['checkDisabled'] = MaterialRadio.prototype.checkDisabled;
	    /**
	       * Check the components toggled state.
	       *
	       * @public
	       */
	    MaterialRadio.prototype.checkToggleState = function () {
	        if (this.btnElement_.checked) {
	            this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	        }
	    };
	    MaterialRadio.prototype['checkToggleState'] = MaterialRadio.prototype.checkToggleState;
	    /**
	       * Disable radio.
	       *
	       * @public
	       */
	    MaterialRadio.prototype.disable = function () {
	        this.btnElement_.disabled = true;
	        this.updateClasses_();
	    };
	    MaterialRadio.prototype['disable'] = MaterialRadio.prototype.disable;
	    /**
	       * Enable radio.
	       *
	       * @public
	       */
	    MaterialRadio.prototype.enable = function () {
	        this.btnElement_.disabled = false;
	        this.updateClasses_();
	    };
	    MaterialRadio.prototype['enable'] = MaterialRadio.prototype.enable;
	    /**
	       * Check radio.
	       *
	       * @public
	       */
	    MaterialRadio.prototype.check = function () {
	        this.btnElement_.checked = true;
	        this.updateClasses_();
	    };
	    MaterialRadio.prototype['check'] = MaterialRadio.prototype.check;
	    /**
	       * Uncheck radio.
	       *
	       * @public
	       */
	    MaterialRadio.prototype.uncheck = function () {
	        this.btnElement_.checked = false;
	        this.updateClasses_();
	    };
	    MaterialRadio.prototype['uncheck'] = MaterialRadio.prototype.uncheck;
	    /**
	       * Initialize element.
	       */
	    MaterialRadio.prototype.init = function () {
	        if (this.element_) {
	            this.btnElement_ = this.element_.querySelector('.' + this.CssClasses_.RADIO_BTN);
	            this.boundChangeHandler_ = this.onChange_.bind(this);
	            this.boundFocusHandler_ = this.onChange_.bind(this);
	            this.boundBlurHandler_ = this.onBlur_.bind(this);
	            this.boundMouseUpHandler_ = this.onMouseup_.bind(this);
	            var outerCircle = document.createElement('span');
	            outerCircle.classList.add(this.CssClasses_.RADIO_OUTER_CIRCLE);
	            var innerCircle = document.createElement('span');
	            innerCircle.classList.add(this.CssClasses_.RADIO_INNER_CIRCLE);
	            this.element_.appendChild(outerCircle);
	            this.element_.appendChild(innerCircle);
	            var rippleContainer;
	            if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	                this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	                rippleContainer = document.createElement('span');
	                rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	                rippleContainer.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	                rippleContainer.classList.add(this.CssClasses_.RIPPLE_CENTER);
	                rippleContainer.addEventListener('mouseup', this.boundMouseUpHandler_);
	                var ripple = document.createElement('span');
	                ripple.classList.add(this.CssClasses_.RIPPLE);
	                rippleContainer.appendChild(ripple);
	                this.element_.appendChild(rippleContainer);
	            }
	            this.btnElement_.addEventListener('change', this.boundChangeHandler_);
	            this.btnElement_.addEventListener('focus', this.boundFocusHandler_);
	            this.btnElement_.addEventListener('blur', this.boundBlurHandler_);
	            this.element_.addEventListener('mouseup', this.boundMouseUpHandler_);
	            this.updateClasses_();
	            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialRadio,
	        classAsString: 'MaterialRadio',
	        cssClass: 'mdl-js-radio',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Slider MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialSlider = function MaterialSlider(element) {
	        this.element_ = element;
	        // Browser feature detection.
	        this.isIE_ = window.navigator.msPointerEnabled;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialSlider'] = MaterialSlider;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialSlider.prototype.Constant_ = {};
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialSlider.prototype.CssClasses_ = {
	        IE_CONTAINER: 'mdl-slider__ie-container',
	        SLIDER_CONTAINER: 'mdl-slider__container',
	        BACKGROUND_FLEX: 'mdl-slider__background-flex',
	        BACKGROUND_LOWER: 'mdl-slider__background-lower',
	        BACKGROUND_UPPER: 'mdl-slider__background-upper',
	        IS_LOWEST_VALUE: 'is-lowest-value',
	        IS_UPGRADED: 'is-upgraded'
	    };
	    /**
	       * Handle input on element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialSlider.prototype.onInput_ = function (event) {
	        this.updateValueStyles_();
	    };
	    /**
	       * Handle change on element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialSlider.prototype.onChange_ = function (event) {
	        this.updateValueStyles_();
	    };
	    /**
	       * Handle mouseup on element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialSlider.prototype.onMouseUp_ = function (event) {
	        event.target.blur();
	    };
	    /**
	       * Handle mousedown on container element.
	       * This handler is purpose is to not require the use to click
	       * exactly on the 2px slider element, as FireFox seems to be very
	       * strict about this.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       * @suppress {missingProperties}
	       */
	    MaterialSlider.prototype.onContainerMouseDown_ = function (event) {
	        // If this click is not on the parent element (but rather some child)
	        // ignore. It may still bubble up.
	        if (event.target !== this.element_.parentElement) {
	            return;
	        }
	        // Discard the original event and create a new event that
	        // is on the slider element.
	        event.preventDefault();
	        var newEvent = new MouseEvent('mousedown', {
	            target: event.target,
	            buttons: event.buttons,
	            clientX: event.clientX,
	            clientY: this.element_.getBoundingClientRect().y
	        });
	        this.element_.dispatchEvent(newEvent);
	    };
	    /**
	       * Handle updating of values.
	       *
	       * @private
	       */
	    MaterialSlider.prototype.updateValueStyles_ = function () {
	        // Calculate and apply percentages to div structure behind slider.
	        var fraction = (this.element_.value - this.element_.min) / (this.element_.max - this.element_.min);
	        if (fraction === 0) {
	            this.element_.classList.add(this.CssClasses_.IS_LOWEST_VALUE);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_LOWEST_VALUE);
	        }
	        if (!this.isIE_) {
	            this.backgroundLower_.style.flex = fraction;
	            this.backgroundLower_.style.webkitFlex = fraction;
	            this.backgroundUpper_.style.flex = 1 - fraction;
	            this.backgroundUpper_.style.webkitFlex = 1 - fraction;
	        }
	    };
	    // Public methods.
	    /**
	       * Disable slider.
	       *
	       * @public
	       */
	    MaterialSlider.prototype.disable = function () {
	        this.element_.disabled = true;
	    };
	    MaterialSlider.prototype['disable'] = MaterialSlider.prototype.disable;
	    /**
	       * Enable slider.
	       *
	       * @public
	       */
	    MaterialSlider.prototype.enable = function () {
	        this.element_.disabled = false;
	    };
	    MaterialSlider.prototype['enable'] = MaterialSlider.prototype.enable;
	    /**
	       * Update slider value.
	       *
	       * @param {number} value The value to which to set the control (optional).
	       * @public
	       */
	    MaterialSlider.prototype.change = function (value) {
	        if (typeof value !== 'undefined') {
	            this.element_.value = value;
	        }
	        this.updateValueStyles_();
	    };
	    MaterialSlider.prototype['change'] = MaterialSlider.prototype.change;
	    /**
	       * Initialize element.
	       */
	    MaterialSlider.prototype.init = function () {
	        if (this.element_) {
	            if (this.isIE_) {
	                // Since we need to specify a very large height in IE due to
	                // implementation limitations, we add a parent here that trims it down to
	                // a reasonable size.
	                var containerIE = document.createElement('div');
	                containerIE.classList.add(this.CssClasses_.IE_CONTAINER);
	                this.element_.parentElement.insertBefore(containerIE, this.element_);
	                this.element_.parentElement.removeChild(this.element_);
	                containerIE.appendChild(this.element_);
	            } else {
	                // For non-IE browsers, we need a div structure that sits behind the
	                // slider and allows us to style the left and right sides of it with
	                // different colors.
	                var container = document.createElement('div');
	                container.classList.add(this.CssClasses_.SLIDER_CONTAINER);
	                this.element_.parentElement.insertBefore(container, this.element_);
	                this.element_.parentElement.removeChild(this.element_);
	                container.appendChild(this.element_);
	                var backgroundFlex = document.createElement('div');
	                backgroundFlex.classList.add(this.CssClasses_.BACKGROUND_FLEX);
	                container.appendChild(backgroundFlex);
	                this.backgroundLower_ = document.createElement('div');
	                this.backgroundLower_.classList.add(this.CssClasses_.BACKGROUND_LOWER);
	                backgroundFlex.appendChild(this.backgroundLower_);
	                this.backgroundUpper_ = document.createElement('div');
	                this.backgroundUpper_.classList.add(this.CssClasses_.BACKGROUND_UPPER);
	                backgroundFlex.appendChild(this.backgroundUpper_);
	            }
	            this.boundInputHandler = this.onInput_.bind(this);
	            this.boundChangeHandler = this.onChange_.bind(this);
	            this.boundMouseUpHandler = this.onMouseUp_.bind(this);
	            this.boundContainerMouseDownHandler = this.onContainerMouseDown_.bind(this);
	            this.element_.addEventListener('input', this.boundInputHandler);
	            this.element_.addEventListener('change', this.boundChangeHandler);
	            this.element_.addEventListener('mouseup', this.boundMouseUpHandler);
	            this.element_.parentElement.addEventListener('mousedown', this.boundContainerMouseDownHandler);
	            this.updateValueStyles_();
	            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialSlider,
	        classAsString: 'MaterialSlider',
	        cssClass: 'mdl-js-slider',
	        widget: true
	    });
	    /**
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Snackbar MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialSnackbar = function MaterialSnackbar(element) {
	        this.element_ = element;
	        this.textElement_ = this.element_.querySelector('.' + this.cssClasses_.MESSAGE);
	        this.actionElement_ = this.element_.querySelector('.' + this.cssClasses_.ACTION);
	        if (!this.textElement_) {
	            throw new Error('There must be a message element for a snackbar.');
	        }
	        if (!this.actionElement_) {
	            throw new Error('There must be an action element for a snackbar.');
	        }
	        this.active = false;
	        this.actionHandler_ = undefined;
	        this.message_ = undefined;
	        this.actionText_ = undefined;
	        this.queuedNotifications_ = [];
	        this.setActionHidden_(true);
	    };
	    window['MaterialSnackbar'] = MaterialSnackbar;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialSnackbar.prototype.Constant_ = {
	        // The duration of the snackbar show/hide animation, in ms.
	        ANIMATION_LENGTH: 250
	    };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialSnackbar.prototype.cssClasses_ = {
	        SNACKBAR: 'mdl-snackbar',
	        MESSAGE: 'mdl-snackbar__text',
	        ACTION: 'mdl-snackbar__action',
	        ACTIVE: 'mdl-snackbar--active'
	    };
	    /**
	       * Display the snackbar.
	       *
	       * @private
	       */
	    MaterialSnackbar.prototype.displaySnackbar_ = function () {
	        this.element_.setAttribute('aria-hidden', 'true');
	        if (this.actionHandler_) {
	            this.actionElement_.textContent = this.actionText_;
	            this.actionElement_.addEventListener('click', this.actionHandler_);
	            this.setActionHidden_(false);
	        }
	        this.textElement_.textContent = this.message_;
	        this.element_.classList.add(this.cssClasses_.ACTIVE);
	        this.element_.setAttribute('aria-hidden', 'false');
	        setTimeout(this.cleanup_.bind(this), this.timeout_);
	    };
	    /**
	       * Show the snackbar.
	       *
	       * @param {Object} data The data for the notification.
	       * @public
	       */
	    MaterialSnackbar.prototype.showSnackbar = function (data) {
	        if (data === undefined) {
	            throw new Error('Please provide a data object with at least a message to display.');
	        }
	        if (data['message'] === undefined) {
	            throw new Error('Please provide a message to be displayed.');
	        }
	        if (data['actionHandler'] && !data['actionText']) {
	            throw new Error('Please provide action text with the handler.');
	        }
	        if (this.active) {
	            this.queuedNotifications_.push(data);
	        } else {
	            this.active = true;
	            this.message_ = data['message'];
	            if (data['timeout']) {
	                this.timeout_ = data['timeout'];
	            } else {
	                this.timeout_ = 2750;
	            }
	            if (data['actionHandler']) {
	                this.actionHandler_ = data['actionHandler'];
	            }
	            if (data['actionText']) {
	                this.actionText_ = data['actionText'];
	            }
	            this.displaySnackbar_();
	        }
	    };
	    MaterialSnackbar.prototype['showSnackbar'] = MaterialSnackbar.prototype.showSnackbar;
	    /**
	       * Check if the queue has items within it.
	       * If it does, display the next entry.
	       *
	       * @private
	       */
	    MaterialSnackbar.prototype.checkQueue_ = function () {
	        if (this.queuedNotifications_.length > 0) {
	            this.showSnackbar(this.queuedNotifications_.shift());
	        }
	    };
	    /**
	       * Cleanup the snackbar event listeners and accessiblity attributes.
	       *
	       * @private
	       */
	    MaterialSnackbar.prototype.cleanup_ = function () {
	        this.element_.classList.remove(this.cssClasses_.ACTIVE);
	        setTimeout(function () {
	            this.element_.setAttribute('aria-hidden', 'true');
	            this.textElement_.textContent = '';
	            if (!Boolean(this.actionElement_.getAttribute('aria-hidden'))) {
	                this.setActionHidden_(true);
	                this.actionElement_.textContent = '';
	                this.actionElement_.removeEventListener('click', this.actionHandler_);
	            }
	            this.actionHandler_ = undefined;
	            this.message_ = undefined;
	            this.actionText_ = undefined;
	            this.active = false;
	            this.checkQueue_();
	        }.bind(this), this.Constant_.ANIMATION_LENGTH);
	    };
	    /**
	       * Set the action handler hidden state.
	       *
	       * @param {boolean} value
	       * @private
	       */
	    MaterialSnackbar.prototype.setActionHidden_ = function (value) {
	        if (value) {
	            this.actionElement_.setAttribute('aria-hidden', 'true');
	        } else {
	            this.actionElement_.removeAttribute('aria-hidden');
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialSnackbar,
	        classAsString: 'MaterialSnackbar',
	        cssClass: 'mdl-js-snackbar',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Spinner MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @param {HTMLElement} element The element that will be upgraded.
	       * @constructor
	       */
	    var MaterialSpinner = function MaterialSpinner(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialSpinner'] = MaterialSpinner;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialSpinner.prototype.Constant_ = { MDL_SPINNER_LAYER_COUNT: 4 };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialSpinner.prototype.CssClasses_ = {
	        MDL_SPINNER_LAYER: 'mdl-spinner__layer',
	        MDL_SPINNER_CIRCLE_CLIPPER: 'mdl-spinner__circle-clipper',
	        MDL_SPINNER_CIRCLE: 'mdl-spinner__circle',
	        MDL_SPINNER_GAP_PATCH: 'mdl-spinner__gap-patch',
	        MDL_SPINNER_LEFT: 'mdl-spinner__left',
	        MDL_SPINNER_RIGHT: 'mdl-spinner__right'
	    };
	    /**
	       * Auxiliary method to create a spinner layer.
	       *
	       * @param {number} index Index of the layer to be created.
	       * @public
	       */
	    MaterialSpinner.prototype.createLayer = function (index) {
	        var layer = document.createElement('div');
	        layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);
	        layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER + '-' + index);
	        var leftClipper = document.createElement('div');
	        leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
	        leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);
	        var gapPatch = document.createElement('div');
	        gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);
	        var rightClipper = document.createElement('div');
	        rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
	        rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);
	        var circleOwners = [leftClipper, gapPatch, rightClipper];
	        for (var i = 0; i < circleOwners.length; i++) {
	            var circle = document.createElement('div');
	            circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);
	            circleOwners[i].appendChild(circle);
	        }
	        layer.appendChild(leftClipper);
	        layer.appendChild(gapPatch);
	        layer.appendChild(rightClipper);
	        this.element_.appendChild(layer);
	    };
	    MaterialSpinner.prototype['createLayer'] = MaterialSpinner.prototype.createLayer;
	    /**
	       * Stops the spinner animation.
	       * Public method for users who need to stop the spinner for any reason.
	       *
	       * @public
	       */
	    MaterialSpinner.prototype.stop = function () {
	        this.element_.classList.remove('is-active');
	    };
	    MaterialSpinner.prototype['stop'] = MaterialSpinner.prototype.stop;
	    /**
	       * Starts the spinner animation.
	       * Public method for users who need to manually start the spinner for any reason
	       * (instead of just adding the 'is-active' class to their markup).
	       *
	       * @public
	       */
	    MaterialSpinner.prototype.start = function () {
	        this.element_.classList.add('is-active');
	    };
	    MaterialSpinner.prototype['start'] = MaterialSpinner.prototype.start;
	    /**
	       * Initialize element.
	       */
	    MaterialSpinner.prototype.init = function () {
	        if (this.element_) {
	            for (var i = 1; i <= this.Constant_.MDL_SPINNER_LAYER_COUNT; i++) {
	                this.createLayer(i);
	            }
	            this.element_.classList.add('is-upgraded');
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialSpinner,
	        classAsString: 'MaterialSpinner',
	        cssClass: 'mdl-js-spinner',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Checkbox MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialSwitch = function MaterialSwitch(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialSwitch'] = MaterialSwitch;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialSwitch.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialSwitch.prototype.CssClasses_ = {
	        INPUT: 'mdl-switch__input',
	        TRACK: 'mdl-switch__track',
	        THUMB: 'mdl-switch__thumb',
	        FOCUS_HELPER: 'mdl-switch__focus-helper',
	        RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	        RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	        RIPPLE_CONTAINER: 'mdl-switch__ripple-container',
	        RIPPLE_CENTER: 'mdl-ripple--center',
	        RIPPLE: 'mdl-ripple',
	        IS_FOCUSED: 'is-focused',
	        IS_DISABLED: 'is-disabled',
	        IS_CHECKED: 'is-checked'
	    };
	    /**
	       * Handle change of state.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialSwitch.prototype.onChange_ = function (event) {
	        this.updateClasses_();
	    };
	    /**
	       * Handle focus of element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialSwitch.prototype.onFocus_ = function (event) {
	        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle lost focus of element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialSwitch.prototype.onBlur_ = function (event) {
	        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle mouseup.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialSwitch.prototype.onMouseUp_ = function (event) {
	        this.blur_();
	    };
	    /**
	       * Handle class updates.
	       *
	       * @private
	       */
	    MaterialSwitch.prototype.updateClasses_ = function () {
	        this.checkDisabled();
	        this.checkToggleState();
	    };
	    /**
	       * Add blur.
	       *
	       * @private
	       */
	    MaterialSwitch.prototype.blur_ = function () {
	        // TODO: figure out why there's a focus event being fired after our blur,
	        // so that we can avoid this hack.
	        window.setTimeout(function () {
	            this.inputElement_.blur();
	        }.bind(this), this.Constant_.TINY_TIMEOUT);
	    };
	    // Public methods.
	    /**
	       * Check the components disabled state.
	       *
	       * @public
	       */
	    MaterialSwitch.prototype.checkDisabled = function () {
	        if (this.inputElement_.disabled) {
	            this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	        }
	    };
	    MaterialSwitch.prototype['checkDisabled'] = MaterialSwitch.prototype.checkDisabled;
	    /**
	       * Check the components toggled state.
	       *
	       * @public
	       */
	    MaterialSwitch.prototype.checkToggleState = function () {
	        if (this.inputElement_.checked) {
	            this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	        }
	    };
	    MaterialSwitch.prototype['checkToggleState'] = MaterialSwitch.prototype.checkToggleState;
	    /**
	       * Disable switch.
	       *
	       * @public
	       */
	    MaterialSwitch.prototype.disable = function () {
	        this.inputElement_.disabled = true;
	        this.updateClasses_();
	    };
	    MaterialSwitch.prototype['disable'] = MaterialSwitch.prototype.disable;
	    /**
	       * Enable switch.
	       *
	       * @public
	       */
	    MaterialSwitch.prototype.enable = function () {
	        this.inputElement_.disabled = false;
	        this.updateClasses_();
	    };
	    MaterialSwitch.prototype['enable'] = MaterialSwitch.prototype.enable;
	    /**
	       * Activate switch.
	       *
	       * @public
	       */
	    MaterialSwitch.prototype.on = function () {
	        this.inputElement_.checked = true;
	        this.updateClasses_();
	    };
	    MaterialSwitch.prototype['on'] = MaterialSwitch.prototype.on;
	    /**
	       * Deactivate switch.
	       *
	       * @public
	       */
	    MaterialSwitch.prototype.off = function () {
	        this.inputElement_.checked = false;
	        this.updateClasses_();
	    };
	    MaterialSwitch.prototype['off'] = MaterialSwitch.prototype.off;
	    /**
	       * Initialize element.
	       */
	    MaterialSwitch.prototype.init = function () {
	        if (this.element_) {
	            this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	            var track = document.createElement('div');
	            track.classList.add(this.CssClasses_.TRACK);
	            var thumb = document.createElement('div');
	            thumb.classList.add(this.CssClasses_.THUMB);
	            var focusHelper = document.createElement('span');
	            focusHelper.classList.add(this.CssClasses_.FOCUS_HELPER);
	            thumb.appendChild(focusHelper);
	            this.element_.appendChild(track);
	            this.element_.appendChild(thumb);
	            this.boundMouseUpHandler = this.onMouseUp_.bind(this);
	            if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	                this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	                this.rippleContainerElement_ = document.createElement('span');
	                this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	                this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	                this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	                this.rippleContainerElement_.addEventListener('mouseup', this.boundMouseUpHandler);
	                var ripple = document.createElement('span');
	                ripple.classList.add(this.CssClasses_.RIPPLE);
	                this.rippleContainerElement_.appendChild(ripple);
	                this.element_.appendChild(this.rippleContainerElement_);
	            }
	            this.boundChangeHandler = this.onChange_.bind(this);
	            this.boundFocusHandler = this.onFocus_.bind(this);
	            this.boundBlurHandler = this.onBlur_.bind(this);
	            this.inputElement_.addEventListener('change', this.boundChangeHandler);
	            this.inputElement_.addEventListener('focus', this.boundFocusHandler);
	            this.inputElement_.addEventListener('blur', this.boundBlurHandler);
	            this.element_.addEventListener('mouseup', this.boundMouseUpHandler);
	            this.updateClasses_();
	            this.element_.classList.add('is-upgraded');
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialSwitch,
	        classAsString: 'MaterialSwitch',
	        cssClass: 'mdl-js-switch',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Tabs MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {Element} element The element that will be upgraded.
	       */
	    var MaterialTabs = function MaterialTabs(element) {
	        // Stores the HTML element.
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialTabs'] = MaterialTabs;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialTabs.prototype.Constant_ = {};
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialTabs.prototype.CssClasses_ = {
	        TAB_CLASS: 'mdl-tabs__tab',
	        PANEL_CLASS: 'mdl-tabs__panel',
	        ACTIVE_CLASS: 'is-active',
	        UPGRADED_CLASS: 'is-upgraded',
	        MDL_JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	        MDL_RIPPLE_CONTAINER: 'mdl-tabs__ripple-container',
	        MDL_RIPPLE: 'mdl-ripple',
	        MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events'
	    };
	    /**
	       * Handle clicks to a tabs component
	       *
	       * @private
	       */
	    MaterialTabs.prototype.initTabs_ = function () {
	        if (this.element_.classList.contains(this.CssClasses_.MDL_JS_RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS);
	        }
	        // Select element tabs, document panels
	        this.tabs_ = this.element_.querySelectorAll('.' + this.CssClasses_.TAB_CLASS);
	        this.panels_ = this.element_.querySelectorAll('.' + this.CssClasses_.PANEL_CLASS);
	        // Create new tabs for each tab element
	        for (var i = 0; i < this.tabs_.length; i++) {
	            new MaterialTab(this.tabs_[i], this);
	        }
	        this.element_.classList.add(this.CssClasses_.UPGRADED_CLASS);
	    };
	    /**
	       * Reset tab state, dropping active classes
	       *
	       * @private
	       */
	    MaterialTabs.prototype.resetTabState_ = function () {
	        for (var k = 0; k < this.tabs_.length; k++) {
	            this.tabs_[k].classList.remove(this.CssClasses_.ACTIVE_CLASS);
	        }
	    };
	    /**
	       * Reset panel state, droping active classes
	       *
	       * @private
	       */
	    MaterialTabs.prototype.resetPanelState_ = function () {
	        for (var j = 0; j < this.panels_.length; j++) {
	            this.panels_[j].classList.remove(this.CssClasses_.ACTIVE_CLASS);
	        }
	    };
	    /**
	       * Initialize element.
	       */
	    MaterialTabs.prototype.init = function () {
	        if (this.element_) {
	            this.initTabs_();
	        }
	    };
	    /**
	       * Constructor for an individual tab.
	       *
	       * @constructor
	       * @param {Element} tab The HTML element for the tab.
	       * @param {MaterialTabs} ctx The MaterialTabs object that owns the tab.
	       */
	    function MaterialTab(tab, ctx) {
	        if (tab) {
	            if (ctx.element_.classList.contains(ctx.CssClasses_.MDL_JS_RIPPLE_EFFECT)) {
	                var rippleContainer = document.createElement('span');
	                rippleContainer.classList.add(ctx.CssClasses_.MDL_RIPPLE_CONTAINER);
	                rippleContainer.classList.add(ctx.CssClasses_.MDL_JS_RIPPLE_EFFECT);
	                var ripple = document.createElement('span');
	                ripple.classList.add(ctx.CssClasses_.MDL_RIPPLE);
	                rippleContainer.appendChild(ripple);
	                tab.appendChild(rippleContainer);
	            }
	            tab.addEventListener('click', function (e) {
	                e.preventDefault();
	                var href = tab.href.split('#')[1];
	                var panel = ctx.element_.querySelector('#' + href);
	                ctx.resetTabState_();
	                ctx.resetPanelState_();
	                tab.classList.add(ctx.CssClasses_.ACTIVE_CLASS);
	                panel.classList.add(ctx.CssClasses_.ACTIVE_CLASS);
	            });
	        }
	    }
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialTabs,
	        classAsString: 'MaterialTabs',
	        cssClass: 'mdl-js-tabs'
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Textfield MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialTextfield = function MaterialTextfield(element) {
	        this.element_ = element;
	        this.maxRows = this.Constant_.NO_MAX_ROWS;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialTextfield'] = MaterialTextfield;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialTextfield.prototype.Constant_ = {
	        NO_MAX_ROWS: -1,
	        MAX_ROWS_ATTRIBUTE: 'maxrows'
	    };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialTextfield.prototype.CssClasses_ = {
	        LABEL: 'mdl-textfield__label',
	        INPUT: 'mdl-textfield__input',
	        IS_DIRTY: 'is-dirty',
	        IS_FOCUSED: 'is-focused',
	        IS_DISABLED: 'is-disabled',
	        IS_INVALID: 'is-invalid',
	        IS_UPGRADED: 'is-upgraded'
	    };
	    /**
	       * Handle input being entered.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialTextfield.prototype.onKeyDown_ = function (event) {
	        var currentRowCount = event.target.value.split('\n').length;
	        if (event.keyCode === 13) {
	            if (currentRowCount >= this.maxRows) {
	                event.preventDefault();
	            }
	        }
	    };
	    /**
	       * Handle focus.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialTextfield.prototype.onFocus_ = function (event) {
	        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle lost focus.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialTextfield.prototype.onBlur_ = function (event) {
	        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	    };
	    /**
	       * Handle reset event from out side.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialTextfield.prototype.onReset_ = function (event) {
	        this.updateClasses_();
	    };
	    /**
	       * Handle class updates.
	       *
	       * @private
	       */
	    MaterialTextfield.prototype.updateClasses_ = function () {
	        this.checkDisabled();
	        this.checkValidity();
	        this.checkDirty();
	        this.checkFocus();
	    };
	    // Public methods.
	    /**
	       * Check the disabled state and update field accordingly.
	       *
	       * @public
	       */
	    MaterialTextfield.prototype.checkDisabled = function () {
	        if (this.input_.disabled) {
	            this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	        }
	    };
	    MaterialTextfield.prototype['checkDisabled'] = MaterialTextfield.prototype.checkDisabled;
	    /**
	      * Check the focus state and update field accordingly.
	      *
	      * @public
	      */
	    MaterialTextfield.prototype.checkFocus = function () {
	        if (Boolean(this.element_.querySelector(':focus'))) {
	            this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	        }
	    };
	    MaterialTextfield.prototype['checkFocus'] = MaterialTextfield.prototype.checkFocus;
	    /**
	       * Check the validity state and update field accordingly.
	       *
	       * @public
	       */
	    MaterialTextfield.prototype.checkValidity = function () {
	        if (this.input_.validity) {
	            if (this.input_.validity.valid) {
	                this.element_.classList.remove(this.CssClasses_.IS_INVALID);
	            } else {
	                this.element_.classList.add(this.CssClasses_.IS_INVALID);
	            }
	        }
	    };
	    MaterialTextfield.prototype['checkValidity'] = MaterialTextfield.prototype.checkValidity;
	    /**
	       * Check the dirty state and update field accordingly.
	       *
	       * @public
	       */
	    MaterialTextfield.prototype.checkDirty = function () {
	        if (this.input_.value && this.input_.value.length > 0) {
	            this.element_.classList.add(this.CssClasses_.IS_DIRTY);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_DIRTY);
	        }
	    };
	    MaterialTextfield.prototype['checkDirty'] = MaterialTextfield.prototype.checkDirty;
	    /**
	       * Disable text field.
	       *
	       * @public
	       */
	    MaterialTextfield.prototype.disable = function () {
	        this.input_.disabled = true;
	        this.updateClasses_();
	    };
	    MaterialTextfield.prototype['disable'] = MaterialTextfield.prototype.disable;
	    /**
	       * Enable text field.
	       *
	       * @public
	       */
	    MaterialTextfield.prototype.enable = function () {
	        this.input_.disabled = false;
	        this.updateClasses_();
	    };
	    MaterialTextfield.prototype['enable'] = MaterialTextfield.prototype.enable;
	    /**
	       * Update text field value.
	       *
	       * @param {string} value The value to which to set the control (optional).
	       * @public
	       */
	    MaterialTextfield.prototype.change = function (value) {
	        this.input_.value = value || '';
	        this.updateClasses_();
	    };
	    MaterialTextfield.prototype['change'] = MaterialTextfield.prototype.change;
	    /**
	       * Initialize element.
	       */
	    MaterialTextfield.prototype.init = function () {
	        if (this.element_) {
	            this.label_ = this.element_.querySelector('.' + this.CssClasses_.LABEL);
	            this.input_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	            if (this.input_) {
	                if (this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)) {
	                    this.maxRows = parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE), 10);
	                    if (isNaN(this.maxRows)) {
	                        this.maxRows = this.Constant_.NO_MAX_ROWS;
	                    }
	                }
	                this.boundUpdateClassesHandler = this.updateClasses_.bind(this);
	                this.boundFocusHandler = this.onFocus_.bind(this);
	                this.boundBlurHandler = this.onBlur_.bind(this);
	                this.boundResetHandler = this.onReset_.bind(this);
	                this.input_.addEventListener('input', this.boundUpdateClassesHandler);
	                this.input_.addEventListener('focus', this.boundFocusHandler);
	                this.input_.addEventListener('blur', this.boundBlurHandler);
	                this.input_.addEventListener('reset', this.boundResetHandler);
	                if (this.maxRows !== this.Constant_.NO_MAX_ROWS) {
	                    // TODO: This should handle pasting multi line text.
	                    // Currently doesn't.
	                    this.boundKeyDownHandler = this.onKeyDown_.bind(this);
	                    this.input_.addEventListener('keydown', this.boundKeyDownHandler);
	                }
	                var invalid = this.element_.classList.contains(this.CssClasses_.IS_INVALID);
	                this.updateClasses_();
	                this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	                if (invalid) {
	                    this.element_.classList.add(this.CssClasses_.IS_INVALID);
	                }
	                if (this.input_.hasAttribute('autofocus')) {
	                    this.element_.focus();
	                    this.checkFocus();
	                }
	            }
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialTextfield,
	        classAsString: 'MaterialTextfield',
	        cssClass: 'mdl-js-textfield',
	        widget: true
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Tooltip MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialTooltip = function MaterialTooltip(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialTooltip'] = MaterialTooltip;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialTooltip.prototype.Constant_ = {};
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialTooltip.prototype.CssClasses_ = {
	        IS_ACTIVE: 'is-active',
	        BOTTOM: 'mdl-tooltip--bottom',
	        LEFT: 'mdl-tooltip--left',
	        RIGHT: 'mdl-tooltip--right',
	        TOP: 'mdl-tooltip--top'
	    };
	    /**
	       * Handle mouseenter for tooltip.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialTooltip.prototype.handleMouseEnter_ = function (event) {
	        var props = event.target.getBoundingClientRect();
	        var left = props.left + props.width / 2;
	        var top = props.top + props.height / 2;
	        var marginLeft = -1 * (this.element_.offsetWidth / 2);
	        var marginTop = -1 * (this.element_.offsetHeight / 2);
	        if (this.element_.classList.contains(this.CssClasses_.LEFT) || this.element_.classList.contains(this.CssClasses_.RIGHT)) {
	            left = props.width / 2;
	            if (top + marginTop < 0) {
	                this.element_.style.top = 0;
	                this.element_.style.marginTop = 0;
	            } else {
	                this.element_.style.top = top + 'px';
	                this.element_.style.marginTop = marginTop + 'px';
	            }
	        } else {
	            if (left + marginLeft < 0) {
	                this.element_.style.left = 0;
	                this.element_.style.marginLeft = 0;
	            } else {
	                this.element_.style.left = left + 'px';
	                this.element_.style.marginLeft = marginLeft + 'px';
	            }
	        }
	        if (this.element_.classList.contains(this.CssClasses_.TOP)) {
	            this.element_.style.top = props.top - this.element_.offsetHeight - 10 + 'px';
	        } else if (this.element_.classList.contains(this.CssClasses_.RIGHT)) {
	            this.element_.style.left = props.left + props.width + 10 + 'px';
	        } else if (this.element_.classList.contains(this.CssClasses_.LEFT)) {
	            this.element_.style.left = props.left - this.element_.offsetWidth - 10 + 'px';
	        } else {
	            this.element_.style.top = props.top + props.height + 10 + 'px';
	        }
	        this.element_.classList.add(this.CssClasses_.IS_ACTIVE);
	    };
	    /**
	       * Handle mouseleave for tooltip.
	       *
	       * @private
	       */
	    MaterialTooltip.prototype.handleMouseLeave_ = function () {
	        this.element_.classList.remove(this.CssClasses_.IS_ACTIVE);
	    };
	    /**
	       * Initialize element.
	       */
	    MaterialTooltip.prototype.init = function () {
	        if (this.element_) {
	            var forElId = this.element_.getAttribute('for');
	            if (forElId) {
	                this.forElement_ = document.getElementById(forElId);
	            }
	            if (this.forElement_) {
	                // It's left here because it prevents accidental text selection on Android
	                if (!this.forElement_.hasAttribute('tabindex')) {
	                    this.forElement_.setAttribute('tabindex', '0');
	                }
	                this.boundMouseEnterHandler = this.handleMouseEnter_.bind(this);
	                this.boundMouseLeaveHandler = this.handleMouseLeave_.bind(this);
	                this.forElement_.addEventListener('mouseenter', this.boundMouseEnterHandler, false);
	                this.forElement_.addEventListener('touchend', this.boundMouseEnterHandler, false);
	                this.forElement_.addEventListener('mouseleave', this.boundMouseLeaveHandler, false);
	                window.addEventListener('touchstart', this.boundMouseLeaveHandler);
	            }
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialTooltip,
	        classAsString: 'MaterialTooltip',
	        cssClass: 'mdl-tooltip'
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Layout MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialLayout = function MaterialLayout(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialLayout'] = MaterialLayout;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialLayout.prototype.Constant_ = {
	        MAX_WIDTH: '(max-width: 1024px)',
	        TAB_SCROLL_PIXELS: 100,
	        MENU_ICON: '&#xE5D2;',
	        CHEVRON_LEFT: 'chevron_left',
	        CHEVRON_RIGHT: 'chevron_right'
	    };
	    /**
	       * Keycodes, for code readability.
	       *
	       * @enum {number}
	       * @private
	       */
	    MaterialLayout.prototype.Keycodes_ = {
	        ENTER: 13,
	        ESCAPE: 27,
	        SPACE: 32
	    };
	    /**
	       * Modes.
	       *
	       * @enum {number}
	       * @private
	       */
	    MaterialLayout.prototype.Mode_ = {
	        STANDARD: 0,
	        SEAMED: 1,
	        WATERFALL: 2,
	        SCROLL: 3
	    };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialLayout.prototype.CssClasses_ = {
	        CONTAINER: 'mdl-layout__container',
	        HEADER: 'mdl-layout__header',
	        DRAWER: 'mdl-layout__drawer',
	        CONTENT: 'mdl-layout__content',
	        DRAWER_BTN: 'mdl-layout__drawer-button',
	        ICON: 'material-icons',
	        JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	        RIPPLE_CONTAINER: 'mdl-layout__tab-ripple-container',
	        RIPPLE: 'mdl-ripple',
	        RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	        HEADER_SEAMED: 'mdl-layout__header--seamed',
	        HEADER_WATERFALL: 'mdl-layout__header--waterfall',
	        HEADER_SCROLL: 'mdl-layout__header--scroll',
	        FIXED_HEADER: 'mdl-layout--fixed-header',
	        OBFUSCATOR: 'mdl-layout__obfuscator',
	        TAB_BAR: 'mdl-layout__tab-bar',
	        TAB_CONTAINER: 'mdl-layout__tab-bar-container',
	        TAB: 'mdl-layout__tab',
	        TAB_BAR_BUTTON: 'mdl-layout__tab-bar-button',
	        TAB_BAR_LEFT_BUTTON: 'mdl-layout__tab-bar-left-button',
	        TAB_BAR_RIGHT_BUTTON: 'mdl-layout__tab-bar-right-button',
	        PANEL: 'mdl-layout__tab-panel',
	        HAS_DRAWER: 'has-drawer',
	        HAS_TABS: 'has-tabs',
	        HAS_SCROLLING_HEADER: 'has-scrolling-header',
	        CASTING_SHADOW: 'is-casting-shadow',
	        IS_COMPACT: 'is-compact',
	        IS_SMALL_SCREEN: 'is-small-screen',
	        IS_DRAWER_OPEN: 'is-visible',
	        IS_ACTIVE: 'is-active',
	        IS_UPGRADED: 'is-upgraded',
	        IS_ANIMATING: 'is-animating',
	        ON_LARGE_SCREEN: 'mdl-layout--large-screen-only',
	        ON_SMALL_SCREEN: 'mdl-layout--small-screen-only'
	    };
	    /**
	       * Handles scrolling on the content.
	       *
	       * @private
	       */
	    MaterialLayout.prototype.contentScrollHandler_ = function () {
	        if (this.header_.classList.contains(this.CssClasses_.IS_ANIMATING)) {
	            return;
	        }
	        var headerVisible = !this.element_.classList.contains(this.CssClasses_.IS_SMALL_SCREEN) || this.element_.classList.contains(this.CssClasses_.FIXED_HEADER);
	        if (this.content_.scrollTop > 0 && !this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	            this.header_.classList.add(this.CssClasses_.CASTING_SHADOW);
	            this.header_.classList.add(this.CssClasses_.IS_COMPACT);
	            if (headerVisible) {
	                this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	            }
	        } else if (this.content_.scrollTop <= 0 && this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	            this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	            this.header_.classList.remove(this.CssClasses_.IS_COMPACT);
	            if (headerVisible) {
	                this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	            }
	        }
	    };
	    /**
	       * Handles a keyboard event on the drawer.
	       *
	       * @param {Event} evt The event that fired.
	       * @private
	       */
	    MaterialLayout.prototype.keyboardEventHandler_ = function (evt) {
	        if (evt.keyCode === this.Keycodes_.ESCAPE) {
	            this.toggleDrawer();
	        }
	    };
	    /**
	       * Handles changes in screen size.
	       *
	       * @private
	       */
	    MaterialLayout.prototype.screenSizeHandler_ = function () {
	        if (this.screenSizeMediaQuery_.matches) {
	            this.element_.classList.add(this.CssClasses_.IS_SMALL_SCREEN);
	        } else {
	            this.element_.classList.remove(this.CssClasses_.IS_SMALL_SCREEN);
	            // Collapse drawer (if any) when moving to a large screen size.
	            if (this.drawer_) {
	                this.drawer_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN);
	                this.obfuscator_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN);
	            }
	        }
	    };
	    /**
	       * Handles events of drawer button.
	       *
	       * @param {Event} evt The event that fired.
	       * @private
	       */
	    MaterialLayout.prototype.drawerToggleHandler_ = function (evt) {
	        if (evt && evt.type === 'keydown') {
	            if (evt.keyCode === this.Keycodes_.SPACE || evt.keyCode === this.Keycodes_.ENTER) {
	                // prevent scrolling in drawer nav
	                evt.preventDefault();
	            } else {
	                // prevent other keys
	                return;
	            }
	        }
	        this.toggleDrawer();
	    };
	    /**
	       * Handles (un)setting the `is-animating` class
	       *
	       * @private
	       */
	    MaterialLayout.prototype.headerTransitionEndHandler_ = function () {
	        this.header_.classList.remove(this.CssClasses_.IS_ANIMATING);
	    };
	    /**
	       * Handles expanding the header on click
	       *
	       * @private
	       */
	    MaterialLayout.prototype.headerClickHandler_ = function () {
	        if (this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	            this.header_.classList.remove(this.CssClasses_.IS_COMPACT);
	            this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	        }
	    };
	    /**
	       * Reset tab state, dropping active classes
	       *
	       * @private
	       */
	    MaterialLayout.prototype.resetTabState_ = function (tabBar) {
	        for (var k = 0; k < tabBar.length; k++) {
	            tabBar[k].classList.remove(this.CssClasses_.IS_ACTIVE);
	        }
	    };
	    /**
	       * Reset panel state, droping active classes
	       *
	       * @private
	       */
	    MaterialLayout.prototype.resetPanelState_ = function (panels) {
	        for (var j = 0; j < panels.length; j++) {
	            panels[j].classList.remove(this.CssClasses_.IS_ACTIVE);
	        }
	    };
	    /**
	      * Toggle drawer state
	      *
	      * @public
	      */
	    MaterialLayout.prototype.toggleDrawer = function () {
	        var drawerButton = this.element_.querySelector('.' + this.CssClasses_.DRAWER_BTN);
	        this.drawer_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN);
	        this.obfuscator_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN);
	        // Set accessibility properties.
	        if (this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)) {
	            this.drawer_.setAttribute('aria-hidden', 'false');
	            drawerButton.setAttribute('aria-expanded', 'true');
	        } else {
	            this.drawer_.setAttribute('aria-hidden', 'true');
	            drawerButton.setAttribute('aria-expanded', 'false');
	        }
	    };
	    MaterialLayout.prototype['toggleDrawer'] = MaterialLayout.prototype.toggleDrawer;
	    /**
	       * Initialize element.
	       */
	    MaterialLayout.prototype.init = function () {
	        if (this.element_) {
	            var container = document.createElement('div');
	            container.classList.add(this.CssClasses_.CONTAINER);
	            this.element_.parentElement.insertBefore(container, this.element_);
	            this.element_.parentElement.removeChild(this.element_);
	            container.appendChild(this.element_);
	            var directChildren = this.element_.childNodes;
	            var numChildren = directChildren.length;
	            for (var c = 0; c < numChildren; c++) {
	                var child = directChildren[c];
	                if (child.classList && child.classList.contains(this.CssClasses_.HEADER)) {
	                    this.header_ = child;
	                }
	                if (child.classList && child.classList.contains(this.CssClasses_.DRAWER)) {
	                    this.drawer_ = child;
	                }
	                if (child.classList && child.classList.contains(this.CssClasses_.CONTENT)) {
	                    this.content_ = child;
	                }
	            }
	            window.addEventListener('pageshow', function (e) {
	                if (e.persisted) {
	                    // when page is loaded from back/forward cache
	                    // trigger repaint to let layout scroll in safari
	                    this.element_.style.overflowY = 'hidden';
	                    requestAnimationFrame(function () {
	                        this.element_.style.overflowY = '';
	                    }.bind(this));
	                }
	            }.bind(this), false);
	            if (this.header_) {
	                this.tabBar_ = this.header_.querySelector('.' + this.CssClasses_.TAB_BAR);
	            }
	            var mode = this.Mode_.STANDARD;
	            if (this.header_) {
	                if (this.header_.classList.contains(this.CssClasses_.HEADER_SEAMED)) {
	                    mode = this.Mode_.SEAMED;
	                } else if (this.header_.classList.contains(this.CssClasses_.HEADER_WATERFALL)) {
	                    mode = this.Mode_.WATERFALL;
	                    this.header_.addEventListener('transitionend', this.headerTransitionEndHandler_.bind(this));
	                    this.header_.addEventListener('click', this.headerClickHandler_.bind(this));
	                } else if (this.header_.classList.contains(this.CssClasses_.HEADER_SCROLL)) {
	                    mode = this.Mode_.SCROLL;
	                    container.classList.add(this.CssClasses_.HAS_SCROLLING_HEADER);
	                }
	                if (mode === this.Mode_.STANDARD) {
	                    this.header_.classList.add(this.CssClasses_.CASTING_SHADOW);
	                    if (this.tabBar_) {
	                        this.tabBar_.classList.add(this.CssClasses_.CASTING_SHADOW);
	                    }
	                } else if (mode === this.Mode_.SEAMED || mode === this.Mode_.SCROLL) {
	                    this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	                    if (this.tabBar_) {
	                        this.tabBar_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	                    }
	                } else if (mode === this.Mode_.WATERFALL) {
	                    // Add and remove shadows depending on scroll position.
	                    // Also add/remove auxiliary class for styling of the compact version of
	                    // the header.
	                    this.content_.addEventListener('scroll', this.contentScrollHandler_.bind(this));
	                    this.contentScrollHandler_();
	                }
	            }
	            // Add drawer toggling button to our layout, if we have an openable drawer.
	            if (this.drawer_) {
	                var drawerButton = this.element_.querySelector('.' + this.CssClasses_.DRAWER_BTN);
	                if (!drawerButton) {
	                    drawerButton = document.createElement('div');
	                    drawerButton.setAttribute('aria-expanded', 'false');
	                    drawerButton.setAttribute('role', 'button');
	                    drawerButton.setAttribute('tabindex', '0');
	                    drawerButton.classList.add(this.CssClasses_.DRAWER_BTN);
	                    var drawerButtonIcon = document.createElement('i');
	                    drawerButtonIcon.classList.add(this.CssClasses_.ICON);
	                    drawerButtonIcon.innerHTML = this.Constant_.MENU_ICON;
	                    drawerButton.appendChild(drawerButtonIcon);
	                }
	                if (this.drawer_.classList.contains(this.CssClasses_.ON_LARGE_SCREEN)) {
	                    //If drawer has ON_LARGE_SCREEN class then add it to the drawer toggle button as well.
	                    drawerButton.classList.add(this.CssClasses_.ON_LARGE_SCREEN);
	                } else if (this.drawer_.classList.contains(this.CssClasses_.ON_SMALL_SCREEN)) {
	                    //If drawer has ON_SMALL_SCREEN class then add it to the drawer toggle button as well.
	                    drawerButton.classList.add(this.CssClasses_.ON_SMALL_SCREEN);
	                }
	                drawerButton.addEventListener('click', this.drawerToggleHandler_.bind(this));
	                drawerButton.addEventListener('keydown', this.drawerToggleHandler_.bind(this));
	                // Add a class if the layout has a drawer, for altering the left padding.
	                // Adds the HAS_DRAWER to the elements since this.header_ may or may
	                // not be present.
	                this.element_.classList.add(this.CssClasses_.HAS_DRAWER);
	                // If we have a fixed header, add the button to the header rather than
	                // the layout.
	                if (this.element_.classList.contains(this.CssClasses_.FIXED_HEADER)) {
	                    this.header_.insertBefore(drawerButton, this.header_.firstChild);
	                } else {
	                    this.element_.insertBefore(drawerButton, this.content_);
	                }
	                var obfuscator = document.createElement('div');
	                obfuscator.classList.add(this.CssClasses_.OBFUSCATOR);
	                this.element_.appendChild(obfuscator);
	                obfuscator.addEventListener('click', this.drawerToggleHandler_.bind(this));
	                this.obfuscator_ = obfuscator;
	                this.drawer_.addEventListener('keydown', this.keyboardEventHandler_.bind(this));
	                this.drawer_.setAttribute('aria-hidden', 'true');
	            }
	            // Keep an eye on screen size, and add/remove auxiliary class for styling
	            // of small screens.
	            this.screenSizeMediaQuery_ = window.matchMedia(this.Constant_.MAX_WIDTH);
	            this.screenSizeMediaQuery_.addListener(this.screenSizeHandler_.bind(this));
	            this.screenSizeHandler_();
	            // Initialize tabs, if any.
	            if (this.header_ && this.tabBar_) {
	                this.element_.classList.add(this.CssClasses_.HAS_TABS);
	                var tabContainer = document.createElement('div');
	                tabContainer.classList.add(this.CssClasses_.TAB_CONTAINER);
	                this.header_.insertBefore(tabContainer, this.tabBar_);
	                this.header_.removeChild(this.tabBar_);
	                var leftButton = document.createElement('div');
	                leftButton.classList.add(this.CssClasses_.TAB_BAR_BUTTON);
	                leftButton.classList.add(this.CssClasses_.TAB_BAR_LEFT_BUTTON);
	                var leftButtonIcon = document.createElement('i');
	                leftButtonIcon.classList.add(this.CssClasses_.ICON);
	                leftButtonIcon.textContent = this.Constant_.CHEVRON_LEFT;
	                leftButton.appendChild(leftButtonIcon);
	                leftButton.addEventListener('click', function () {
	                    this.tabBar_.scrollLeft -= this.Constant_.TAB_SCROLL_PIXELS;
	                }.bind(this));
	                var rightButton = document.createElement('div');
	                rightButton.classList.add(this.CssClasses_.TAB_BAR_BUTTON);
	                rightButton.classList.add(this.CssClasses_.TAB_BAR_RIGHT_BUTTON);
	                var rightButtonIcon = document.createElement('i');
	                rightButtonIcon.classList.add(this.CssClasses_.ICON);
	                rightButtonIcon.textContent = this.Constant_.CHEVRON_RIGHT;
	                rightButton.appendChild(rightButtonIcon);
	                rightButton.addEventListener('click', function () {
	                    this.tabBar_.scrollLeft += this.Constant_.TAB_SCROLL_PIXELS;
	                }.bind(this));
	                tabContainer.appendChild(leftButton);
	                tabContainer.appendChild(this.tabBar_);
	                tabContainer.appendChild(rightButton);
	                // Add and remove buttons depending on scroll position.
	                var tabScrollHandler = function () {
	                    if (this.tabBar_.scrollLeft > 0) {
	                        leftButton.classList.add(this.CssClasses_.IS_ACTIVE);
	                    } else {
	                        leftButton.classList.remove(this.CssClasses_.IS_ACTIVE);
	                    }
	                    if (this.tabBar_.scrollLeft < this.tabBar_.scrollWidth - this.tabBar_.offsetWidth) {
	                        rightButton.classList.add(this.CssClasses_.IS_ACTIVE);
	                    } else {
	                        rightButton.classList.remove(this.CssClasses_.IS_ACTIVE);
	                    }
	                }.bind(this);
	                this.tabBar_.addEventListener('scroll', tabScrollHandler);
	                tabScrollHandler();
	                if (this.tabBar_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)) {
	                    this.tabBar_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	                }
	                // Select element tabs, document panels
	                var tabs = this.tabBar_.querySelectorAll('.' + this.CssClasses_.TAB);
	                var panels = this.content_.querySelectorAll('.' + this.CssClasses_.PANEL);
	                // Create new tabs for each tab element
	                for (var i = 0; i < tabs.length; i++) {
	                    new MaterialLayoutTab(tabs[i], tabs, panels, this);
	                }
	            }
	            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	        }
	    };
	    /**
	       * Constructor for an individual tab.
	       *
	       * @constructor
	       * @param {HTMLElement} tab The HTML element for the tab.
	       * @param {!Array<HTMLElement>} tabs Array with HTML elements for all tabs.
	       * @param {!Array<HTMLElement>} panels Array with HTML elements for all panels.
	       * @param {MaterialLayout} layout The MaterialLayout object that owns the tab.
	       */
	    function MaterialLayoutTab(tab, tabs, panels, layout) {
	        /**
	         * Auxiliary method to programmatically select a tab in the UI.
	         */
	        function selectTab() {
	            var href = tab.href.split('#')[1];
	            var panel = layout.content_.querySelector('#' + href);
	            layout.resetTabState_(tabs);
	            layout.resetPanelState_(panels);
	            tab.classList.add(layout.CssClasses_.IS_ACTIVE);
	            panel.classList.add(layout.CssClasses_.IS_ACTIVE);
	        }
	        if (layout.tabBar_.classList.contains(layout.CssClasses_.JS_RIPPLE_EFFECT)) {
	            var rippleContainer = document.createElement('span');
	            rippleContainer.classList.add(layout.CssClasses_.RIPPLE_CONTAINER);
	            rippleContainer.classList.add(layout.CssClasses_.JS_RIPPLE_EFFECT);
	            var ripple = document.createElement('span');
	            ripple.classList.add(layout.CssClasses_.RIPPLE);
	            rippleContainer.appendChild(ripple);
	            tab.appendChild(rippleContainer);
	        }
	        tab.addEventListener('click', function (e) {
	            if (tab.getAttribute('href').charAt(0) === '#') {
	                e.preventDefault();
	                selectTab();
	            }
	        });
	        tab.show = selectTab;
	        tab.addEventListener('click', function (e) {
	            e.preventDefault();
	            var href = tab.href.split('#')[1];
	            var panel = layout.content_.querySelector('#' + href);
	            layout.resetTabState_(tabs);
	            layout.resetPanelState_(panels);
	            tab.classList.add(layout.CssClasses_.IS_ACTIVE);
	            panel.classList.add(layout.CssClasses_.IS_ACTIVE);
	        });
	    }
	    window['MaterialLayoutTab'] = MaterialLayoutTab;
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialLayout,
	        classAsString: 'MaterialLayout',
	        cssClass: 'mdl-js-layout'
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Data Table Card MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {Element} element The element that will be upgraded.
	       */
	    var MaterialDataTable = function MaterialDataTable(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialDataTable'] = MaterialDataTable;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialDataTable.prototype.Constant_ = {};
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialDataTable.prototype.CssClasses_ = {
	        DATA_TABLE: 'mdl-data-table',
	        SELECTABLE: 'mdl-data-table--selectable',
	        SELECT_ELEMENT: 'mdl-data-table__select',
	        IS_SELECTED: 'is-selected',
	        IS_UPGRADED: 'is-upgraded'
	    };
	    /**
	       * Generates and returns a function that toggles the selection state of a
	       * single row (or multiple rows).
	       *
	       * @param {Element} checkbox Checkbox that toggles the selection state.
	       * @param {Element} row Row to toggle when checkbox changes.
	       * @param {(Array<Object>|NodeList)=} opt_rows Rows to toggle when checkbox changes.
	       * @private
	       */
	    MaterialDataTable.prototype.selectRow_ = function (checkbox, row, opt_rows) {
	        if (row) {
	            return function () {
	                if (checkbox.checked) {
	                    row.classList.add(this.CssClasses_.IS_SELECTED);
	                } else {
	                    row.classList.remove(this.CssClasses_.IS_SELECTED);
	                }
	            }.bind(this);
	        }
	        if (opt_rows) {
	            return function () {
	                var i;
	                var el;
	                if (checkbox.checked) {
	                    for (i = 0; i < opt_rows.length; i++) {
	                        el = opt_rows[i].querySelector('td').querySelector('.mdl-checkbox');
	                        el['MaterialCheckbox'].check();
	                        opt_rows[i].classList.add(this.CssClasses_.IS_SELECTED);
	                    }
	                } else {
	                    for (i = 0; i < opt_rows.length; i++) {
	                        el = opt_rows[i].querySelector('td').querySelector('.mdl-checkbox');
	                        el['MaterialCheckbox'].uncheck();
	                        opt_rows[i].classList.remove(this.CssClasses_.IS_SELECTED);
	                    }
	                }
	            }.bind(this);
	        }
	    };
	    /**
	       * Creates a checkbox for a single or or multiple rows and hooks up the
	       * event handling.
	       *
	       * @param {Element} row Row to toggle when checkbox changes.
	       * @param {(Array<Object>|NodeList)=} opt_rows Rows to toggle when checkbox changes.
	       * @private
	       */
	    MaterialDataTable.prototype.createCheckbox_ = function (row, opt_rows) {
	        var label = document.createElement('label');
	        var labelClasses = ['mdl-checkbox', 'mdl-js-checkbox', 'mdl-js-ripple-effect', this.CssClasses_.SELECT_ELEMENT];
	        label.className = labelClasses.join(' ');
	        var checkbox = document.createElement('input');
	        checkbox.type = 'checkbox';
	        checkbox.classList.add('mdl-checkbox__input');
	        if (row) {
	            checkbox.checked = row.classList.contains(this.CssClasses_.IS_SELECTED);
	            checkbox.addEventListener('change', this.selectRow_(checkbox, row));
	        } else if (opt_rows) {
	            checkbox.addEventListener('change', this.selectRow_(checkbox, null, opt_rows));
	        }
	        label.appendChild(checkbox);
	        componentHandler.upgradeElement(label, 'MaterialCheckbox');
	        return label;
	    };
	    /**
	       * Initialize element.
	       */
	    MaterialDataTable.prototype.init = function () {
	        if (this.element_) {
	            var firstHeader = this.element_.querySelector('th');
	            var bodyRows = Array.prototype.slice.call(this.element_.querySelectorAll('tbody tr'));
	            var footRows = Array.prototype.slice.call(this.element_.querySelectorAll('tfoot tr'));
	            var rows = bodyRows.concat(footRows);
	            if (this.element_.classList.contains(this.CssClasses_.SELECTABLE)) {
	                var th = document.createElement('th');
	                var headerCheckbox = this.createCheckbox_(null, rows);
	                th.appendChild(headerCheckbox);
	                firstHeader.parentElement.insertBefore(th, firstHeader);
	                for (var i = 0; i < rows.length; i++) {
	                    var firstCell = rows[i].querySelector('td');
	                    if (firstCell) {
	                        var td = document.createElement('td');
	                        if (rows[i].parentNode.nodeName.toUpperCase() === 'TBODY') {
	                            var rowCheckbox = this.createCheckbox_(rows[i]);
	                            td.appendChild(rowCheckbox);
	                        }
	                        rows[i].insertBefore(td, firstCell);
	                    }
	                }
	                this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	            }
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialDataTable,
	        classAsString: 'MaterialDataTable',
	        cssClass: 'mdl-js-data-table'
	    });
	    /**
	     * @license
	     * Copyright 2015 Google Inc. All Rights Reserved.
	     *
	     * Licensed under the Apache License, Version 2.0 (the "License");
	     * you may not use this file except in compliance with the License.
	     * You may obtain a copy of the License at
	     *
	     *      http://www.apache.org/licenses/LICENSE-2.0
	     *
	     * Unless required by applicable law or agreed to in writing, software
	     * distributed under the License is distributed on an "AS IS" BASIS,
	     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	     * See the License for the specific language governing permissions and
	     * limitations under the License.
	     */
	    /**
	       * Class constructor for Ripple MDL component.
	       * Implements MDL component design pattern defined at:
	       * https://github.com/jasonmayes/mdl-component-design-pattern
	       *
	       * @constructor
	       * @param {HTMLElement} element The element that will be upgraded.
	       */
	    var MaterialRipple = function MaterialRipple(element) {
	        this.element_ = element;
	        // Initialize instance.
	        this.init();
	    };
	    window['MaterialRipple'] = MaterialRipple;
	    /**
	       * Store constants in one place so they can be updated easily.
	       *
	       * @enum {string | number}
	       * @private
	       */
	    MaterialRipple.prototype.Constant_ = {
	        INITIAL_SCALE: 'scale(0.0001, 0.0001)',
	        INITIAL_SIZE: '1px',
	        INITIAL_OPACITY: '0.4',
	        FINAL_OPACITY: '0',
	        FINAL_SCALE: ''
	    };
	    /**
	       * Store strings for class names defined by this component that are used in
	       * JavaScript. This allows us to simply change it in one place should we
	       * decide to modify at a later date.
	       *
	       * @enum {string}
	       * @private
	       */
	    MaterialRipple.prototype.CssClasses_ = {
	        RIPPLE_CENTER: 'mdl-ripple--center',
	        RIPPLE_EFFECT_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	        RIPPLE: 'mdl-ripple',
	        IS_ANIMATING: 'is-animating',
	        IS_VISIBLE: 'is-visible'
	    };
	    /**
	       * Handle mouse / finger down on element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialRipple.prototype.downHandler_ = function (event) {
	        if (!this.rippleElement_.style.width && !this.rippleElement_.style.height) {
	            var rect = this.element_.getBoundingClientRect();
	            this.boundHeight = rect.height;
	            this.boundWidth = rect.width;
	            this.rippleSize_ = Math.sqrt(rect.width * rect.width + rect.height * rect.height) * 2 + 2;
	            this.rippleElement_.style.width = this.rippleSize_ + 'px';
	            this.rippleElement_.style.height = this.rippleSize_ + 'px';
	        }
	        this.rippleElement_.classList.add(this.CssClasses_.IS_VISIBLE);
	        if (event.type === 'mousedown' && this.ignoringMouseDown_) {
	            this.ignoringMouseDown_ = false;
	        } else {
	            if (event.type === 'touchstart') {
	                this.ignoringMouseDown_ = true;
	            }
	            var frameCount = this.getFrameCount();
	            if (frameCount > 0) {
	                return;
	            }
	            this.setFrameCount(1);
	            var bound = event.currentTarget.getBoundingClientRect();
	            var x;
	            var y;
	            // Check if we are handling a keyboard click.
	            if (event.clientX === 0 && event.clientY === 0) {
	                x = Math.round(bound.width / 2);
	                y = Math.round(bound.height / 2);
	            } else {
	                var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	                var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	                x = Math.round(clientX - bound.left);
	                y = Math.round(clientY - bound.top);
	            }
	            this.setRippleXY(x, y);
	            this.setRippleStyles(true);
	            window.requestAnimationFrame(this.animFrameHandler.bind(this));
	        }
	    };
	    /**
	       * Handle mouse / finger up on element.
	       *
	       * @param {Event} event The event that fired.
	       * @private
	       */
	    MaterialRipple.prototype.upHandler_ = function (event) {
	        // Don't fire for the artificial "mouseup" generated by a double-click.
	        if (event && event.detail !== 2) {
	            // Allow a repaint to occur before removing this class, so the animation
	            // shows for tap events, which seem to trigger a mouseup too soon after
	            // mousedown.
	            window.setTimeout(function () {
	                this.rippleElement_.classList.remove(this.CssClasses_.IS_VISIBLE);
	            }.bind(this), 0);
	        }
	    };
	    /**
	       * Initialize element.
	       */
	    MaterialRipple.prototype.init = function () {
	        if (this.element_) {
	            var recentering = this.element_.classList.contains(this.CssClasses_.RIPPLE_CENTER);
	            if (!this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT_IGNORE_EVENTS)) {
	                this.rippleElement_ = this.element_.querySelector('.' + this.CssClasses_.RIPPLE);
	                this.frameCount_ = 0;
	                this.rippleSize_ = 0;
	                this.x_ = 0;
	                this.y_ = 0;
	                // Touch start produces a compat mouse down event, which would cause a
	                // second ripples. To avoid that, we use this property to ignore the first
	                // mouse down after a touch start.
	                this.ignoringMouseDown_ = false;
	                this.boundDownHandler = this.downHandler_.bind(this);
	                this.element_.addEventListener('mousedown', this.boundDownHandler);
	                this.element_.addEventListener('touchstart', this.boundDownHandler);
	                this.boundUpHandler = this.upHandler_.bind(this);
	                this.element_.addEventListener('mouseup', this.boundUpHandler);
	                this.element_.addEventListener('mouseleave', this.boundUpHandler);
	                this.element_.addEventListener('touchend', this.boundUpHandler);
	                this.element_.addEventListener('blur', this.boundUpHandler);
	                /**
	                * Getter for frameCount_.
	                * @return {number} the frame count.
	                */
	                this.getFrameCount = function () {
	                    return this.frameCount_;
	                };
	                /**
	                * Setter for frameCount_.
	                * @param {number} fC the frame count.
	                */
	                this.setFrameCount = function (fC) {
	                    this.frameCount_ = fC;
	                };
	                /**
	                * Getter for rippleElement_.
	                * @return {Element} the ripple element.
	                */
	                this.getRippleElement = function () {
	                    return this.rippleElement_;
	                };
	                /**
	                * Sets the ripple X and Y coordinates.
	                * @param  {number} newX the new X coordinate
	                * @param  {number} newY the new Y coordinate
	                */
	                this.setRippleXY = function (newX, newY) {
	                    this.x_ = newX;
	                    this.y_ = newY;
	                };
	                /**
	                * Sets the ripple styles.
	                * @param  {boolean} start whether or not this is the start frame.
	                */
	                this.setRippleStyles = function (start) {
	                    if (this.rippleElement_ !== null) {
	                        var transformString;
	                        var scale;
	                        var size;
	                        var offset = 'translate(' + this.x_ + 'px, ' + this.y_ + 'px)';
	                        if (start) {
	                            scale = this.Constant_.INITIAL_SCALE;
	                            size = this.Constant_.INITIAL_SIZE;
	                        } else {
	                            scale = this.Constant_.FINAL_SCALE;
	                            size = this.rippleSize_ + 'px';
	                            if (recentering) {
	                                offset = 'translate(' + this.boundWidth / 2 + 'px, ' + this.boundHeight / 2 + 'px)';
	                            }
	                        }
	                        transformString = 'translate(-50%, -50%) ' + offset + scale;
	                        this.rippleElement_.style.webkitTransform = transformString;
	                        this.rippleElement_.style.msTransform = transformString;
	                        this.rippleElement_.style.transform = transformString;
	                        if (start) {
	                            this.rippleElement_.classList.remove(this.CssClasses_.IS_ANIMATING);
	                        } else {
	                            this.rippleElement_.classList.add(this.CssClasses_.IS_ANIMATING);
	                        }
	                    }
	                };
	                /**
	                * Handles an animation frame.
	                */
	                this.animFrameHandler = function () {
	                    if (this.frameCount_-- > 0) {
	                        window.requestAnimationFrame(this.animFrameHandler.bind(this));
	                    } else {
	                        this.setRippleStyles(false);
	                    }
	                };
	            }
	        }
	    };
	    // The component registers itself. It can assume componentHandler is available
	    // in the global scope.
	    componentHandler.register({
	        constructor: MaterialRipple,
	        classAsString: 'MaterialRipple',
	        cssClass: 'mdl-js-ripple-effect',
	        widget: false
	    });
	})();

/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"mdl-layout environment mdl-js-layout {{ vm.environment }} \" id=\"mdl-layout\">\r\n  <header class=\"mdl-layout__header\">\r\n    <div class=\"mdl-layout-icon\"></div>\r\n    <div class=\"mdl-layout__header-row\">\r\n      <span class=\"mdl-layout__title\" title=\"Code Focus\">Code Focus <span ng-bind=\"'- ' + vm.environment\"></span></span>\r\n      <div class=\"mdl-layout-spacer\"></div>\r\n      <nav class=\"mdl-navigation\">\r\n        <span class=\"loggedIn\" ng-if=\"!isLogoutPage()\">You are logged in as <strong ng-bind=\"vm.user.name\" id=\"loggedInUser\"></strong></span>\r\n        <!-- Right aligned menu below button -->\r\n        <button id=\"menu-upper-right\" class=\"mdl-button mdl-js-button mdl-button--icon\">\r\n          <i class=\"material-icons\">more_vert</i>\r\n        </button>\r\n        <ul class=\"mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect\" for=\"menu-upper-right\" ng-show=\"vm.appMenuFunctions.length\">\r\n          <a ng-repeat=\"menuItem in vm.appMenuFunctions\"\r\n            ng-show=\"menuItem.isActive\"\r\n            href=\"/{{menuItem.routePath}}\" id=\"rm-{{menuItem.name.replace(' ', '')}}\"\r\n            ng-click=\"navItemClick(menuItem.routePath, false)\"><li class=\"mdl-menu__item\">{{menuItem.name}}</li></a>\r\n        </ul>\r\n      </nav>\r\n    </div>\r\n  </header>\r\n  <div class=\"mdl-layout__drawer\">\r\n    <span class=\"mdl-layout__title\">Code Focus</span>\r\n    <nav class=\"mdl-navigation\" ng-show=\"vm.appMenuFunctions.length\">\r\n      <a ng-repeat=\"menuItem in vm.appMenuFunctions\"\r\n        ng-show=\"menuItem.isActive\"\r\n        href=\"/{{menuItem.routePath}}\" id=\"lm-{{menuItem.name.replace(' ', '')}}\"\r\n        ng-click=\"navItemClick(menuItem.routePath, true)\"\r\n        class=\"mdl-navigation__link\">{{menuItem.name}}</a>\r\n    </nav>\r\n  </div>\r\n  <main class=\"mdl-layout__content\">\r\n    <div ng-if=\"vm.appFunctions.length || isLoginPage()\" ui-view></div>\r\n  </main>\r\n</div>\r\n"

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\" id=\"drgs\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"9\">\r\n      <h1>{{ vm.name }} - {{ vm.DRG.selectedDRG.DRGCode + \": \" + vm.DRG.selectedDRG.label + \" (\" + vm.WIESVER.selectedWIESVER.wiesVersion + \")\" }}</h1>\r\n    </div>\r\n  </div>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"4\">\r\n        <lx-select ng-model=\"vm.WIESVER.selectedWIESVER\" lx-choices=\"vm.WIESVEROptions\" lx-label=\"{{ vm.episodeValue }} Version\" lx-multiple=\"false\" ng-change=\"vm.WIESVERCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected.wiesVersion }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.wiesVersion }}</lx-select-choices>\r\n        </lx-select>\r\n        <lx-select class=\"drg-input\" ng-model=\"vm.DRG.selectedDRG\" lx-display-filter=\"true\" lx-choices=\"vm.DRGOptions\" lx-label=\"DRG\" lx-multiple=\"false\" ng-change=\"vm.DRGCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected.DRGCode + \": \" + $selected.label }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.DRGCode + \": \" + $choice.label }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-choices=\"vm.specialty.specialtyOptions\" lx-label=\"{{ vm.specialtyString }} Targets\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected.description }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.description }}</lx-select-choices>\r\n        </lx-select>\r\n        <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" class=\"drgForm\" novalidate autocomplete=\"off\">\r\n          <formly-form model=\"vm.model\" fields=\"vm.fields\" options=\"vm.options\" form=\"vm.form\">\r\n          </formly-form>\r\n        </form>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <br />\r\n        <lx-button type=\"button\" lx-color=\"green\" ng-disabled=\"vm.checkValid()\" ng-click=\"vm.submitDRG()\">UPDATE DRG</lx-button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"p+\" flex-container=\"row\" flex-column=\"12\">\r\n  <div flex-item=\"12\">\r\n    <div id=\"specialty__notification\" class=\"mdl-js-snackbar mdl-snackbar specialty__notification\">\r\n      <div class=\"mdl-snackbar__text\"></div>\r\n      <button class=\"mdl-snackbar__action\" type=\"button\"></button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<lx-dialog id=\"doubleCheck\">\r\n  <lx-dialog-header>\r\n    <div class=\"toolbar bgc-primary pl++\">\r\n      <span class=\"toolbar__label tc-white fs-title\">\r\n        Are you sure?\r\n      </span>\r\n    </div>\r\n  </lx-dialog-header>\r\n  <lx-dialog-footer>\r\n    <lx-button type=\"button\" lx-color=\"orange\" lx-dialog-close>CANCEL</lx-button>\r\n    <lx-button type=\"button\" lx-color=\"green\" ng-click=\"vm.disableUser(vm.coder.selectedCoder.id)\" lx-dialog-close>DISABLE</lx-button>\r\n  </lx-dialog-footer>\r\n</lx-dialog>\r\n"

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"mdl-grid mdl-grid-height100\">\r\n    <div class=\"mdl-cell mdl-cell--12-col\">\r\n        <div class=\"card material-table\">\r\n            <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n                <div flex-item=\"9\">\r\n                    <h1>{{ vm.name }}</h1>\r\n                </div>\r\n            </div>\r\n            <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n            </table>\r\n            <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n        </div>\r\n        <div class=\"reports__filters p++ pt0\">\r\n            <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n                <div flex-item=\"9\">\r\n                    <lx-text-field lx-label=\"Enter Episode Numbers - comma separated\">\r\n                        <textarea ng-model=\"vm.searchFilter\"></textarea>\r\n                    </lx-text-field>\r\n                </div>\r\n                <div flex-item=\"3\">\r\n                    <lx-select ng-model=\"vm.status.selectedStatus\" lx-choices=\"vm.statusOptions\" lx-label=\"New Episode Status\" ng-change=\"vm.openDialog(newValue, oldValue)\">\r\n                        <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n                        <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n                    </lx-select>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"p++\" flex-container=\"row\" flex-column=\"12\">\r\n    <div flex-item=\"12\">\r\n        <div id=\"audit__notification\" class=\"mdl-js-snackbar mdl-snackbar audit__notification\">\r\n            <div class=\"mdl-snackbar__text\"></div>\r\n            <button class=\"mdl-snackbar__action\" type=\"button\"></button>\r\n        </div>\r\n    </div>\r\n</div>\r\n<lx-dialog id=\"doubleCheck\">\r\n    <lx-dialog-header>\r\n        <div class=\"toolbar bgc-primary pl++\">\r\n            <span class=\"toolbar__label tc-white fs-title\">\r\n              Are you sure?\r\n          </span>\r\n        </div>\r\n    </lx-dialog-header>\r\n    <lx-dialog-footer>\r\n        <lx-button type=\"button\" lx-color=\"orange\" ng-click=\"vm.resetSelectors()\" lx-dialog-close>CANCEL</lx-button>\r\n        <lx-button type=\"button\" lx-color=\"green\" ng-click=\"vm.setStatus()\" lx-dialog-close>UPDATE</lx-button>\r\n    </lx-dialog-footer>\r\n</lx-dialog>\r\n"

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\" id=\"wies\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"9\">\r\n      <h1>{{ vm.name }} for {{ vm.year.selectedYear }}</h1>\r\n    </div>\r\n  </div>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.year.selectedYear\" lx-choices=\"vm.yearOptions\" lx-label=\"Financial Years\" lx-multiple=\"false\" ng-change=\"vm.wiesCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n        <button ng-disabled=\"vm.yearValid()\" ng-click=\"vm.addWies()\" class=\"mdl-button mdl-js-button mdl-button--icon mdl-button--colored\">\r\n          <i class=\"material-icons\">alarm_add</i>\r\n        </button>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" class=\"drgForm\" novalidate autocomplete=\"off\">\r\n          <formly-form model=\"vm.model\" fields=\"vm.fields\" options=\"vm.options\" form=\"vm.form\">\r\n          </formly-form>\r\n        </form>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <br />\r\n        <lx-button type=\"button\" lx-color=\"green\" ng-disabled=\"vm.checkValid()\" ng-click=\"vm.submitWies()\">UPDATE {{ vm.episodeValue }}</lx-button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"p+\" flex-container=\"row\" flex-column=\"12\">\r\n  <div flex-item=\"12\">\r\n    <div id=\"wies__notification\" class=\"mdl-js-snackbar mdl-snackbar wies__notification\">\r\n      <div class=\"mdl-snackbar__text\"></div>\r\n      <button class=\"mdl-snackbar__action\" type=\"button\"></button>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\" id=\"specialties\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"9\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" class=\"drgForm\" novalidate autocomplete=\"off\">\r\n          <formly-form model=\"vm.model\" fields=\"vm.fields\" options=\"vm.options\" form=\"vm.form\">\r\n          </formly-form>\r\n        </form>\r\n        <br>\r\n        <div class=\"build-number\">Build Number: {{vm.buildNumber}}</div>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <br />\r\n        <lx-button type=\"button\" lx-color=\"green\" ng-disabled=\"vm.checkValid()\" ng-click=\"vm.putData()\">UPDATE SITE</lx-button>\r\n        <br>\r\n        <br>\r\n        <div ng-if=\"vm.functionSettings && vm.functionSettings.AdminSiteHl7Download && vm.functionSettings.AdminSiteHl7Download.isActive\">\r\n          <span>Download HL7 zip</span>\r\n          <span>\r\n            <lx-button type=\"button\" lx-type=\"icon\" lx-color=\"blue\" lx-size=\"l\" ng-click=\"vm.viewTemplate(39)\">\r\n              <i class=\"mdi mdi-file\"></i>\r\n            </lx-button>\r\n          </span>\r\n          <span><div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" ng-class=\"{'hidden': vm.hl7NotLoading}\"></div></span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"p+\" flex-container=\"row\" flex-column=\"12\">\r\n  <div flex-item=\"12\">\r\n    <div id=\"site__notification\" class=\"mdl-js-snackbar mdl-snackbar specialty__notification\">\r\n      <div class=\"mdl-snackbar__text\"></div>\r\n      <button class=\"mdl-snackbar__action\" type=\"button\"></button>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\" id=\"specialties\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"9\">\r\n      <h1>{{ vm.specialtyString }} - {{ vm.coder.selectedCoder.description }}</h1>\r\n    </div>\r\n  </div>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.coder.selectedCoder\" lx-display-filter=\"true\" lx-choices=\"vm.coderOptions\"\r\n                   lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"false\"\r\n                   ng-change=\"vm.coderCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected.description }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.description }}</lx-select-choices>\r\n        </lx-select>\r\n        <button ng-click=\"vm.addSpecialty()\" class=\"mdl-button mdl-js-button mdl-button--icon mdl-button--colored\">\r\n          <i class=\"material-icons\">playlist_add</i>\r\n        </button>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" class=\"drgForm\" novalidate autocomplete=\"off\">\r\n          <formly-form model=\"vm.model\" fields=\"vm.fields\" options=\"vm.options\" form=\"vm.form\">\r\n          </formly-form>\r\n        </form>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <br/>\r\n        <lx-button type=\"button\" lx-color=\"green\" ng-disabled=\"vm.isButtonDisabled()\" ng-click=\"vm.submitSpecialty()\">\r\n          {{ vm.coder.selectedCoder.refCodeId ? 'UPDATE' : 'ADD' }}\r\n          <span class=\"uppercase\">{{ vm.specialtyString }}</span></lx-button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"p+\" flex-container=\"row\" flex-column=\"12\">\r\n  <div flex-item=\"12\">\r\n    <div id=\"specialty__notification\" class=\"mdl-js-snackbar mdl-snackbar specialty__notification\">\r\n      <div class=\"mdl-snackbar__text\"></div>\r\n      <button class=\"mdl-snackbar__action\" type=\"button\"></button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<lx-dialog id=\"doubleCheck\">\r\n  <lx-dialog-header>\r\n    <div class=\"toolbar bgc-primary pl++\">\r\n      <span class=\"toolbar__label tc-white fs-title\">\r\n        Are you sure?\r\n      </span>\r\n    </div>\r\n  </lx-dialog-header>\r\n  <lx-dialog-footer>\r\n    <lx-button type=\"button\" lx-color=\"orange\" lx-dialog-close>CANCEL</lx-button>\r\n    <lx-button type=\"button\" lx-color=\"green\" ng-click=\"vm.disableUser(vm.coder.selectedCoder.id)\" lx-dialog-close>\r\n      DISABLE\r\n    </lx-button>\r\n  </lx-dialog-footer>\r\n</lx-dialog>\r\n"

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\" id=\"users\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"9\">\r\n      <h1>{{ vm.name }}{{ vm.coder.selectedCoder.firstname ? ' - ' : '' }}<span ng-bind=\"vm.coder.selectedCoder.firstname + ' ' + vm.coder.selectedCoder.lastname\"></h1>\r\n    </div>\r\n  </div>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.coder.selectedCoder\" lx-display-filter=\"true\" lx-choices=\"vm.coderOptions\" lx-label=\"Existing Users\" lx-multiple=\"false\" ng-change=\"vm.coderCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected.firstname + \" \" + $selected.lastname }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.firstname + \" \" + $choice.lastname }}</lx-select-choices>\r\n        </lx-select>\r\n        <button ng-click=\"vm.addUser()\" class=\"mdl-button mdl-js-button mdl-button--icon mdl-button--colored\">\r\n          <i class=\"material-icons\">person_add</i>\r\n        </button>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <form ng-submit=\"vm.onSubmit()\" name=\"vm.form\" class=\"drgForm\" novalidate autocomplete=\"off\">\r\n          <formly-form model=\"vm.model\" fields=\"vm.fields\" options=\"vm.options\" form=\"vm.form\">\r\n          </formly-form>\r\n        </form>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-choices=\"vm.specialty.specialtyOptions\" lx-label=\"{{ vm.specialtyString }} Defaults\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-choices=\"vm.campus.campusOptions\" lx-label=\"Campus Defaults\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n        <lx-select ng-model=\"vm.roles.selectedRole\" lx-choices=\"vm.roles.rolesOptions\" lx-label=\"User Role\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n        <lx-select ng-if=\"vm.worklistsFunc.isActive\" ng-model=\"vm.worklist.selectedWorklist\" lx-choices=\"vm.worklist.worklistOptions\" lx-label=\"{{vm.worklistsFunc.label}}\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n        <br />\r\n        <div ng-if=\"vm.functionSettings.CodingOperationsTeamSwitch && vm.functionSettings.CodingOperationsTeamSwitch.isActive\" class=\"checkbox ng-scope\">\r\n          <input ng-model=\"vm.model.codingOperationsTeam\" type=\"checkbox\" role=\"checkbox\"\r\n            class=\"checkbox__input ng-pristine ng-untouched ng-valid ng-empty\" id=\"formly_2_lx-checkbox_codingOperationsTeam\"\r\n            name=\"formly_2_lx-checkbox_codingOperationsTeam\" aria-invalid=\"false\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n          <label for=\"formly_2_lx-checkbox_codingOperationsTeam\" class=\"checkbox__label ng-binding\" aria-label=\"Coding Operations Team\">Coding Operations Team</label>\r\n        </div>\r\n        <br />\r\n        <lx-button type=\"button\" lx-color=\"green\" ng-disabled=\"vm.checkValid()\" ng-click=\"vm.submitUser()\">UPDATE USER</lx-button>\r\n        <lx-button type=\"button\" lx-color=\"red\" ng-click=\"vm.openDialog()\">DISABLE USER</lx-button>\r\n\r\n        <div ng-if=\"vm.userScheduleDays && vm.userScheduleDays.length > 0\">\r\n          <br />\r\n          <br />\r\n          <br />\r\n          <h4>Default hours</h4>\r\n          <br />\r\n          <table class=\"table-defhrs__mtd mdl-data-table\">\r\n            <thead>\r\n              <tr>\r\n                <th ng-repeat=\"userScheduleDay in vm.userScheduleDays\" ng-bind=\"userScheduleDay.code\"></th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr>\r\n                <td ng-repeat=\"userScheduleItem in vm.coder.selectedCoder.userSchedule\">\r\n                  <lx-text-field>\r\n                    <input type=\"number\" ng-model=\"userScheduleItem.hoursNumber\" class=\"text-defhrslx__mtd\" ng-change=\"vm.userScheduleCallback(userScheduleItem.hoursNumber, {{userScheduleItem.hoursNumber}})\">\r\n                  </lx-text-field>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"p+\" flex-container=\"row\" flex-column=\"12\">\r\n  <div flex-item=\"12\">\r\n    <div id=\"users__notification\" class=\"mdl-js-snackbar mdl-snackbar users__notification\">\r\n      <div class=\"mdl-snackbar__text\"></div>\r\n      <button class=\"mdl-snackbar__action\" type=\"button\"></button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<lx-dialog id=\"doubleCheck\">\r\n  <lx-dialog-header>\r\n    <div class=\"toolbar bgc-primary pl++\">\r\n      <span class=\"toolbar__label tc-white fs-title\">\r\n        Are you sure?\r\n      </span>\r\n    </div>\r\n  </lx-dialog-header>\r\n  <lx-dialog-footer>\r\n    <lx-button type=\"button\" lx-color=\"orange\" lx-dialog-close>CANCEL</lx-button>\r\n    <lx-button type=\"button\" lx-color=\"green\" ng-click=\"vm.disableUser(vm.coder.selectedCoder.id)\" lx-dialog-close>DISABLE</lx-button>\r\n  </lx-dialog-footer>\r\n</lx-dialog>\r\n"

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('atsi', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('atsi', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.atsi.selectedAtsi\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.atsiOptions\" lx-label=\"ATSI Status\" lx-multiple=\"true\" ng-change=\"vm.atsiCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.atsiCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"8\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n    <div flex-item=\"4\">\r\n      <aside class=\"reports__stats\">\r\n        <span class=\"total-figures\" id=\"total-proj-wies\"></span>\r\n        <span class=\"total-figures\" id=\"total-queries\"></span>\r\n      </aside>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.specialty.selectedSpecialty\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.specialtyOptions\"\r\n          lx-label=\"{{ vm.specialtyString }}\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('auditType', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('auditType', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.auditType.selectedAuditType\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.auditTypeOptions\"\r\n          lx-label=\"Audit Type\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('changeType', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('changeType', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.changeType.selectedChangeType\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.changeTypeOptions\"\r\n          lx-label=\"Type of Change\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"startDatePicker\"\r\n          ng-model=\"vm.startDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.startDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"endDatePicker\"\r\n          ng-model=\"vm.endDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.endDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('errorCategory', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('errorCategory', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-if=\"vm.errorCategoryOptions.length\"\r\n          ng-model=\"vm.errorCategory.selectedErrorCategory\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.errorCategoryOptions\"\r\n          lx-label=\"Error Category\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('queryModifiedBy', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('queryModifiedBy', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.queryModifiedBy.selectedQueryModifiedBy\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.coderOptions\"\r\n          lx-label=\"Update Name\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('coder', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('coder', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.coder.selectedCoder\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.coderOptions\"\r\n          lx-label=\"Original Coder\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select\r\n          ng-model=\"vm.queryType.selectedQueryType\"\r\n          lx-choices=\"vm.queryTypeOptions\"\r\n          lx-label=\"Query Type\"\r\n          lx-display-filter=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n          lx-allow-clear=\"true\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('auditRule', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('auditRule', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.auditRule.selectedAuditRule\"\r\n          lx-choices=\"vm.auditRuleOptions\"\r\n          lx-label=\"Audit Rule\"\r\n          lx-display-filter=\"true\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('status', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('status', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.status.selectedStatus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.statusOptions\"\r\n          lx-label=\"Status\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div\r\n        flex-item=\"3\"\r\n        ng-if=\"vm.functionSettings.WiesChangeWithoutDRGChangeFilter && vm.functionSettings.WiesChangeWithoutDRGChangeFilter.isActive\"\r\n      >\r\n        <lx-select\r\n          ng-model=\"vm.wiesOnly.selectedWiesOnly\"\r\n          lx-choices=\"vm.wiesOnlyOptions\"\r\n          lx-label=\"{{vm.episodeValue}} Only\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n          lx-allow-clear=\"true\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"startDatePicker\"\r\n          ng-model=\"vm.startDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.startDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"endDatePicker\"\r\n          ng-model=\"vm.endDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.endDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('auditType', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('auditType', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.auditType.selectedAuditType\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.auditTypeOptions\"\r\n          lx-label=\"Audit Type\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.filterCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n        <div flex-item=\"6\">\r\n            <h1>{{ vm.name }}</h1>\r\n        </div>\r\n        <div flex-item=\"2\">\r\n            <aside class=\"reports__stats\">\r\n                <h6>Total Users: {{ vm.TUsers }}</h6>\r\n                <h6>Total Open: {{ vm.TOpenForAudit }}</h6>\r\n            </aside>\r\n        </div>\r\n        <div flex-item=\"2\">\r\n            <aside class=\"reports__stats\">\r\n                <h6>Total Ready: {{ vm.TApproved }}</h6>\r\n                <h6>Total Finalised: {{ vm.TFinalised }}</h6>\r\n            </aside>\r\n        </div>\r\n        <div flex-item=\"2\">\r\n            <aside class=\"reports__stats\">\r\n                <h6>Total Audited: {{ vm.TAudited }}</h6>\r\n                <h6>Total {{ vm.episodeValue }} Change: {{ vm.TWIESChange }}</h6>\r\n            </aside>\r\n        </div>\r\n    </div>\r\n    <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n    </table>\r\n    <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n    <div class=\"reports__filters p+++\">\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"6\">\r\n                <div class=\"filter__swap\">\r\n                    <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterCareType('minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n                    <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterCareType('add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n                </div>\r\n                <lx-select ng-model=\"vm.careType.selectedCareType\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.careTypeOptions\" lx-label=\"Care Type\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n                    <lx-select-selected>{{ $selected.description }}</lx-select-selected>\r\n                    <lx-select-choices>{{ $choice.description }}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n            <div flex-item=\"6\">\r\n                <div class=\"filter__swap\">\r\n                    <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n                    <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n                </div>\r\n                <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n                    <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n                    <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n        </div>\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"6\">\r\n                <div class=\"filter__swap\">\r\n                    <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('los', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n                    <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('los', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n                </div>\r\n                <lx-select ng-model=\"vm.los.selectedLos\" lx-allow-clear=\"true\" lx-choices=\"vm.losOptions\" lx-label=\"Length of Stay\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n                    <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n                    <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n            <div flex-item=\"3\">\r\n                <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n                    <lx-text-field lx-label=\"Start Coded Date\">\r\n                        <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n                    </lx-text-field>\r\n                </lx-date-picker>\r\n            </div>\r\n            <div flex-item=\"3\">\r\n                <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n                    <lx-text-field lx-label=\"End Coded Date\">\r\n                        <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n                    </lx-text-field>\r\n                </lx-date-picker>\r\n            </div>\r\n        </div>\r\n      <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n        <div flex-item=\"6\">\r\n          <div class=\"filter__swap\">\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n          </div>\r\n          <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n            <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n            <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n          </lx-select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"6\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n    <div flex-item=\"6\">\r\n      <aside class=\"reports__stats\">\r\n        <h6 id=\"total-wies-change\"></h6>\r\n        <h6 id=\"total-specialty\"></h6>\r\n        <h6 id=\"total-querySpecialty\"></h6>\r\n      </aside>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.specialty.selectedSpecialty\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.specialtyOptions\"\r\n          lx-label=\"{{ vm.specialtyString }}\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.specialtyCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('querySpecialty', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('querySpecialty', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.querySpecialty.selectedQuerySpecialty\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.specialtyOptions\"\r\n          lx-label=\"Query {{ vm.specialtyString }}\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.specialtyCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('auditType', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('auditType', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.auditType.selectedAuditType\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.auditTypeOptions\"\r\n          lx-label=\"Audit Type\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.changeData()\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('queryStatus', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('queryStatus', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.queryStatus.selectedQueryStatus\"\r\n          lx-display-filter=\"false\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.queryStatusOptions\"\r\n          lx-label=\"Query Status\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.changeData()\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"startDatePicker\"\r\n          ng-model=\"vm.startDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Updated on or After\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.startDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"endDatePicker\"\r\n          ng-model=\"vm.endDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Updated on or Before\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.endDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div\r\n        flex-item=\"6\"\r\n        ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                            || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\"\r\n      >\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.changeData()\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name + ' ' + vm.dateRange }}</h1>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCaretype('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCaretype('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.caretype.selectedCaretype\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.caretypeOptions\"\r\n          lx-label=\"Care Type\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected.description }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.description }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.specialty.selectedSpecialty\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.specialtyOptions\"\r\n          lx-label=\"{{ vm.specialtyString }}\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterPatientClass('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterPatientClass('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.patientClass.selectedPatientClass\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.patientClassOptions\"\r\n          lx-label=\"Patient Classification\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCampus('minus')\"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCampus('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-select\r\n          ng-model=\"vm.year.yearTypeSelected\"\r\n          lx-choices=\"vm.yearTypeOptions\"\r\n          lx-label=\"Reporting Year\"\r\n          ng-change=\"vm.setYearType(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select\r\n          ng-model=\"vm.year.selectedFy\"\r\n          lx-choices=\"vm.yearOptions\"\r\n          lx-label=\"Year\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"8\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n    <div flex-item=\"4\">\r\n      <aside class=\"reports__stats\">\r\n        <h6><span id=\"total-proj-wies\" ng-show=\"!vm.western\"></span></h6>\r\n        <h6><span id=\"total-queries\"></span></h6>\r\n      </aside>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('querySpecialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('querySpecialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.querySpecialty.selectedQuerySpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"Query {{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"9\">\r\n      <h1>\r\n        {{ vm.name }} {{ vm.coder.selectedCoder ? '-' : '' }} {{\r\n        vm.coder.selectedCoder }}\r\n      </h1>\r\n    </div>\r\n    <!--     <div flex-item=\"3\">\r\n      <aside class=\"reports__stats\">\r\n        <h6>Total Episodes Coded: {{ vm.TEC }}</h6>\r\n        <h6>Total Episodes Audited: {{ vm.TEA }}</h6>\r\n      </aside>\r\n    </div> -->\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <lx-select\r\n          ng-model=\"vm.coder.selectedCoder\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.coderOptions\"\r\n          lx-label=\"Coder\"\r\n          ng-disabled=\"vm.coderDisabled()\"\r\n          lx-multiple=\"false\"\r\n          ng-change=\"vm.coderCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.specialty.selectedSpecialty\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.specialtyOptions\"\r\n          lx-label=\"{{ vm.specialtyString }}\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.coderCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('status', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('status', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.status.selectedStatus\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.statusOptions\"\r\n          lx-label=\"Status\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.coderCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"startDatePicker\"\r\n          ng-model=\"vm.startDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.startDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"endDatePicker\"\r\n          ng-model=\"vm.endDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.endDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div\r\n        flex-item=\"6\"\r\n        ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\"\r\n      >\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.coderCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"10\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n    <div flex-item=\"2\">\r\n      <aside class=\"reports__stats\">\r\n        <h6>Total Users: {{ vm.totalUsers }}</h6>\r\n        <h6>Total Coded: {{ vm.grandTotalCoded }}</h6>\r\n        <h6>Total {{ vm.episodeValue }}: {{ vm.grandTotalWies }}</h6>\r\n      </aside>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCaretype('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCaretype('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.caretype.selectedCaretype\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.caretypeOptions\"\r\n          lx-label=\"Care Type\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected.description }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.description }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('specialty', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.specialty.selectedSpecialty\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.specialtyOptions\"\r\n          lx-label=\"{{ vm.specialtyString }}\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.specialtyCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('los', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('los', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.los.selectedLos\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.losOptions\"\r\n          lx-label=\"Length of Stay\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <lx-select\r\n          lx-label=\"Date Type\"\r\n          ng-model=\"vm.dateType\"\r\n          lx-choices=\"vm.dateTypeOptions\"\r\n          ng-change=\"vm.setDateType(newValue)\"\r\n        >\r\n          <lx-select-selected> {{ $selected.value }} </lx-select-selected>\r\n          <lx-select-choices> {{ $choice.value }} </lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            lx-tooltip=\"Remove date\"\r\n            ng-click=\"vm.filterSwap('startDate', 'minus') \"\r\n            class=\"filter__minus\"\r\n          >\r\n            <i class=\"mdi mdi-minus\"></i\r\n            ></lx-button>\r\n        </div>\r\n        <lx-date-picker\r\n          id=\"startDatePicker\"\r\n          ng-model=\"vm.startDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Date Start\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.startDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            lx-tooltip=\"Remove date\"\r\n            ng-click=\"vm.filterSwap('endDate', 'minus') \"\r\n            class=\"filter__minus\"\r\n          >\r\n            <i class=\"mdi mdi-minus\"></i\r\n            ></lx-button>\r\n        </div>\r\n        <lx-date-picker\r\n          id=\"endDatePicker\"\r\n          ng-model=\"vm.endDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Date End\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.endDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"9\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n    <div flex-item=\"3\">\r\n      <aside class=\"reports__stats\">\r\n        <h6>Total Coded: {{ vm.TAudited }}</h6>\r\n        <h6>Total Reviewed: {{ vm.TFinalised }}</h6>\r\n        <h6>Total Not Reviewed: {{ vm.TApproved }}</h6>\r\n      </aside>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"startDatePicker\"\r\n          ng-model=\"vm.startDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.startDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker\r\n          id=\"endDatePicker\"\r\n          ng-model=\"vm.endDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.endDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.selectCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"8\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstance\"\r\n    class=\"mdl-data-table pageResize\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-select\r\n          lx-label=\"Date Type\"\r\n          ng-model=\"vm.dateType\"\r\n          lx-choices=\"vm.dateTypeOptions\"\r\n          lx-color=\"blue\"\r\n          ng-change=\"vm.setDateType(newValue)\"\r\n        >\r\n          <lx-select-selected> {{ $selected.value }} </lx-select-selected>\r\n          <lx-select-choices> {{ $choice.value }} </lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            lx-tooltip=\"Remove date\"\r\n            ng-click=\"vm.filterSwap('startDate', 'minus') \"\r\n            class=\"filter__minus\"\r\n          >\r\n            <i class=\"mdi mdi-minus\"></i\r\n            ></lx-button>\r\n        </div>\r\n        <lx-date-picker\r\n          id=\"startDate\"\r\n          ng-model=\"vm.startDate.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDate.input.dateFormatted\" />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            lx-tooltip=\"Remove date\"\r\n            ng-click=\"vm.filterSwap('endDate', 'minus') \"\r\n            class=\"filter__minus\"\r\n          >\r\n            <i class=\"mdi mdi-minus\"></i\r\n            ></lx-button>\r\n        </div>\r\n        <lx-date-picker\r\n          id=\"endDate\"\r\n          ng-model=\"vm.endDate.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDate.input.dateFormatted\" />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\"\r\n           ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\"\r\n      >\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('campus', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.setCampus(newValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('careType', 'minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterSwap('careType', 'add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.careType.selectedCareType\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.careTypeOptions\"\r\n          lx-label=\"Care Type\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.setCareType(newValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected.description }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.description }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.campusCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.campusCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.campusCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.campusCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-text-field lx-label=\"DRG\" lx-allow-clear=\"true\">\r\n          <input type=\"text\" ng-model=\"vm.selectedDRG\">\r\n        </lx-text-field>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table auditedmed\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"4\">\r\n        <lx-select\r\n          lx-label=\"Date Type\"\r\n          ng-model=\"vm.dateType\"\r\n          lx-choices=\"vm.dateTypeOptions\"\r\n          lx-color=\"blue\"\r\n          ng-change=\"vm.setDateType(newValue)\"\r\n        >\r\n          <lx-select-selected> {{ $selected.value }} </lx-select-selected>\r\n          <lx-select-choices> {{ $choice.value }} </lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-date-picker\r\n          id=\"startDatePicker\"\r\n          ng-model=\"vm.startDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Date Start\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.startDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-date-picker\r\n          id=\"endDatePicker\"\r\n          ng-model=\"vm.endDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Date End\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.endDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCoder('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCoder('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.coder.selectedCoder\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.coderOptions\"\r\n          lx-label=\"Original Coder\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.setCoder(newValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterDischargeUnit('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterDischargeUnit('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.dischargeUnit.selectedDischargeUnit\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.dischargeUnitOptions\"\r\n          lx-label=\"Unit\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.dischargeUnitCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterEpisodeChangeType('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterEpisodeChangeType('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.episodeChangeType.selectedEpisodeChangeType\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.episodeChangeTypeOptions\"\r\n          lx-label=\"Change Type\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.episodeChangeTypeCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCreatedBy('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCreatedBy('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.createdBy.selectedCreatedBy\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.createdByOptions\"\r\n          lx-label=\"Created By\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.setCreatedBy(newValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-select\r\n          lx-label=\"Episode Active\"\r\n          ng-model=\"vm.episodeActive\"\r\n          lx-choices=\"vm.episodeActiveChoices\"\r\n          lx-color=\"blue\"\r\n          lx-size=\"\"\r\n          ng-change=\"vm.changeData()\"\r\n        >\r\n          <lx-select-selected> {{ $selected }} </lx-select-selected>\r\n          <lx-select-choices> {{ $choice }} </lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-select\r\n          lx-label=\"Episode Change Entry Status\"\r\n          ng-model=\"vm.episodeOpen\"\r\n          lx-choices=\"vm.episodeOpenChoices\"\r\n          lx-color=\"blue\"\r\n          ng-change=\"vm.changeData()\"\r\n        >\r\n          <lx-select-selected> {{ $selected }} </lx-select-selected>\r\n          <lx-select-choices> {{ $choice }} </lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"4\">\r\n        <lx-text-field\r\n          lx-label=\"Episode Search [URN & Episode no.]\"\r\n          lx-allow-clear=\"true\"\r\n          class=\"search-label\"\r\n        >\r\n          <input\r\n            type=\"text\"\r\n            ng-model=\"vm.search\"\r\n            ng-change=\"vm.changeData()\"\r\n            ng-model-options=\"{debounce: 500}\"\r\n            class=\"lx-input-wrapper\"\r\n            style=\"font-size: 14px\"\r\n          />\r\n        </lx-text-field>\r\n      </div>\r\n      <div flex-item=\"4\"></div>\r\n      <div flex-item=\"4\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card mb++\" flex-container=\"row\" flex-column=\"12\">\r\n    <div class=\"p+\" flex-item=\"7\">\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"3\">\r\n                <lx-select ng-model=\"vm.yearTypeSelected\" lx-choices=\"vm.yearTypeOptions\" lx-label=\"Reporting Year\" ng-change=\"vm.setYearType(newValue, oldValue)\">\r\n                    <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n                    <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n                  </lx-select>\r\n            </div>\r\n            <div flex-item=\"3\">\r\n                <lx-select ng-model=\"vm.yearSelected\" lx-choices=\"vm.yearOptions\" lx-label=\"Year\" ng-change=\"vm.setYear(newValue, oldValue)\">\r\n                    <lx-select-selected>{{$selected}}</lx-select-selected>\r\n                    <lx-select-choices>{{$choice}}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n            <div flex-item=\"3\">\r\n                <lx-select ng-model=\"vm.monthSelected\" lx-choices=\"vm.monthOptions\" lx-label=\"Month\" lx-multiple=\"false\" ng-change=\"vm.setMonth(newValue, oldValue)\">\r\n                    <lx-select-selected>{{$selected}}</lx-select-selected>\r\n                    <lx-select-choices>{{$choice}}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n            <div flex-item=\"5\" ng-if=\"vm.functionSettings && vm.functionSettings.ExecSummRepCampusSelect && vm.functionSettings.ExecSummRepCampusSelect.isActive\">\r\n                <lx-select ng-model=\"vm.campusSelected\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"false\" ng-change=\"vm.changeData()\">\r\n                    <lx-select-selected>{{$selected}}</lx-select-selected>\r\n                    <lx-select-choices>{{$choice}}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n            <div flex-item=\"5\" ng-if=\"vm.functionSettings && vm.functionSettings.ExecSummRepDivisionSelect && vm.functionSettings.ExecSummRepDivisionSelect.isActive\">\r\n                <lx-select ng-model=\"vm.divisionSelected\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.divisionOptions\" lx-label=\"Division\" lx-multiple=\"false\" ng-change=\"vm.changeData()\">\r\n                    <lx-select-selected>{{$selected}}</lx-select-selected>\r\n                    <lx-select-choices>{{$choice}}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n            <div flex-item=\"5\">\r\n                <div class=\"print-btn\">\r\n                    <lx-button lx-color=\"blue\" ng-click=\"vm.printPage()\">Print</lx-button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div id=\"print\">\r\n    <div class=\"card mb++ pb+\" flex-container=\"row\" flex-column=\"12\">\r\n        <div flex-item=\"12\">\r\n            <h1>{{vm.title}}</h1>\r\n            <p class=\"pl++\">{{vm.startDateDisplay}} - {{vm.endDateDisplay}}</p>\r\n            <p class=\"pl++\">Report date: {{vm.currentDate}}</p>\r\n        </div>\r\n    </div>\r\n    <div id=\"byMonthDtContainer\" class=\"card material-table mb++\">\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"9\">\r\n                <h1>{{vm.byMonthHeading}}<span ng-if=\"vm.divisionSelected\">: {{vm.divisionSelected}}</span></h1>\r\n            </div>\r\n            <div flex-item=\"3\">\r\n                <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printByMonthDt\">Print table</lx-switch>\r\n                <lx-select ng-model=\"vm.byMonthDtColsSelected\" lx-choices=\"vm.byMonthDtColsOptions\" lx-fixed-label=\"true\" lx-label=\"Visible columns\" ng-change=\"vm.toggleColumns('byMonthDt')\" lx-allow-clear=\"false\" lx-multiple=\"true\">\r\n                    <lx-select-selected>{{$selected}}</lx-select-selected>\r\n                    <lx-select-choices>{{$choice}}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <table id=\"byMonthDt\" class=\"mdl-data-table mdl-js-data-table\">\r\n                <thead>\r\n                    <tr>\r\n                        <th class=\"mdl-data-table__cell--non-numeric\">Month</th>\r\n                        <th>Episodes</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes currently in the status- 1 requiring review by auditor, 2 currently open for audit, 3 Ready for Clinician and 4- Finalised.\">Episodes requiring audit</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The percentage of the episodes currently in the status- 1 requiring review by auditor, 2 currently open for audit, 3 Ready for Clinician and 4- Finalised by the total number of episodes for the month.\">Episodes requiring audit (%)</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The episodes that are in the status 4- finalised.\">Episodes audited</th>\r\n                        <th>Episodes audited (%)</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes requiring audit minus the total episodes audited.\">Episodes to be audited</th>\r\n                        <th>Episodes to be audited (%)</th>\r\n                        <th>Queries generated</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The episodes that have been set as ‘Ready for Clinician’\">Queries awaiting clinician review</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The total number of episodes with coding changes with error categories assigned, both finalised and unfinalised\">Coding changes</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\" The total number of episodes with DRG/{{vm.episodeValue}} changes where the DRG change modal checkbox is activated, in all episode statuses (for the month). This checkbox is activated when information is entered in the DRG Change modal.\">DRG/{{vm.episodeValue}} changes</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The percentage of the total number of episodes with DRG/{{vm.episodeValue}} changes where the DRG change modal checkbox is activated, in all episode statuses (for the month). This checkbox is activated when information is entered in the DRG Change modal.\">DRG/{{vm.episodeValue}} changes (%)</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The total {{vm.episodeValue}} change for the episode\">{{vm.episodeValue}} change</th>\r\n                        <th>Current {{vm.episodeValue}}</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The set {{vm.episodeValue}} target for the month, applied through the admin settings.\">{{vm.episodeValue}} target</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The variance in the total {{vm.episodeValue}} to the set target\">{{vm.episodeValue}} variance</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody></tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n    <div id=\"criteriaSummaryDtContainer\" class=\"card material-table mb++\" ng-show=\"vm.showCriteriaSummary\">\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"8\">\r\n                <h1>{{vm.criteriaSummaryHeading}}<span ng-if=\"vm.monthSelected\">: {{vm.monthSelected}}</span></h1>\r\n            </div>\r\n            <div flex-item=\"4\">\r\n                <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printCriteriaSummaryDt\">Print table</lx-switch>\r\n                <lx-select ng-model=\"vm.criteriaSummaryDtColsSelected\" lx-choices=\"vm.criteriaSummaryDtColsOptions\" lx-fixed-label=\"true\" lx-label=\"Visible columns\" ng-change=\"vm.toggleColumns('criteriaSummaryDt')\" lx-allow-clear=\"false\" lx-multiple=\"true\">\r\n                    <lx-select-selected>{{$selected}}</lx-select-selected>\r\n                    <lx-select-choices>{{$choice}}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <table id=\"criteriaSummaryDt\" class=\"mdl-data-table mdl-js-data-table\">\r\n                <thead>\r\n                    <tr>\r\n                        <th>Summary Category</th>\r\n                        <th>Criterion 0:<br>Does not meet<br>audit criteria</th>\r\n                        <th>Criterion 0:<br>Does not meet<br>audit criteria (%)</th>\r\n                        <th>Criterion 1:<br>Original coding queries</th>\r\n                        <th>Criterion 1:<br>Original coding queries (%)</th>\r\n                        <th>Criterion 2:<br>Target DRGs</th>\r\n                        <th>Criterion 2:<br>Target DRGs (%)</th>\r\n                        <th>Criterion 3:<br>B/C split</th>\r\n                        <th>Criterion 3:<br>B/C split (%)</th>\r\n                        <th>Criterion 4:<br>Other</th>\r\n                        <th>Criterion 4:<br>Other (%)</th>\r\n                        <th>Total</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody></tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n    <div id=\"auditTypeSummaryDtContainer\" class=\"card material-table mb++\">\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"8\">\r\n                <h1>{{vm.auditTypeSummaryHeading}}<span ng-if=\"vm.monthSelected\">: {{vm.monthSelected}}</span></h1>\r\n            </div>\r\n            <div flex-item=\"4\">\r\n                <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printAuditTypeSummaryDt\">Print table</lx-switch>\r\n                <lx-select ng-model=\"vm.auditTypeSummaryDtColsSelected\" lx-choices=\"vm.auditTypeSummaryDtColsOptions\" lx-fixed-label=\"true\" lx-label=\"Visible columns\" ng-change=\"vm.toggleColumns('auditTypeSummaryDt')\" lx-allow-clear=\"false\" lx-multiple=\"true\">\r\n                    <lx-select-selected>{{$selected}}</lx-select-selected>\r\n                    <lx-select-choices>{{$choice}}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <table id=\"auditTypeSummaryDt\" class=\"mdl-data-table mdl-js-data-table\">\r\n                <thead>\r\n                    <tr>\r\n                        <th>Audit Type</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The total number of episodes that have been flagged in the applied rules box against that audit type\">Number of Episodes Flagged</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The total number of finalised episodes that have been audited against the audit type\">Number of Episodes Audited</th>\r\n                        <th>Episodes Audited (%)</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The total number of DRG changes, where the audit type is specified in the DRG change modal\">Number of DRG Changes</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"DRG changes, where the audit type is specified in the DRG change modal\">DRG Changes (%)</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The total {{vm.episodeValue}} difference that has been achieved from the audit type\">{{vm.episodeValue}} Difference</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody></tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n    <div id=\"bySpecialtyDtContainer\" class=\"card material-table mb++\">\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"9\">\r\n                <h1>{{vm.bySpecialtyHeading}}<span ng-if=\"vm.monthSelected\">: {{vm.monthSelected}}</span></h1>\r\n            </div>\r\n            <div flex-item=\"3\">\r\n                <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printBySpecialtyDt\">Print table</lx-switch>\r\n                <lx-select ng-model=\"vm.bySpecialtyDtColsSelected\" lx-choices=\"vm.bySpecialtyDtColsOptions\" lx-fixed-label=\"true\" lx-label=\"Visible columns\" ng-change=\"vm.toggleColumns('bySpecialtyDt')\" lx-allow-clear=\"false\" lx-multiple=\"true\">\r\n                    <lx-select-selected>{{$selected}}</lx-select-selected>\r\n                    <lx-select-choices>{{$choice}}</lx-select-choices>\r\n                </lx-select>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <table id=\"bySpecialtyDt\" class=\"mdl-data-table mdl-js-data-table\">\r\n                <thead>\r\n                    <tr>\r\n                        <th>Division</th>\r\n                        <th>{{vm.specialtyStringSentenceCase}}</th>\r\n                        <th>Episodes</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes currently in the status- 1 requiring review by auditor, 2 currently open for audit, 3 Ready for Clinician and 4- Finalised.\">Episodes requiring audit</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The percentage of episodes in the status- 1 requiring review by auditor, 2 currently open for audit, 3 Ready for Clinician and 4- Finalised by the total number of episodes (for the specified timeframe).\">Episodes requiring audit (%)</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The episodes that have been finalised for the specified unit.\">Episodes audited</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The percentage of the episodes that have been finalised for audit to the total episodes for the specified unit.\">Episodes audited (%)</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes in the status- 2 currently open for audit for the specified unit.\">Episodes to be audited</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes in the status- 2 currently open for audit to the total episodes for the specified unit.\">Episodes to be audited (%)</th>\r\n                        <th lx-tooltip-position=\"right\" lx-tooltip=\"The total number of queries that have been generated for the specified unit.\">Queries generated</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The episodes that have been set as ‘Ready for Clinician’ for the specified unit.\">Queries awaiting clinician review</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The total number of episodes with coding changes with error categories assigned, both finalised and unfinalised.\">Coding changes</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The total number of episodes with DRG/{{vm.episodeValue}} changes where the DRG change modal checkbox is activated, in all episode statuses. This checkbox is activated when information is entered in the DRG Change modal.\">DRG/{{vm.episodeValue}} changes</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The percentage of total number of episodes with DRG/{{vm.episodeValue}} changes where the DRG change modal checkbox is activated, in all episode statuses. This checkbox is activated when information is entered in the DRG Change modal.\">DRG/{{vm.episodeValue}} changes (%)</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The total {{vm.episodeValue}} change for the episode.\">{{vm.episodeValue}} change</th>\r\n                        <th>Current {{vm.episodeValue}}</th>\r\n                        <th lx-tooltip-position=\"left\" lx-tooltip=\"The {{vm.episodeValue}} value by the number of episodes in that month for the specified unit.\">Complexity Index</th>\r\n                  </tr>\r\n                </thead>\r\n                <tbody></tbody>\r\n                <tfoot></tfoot>\r\n            </table>\r\n        </div>\r\n    </div>\r\n    <div id=\"wiesByMonth\" class=\"card mb++\">\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"8\">\r\n                <h1>Overall {{vm.episodeValue}} Achievement</h1>\r\n            </div>\r\n            <div flex-item=\"4\">\r\n                <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printWiesByMonthChart\">Print chart</lx-switch>\r\n                <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printWiesByMonthTable\">Print table</lx-switch>\r\n            </div>\r\n        </div>\r\n        <div flex-container=\"row\">\r\n            <div id=\"table__wiesByMonth\" class=\"p+ table\">\r\n                <table class=\"mdl-data-table mdl-js-data-table table-chart__wiesByMonth\">\r\n                    <thead>\r\n                        <tr>\r\n                        <th class=\"mdl-data-table__cell--non-numeric\">Month</th>\r\n                        <th>Original</th>\r\n                        <th>Actual</th>\r\n                        <th>Retrieved</th>\r\n                        <th>Target</th>\r\n                        <th>Variance</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody></tbody>\r\n                    <tfoot></tfoot>\r\n                </table>\r\n            </div>\r\n            <div class=\"p+ chart\">\r\n                <div id=\"chart__wiesByMonth\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div id=\"wiesBySpecialty\" class=\"card mb++\">\r\n        <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n            <div flex-item=\"8\">\r\n                <h1>Comparison of {{vm.specialtyString}} {{vm.episodeValue}} Achievement</h1>\r\n            </div>\r\n            <div flex-item=\"4\">\r\n                <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printWiesBySpecialtyChart\">Print chart</lx-switch>\r\n                <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printWiesBySpecialtyTable\">Print table</lx-switch>\r\n            </div>\r\n        </div>\r\n        <div flex-container=\"row\">\r\n            <div id=\"table__wiesBySpecialty\" class=\"p+ table\">\r\n                <table class=\"mdl-data-table mdl-js-data-table table-chart__wiesBySpecialty\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">{{vm.specialtyStringSentenceCase}}</th>\r\n                            <th>{{vm.episodeValue}} change</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody></tbody>\r\n                </table>\r\n            </div>\r\n            <div class=\"p+ chart\">\r\n                <div id=\"chart__wiesBySpecialty\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"card mb++\" flex-container=\"row\" flex-column=\"12\">\r\n        <div flex-item=\"12\">\r\n            <div class=\"p+\">\r\n                <ul class=\"pl++\">\r\n                    <li>Data as at {{vm.currentDate}}</li>\r\n                    <li ng-if=\"!(vm.functionSettings.ExecSummaryCustomFootNotes && vm.functionSettings.ExecSummaryCustomFootNotes.isActive)\">Acute inc Qual Newborn only</li>\r\n                    <li>Acute totals exclude units: {{vm.excludedSpecialties ? vm.excludedSpecialties : \"N/A\"}}</li>\r\n                    <li ng-if=\"vm.functionSettings.ExecSummaryCustomFootNotes && vm.functionSettings.ExecSummaryCustomFootNotes.isActive\">Patient classifications exclude units: {{vm.excludedPatientClasses ? vm.excludedPatientClasses : \"N/A\"}}</li>\r\n                    <li>Episodes requiring audit subject to change</li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card mb++\" flex-container=\"row\" flex-column=\"12\">\r\n  <div class=\"p+\" flex-item=\"7\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.yearTypeSelected\" lx-choices=\"vm.yearTypeOptions\" lx-label=\"Reporting Year\"\r\n                   ng-change=\"vm.setYearType(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.yearSelected\" lx-choices=\"vm.yearOptions\" lx-label=\"Year\"\r\n                   ng-change=\"vm.setYear(newValue, oldValue)\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.monthSelected\" lx-choices=\"vm.monthOptions\" lx-label=\"Month\" lx-multiple=\"false\"\r\n                   ng-change=\"vm.setMonth(newValue, oldValue)\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.sqlDateSelected\" lx-choices=\"vm.sqlDateOptions\" lx-label=\"Query By\"\r\n                   ng-change=\"vm.setSQLDate(newValue, oldValue)\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.sqlGroupBySelected\" lx-choices=\"vm.sqlGroupByOptions\" lx-label=\"Group By\"\r\n                   ng-change=\"vm.setSQLGroupBy(newValue, oldValue)\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\"\r\n           ng-if=\"vm.functionSettings && vm.functionSettings.ExecSummRepCampusSelect && vm.functionSettings.ExecSummRepCampusSelect.isActive\">\r\n        <lx-select ng-model=\"vm.campusSelected\" lx-display-filter=\"true\" lx-allow-clear=\"true\"\r\n                   lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.changeData()\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\"\r\n           ng-if=\"vm.functionSettings && vm.functionSettings.ExecSummRepDivisionSelect && vm.functionSettings.ExecSummRepDivisionSelect.isActive\">\r\n        <lx-select ng-model=\"vm.divisionSelected\" lx-display-filter=\"true\" lx-allow-clear=\"true\"\r\n                   lx-choices=\"vm.divisionOptions\" lx-label=\"Division\" lx-multiple=\"false\" ng-change=\"vm.changeData()\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"5\">\r\n        <div class=\"print-btn\">\r\n          <lx-button lx-color=\"blue\" ng-click=\"vm.printPage()\">Print</lx-button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div id=\"print\">\r\n  <div class=\"card mb++ pb+\" flex-container=\"row\" flex-column=\"12\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{vm.title}}</h1>\r\n      <p class=\"pl++\">{{vm.startDateDisplay}} - {{vm.endDateDisplay}}</p>\r\n      <p class=\"pl++\">Report date: {{vm.currentDate}}</p>\r\n    </div>\r\n  </div>\r\n  <div id=\"byMonthDtContainer\" class=\"card material-table mb++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"9\">\r\n        <h1>{{vm.byMonthHeading}}<span ng-if=\"vm.divisionSelected\">: {{vm.divisionSelected}}</span></h1>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printByMonthDt\">Print table\r\n        </lx-switch>\r\n        <lx-select ng-model=\"vm.byMonthDtColsSelected\" lx-choices=\"vm.byMonthDtColsOptions\" lx-fixed-label=\"true\"\r\n                   lx-label=\"Visible columns\" ng-change=\"vm.toggleColumns('byMonthDt')\" lx-allow-clear=\"false\"\r\n                   lx-multiple=\"true\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <table id=\"byMonthDt\" class=\"mdl-data-table mdl-js-data-table\">\r\n        <thead>\r\n        <tr>\r\n          <th class=\"mdl-data-table__cell--non-numeric\">Month</th>\r\n          <th>Episodes</th>\r\n          <th lx-tooltip-position=\"right\"\r\n              lx-tooltip=\"Episodes currently in the status- 1 requiring review by auditor, 2 currently open for audit, 3 Ready for Clinician and 4- Finalised.\">\r\n            Episodes requiring audit\r\n          </th>\r\n          <th lx-tooltip-position=\"right\"\r\n              lx-tooltip=\"The percentage of the episodes currently in the status- 1 requiring review by auditor, 2 currently open for audit, 3 Ready for Clinician and 4- Finalised by the total number of episodes for the month.\">\r\n            Episodes requiring audit (%)\r\n          </th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"The episodes that are in the status 4- finalised.\">Episodes\r\n            audited\r\n          </th>\r\n          <th>Episodes audited (%)</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes requiring audit minus the total episodes audited.\">\r\n            Episodes to be audited\r\n          </th>\r\n          <th>Episodes to be audited (%)</th>\r\n          <th>Queries generated</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"The episodes that have been set as ‘Ready for Clinician’\">Queries\r\n            awaiting clinician review\r\n          </th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"The projected amount for Episodes linked to Queries\">\r\n            Queries projected diff\r\n          </th>\r\n          <th lx-tooltip-position=\"left\"\r\n              lx-tooltip=\"The total number of episodes with coding changes with error categories assigned, both finalised and unfinalised\">\r\n            Coding changes\r\n          </th>\r\n          <th lx-tooltip-position=\"left\"\r\n              lx-tooltip=\" The total number of episodes with DRG/{{vm.episodeValue}} changes where the DRG change modal checkbox is activated, in all episode statuses (for the month). This checkbox is activated when information is entered in the DRG Change modal.\">\r\n            DRG/{{vm.episodeValue}} changes\r\n          </th>\r\n          <th lx-tooltip-position=\"left\"\r\n              lx-tooltip=\"The percentage of the total number of episodes with DRG/{{vm.episodeValue}} changes where the DRG change modal checkbox is activated, in all episode statuses (for the month). This checkbox is activated when information is entered in the DRG Change modal.\">\r\n            DRG/{{vm.episodeValue}} changes (%)\r\n          </th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The total {{vm.episodeValue}} change for the episode\">\r\n            {{vm.episodeValue}} change\r\n          </th>\r\n          <th>Current {{vm.episodeValue}}</th>\r\n          <th lx-tooltip-position=\"left\"\r\n              lx-tooltip=\"The set {{vm.episodeValue}} target for the month, applied through the admin settings.\">\r\n            {{vm.episodeValue}} target\r\n          </th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The variance in the total {{vm.episodeValue}} to the set target\">\r\n            {{vm.episodeValue}} variance\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody></tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <div id=\"criteriaSummaryDtContainer\" class=\"card material-table mb++\" ng-show=\"vm.showCriteriaSummary\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"8\">\r\n        <h1>{{vm.criteriaSummaryHeading}}<span ng-if=\"vm.monthSelected\">: {{vm.monthSelected}}</span></h1>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printCriteriaSummaryDt\">Print\r\n          table\r\n        </lx-switch>\r\n        <lx-select ng-model=\"vm.criteriaSummaryDtColsSelected\" lx-choices=\"vm.criteriaSummaryDtColsOptions\"\r\n                   lx-fixed-label=\"true\" lx-label=\"Visible columns\" ng-change=\"vm.toggleColumns('criteriaSummaryDt')\"\r\n                   lx-allow-clear=\"false\" lx-multiple=\"true\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <table id=\"criteriaSummaryDt\" class=\"mdl-data-table mdl-js-data-table\">\r\n        <thead>\r\n        <tr>\r\n          <th>Summary Category</th>\r\n          <th>Criterion 0:<br>Does not meet<br>audit criteria</th>\r\n          <th>Criterion 0:<br>Does not meet<br>audit criteria (%)</th>\r\n          <th>Criterion 1:<br>Original coding queries</th>\r\n          <th>Criterion 1:<br>Original coding queries (%)</th>\r\n          <th>Criterion 2:<br>Target DRGs</th>\r\n          <th>Criterion 2:<br>Target DRGs (%)</th>\r\n          <th>Criterion 3:<br>B/C split</th>\r\n          <th>Criterion 3:<br>B/C split (%)</th>\r\n          <th>Criterion 4:<br>Other</th>\r\n          <th>Criterion 4:<br>Other (%)</th>\r\n          <th>Total</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody></tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <div id=\"auditTypeSummaryDtContainer\" class=\"card material-table mb++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"8\">\r\n        <h1>{{vm.auditTypeSummaryHeading}}<span ng-if=\"vm.monthSelected\">: {{vm.monthSelected}}</span></h1>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printAuditTypeSummaryDt\">Print\r\n          table\r\n        </lx-switch>\r\n        <lx-select ng-model=\"vm.auditTypeSummaryDtColsSelected\" lx-choices=\"vm.auditTypeSummaryDtColsOptions\"\r\n                   lx-fixed-label=\"true\" lx-label=\"Visible columns\" ng-change=\"vm.toggleColumns('auditTypeSummaryDt')\"\r\n                   lx-allow-clear=\"false\" lx-multiple=\"true\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <table id=\"auditTypeSummaryDt\" class=\"mdl-data-table mdl-js-data-table\">\r\n        <thead>\r\n        <tr>\r\n          <th>Audit type</th>\r\n          <th lx-tooltip-position=\"right\"\r\n              lx-tooltip=\"The total number of episodes that have been flagged in the applied rules box against that audit type\">\r\n            Number of episodes flagged\r\n          </th>\r\n          <th lx-tooltip-position=\"right\"\r\n              lx-tooltip=\"The total number of finalised episodes that have been audited against the audit type\">Number\r\n            of episodes audited\r\n          </th>\r\n          <th>Episodes audited (%)</th>\r\n          <th lx-tooltip-position=\"left\"\r\n              lx-tooltip=\"The total number of DRG changes, where the audit type is specified in the DRG change modal\">\r\n            Number of DRG changes\r\n          </th>\r\n          <th lx-tooltip-position=\"left\"\r\n              lx-tooltip=\"DRG changes, where the audit type is specified in the DRG change modal\">DRG changes (%)\r\n          </th>\r\n          <th lx-tooltip-position=\"left\"\r\n              lx-tooltip=\"The total {{vm.episodeValue}} difference that has been achieved from the audit type\">\r\n            {{vm.episodeValue}} Difference\r\n          </th>\r\n        </tr>\r\n        </thead>\r\n        <tbody></tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <div id=\"bySpecialtyDtContainer\" class=\"card material-table mb++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"9\">\r\n        <h1>{{vm.bySpecialtyHeading}}<span ng-if=\"vm.monthSelected\">: {{vm.monthSelected}}</span></h1>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printBySpecialtyDt\">Print\r\n          table\r\n        </lx-switch>\r\n        <lx-select ng-model=\"vm.bySpecialtyDtColsSelected\" lx-choices=\"vm.bySpecialtyDtColsOptions\"\r\n                   lx-fixed-label=\"true\" lx-label=\"Visible columns\" ng-change=\"vm.toggleColumns('bySpecialtyDt')\"\r\n                   lx-allow-clear=\"false\" lx-multiple=\"true\">\r\n          <lx-select-selected>{{$selected}}</lx-select-selected>\r\n          <lx-select-choices>{{$choice}}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <table id=\"bySpecialtyDt\" class=\"mdl-data-table mdl-js-data-table\">\r\n        <thead>\r\n        <tr>\r\n          <th>{{vm.sqlGroupBySelected}}</th>\r\n          <th>Episodes</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes currently in the status- 1 requiring review by auditor, 2 currently open for audit, 3 Ready for Clinician and 4- Finalised.\">Episodes requiring audit</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"The percentage of episodes in the status- 1 requiring review by auditor, 2 currently open for audit, 3 Ready for Clinician and 4- Finalised by the total number of episodes (for the specified timeframe).\">Episodes requiring audit (%)</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"The episodes that have been finalised for the specified unit.\">Episodes audited</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"The percentage of the episodes that have been finalised for audit to the total episodes for the specified unit.\">Episodes audited (%)</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes in the status- 2 currently open for audit for the specified unit.\">Episodes to be audited</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"Episodes in the status- 2 currently open for audit to the total episodes for the specified unit.\">Episodes to be audited (%)</th>\r\n          <th lx-tooltip-position=\"right\" lx-tooltip=\"The total number of queries that have been generated for the specified unit.\">Queries generated</th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The episodes that have been set as ‘Ready for Clinician’ for the specified unit.\">Queries awaiting clinician review</th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The value...\">Queries projected diff</th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The total number of episodes with coding changes with error categories assigned, both finalised and unfinalised.\">Coding changes</th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The total number of episodes with DRG/{{vm.episodeValue}} changes where the DRG change modal checkbox is activated, in all episode statuses. This checkbox is activated when information is entered in the DRG Change modal.\">DRG/{{vm.episodeValue}} changes</th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The percentage of total number of episodes with DRG/{{vm.episodeValue}} changes where the DRG change modal checkbox is activated, in all episode statuses. This checkbox is activated when information is entered in the DRG Change modal.\">DRG/{{vm.episodeValue}} changes (%)</th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The total {{vm.episodeValue}} change for the episode.\">{{vm.episodeValue}} change</th>\r\n          <th>Current {{vm.episodeValue}}</th>\r\n          <th lx-tooltip-position=\"left\" lx-tooltip=\"The {{vm.episodeValue}} value by the number of episodes in that month for the specified unit.\">Average {{vm.episodeValue}} change</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody></tbody>\r\n        <tfoot></tfoot>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <div id=\"wiesByMonth\" class=\"card mb++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"8\">\r\n        <h1>Overall {{vm.episodeValue}} Achievement</h1>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printWiesByMonthChart\">Print\r\n          chart\r\n        </lx-switch>\r\n        <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printWiesByMonthTable\">Print\r\n          table\r\n        </lx-switch>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\">\r\n      <div id=\"table__wiesByMonth\" class=\"p+ table\">\r\n        <table class=\"mdl-data-table mdl-js-data-table table-chart__wiesByMonth\">\r\n          <thead>\r\n          <tr>\r\n            <th class=\"mdl-data-table__cell--non-numeric\" colspan=\"2\" style=\"width: 250px\">Month</th>\r\n            <!-- <th>Original</th> -->\r\n            <!-- <th>Actual</th> -->\r\n            <th>Retrieved</th>\r\n            <th>Target</th>\r\n            <th>Variance</th>\r\n          </tr>\r\n          </thead>\r\n          <tbody></tbody>\r\n          <tfoot></tfoot>\r\n        </table>\r\n      </div>\r\n      <div class=\"p+ chart\">\r\n        <div id=\"chart__wiesByMonth\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div id=\"wiesBySpecialty\" class=\"card mb++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"8\">\r\n        <h1>Comparison of {{vm.sqlGroupBySelected}} {{vm.episodeValue}} Achievement</h1>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printWiesBySpecialtyChart\">\r\n          Print chart\r\n        </lx-switch>\r\n        <lx-switch class=\"print-switch pt+ pr+\" ng-change=\"vm.togglePrint()\" ng-model=\"vm.printWiesBySpecialtyTable\">\r\n          Print table\r\n        </lx-switch>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\">\r\n      <div id=\"table__wiesBySpecialty\" class=\"p+ table\">\r\n        <table class=\"mdl-data-table mdl-js-data-table table-chart__wiesBySpecialty\">\r\n          <thead>\r\n          <tr>\r\n            <th class=\"mdl-data-table__cell--non-numeric\">{{vm.sqlGroupBySelected}}</th>\r\n            <th>{{vm.episodeValue}} change</th>\r\n          </tr>\r\n          </thead>\r\n          <tbody></tbody>\r\n        </table>\r\n      </div>\r\n      <div class=\"p+ chart\">\r\n        <div id=\"chart__wiesBySpecialty\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"card mb++\" flex-container=\"row\" flex-column=\"12\">\r\n    <div flex-item=\"12\">\r\n      <div class=\"p+\">\r\n        <ul class=\"pl++\">\r\n          <li>Data as at {{vm.currentDate}}</li>\r\n          <li>Acute inc Qual Newborn only</li>\r\n          <li>Acute totals exclude units: {{vm.excludedSpecialties ? vm.excludedSpecialties : \"N/A\"}}</li>\r\n          <li>Episodes requiring audit subject to change</li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table auditedmed\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table\r\n    id=\"auditTable\"\r\n    datatable=\"\"\r\n    dt-options=\"vm.dtOptions\"\r\n    dt-columns=\"vm.dtColumns\"\r\n    dt-instance=\"vm.dtInstanceCallback\"\r\n    class=\"mdl-data-table\"\r\n    cellspacing=\"0\"\r\n    width=\"100%\"\r\n  ></table>\r\n  <div\r\n    class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"\r\n  ></div>\r\n  <div class=\"reports__filters p+\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"4\">\r\n        <lx-select\r\n          lx-label=\"Date Type\"\r\n          ng-model=\"vm.dateType\"\r\n          lx-choices=\"vm.dateTypeOptions\"\r\n          lx-color=\"blue\"\r\n          ng-change=\"vm.setDateType(newValue)\"\r\n        >\r\n          <lx-select-selected> {{ $selected.value }} </lx-select-selected>\r\n          <lx-select-choices> {{ $choice.value }} </lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-date-picker\r\n          id=\"startDatePicker\"\r\n          ng-model=\"vm.startDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Date Start\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.startDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <lx-date-picker\r\n          id=\"endDatePicker\"\r\n          ng-model=\"vm.endDatePicker.input.date\"\r\n          lx-color=\"blue\"\r\n          lx-input-format=\"L\"\r\n          lx-locale=\"{{ vm.locale }}\"\r\n        >\r\n          <lx-text-field lx-label=\"Date End\">\r\n            <input\r\n              type=\"text\"\r\n              ng-model=\"vm.endDatePicker.input.dateFormatted\"\r\n            />\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div\r\n        flex-item=\"4\"\r\n        ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\"\r\n      >\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCampus('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCampus('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.campus.selectedCampus\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.campusOptions\"\r\n          lx-label=\"Campus\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.campusCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCoder('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCoder('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.coder.selectedCoder\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.coderOptions\"\r\n          lx-label=\"Original Coder\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.setCoder(newValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterDischargeUnit('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterDischargeUnit('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.dischargeUnit.selectedDischargeUnit\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.dischargeUnitOptions\"\r\n          lx-label=\"{{ vm.specialtyString }}\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.dischargeUnitCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterDocType('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterDocType('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.docType.selectedDocType\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.docTypeOptions\"\r\n          lx-label=\"Documentation Type\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.docTypeCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterIncompleteDocumentation('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterIncompleteDocumentation('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.hasOutstandingDocuments\"\r\n          lx-display-filter=\"false\"\r\n          lx-allow-clear=\"yes\"\r\n          lx-choices=\"vm.outstandingDocsOptions\"\r\n          lx-label=\"Incomplete Documentation Entry Status\"\r\n          lx-multiple=\"false\"\r\n          ng-change=\"vm.outstandingDocsCallback(newValue, oldValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected.label }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.label }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCreatedBy('minus') \"\r\n            class=\"filter__minus\"\r\n          ><i class=\"mdi mdi-minus\"></i\r\n          ></lx-button>\r\n          <lx-button\r\n            lx-type=\"icon\"\r\n            lx-color=\"pink\"\r\n            lx-size=\"xs\"\r\n            ng-click=\"vm.filterCreatedBy('add')\"\r\n            class=\"filter__add\"\r\n          ><i class=\"mdi mdi-plus\"></i\r\n          ></lx-button>\r\n        </div>\r\n        <lx-select\r\n          ng-model=\"vm.createdBy.selectedCreatedBy\"\r\n          lx-display-filter=\"true\"\r\n          lx-allow-clear=\"true\"\r\n          lx-choices=\"vm.createdByOptions\"\r\n          lx-label=\"Created By\"\r\n          lx-multiple=\"true\"\r\n          ng-change=\"vm.setCreatedBy(newValue)\"\r\n        >\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-item=\"4\"></div>\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table auditedmed\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"Updated on or after\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"Updated on or before\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"8\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n    <div flex-item=\"4\">\r\n      <aside class=\"reports__stats\">\r\n        <h6><span id=\"total-proj-wies\"></span></h6>\r\n        <h6><span id=\"total-queries\"></span></h6>\r\n      </aside>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\" ng-if=\"vm.episodeValue\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\" ng-if=\"vm.showQueryByColumn\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryType', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryType', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.queryType.selectedQueryType\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.queryTypeOptions\" lx-label=\"Query By\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\" ng-if=\"vm.showAuditTypeColumn\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('auditType', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('auditType', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.auditType.selectedAuditType\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.queryTypeOptions\" lx-label=\"{{vm.functionSettings.AuditTypeColumn ? vm.functionSettings.AuditTypeColumn.valueString : 'Audit Type'}}\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryTemplate', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryTemplate', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.queryTemplate.selectedQueryTemplates\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.queryTemplateOptions\" lx-label=\"Query Type\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryStatus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryStatus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.queryStatus.selectedQueryStatus\" lx-display-filter=\"false\" lx-allow-clear=\"true\" lx-choices=\"vm.queryStatusOptions\" lx-label=\"Query Status\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('querySpecialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('querySpecialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.querySpecialty.selectedQuerySpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"Query {{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('coder', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('coder', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.coder.selectedCoder\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.coderOptions\" lx-label=\"Coder\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n            <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n            <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryCreatedBy', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryCreatedBy', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.queryCreatedBy.selectedQueryCreatedBy\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.coderOptions\" lx-label=\"Query Created By\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n            <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n            <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <div class=\"filter__swap\">\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('episodeActive', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('episodeActive', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.episodeActive.selectedEpisodeActive\" lx-allow-clear=\"true\" lx-choices=\"vm.episodeActiveOptions\" lx-label=\"Episodes Active\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n            <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n            <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                          || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('campus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" lx-multiple=\"true\" ng-change=\"vm.campusCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"2\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"2\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('patientClassification', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('patientClassification', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.patientClassification.selectedPatientClassification\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.patientClassificationOptions\" lx-label=\"Patient Classification\" lx-multiple=\"true\" ng-change=\"vm.patientClassificationCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"4\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('healthCareFund', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('healthCareFund', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.healthCareFund.selectedHealthCareFund\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.healthCareFundOptions\" lx-label=\"Health Care Fund\" lx-multiple=\"true\" ng-change=\"vm.healthCareFundCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"12\">\r\n        <h1>{{ vm.name }}</h1>\r\n      </div>\r\n    </div>\r\n    <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n    </table>\r\n    <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n    <div class=\"reports__filters p+++\">\r\n      <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n        <div flex-item=\"3\">\r\n          <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n            <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n              <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n            </lx-text-field>\r\n          </lx-date-picker>\r\n        </div>\r\n        <div flex-item=\"3\">\r\n          <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n            <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n              <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n            </lx-text-field>\r\n          </lx-date-picker>\r\n        </div>\r\n        <div flex-item=\"3\">\r\n          <div class=\"filter__swap\">\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryStatus', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n            <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('queryStatus', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n          </div>\r\n          <lx-select ng-model=\"vm.queryStatus.selectedQueryStatus\" lx-display-filter=\"false\" lx-allow-clear=\"true\" lx-choices=\"vm.queryStatusOptions\" lx-label=\"Query Status\" lx-multiple=\"true\" ng-change=\"vm.filterCallback(newValue, oldValue)\">\r\n            <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n            <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n          </lx-select>\r\n        </div>\r\n        <div flex-item=\"3\">\r\n          <div class=\"toolbar__right\">\r\n            <lx-search-filter lx-color=\"blue\" lx-closed=\"true\">\r\n              <input type=\"text\" ng-model=\"vm.searchFilter\" title=\"Search by query ID or URN\">\r\n            </lx-search-filter>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  "

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table auditedmed\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n</div>\r\n"

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name + ' ' + vm.dateRange }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterCaretype('minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterCaretype('add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.caretype.selectedCaretype\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.caretypeOptions\" lx-label=\"Care Type\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected.description }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.description }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterPatientclass('minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterPatientclass('add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.patientclass.selectedPatientclass\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.patientclassOptions\" lx-label=\"Patient Classification\" lx-multiple=\"true\" ng-change=\"vm.selectCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"startDatePicker\" ng-model=\"vm.startDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date Start\">\r\n            <input type=\"text\" ng-model=\"vm.startDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-date-picker id=\"endDatePicker\" ng-model=\"vm.endDatePicker.input.date\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"{{ vm.locale }}\">\r\n          <lx-text-field lx-label=\"{{ vm.separationString }} Date End\">\r\n            <input type=\"text\" ng-model=\"vm.endDatePicker.input.dateFormatted\">\r\n          </lx-text-field>\r\n        </lx-date-picker>\r\n      </div>\r\n    </div>\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                            || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n          <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" ng-change=\"vm.campusCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card material-table\">\r\n  <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n    <div flex-item=\"12\">\r\n      <h1>{{ vm.name }}</h1>\r\n    </div>\r\n  </div>\r\n  <table id=\"auditTable\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstanceCallback\" class=\"mdl-data-table\" cellspacing=\"0\" width=\"100%\">\r\n  </table>\r\n  <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active hidden\"></div>\r\n  <div class=\"reports__filters p+++\">\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterSwap('specialty', 'add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.specialty.selectedSpecialty\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.specialtyOptions\" lx-label=\"{{ vm.specialtyString }}\" lx-multiple=\"true\" ng-change=\"vm.specialtyCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.fytd.selectedFytd\" lx-choices=\"vm.fytdOptions\" lx-label=\"Select Year\" ng-change=\"vm.yearCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"3\">\r\n        <lx-select ng-model=\"vm.months.selectedMonth\" lx-choices=\"vm.monthOptions\" lx-label=\"FY Month\" lx-multiple=\"false\" ng-change=\"vm.monthCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterPatientclass('minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterPatientclass('add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.patientclass.selectedPatientclass\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.patientclassOptions\" lx-label=\"Patient Classification\" lx-multiple=\"true\" ng-change=\"vm.patientclassCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n      <div flex-item=\"6\">\r\n        <div class=\"filter__swap\">\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterCaretype('minus') \" class=\"filter__minus\"><i class=\"mdi mdi-minus\"></i></lx-button>\r\n          <lx-button lx-type=\"icon\" lx-color=\"pink\" lx-size=\"xs\" ng-click=\"vm.filterCaretype('add')\" class=\"filter__add\"><i class=\"mdi mdi-plus\"></i></lx-button>\r\n        </div>\r\n        <lx-select ng-model=\"vm.caretype.selectedCaretype\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.caretypeOptions\" lx-label=\"Care Type\" lx-multiple=\"true\" ng-change=\"vm.caretypeCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected.description }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice.description }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n\r\n    <div flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n      <div flex-item=\"6\" ng-if=\"vm.functionSettings.LimitCampusDropDown === undefined\r\n                            || (vm.user.role === 'Administrator' && vm.functionSettings.LimitCampusDropDown && vm.functionSettings.LimitCampusDropDown.isActive)\">\r\n        <lx-select ng-model=\"vm.campus.selectedCampus\" lx-display-filter=\"true\" lx-allow-clear=\"true\" lx-choices=\"vm.campusOptions\" lx-label=\"Campus\" ng-change=\"vm.campusCallback(newValue, oldValue)\">\r\n          <lx-select-selected>{{ $selected }}</lx-select-selected>\r\n          <lx-select-choices>{{ $choice }}</lx-select-choices>\r\n        </lx-select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"admin\">\r\n  <div class=\"p+ pl++\">\r\n    <lx-dropdown>\r\n      <lx-dropdown-toggle>\r\n        <lx-button>Select Admin</lx-button>\r\n      </lx-dropdown-toggle>\r\n      <lx-dropdown-menu>\r\n        <ul>\r\n          <li><a ng-show=\"vm.user.role !== 'Reporter'\" ui-sref=\"admin.users\">Users</a></li>\r\n          <li><a ng-show=\"vm.user.role !== 'Reporter' && vm.user.role !== 'Manager'\" ui-sref=\"admin.episodes\">Episodes</a></li>\r\n          <li><a ng-show=\"vm.user.role !== 'Reporter' && vm.user.role !== 'Manager'\" ui-sref=\"admin.specialties\">{{ vm.specialtyString }}</a></li>\r\n          <li><a ng-show=\"vm.user.role !== 'Reporter' && vm.user.role !== 'Manager'\" ui-sref=\"admin.episodevalue\">{{ vm.episodeValue }} Targets</a></li>\r\n          <li><a ng-show=\"vm.user.role !== 'Reporter' && vm.user.role !== 'Manager'\" ui-sref=\"admin.drgs\">DRG</a></li>\r\n          <!-- CFS-994 - Hiding this menu item -->\r\n          <!-- <li class=\"beta\"><a ng-show=\"vm.user.role !== 'Reporter'\" ui-sref=\"admin.coding\">Coding</a></li> -->\r\n          <li><a ng-show=\"vm.user.role !== 'Reporter' && vm.user.role !== 'Manager'\" ui-sref=\"admin.site\">Site</a></li>\r\n        </ul>\r\n      </lx-dropdown-menu>\r\n    </lx-dropdown>\r\n  </div>\r\n  <div class=\"mdl-grid mdl-grid-height100\">\r\n    <div class=\"mdl-cell mdl-cell--12-col\">\r\n      <div ui-view></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"auth\" flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n  <div flex-item=\"4\"></div>\r\n  <div flex-item=\"4\" class=\"p\">\r\n    <div class=\"mdl-card mdl-shadow--4dp mt+++ mb++\">\r\n      <form ng-if=\"!activeDirectoryError()\" ng-submit=\"login()\" class=\"authentication\" options=\"vm.options\" name=\"vm.form\" ng-submit=\"vm.onSubmit()\" novalidate autocomplete=\"off\">\r\n        <formly-form model=\"vm.model\" fields=\"vm.userFields\" options=\"vm.options\"></formly-form>\r\n        <input type=\"submit\" />\r\n      </form>\r\n      <div ng-if=\"!activeDirectoryError()\" class=\"pl++ pt+ pb+\">\r\n        <lx-button class=\"pull-right\" ng-click=\"login()\" ng-disabled=\"dataLoading || vm.form.$invalid\" lx-type=\"raised\">Login</lx-button>\r\n      </div>\r\n      <div ng-if=\"!activeDirectoryError()\" class=\"pt+++ pl++ pb+\">\r\n        <div ng-show=\"error\" class=\"tc-red-400\">{{error}}</div>\r\n      </div>\r\n      <div ng-if=\"activeDirectoryError()\" class=\"ad-error\">\r\n        <p>\r\n          <b ng-if=\"!vm.activeDirectoryErrorMsg\">Code Focus login via AD encountered an error.</b>\r\n          <b ng-if=\"vm.activeDirectoryErrorMsg\">{{vm.activeDirectoryErrorMsg}}</b>\r\n        </p>\r\n        <br>\r\n        <p><b>Redirecting you back to AD FS login page...</b></p>\r\n        <br>\r\n        <div class=\"lds-ring\"><div></div><div></div><div></div><div></div></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div flex-item=\"4\"></div>\r\n</div>\r\n"

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"auth\" flex-container=\"row\" flex-column=\"12\" flex-gutter=\"16\">\r\n  <div flex-item=\"5\"></div>\r\n  <div flex-item=\"2\" class=\"p\">\r\n    <div class=\"mdl-card mdl-shadow--4dp mt+++ mb++\">\r\n      <br />\r\n      <br />\r\n      <br />\r\n      <p class=\"pl++ pt+ pb+\">You have been successfully logged out. To log back in again please click\r\n        <a href=\"{{vm.loginURL}}\" onclick=\"window.location.reload()\">here</a></p>\r\n    </div>\r\n  </div>\r\n  <div flex-item=\"5\"></div>\r\n</div>\r\n"

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"reports\">\r\n  <div class=\"p+ pl+\">\r\n    <lx-dropdown>\r\n      <lx-dropdown-toggle>\r\n        <lx-button>Select Report</lx-button>\r\n      </lx-dropdown-toggle>\r\n      <lx-dropdown-menu>\r\n        <ul ng-show=\"vm.appFunctions.length\">\r\n          <li ng-repeat=\"menuItem in vm.appFunctions\" >\r\n            <a ng-show=\"menuItem.isActive && menuItem.routePath && menuItem.functionType === 'REP'\"\r\n              href=\"/{{menuItem.routePath}}\" id=\"{{menuItem.code}}\"\r\n              ng-click=\"navItemClick(menuItem.routePath, false)\">{{menuItem.label}}</a>\r\n          </li>\r\n        </ul>\r\n      </lx-dropdown-menu>\r\n    </lx-dropdown>\r\n  </div>\r\n  <div class=\"mdl-grid mdl-grid-height100\">\r\n    <div class=\"mdl-cell mdl-cell--12-col\">\r\n      <div ui-view></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports = ""

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"checkbox\">\r\n\t<input ng-model=\"model[options.key]\"\r\n\t       type=\"checkbox\"\r\n\t       role=\"checkbox\"\r\n\t       class=\"checkbox__input\">\r\n\t<label for={{::id}} class=\"checkbox__label\" aria-label=\"{{::to.label}}\">{{to.label}}</label>\r\n\t<span ng-if=\"::to.description\"\r\n\t      class=\"checkbox__help\">{{::to.description}}</span>\r\n</div>"

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports = "<!--\r\n<lx-date-picker model=\"model[options.key]\" aria-label=\"{{::to.label}}\" label=\"{{::to.label}} {{::to.required ? '*' : ''}}\"></lx-date-picker>\r\n -->\r\n\r\n <!-- I've customised this to work with the latest LumX - SH -->\r\n<lx-date-picker ng-model=\"::model['options.key']\" lx-color=\"blue\" lx-input-format=\"L\" lx-locale=\"en-AU\">\r\n  <lx-text-field lx-label=\"{{::to.label}}\">\r\n    <input type=\"text\" ng-model=\"::model[options.key]\">\r\n  </lx-text-field>\r\n</lx-date-picker>\r\n"

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"aftl-flex-fields\"\r\n     model=\"$parent.model\"\r\n     flex-container=\"{{::to.flex.container || 'row'}}\"\r\n     flex-align=\"{{::to.flex.align || 'space-between'}}\"\r\n     flex-gutter=\"{{::to.flex.gutter || '24'}}\">\r\n\t<div formly-field\r\n\t     ng-repeat=\"field in to.fields track by $index\"\r\n\t     ng-if=\"!field.hide\"\r\n\t     class=\"formly-field {{::field.type ? 'formly-field-' + field.type : ''}}\"\r\n       ng-class=\"field.className\"\r\n\t     ng-style=\"::to.flex.style\"\r\n\t     options=\"field\"\r\n\t     model=\"field.model || model\"\r\n\t     fields=\"fields\"\r\n\t     form=\"form\"\r\n\t     form-id=\"formId\"\r\n\t     form-state=\"options.formState\"\r\n\t     index=\"$index\"\r\n\t     flex-item=\"{{::to.flex.item || '1'}}\"\r\n\t     flex-order=\"{{::to.flex.order}}\">\r\n\t</div>\r\n</div>\r\n"

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports = "<lx-text-field data-model=\"::model[options.key]\"\r\n               icon=\"{{::to.icon}}\"\r\n               fixed-label=\"::to.fixedLabel\"\r\n               theme=\"{{::to.theme}}\"\r\n               disabled=\"to.disabled\"\r\n               label=\"{{to.label}} {{::to.required ? '*' : ''}}\"\r\n               valid=\"fc.$valid && fc.$touched\"\r\n               error=\"fc.$invalid && fc.$touched\">\r\n\t<input ng-model=\"model[options.key]\"\r\n\t       type=\"{{::to.type}}\"\r\n\t       aria-label=\"{{::to.label}}\"\r\n\t       ng-class=\"::to.className\"/>\r\n</lx-text-field>"

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"radio-group\">\r\n\t<h3 ng-if=\"::to.label\"><label>{{::to.label}}</label></h3>\r\n\r\n\t<div class=\"radio-button\"\r\n\t     ng-class=\"{'radio-button__inline': to.inline}\"\r\n\t     ng-repeat=\"o in to.options\">\r\n\t\t<input ng-model=\"$parent.model[$parent.options.key]\"\r\n\t\t       id=\"{{::id + '_' + $index}}\"\r\n\t\t       type=\"radio\"\r\n\t\t       ng-disabled=\"::o.disabled\"\r\n\t\t       class=\"radio-button__input\"\r\n\t\t       ng-value=\"::o.value\"\r\n\t\t       aria-labelledby=\"{{::id + '_' + $index + '_radioButton'}}\">\r\n\t\t<label for=\"{{::id + '_' + $index}}\"\r\n\t\t       class=\"radio-button__label\">{{::o.name}}</label>\r\n      <span ng-if=\"::o.description\" class=\"radio-button__help\">{{::o.description}}\r\n      </span>\r\n\t</div>\r\n</div>\r\n"

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"aftl-select\">\r\n\t<h3 ng-if=\"::to.label\"><label>\r\n\t\t{{to.label}} {{::to.required ? '*' : ''}}\r\n\t</label></h3>\r\n\t<lx-select ng-model=\"model[options.key]\"\r\n\t           choices=\"to.options\"\r\n\t           placeholder=\"{{::to.placeholder}}\"\r\n\t           min-length=\"::to.minLength\"\r\n\t           allow-clear=\"::to.allowClear\"\r\n\t           ng-attr-multiple=\"{{::to.multiple}}\"\r\n\t\t\t\t\t\t lx-display-filter=\"to.displayFilter\">\r\n\r\n\t\t<lx-select-selected>\r\n\t\t\t{{$selected[to.selected] || $selected}} {{::to.selected2 ? ' - ' +\r\n\t\t\t$selected[to.selected2] : ''}}\r\n\t\t</lx-select-selected>\r\n\r\n\t\t<lx-select-choices>\r\n\t\t\t{{$choice[to.choice] || $choice}} {{::to.choice2 ? ' - ' +\r\n\t\t\t$choice[to.choice2] : ''}}\r\n\t\t</lx-select-choices>\r\n\r\n\t</lx-select>\r\n</div>"

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"switch\">\r\n\t<input ng-model=\"model[options.key]\"\r\n\t       type=\"checkbox\"\r\n\t       role=\"checkbox\"\r\n\t       class=\"switch__input\"/>\r\n\t<label for=\"{{::id}}\" class=\"switch__label\" aria-label=\"{{::to.label}}\">{{to.label}}</label>\r\n\t<span ng-if=\"::to.description\"\r\n\t      class=\"switch__help\">{{::to.description}}</span>\r\n</div>\r\n\r\n"

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports = "<lx-text-field data-model=\"::model[options.key]\"\r\n               fixed-label=\"::to.fixedLabel\"\r\n               icon=\"{{::to.icon}}\"\r\n               theme=\"{{::to.theme}}\"\r\n               label=\"{{to.label}} {{::to.required ? '*' : ''}}\"\r\n               valid=\"fc.$valid && fc.$touched\"\r\n               error=\"fc.$invalid && fc.$touched\">\r\n    <textarea ng-model=\"model[options.key]\"\r\n              aria-label=\"{{::to.label}}\"\r\n              rows=\"{{::to.rows}}\" cols=\"{{::to.cols}}\">\r\n    </textarea>\r\n</lx-text-field>\r\n"

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"::to.div.className\"\r\n\tng-style=\"::to.div.style\">\r\n\t<formly-transclude></formly-transclude>\r\n</div>"

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n\t<formly-transclude></formly-transclude>\r\n\t<ul class=\"form-error\" ng-messages=\"fc.$error\"\r\n\t    ng-show=\"options.validation.errorExistsAndShouldBeVisible\">\r\n\t\t<li ng-repeat=\"(name, message) in ::options.validation.messages\"\r\n\t\t    ng-message={{::name}}>\r\n\t\t\t{{message(fc.$viewValue, fc.$modelValue, this)}}\r\n\t\t</li>\r\n\t</ul>\r\n\t<span class=\"form-pending\"\r\n\t      ng-if=\"to.pending && fc.$pending && fc.$touched\">\r\n\t{{::to.pending || 'Checking...'}}\r\n\t</span>\r\n</div>\r\n"

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"::to.div.className\"\r\n     ng-style=\"::to.div.style || {}\"\r\n     flex-item=\"::to.flex.item\"\r\n     flex-order=\"::to.flex-order\">\r\n\t<formly-transclude></formly-transclude>\r\n</div>"

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports = "<span class=\"inline-wrapper\">\r\n\t<span class=\"inline--before\">{{::to.inline.before}}</span>\r\n\t<span class=\"inline--content\">\r\n\t\t<formly-transclude></formly-transclude>\r\n\t</span>\r\n\t<span class=\"inline--after\">{{::to.inline.after}}</span>\r\n</span>"

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(48);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./material.blue-light_blue.min.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./material.blue-light_blue.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(49);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./_lumx.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./_lumx.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(50);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(51);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./drgs.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./drgs.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(52);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./episodes.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./episodes.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(53);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./episodevalue.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./episodevalue.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(54);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./site.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./site.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(55);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./specialties.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./specialties.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(56);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./users.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./users.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(57);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./atsi.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./atsi.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(58);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditprogramdrgchanges.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditprogramdrgchanges.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(59);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditprogramresults.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditprogramresults.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(60);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditprogress.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditprogress.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(61);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditresultsummary.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditresultsummary.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(62);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditsbymonth.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./auditsbymonth.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(63);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./awaitingreview.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./awaitingreview.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(64);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./changespercoder.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./changespercoder.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(65);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./codedmedicalrecords.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./codedmedicalrecords.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(66);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./coderreviewed.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./coderreviewed.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(67);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./codingactivity.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./codingactivity.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(68);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./commonchangedtodrg.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./commonchangedtodrg.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(69);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./commondrgchanges.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./commondrgchanges.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(70);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./commonicdchanges.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./commonicdchanges.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(71);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./commonicdchangesbydrg.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./commonicdchangesbydrg.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(72);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./episodechangereport.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./episodechangereport.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(73);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./episodelist.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./episodelist.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(74);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./executivesummary.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./executivesummary.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(75);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./executivesummary.poc.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./executivesummary.poc.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(76);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./incompletedocumentation.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./incompletedocumentation.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(77);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./mechvent.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./mechvent.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(78);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./picq.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./picq.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(79);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./queries.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./queries.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(80);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./querychanges.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./querychanges.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(81);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./readmissions.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./readmissions.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(82);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./sentqueries.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./sentqueries.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(83);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./targetdrgs.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./targetdrgs.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(84);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./totalaudit.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./totalaudit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(85);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./unitaudit.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./unitaudit.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(86);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./admin.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./admin.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(87);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./authentication.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./authentication.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(88);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./logout.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./logout.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(89);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./reports.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./reports.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
]);


// WEBPACK FOOTER //
// app.9d5e6f2093ef84fda6e1.js